import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  Decimal: { input: number; output: number; }
  LocalDate: { input: string; output: string; }
  Long: { input: number; output: number; }
  TimeSpan: { input: string; output: string; }
  UUID: { input: string; output: string; }
  Upload: { input: any; output: any; }
};

export type Absence = Node & {
  __typename?: 'Absence';
  absenceReasonId: Scalars['ID']['output'];
  absenceReasonName: Scalars['String']['output'];
  absenceReasonType: AbsenceReasonType;
  createdBy: Contact;
  createdById: Scalars['ID']['output'];
  delegateEmployee?: Maybe<Contact>;
  delegateEmployeeId?: Maybe<Scalars['ID']['output']>;
  employee: Contact;
  employeeId: Scalars['ID']['output'];
  end: Scalars['LocalDate']['output'];
  history: Array<AbsenceHistory>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isHalfEndDay: Scalars['Boolean']['output'];
  isHalfStartDay: Scalars['Boolean']['output'];
  logs: Array<AbsenceLog>;
  publicHolidays: Scalars['Decimal']['output'];
  start: Scalars['LocalDate']['output'];
  status: AbsenceStatusType;
  timestamp: Scalars['DateTime']['output'];
  totalDays: Scalars['Decimal']['output'];
  version: Scalars['Long']['output'];
  workDays: Scalars['Decimal']['output'];
};

export type AbsenceHistory = {
  __typename?: 'AbsenceHistory';
  absenceReasonId: Scalars['ID']['output'];
  absenceReasonName: Scalars['String']['output'];
  createdBy: Contact;
  createdById: Scalars['ID']['output'];
  delegateEmployee?: Maybe<Contact>;
  delegateEmployeeId?: Maybe<Scalars['ID']['output']>;
  end: Scalars['LocalDate']['output'];
  isHalfEndDay: Scalars['Boolean']['output'];
  isHalfStartDay: Scalars['Boolean']['output'];
  publicHolidays: Scalars['Decimal']['output'];
  start: Scalars['LocalDate']['output'];
  status: AbsenceStatusType;
  timestamp: Scalars['DateTime']['output'];
  totalDays: Scalars['Decimal']['output'];
  version: Scalars['Long']['output'];
  workDays: Scalars['Decimal']['output'];
};

export type AbsenceLog = {
  __typename?: 'AbsenceLog';
  createdBy: Contact;
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type AbsenceOverview = {
  __typename?: 'AbsenceOverview';
  contact: Contact;
  contactId: Scalars['ID']['output'];
  details: Array<AbsenceOverviewDetails>;
  spentHolidays: Scalars['Decimal']['output'];
  totalSickDays: Scalars['Decimal']['output'];
};

export type AbsenceOverviewDetails = {
  __typename?: 'AbsenceOverviewDetails';
  absenceReasonName: Scalars['String']['output'];
  end: Scalars['LocalDate']['output'];
  isHalfEndDay: Scalars['Boolean']['output'];
  isHalfStartDay: Scalars['Boolean']['output'];
  publicHolidays: Scalars['Decimal']['output'];
  start: Scalars['LocalDate']['output'];
  status: AbsenceStatusType;
  totalDays: Scalars['Decimal']['output'];
  workDays: Scalars['Decimal']['output'];
};

export type AbsenceOverviewQueryFilterInput = {
  endDate: Scalars['LocalDate']['input'];
  startDate: Scalars['LocalDate']['input'];
};

export type AbsenceQueryFilterInput = {
  showCanceled?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['LocalDate']['input'];
};

export type AbsenceReason = Node & {
  __typename?: 'AbsenceReason';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  maximumContinuedPayment?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  removesWorkingHours: Scalars['Boolean']['output'];
  type: AbsenceReasonType;
  version: Scalars['Long']['output'];
};

export enum AbsenceReasonType {
  Other = 'OTHER',
  Sabbatical = 'SABBATICAL',
  Vacation = 'VACATION'
}

export enum AbsenceStatusType {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  DelegateApproved = 'DELEGATE_APPROVED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED'
}

export type AbsolutOrPercent = {
  __typename?: 'AbsolutOrPercent';
  isPercent: Scalars['Boolean']['output'];
  value: Scalars['Decimal']['output'];
};

export type AbsolutOrPercentInput = {
  isPercent: Scalars['Boolean']['input'];
  value: Scalars['Decimal']['input'];
};

export type AcceptOfferError = DomainError | PropertyValidationError;

export type AcceptOfferInput = {
  id: Scalars['ID']['input'];
};

export type AcceptOfferPayload = {
  __typename?: 'AcceptOfferPayload';
  errors?: Maybe<Array<AcceptOfferError>>;
  offer?: Maybe<Offer>;
};

export type AcceptTimeApprovalError = DomainError | PropertyValidationError;

export type AcceptTimeApprovalInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  projectTimeApprovalId: Scalars['ID']['input'];
};

export type AcceptTimeApprovalPayload = {
  __typename?: 'AcceptTimeApprovalPayload';
  errors?: Maybe<Array<AcceptTimeApprovalError>>;
  projectTimeApproval?: Maybe<ProjectTimeApproval>;
};

export type AccountingProfile = Node & {
  __typename?: 'AccountingProfile';
  createdById: Scalars['ID']['output'];
  entries: Array<AccountingProfileEntry>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type AccountingProfileEntry = {
  __typename?: 'AccountingProfileEntry';
  daysOfWeek: Array<DayOfWeek>;
  name: Scalars['String']['output'];
  period: TimeRange;
  surcharge: AbsolutOrPercent;
};

export type AccountingProfileEntryInput = {
  daysOfWeek: Array<DayOfWeek>;
  name: Scalars['String']['input'];
  period: TimeRangeInput;
  surcharge: AbsolutOrPercentInput;
};

export type AccountingProfileQueryInput = {
  filterByName?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderType>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddApprovalToAllTimeEntriesError = DomainError | InvalidUserPrivilegesError | PropertyValidationError;

export type AddApprovalToAllTimeEntriesInput = {
  approved: Scalars['Boolean']['input'];
  employeeId: Scalars['ID']['input'];
  endDate: Scalars['LocalDate']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['LocalDate']['input'];
};

export type AddApprovalToAllTimeEntriesPayload = {
  __typename?: 'AddApprovalToAllTimeEntriesPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<AddApprovalToAllTimeEntriesError>>;
};

export type AddApprovalToTimeEntryError = DomainError | InvalidUserPrivilegesError | PropertyValidationError;

export type AddApprovalToTimeEntryInput = {
  approved: Scalars['Boolean']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  timeEntryId: Scalars['ID']['input'];
};

export type AddApprovalToTimeEntryPayload = {
  __typename?: 'AddApprovalToTimeEntryPayload';
  errors?: Maybe<Array<AddApprovalToTimeEntryError>>;
  timeEntry?: Maybe<TimeEntry>;
};

export type AddEmployeesToLabelGroupError = ConcurrentAccessError | DomainError | PropertyValidationError;

export type AddEmployeesToLabelGroupInput = {
  employees: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  version: Scalars['Long']['input'];
};

export type AddEmployeesToLabelGroupPayload = {
  __typename?: 'AddEmployeesToLabelGroupPayload';
  errors?: Maybe<Array<AddEmployeesToLabelGroupError>>;
  timeLabelGroup?: Maybe<TimeLabelGroup>;
};

export type AddEmployeesToTimeLabelError = ConcurrentAccessError | DomainError | PropertyValidationError;

export type AddEmployeesToTimeLabelInput = {
  employeeIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  version: Scalars['Long']['input'];
};

export type AddEmployeesToTimeLabelPayload = {
  __typename?: 'AddEmployeesToTimeLabelPayload';
  errors?: Maybe<Array<AddEmployeesToTimeLabelError>>;
  timeLabel?: Maybe<TimeLabel>;
};

export type AddLabelGroupsToDepartmentError = DomainError | PropertyValidationError;

export type AddLabelGroupsToDepartmentInput = {
  id: Scalars['ID']['input'];
  timeLabelGroupsIds: Array<Scalars['ID']['input']>;
};

export type AddLabelGroupsToDepartmentPayload = {
  __typename?: 'AddLabelGroupsToDepartmentPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<AddLabelGroupsToDepartmentError>>;
};

export type AddLabelsToDepartmentError = DomainError | PropertyValidationError;

export type AddLabelsToDepartmentInput = {
  id: Scalars['ID']['input'];
  timeLabelIds: Array<Scalars['ID']['input']>;
};

export type AddLabelsToDepartmentPayload = {
  __typename?: 'AddLabelsToDepartmentPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<AddLabelsToDepartmentError>>;
};

export type AddLabelsToLabelGroupError = ConcurrentAccessError | DomainError | PropertyValidationError;

export type AddLabelsToLabelGroupInput = {
  id: Scalars['ID']['input'];
  labels: Array<Scalars['ID']['input']>;
  version: Scalars['Long']['input'];
};

export type AddLabelsToLabelGroupPayload = {
  __typename?: 'AddLabelsToLabelGroupPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<AddLabelsToLabelGroupError>>;
};

export type AddLogToAbsenceError = DomainError | InvalidUserPrivilegesError | PropertyValidationError;

export type AddLogToAbsenceInput = {
  absenceId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};

export type AddLogToAbsencePayload = {
  __typename?: 'AddLogToAbsencePayload';
  absence?: Maybe<Absence>;
  errors?: Maybe<Array<AddLogToAbsenceError>>;
};

export type AddLogToProjectTimeEntryError = DomainError | InvalidUserPrivilegesError | PropertyValidationError;

export type AddLogToProjectTimeEntryInput = {
  message: Scalars['String']['input'];
  projectTimeEntryId: Scalars['ID']['input'];
};

export type AddLogToProjectTimeEntryPayload = {
  __typename?: 'AddLogToProjectTimeEntryPayload';
  errors?: Maybe<Array<AddLogToProjectTimeEntryError>>;
  projectTimeEntry?: Maybe<ProjectTimeEntry>;
};

export type AddLogToTimeEntryError = DomainError | InvalidUserPrivilegesError | PropertyValidationError;

export type AddLogToTimeEntryInput = {
  message: Scalars['String']['input'];
  timeEntryId: Scalars['ID']['input'];
};

export type AddLogToTimeEntryPayload = {
  __typename?: 'AddLogToTimeEntryPayload';
  errors?: Maybe<Array<AddLogToTimeEntryError>>;
  timeEntry?: Maybe<TimeEntry>;
};

export type AddMemberError = DomainError | EntityNotFoundError | PropertyValidationError;

export type AddMemberInput = {
  memberId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type AddMemberPayload = {
  __typename?: 'AddMemberPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<AddMemberError>>;
};

export type AddServicesToProjectError = DomainError | PropertyValidationError;

export type AddServicesToProjectInput = {
  projectId: Scalars['ID']['input'];
  serviceIds: Array<Scalars['String']['input']>;
};

export type AddServicesToProjectPayload = {
  __typename?: 'AddServicesToProjectPayload';
  errors?: Maybe<Array<AddServicesToProjectError>>;
  project?: Maybe<Project>;
};

export type AdditionalAccountingInformation = ProjectAdditionalInformation & {
  __typename?: 'AdditionalAccountingInformation';
  accountingProfile?: Maybe<AccountingProfile>;
  accountingProfileId?: Maybe<Scalars['ID']['output']>;
  clientContractNumber?: Maybe<Scalars['String']['output']>;
  clientContratDate?: Maybe<Scalars['LocalDate']['output']>;
  clientOrderingDate?: Maybe<Scalars['LocalDate']['output']>;
  clientOrderingNumber?: Maybe<Scalars['String']['output']>;
  clientProjectNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  provision?: Maybe<Scalars['Decimal']['output']>;
  provisionDescription?: Maybe<Scalars['String']['output']>;
  supplierProjectNumber?: Maybe<Scalars['String']['output']>;
  timeTrackingResolution: Scalars['Int']['output'];
};

export type AdditionalContactInformation = ProjectAdditionalInformation & {
  __typename?: 'AdditionalContactInformation';
  client?: Maybe<Contact>;
  clientId?: Maybe<Scalars['ID']['output']>;
  contractor: Contact;
  contractorId: Scalars['ID']['output'];
  endCustomer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type AdditionalContactPersonInformation = ProjectAdditionalInformation & {
  __typename?: 'AdditionalContactPersonInformation';
  clientContactPerson?: Maybe<Contact>;
  clientContactPersonId?: Maybe<Scalars['ID']['output']>;
  contractorContactPerson?: Maybe<Contact>;
  contractorContactPersonId?: Maybe<Scalars['ID']['output']>;
  contractorProjectLeader?: Maybe<Contact>;
  contractorProjectLeaderId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
};

export type AdditionalPositionInformation = ProjectAdditionalInformation & {
  __typename?: 'AdditionalPositionInformation';
  accountingProfile?: Maybe<AccountingProfile>;
  accountingProfileId?: Maybe<Scalars['ID']['output']>;
  description: Scalars['String']['output'];
  hours?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
  pricePerHour?: Maybe<Scalars['Decimal']['output']>;
  priceRate?: Maybe<ProjectPositionPriceRateType>;
  saleableServiceId: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
  servicePrice: Scalars['Decimal']['output'];
};

export type AdditionalTeamMemberInformation = ProjectAdditionalInformation & {
  __typename?: 'AdditionalTeamMemberInformation';
  contractor?: Maybe<Contact>;
  contractorId?: Maybe<Scalars['ID']['output']>;
  employee?: Maybe<Contact>;
  employeeId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  worksOnPositions: Array<WorksOnPosition>;
};

export type AdditionalTemplateInformation = ProjectAdditionalInformation & {
  __typename?: 'AdditionalTemplateInformation';
  id: Scalars['ID']['output'];
  isDetailTimesheet: Scalars['Boolean']['output'];
  isInvoiceWithTimesheet: Scalars['Boolean']['output'];
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  type: AddressType;
  zipCode: Scalars['String']['output'];
};

export type AddressInformation = ContactAdditionalInformation & {
  __typename?: 'AddressInformation';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  type: AddressType;
  zipCode: Scalars['String']['output'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  type: AddressType;
  zipCode: Scalars['String']['input'];
};

export enum AddressType {
  German = 'GERMAN',
  International = 'INTERNATIONAL'
}

/** A connection to a list of items. */
export type AllAbsenceOverviewRequestsConnection = {
  __typename?: 'AllAbsenceOverviewRequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllAbsenceOverviewRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AbsenceOverview>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllAbsenceOverviewRequestsEdge = {
  __typename?: 'AllAbsenceOverviewRequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AbsenceOverview;
};

/** A connection to a list of items. */
export type AllAbsenceReasonsConnection = {
  __typename?: 'AllAbsenceReasonsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllAbsenceReasonsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AbsenceReason>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllAbsenceReasonsEdge = {
  __typename?: 'AllAbsenceReasonsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AbsenceReason;
};

/** A connection to a list of items. */
export type AllAbsenceReasonsForUsageConnection = {
  __typename?: 'AllAbsenceReasonsForUsageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllAbsenceReasonsForUsageEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AbsenceReason>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllAbsenceReasonsForUsageEdge = {
  __typename?: 'AllAbsenceReasonsForUsageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AbsenceReason;
};

export type AllAbsenceReasonsForUsageQueryInput = {
  filterByTypes?: InputMaybe<Array<AbsenceReasonType>>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
};

export type AllAbsenceReasonsQueryInput = {
  filterByTypes?: InputMaybe<Array<AbsenceReasonType>>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  onlyVisible?: InputMaybe<Scalars['Boolean']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A connection to a list of items. */
export type AllAbsencesConnection = {
  __typename?: 'AllAbsencesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllAbsencesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Absence>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllAbsencesEdge = {
  __typename?: 'AllAbsencesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Absence;
};

/** A connection to a list of items. */
export type AllAbsencesOfDateConnection = {
  __typename?: 'AllAbsencesOfDateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllAbsencesOfDateEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Absence>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllAbsencesOfDateEdge = {
  __typename?: 'AllAbsencesOfDateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Absence;
};

/** A connection to a list of items. */
export type AllAccountingProfilesConnection = {
  __typename?: 'AllAccountingProfilesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllAccountingProfilesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AccountingProfile>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllAccountingProfilesEdge = {
  __typename?: 'AllAccountingProfilesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AccountingProfile;
};

/** A connection to a list of items. */
export type AllCalendarEventsConnection = {
  __typename?: 'AllCalendarEventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllCalendarEventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CalendarEvent>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllCalendarEventsEdge = {
  __typename?: 'AllCalendarEventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CalendarEvent;
};

export type AllCalendarEventsQueryInput = {
  endDate: Scalars['LocalDate']['input'];
  federalStateCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate: Scalars['LocalDate']['input'];
};

/** A connection to a list of items. */
export type AllCatalogEntriesConnection = {
  __typename?: 'AllCatalogEntriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllCatalogEntriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CatalogEntry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllCatalogEntriesEdge = {
  __typename?: 'AllCatalogEntriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CatalogEntry;
};

/** A connection to a list of items. */
export type AllCommercialDocumentsConnection = {
  __typename?: 'AllCommercialDocumentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllCommercialDocumentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CommercialDocumentSummary>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllCommercialDocumentsEdge = {
  __typename?: 'AllCommercialDocumentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CommercialDocumentSummary;
};

/** A connection to a list of items. */
export type AllContactsConnection = {
  __typename?: 'AllContactsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllContactsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Contact>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllContactsEdge = {
  __typename?: 'AllContactsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Contact;
};

export type AllDepartmentIdsOfContactResult = {
  __typename?: 'AllDepartmentIdsOfContactResult';
  departmentIds: Array<Scalars['ID']['output']>;
};

/** A connection to a list of items. */
export type AllDepartmentsConnection = {
  __typename?: 'AllDepartmentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllDepartmentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Department>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllDepartmentsEdge = {
  __typename?: 'AllDepartmentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Department;
};

/** A connection to a list of items. */
export type AllDiscountProfilesConnection = {
  __typename?: 'AllDiscountProfilesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllDiscountProfilesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DiscountProfile>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllDiscountProfilesEdge = {
  __typename?: 'AllDiscountProfilesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DiscountProfile;
};

/** A connection to a list of items. */
export type AllEmployeesConnection = {
  __typename?: 'AllEmployeesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllEmployeesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Contact>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllEmployeesEdge = {
  __typename?: 'AllEmployeesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Contact;
};

/** A connection to a list of items. */
export type AllEmployeesOfContractorConnection = {
  __typename?: 'AllEmployeesOfContractorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllEmployeesOfContractorEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Contact>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllEmployeesOfContractorEdge = {
  __typename?: 'AllEmployeesOfContractorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Contact;
};

export type AllEmployeesOfContractorInput = {
  filterByName?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderType>;
  showTemporary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AllMembersOfCompanyInput = {
  andTypes?: InputMaybe<Scalars['Boolean']['input']>;
  filterByName?: InputMaybe<Scalars['String']['input']>;
  filterByTypes?: InputMaybe<Array<ContactType>>;
  order?: InputMaybe<OrderType>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A connection to a list of items. */
export type AllMembersOfConnection = {
  __typename?: 'AllMembersOfConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllMembersOfEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Contact>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type AllMembersOfDepartmentConnection = {
  __typename?: 'AllMembersOfDepartmentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllMembersOfDepartmentEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Contact>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllMembersOfDepartmentEdge = {
  __typename?: 'AllMembersOfDepartmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Contact;
};

export type AllMembersOfDepartmentInput = {
  filterByName?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderType>;
};

/** An edge in a connection. */
export type AllMembersOfEdge = {
  __typename?: 'AllMembersOfEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Contact;
};

/** A connection to a list of items. */
export type AllMembersOfMyContractorsConnection = {
  __typename?: 'AllMembersOfMyContractorsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllMembersOfMyContractorsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Contact>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllMembersOfMyContractorsEdge = {
  __typename?: 'AllMembersOfMyContractorsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Contact;
};

/** A connection to a list of items. */
export type AllProjectIdsOfClientConnection = {
  __typename?: 'AllProjectIdsOfClientConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllProjectIdsOfClientEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProjectSummary>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllProjectIdsOfClientEdge = {
  __typename?: 'AllProjectIdsOfClientEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProjectSummary;
};

/** A connection to a list of items. */
export type AllProjectsConnection = {
  __typename?: 'AllProjectsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllProjectsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProjectSummary>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllProjectsEdge = {
  __typename?: 'AllProjectsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProjectSummary;
};

/** A connection to a list of items. */
export type AllRootProjectsConnection = {
  __typename?: 'AllRootProjectsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllRootProjectsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProjectSummary>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllRootProjectsEdge = {
  __typename?: 'AllRootProjectsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProjectSummary;
};

/** A connection to a list of items. */
export type AllTemplatesConnection = {
  __typename?: 'AllTemplatesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllTemplatesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FlatTemplate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllTemplatesEdge = {
  __typename?: 'AllTemplatesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FlatTemplate;
};

/** A connection to a list of items. */
export type AllTimeApprovalsConnection = {
  __typename?: 'AllTimeApprovalsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllTimeApprovalsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProjectTimeApproval>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllTimeApprovalsEdge = {
  __typename?: 'AllTimeApprovalsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProjectTimeApproval;
};

/** A connection to a list of items. */
export type AllTimeBalanceEntriesConnection = {
  __typename?: 'AllTimeBalanceEntriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllTimeBalanceEntriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TimeBalanceEntry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllTimeBalanceEntriesEdge = {
  __typename?: 'AllTimeBalanceEntriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TimeBalanceEntry;
};

export type AllTimeBalanceEntriesQueryInput = {
  employeeId: Scalars['ID']['input'];
};

/** A connection to a list of items. */
export type AllTimeLabelConnection = {
  __typename?: 'AllTimeLabelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllTimeLabelEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TimeLabel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllTimeLabelEdge = {
  __typename?: 'AllTimeLabelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TimeLabel;
};

/** A connection to a list of items. */
export type AllTimeLabelGroupConnection = {
  __typename?: 'AllTimeLabelGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllTimeLabelGroupEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TimeLabelGroup>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllTimeLabelGroupEdge = {
  __typename?: 'AllTimeLabelGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TimeLabelGroup;
};

export type AllTimeLabelGroupInput = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type AllTimeLabelGroupsOfDepartmentConnection = {
  __typename?: 'AllTimeLabelGroupsOfDepartmentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllTimeLabelGroupsOfDepartmentEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TimeLabelGroup>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllTimeLabelGroupsOfDepartmentEdge = {
  __typename?: 'AllTimeLabelGroupsOfDepartmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TimeLabelGroup;
};

export type AllTimeLabelInput = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
  onlyActive: Scalars['Boolean']['input'];
  showDeleted: Scalars['Boolean']['input'];
};

/** A connection to a list of items. */
export type AllTimeLabelsOfDepartmentConnection = {
  __typename?: 'AllTimeLabelsOfDepartmentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllTimeLabelsOfDepartmentEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TimeLabel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllTimeLabelsOfDepartmentEdge = {
  __typename?: 'AllTimeLabelsOfDepartmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TimeLabel;
};

/** A connection to a list of items. */
export type AllTimeLabelsOfTimeLabelGroupConnection = {
  __typename?: 'AllTimeLabelsOfTimeLabelGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllTimeLabelsOfTimeLabelGroupEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TimeLabel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllTimeLabelsOfTimeLabelGroupEdge = {
  __typename?: 'AllTimeLabelsOfTimeLabelGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TimeLabel;
};

/** A connection to a list of items. */
export type AllUserGroupsConnection = {
  __typename?: 'AllUserGroupsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllUserGroupsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserGroup>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllUserGroupsEdge = {
  __typename?: 'AllUserGroupsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserGroup;
};

/** A connection to a list of items. */
export type AllUsersConnection = {
  __typename?: 'AllUsersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllUsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllUsersEdge = {
  __typename?: 'AllUsersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: User;
};

export type AllUsersQueryInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type AllWorkingTimeModelsConnection = {
  __typename?: 'AllWorkingTimeModelsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllWorkingTimeModelsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<WorkingTimeModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllWorkingTimeModelsEdge = {
  __typename?: 'AllWorkingTimeModelsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: WorkingTimeModel;
};

export type AllWorkingTimeModelsQueryInput = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
  onlyVisible?: InputMaybe<Scalars['Boolean']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

export enum ApprovalTimeEntryStatus {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ApproveVacationError = DomainError | InvalidUserPrivilegesError | PropertyValidationError;

export type ApproveVacationInput = {
  absenceId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  isApproved: Scalars['Boolean']['input'];
  version: Scalars['Long']['input'];
};

export type ApproveVacationPayload = {
  __typename?: 'ApproveVacationPayload';
  absence?: Maybe<Absence>;
  errors?: Maybe<Array<ApproveVacationError>>;
};

export type AvailableService = {
  __typename?: 'AvailableService';
  budget: Budget;
  hasFixSellingPrice: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Decimal']['output'];
  purchasePrice: Scalars['Decimal']['output'];
  sellingPrice: Scalars['Decimal']['output'];
  unitName?: Maybe<Scalars['String']['output']>;
  vatRate: Scalars['Decimal']['output'];
};

export type AvailableServiceGroup = {
  __typename?: 'AvailableServiceGroup';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  services: Array<AvailableService>;
};

export type BalanceEntry = {
  __typename?: 'BalanceEntry';
  overtimeMinutes: Scalars['Int']['output'];
  type: TimeBalanceType;
};

export type BankAccount = {
  __typename?: 'BankAccount';
  bankName?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  clientReference?: Maybe<Scalars['String']['output']>;
  clientReferenceDate?: Maybe<Scalars['LocalDate']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
};

export type BankAccountInput = {
  bankName?: InputMaybe<Scalars['String']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  clientReference?: InputMaybe<Scalars['String']['input']>;
  clientReferenceDate?: InputMaybe<Scalars['LocalDate']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
};

export type BccRecipientList = Node & {
  __typename?: 'BccRecipientList';
  contractorId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  recipients: Array<Scalars['String']['output']>;
  type: EmailType;
};

export type BillingInformation = ContactAdditionalInformation & {
  __typename?: 'BillingInformation';
  bankAccount: BankAccount;
  billingAddress: Address;
  id: Scalars['ID']['output'];
  isSameAsShippingAddress: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  shippingAddress: Address;
};

export type Budget = {
  __typename?: 'Budget';
  amount: Scalars['Decimal']['output'];
  hasAmountLimit: Scalars['Boolean']['output'];
  hasTimeLimit: Scalars['Boolean']['output'];
  hours: Scalars['Decimal']['output'];
};

export type BudgetInput = {
  amount: Scalars['Decimal']['input'];
  hasAmountLimit: Scalars['Boolean']['input'];
  hasTimeLimit: Scalars['Boolean']['input'];
  hours: Scalars['Decimal']['input'];
};

/** Represents the calculated budget status for a project. */
export type BudgetStatus = {
  __typename?: 'BudgetStatus';
  approvedMinutes: Scalars['Int']['output'];
  calculatedAt?: Maybe<Scalars['DateTime']['output']>;
  minutesUtilizationPercent: Scalars['Decimal']['output'];
  openMinutes: Scalars['Int']['output'];
  pendingMinutes: Scalars['Int']['output'];
  remainingAmount: Scalars['Decimal']['output'];
  remainingMinutes: Scalars['Int']['output'];
  spentAmount: Scalars['Decimal']['output'];
  spentMinutes: Scalars['Int']['output'];
  totalBudgetAmount: Scalars['Decimal']['output'];
  totalBudgetMinutes: Scalars['Int']['output'];
  utilizationPercent: Scalars['Decimal']['output'];
};

export type BulkDocumentStatusesResult = {
  __typename?: 'BulkDocumentStatusesResult';
  creditNoteStatuses: Array<DocumentStatusEntry>;
  invoiceStatuses: Array<DocumentStatusEntry>;
};

export type CalendarEntry = {
  __typename?: 'CalendarEntry';
  absenceId?: Maybe<Scalars['ID']['output']>;
  absenceReasonId?: Maybe<Scalars['ID']['output']>;
  absenceReasonType?: Maybe<AbsenceReasonType>;
  absenceStatus?: Maybe<AbsenceStatusType>;
  absenceVersion?: Maybe<Scalars['Long']['output']>;
  delegateEmployee?: Maybe<Contact>;
  delegateEmployeeId?: Maybe<Scalars['ID']['output']>;
  employee?: Maybe<Contact>;
  employeeId?: Maybe<Scalars['ID']['output']>;
  endDate: Scalars['LocalDate']['output'];
  isHalfEndDay: Scalars['Boolean']['output'];
  isHalfStartDay: Scalars['Boolean']['output'];
  startDate: Scalars['LocalDate']['output'];
  title: Scalars['String']['output'];
  totalDays: Scalars['Decimal']['output'];
  type: CalendarEntryType;
};

export enum CalendarEntryType {
  Delegating = 'DELEGATING',
  Information = 'INFORMATION',
  OtherAbsence = 'OTHER_ABSENCE',
  PublicHoliday = 'PUBLIC_HOLIDAY',
  Sick = 'SICK',
  Vacation = 'VACATION'
}

export type CalendarEvent = Node & {
  __typename?: 'CalendarEvent';
  description: Scalars['String']['output'];
  endDate: Scalars['LocalDate']['output'];
  federalStateCodes: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isHalfEndDay: Scalars['Boolean']['output'];
  isHalfStartDay: Scalars['Boolean']['output'];
  isVacation: Scalars['Boolean']['output'];
  locations: Array<Scalars['String']['output']>;
  startDate: Scalars['LocalDate']['output'];
  type: CalendarEventType;
  version: Scalars['Long']['output'];
};

export enum CalendarEventType {
  CompanyHoliday = 'COMPANY_HOLIDAY',
  Other = 'OTHER',
  PublicHoliday = 'PUBLIC_HOLIDAY',
  SchoolHoliday = 'SCHOOL_HOLIDAY'
}

export type CancelDocumentError = DomainError | PropertyValidationError;

export type CancelDocumentInput = {
  documentId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CancelDocumentPayload = {
  __typename?: 'CancelDocumentPayload';
  commercialDocument?: Maybe<CommercialDocument>;
  errors?: Maybe<Array<CancelDocumentError>>;
};

export type CancellationInfo = {
  __typename?: 'CancellationInfo';
  at: Scalars['DateTime']['output'];
  externalRef?: Maybe<Scalars['String']['output']>;
  mode: CancellationMode;
  reason: Scalars['String']['output'];
  reversalDocumentId?: Maybe<Scalars['UUID']['output']>;
};

export enum CancellationMode {
  Reversal = 'REVERSAL',
  Void = 'VOID'
}

/** Represents a file or folder entry in the catalog */
export type CatalogEntry = Node & {
  __typename?: 'CatalogEntry';
  /** MIME type of the file (null for folders) */
  contentType?: Maybe<Scalars['String']['output']>;
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Contact ID who created this entry */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Contact ID who deposited this entry */
  depositedBy?: Maybe<Scalars['String']['output']>;
  /** Role name of the depositor */
  depositedByRole?: Maybe<Scalars['String']['output']>;
  /** The entity (project, contact, etc.) that owns this entry */
  entityId: Scalars['String']['output'];
  /** ETag of the file (for versioning) */
  etag?: Maybe<Scalars['String']['output']>;
  /** Expiration date for temporary entries */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for the entry */
  id: Scalars['ID']['output'];
  /** Whether the entry is read-only */
  isReadOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this is a temporary entry */
  isTemp: Scalars['Boolean']['output'];
  /** Additional metadata as JSON string */
  metadata?: Maybe<Scalars['String']['output']>;
  /** Name of the entry */
  name: Scalars['String']['output'];
  /** Origin of the entry: USER or SYSTEM */
  origin: Origin;
  /** Full path of the entry */
  path: Scalars['String']['output'];
  /** Protection level: NONE, READ_ONLY, or ROLE_RESTRICTED */
  protection: Protection;
  /** File size in bytes (null for folders) */
  size?: Maybe<Scalars['Long']['output']>;
  /** Type of entry: FILE or FOLDER */
  type: EntryType;
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output'];
  /** Contact ID who last updated this entry */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Version ID of the file */
  versionId?: Maybe<Scalars['String']['output']>;
};

export type ClearAllTemplatesPayload = {
  __typename?: 'ClearAllTemplatesPayload';
  int?: Maybe<Scalars['Int']['output']>;
};

/** A commercial document - Invoice, CreditNote, or Offer */
export type CommercialDocument = {
  clientContactPersonId?: Maybe<Scalars['ID']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  contractorId?: Maybe<Scalars['ID']['output']>;
  documentRole: DocumentRole;
  documentType: DocumentType;
  dueDate?: Maybe<Scalars['LocalDate']['output']>;
  employeeIds: Array<Scalars['ID']['output']>;
  items: Array<LineItem>;
  number?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['ID']['output']>;
  status: DocumentStatus;
  taxDetails: Array<TaxDetail>;
  timeSheetApprovalIds: Array<Scalars['ID']['output']>;
};

export type CommercialDocumentEmail = {
  __typename?: 'CommercialDocumentEmail';
  attachments?: Maybe<Array<CommercialDocumentEmailAttachment>>;
  bccRecipients?: Maybe<Array<Scalars['String']['output']>>;
  body: Scalars['String']['output'];
  ccRecipients?: Maybe<Array<Scalars['String']['output']>>;
  recipients: Array<Scalars['String']['output']>;
  shouldMergeAttachments: Scalars['Boolean']['output'];
  subject: Scalars['String']['output'];
};

export type CommercialDocumentEmailAttachment = {
  __typename?: 'CommercialDocumentEmailAttachment';
  content: Scalars['String']['output'];
  extension?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  positionNumber: Scalars['Int']['output'];
};

export type CommercialDocumentEmailAttachmentInput = {
  content: Scalars['String']['input'];
  extension?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  positionNumber: Scalars['Int']['input'];
};

export type CommercialDocumentEmailInput = {
  attachments?: InputMaybe<Array<CommercialDocumentEmailAttachmentInput>>;
  bccRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  body: Scalars['String']['input'];
  ccRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  recipients: Array<Scalars['String']['input']>;
  shouldMergeAttachments: Scalars['Boolean']['input'];
  subject: Scalars['String']['input'];
};

export type CommercialDocumentSummary = {
  __typename?: 'CommercialDocumentSummary';
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancellationReversalDocumentId?: Maybe<Scalars['ID']['output']>;
  cancellationReversalDocumentSentDate?: Maybe<Scalars['DateTime']['output']>;
  client?: Maybe<Contact>;
  clientContactPerson?: Maybe<Contact>;
  clientContactPersonId?: Maybe<Scalars['ID']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  contractor?: Maybe<Contact>;
  contractorId?: Maybe<Scalars['ID']['output']>;
  createdBy: Contact;
  createdById: Scalars['ID']['output'];
  createdDate: Scalars['LocalDate']['output'];
  documentRole: DocumentRole;
  documentType: DocumentType;
  dueDate?: Maybe<Scalars['LocalDate']['output']>;
  employeeIds: Array<Scalars['ID']['output']>;
  employees: Array<Contact>;
  grossTotal: Scalars['Decimal']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  isInvalid?: Maybe<Scalars['Boolean']['output']>;
  isProforma: Scalars['Boolean']['output'];
  issueDate?: Maybe<Scalars['LocalDate']['output']>;
  netTotal: Scalars['Decimal']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  openTotal?: Maybe<Scalars['Decimal']['output']>;
  originalDocumentDate?: Maybe<Scalars['LocalDate']['output']>;
  originalDocumentId?: Maybe<Scalars['ID']['output']>;
  originalDocumentNumber?: Maybe<Scalars['String']['output']>;
  paidTotal?: Maybe<Scalars['Decimal']['output']>;
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['ID']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  sentDate?: Maybe<Scalars['DateTime']['output']>;
  status: DocumentStatus;
  taxTotal: Scalars['Decimal']['output'];
  timeSheetApprovalIds: Array<Scalars['ID']['output']>;
};

export type CommercialDocumentSummaryFilterInput = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  isProforma?: InputMaybe<Scalars['Boolean']['input']>;
  ofStatuses?: InputMaybe<Array<DocumentStatus>>;
  ofTypes?: InputMaybe<Array<DocumentType>>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['LocalDate']['input'];
};

export type CompleteUploadInput = {
  entityId: Scalars['String']['input'];
  parts: Array<PartInfoInput>;
  uploadId: Scalars['String']['input'];
};

export type CompleteUploadPayload = {
  __typename?: 'CompleteUploadPayload';
  catalogEntry?: Maybe<CatalogEntry>;
};

export type ConcurrentAccessError = Error & {
  __typename?: 'ConcurrentAccessError';
  errorType: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Contact = Node & {
  __typename?: 'Contact';
  additionalInformation: Array<ContactAdditionalInformation>;
  companyName: Scalars['String']['output'];
  contactNumber: Scalars['String']['output'];
  contactTypes: Array<ContactType>;
  displayContactType: Array<ContactType>;
  displayName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isACompany: Scalars['Boolean']['output'];
  isAFreelancer: Scalars['Boolean']['output'];
  isAMailbox: Scalars['Boolean']['output'];
  isAPerson: Scalars['Boolean']['output'];
  isContactPerson: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isEmployee: Scalars['Boolean']['output'];
  isMemberOf: Array<Scalars['UUID']['output']>;
  isTemporary: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  salutation: SalutationType;
  shortCode: Scalars['String']['output'];
  title: Scalars['String']['output'];
  version: Scalars['Long']['output'];
};

export type ContactAdditionalInformation = {
  id: Scalars['ID']['output'];
};

export type ContactFilterInput = {
  filterByName?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ContactOrderByProperty {
  DisplayName = 'DISPLAY_NAME'
}

export type ContactPersonInformation = ContactAdditionalInformation & {
  __typename?: 'ContactPersonInformation';
  contactPersonId: Scalars['ID']['output'];
  contactUsage: Array<ContactUsage>;
  id: Scalars['ID']['output'];
};

export type ContactQueryInput = {
  andTypes?: InputMaybe<Scalars['Boolean']['input']>;
  filterByName?: InputMaybe<Scalars['String']['input']>;
  filterByTypes?: InputMaybe<Array<ContactType>>;
  order?: InputMaybe<OrderType>;
  orderByProperty?: InputMaybe<ContactOrderByProperty>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  showTemporary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactTimeEntriesQueryInput = {
  employeeId: Scalars['ID']['input'];
  endDate: Scalars['LocalDate']['input'];
  projectId: Scalars['ID']['input'];
  startDate: Scalars['LocalDate']['input'];
};

export enum ContactType {
  Client = 'CLIENT',
  Company = 'COMPANY',
  ContactPerson = 'CONTACT_PERSON',
  Contractor = 'CONTRACTOR',
  Employee = 'EMPLOYEE',
  Freelancer = 'FREELANCER',
  Mailbox = 'MAILBOX',
  Person = 'PERSON',
  Supplier = 'SUPPLIER'
}

export enum ContactUsage {
  Invoice = 'INVOICE',
  InvoiceReminder = 'INVOICE_REMINDER',
  Offer = 'OFFER'
}

export type ContractedInformation = ContactAdditionalInformation & {
  __typename?: 'ContractedInformation';
  contractedId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  marge: Scalars['Decimal']['output'];
};

export type ConvertOfferToInvoiceError = DomainError | PropertyValidationError;

export type ConvertOfferToInvoiceInput = {
  id: Scalars['ID']['input'];
};

export type ConvertOfferToInvoicePayload = {
  __typename?: 'ConvertOfferToInvoicePayload';
  errors?: Maybe<Array<ConvertOfferToInvoiceError>>;
  invoice?: Maybe<Invoice>;
};

export type CorrectedCreditNote = CommercialDocument & Node & {
  __typename?: 'CorrectedCreditNote';
  billTo: GenericAddress;
  cancellation?: Maybe<CancellationInfo>;
  clientContactPersonId?: Maybe<Scalars['ID']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clientVatId?: Maybe<Scalars['String']['output']>;
  concludingText?: Maybe<Scalars['String']['output']>;
  contractorId?: Maybe<Scalars['ID']['output']>;
  contractorVatId?: Maybe<Scalars['String']['output']>;
  createdById: Scalars['ID']['output'];
  createdDate: Scalars['LocalDate']['output'];
  documentRole: DocumentRole;
  documentType: DocumentType;
  dueDate?: Maybe<Scalars['LocalDate']['output']>;
  employeeIds: Array<Scalars['ID']['output']>;
  grossTotal: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  introductoryText: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isInvalid: Scalars['Boolean']['output'];
  isProforma: Scalars['Boolean']['output'];
  isReversal: Scalars['Boolean']['output'];
  issueDate?: Maybe<Scalars['LocalDate']['output']>;
  items: Array<LineItem>;
  netTotal: Scalars['Decimal']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  openTotal: Scalars['Decimal']['output'];
  originalDocumentDate?: Maybe<Scalars['LocalDate']['output']>;
  originalDocumentId?: Maybe<Scalars['ID']['output']>;
  originalDocumentNumber?: Maybe<Scalars['String']['output']>;
  paidTotal?: Maybe<Scalars['Decimal']['output']>;
  paymentDeadlineInDays: Scalars['Int']['output'];
  payments?: Maybe<Array<PaymentItem>>;
  projectId?: Maybe<Scalars['ID']['output']>;
  sentDate?: Maybe<Scalars['DateTime']['output']>;
  sentEmailId?: Maybe<Scalars['UUID']['output']>;
  shipTo?: Maybe<GenericAddress>;
  status: DocumentStatus;
  taxDetails: Array<TaxDetail>;
  taxTotal: Scalars['Decimal']['output'];
  timeSheetApprovalIds: Array<Scalars['ID']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export type CorrectedInvoice = CommercialDocument & Node & {
  __typename?: 'CorrectedInvoice';
  billTo: GenericAddress;
  cancellation?: Maybe<CancellationInfo>;
  clientContactPersonId?: Maybe<Scalars['ID']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clientVatId?: Maybe<Scalars['String']['output']>;
  concludingText?: Maybe<Scalars['String']['output']>;
  contractorId?: Maybe<Scalars['ID']['output']>;
  contractorVatId?: Maybe<Scalars['String']['output']>;
  createdById: Scalars['ID']['output'];
  createdDate: Scalars['LocalDate']['output'];
  documentRole: DocumentRole;
  documentType: DocumentType;
  dueDate?: Maybe<Scalars['LocalDate']['output']>;
  employeeIds: Array<Scalars['ID']['output']>;
  grossTotal: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  introductoryText: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isInvalid: Scalars['Boolean']['output'];
  isProforma: Scalars['Boolean']['output'];
  isReversal: Scalars['Boolean']['output'];
  issueDate?: Maybe<Scalars['LocalDate']['output']>;
  items: Array<LineItem>;
  netTotal: Scalars['Decimal']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  openTotal: Scalars['Decimal']['output'];
  originalDocumentDate?: Maybe<Scalars['LocalDate']['output']>;
  originalDocumentId?: Maybe<Scalars['ID']['output']>;
  originalDocumentNumber?: Maybe<Scalars['String']['output']>;
  paidTotal?: Maybe<Scalars['Decimal']['output']>;
  paymentDeadlineInDays: Scalars['Int']['output'];
  payments?: Maybe<Array<PaymentItem>>;
  projectId?: Maybe<Scalars['ID']['output']>;
  sentDate?: Maybe<Scalars['DateTime']['output']>;
  sentEmailId?: Maybe<Scalars['UUID']['output']>;
  shipTo?: Maybe<GenericAddress>;
  status: DocumentStatus;
  taxDetails: Array<TaxDetail>;
  taxTotal: Scalars['Decimal']['output'];
  timeSheetApprovalIds: Array<Scalars['ID']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export type CreateAbsenceError = DomainError | PropertyValidationError;

export type CreateAbsenceInput = {
  absenceReasonId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  delegateEmployeeId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
  end: Scalars['LocalDate']['input'];
  isHalfEndDay: Scalars['Boolean']['input'];
  isHalfStartDay: Scalars['Boolean']['input'];
  start: Scalars['LocalDate']['input'];
  startWorkflow?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateAbsencePayload = {
  __typename?: 'CreateAbsencePayload';
  absence?: Maybe<Absence>;
  errors?: Maybe<Array<CreateAbsenceError>>;
};

export type CreateAbsenceReasonError = DomainError | PropertyValidationError;

export type CreateAbsenceReasonInput = {
  description: Scalars['String']['input'];
  isPaid: Scalars['Boolean']['input'];
  isVisible: Scalars['Boolean']['input'];
  maximumContinuedPayment?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  removesWorkingHours: Scalars['Boolean']['input'];
  type: AbsenceReasonType;
};

export type CreateAbsenceReasonPayload = {
  __typename?: 'CreateAbsenceReasonPayload';
  absenceReason?: Maybe<AbsenceReason>;
  errors?: Maybe<Array<CreateAbsenceReasonError>>;
};

export type CreateAccountingProfileError = PropertyValidationError;

export type CreateAccountingProfileInput = {
  entries: Array<AccountingProfileEntryInput>;
  name: Scalars['String']['input'];
};

export type CreateAccountingProfilePayload = {
  __typename?: 'CreateAccountingProfilePayload';
  accountingProfile?: Maybe<AccountingProfile>;
  errors?: Maybe<Array<CreateAccountingProfileError>>;
};

export type CreateBillingInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type CreateBillingInformationInput = {
  bankAccount: BankAccountInput;
  billingAddress: AddressInput;
  contactId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  shippingAddress: AddressInput;
};

export type CreateBillingInformationPayload = {
  __typename?: 'CreateBillingInformationPayload';
  billingInformation?: Maybe<BillingInformation>;
  errors?: Maybe<Array<CreateBillingInformationError>>;
};

export type CreateBucketInput = {
  entityId: Scalars['String']['input'];
};

export type CreateBucketPayload = {
  __typename?: 'CreateBucketPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateCalendarEventError = DomainError | PropertyValidationError;

export type CreateCalendarEventInput = {
  description: Scalars['String']['input'];
  endDate: Scalars['LocalDate']['input'];
  federalStateCodes: Array<Scalars['String']['input']>;
  isHalfEndDay: Scalars['Boolean']['input'];
  isHalfStartDay: Scalars['Boolean']['input'];
  isVacation: Scalars['Boolean']['input'];
  locations: Array<Scalars['String']['input']>;
  startDate: Scalars['LocalDate']['input'];
  type: CalendarEventType;
};

export type CreateCalendarEventPayload = {
  __typename?: 'CreateCalendarEventPayload';
  calendarEvent?: Maybe<CalendarEvent>;
  errors?: Maybe<Array<CreateCalendarEventError>>;
};

export type CreateCompanyContactError = DomainError | PropertyValidationError;

export type CreateCompanyContactInput = {
  companyName: Scalars['String']['input'];
  contactType: ContactType;
};

export type CreateCompanyContactPayload = {
  __typename?: 'CreateCompanyContactPayload';
  contact?: Maybe<Contact>;
  errors?: Maybe<Array<CreateCompanyContactError>>;
};

export type CreateContactAddressError = DomainError | EntityNotFoundError | PropertyValidationError;

export type CreateContactAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  contactId: Scalars['ID']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  type?: AddressType;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContactAddressPayload = {
  __typename?: 'CreateContactAddressPayload';
  addressInformation?: Maybe<AddressInformation>;
  errors?: Maybe<Array<CreateContactAddressError>>;
};

export type CreateContactEmailError = DomainError | EntityNotFoundError | PropertyValidationError;

export type CreateContactEmailInput = {
  contactId: Scalars['ID']['input'];
  emailAddress: Scalars['String']['input'];
  emailType: EmailType;
};

export type CreateContactEmailPayload = {
  __typename?: 'CreateContactEmailPayload';
  emailInformation?: Maybe<EmailInformation>;
  errors?: Maybe<Array<CreateContactEmailError>>;
};

export type CreateContactPersonInformationError = EntityNotFoundError | PropertyValidationError;

export type CreateContactPersonInformationInput = {
  contactId: Scalars['ID']['input'];
  contactPersonId: Scalars['ID']['input'];
  contactUsage: Array<ContactUsage>;
};

export type CreateContactPersonInformationPayload = {
  __typename?: 'CreateContactPersonInformationPayload';
  contactPersonInformation?: Maybe<ContactPersonInformation>;
  errors?: Maybe<Array<CreateContactPersonInformationError>>;
};

export type CreateContractedInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type CreateContractedInformationInput = {
  contactId: Scalars['ID']['input'];
  contractedId: Scalars['ID']['input'];
  margin: Scalars['Decimal']['input'];
};

export type CreateContractedInformationPayload = {
  __typename?: 'CreateContractedInformationPayload';
  contractedInformation?: Maybe<ContractedInformation>;
  errors?: Maybe<Array<CreateContractedInformationError>>;
};

export type CreateDateInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type CreateDateInformationInput = {
  contactId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  dateType: PersonDateType;
};

export type CreateDateInformationPayload = {
  __typename?: 'CreateDateInformationPayload';
  dateInformation?: Maybe<DateInformation>;
  errors?: Maybe<Array<CreateDateInformationError>>;
};

export type CreateDepartmentError = PropertyValidationError;

export type CreateDepartmentInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type CreateDepartmentInformationInput = {
  contactId: Scalars['ID']['input'];
  departmentName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDepartmentInformationPayload = {
  __typename?: 'CreateDepartmentInformationPayload';
  departmentInformation?: Maybe<DepartmentInformation>;
  errors?: Maybe<Array<CreateDepartmentInformationError>>;
};

export type CreateDepartmentInput = {
  companyId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  leaderId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateDepartmentPayload = {
  __typename?: 'CreateDepartmentPayload';
  department?: Maybe<Department>;
  errors?: Maybe<Array<CreateDepartmentError>>;
};

export type CreateDiscountProfileError = MyEntityNotFoundError | PropertyValidationError;

export type CreateDiscountProfileInput = {
  entries: Array<DiscountProfileEntryInput>;
  maxDueDate: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type CreateDiscountProfilePayload = {
  __typename?: 'CreateDiscountProfilePayload';
  discountProfile?: Maybe<DiscountProfile>;
  errors?: Maybe<Array<CreateDiscountProfileError>>;
};

export type CreateDocumentDraftError = DomainError | PropertyValidationError;

export type CreateDocumentDraftInput = {
  creditNoteKind?: InputMaybe<CreditNoteKind>;
  document: ModifyInvoiceInput;
  documentRole?: InputMaybe<DocumentRole>;
  documentType: DocumentType;
  settlesInvoiceId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateDocumentDraftPayload = {
  __typename?: 'CreateDocumentDraftPayload';
  commercialDocument?: Maybe<CommercialDocument>;
  errors?: Maybe<Array<CreateDocumentDraftError>>;
};

export type CreateDownloadUrlInput = {
  disposition?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  fileNameOverride?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
};

export type CreateDownloadUrlPayload = {
  __typename?: 'CreateDownloadUrlPayload';
  string?: Maybe<Scalars['String']['output']>;
};

export type CreateDunningLevelError = MyEntityNotFoundError | PropertyValidationError;

export type CreateDunningLevelInput = {
  contractorId: Scalars['ID']['input'];
  feeAmount: Scalars['Decimal']['input'];
  feeCurrency: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  level: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  paymentDays: Scalars['Int']['input'];
};

export type CreateDunningLevelPayload = {
  __typename?: 'CreateDunningLevelPayload';
  dunningLevel?: Maybe<DunningLevel>;
  errors?: Maybe<Array<CreateDunningLevelError>>;
};

export type CreateEmailError = MyEntityNotFoundError | PropertyValidationError;

export type CreateEmailInput = {
  attachments?: InputMaybe<Array<EmailAttachmentInput>>;
  bccRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  body: Scalars['String']['input'];
  ccRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  contactId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  recipients: Array<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  type: EmailType;
};

export type CreateEmailPayload = {
  __typename?: 'CreateEmailPayload';
  email?: Maybe<Email>;
  errors?: Maybe<Array<CreateEmailError>>;
};

export type CreateEmployeeWorkingConditionError = DomainError | EntityNotFoundError | PropertyValidationError;

export type CreateEmployeeWorkingConditionInput = {
  contactId: Scalars['ID']['input'];
  federalCode: Scalars['String']['input'];
  from: Scalars['LocalDate']['input'];
  to?: InputMaybe<Scalars['LocalDate']['input']>;
  workingTimeModelId: Scalars['ID']['input'];
};

export type CreateEmployeeWorkingConditionPayload = {
  __typename?: 'CreateEmployeeWorkingConditionPayload';
  employeeWorkingConditionInformation?: Maybe<EmployeeWorkingConditionInformation>;
  errors?: Maybe<Array<CreateEmployeeWorkingConditionError>>;
};

export type CreateFileEntryError = InvalidEntityIdError | PropertyValidationError;

export type CreateFileEntryInput = {
  file: Scalars['Upload']['input'];
  folderPath: Scalars['String']['input'];
};

export type CreateFileEntryPayload = {
  __typename?: 'CreateFileEntryPayload';
  errors?: Maybe<Array<CreateFileEntryError>>;
  fileEntry?: Maybe<FileEntry>;
};

export type CreateFolderEntryError = InvalidEntityIdError | PropertyValidationError;

export type CreateFolderEntryInput = {
  folderPath: Scalars['String']['input'];
};

export type CreateFolderEntryPayload = {
  __typename?: 'CreateFolderEntryPayload';
  errors?: Maybe<Array<CreateFolderEntryError>>;
  folderEntry?: Maybe<FolderEntry>;
};

export type CreateFolderInput = {
  entityId: Scalars['String']['input'];
  path: Scalars['String']['input'];
};

export type CreateFolderPayload = {
  __typename?: 'CreateFolderPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateMailboxContactError = DomainError | PropertyValidationError;

export type CreateMailboxContactInput = {
  memberOfCompanyId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateMailboxContactPayload = {
  __typename?: 'CreateMailboxContactPayload';
  contact?: Maybe<Contact>;
  errors?: Maybe<Array<CreateMailboxContactError>>;
};

export type CreateNextRollingNumberError = MyEntityNotFoundError | PropertyValidationError;

export type CreateNextRollingNumberInput = {
  contactId?: InputMaybe<Scalars['ID']['input']>;
  type: RollingNumberType;
};

export type CreateNextRollingNumberPayload = {
  __typename?: 'CreateNextRollingNumberPayload';
  errors?: Maybe<Array<CreateNextRollingNumberError>>;
  string?: Maybe<Scalars['String']['output']>;
};

export type CreateOfferFromProjectError = DomainError | PropertyValidationError;

export type CreateOfferFromProjectInput = {
  projectId: Scalars['ID']['input'];
};

export type CreateOfferFromProjectPayload = {
  __typename?: 'CreateOfferFromProjectPayload';
  errors?: Maybe<Array<CreateOfferFromProjectError>>;
  offer?: Maybe<Offer>;
};

export type CreatePaymentConditionInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type CreatePaymentConditionInformationInput = {
  contactId: Scalars['ID']['input'];
  discountProfileId?: InputMaybe<VersionedDiscountProfileIdInput>;
  doesNotParticipateInVoucherProcess: Scalars['Boolean']['input'];
  selectedEntryId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreatePaymentConditionInformationPayload = {
  __typename?: 'CreatePaymentConditionInformationPayload';
  errors?: Maybe<Array<CreatePaymentConditionInformationError>>;
  paymentConditionInformation?: Maybe<PaymentConditionInformation>;
};

export type CreatePaymentInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type CreatePaymentInformationInput = {
  contactId: Scalars['ID']['input'];
  paymentDeadlineInDays?: InputMaybe<Scalars['Int']['input']>;
  routeId?: InputMaybe<Scalars['String']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePaymentInformationPayload = {
  __typename?: 'CreatePaymentInformationPayload';
  errors?: Maybe<Array<CreatePaymentInformationError>>;
  paymentInformation?: Maybe<PaymentInformation>;
};

export type CreatePersonContactError = DomainError | PropertyValidationError;

export type CreatePersonContactInput = {
  contactType: ContactType;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  memberOfCompanyId: Scalars['ID']['input'];
  salutation: SalutationType;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePersonContactPayload = {
  __typename?: 'CreatePersonContactPayload';
  contact?: Maybe<Contact>;
  errors?: Maybe<Array<CreatePersonContactError>>;
};

export type CreatePhoneInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type CreatePhoneInformationInput = {
  contactId: Scalars['ID']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  phoneType: PhoneType;
};

export type CreatePhoneInformationPayload = {
  __typename?: 'CreatePhoneInformationPayload';
  errors?: Maybe<Array<CreatePhoneInformationError>>;
  phoneInformation?: Maybe<PhoneInformation>;
};

export type CreateProjectAdditionalAccountingInformationError = DomainError | PropertyValidationError;

export type CreateProjectAdditionalAccountingInformationInput = {
  accountingProfileId?: InputMaybe<Scalars['ID']['input']>;
  clientContractNumber?: InputMaybe<Scalars['String']['input']>;
  clientContratDate?: InputMaybe<Scalars['LocalDate']['input']>;
  clientOrderingDate?: InputMaybe<Scalars['LocalDate']['input']>;
  clientOrderingNumber?: InputMaybe<Scalars['String']['input']>;
  clientProjectNumber?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  provision?: InputMaybe<Scalars['Decimal']['input']>;
  provisionDescription?: InputMaybe<Scalars['String']['input']>;
  supplierProjectNumber?: InputMaybe<Scalars['String']['input']>;
  timeTrackingResolution: Scalars['Int']['input'];
};

export type CreateProjectAdditionalAccountingInformationPayload = {
  __typename?: 'CreateProjectAdditionalAccountingInformationPayload';
  additionalAccountingInformation?: Maybe<AdditionalAccountingInformation>;
  errors?: Maybe<Array<CreateProjectAdditionalAccountingInformationError>>;
};

export type CreateProjectAdditionalContactInformationError = DomainError | PropertyValidationError;

export type CreateProjectAdditionalContactInformationInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  contractorId: Scalars['ID']['input'];
  endCustomer?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};

export type CreateProjectAdditionalContactInformationPayload = {
  __typename?: 'CreateProjectAdditionalContactInformationPayload';
  additionalContactInformation?: Maybe<AdditionalContactInformation>;
  errors?: Maybe<Array<CreateProjectAdditionalContactInformationError>>;
};

export type CreateProjectAdditionalContactPersonInformationError = DomainError | PropertyValidationError;

export type CreateProjectAdditionalContactPersonInformationInput = {
  clientContactPersonId?: InputMaybe<Scalars['ID']['input']>;
  contractorContactPersonId?: InputMaybe<Scalars['ID']['input']>;
  contractorProjectLeaderId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
};

export type CreateProjectAdditionalContactPersonInformationPayload = {
  __typename?: 'CreateProjectAdditionalContactPersonInformationPayload';
  additionalContactPersonInformation?: Maybe<AdditionalContactPersonInformation>;
  errors?: Maybe<Array<CreateProjectAdditionalContactPersonInformationError>>;
};

export type CreateProjectAdditionalPositionInformationError = DomainError | PropertyValidationError;

export type CreateProjectAdditionalPositionInformationInput = {
  accountingProfileId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hours?: InputMaybe<Scalars['Decimal']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  pricePerHour?: InputMaybe<Scalars['Decimal']['input']>;
  priceRate?: InputMaybe<ProjectPositionPriceRateType>;
  projectId: Scalars['ID']['input'];
  projectSaleableServiceId: Scalars['String']['input'];
  serviceName: Scalars['String']['input'];
  servicePrice: Scalars['Decimal']['input'];
};

export type CreateProjectAdditionalPositionInformationPayload = {
  __typename?: 'CreateProjectAdditionalPositionInformationPayload';
  additionalPositionInformation?: Maybe<AdditionalPositionInformation>;
  errors?: Maybe<Array<CreateProjectAdditionalPositionInformationError>>;
};

export type CreateProjectAdditionalTeamMemberInformationError = DomainError | PropertyValidationError;

export type CreateProjectAdditionalTeamMemberInformationInput = {
  contractorId?: InputMaybe<Scalars['ID']['input']>;
  memberId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  worksOnPositions: Array<WorksOnPositionInput>;
};

export type CreateProjectAdditionalTeamMemberInformationPayload = {
  __typename?: 'CreateProjectAdditionalTeamMemberInformationPayload';
  additionalTeamMemberInformation?: Maybe<AdditionalTeamMemberInformation>;
  errors?: Maybe<Array<CreateProjectAdditionalTeamMemberInformationError>>;
};

export type CreateProjectAdditionalTemplateInformationError = DomainError | PropertyValidationError;

export type CreateProjectAdditionalTemplateInformationInput = {
  isDetailTimesheet: Scalars['Boolean']['input'];
  isInvoiceWithTimesheet: Scalars['Boolean']['input'];
  projectId: Scalars['ID']['input'];
};

export type CreateProjectAdditionalTemplateInformationPayload = {
  __typename?: 'CreateProjectAdditionalTemplateInformationPayload';
  additionalTemplateInformation?: Maybe<AdditionalTemplateInformation>;
  errors?: Maybe<Array<CreateProjectAdditionalTemplateInformationError>>;
};

export type CreateProjectError = DomainError | PropertyValidationError;

export type CreateProjectInput = {
  name: Scalars['String']['input'];
  parentProjectId?: InputMaybe<Scalars['ID']['input']>;
  range: DateOnlyRangeInput;
  type: ProjectType;
};

export type CreateProjectPayload = {
  __typename?: 'CreateProjectPayload';
  errors?: Maybe<Array<CreateProjectError>>;
  project?: Maybe<Project>;
};

export type CreateProjectSaleableServiceError = DomainError | PropertyValidationError;

export type CreateProjectSaleableServiceGroupError = DomainError | PropertyValidationError;

export type CreateProjectSaleableServiceGroupInput = {
  budget: BudgetInput;
  hasFixSellingPrice: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  originalGroupId: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  sellingPrice: Scalars['Decimal']['input'];
};

export type CreateProjectSaleableServiceGroupPayload = {
  __typename?: 'CreateProjectSaleableServiceGroupPayload';
  errors?: Maybe<Array<CreateProjectSaleableServiceGroupError>>;
  projectSaleableServiceGroup?: Maybe<ProjectSaleableServiceGroup>;
};

export type CreateProjectSaleableServiceInput = {
  budget: BudgetInput;
  hasFixSellingPrice: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  originalServiceId: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  projectSaleableServiceGroupId: Scalars['ID']['input'];
  projectSaleableUnitId: Scalars['ID']['input'];
  purchasePrice: Scalars['Decimal']['input'];
  sellingPrice: Scalars['Decimal']['input'];
  vatRate: Scalars['Decimal']['input'];
};

export type CreateProjectSaleableServicePayload = {
  __typename?: 'CreateProjectSaleableServicePayload';
  errors?: Maybe<Array<CreateProjectSaleableServiceError>>;
  projectSaleableService?: Maybe<ProjectSaleableService>;
};

export type CreateProjectSaleableUnitError = DomainError | PropertyValidationError;

export type CreateProjectSaleableUnitInput = {
  name: Scalars['String']['input'];
  originalUnitId: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  shortCode: Scalars['String']['input'];
};

export type CreateProjectSaleableUnitPayload = {
  __typename?: 'CreateProjectSaleableUnitPayload';
  errors?: Maybe<Array<CreateProjectSaleableUnitError>>;
  projectSaleableUnit?: Maybe<ProjectSaleableUnit>;
};

export type CreateSalaryInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type CreateSalaryInformationInput = {
  contactId: Scalars['ID']['input'];
  pricePerHour: Scalars['Decimal']['input'];
  startDate: Scalars['LocalDate']['input'];
};

export type CreateSalaryInformationPayload = {
  __typename?: 'CreateSalaryInformationPayload';
  errors?: Maybe<Array<CreateSalaryInformationError>>;
  salaryInformation?: Maybe<SalaryInformation>;
};

export type CreateSaleableServiceError = PropertyValidationError;

export type CreateSaleableServiceGroupError = PropertyValidationError;

export type CreateSaleableServiceGroupInput = {
  name: Scalars['String']['input'];
  sellingPrice: Scalars['Decimal']['input'];
};

export type CreateSaleableServiceGroupPayload = {
  __typename?: 'CreateSaleableServiceGroupPayload';
  errors?: Maybe<Array<CreateSaleableServiceGroupError>>;
  saleableServiceGroup?: Maybe<SaleableServiceGroup>;
};

export type CreateSaleableServiceInput = {
  groupId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  purchasePrice: Scalars['Decimal']['input'];
  sellingPrice: Scalars['Decimal']['input'];
  unitId: Scalars['ID']['input'];
  vatRate: Scalars['Decimal']['input'];
};

export type CreateSaleableServicePayload = {
  __typename?: 'CreateSaleableServicePayload';
  errors?: Maybe<Array<CreateSaleableServiceError>>;
  saleableService?: Maybe<SaleableService>;
};

export type CreateSaleableUnitError = PropertyValidationError;

export type CreateSaleableUnitInput = {
  name: Scalars['String']['input'];
  shortCode: Scalars['String']['input'];
};

export type CreateSaleableUnitPayload = {
  __typename?: 'CreateSaleableUnitPayload';
  errors?: Maybe<Array<CreateSaleableUnitError>>;
  saleableUnit?: Maybe<SaleableUnit>;
};

export type CreateTemplateError = DomainError | PropertyValidationError;

export type CreateTemplateInput = {
  contactId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  rendering: TemplateRendering;
  type: TemplateType;
};

export type CreateTemplatePayload = {
  __typename?: 'CreateTemplatePayload';
  errors?: Maybe<Array<CreateTemplateError>>;
  template?: Maybe<Template>;
};

export type CreateTemporaryFreelancerError = DomainError | PropertyValidationError;

export type CreateTemporaryFreelancerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  pricePerHour: Scalars['Decimal']['input'];
  salutation: SalutationType;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTemporaryFreelancerPayload = {
  __typename?: 'CreateTemporaryFreelancerPayload';
  contact?: Maybe<Contact>;
  errors?: Maybe<Array<CreateTemporaryFreelancerError>>;
};

export type CreateTimeBalanceEntryError = DomainError | PropertyValidationError;

export type CreateTimeBalanceEntryInput = {
  date: Scalars['LocalDate']['input'];
  employeeId: Scalars['ID']['input'];
  overtime?: InputMaybe<Scalars['TimeSpan']['input']>;
  reason: Scalars['String']['input'];
  type: TimeBalanceType;
  vacationDays?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreateTimeBalanceEntryPayload = {
  __typename?: 'CreateTimeBalanceEntryPayload';
  errors?: Maybe<Array<CreateTimeBalanceEntryError>>;
  timeBalanceEntry?: Maybe<TimeBalanceEntry>;
};

export type CreateTimeLabelError = DomainError | PropertyValidationError;

export type CreateTimeLabelGroupError = DomainError | PropertyValidationError;

export type CreateTimeLabelGroupInput = {
  companyId: Scalars['ID']['input'];
  isGlobal: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreateTimeLabelGroupPayload = {
  __typename?: 'CreateTimeLabelGroupPayload';
  errors?: Maybe<Array<CreateTimeLabelGroupError>>;
  timeLabelGroup?: Maybe<TimeLabelGroup>;
};

export type CreateTimeLabelInput = {
  companyId: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreateTimeLabelPayload = {
  __typename?: 'CreateTimeLabelPayload';
  errors?: Maybe<Array<CreateTimeLabelError>>;
  timeLabel?: Maybe<TimeLabel>;
};

export type CreateWebsiteInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type CreateWebsiteInformationInput = {
  contactId: Scalars['ID']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWebsiteInformationPayload = {
  __typename?: 'CreateWebsiteInformationPayload';
  errors?: Maybe<Array<CreateWebsiteInformationError>>;
  websiteInformation?: Maybe<WebsiteInformation>;
};

export type CreateWorkingConditionInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type CreateWorkingConditionInformationInput = {
  contactId: Scalars['ID']['input'];
  hoursPerFriday: Scalars['Decimal']['input'];
  hoursPerMonday: Scalars['Decimal']['input'];
  hoursPerSaturday: Scalars['Decimal']['input'];
  hoursPerSunday: Scalars['Decimal']['input'];
  hoursPerThursday: Scalars['Decimal']['input'];
  hoursPerTuesday: Scalars['Decimal']['input'];
  hoursPerWednesday: Scalars['Decimal']['input'];
  hoursPerWeek: Scalars['Decimal']['input'];
  isFlexible: Scalars['Boolean']['input'];
  startDate: Scalars['LocalDate']['input'];
};

export type CreateWorkingConditionInformationPayload = {
  __typename?: 'CreateWorkingConditionInformationPayload';
  errors?: Maybe<Array<CreateWorkingConditionInformationError>>;
  workingConditionInformation?: Maybe<WorkingConditionInformation>;
};

export type CreateWorkingTimeModelError = DomainError | PropertyValidationError;

export type CreateWorkingTimeModelInput = {
  description: Scalars['String']['input'];
  hoursPerFriday: Scalars['Decimal']['input'];
  hoursPerMonday: Scalars['Decimal']['input'];
  hoursPerSaturday: Scalars['Decimal']['input'];
  hoursPerSunday: Scalars['Decimal']['input'];
  hoursPerThursday: Scalars['Decimal']['input'];
  hoursPerTuesday: Scalars['Decimal']['input'];
  hoursPerWednesday: Scalars['Decimal']['input'];
  hoursPerWeek: Scalars['Decimal']['input'];
  isFlexible: Scalars['Boolean']['input'];
  isVisible: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  vacationDaysPerYear: Scalars['Decimal']['input'];
};

export type CreateWorkingTimeModelPayload = {
  __typename?: 'CreateWorkingTimeModelPayload';
  errors?: Maybe<Array<CreateWorkingTimeModelError>>;
  workingTimeModel?: Maybe<WorkingTimeModel>;
};

export type CreditNote = CommercialDocument & Node & {
  __typename?: 'CreditNote';
  billTo: GenericAddress;
  cancelVoid: CreditNote;
  cancelWithReversal: CorrectedCreditNote;
  cancellation?: Maybe<CancellationInfo>;
  clientContactPersonId?: Maybe<Scalars['ID']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clientVatId?: Maybe<Scalars['String']['output']>;
  concludingText?: Maybe<Scalars['String']['output']>;
  contractorId?: Maybe<Scalars['ID']['output']>;
  contractorVatId?: Maybe<Scalars['String']['output']>;
  createdById: Scalars['ID']['output'];
  createdDate: Scalars['LocalDate']['output'];
  documentRole: DocumentRole;
  documentType: DocumentType;
  dueDate?: Maybe<Scalars['LocalDate']['output']>;
  employeeIds: Array<Scalars['ID']['output']>;
  grossTotal: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  introductoryText: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isInvalid: Scalars['Boolean']['output'];
  isPayable: Scalars['Boolean']['output'];
  isProforma: Scalars['Boolean']['output'];
  isReversal: Scalars['Boolean']['output'];
  issueDate?: Maybe<Scalars['LocalDate']['output']>;
  items: Array<LineItem>;
  kind: CreditNoteKind;
  netTotal: Scalars['Decimal']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  openTotal: Scalars['Decimal']['output'];
  paidTotal: Scalars['Decimal']['output'];
  paymentDeadlineInDays: Scalars['Int']['output'];
  payments?: Maybe<Array<PaymentItem>>;
  projectId?: Maybe<Scalars['ID']['output']>;
  recipientObjectedAt?: Maybe<Scalars['DateTime']['output']>;
  sentDate?: Maybe<Scalars['DateTime']['output']>;
  sentEmailId?: Maybe<Scalars['UUID']['output']>;
  settlesInvoiceId?: Maybe<Scalars['ID']['output']>;
  shipTo?: Maybe<GenericAddress>;
  status: DocumentStatus;
  taxDetails: Array<TaxDetail>;
  taxTotal: Scalars['Decimal']['output'];
  timeSheetApprovalIds: Array<Scalars['ID']['output']>;
  timestamp: Scalars['DateTime']['output'];
};


export type CreditNoteCancelVoidArgs = {
  reason: Scalars['String']['input'];
};


export type CreditNoteCancelWithReversalArgs = {
  createdBy: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export enum CreditNoteKind {
  CustomerCreditMemo = 'CUSTOMER_CREDIT_MEMO',
  SelfBilling = 'SELF_BILLING'
}

export type CreditNoteReference = {
  __typename?: 'CreditNoteReference';
  createdAt: Scalars['DateTime']['output'];
  creditNoteId: Scalars['ID']['output'];
  status: InvoiceDocumentStatus;
};

export type DateInformation = ContactAdditionalInformation & {
  __typename?: 'DateInformation';
  date?: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['ID']['output'];
  personDateType: PersonDateType;
};

export type DateOnlyRange = {
  __typename?: 'DateOnlyRange';
  contains: Scalars['Boolean']['output'];
  dates: Array<Scalars['LocalDate']['output']>;
  from: Scalars['LocalDate']['output'];
  to: Scalars['LocalDate']['output'];
};


export type DateOnlyRangeContainsArgs = {
  date: Scalars['LocalDate']['input'];
};

export type DateOnlyRangeInput = {
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DeleteAbsenceError = DomainError | PropertyValidationError;

export type DeleteAbsenceInput = {
  absenceId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['Long']['input'];
};

export type DeleteAbsencePayload = {
  __typename?: 'DeleteAbsencePayload';
  absence?: Maybe<Absence>;
  errors?: Maybe<Array<DeleteAbsenceError>>;
};

export type DeleteAbsenceReasonError = DomainError | PropertyValidationError;

export type DeleteAbsenceReasonInput = {
  id: Scalars['ID']['input'];
};

export type DeleteAbsenceReasonPayload = {
  __typename?: 'DeleteAbsenceReasonPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteAbsenceReasonError>>;
};

export type DeleteAccountingProfileError = DomainError | PropertyValidationError;

export type DeleteAccountingProfileInput = {
  id: Scalars['ID']['input'];
};

export type DeleteAccountingProfilePayload = {
  __typename?: 'DeleteAccountingProfilePayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteAccountingProfileError>>;
};

export type DeleteAdditionalInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type DeleteAdditionalInformationInput = {
  contactId: Scalars['ID']['input'];
  informationId: Scalars['ID']['input'];
};

export type DeleteAdditionalInformationPayload = {
  __typename?: 'DeleteAdditionalInformationPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteAdditionalInformationError>>;
};

export type DeleteBucketInput = {
  entityId: Scalars['String']['input'];
  force: Scalars['Boolean']['input'];
};

export type DeleteBucketPayload = {
  __typename?: 'DeleteBucketPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCalendarEventError = PropertyValidationError;

export type DeleteCalendarEventInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCalendarEventPayload = {
  __typename?: 'DeleteCalendarEventPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteCalendarEventError>>;
};

export type DeleteContactAddressError = DomainError | EntityNotFoundError | PropertyValidationError;

export type DeleteContactAddressInput = {
  contactId: Scalars['ID']['input'];
  informationId: Scalars['ID']['input'];
};

export type DeleteContactAddressPayload = {
  __typename?: 'DeleteContactAddressPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteContactAddressError>>;
};

export type DeleteCorrectedCreditNotePaymentError = DomainError | PropertyValidationError;

export type DeleteCorrectedCreditNotePaymentInput = {
  correctedCreditNoteId: Scalars['ID']['input'];
  paymentId: Scalars['ID']['input'];
};

export type DeleteCorrectedCreditNotePaymentPayload = {
  __typename?: 'DeleteCorrectedCreditNotePaymentPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteCorrectedCreditNotePaymentError>>;
};

export type DeleteCorrectedInvoicePaymentError = DomainError | PropertyValidationError;

export type DeleteCorrectedInvoicePaymentInput = {
  correctedInvoiceId: Scalars['ID']['input'];
  paymentId: Scalars['ID']['input'];
};

export type DeleteCorrectedInvoicePaymentPayload = {
  __typename?: 'DeleteCorrectedInvoicePaymentPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteCorrectedInvoicePaymentError>>;
};

export type DeleteCreditNotePaymentError = DomainError | PropertyValidationError;

export type DeleteCreditNotePaymentInput = {
  creditNoteId: Scalars['ID']['input'];
  creditNotePaymentId: Scalars['ID']['input'];
};

export type DeleteCreditNotePaymentPayload = {
  __typename?: 'DeleteCreditNotePaymentPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteCreditNotePaymentError>>;
};

export type DeleteDepartmentError = PropertyValidationError;

export type DeleteDepartmentInput = {
  departmentId: Scalars['ID']['input'];
};

export type DeleteDepartmentPayload = {
  __typename?: 'DeleteDepartmentPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteDepartmentError>>;
};

export type DeleteDiscountProfileError = MyEntityNotFoundError | PropertyValidationError;

export type DeleteDiscountProfileInput = {
  id: Scalars['ID']['input'];
};

export type DeleteDiscountProfilePayload = {
  __typename?: 'DeleteDiscountProfilePayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteDiscountProfileError>>;
};

export type DeleteDocumentDraftError = DomainError | PropertyValidationError;

export type DeleteDocumentDraftInput = {
  documentId: Scalars['String']['input'];
};

export type DeleteDocumentDraftPayload = {
  __typename?: 'DeleteDocumentDraftPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteDocumentDraftError>>;
};

export type DeleteDunningLevelError = MyEntityNotFoundError | PropertyValidationError;

export type DeleteDunningLevelInput = {
  id: Scalars['ID']['input'];
};

export type DeleteDunningLevelPayload = {
  __typename?: 'DeleteDunningLevelPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteDunningLevelError>>;
};

export type DeleteFileEntryError = InvalidEntityIdError | PropertyValidationError;

export type DeleteFileEntryInput = {
  id: Scalars['ID']['input'];
};

export type DeleteFileEntryPayload = {
  __typename?: 'DeleteFileEntryPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteFileEntryError>>;
};

export type DeleteFolderEntryError = InvalidEntityIdError | PropertyValidationError;

export type DeleteFolderEntryInput = {
  id: Scalars['ID']['input'];
};

export type DeleteFolderEntryPayload = {
  __typename?: 'DeleteFolderEntryPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteFolderEntryError>>;
};

export type DeleteInvoicePaymentError = DomainError | PropertyValidationError;

export type DeleteInvoicePaymentInput = {
  invoiceId: Scalars['ID']['input'];
  invoicePaymentId: Scalars['ID']['input'];
};

export type DeleteInvoicePaymentPayload = {
  __typename?: 'DeleteInvoicePaymentPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteInvoicePaymentError>>;
};

export type DeleteMemberError = DomainError | EntityNotFoundError | PropertyValidationError;

export type DeleteMemberInput = {
  memberId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type DeleteMemberPayload = {
  __typename?: 'DeleteMemberPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteMemberError>>;
};

export type DeleteOfferDraftError = DomainError | PropertyValidationError;

export type DeleteOfferDraftInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOfferDraftPayload = {
  __typename?: 'DeleteOfferDraftPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteOfferDraftError>>;
};

export type DeletePathInput = {
  entityId: Scalars['String']['input'];
  path: Scalars['String']['input'];
  recursive?: Scalars['Boolean']['input'];
};

export type DeletePathPayload = {
  __typename?: 'DeletePathPayload';
  deleteResult?: Maybe<DeleteResult>;
};

export type DeleteProjectAdditionalInformationError = DomainError | PropertyValidationError;

export type DeleteProjectAdditionalInformationInput = {
  projectId: Scalars['ID']['input'];
  projectInformationId: Scalars['ID']['input'];
};

export type DeleteProjectAdditionalInformationPayload = {
  __typename?: 'DeleteProjectAdditionalInformationPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteProjectAdditionalInformationError>>;
};

export type DeleteProjectError = DomainError | PropertyValidationError;

export type DeleteProjectInput = {
  projectId: Scalars['ID']['input'];
};

export type DeleteProjectPayload = {
  __typename?: 'DeleteProjectPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteProjectError>>;
};

export type DeleteProjectSaleableServiceError = DomainError | PropertyValidationError;

export type DeleteProjectSaleableServiceGroupError = DomainError | PropertyValidationError;

export type DeleteProjectSaleableServiceGroupInput = {
  projectId: Scalars['ID']['input'];
  projectSaleableServiceGroupId: Scalars['ID']['input'];
};

export type DeleteProjectSaleableServiceGroupPayload = {
  __typename?: 'DeleteProjectSaleableServiceGroupPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteProjectSaleableServiceGroupError>>;
};

export type DeleteProjectSaleableServiceInput = {
  projectId: Scalars['ID']['input'];
  projectSaleableServiceId: Scalars['ID']['input'];
};

export type DeleteProjectSaleableServicePayload = {
  __typename?: 'DeleteProjectSaleableServicePayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteProjectSaleableServiceError>>;
};

export type DeleteProjectSaleableUnitError = DomainError | PropertyValidationError;

export type DeleteProjectSaleableUnitInput = {
  projectId: Scalars['ID']['input'];
  projectSaleableUnitId: Scalars['ID']['input'];
};

export type DeleteProjectSaleableUnitPayload = {
  __typename?: 'DeleteProjectSaleableUnitPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteProjectSaleableUnitError>>;
};

export type DeleteResult = {
  __typename?: 'DeleteResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteSaleableServiceError = DomainError | PropertyValidationError;

export type DeleteSaleableServiceGroupError = DomainError | PropertyValidationError;

export type DeleteSaleableServiceGroupInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSaleableServiceGroupPayload = {
  __typename?: 'DeleteSaleableServiceGroupPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteSaleableServiceGroupError>>;
};

export type DeleteSaleableServiceInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSaleableServicePayload = {
  __typename?: 'DeleteSaleableServicePayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteSaleableServiceError>>;
};

export type DeleteSaleableUnitError = DomainError | PropertyValidationError;

export type DeleteSaleableUnitInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSaleableUnitPayload = {
  __typename?: 'DeleteSaleableUnitPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteSaleableUnitError>>;
};

export type DeleteSubstituteInput = {
  absenceId: Scalars['ID']['input'];
};

export type DeleteSubstitutePayload = {
  __typename?: 'DeleteSubstitutePayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteTemplateError = PropertyValidationError;

export type DeleteTemplateInput = {
  templateId: Scalars['ID']['input'];
};

export type DeleteTemplatePayload = {
  __typename?: 'DeleteTemplatePayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteTemplateError>>;
};

export type DeleteTimeApprovalError = DomainError | PropertyValidationError;

export type DeleteTimeApprovalInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  projectTimeApprovalId: Scalars['ID']['input'];
};

export type DeleteTimeApprovalPayload = {
  __typename?: 'DeleteTimeApprovalPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteTimeApprovalError>>;
};

export type DeleteTimeBalanceEntryError = PropertyValidationError;

export type DeleteTimeBalanceEntryInput = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  version: Scalars['Long']['input'];
};

export type DeleteTimeBalanceEntryPayload = {
  __typename?: 'DeleteTimeBalanceEntryPayload';
  errors?: Maybe<Array<DeleteTimeBalanceEntryError>>;
  timeBalanceEntry?: Maybe<TimeBalanceEntry>;
};

export type DeleteTimeLabelError = ConcurrentAccessError | PropertyValidationError;

export type DeleteTimeLabelGroupError = ConcurrentAccessError | PropertyValidationError;

export type DeleteTimeLabelGroupInput = {
  id: Scalars['ID']['input'];
  version: Scalars['Long']['input'];
};

export type DeleteTimeLabelGroupPayload = {
  __typename?: 'DeleteTimeLabelGroupPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteTimeLabelGroupError>>;
};

export type DeleteTimeLabelInput = {
  id: Scalars['ID']['input'];
  version: Scalars['Long']['input'];
};

export type DeleteTimeLabelPayload = {
  __typename?: 'DeleteTimeLabelPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteTimeLabelError>>;
};

export type DeleteWorkingTimeModelError = DomainError | PropertyValidationError;

export type DeleteWorkingTimeModelInput = {
  id: Scalars['ID']['input'];
};

export type DeleteWorkingTimeModelPayload = {
  __typename?: 'DeleteWorkingTimeModelPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<DeleteWorkingTimeModelError>>;
};

export type Department = Node & {
  __typename?: 'Department';
  companyId: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  leader?: Maybe<Contact>;
  leaderId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  version: Scalars['Long']['output'];
};

export type DepartmentInformation = ContactAdditionalInformation & {
  __typename?: 'DepartmentInformation';
  departmentName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type DepartmentQueryInput = {
  companyId: Scalars['ID']['input'];
  filterByName?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderType>;
};

export type DetailProjectPosition = {
  __typename?: 'DetailProjectPosition';
  clientId?: Maybe<Scalars['ID']['output']>;
  contractorId?: Maybe<Scalars['ID']['output']>;
  projectId: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
  projectPositionId: Scalars['ID']['output'];
  saleableServiceName: Scalars['String']['output'];
};

export type DiscountProfile = Node & {
  __typename?: 'DiscountProfile';
  entries: Array<DiscountProfileEntry>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  maxDueDate: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  version: Scalars['Long']['output'];
};

export type DiscountProfileEntry = {
  __typename?: 'DiscountProfileEntry';
  discount: Scalars['Decimal']['output'];
  dueDate: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export type DiscountProfileEntryInput = {
  discount: Scalars['Decimal']['input'];
  dueDate: Scalars['Int']['input'];
};

export type DiscountProfileQueryInput = {
  filterByName?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderType>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DocumentRole {
  Purchase = 'PURCHASE',
  Sales = 'SALES'
}

export enum DocumentStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Converted = 'CONVERTED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Finalized = 'FINALIZED',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

export type DocumentStatusEntry = {
  __typename?: 'DocumentStatusEntry';
  id: Scalars['UUID']['output'];
  status: DocumentStatus;
};

export enum DocumentType {
  CorrectedCreditNote = 'CORRECTED_CREDIT_NOTE',
  CorrectedInvoice = 'CORRECTED_INVOICE',
  CreditNote = 'CREDIT_NOTE',
  Invoice = 'INVOICE',
  Offer = 'OFFER'
}

export type DomainError = Error & {
  __typename?: 'DomainError';
  errorType: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type DunningCase = {
  __typename?: 'DunningCase';
  accruedFees: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  entries: Array<DunningEntry>;
  id: Scalars['ID']['output'];
  invoiceId: Scalars['ID']['output'];
};

export type DunningEntry = {
  __typename?: 'DunningEntry';
  createdDate: Scalars['LocalDate']['output'];
  dueDate: Scalars['LocalDate']['output'];
  fee: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  sentDate?: Maybe<Scalars['LocalDate']['output']>;
  sentEmailId?: Maybe<Scalars['UUID']['output']>;
  status: DunningStatus;
};

export type DunningLevel = Node & {
  __typename?: 'DunningLevel';
  contractorId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  feeAmount: Scalars['Decimal']['output'];
  feeCurrency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  level: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  paymentDays: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Long']['output'];
};

export type DunningLevelQueryFilterInput = {
  filterByName?: InputMaybe<Scalars['String']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DunningStatus {
  Closed = 'CLOSED',
  Expired = 'EXPIRED',
  Open = 'OPEN',
  Sending = 'SENDING',
  Sent = 'SENT'
}

export type EditablePaymentCondition = {
  __typename?: 'EditablePaymentCondition';
  companyId: Scalars['ID']['output'];
  displayName: Scalars['String']['output'];
  entries: Array<DiscountProfileEntry>;
  paymentInformationId: Scalars['ID']['output'];
  selectedEntry?: Maybe<Scalars['ID']['output']>;
};

export type EligibleTimesheetForBillingType = {
  __typename?: 'EligibleTimesheetForBillingType';
  employee: Contact;
  employeeId: Scalars['ID']['output'];
  from: Scalars['LocalDate']['output'];
  hasClientInvoice: Scalars['Boolean']['output'];
  hasContractorCreditNote: Scalars['Boolean']['output'];
  hasSupplierCreditNote: Scalars['Boolean']['output'];
  number: Scalars['String']['output'];
  requiresContractorCreditNote: Scalars['Boolean']['output'];
  requiresCreditNote: Scalars['Boolean']['output'];
  timesheetId: Scalars['ID']['output'];
  to: Scalars['LocalDate']['output'];
  totalHours: Scalars['Decimal']['output'];
};

export type Email = Node & {
  __typename?: 'Email';
  attachments?: Maybe<Array<EmailAttachment>>;
  bccRecipients?: Maybe<Array<Scalars['String']['output']>>;
  body: Scalars['String']['output'];
  ccRecipients?: Maybe<Array<Scalars['String']['output']>>;
  contactId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  recipients: Array<Scalars['String']['output']>;
  status: EmailStatus;
  subject: Scalars['String']['output'];
  type: EmailType;
};

export type EmailAttachment = {
  __typename?: 'EmailAttachment';
  content: Scalars['String']['output'];
  extension: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  positionNumber: Scalars['Int']['output'];
};

export type EmailAttachmentInput = {
  content: Scalars['String']['input'];
  extension: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  positionNumber: Scalars['Int']['input'];
};

export type EmailInformation = ContactAdditionalInformation & {
  __typename?: 'EmailInformation';
  emailAddress: Scalars['String']['output'];
  emailType: EmailType;
  id: Scalars['ID']['output'];
};

export enum EmailStatus {
  Failed = 'FAILED',
  InPreparation = 'IN_PREPARATION',
  Sending = 'SENDING',
  Sent = 'SENT',
  ToBeSent = 'TO_BE_SENT'
}

export enum EmailType {
  CreditNote = 'CREDIT_NOTE',
  Invoice = 'INVOICE',
  Offer = 'OFFER',
  Other = 'OTHER',
  Private = 'PRIVATE',
  Reminder = 'REMINDER',
  TimeSheet = 'TIME_SHEET',
  Work = 'WORK'
}

/** A connection to a list of items. */
export type EmailsByTypeAndStatusConnection = {
  __typename?: 'EmailsByTypeAndStatusConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EmailsByTypeAndStatusEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Email>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EmailsByTypeAndStatusEdge = {
  __typename?: 'EmailsByTypeAndStatusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Email;
};

/** A connection to a list of items. */
export type EmailsByTypeConnection = {
  __typename?: 'EmailsByTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EmailsByTypeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Email>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EmailsByTypeEdge = {
  __typename?: 'EmailsByTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Email;
};

export type EmailsQueryTypeInput = {
  contactId: Scalars['ID']['input'];
  order?: InputMaybe<OrderType>;
  type: EmailType;
};

export type EmailsQueryTypeStatusInput = {
  contactId: Scalars['ID']['input'];
  order?: InputMaybe<OrderType>;
  status: EmailStatus;
  type: EmailType;
};

export type EmployeeWorkingConditionInformation = ContactAdditionalInformation & {
  __typename?: 'EmployeeWorkingConditionInformation';
  federalLocation: Scalars['String']['output'];
  from: Scalars['LocalDate']['output'];
  id: Scalars['ID']['output'];
  to: Scalars['LocalDate']['output'];
  workingTimeModel?: Maybe<WorkingTimeModel>;
  workingTimeModelId: Scalars['ID']['output'];
};

export type EntityNotFoundError = Error & {
  __typename?: 'EntityNotFoundError';
  entityId: Array<Scalars['UUID']['output']>;
  entityName: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Entry = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentFolderId?: Maybe<Scalars['ID']['output']>;
  path: Scalars['String']['output'];
};

export enum EntryType {
  File = 'FILE',
  Folder = 'FOLDER'
}

export type Error = {
  message: Scalars['String']['output'];
};

export type FederalState = {
  __typename?: 'FederalState';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FileEntry = Entry & Node & {
  __typename?: 'FileEntry';
  fileSize: Scalars['Long']['output'];
  fileType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentFolderId?: Maybe<Scalars['ID']['output']>;
  path: Scalars['String']['output'];
  uploadedAt: Scalars['DateTime']['output'];
  version: Scalars['Long']['output'];
};

export type FinalizeDocumentError = DomainError | PropertyValidationError;

export type FinalizeDocumentInput = {
  documentId: Scalars['String']['input'];
  issueDate: Scalars['LocalDate']['input'];
};

export type FinalizeDocumentPayload = {
  __typename?: 'FinalizeDocumentPayload';
  commercialDocument?: Maybe<CommercialDocument>;
  errors?: Maybe<Array<FinalizeDocumentError>>;
};

export type FinalizeOfferError = DomainError | PropertyValidationError;

export type FinalizeOfferInput = {
  issueDate: Scalars['LocalDate']['input'];
};

export type FinalizeOfferPayload = {
  __typename?: 'FinalizeOfferPayload';
  errors?: Maybe<Array<FinalizeOfferError>>;
  offer?: Maybe<Offer>;
};

export type FlatTemplate = {
  __typename?: 'FlatTemplate';
  contactId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rendering: TemplateRendering;
  type: TemplateType;
};

export type FolderEntry = Entry & Node & {
  __typename?: 'FolderEntry';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isBucket: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentFolderId?: Maybe<Scalars['ID']['output']>;
  path: Scalars['String']['output'];
  version: Scalars['Long']['output'];
};

export type FolderEntryIdFilterInput = {
  and?: InputMaybe<Array<FolderEntryIdFilterInput>>;
  or?: InputMaybe<Array<FolderEntryIdFilterInput>>;
  value?: InputMaybe<UuidOperationFilterInput>;
};

export type GenerateReminderError = DomainError | PropertyValidationError;

export type GenerateReminderInput = {
  documentId: Scalars['String']['input'];
};

export type GenerateReminderPayload = {
  __typename?: 'GenerateReminderPayload';
  dunningCase?: Maybe<DunningCase>;
  errors?: Maybe<Array<GenerateReminderError>>;
};

export type GenericAddress = {
  __typename?: 'GenericAddress';
  line1: Scalars['String']['output'];
  line2: Scalars['String']['output'];
  line3: Scalars['String']['output'];
  line4: Scalars['String']['output'];
  line5: Scalars['String']['output'];
};

export type GetAllMemberContactIdsOfSuppliersResult = {
  __typename?: 'GetAllMemberContactIdsOfSuppliersResult';
  contactIds: Array<Scalars['ID']['output']>;
};

export type GetAllProjectPositionOfEmployeeInput = {
  employeeId: Scalars['ID']['input'];
  endDate: Scalars['LocalDate']['input'];
  startDate: Scalars['LocalDate']['input'];
};

export type GetAllTeamMembersOfContactResult = {
  __typename?: 'GetAllTeamMembersOfContactResult';
  contactIds: Array<Scalars['ID']['output']>;
};

export type GetMyAllProjectPositionInput = {
  endDate: Scalars['LocalDate']['input'];
  startDate: Scalars['LocalDate']['input'];
};

export type GetSuppliersOfContactResult = {
  __typename?: 'GetSuppliersOfContactResult';
  supplierIds: Array<Scalars['ID']['output']>;
};

export type GetTemplateVariablesInput = {
  rendering: TemplateRendering;
  type: TemplateType;
};

export type IEntryFilterInput = {
  and?: InputMaybe<Array<IEntryFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IEntryFilterInput>>;
  parentFolderId?: InputMaybe<FolderEntryIdFilterInput>;
  path?: InputMaybe<StringOperationFilterInput>;
};

export type IEntrySortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parentFolderId?: InputMaybe<SortEnumType>;
  path?: InputMaybe<SortEnumType>;
};

export type InitiateUploadInput = {
  contentType: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  path: Scalars['String']['input'];
  size: Scalars['Long']['input'];
};

export type InitiateUploadPayload = {
  __typename?: 'InitiateUploadPayload';
  uploadSession?: Maybe<UploadSession>;
};

export type InvalidEntityIdError = Error & {
  __typename?: 'InvalidEntityIdError';
  errorType: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type InvalidUserPrivilegesError = Error & {
  __typename?: 'InvalidUserPrivilegesError';
  errorType: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Invoice = CommercialDocument & Node & {
  __typename?: 'Invoice';
  billTo: GenericAddress;
  cancelVoid: Invoice;
  cancelWithReversal: CorrectedInvoice;
  cancellation?: Maybe<CancellationInfo>;
  clientContactPersonId?: Maybe<Scalars['ID']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clientVatId?: Maybe<Scalars['String']['output']>;
  concludingText?: Maybe<Scalars['String']['output']>;
  contractorId?: Maybe<Scalars['ID']['output']>;
  contractorVatId?: Maybe<Scalars['String']['output']>;
  createdById: Scalars['ID']['output'];
  createdDate: Scalars['LocalDate']['output'];
  documentRole: DocumentRole;
  documentType: DocumentType;
  dueDate?: Maybe<Scalars['LocalDate']['output']>;
  employeeIds: Array<Scalars['ID']['output']>;
  grossTotal: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  introductoryText: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isInvalid: Scalars['Boolean']['output'];
  isProforma: Scalars['Boolean']['output'];
  isReversal: Scalars['Boolean']['output'];
  issueDate?: Maybe<Scalars['LocalDate']['output']>;
  items: Array<LineItem>;
  netTotal: Scalars['Decimal']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  openTotal: Scalars['Decimal']['output'];
  paidTotal: Scalars['Decimal']['output'];
  paymentDeadlineInDays: Scalars['Int']['output'];
  payments?: Maybe<Array<PaymentItem>>;
  projectId?: Maybe<Scalars['ID']['output']>;
  sentDate?: Maybe<Scalars['DateTime']['output']>;
  sentEmailId?: Maybe<Scalars['UUID']['output']>;
  shipTo?: Maybe<GenericAddress>;
  status: DocumentStatus;
  taxDetails: Array<TaxDetail>;
  taxTotal: Scalars['Decimal']['output'];
  timeSheetApprovalIds: Array<Scalars['ID']['output']>;
  timestamp: Scalars['DateTime']['output'];
};


export type InvoiceCancelVoidArgs = {
  reason: Scalars['String']['input'];
};


export type InvoiceCancelWithReversalArgs = {
  createdBy: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export enum InvoiceDocumentStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Finalized = 'FINALIZED',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Sent = 'SENT'
}

export type InvoiceReference = {
  __typename?: 'InvoiceReference';
  createdAt: Scalars['DateTime']['output'];
  invoiceId: Scalars['ID']['output'];
  status: InvoiceDocumentStatus;
};

export type InvoiceValidationError = {
  __typename?: 'InvoiceValidationError';
  btCode: Scalars['String']['output'];
  fieldPath: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type IsContactPersonOfInformation = ContactAdditionalInformation & {
  __typename?: 'IsContactPersonOfInformation';
  contactPersonId: Scalars['ID']['output'];
  contactUsage: Array<ContactUsage>;
  id: Scalars['ID']['output'];
};

export type KeyCloakError = Error & {
  __typename?: 'KeyCloakError';
  httpResponse: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type LeavesDepartmentError = DomainError | EntityNotFoundError | PropertyValidationError;

export type LeavesDepartmentInput = {
  contactId: Scalars['ID']['input'];
};

export type LeavesDepartmentPayload = {
  __typename?: 'LeavesDepartmentPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<LeavesDepartmentError>>;
};

export type LineItem = {
  __typename?: 'LineItem';
  description: Scalars['String']['output'];
  discountPercent?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['UUID']['output'];
  lineGrossTotal: Scalars['Decimal']['output'];
  lineNetTotal: Scalars['Decimal']['output'];
  lineTaxTotal: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  positionNo: Scalars['Int']['output'];
  quantity: Scalars['Decimal']['output'];
  tax: Scalars['Decimal']['output'];
  taxCode: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  unitPriceNet: Scalars['Decimal']['output'];
};

/** A connection to a list of items. */
export type ListFolderEntriesConnection = {
  __typename?: 'ListFolderEntriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ListFolderEntriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Entry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ListFolderEntriesEdge = {
  __typename?: 'ListFolderEntriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Entry;
};

export type MarkOfferSentError = DomainError | PropertyValidationError;

export type MarkOfferSentInput = {
  id: Scalars['ID']['input'];
  sentDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type MarkOfferSentPayload = {
  __typename?: 'MarkOfferSentPayload';
  errors?: Maybe<Array<MarkOfferSentError>>;
  offer?: Maybe<Offer>;
};

export type MigrateBillingAddressesPayload = {
  __typename?: 'MigrateBillingAddressesPayload';
  migrateBillingAddressesResult?: Maybe<MigrateBillingAddressesResult>;
};

export type MigrateBillingAddressesResult = {
  __typename?: 'MigrateBillingAddressesResult';
  migratedContacts: Array<Scalars['String']['output']>;
  migratedCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
};

export type ModifyInvoiceInput = {
  clientContactPersonId?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  concludingText?: InputMaybe<Scalars['String']['input']>;
  contractorId?: InputMaybe<Scalars['ID']['input']>;
  dueDate?: InputMaybe<Scalars['LocalDate']['input']>;
  introductoryText?: InputMaybe<Scalars['String']['input']>;
  isProforma?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<ModifyInvoiceItemInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentDeadlineInDays?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type ModifyInvoiceItemInput = {
  description: Scalars['String']['input'];
  discountPercent: Scalars['Decimal']['input'];
  name: Scalars['String']['input'];
  positionNo: Scalars['Int']['input'];
  quantity: Scalars['Decimal']['input'];
  tax: Scalars['Decimal']['input'];
  taxCode: Scalars['String']['input'];
  unit: Scalars['String']['input'];
  unitPriceNet: Scalars['Decimal']['input'];
};

export type MonthlyBillingEligibilityType = {
  __typename?: 'MonthlyBillingEligibilityType';
  eligibleSupplierIds: Array<Scalars['ID']['output']>;
  eligibleTimesheetIds: Array<Scalars['ID']['output']>;
  ineligibilityReason?: Maybe<Scalars['String']['output']>;
  isEligible: Scalars['Boolean']['output'];
};

export type MonthlyOverviewRootsResultType = {
  __typename?: 'MonthlyOverviewRootsResultType';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<MonthlyProjectOverviewItem>;
  totalCount: Scalars['Int']['output'];
};

export type MonthlyOverviewSearchResultType = {
  __typename?: 'MonthlyOverviewSearchResultType';
  items: Array<MonthlyProjectOverviewItem>;
  matchedProjectIds: Array<Scalars['ID']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type MonthlyProjectOverviewItem = {
  __typename?: 'MonthlyProjectOverviewItem';
  approvedMinutes: Scalars['Long']['output'];
  budgetStatus?: Maybe<BudgetStatus>;
  canCreateCreditNote: Scalars['Boolean']['output'];
  canCreateInvoice: Scalars['Boolean']['output'];
  canCreateMonthlyBilling: Scalars['Boolean']['output'];
  client?: Maybe<Contact>;
  clientId?: Maybe<Scalars['ID']['output']>;
  clientInvoices: Array<InvoiceReference>;
  employee?: Maybe<Contact>;
  employeeId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['String']['output'];
  isGroup: Scalars['Boolean']['output'];
  isInternalProjectsGroup: Scalars['Boolean']['output'];
  itemType: OverviewItemType;
  openMinutes: Scalars['Long']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  path: Array<Scalars['String']['output']>;
  pendingMinutes: Scalars['Long']['output'];
  project?: Maybe<ProjectSummary>;
  projectId?: Maybe<Scalars['ID']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  projectNumber?: Maybe<Scalars['String']['output']>;
  projectStatus?: Maybe<ProjectStatus>;
  projectType?: Maybe<ProjectType>;
  supplierCreditNotes: Array<CreditNoteReference>;
  timesheetFrom?: Maybe<Scalars['LocalDate']['output']>;
  timesheetId?: Maybe<Scalars['ID']['output']>;
  timesheetNumber?: Maybe<Scalars['String']['output']>;
  timesheetStatus?: Maybe<ApprovalTimeEntryStatus>;
  timesheetTo?: Maybe<Scalars['LocalDate']['output']>;
  totalMinutes: Scalars['Long']['output'];
};

export type MoveInput = {
  entityId: Scalars['String']['input'];
  fromPath: Scalars['String']['input'];
  toPath: Scalars['String']['input'];
};

export type MovePayload = {
  __typename?: 'MovePayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptOffer: AcceptOfferPayload;
  acceptTimeApproval: AcceptTimeApprovalPayload;
  addApprovalToAllTimeEntries: AddApprovalToAllTimeEntriesPayload;
  addApprovalToTimeEntry: AddApprovalToTimeEntryPayload;
  addEmployeesToLabelGroup: AddEmployeesToLabelGroupPayload;
  addEmployeesToTimeLabel: AddEmployeesToTimeLabelPayload;
  addLabelGroupsToDepartment: AddLabelGroupsToDepartmentPayload;
  addLabelsToDepartment: AddLabelsToDepartmentPayload;
  addLabelsToLabelGroup: AddLabelsToLabelGroupPayload;
  addLogToAbsence: AddLogToAbsencePayload;
  addLogToProjectTimeEntry: AddLogToProjectTimeEntryPayload;
  addLogToTimeEntry: AddLogToTimeEntryPayload;
  addMember: AddMemberPayload;
  addServicesToProject: AddServicesToProjectPayload;
  approveVacation: ApproveVacationPayload;
  cancelDocument: CancelDocumentPayload;
  clearAllTemplates: ClearAllTemplatesPayload;
  completeUpload: CompleteUploadPayload;
  convertOfferToInvoice: ConvertOfferToInvoicePayload;
  createAbsence: CreateAbsencePayload;
  createAbsenceReason: CreateAbsenceReasonPayload;
  createAccountingProfile: CreateAccountingProfilePayload;
  createBillingInformation: CreateBillingInformationPayload;
  createBucket: CreateBucketPayload;
  createCalendarEvent: CreateCalendarEventPayload;
  createCompanyContact: CreateCompanyContactPayload;
  createContactAddress: CreateContactAddressPayload;
  createContactEmail: CreateContactEmailPayload;
  createContactPersonInformation: CreateContactPersonInformationPayload;
  createContractedInformation: CreateContractedInformationPayload;
  createDateInformation: CreateDateInformationPayload;
  createDepartment: CreateDepartmentPayload;
  createDepartmentInformation: CreateDepartmentInformationPayload;
  createDiscountProfile: CreateDiscountProfilePayload;
  createDocumentDraft: CreateDocumentDraftPayload;
  createDownloadUrl: CreateDownloadUrlPayload;
  createDunningLevel: CreateDunningLevelPayload;
  createEmail: CreateEmailPayload;
  createEmployeeWorkingCondition: CreateEmployeeWorkingConditionPayload;
  createFileEntry: CreateFileEntryPayload;
  createFolder: CreateFolderPayload;
  createFolderEntry: CreateFolderEntryPayload;
  createMailboxContact: CreateMailboxContactPayload;
  createNextRollingNumber: CreateNextRollingNumberPayload;
  createOfferFromProject: CreateOfferFromProjectPayload;
  createPaymentConditionInformation: CreatePaymentConditionInformationPayload;
  createPaymentInformation: CreatePaymentInformationPayload;
  createPersonContact: CreatePersonContactPayload;
  createPhoneInformation: CreatePhoneInformationPayload;
  createProject: CreateProjectPayload;
  createProjectAdditionalAccountingInformation: CreateProjectAdditionalAccountingInformationPayload;
  createProjectAdditionalContactInformation: CreateProjectAdditionalContactInformationPayload;
  createProjectAdditionalContactPersonInformation: CreateProjectAdditionalContactPersonInformationPayload;
  createProjectAdditionalPositionInformation: CreateProjectAdditionalPositionInformationPayload;
  createProjectAdditionalTeamMemberInformation: CreateProjectAdditionalTeamMemberInformationPayload;
  createProjectAdditionalTemplateInformation: CreateProjectAdditionalTemplateInformationPayload;
  createProjectSaleableService: CreateProjectSaleableServicePayload;
  createProjectSaleableServiceGroup: CreateProjectSaleableServiceGroupPayload;
  createProjectSaleableUnit: CreateProjectSaleableUnitPayload;
  createSalaryInformation: CreateSalaryInformationPayload;
  createSaleableService: CreateSaleableServicePayload;
  createSaleableServiceGroup: CreateSaleableServiceGroupPayload;
  createSaleableUnit: CreateSaleableUnitPayload;
  createTemplate: CreateTemplatePayload;
  createTemporaryFreelancer: CreateTemporaryFreelancerPayload;
  createTimeBalanceEntry: CreateTimeBalanceEntryPayload;
  createTimeLabel: CreateTimeLabelPayload;
  createTimeLabelGroup: CreateTimeLabelGroupPayload;
  createWebsiteInformation: CreateWebsiteInformationPayload;
  createWorkingConditionInformation: CreateWorkingConditionInformationPayload;
  createWorkingTimeModel: CreateWorkingTimeModelPayload;
  deleteAbsence: DeleteAbsencePayload;
  deleteAbsenceReason: DeleteAbsenceReasonPayload;
  deleteAccountingProfile: DeleteAccountingProfilePayload;
  deleteAdditionalInformation: DeleteAdditionalInformationPayload;
  deleteBucket: DeleteBucketPayload;
  deleteCalendarEvent: DeleteCalendarEventPayload;
  deleteContactAddress: DeleteContactAddressPayload;
  deleteCorrectedCreditNotePayment: DeleteCorrectedCreditNotePaymentPayload;
  deleteCorrectedInvoicePayment: DeleteCorrectedInvoicePaymentPayload;
  deleteCreditNotePayment: DeleteCreditNotePaymentPayload;
  deleteDepartment: DeleteDepartmentPayload;
  deleteDiscountProfile: DeleteDiscountProfilePayload;
  deleteDocumentDraft: DeleteDocumentDraftPayload;
  deleteDunningLevel: DeleteDunningLevelPayload;
  deleteFileEntry: DeleteFileEntryPayload;
  deleteFolderEntry: DeleteFolderEntryPayload;
  deleteInvoicePayment: DeleteInvoicePaymentPayload;
  deleteMember: DeleteMemberPayload;
  deleteOfferDraft: DeleteOfferDraftPayload;
  deletePath: DeletePathPayload;
  deleteProject: DeleteProjectPayload;
  deleteProjectAdditionalInformation: DeleteProjectAdditionalInformationPayload;
  deleteProjectSaleableService: DeleteProjectSaleableServicePayload;
  deleteProjectSaleableServiceGroup: DeleteProjectSaleableServiceGroupPayload;
  deleteProjectSaleableUnit: DeleteProjectSaleableUnitPayload;
  deleteSaleableService: DeleteSaleableServicePayload;
  deleteSaleableServiceGroup: DeleteSaleableServiceGroupPayload;
  deleteSaleableUnit: DeleteSaleableUnitPayload;
  deleteSubstitute: DeleteSubstitutePayload;
  deleteTemplate: DeleteTemplatePayload;
  deleteTimeApproval: DeleteTimeApprovalPayload;
  deleteTimeBalanceEntry: DeleteTimeBalanceEntryPayload;
  deleteTimeLabel: DeleteTimeLabelPayload;
  deleteTimeLabelGroup: DeleteTimeLabelGroupPayload;
  deleteWorkingTimeModel: DeleteWorkingTimeModelPayload;
  finalizeDocument: FinalizeDocumentPayload;
  finalizeOffer: FinalizeOfferPayload;
  generateReminder: GenerateReminderPayload;
  initiateUpload: InitiateUploadPayload;
  leavesDepartment: LeavesDepartmentPayload;
  markOfferSent: MarkOfferSentPayload;
  migrateBillingAddresses: MigrateBillingAddressesPayload;
  move: MovePayload;
  myCancelVacation: MyCancelVacationPayload;
  myCreateTimeApproval: MyCreateTimeApprovalPayload;
  myCreateVacation: MyCreateVacationPayload;
  myDeleteTimer: MyDeleteTimerPayload;
  myStartTimer: MyStartTimerPayload;
  myStopTimer: MyStopTimerPayload;
  myUpdateVacation: MyUpdateVacationPayload;
  presignPart: PresignPartPayload;
  recalculateAllProjectBudgets: RecalculateAllProjectBudgetsPayload;
  recordCorrectedCreditNotePayment: RecordCorrectedCreditNotePaymentPayload;
  recordCorrectedInvoicePayment: RecordCorrectedInvoicePaymentPayload;
  recordCreditNotePayment: RecordCreditNotePaymentPayload;
  recordInvoicePayment: RecordInvoicePaymentPayload;
  refreshMonthlyInvoiceStatuses: RefreshMonthlyInvoiceStatusesPayload;
  rejectOffer: RejectOfferPayload;
  rejectTimeApproval: RejectTimeApprovalPayload;
  removeEmployeesFromLabelGroup: RemoveEmployeesFromLabelGroupPayload;
  removeEmployeesFromTimeLabel: RemoveEmployeesFromTimeLabelPayload;
  removeLabelGroupsFromDepartment: RemoveLabelGroupsFromDepartmentPayload;
  removeLabelsFromDepartment: RemoveLabelsFromDepartmentPayload;
  removeLabelsFromLabelGroup: RemoveLabelsFromLabelGroupPayload;
  removeServicesFromProject: RemoveServicesFromProjectPayload;
  requestMonthlyBilling: RequestMonthlyBillingPayload;
  resendVerificationEmail: ResendVerificationEmailPayload;
  resendVerificationEmailToAllUnverified: ResendVerificationEmailToAllUnverifiedPayload;
  resetProjectStatusToAutomatic: ResetProjectStatusToAutomaticPayload;
  seedTimeBalanceEntry: SeedTimeBalanceEntryPayload;
  seedVacation: SeedVacationPayload;
  sendDocumentEmail: SendDocumentEmailPayload;
  sendTimeSheetApprovalEmail: SendTimeSheetApprovalEmailPayload;
  setEmailForSending: SetEmailForSendingPayload;
  updateAbsence: UpdateAbsencePayload;
  updateAbsenceReason: UpdateAbsenceReasonPayload;
  updateAccountingProfile: UpdateAccountingProfilePayload;
  updateBccRecipientList: UpdateBccRecipientListPayload;
  updateBillingInformation: UpdateBillingInformationPayload;
  updateCalendarEvent: UpdateCalendarEventPayload;
  updateCompanyContact: UpdateCompanyContactPayload;
  updateContactAddress: UpdateContactAddressPayload;
  updateContactDelete: UpdateContactDeletePayload;
  updateContactEmail: UpdateContactEmailPayload;
  updateContactPersonInformation: UpdateContactPersonInformationPayload;
  updateContractedInformation: UpdateContractedInformationPayload;
  updateDateInformation: UpdateDateInformationPayload;
  updateDayProjectTimeEntry: UpdateDayProjectTimeEntryPayload;
  updateDayTimeEntry: UpdateDayTimeEntryPayload;
  updateDepartment: UpdateDepartmentPayload;
  updateDepartmentInformation: UpdateDepartmentInformationPayload;
  updateDiscountProfile: UpdateDiscountProfilePayload;
  updateDocumentDraft: UpdateDocumentDraftPayload;
  updateDunningLevel: UpdateDunningLevelPayload;
  updateEmail: UpdateEmailPayload;
  updateEmployeeWorkingCondition: UpdateEmployeeWorkingConditionPayload;
  updateFileEntry: UpdateFileEntryPayload;
  updateMailboxContact: UpdateMailboxContactPayload;
  updateMetadata: UpdateMetadataPayload;
  updateMyDayProjectTimeEntry: UpdateMyDayProjectTimeEntryPayload;
  updateMyDayTimeEntry: UpdateMyDayTimeEntryPayload;
  updateMyPaymentCondition: UpdateMyPaymentConditionPayload;
  updatePaymentConditionInformation: UpdatePaymentConditionInformationPayload;
  updatePaymentInformation: UpdatePaymentInformationPayload;
  updatePersonContact: UpdatePersonContactPayload;
  updatePhoneInformation: UpdatePhoneInformationPayload;
  updateProject: UpdateProjectPayload;
  updateProjectActiveStatus: UpdateProjectActiveStatusPayload;
  updateProjectAdditionalAccountingInformation: UpdateProjectAdditionalAccountingInformationPayload;
  updateProjectAdditionalContactInformation: UpdateProjectAdditionalContactInformationPayload;
  updateProjectAdditionalContactPersonInformation: UpdateProjectAdditionalContactPersonInformationPayload;
  updateProjectAdditionalPositionInformation: UpdateProjectAdditionalPositionInformationPayload;
  updateProjectAdditionalTeamMemberInformation: UpdateProjectAdditionalTeamMemberInformationPayload;
  updateProjectAdditionalTemplateInformation: UpdateProjectAdditionalTemplateInformationPayload;
  updateProjectSaleableService: UpdateProjectSaleableServicePayload;
  updateProjectSaleableServiceGroup: UpdateProjectSaleableServiceGroupPayload;
  updateProjectSaleableUnit: UpdateProjectSaleableUnitPayload;
  updateProjectStatus: UpdateProjectStatusPayload;
  updateRollingNumber: UpdateRollingNumberPayload;
  updateSalaryInformation: UpdateSalaryInformationPayload;
  updateSaleableService: UpdateSaleableServicePayload;
  updateSaleableServiceGroup: UpdateSaleableServiceGroupPayload;
  updateSaleableUnit: UpdateSaleableUnitPayload;
  updateTemplate: UpdateTemplatePayload;
  updateTimeBalanceEntry: UpdateTimeBalanceEntryPayload;
  updateTimeLabel: UpdateTimeLabelPayload;
  updateTimeLabelGroup: UpdateTimeLabelGroupPayload;
  updateWebsiteInformation: UpdateWebsiteInformationPayload;
  updateWorkingConditionInformation: UpdateWorkingConditionInformationPayload;
  updateWorkingTimeModel: UpdateWorkingTimeModelPayload;
  uploadSmall: UploadSmallPayload;
  upsertSubstitute: UpsertSubstitutePayload;
  userAddLogin: UserAddLoginPayload;
  userChangeGroups: UserChangeGroupsPayload;
  userRemoveLogin: UserRemoveLoginPayload;
  userSetEnabled: UserSetEnabledPayload;
  validateAllProjects: ValidateAllProjectsPayload;
  worksInDepartment: WorksInDepartmentPayload;
};


export type MutationAcceptOfferArgs = {
  input: AcceptOfferInput;
};


export type MutationAcceptTimeApprovalArgs = {
  input: AcceptTimeApprovalInput;
};


export type MutationAddApprovalToAllTimeEntriesArgs = {
  input: AddApprovalToAllTimeEntriesInput;
};


export type MutationAddApprovalToTimeEntryArgs = {
  input: AddApprovalToTimeEntryInput;
};


export type MutationAddEmployeesToLabelGroupArgs = {
  input: AddEmployeesToLabelGroupInput;
};


export type MutationAddEmployeesToTimeLabelArgs = {
  input: AddEmployeesToTimeLabelInput;
};


export type MutationAddLabelGroupsToDepartmentArgs = {
  input: AddLabelGroupsToDepartmentInput;
};


export type MutationAddLabelsToDepartmentArgs = {
  input: AddLabelsToDepartmentInput;
};


export type MutationAddLabelsToLabelGroupArgs = {
  input: AddLabelsToLabelGroupInput;
};


export type MutationAddLogToAbsenceArgs = {
  input: AddLogToAbsenceInput;
};


export type MutationAddLogToProjectTimeEntryArgs = {
  input: AddLogToProjectTimeEntryInput;
};


export type MutationAddLogToTimeEntryArgs = {
  input: AddLogToTimeEntryInput;
};


export type MutationAddMemberArgs = {
  input: AddMemberInput;
};


export type MutationAddServicesToProjectArgs = {
  input: AddServicesToProjectInput;
};


export type MutationApproveVacationArgs = {
  input: ApproveVacationInput;
};


export type MutationCancelDocumentArgs = {
  input: CancelDocumentInput;
};


export type MutationCompleteUploadArgs = {
  input: CompleteUploadInput;
};


export type MutationConvertOfferToInvoiceArgs = {
  input: ConvertOfferToInvoiceInput;
};


export type MutationCreateAbsenceArgs = {
  input: CreateAbsenceInput;
};


export type MutationCreateAbsenceReasonArgs = {
  input: CreateAbsenceReasonInput;
};


export type MutationCreateAccountingProfileArgs = {
  input: CreateAccountingProfileInput;
};


export type MutationCreateBillingInformationArgs = {
  input: CreateBillingInformationInput;
};


export type MutationCreateBucketArgs = {
  input: CreateBucketInput;
};


export type MutationCreateCalendarEventArgs = {
  input: CreateCalendarEventInput;
};


export type MutationCreateCompanyContactArgs = {
  input: CreateCompanyContactInput;
};


export type MutationCreateContactAddressArgs = {
  input: CreateContactAddressInput;
};


export type MutationCreateContactEmailArgs = {
  input: CreateContactEmailInput;
};


export type MutationCreateContactPersonInformationArgs = {
  input: CreateContactPersonInformationInput;
};


export type MutationCreateContractedInformationArgs = {
  input: CreateContractedInformationInput;
};


export type MutationCreateDateInformationArgs = {
  input: CreateDateInformationInput;
};


export type MutationCreateDepartmentArgs = {
  input: CreateDepartmentInput;
};


export type MutationCreateDepartmentInformationArgs = {
  input: CreateDepartmentInformationInput;
};


export type MutationCreateDiscountProfileArgs = {
  input: CreateDiscountProfileInput;
};


export type MutationCreateDocumentDraftArgs = {
  input: CreateDocumentDraftInput;
};


export type MutationCreateDownloadUrlArgs = {
  input: CreateDownloadUrlInput;
};


export type MutationCreateDunningLevelArgs = {
  input: CreateDunningLevelInput;
};


export type MutationCreateEmailArgs = {
  input: CreateEmailInput;
};


export type MutationCreateEmployeeWorkingConditionArgs = {
  input: CreateEmployeeWorkingConditionInput;
};


export type MutationCreateFileEntryArgs = {
  input: CreateFileEntryInput;
};


export type MutationCreateFolderArgs = {
  input: CreateFolderInput;
};


export type MutationCreateFolderEntryArgs = {
  input: CreateFolderEntryInput;
};


export type MutationCreateMailboxContactArgs = {
  input: CreateMailboxContactInput;
};


export type MutationCreateNextRollingNumberArgs = {
  input: CreateNextRollingNumberInput;
};


export type MutationCreateOfferFromProjectArgs = {
  input: CreateOfferFromProjectInput;
};


export type MutationCreatePaymentConditionInformationArgs = {
  input: CreatePaymentConditionInformationInput;
};


export type MutationCreatePaymentInformationArgs = {
  input: CreatePaymentInformationInput;
};


export type MutationCreatePersonContactArgs = {
  input: CreatePersonContactInput;
};


export type MutationCreatePhoneInformationArgs = {
  input: CreatePhoneInformationInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreateProjectAdditionalAccountingInformationArgs = {
  input: CreateProjectAdditionalAccountingInformationInput;
};


export type MutationCreateProjectAdditionalContactInformationArgs = {
  input: CreateProjectAdditionalContactInformationInput;
};


export type MutationCreateProjectAdditionalContactPersonInformationArgs = {
  input: CreateProjectAdditionalContactPersonInformationInput;
};


export type MutationCreateProjectAdditionalPositionInformationArgs = {
  input: CreateProjectAdditionalPositionInformationInput;
};


export type MutationCreateProjectAdditionalTeamMemberInformationArgs = {
  input: CreateProjectAdditionalTeamMemberInformationInput;
};


export type MutationCreateProjectAdditionalTemplateInformationArgs = {
  input: CreateProjectAdditionalTemplateInformationInput;
};


export type MutationCreateProjectSaleableServiceArgs = {
  input: CreateProjectSaleableServiceInput;
};


export type MutationCreateProjectSaleableServiceGroupArgs = {
  input: CreateProjectSaleableServiceGroupInput;
};


export type MutationCreateProjectSaleableUnitArgs = {
  input: CreateProjectSaleableUnitInput;
};


export type MutationCreateSalaryInformationArgs = {
  input: CreateSalaryInformationInput;
};


export type MutationCreateSaleableServiceArgs = {
  input: CreateSaleableServiceInput;
};


export type MutationCreateSaleableServiceGroupArgs = {
  input: CreateSaleableServiceGroupInput;
};


export type MutationCreateSaleableUnitArgs = {
  input: CreateSaleableUnitInput;
};


export type MutationCreateTemplateArgs = {
  input: CreateTemplateInput;
};


export type MutationCreateTemporaryFreelancerArgs = {
  input: CreateTemporaryFreelancerInput;
};


export type MutationCreateTimeBalanceEntryArgs = {
  input: CreateTimeBalanceEntryInput;
};


export type MutationCreateTimeLabelArgs = {
  input: CreateTimeLabelInput;
};


export type MutationCreateTimeLabelGroupArgs = {
  input: CreateTimeLabelGroupInput;
};


export type MutationCreateWebsiteInformationArgs = {
  input: CreateWebsiteInformationInput;
};


export type MutationCreateWorkingConditionInformationArgs = {
  input: CreateWorkingConditionInformationInput;
};


export type MutationCreateWorkingTimeModelArgs = {
  input: CreateWorkingTimeModelInput;
};


export type MutationDeleteAbsenceArgs = {
  input: DeleteAbsenceInput;
};


export type MutationDeleteAbsenceReasonArgs = {
  input: DeleteAbsenceReasonInput;
};


export type MutationDeleteAccountingProfileArgs = {
  input: DeleteAccountingProfileInput;
};


export type MutationDeleteAdditionalInformationArgs = {
  input: DeleteAdditionalInformationInput;
};


export type MutationDeleteBucketArgs = {
  input: DeleteBucketInput;
};


export type MutationDeleteCalendarEventArgs = {
  input: DeleteCalendarEventInput;
};


export type MutationDeleteContactAddressArgs = {
  input: DeleteContactAddressInput;
};


export type MutationDeleteCorrectedCreditNotePaymentArgs = {
  input: DeleteCorrectedCreditNotePaymentInput;
};


export type MutationDeleteCorrectedInvoicePaymentArgs = {
  input: DeleteCorrectedInvoicePaymentInput;
};


export type MutationDeleteCreditNotePaymentArgs = {
  input: DeleteCreditNotePaymentInput;
};


export type MutationDeleteDepartmentArgs = {
  input: DeleteDepartmentInput;
};


export type MutationDeleteDiscountProfileArgs = {
  input: DeleteDiscountProfileInput;
};


export type MutationDeleteDocumentDraftArgs = {
  input: DeleteDocumentDraftInput;
};


export type MutationDeleteDunningLevelArgs = {
  input: DeleteDunningLevelInput;
};


export type MutationDeleteFileEntryArgs = {
  input: DeleteFileEntryInput;
};


export type MutationDeleteFolderEntryArgs = {
  input: DeleteFolderEntryInput;
};


export type MutationDeleteInvoicePaymentArgs = {
  input: DeleteInvoicePaymentInput;
};


export type MutationDeleteMemberArgs = {
  input: DeleteMemberInput;
};


export type MutationDeleteOfferDraftArgs = {
  input: DeleteOfferDraftInput;
};


export type MutationDeletePathArgs = {
  input: DeletePathInput;
};


export type MutationDeleteProjectArgs = {
  input: DeleteProjectInput;
};


export type MutationDeleteProjectAdditionalInformationArgs = {
  input: DeleteProjectAdditionalInformationInput;
};


export type MutationDeleteProjectSaleableServiceArgs = {
  input: DeleteProjectSaleableServiceInput;
};


export type MutationDeleteProjectSaleableServiceGroupArgs = {
  input: DeleteProjectSaleableServiceGroupInput;
};


export type MutationDeleteProjectSaleableUnitArgs = {
  input: DeleteProjectSaleableUnitInput;
};


export type MutationDeleteSaleableServiceArgs = {
  input: DeleteSaleableServiceInput;
};


export type MutationDeleteSaleableServiceGroupArgs = {
  input: DeleteSaleableServiceGroupInput;
};


export type MutationDeleteSaleableUnitArgs = {
  input: DeleteSaleableUnitInput;
};


export type MutationDeleteSubstituteArgs = {
  input: DeleteSubstituteInput;
};


export type MutationDeleteTemplateArgs = {
  input: DeleteTemplateInput;
};


export type MutationDeleteTimeApprovalArgs = {
  input: DeleteTimeApprovalInput;
};


export type MutationDeleteTimeBalanceEntryArgs = {
  input: DeleteTimeBalanceEntryInput;
};


export type MutationDeleteTimeLabelArgs = {
  input: DeleteTimeLabelInput;
};


export type MutationDeleteTimeLabelGroupArgs = {
  input: DeleteTimeLabelGroupInput;
};


export type MutationDeleteWorkingTimeModelArgs = {
  input: DeleteWorkingTimeModelInput;
};


export type MutationFinalizeDocumentArgs = {
  input: FinalizeDocumentInput;
};


export type MutationFinalizeOfferArgs = {
  id: Scalars['ID']['input'];
  input: FinalizeOfferInput;
};


export type MutationGenerateReminderArgs = {
  input: GenerateReminderInput;
};


export type MutationInitiateUploadArgs = {
  input: InitiateUploadInput;
};


export type MutationLeavesDepartmentArgs = {
  input: LeavesDepartmentInput;
};


export type MutationMarkOfferSentArgs = {
  input: MarkOfferSentInput;
};


export type MutationMoveArgs = {
  input: MoveInput;
};


export type MutationMyCancelVacationArgs = {
  input: MyCancelVacationInput;
};


export type MutationMyCreateTimeApprovalArgs = {
  input: MyCreateTimeApprovalInput;
};


export type MutationMyCreateVacationArgs = {
  input: MyCreateVacationInput;
};


export type MutationMyStartTimerArgs = {
  input: MyStartTimerInput;
};


export type MutationMyStopTimerArgs = {
  input: MyStopTimerInput;
};


export type MutationMyUpdateVacationArgs = {
  input: MyUpdateVacationInput;
};


export type MutationPresignPartArgs = {
  input: PresignPartInput;
};


export type MutationRecordCorrectedCreditNotePaymentArgs = {
  input: RecordCorrectedCreditNotePaymentInput;
};


export type MutationRecordCorrectedInvoicePaymentArgs = {
  input: RecordCorrectedInvoicePaymentInput;
};


export type MutationRecordCreditNotePaymentArgs = {
  input: RecordCreditNotePaymentInput;
};


export type MutationRecordInvoicePaymentArgs = {
  input: RecordInvoicePaymentInput;
};


export type MutationRefreshMonthlyInvoiceStatusesArgs = {
  input: RefreshMonthlyInvoiceStatusesInput;
};


export type MutationRejectOfferArgs = {
  input: RejectOfferInput;
};


export type MutationRejectTimeApprovalArgs = {
  input: RejectTimeApprovalInput;
};


export type MutationRemoveEmployeesFromLabelGroupArgs = {
  input: RemoveEmployeesFromLabelGroupInput;
};


export type MutationRemoveEmployeesFromTimeLabelArgs = {
  input: RemoveEmployeesFromTimeLabelInput;
};


export type MutationRemoveLabelGroupsFromDepartmentArgs = {
  input: RemoveLabelGroupsFromDepartmentInput;
};


export type MutationRemoveLabelsFromDepartmentArgs = {
  input: RemoveLabelsFromDepartmentInput;
};


export type MutationRemoveLabelsFromLabelGroupArgs = {
  input: RemoveLabelsFromLabelGroupInput;
};


export type MutationRemoveServicesFromProjectArgs = {
  input: RemoveServicesFromProjectInput;
};


export type MutationRequestMonthlyBillingArgs = {
  input: RequestMonthlyBillingInput;
};


export type MutationResendVerificationEmailArgs = {
  input: ResendVerificationEmailInput;
};


export type MutationResendVerificationEmailToAllUnverifiedArgs = {
  input: ResendVerificationEmailToAllUnverifiedInput;
};


export type MutationResetProjectStatusToAutomaticArgs = {
  input: ResetProjectStatusToAutomaticInput;
};


export type MutationSeedTimeBalanceEntryArgs = {
  input: SeedTimeBalanceEntryInput;
};


export type MutationSeedVacationArgs = {
  input: SeedVacationInput;
};


export type MutationSendDocumentEmailArgs = {
  input: SendDocumentEmailInput;
};


export type MutationSendTimeSheetApprovalEmailArgs = {
  input: SendTimeSheetApprovalEmailInput;
};


export type MutationSetEmailForSendingArgs = {
  input: SetEmailForSendingInput;
};


export type MutationUpdateAbsenceArgs = {
  input: UpdateAbsenceInput;
};


export type MutationUpdateAbsenceReasonArgs = {
  input: UpdateAbsenceReasonInput;
};


export type MutationUpdateAccountingProfileArgs = {
  input: UpdateAccountingProfileInput;
};


export type MutationUpdateBccRecipientListArgs = {
  input: UpdateBccRecipientListInput;
};


export type MutationUpdateBillingInformationArgs = {
  input: UpdateBillingInformationInput;
};


export type MutationUpdateCalendarEventArgs = {
  input: UpdateCalendarEventInput;
};


export type MutationUpdateCompanyContactArgs = {
  input: UpdateCompanyContactInput;
};


export type MutationUpdateContactAddressArgs = {
  input: UpdateContactAddressInput;
};


export type MutationUpdateContactDeleteArgs = {
  input: UpdateContactDeleteInput;
};


export type MutationUpdateContactEmailArgs = {
  input: UpdateContactEmailInput;
};


export type MutationUpdateContactPersonInformationArgs = {
  input: UpdateContactPersonInformationInput;
};


export type MutationUpdateContractedInformationArgs = {
  input: UpdateContractedInformationInput;
};


export type MutationUpdateDateInformationArgs = {
  input: UpdateDateInformationInput;
};


export type MutationUpdateDayProjectTimeEntryArgs = {
  input: UpdateDayProjectTimeEntryInput;
};


export type MutationUpdateDayTimeEntryArgs = {
  input: UpdateDayTimeEntryInput;
};


export type MutationUpdateDepartmentArgs = {
  input: UpdateDepartmentInput;
};


export type MutationUpdateDepartmentInformationArgs = {
  input: UpdateDepartmentInformationInput;
};


export type MutationUpdateDiscountProfileArgs = {
  input: UpdateDiscountProfileInput;
};


export type MutationUpdateDocumentDraftArgs = {
  input: UpdateDocumentDraftInput;
};


export type MutationUpdateDunningLevelArgs = {
  input: UpdateDunningLevelInput;
};


export type MutationUpdateEmailArgs = {
  input: UpdateEmailInput;
};


export type MutationUpdateEmployeeWorkingConditionArgs = {
  input: UpdateEmployeeWorkingConditionInput;
};


export type MutationUpdateFileEntryArgs = {
  input: UpdateFileEntryInput;
};


export type MutationUpdateMailboxContactArgs = {
  input: UpdateMailboxContactInput;
};


export type MutationUpdateMetadataArgs = {
  input: UpdateMetadataInput;
};


export type MutationUpdateMyDayProjectTimeEntryArgs = {
  input: UpdateMyDayProjectTimeEntryInput;
};


export type MutationUpdateMyDayTimeEntryArgs = {
  input: UpdateMyDayTimeEntryInput;
};


export type MutationUpdateMyPaymentConditionArgs = {
  input: UpdateMyPaymentConditionInput;
};


export type MutationUpdatePaymentConditionInformationArgs = {
  input: UpdatePaymentConditionInformationInput;
};


export type MutationUpdatePaymentInformationArgs = {
  input: UpdatePaymentInformationInput;
};


export type MutationUpdatePersonContactArgs = {
  input: UpdatePersonContactInput;
};


export type MutationUpdatePhoneInformationArgs = {
  input: UpdatePhoneInformationInput;
};


export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};


export type MutationUpdateProjectActiveStatusArgs = {
  input: UpdateProjectActiveStatusInput;
};


export type MutationUpdateProjectAdditionalAccountingInformationArgs = {
  input: UpdateProjectAdditionalAccountingInformationInput;
};


export type MutationUpdateProjectAdditionalContactInformationArgs = {
  input: UpdateProjectAdditionalContactInformationInput;
};


export type MutationUpdateProjectAdditionalContactPersonInformationArgs = {
  input: UpdateProjectAdditionalContactPersonInformationInput;
};


export type MutationUpdateProjectAdditionalPositionInformationArgs = {
  input: UpdateProjectAdditionalPositionInformationInput;
};


export type MutationUpdateProjectAdditionalTeamMemberInformationArgs = {
  input: UpdateProjectAdditionalTeamMemberInformationInput;
};


export type MutationUpdateProjectAdditionalTemplateInformationArgs = {
  input: UpdateProjectAdditionalTemplateInformationInput;
};


export type MutationUpdateProjectSaleableServiceArgs = {
  input: UpdateProjectSaleableServiceInput;
};


export type MutationUpdateProjectSaleableServiceGroupArgs = {
  input: UpdateProjectSaleableServiceGroupInput;
};


export type MutationUpdateProjectSaleableUnitArgs = {
  input: UpdateProjectSaleableUnitInput;
};


export type MutationUpdateProjectStatusArgs = {
  input: UpdateProjectStatusInput;
};


export type MutationUpdateRollingNumberArgs = {
  input: UpdateRollingNumberInput;
};


export type MutationUpdateSalaryInformationArgs = {
  input: UpdateSalaryInformationInput;
};


export type MutationUpdateSaleableServiceArgs = {
  input: UpdateSaleableServiceInput;
};


export type MutationUpdateSaleableServiceGroupArgs = {
  input: UpdateSaleableServiceGroupInput;
};


export type MutationUpdateSaleableUnitArgs = {
  input: UpdateSaleableUnitInput;
};


export type MutationUpdateTemplateArgs = {
  input: UpdateTemplateInput;
};


export type MutationUpdateTimeBalanceEntryArgs = {
  input: UpdateTimeBalanceEntryInput;
};


export type MutationUpdateTimeLabelArgs = {
  input: UpdateTimeLabelInput;
};


export type MutationUpdateTimeLabelGroupArgs = {
  input: UpdateTimeLabelGroupInput;
};


export type MutationUpdateWebsiteInformationArgs = {
  input: UpdateWebsiteInformationInput;
};


export type MutationUpdateWorkingConditionInformationArgs = {
  input: UpdateWorkingConditionInformationInput;
};


export type MutationUpdateWorkingTimeModelArgs = {
  input: UpdateWorkingTimeModelInput;
};


export type MutationUploadSmallArgs = {
  input: UploadSmallInput;
};


export type MutationUpsertSubstituteArgs = {
  input: UpsertSubstituteInput;
};


export type MutationUserAddLoginArgs = {
  input: UserAddLoginInput;
};


export type MutationUserChangeGroupsArgs = {
  input: UserChangeGroupsInput;
};


export type MutationUserRemoveLoginArgs = {
  input: UserRemoveLoginInput;
};


export type MutationUserSetEnabledArgs = {
  input: UserSetEnabledInput;
};


export type MutationWorksInDepartmentArgs = {
  input: WorksInDepartmentInput;
};

/** A connection to a list of items. */
export type MyAllAbsencesConnection = {
  __typename?: 'MyAllAbsencesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MyAllAbsencesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Absence>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MyAllAbsencesEdge = {
  __typename?: 'MyAllAbsencesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Absence;
};

/** A connection to a list of items. */
export type MyAllAcceptedVacationRequestsConnection = {
  __typename?: 'MyAllAcceptedVacationRequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MyAllAcceptedVacationRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Absence>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MyAllAcceptedVacationRequestsEdge = {
  __typename?: 'MyAllAcceptedVacationRequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Absence;
};

export type MyAllAcceptedVacationRequestsFilterInput = {
  startDate: Scalars['LocalDate']['input'];
};

/** A connection to a list of items. */
export type MyAllProjectsConnection = {
  __typename?: 'MyAllProjectsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MyAllProjectsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProjectSummary>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MyAllProjectsEdge = {
  __typename?: 'MyAllProjectsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProjectSummary;
};

/** A connection to a list of items. */
export type MyAllTimeApprovalsConnection = {
  __typename?: 'MyAllTimeApprovalsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MyAllTimeApprovalsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProjectTimeApproval>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MyAllTimeApprovalsEdge = {
  __typename?: 'MyAllTimeApprovalsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProjectTimeApproval;
};

/** A connection to a list of items. */
export type MyAllVacationRequestsConnection = {
  __typename?: 'MyAllVacationRequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MyAllVacationRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Absence>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MyAllVacationRequestsEdge = {
  __typename?: 'MyAllVacationRequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Absence;
};

export type MyCancelVacationError = DomainError | InvalidUserPrivilegesError | PropertyValidationError;

export type MyCancelVacationInput = {
  absenceId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['Long']['input'];
};

export type MyCancelVacationPayload = {
  __typename?: 'MyCancelVacationPayload';
  absence?: Maybe<Absence>;
  errors?: Maybe<Array<MyCancelVacationError>>;
};

/** A connection to a list of items. */
export type MyContractorsConnection = {
  __typename?: 'MyContractorsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MyContractorsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Contact>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MyContractorsEdge = {
  __typename?: 'MyContractorsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Contact;
};

export type MyCreateTimeApprovalError = DomainError | PropertyValidationError;

export type MyCreateTimeApprovalInput = {
  month: Scalars['LocalDate']['input'];
  projectId: Scalars['ID']['input'];
};

export type MyCreateTimeApprovalPayload = {
  __typename?: 'MyCreateTimeApprovalPayload';
  errors?: Maybe<Array<MyCreateTimeApprovalError>>;
  projectTimeApproval?: Maybe<ProjectTimeApproval>;
};

export type MyCreateVacationError = DomainError | PropertyValidationError;

export type MyCreateVacationInput = {
  absenceReasonId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  delegateEmployeeId: Scalars['ID']['input'];
  end: Scalars['LocalDate']['input'];
  isHalfEndDay: Scalars['Boolean']['input'];
  isHalfStartDay: Scalars['Boolean']['input'];
  start: Scalars['LocalDate']['input'];
};

export type MyCreateVacationPayload = {
  __typename?: 'MyCreateVacationPayload';
  absence?: Maybe<Absence>;
  errors?: Maybe<Array<MyCreateVacationError>>;
};

export type MyDeleteTimerError = DomainError;

export type MyDeleteTimerPayload = {
  __typename?: 'MyDeleteTimerPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<MyDeleteTimerError>>;
};

export type MyEntityNotFoundError = Error & {
  __typename?: 'MyEntityNotFoundError';
  error: Scalars['String']['output'];
  errorType: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type MyStartTimerError = DomainError;

export type MyStartTimerInput = {
  startTime: Scalars['DateTime']['input'];
};

export type MyStartTimerPayload = {
  __typename?: 'MyStartTimerPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<MyStartTimerError>>;
};

export type MyStopTimerError = DomainError;

export type MyStopTimerInput = {
  endTime: Scalars['DateTime']['input'];
};

export type MyStopTimerPayload = {
  __typename?: 'MyStopTimerPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<MyStopTimerError>>;
};

/** A connection to a list of items. */
export type MySupplierMembersConnection = {
  __typename?: 'MySupplierMembersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MySupplierMembersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Contact>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MySupplierMembersEdge = {
  __typename?: 'MySupplierMembersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Contact;
};

/** A connection to a list of items. */
export type MyTeamMembersConnection = {
  __typename?: 'MyTeamMembersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MyTeamMembersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Contact>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MyTeamMembersEdge = {
  __typename?: 'MyTeamMembersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Contact;
};

/** A connection to a list of items. */
export type MyTimeApprovalsByProjectConnection = {
  __typename?: 'MyTimeApprovalsByProjectConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MyTimeApprovalsByProjectEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProjectTimeApproval>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MyTimeApprovalsByProjectEdge = {
  __typename?: 'MyTimeApprovalsByProjectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProjectTimeApproval;
};

export type MyUpdateVacationError = ConcurrentAccessError | DomainError | InvalidUserPrivilegesError | PropertyValidationError;

export type MyUpdateVacationInput = {
  absenceId: Scalars['ID']['input'];
  absenceReasonId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  delegateEmployeeId: Scalars['ID']['input'];
  end: Scalars['LocalDate']['input'];
  isHalfEndDay: Scalars['Boolean']['input'];
  isHalfStartDay: Scalars['Boolean']['input'];
  start: Scalars['LocalDate']['input'];
  version: Scalars['Long']['input'];
};

export type MyUpdateVacationPayload = {
  __typename?: 'MyUpdateVacationPayload';
  absence?: Maybe<Absence>;
  errors?: Maybe<Array<MyUpdateVacationError>>;
};

/** The node interface is implemented by entities that have a global unique identifier. */
export type Node = {
  id: Scalars['ID']['output'];
};

export type Offer = CommercialDocument & Node & {
  __typename?: 'Offer';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  billTo: GenericAddress;
  cancellation?: Maybe<CancellationInfo>;
  clientContactPersonId?: Maybe<Scalars['ID']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clientVatId?: Maybe<Scalars['String']['output']>;
  concludingText?: Maybe<Scalars['String']['output']>;
  contractorId?: Maybe<Scalars['ID']['output']>;
  contractorVatId?: Maybe<Scalars['String']['output']>;
  createdById: Scalars['ID']['output'];
  createdDate: Scalars['LocalDate']['output'];
  documentRole: DocumentRole;
  documentType: DocumentType;
  dueDate?: Maybe<Scalars['LocalDate']['output']>;
  employeeIds: Array<Scalars['ID']['output']>;
  grossTotal: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  introductoryText: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isInvalid: Scalars['Boolean']['output'];
  isProforma: Scalars['Boolean']['output'];
  isReversal: Scalars['Boolean']['output'];
  issueDate?: Maybe<Scalars['LocalDate']['output']>;
  items: Array<LineItem>;
  netTotal: Scalars['Decimal']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  paymentDeadlineInDays: Scalars['Int']['output'];
  payments?: Maybe<Array<PaymentItem>>;
  projectId?: Maybe<Scalars['ID']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  sentDate?: Maybe<Scalars['DateTime']['output']>;
  sentEmailId?: Maybe<Scalars['UUID']['output']>;
  shipTo?: Maybe<GenericAddress>;
  status: DocumentStatus;
  taxDetails: Array<TaxDetail>;
  taxTotal: Scalars['Decimal']['output'];
  timeSheetApprovalIds: Array<Scalars['ID']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export enum OrderType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum Origin {
  System = 'SYSTEM',
  User = 'USER'
}

export enum OverviewItemType {
  Client = 'CLIENT',
  Employee = 'EMPLOYEE',
  Project = 'PROJECT',
  Timesheet = 'TIMESHEET'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PartInfoInput = {
  etag: Scalars['String']['input'];
  partNumber: Scalars['Int']['input'];
};

export type PaymentConditionInformation = ContactAdditionalInformation & {
  __typename?: 'PaymentConditionInformation';
  discountProfileId?: Maybe<VersionedDiscountProfileId>;
  doesNotParticipateInVoucherProcess: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  selectedEntry?: Maybe<DiscountProfileEntry>;
  selectedEntryId?: Maybe<Scalars['ID']['output']>;
};

export type PaymentInformation = ContactAdditionalInformation & {
  __typename?: 'PaymentInformation';
  id: Scalars['ID']['output'];
  paymentDeadlineInDays?: Maybe<Scalars['Int']['output']>;
  routeId: Scalars['String']['output'];
  taxNumber: Scalars['String']['output'];
  vatId: Scalars['String']['output'];
};

export type PaymentItem = {
  __typename?: 'PaymentItem';
  amount: Scalars['Decimal']['output'];
  creationDate: Scalars['LocalDate']['output'];
  documentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  paymentDate: Scalars['LocalDate']['output'];
  paymentMethod?: Maybe<Scalars['String']['output']>;
};

export enum PersonDateType {
  Anniversary = 'ANNIVERSARY',
  BirthDate = 'BIRTH_DATE',
  Other = 'OTHER'
}

export type PhoneInformation = ContactAdditionalInformation & {
  __typename?: 'PhoneInformation';
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  phoneType: PhoneType;
};

export enum PhoneType {
  Home = 'HOME',
  Mobile = 'MOBILE',
  Other = 'OTHER',
  Work = 'WORK'
}

export type PresignPartInput = {
  entityId: Scalars['String']['input'];
  partNumber: Scalars['Int']['input'];
  uploadId: Scalars['String']['input'];
};

export type PresignPartPayload = {
  __typename?: 'PresignPartPayload';
  string?: Maybe<Scalars['String']['output']>;
};

export type Privilege = {
  __typename?: 'Privilege';
  contractorId?: Maybe<Scalars['ID']['output']>;
  isMultiContractor: Scalars['Boolean']['output'];
  roles: Array<Scalars['String']['output']>;
  substituting: Array<Scalars['ID']['output']>;
};

export type Project = Node & {
  __typename?: 'Project';
  additionalInformation: Array<ProjectAdditionalInformation>;
  budget: Budget;
  budgetStatus: BudgetStatus;
  createdBy: Contact;
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isGroup: Scalars['Boolean']['output'];
  isManualStatusOverride: Scalars['Boolean']['output'];
  isRoot: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  parentProjectId?: Maybe<Scalars['ID']['output']>;
  parentProjectName?: Maybe<Scalars['String']['output']>;
  path: Array<Scalars['ID']['output']>;
  projectType: ProjectType;
  range: DateOnlyRange;
  saleableServiceGroups: Array<ProjectSaleableServiceGroup>;
  saleableServices: Array<ProjectSaleableService>;
  saleableUnits: Array<ProjectSaleableUnit>;
  status: ProjectStatus;
  timestamp: Scalars['DateTime']['output'];
  validatedAt?: Maybe<Scalars['DateTime']['output']>;
  validationErrors: Array<ProjectValidationError>;
  validationStatus: ValidationStatus;
};

export type ProjectAccountingData = {
  __typename?: 'ProjectAccountingData';
  clientContractDate?: Maybe<Scalars['LocalDate']['output']>;
  clientContractNumber?: Maybe<Scalars['String']['output']>;
  clientOrderingDate?: Maybe<Scalars['LocalDate']['output']>;
  clientOrderingNumber?: Maybe<Scalars['String']['output']>;
  clientProjectNumber?: Maybe<Scalars['String']['output']>;
  supplierProjectNumber?: Maybe<Scalars['String']['output']>;
};

export type ProjectAdditionalInformation = {
  id: Scalars['ID']['output'];
};

export type ProjectExtendedData = {
  __typename?: 'ProjectExtendedData';
  accountingInfo?: Maybe<ProjectAccountingData>;
  clientContactPersonId?: Maybe<Scalars['ID']['output']>;
  contractorContactPersonId?: Maybe<Scalars['ID']['output']>;
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  templateInformation?: Maybe<AdditionalTemplateInformation>;
  tenderName?: Maybe<Scalars['String']['output']>;
  tenderNumber?: Maybe<Scalars['String']['output']>;
};

export type ProjectInvoiceInformation = {
  __typename?: 'ProjectInvoiceInformation';
  accountingProfile?: Maybe<AccountingProfile>;
  clientContactPersonId?: Maybe<Scalars['ID']['output']>;
  clientContractNumber: Scalars['String']['output'];
  clientId?: Maybe<Scalars['ID']['output']>;
  clientOrderingDate?: Maybe<Scalars['LocalDate']['output']>;
  clientOrderingNumber: Scalars['String']['output'];
  contractorContactPersonId?: Maybe<Scalars['ID']['output']>;
  contractorId: Scalars['ID']['output'];
  creditNoteWorkItems: Array<ProjectTimeApprovalDetailEntry>;
  documentNumber: Scalars['String']['output'];
  employeeId: Scalars['ID']['output'];
  invoiceWorkItems: Array<ProjectTimeApprovalDetailEntry>;
  projectId: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
  projectNumber: Scalars['String']['output'];
  projectPositions: Array<ProjectPositionInformation>;
  projectTemplateInformation?: Maybe<ProjectTemplateInformation>;
  provisionDescription?: Maybe<Scalars['String']['output']>;
  provisionPercent?: Maybe<Scalars['Decimal']['output']>;
  requiresCreditNote: Scalars['Boolean']['output'];
  teamMemberContractorId?: Maybe<Scalars['ID']['output']>;
  tenderName?: Maybe<Scalars['String']['output']>;
  tenderNumber?: Maybe<Scalars['String']['output']>;
};

export type ProjectOfferData = {
  __typename?: 'ProjectOfferData';
  clientContactPersonId?: Maybe<Scalars['ID']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  contractorId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  positions: Array<ProjectOfferPositionData>;
  projectId: Scalars['ID']['output'];
  provisionDescription?: Maybe<Scalars['String']['output']>;
  provisionPercent?: Maybe<Scalars['Decimal']['output']>;
};

export type ProjectOfferPositionData = {
  __typename?: 'ProjectOfferPositionData';
  description: Scalars['String']['output'];
  hours?: Maybe<Scalars['Decimal']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  pricePerHour?: Maybe<Scalars['Decimal']['output']>;
  priceRate?: Maybe<Scalars['String']['output']>;
  serviceName: Scalars['String']['output'];
  servicePrice: Scalars['Decimal']['output'];
};

export type ProjectPosition = {
  __typename?: 'ProjectPosition';
  projectPositionId: Scalars['ID']['output'];
  saleableServiceName: Scalars['String']['output'];
};

export type ProjectPositionInformation = {
  __typename?: 'ProjectPositionInformation';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pricePerHour: Scalars['Decimal']['output'];
  teamMemberPricePerHour?: Maybe<Scalars['Decimal']['output']>;
};

export enum ProjectPositionPriceRateType {
  DailyRate = 'DAILY_RATE',
  FlatRate = 'FLAT_RATE',
  MonthlyRate = 'MONTHLY_RATE',
  Unit = 'UNIT',
  YearlyRate = 'YEARLY_RATE'
}

export type ProjectQueryInput = {
  filterByClientId?: InputMaybe<Scalars['ID']['input']>;
  filterByName?: InputMaybe<Scalars['String']['input']>;
  filterByStatus?: InputMaybe<ProjectStatus>;
  filterByType?: InputMaybe<ProjectType>;
  order?: InputMaybe<OrderType>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectSaleableService = {
  __typename?: 'ProjectSaleableService';
  budget: Budget;
  hasFixSellingPrice: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  originalId: Scalars['String']['output'];
  purchasePrice: Scalars['Decimal']['output'];
  sellingPrice: Scalars['Decimal']['output'];
  unit?: Maybe<ProjectSaleableUnit>;
  vatRate: Scalars['Decimal']['output'];
};

export type ProjectSaleableServiceGroup = {
  __typename?: 'ProjectSaleableServiceGroup';
  budget: Budget;
  hasFixSellingPrice: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  originalId: Scalars['String']['output'];
  sellingPrice: Scalars['Decimal']['output'];
  services: Array<ProjectSaleableService>;
};

export type ProjectSaleableUnit = {
  __typename?: 'ProjectSaleableUnit';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  originalId: Scalars['String']['output'];
  shortCode: Scalars['String']['output'];
};

export type ProjectSearchResultType = {
  __typename?: 'ProjectSearchResultType';
  matchedIds: Array<Scalars['ID']['output']>;
  projects: Array<ProjectSummary>;
  totalCount: Scalars['Int']['output'];
};

export enum ProjectStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  OfferCreated = 'OFFER_CREATED',
  OfferSent = 'OFFER_SENT',
  Rejected = 'REJECTED'
}

export type ProjectSummary = {
  __typename?: 'ProjectSummary';
  budget: Budget;
  budgetStatus: BudgetStatus;
  client?: Maybe<Contact>;
  clientId?: Maybe<Scalars['ID']['output']>;
  contractor?: Maybe<Contact>;
  contractorId?: Maybe<Scalars['ID']['output']>;
  createdBy: Contact;
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isGroup: Scalars['Boolean']['output'];
  isManualStatusOverride: Scalars['Boolean']['output'];
  isRoot: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  parentProjectId?: Maybe<Scalars['ID']['output']>;
  parentProjectName?: Maybe<Scalars['String']['output']>;
  path: Array<Scalars['ID']['output']>;
  projectType: ProjectType;
  range: DateOnlyRange;
  status: ProjectStatus;
  timestamp: Scalars['DateTime']['output'];
  validatedAt?: Maybe<Scalars['DateTime']['output']>;
  validationErrors: Array<ProjectValidationError>;
  validationStatus: ValidationStatus;
};

export type ProjectTemplateInformation = {
  __typename?: 'ProjectTemplateInformation';
  id: Scalars['ID']['output'];
  isDetailTimesheet: Scalars['Boolean']['output'];
  isInvoiceWithTimesheet: Scalars['Boolean']['output'];
};

export type ProjectTimeApproval = Node & {
  __typename?: 'ProjectTimeApproval';
  clientInvoices: Array<InvoiceReference>;
  contractorCreditNotes: Array<CreditNoteReference>;
  createdBy: Contact;
  createdById: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  employee: Contact;
  employeeId: Scalars['ID']['output'];
  from: Scalars['LocalDate']['output'];
  history: Array<ProjectTimeApprovalHistory>;
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  project: ProjectSummary;
  projectId: Scalars['ID']['output'];
  requiresContractorCreditNote: Scalars['Boolean']['output'];
  requiresCreditNote: Scalars['Boolean']['output'];
  status: ApprovalTimeEntryStatus;
  supplierCreditNotes: Array<CreditNoteReference>;
  timestamp: Scalars['DateTime']['output'];
  to: Scalars['LocalDate']['output'];
  totalMinutes: Scalars['Long']['output'];
};

export type ProjectTimeApprovalDetail = {
  __typename?: 'ProjectTimeApprovalDetail';
  description: Scalars['String']['output'];
  employee: Contact;
  employeeId: Scalars['ID']['output'];
  entries: Array<ProjectTimeApprovalDetailEntry>;
  from: Scalars['LocalDate']['output'];
  project: ProjectSummary;
  projectId: Scalars['ID']['output'];
  status: ApprovalTimeEntryStatus;
  to: Scalars['LocalDate']['output'];
  totalMinutes: Scalars['Long']['output'];
};

export type ProjectTimeApprovalDetailEntry = {
  __typename?: 'ProjectTimeApprovalDetailEntry';
  date: Scalars['LocalDate']['output'];
  description: Scalars['String']['output'];
  endTime: Scalars['TimeSpan']['output'];
  projectPositionId: Scalars['ID']['output'];
  startTime: Scalars['TimeSpan']['output'];
  surcharge: AbsolutOrPercent;
  totalMinutes: Scalars['Long']['output'];
};

export type ProjectTimeApprovalHistory = {
  __typename?: 'ProjectTimeApprovalHistory';
  createdBy: Contact;
  createdById: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  status: ApprovalTimeEntryStatus;
  timestamp: Scalars['DateTime']['output'];
};

export type ProjectTimeEntry = Node & {
  __typename?: 'ProjectTimeEntry';
  createdBy: Contact;
  createdById: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  errors: Array<ProjectTimeEntryDayGroupErrors>;
  history: Array<ProjectTimeEntryHistory>;
  id: Scalars['ID']['output'];
  logs: Array<ProjectTimeLogEntry>;
  member: Contact;
  memberId: Scalars['ID']['output'];
  projectId: Scalars['ID']['output'];
  projectPosition: DetailProjectPosition;
  projectPositionId: Scalars['ID']['output'];
  start: Scalars['DateTime']['output'];
  status: ProjectTimeEntryStatus;
  timestamp: Scalars['DateTime']['output'];
  version: Scalars['Long']['output'];
};

export type ProjectTimeEntryDayGroup = {
  __typename?: 'ProjectTimeEntryDayGroup';
  absenceReason?: Maybe<Scalars['String']['output']>;
  approvedWorkingMinutes: Scalars['Int']['output'];
  date: Scalars['LocalDate']['output'];
  errors: Array<ProjectTimeEntryDayGroupErrors>;
  id: Scalars['String']['output'];
  items: Array<ProjectTimeEntry>;
  pendingWorkingMinutes: Scalars['Int']['output'];
  rejectedWorkingMinutes: Scalars['Int']['output'];
  requiredWorkingMinutes: Scalars['Int']['output'];
  workingMinutes: Scalars['Int']['output'];
};

export enum ProjectTimeEntryDayGroupErrors {
  Tododefineerrorors = 'TODODEFINEERRORORS'
}

export type ProjectTimeEntryHistory = {
  __typename?: 'ProjectTimeEntryHistory';
  createdBy: Contact;
  createdById: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  member: Contact;
  memberId: Scalars['ID']['output'];
  projectId: Scalars['ID']['output'];
  projectPosition: DetailProjectPosition;
  projectPositionId: Scalars['ID']['output'];
  start: Scalars['DateTime']['output'];
  status: ProjectTimeEntryStatus;
  timestamp: Scalars['DateTime']['output'];
  version: Scalars['Long']['output'];
};

export enum ProjectTimeEntryStatus {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Open = 'OPEN',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ProjectTimeLogEntry = {
  __typename?: 'ProjectTimeLogEntry';
  createdBy: Contact;
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type ProjectTimeSummary = {
  __typename?: 'ProjectTimeSummary';
  approvedMinutes: Scalars['Long']['output'];
  endDate: Scalars['LocalDate']['output'];
  isDeleted: Scalars['Boolean']['output'];
  openMinutes: Scalars['Long']['output'];
  pendingMinutes: Scalars['Long']['output'];
  positionName: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
  projectPositionId: Scalars['ID']['output'];
  startDate: Scalars['LocalDate']['output'];
  totalMinutes: Scalars['Long']['output'];
  totalWorkedMinutes: Scalars['Long']['output'];
};

export enum ProjectType {
  Internal = 'INTERNAL',
  Project = 'PROJECT',
  Tender = 'TENDER'
}

export type ProjectValidationError = {
  __typename?: 'ProjectValidationError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  metadata?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  severity: Scalars['String']['output'];
};

export type ProjectWithPositions = {
  __typename?: 'ProjectWithPositions';
  client?: Maybe<Contact>;
  clientId?: Maybe<Scalars['ID']['output']>;
  contractor?: Maybe<Contact>;
  contractorId?: Maybe<Scalars['ID']['output']>;
  end: Scalars['LocalDate']['output'];
  isProjectInvalid: Scalars['Boolean']['output'];
  positions: Array<ProjectPosition>;
  projectId: Scalars['ID']['output'];
  projectLeader?: Maybe<Contact>;
  projectLeaderId?: Maybe<Scalars['ID']['output']>;
  projectName: Scalars['String']['output'];
  start: Scalars['LocalDate']['output'];
  timeTrackingResolution: Scalars['Int']['output'];
};

export type ProjectWorktimeOverview = {
  __typename?: 'ProjectWorktimeOverview';
  date: Scalars['LocalDate']['output'];
  entries: Array<ProjectWorktimeOverviewEntry>;
};

export type ProjectWorktimeOverviewEntry = {
  __typename?: 'ProjectWorktimeOverviewEntry';
  projectId: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
  projectPositionId: Scalars['ID']['output'];
  projectPositionName: Scalars['String']['output'];
  totalMinutes: Scalars['Int']['output'];
};

export type PropertyError = {
  __typename?: 'PropertyError';
  errorMessage: Scalars['String']['output'];
  propertyName: Scalars['String']['output'];
};

export type PropertyValidationError = Error & {
  __typename?: 'PropertyValidationError';
  errorType: Scalars['String']['output'];
  errors: Array<PropertyError>;
  message: Scalars['String']['output'];
};

export enum Protection {
  None = 'NONE',
  ReadOnly = 'READ_ONLY',
  RoleRestricted = 'ROLE_RESTRICTED'
}

export type Query = {
  __typename?: 'Query';
  accessibleUserGroups: Array<UserGroup>;
  allAbsenceOverviewRequests?: Maybe<AllAbsenceOverviewRequestsConnection>;
  allAbsenceReasons?: Maybe<AllAbsenceReasonsConnection>;
  allAbsenceReasonsForUsage?: Maybe<AllAbsenceReasonsForUsageConnection>;
  allAbsences?: Maybe<AllAbsencesConnection>;
  allAbsencesOfDate?: Maybe<AllAbsencesOfDateConnection>;
  allAccountingProfiles?: Maybe<AllAccountingProfilesConnection>;
  allCalendarEvents?: Maybe<AllCalendarEventsConnection>;
  allCatalogEntries?: Maybe<AllCatalogEntriesConnection>;
  allCommercialDocuments?: Maybe<AllCommercialDocumentsConnection>;
  allContacts?: Maybe<AllContactsConnection>;
  allContractorBccRecipientLists: Array<BccRecipientList>;
  allContractorRollingNumbers: Array<RollingNumber>;
  allCorrectedCreditNotePayments: Array<PaymentItem>;
  allCorrectedInvoicePayments: Array<PaymentItem>;
  allCreditNotePayments: Array<PaymentItem>;
  allDepartmentIdsOfContact: AllDepartmentIdsOfContactResult;
  allDepartments?: Maybe<AllDepartmentsConnection>;
  allDiscountProfiles?: Maybe<AllDiscountProfilesConnection>;
  allDunningLevels: Array<DunningLevel>;
  allEmployeeTimeLabels: Array<TimeLabel>;
  allEmployees?: Maybe<AllEmployeesConnection>;
  allEmployeesOfContractor?: Maybe<AllEmployeesOfContractorConnection>;
  allEmployeesOfTimeLabel: Array<Contact>;
  allEmployeesOfTimeLabelGroup: Array<Contact>;
  allFederalStates: Array<FederalState>;
  allGlobalRollingNumbers: Array<RollingNumber>;
  allInvoicePayments: Array<PaymentItem>;
  allMemberContactIdsOfSuppliers: GetAllMemberContactIdsOfSuppliersResult;
  allMembersOf?: Maybe<AllMembersOfConnection>;
  allMembersOfDepartment?: Maybe<AllMembersOfDepartmentConnection>;
  allMembersOfMyContractors?: Maybe<AllMembersOfMyContractorsConnection>;
  allMyTimeLabels: Array<TimeLabel>;
  allProjectIdsOfClient?: Maybe<AllProjectIdsOfClientConnection>;
  allProjectPositionOfEmployee: Array<ProjectWithPositions>;
  allProjectTimeEntries: Array<ProjectTimeEntryDayGroup>;
  allProjects?: Maybe<AllProjectsConnection>;
  allRootProjects?: Maybe<AllRootProjectsConnection>;
  allSaleableServices: Array<SaleableServiceGroup>;
  allSaleableUnits: Array<SaleableUnit>;
  allSubProjects: Array<ProjectSummary>;
  allTeamMemberIdsOfLeader: GetAllTeamMembersOfContactResult;
  allTemplates?: Maybe<AllTemplatesConnection>;
  allTimeApprovalStatuses: Array<ApprovalTimeEntryStatus>;
  allTimeApprovals?: Maybe<AllTimeApprovalsConnection>;
  allTimeBalanceEntries?: Maybe<AllTimeBalanceEntriesConnection>;
  allTimeEntries: Array<TimeEntryDayGroup>;
  allTimeLabel?: Maybe<AllTimeLabelConnection>;
  allTimeLabelGroup?: Maybe<AllTimeLabelGroupConnection>;
  allTimeLabelGroupsOfDepartment?: Maybe<AllTimeLabelGroupsOfDepartmentConnection>;
  allTimeLabelsOfDepartment?: Maybe<AllTimeLabelsOfDepartmentConnection>;
  allTimeLabelsOfEmployee: Array<TimeLabel>;
  allTimeLabelsOfTimeLabelGroup?: Maybe<AllTimeLabelsOfTimeLabelGroupConnection>;
  allUserGroups?: Maybe<AllUserGroupsConnection>;
  allUsers?: Maybe<AllUsersConnection>;
  allWorkingTimeModels?: Maybe<AllWorkingTimeModelsConnection>;
  availableServicesForProject: Array<AvailableServiceGroup>;
  bulkDocumentStatuses: BulkDocumentStatusesResult;
  catalogEntry?: Maybe<CatalogEntry>;
  checkVacation: VacationCheckResult;
  contactsByIds: Array<Contact>;
  correctedCreditNoteDataById?: Maybe<CorrectedCreditNote>;
  correctedInvoiceDataById?: Maybe<CorrectedInvoice>;
  creditNoteDataById?: Maybe<CreditNote>;
  departmentByIds: Array<Department>;
  doContactsShareSupplier: Scalars['Boolean']['output'];
  doesEmployeeHasATeamLeader: Scalars['Boolean']['output'];
  downloadDocument: Scalars['String']['output'];
  downloadDocumentXml: Scalars['String']['output'];
  downloadTimeSheet: Scalars['String']['output'];
  dunningCaseByDocumentId?: Maybe<DunningCase>;
  eligibleTimesheetsForBilling: Array<EligibleTimesheetForBillingType>;
  emailById?: Maybe<Email>;
  emailsByType?: Maybe<EmailsByTypeConnection>;
  emailsByTypeAndStatus?: Maybe<EmailsByTypeAndStatusConnection>;
  generateDocumentXml: Scalars['String']['output'];
  initializeDocumentEmail: CommercialDocumentEmail;
  invoiceDataById?: Maybe<Invoice>;
  isEmployeeOfCompany: Scalars['Boolean']['output'];
  isOneATeamLeader: Scalars['Boolean']['output'];
  isTeamLeader: Scalars['Boolean']['output'];
  isTeamLeaderOfEmployee: Scalars['Boolean']['output'];
  listFolderEntries?: Maybe<ListFolderEntriesConnection>;
  lookupContactById: Contact;
  me?: Maybe<Contact>;
  monthlyBillingEligibility: MonthlyBillingEligibilityType;
  monthlyOverviewChildren: Array<MonthlyProjectOverviewItem>;
  monthlyOverviewRoots: MonthlyOverviewRootsResultType;
  myAllAbsences?: Maybe<MyAllAbsencesConnection>;
  myAllAcceptedVacationRequests?: Maybe<MyAllAcceptedVacationRequestsConnection>;
  myAllProjectPosition: Array<ProjectWithPositions>;
  myAllProjectTimeSummaries: Array<ProjectTimeSummary>;
  myAllProjects?: Maybe<MyAllProjectsConnection>;
  myAllTimeApprovals?: Maybe<MyAllTimeApprovalsConnection>;
  myAllVacationRequests?: Maybe<MyAllVacationRequestsConnection>;
  myCalendarEntries: Array<CalendarEntry>;
  myCheckVacation: VacationCheckResult;
  myContractors?: Maybe<MyContractorsConnection>;
  myNextCalendarEntries: Array<CalendarEntry>;
  myPaymentConditions: Array<EditablePaymentCondition>;
  myPrivileges: Privilege;
  myProjectTimeEntries: Array<ProjectTimeEntryDayGroup>;
  myProjectTimeSummaries: Array<ProjectTimeSummary>;
  myProjectWorktimeOverview: Array<ProjectWorktimeOverview>;
  myProjectWorktimeYearlyOverview: Array<ProjectWorktimeOverviewEntry>;
  mySupplierMembers?: Maybe<MySupplierMembersConnection>;
  myTeamMembers?: Maybe<MyTeamMembersConnection>;
  myTimeApprovalPreview: ProjectTimeApprovalDetail;
  myTimeApprovalsByProject?: Maybe<MyTimeApprovalsByProjectConnection>;
  myTimeEntries: Array<TimeEntryDayGroup>;
  myTimer?: Maybe<Scalars['DateTime']['output']>;
  myTotalWorkTimeSummary: WorkTimeSummary;
  myVacationSummary: VacationSummary;
  myWorkTimeSummary: WorkTimeSummary;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  offerDataById?: Maybe<Offer>;
  offersByProject: Array<Offer>;
  privileges: Privilege;
  projectExtendedData?: Maybe<ProjectExtendedData>;
  projectInvoiceInformation: ProjectInvoiceInformation;
  projectOfferData?: Maybe<ProjectOfferData>;
  projectTemplateInformation?: Maybe<AdditionalTemplateInformation>;
  projectTimeSummaries: Array<ProjectTimeSummary>;
  renderDocumentEmailBody: Scalars['String']['output'];
  renderDocumentPdf: Scalars['String']['output'];
  renderTimeSheetEmailBody: Scalars['String']['output'];
  renderTimesheetTemplate: Scalars['String']['output'];
  rolesForGroupNames: RolesForGroupNamesResult;
  searchMonthlyOverview: MonthlyOverviewSearchResultType;
  searchProjects: ProjectSearchResultType;
  substitutesOfContact: UserSubstitutesResult;
  suppliersOfContact: GetSuppliersOfContactResult;
  teamMemberTimeEntries: Array<TimeEntryDayGroup>;
  teamMemberWorkTimeSummary: WorkTimeSummary;
  teamVacationSummary: VacationSummary;
  templateById?: Maybe<Template>;
  templateVariables: Array<TemplateVariable>;
  timeApprovalDetails: ProjectTimeApprovalDetail;
  totalTeamMemberWorkTimeSummary: WorkTimeSummary;
  totalWorkTimeSummary: WorkTimeSummary;
  tryGetContractorsOfContact: TryGetContractorsOfContactResult;
  userByContactId?: Maybe<User>;
  userInfoByContactId?: Maybe<UserInfo>;
  userInfoByUserId: UserInfo;
  vacationSummary: VacationSummary;
  validateXml: XmlValidationResult;
  workTimeSummary: WorkTimeSummary;
};


export type QueryAllAbsenceOverviewRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: AbsenceOverviewQueryFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllAbsenceReasonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AllAbsenceReasonsQueryInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllAbsenceReasonsForUsageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AllAbsenceReasonsForUsageQueryInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllAbsencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['ID']['input'];
  filter: AbsenceQueryFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllAbsencesOfDateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['ID']['input'];
  filter: AbsenceQueryFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllAccountingProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AccountingProfileQueryInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllCalendarEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: AllCalendarEventsQueryInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllCatalogEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  filterOrigin?: InputMaybe<Origin>;
  filterType?: InputMaybe<EntryType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeTemp?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryAllCommercialDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CommercialDocumentSummaryFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ContactQueryInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllContractorBccRecipientListsArgs = {
  contractorId: Scalars['ID']['input'];
};


export type QueryAllContractorRollingNumbersArgs = {
  contractorId: Scalars['ID']['input'];
};


export type QueryAllCorrectedCreditNotePaymentsArgs = {
  correctedCreditNoteId: Scalars['ID']['input'];
};


export type QueryAllCorrectedInvoicePaymentsArgs = {
  correctedInvoiceId: Scalars['ID']['input'];
};


export type QueryAllCreditNotePaymentsArgs = {
  creditNoteId: Scalars['ID']['input'];
};


export type QueryAllDepartmentIdsOfContactArgs = {
  contactId: Scalars['ID']['input'];
};


export type QueryAllDepartmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: DepartmentQueryInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllDiscountProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DiscountProfileQueryInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllDunningLevelsArgs = {
  contractorId: Scalars['ID']['input'];
  filter?: InputMaybe<DunningLevelQueryFilterInput>;
};


export type QueryAllEmployeeTimeLabelsArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryAllEmployeesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<AllEmployeesOfContractorInput>;
};


export type QueryAllEmployeesOfContractorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contractorId: Scalars['ID']['input'];
  filter?: InputMaybe<AllEmployeesOfContractorInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllEmployeesOfTimeLabelArgs = {
  timeLabelId: Scalars['ID']['input'];
};


export type QueryAllEmployeesOfTimeLabelGroupArgs = {
  timeLabelGroupId: Scalars['ID']['input'];
};


export type QueryAllInvoicePaymentsArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type QueryAllMemberContactIdsOfSuppliersArgs = {
  supplierIds: Array<Scalars['ID']['input']>;
};


export type QueryAllMembersOfArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactId: Scalars['ID']['input'];
  filter?: InputMaybe<AllMembersOfCompanyInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllMembersOfDepartmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  departmentId: Scalars['ID']['input'];
  filter?: InputMaybe<AllMembersOfDepartmentInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllMembersOfMyContractorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ContactFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllProjectIdsOfClientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['ID']['input'];
  filter?: InputMaybe<ProjectQueryInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllProjectPositionOfEmployeeArgs = {
  input: GetAllProjectPositionOfEmployeeInput;
};


export type QueryAllProjectTimeEntriesArgs = {
  filter: ContactTimeEntriesQueryInput;
};


export type QueryAllProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProjectQueryInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllRootProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProjectQueryInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllSubProjectsArgs = {
  filter?: InputMaybe<ProjectQueryInput>;
  projectId: Scalars['ID']['input'];
};


export type QueryAllTeamMemberIdsOfLeaderArgs = {
  contactId: Scalars['ID']['input'];
};


export type QueryAllTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contractorId: Scalars['ID']['input'];
  filter?: InputMaybe<TemplateQueryInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllTimeApprovalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  end: Scalars['LocalDate']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  searchByNumber?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['LocalDate']['input'];
  statuses?: InputMaybe<Array<ApprovalTimeEntryStatus>>;
};


export type QueryAllTimeBalanceEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: AllTimeBalanceEntriesQueryInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllTimeEntriesArgs = {
  filter: ContactTimeEntriesQueryInput;
};


export type QueryAllTimeLabelArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  filter?: InputMaybe<AllTimeLabelInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllTimeLabelGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  filter?: InputMaybe<AllTimeLabelGroupInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllTimeLabelGroupsOfDepartmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  departmentId: Scalars['ID']['input'];
  filter?: InputMaybe<AllTimeLabelGroupInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllTimeLabelsOfDepartmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  departmentId: Scalars['ID']['input'];
  filter?: InputMaybe<AllTimeLabelInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllTimeLabelsOfEmployeeArgs = {
  contactId: Scalars['ID']['input'];
};


export type QueryAllTimeLabelsOfTimeLabelGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AllTimeLabelInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  timeLabelGroupId: Scalars['ID']['input'];
};


export type QueryAllUserGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AllUsersQueryInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllWorkingTimeModelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AllWorkingTimeModelsQueryInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAvailableServicesForProjectArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryBulkDocumentStatusesArgs = {
  creditNoteIds: Array<Scalars['ID']['input']>;
  invoiceIds: Array<Scalars['ID']['input']>;
};


export type QueryCatalogEntryArgs = {
  entityId: Scalars['String']['input'];
  path: Scalars['String']['input'];
};


export type QueryCheckVacationArgs = {
  employeeId: Scalars['ID']['input'];
  endDate: Scalars['LocalDate']['input'];
  isHalfEndDay: Scalars['Boolean']['input'];
  isHalfStartDay: Scalars['Boolean']['input'];
  startDate: Scalars['LocalDate']['input'];
  updatingAbsenceId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContactsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryCorrectedCreditNoteDataByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCorrectedInvoiceDataByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCreditNoteDataByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDepartmentByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryDoContactsShareSupplierArgs = {
  contactId1: Scalars['ID']['input'];
  contactId2: Scalars['ID']['input'];
};


export type QueryDoesEmployeeHasATeamLeaderArgs = {
  contactId: Scalars['ID']['input'];
};


export type QueryDownloadDocumentArgs = {
  documentId: Scalars['String']['input'];
  dunningEntityId?: InputMaybe<Scalars['String']['input']>;
  shouldDownload: Scalars['Boolean']['input'];
};


export type QueryDownloadDocumentXmlArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryDownloadTimeSheetArgs = {
  projectTimeApprovalId: Scalars['ID']['input'];
};


export type QueryDunningCaseByDocumentIdArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryEligibleTimesheetsForBillingArgs = {
  month: Scalars['LocalDate']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryEmailByIdArgs = {
  emailId: Scalars['ID']['input'];
};


export type QueryEmailsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: EmailsQueryTypeInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEmailsByTypeAndStatusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: EmailsQueryTypeStatusInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGenerateDocumentXmlArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryInitializeDocumentEmailArgs = {
  documentId: Scalars['String']['input'];
  dunningEntityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvoiceDataByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIsEmployeeOfCompanyArgs = {
  companyId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
};


export type QueryIsOneATeamLeaderArgs = {
  contactIds: Array<Scalars['ID']['input']>;
};


export type QueryIsTeamLeaderArgs = {
  contactId: Scalars['ID']['input'];
};


export type QueryIsTeamLeaderOfEmployeeArgs = {
  employeeId: Scalars['ID']['input'];
  teamLeaderId: Scalars['ID']['input'];
};


export type QueryListFolderEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folderPath: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<IEntrySortInput>>;
  pageNumber: Scalars['Int']['input'];
  where?: InputMaybe<IEntryFilterInput>;
};


export type QueryLookupContactByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMonthlyBillingEligibilityArgs = {
  month: Scalars['LocalDate']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryMonthlyOverviewChildrenArgs = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  month: Scalars['LocalDate']['input'];
  parentId: Scalars['String']['input'];
  parentPath: Array<Scalars['String']['input']>;
  parentType: OverviewItemType;
};


export type QueryMonthlyOverviewRootsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  excludeEmptyTenders?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFullyInvoiced?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupByClient?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  month: Scalars['LocalDate']['input'];
};


export type QueryMyAllAbsencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: AbsenceQueryFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyAllAcceptedVacationRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: MyAllAcceptedVacationRequestsFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyAllProjectPositionArgs = {
  input: GetMyAllProjectPositionInput;
};


export type QueryMyAllProjectTimeSummariesArgs = {
  endDate: Scalars['LocalDate']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['LocalDate']['input'];
};


export type QueryMyAllProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['LocalDate']['input'];
  filter?: InputMaybe<ProjectQueryInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  start: Scalars['LocalDate']['input'];
};


export type QueryMyAllTimeApprovalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['LocalDate']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchByNumber?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['LocalDate']['input'];
  statuses?: InputMaybe<Array<ApprovalTimeEntryStatus>>;
};


export type QueryMyAllVacationRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyCalendarEntriesArgs = {
  end: Scalars['LocalDate']['input'];
  showInformation: Scalars['Boolean']['input'];
  showOnlyMe: Scalars['Boolean']['input'];
  showPending: Scalars['Boolean']['input'];
  start: Scalars['LocalDate']['input'];
};


export type QueryMyCheckVacationArgs = {
  endDate: Scalars['LocalDate']['input'];
  isHalfEndDay: Scalars['Boolean']['input'];
  isHalfStartDay: Scalars['Boolean']['input'];
  startDate: Scalars['LocalDate']['input'];
  updatingAbsenceId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMyContractorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ContactFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyNextCalendarEntriesArgs = {
  showInformation: Scalars['Boolean']['input'];
  showPending: Scalars['Boolean']['input'];
  start: Scalars['LocalDate']['input'];
};


export type QueryMyProjectTimeEntriesArgs = {
  filter: TimeEntriesQueryInput;
};


export type QueryMyProjectTimeSummariesArgs = {
  projectId: Scalars['ID']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMyProjectWorktimeOverviewArgs = {
  endDate: Scalars['LocalDate']['input'];
  startDate: Scalars['LocalDate']['input'];
};


export type QueryMyProjectWorktimeYearlyOverviewArgs = {
  year: Scalars['Int']['input'];
};


export type QueryMySupplierMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ContactFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyTeamMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TeamMemberFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyTimeApprovalPreviewArgs = {
  month: Scalars['LocalDate']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryMyTimeApprovalsByProjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['LocalDate']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  searchByNumber?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['LocalDate']['input'];
  statuses?: InputMaybe<Array<ApprovalTimeEntryStatus>>;
};


export type QueryMyTimeEntriesArgs = {
  filter: TimeEntriesQueryInput;
};


export type QueryMyTotalWorkTimeSummaryArgs = {
  today: Scalars['LocalDate']['input'];
};


export type QueryMyVacationSummaryArgs = {
  year: Scalars['Int']['input'];
};


export type QueryMyWorkTimeSummaryArgs = {
  endDate: Scalars['LocalDate']['input'];
  startDate: Scalars['LocalDate']['input'];
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOfferDataByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOffersByProjectArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryPrivilegesArgs = {
  contactId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProjectExtendedDataArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectInvoiceInformationArgs = {
  projectTimeApprovalId: Scalars['ID']['input'];
};


export type QueryProjectOfferDataArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectTemplateInformationArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectTimeSummariesArgs = {
  employeeId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRenderDocumentEmailBodyArgs = {
  documentId: Scalars['String']['input'];
  dunningEntityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRenderDocumentPdfArgs = {
  documentId: Scalars['String']['input'];
  dunningEntityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRenderTimeSheetEmailBodyArgs = {
  input: RenderTimeSheetEmailBodyInput;
};


export type QueryRenderTimesheetTemplateArgs = {
  input: RenderTimesheetTemplateInput;
};


export type QueryRolesForGroupNamesArgs = {
  groupNames: Array<Scalars['String']['input']>;
};


export type QuerySearchMonthlyOverviewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  excludeEmptyTenders?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFullyInvoiced?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  month: Scalars['LocalDate']['input'];
  projectName: Scalars['String']['input'];
};


export type QuerySearchProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProjectQueryInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySubstitutesOfContactArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySuppliersOfContactArgs = {
  contactId: Scalars['ID']['input'];
};


export type QueryTeamMemberTimeEntriesArgs = {
  filter: ContactTimeEntriesQueryInput;
};


export type QueryTeamMemberWorkTimeSummaryArgs = {
  employeeId: Scalars['ID']['input'];
  endDate: Scalars['LocalDate']['input'];
  startDate: Scalars['LocalDate']['input'];
};


export type QueryTeamVacationSummaryArgs = {
  employeeId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};


export type QueryTemplateByIdArgs = {
  templateId: Scalars['ID']['input'];
};


export type QueryTemplateVariablesArgs = {
  input: GetTemplateVariablesInput;
};


export type QueryTimeApprovalDetailsArgs = {
  projectTimeApprovalId: Scalars['ID']['input'];
};


export type QueryTotalTeamMemberWorkTimeSummaryArgs = {
  employeeId: Scalars['ID']['input'];
  today: Scalars['LocalDate']['input'];
};


export type QueryTotalWorkTimeSummaryArgs = {
  employeeId: Scalars['ID']['input'];
  today: Scalars['LocalDate']['input'];
};


export type QueryTryGetContractorsOfContactArgs = {
  contactId: Scalars['ID']['input'];
};


export type QueryUserByContactIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserInfoByContactIdArgs = {
  contactId: Scalars['ID']['input'];
};


export type QueryUserInfoByUserIdArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryVacationSummaryArgs = {
  employeeId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};


export type QueryValidateXmlArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryWorkTimeSummaryArgs = {
  employeeId: Scalars['ID']['input'];
  endDate: Scalars['LocalDate']['input'];
  startDate: Scalars['LocalDate']['input'];
};

export type RecalculateAllProjectBudgetsPayload = {
  __typename?: 'RecalculateAllProjectBudgetsPayload';
  int?: Maybe<Scalars['Int']['output']>;
};

export type RecordCorrectedCreditNotePaymentError = DomainError | PropertyValidationError;

export type RecordCorrectedCreditNotePaymentInput = {
  amount: Scalars['Decimal']['input'];
  correctedCreditNoteId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentDate: Scalars['LocalDate']['input'];
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
};

export type RecordCorrectedCreditNotePaymentPayload = {
  __typename?: 'RecordCorrectedCreditNotePaymentPayload';
  correctedCreditNote?: Maybe<CorrectedCreditNote>;
  errors?: Maybe<Array<RecordCorrectedCreditNotePaymentError>>;
};

export type RecordCorrectedInvoicePaymentError = DomainError | PropertyValidationError;

export type RecordCorrectedInvoicePaymentInput = {
  amount: Scalars['Decimal']['input'];
  correctedInvoiceId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentDate: Scalars['LocalDate']['input'];
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
};

export type RecordCorrectedInvoicePaymentPayload = {
  __typename?: 'RecordCorrectedInvoicePaymentPayload';
  correctedInvoice?: Maybe<CorrectedInvoice>;
  errors?: Maybe<Array<RecordCorrectedInvoicePaymentError>>;
};

export type RecordCreditNotePaymentError = DomainError | PropertyValidationError;

export type RecordCreditNotePaymentInput = {
  amount: Scalars['Decimal']['input'];
  creditNoteId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentDate: Scalars['LocalDate']['input'];
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
};

export type RecordCreditNotePaymentPayload = {
  __typename?: 'RecordCreditNotePaymentPayload';
  creditNote?: Maybe<CreditNote>;
  errors?: Maybe<Array<RecordCreditNotePaymentError>>;
};

export type RecordInvoicePaymentError = DomainError | PropertyValidationError;

export type RecordInvoicePaymentInput = {
  input: RecordPaymentInput;
};

export type RecordInvoicePaymentPayload = {
  __typename?: 'RecordInvoicePaymentPayload';
  errors?: Maybe<Array<RecordInvoicePaymentError>>;
  invoice?: Maybe<Invoice>;
};

export type RecordPaymentInput = {
  amount: Scalars['Decimal']['input'];
  invoiceId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentDate: Scalars['LocalDate']['input'];
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
};

export type RefreshMonthlyInvoiceStatusesError = DomainError | PropertyValidationError;

export type RefreshMonthlyInvoiceStatusesInput = {
  month: Scalars['LocalDate']['input'];
};

export type RefreshMonthlyInvoiceStatusesPayload = {
  __typename?: 'RefreshMonthlyInvoiceStatusesPayload';
  errors?: Maybe<Array<RefreshMonthlyInvoiceStatusesError>>;
  refreshMonthlyInvoiceStatusesResult?: Maybe<RefreshMonthlyInvoiceStatusesResult>;
};

export type RefreshMonthlyInvoiceStatusesResult = {
  __typename?: 'RefreshMonthlyInvoiceStatusesResult';
  updatedCreditNotes: Scalars['Int']['output'];
  updatedInvoices: Scalars['Int']['output'];
};

export type RejectOfferError = DomainError | PropertyValidationError;

export type RejectOfferInput = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type RejectOfferPayload = {
  __typename?: 'RejectOfferPayload';
  errors?: Maybe<Array<RejectOfferError>>;
  offer?: Maybe<Offer>;
};

export type RejectTimeApprovalError = DomainError | PropertyValidationError;

export type RejectTimeApprovalInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  projectTimeApprovalId: Scalars['ID']['input'];
};

export type RejectTimeApprovalPayload = {
  __typename?: 'RejectTimeApprovalPayload';
  errors?: Maybe<Array<RejectTimeApprovalError>>;
  projectTimeApproval?: Maybe<ProjectTimeApproval>;
};

export type RemoveEmployeesFromLabelGroupError = ConcurrentAccessError | DomainError | PropertyValidationError;

export type RemoveEmployeesFromLabelGroupInput = {
  employees: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  version: Scalars['Long']['input'];
};

export type RemoveEmployeesFromLabelGroupPayload = {
  __typename?: 'RemoveEmployeesFromLabelGroupPayload';
  errors?: Maybe<Array<RemoveEmployeesFromLabelGroupError>>;
  timeLabelGroup?: Maybe<TimeLabelGroup>;
};

export type RemoveEmployeesFromTimeLabelError = ConcurrentAccessError | DomainError | PropertyValidationError;

export type RemoveEmployeesFromTimeLabelInput = {
  employeeIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  version: Scalars['Long']['input'];
};

export type RemoveEmployeesFromTimeLabelPayload = {
  __typename?: 'RemoveEmployeesFromTimeLabelPayload';
  errors?: Maybe<Array<RemoveEmployeesFromTimeLabelError>>;
  timeLabel?: Maybe<TimeLabel>;
};

export type RemoveLabelGroupsFromDepartmentError = DomainError | PropertyValidationError;

export type RemoveLabelGroupsFromDepartmentInput = {
  id: Scalars['ID']['input'];
  timeLabelGroupsIds: Array<Scalars['ID']['input']>;
};

export type RemoveLabelGroupsFromDepartmentPayload = {
  __typename?: 'RemoveLabelGroupsFromDepartmentPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<RemoveLabelGroupsFromDepartmentError>>;
};

export type RemoveLabelsFromDepartmentError = DomainError | PropertyValidationError;

export type RemoveLabelsFromDepartmentInput = {
  id: Scalars['ID']['input'];
  timeLabelIds: Array<Scalars['ID']['input']>;
};

export type RemoveLabelsFromDepartmentPayload = {
  __typename?: 'RemoveLabelsFromDepartmentPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<RemoveLabelsFromDepartmentError>>;
};

export type RemoveLabelsFromLabelGroupError = ConcurrentAccessError | DomainError | PropertyValidationError;

export type RemoveLabelsFromLabelGroupInput = {
  id: Scalars['ID']['input'];
  labels: Array<Scalars['ID']['input']>;
  version: Scalars['Long']['input'];
};

export type RemoveLabelsFromLabelGroupPayload = {
  __typename?: 'RemoveLabelsFromLabelGroupPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<RemoveLabelsFromLabelGroupError>>;
};

export type RemoveServicesFromProjectError = DomainError | PropertyValidationError;

export type RemoveServicesFromProjectInput = {
  projectId: Scalars['ID']['input'];
  serviceIds: Array<Scalars['String']['input']>;
};

export type RemoveServicesFromProjectPayload = {
  __typename?: 'RemoveServicesFromProjectPayload';
  errors?: Maybe<Array<RemoveServicesFromProjectError>>;
  project?: Maybe<Project>;
};

export type RenderTimeSheetEmailBodyInput = {
  timeApprovalId: Scalars['ID']['input'];
};

export type RenderTimesheetTemplateInput = {
  timeApprovalId: Scalars['ID']['input'];
};

export type RequestMonthlyBillingError = DomainError | PropertyValidationError;

export type RequestMonthlyBillingInput = {
  month: Scalars['LocalDate']['input'];
  projectId: Scalars['ID']['input'];
  timesheetIdsForContractorCreditNotes: Array<Scalars['ID']['input']>;
  timesheetIdsForCreditNotes: Array<Scalars['ID']['input']>;
  timesheetIdsForInvoice: Array<Scalars['ID']['input']>;
};

export type RequestMonthlyBillingPayload = {
  __typename?: 'RequestMonthlyBillingPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<RequestMonthlyBillingError>>;
};

export type ResendVerificationEmailError = InvalidUserPrivilegesError | KeyCloakError;

export type ResendVerificationEmailInput = {
  clientId: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type ResendVerificationEmailPayload = {
  __typename?: 'ResendVerificationEmailPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<ResendVerificationEmailError>>;
};

export type ResendVerificationEmailToAllUnverifiedError = InvalidUserPrivilegesError | KeyCloakError;

export type ResendVerificationEmailToAllUnverifiedInput = {
  clientId: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
};

export type ResendVerificationEmailToAllUnverifiedPayload = {
  __typename?: 'ResendVerificationEmailToAllUnverifiedPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<ResendVerificationEmailToAllUnverifiedError>>;
};

export type ResetProjectStatusToAutomaticError = DomainError | PropertyValidationError;

export type ResetProjectStatusToAutomaticInput = {
  projectId: Scalars['ID']['input'];
};

export type ResetProjectStatusToAutomaticPayload = {
  __typename?: 'ResetProjectStatusToAutomaticPayload';
  errors?: Maybe<Array<ResetProjectStatusToAutomaticError>>;
  project?: Maybe<Project>;
};

export type RolesForGroupNamesResult = {
  __typename?: 'RolesForGroupNamesResult';
  roles: Array<Scalars['String']['output']>;
};

export type RollingNumber = Node & {
  __typename?: 'RollingNumber';
  contactId?: Maybe<Scalars['ID']['output']>;
  currentValue: Scalars['Int']['output'];
  digitCount: Scalars['Int']['output'];
  format: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: RollingNumberType;
};

export enum RollingNumberType {
  Clients = 'CLIENTS',
  Contractors = 'CONTRACTORS',
  CreditNotes = 'CREDIT_NOTES',
  Employees = 'EMPLOYEES',
  Freelancers = 'FREELANCERS',
  Invoices = 'INVOICES',
  Mailboxes = 'MAILBOXES',
  Offer = 'OFFER',
  ProformaCreditNotes = 'PROFORMA_CREDIT_NOTES',
  ProformaInvoices = 'PROFORMA_INVOICES',
  Projects = 'PROJECTS',
  Suppliers = 'SUPPLIERS',
  Tenders = 'TENDERS',
  Timesheets = 'TIMESHEETS'
}

export type SalaryInformation = ContactAdditionalInformation & {
  __typename?: 'SalaryInformation';
  id: Scalars['ID']['output'];
  pricePerHour: Scalars['Decimal']['output'];
  startDate: Scalars['LocalDate']['output'];
};

export type SaleableService = Node & {
  __typename?: 'SaleableService';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  purchasePrice: Scalars['Decimal']['output'];
  saleableServiceGroupId: Scalars['ID']['output'];
  saleableUnitId?: Maybe<Scalars['ID']['output']>;
  sellingPrice: Scalars['Decimal']['output'];
  unit?: Maybe<SaleableUnit>;
  vatRate: Scalars['Decimal']['output'];
};

export type SaleableServiceGroup = Node & {
  __typename?: 'SaleableServiceGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sellingPrice: Scalars['Decimal']['output'];
  services: Array<SaleableService>;
};

export type SaleableUnit = Node & {
  __typename?: 'SaleableUnit';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  shortCode: Scalars['String']['output'];
};

export enum SalutationType {
  Div = 'DIV',
  Mr = 'MR',
  Mrs = 'MRS'
}

export type SeedTimeBalanceEntryError = DomainError | PropertyValidationError;

export type SeedTimeBalanceEntryInput = {
  date: Scalars['LocalDate']['input'];
  employeeId: Scalars['ID']['input'];
  overtime: Scalars['TimeSpan']['input'];
  reason: Scalars['String']['input'];
  type: TimeBalanceType;
  vacationDays: Scalars['Decimal']['input'];
};

export type SeedTimeBalanceEntryPayload = {
  __typename?: 'SeedTimeBalanceEntryPayload';
  errors?: Maybe<Array<SeedTimeBalanceEntryError>>;
  timeBalanceEntry?: Maybe<TimeBalanceEntry>;
};

export type SeedVacationError = DomainError | PropertyValidationError;

export type SeedVacationInput = {
  absenceReasonId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  delegateEmployeeId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
  end: Scalars['LocalDate']['input'];
  isHalfEndDay: Scalars['Boolean']['input'];
  isHalfStartDay: Scalars['Boolean']['input'];
  start: Scalars['LocalDate']['input'];
};

export type SeedVacationPayload = {
  __typename?: 'SeedVacationPayload';
  absence?: Maybe<Absence>;
  errors?: Maybe<Array<SeedVacationError>>;
};

export type SendDocumentEmailError = DomainError | PropertyValidationError;

export type SendDocumentEmailInput = {
  commercialDocumentEmail: CommercialDocumentEmailInput;
  documentId: Scalars['String']['input'];
  dunningEntityId?: InputMaybe<Scalars['String']['input']>;
};

export type SendDocumentEmailPayload = {
  __typename?: 'SendDocumentEmailPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<SendDocumentEmailError>>;
};

export type SendTimeSheetApprovalEmailError = DomainError | PropertyValidationError;

export type SendTimeSheetApprovalEmailInput = {
  projectTimeApprovalId: Scalars['ID']['input'];
};

export type SendTimeSheetApprovalEmailPayload = {
  __typename?: 'SendTimeSheetApprovalEmailPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<SendTimeSheetApprovalEmailError>>;
};

export type SetEmailForSendingError = MyEntityNotFoundError | PropertyValidationError;

export type SetEmailForSendingInput = {
  emailId: Scalars['ID']['input'];
};

export type SetEmailForSendingPayload = {
  __typename?: 'SetEmailForSendingPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<SetEmailForSendingError>>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortInput = {
  direction: SortDirection;
  field?: InputMaybe<Scalars['String']['input']>;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Substitute = {
  __typename?: 'Substitute';
  absenceId: Scalars['ID']['output'];
  employeeId: Scalars['ID']['output'];
  from: Scalars['LocalDate']['output'];
  to: Scalars['LocalDate']['output'];
  willRepresentEmployeeId: Scalars['ID']['output'];
};

export type TaxDetail = {
  __typename?: 'TaxDetail';
  code: Scalars['String']['output'];
  netAmount: Scalars['Decimal']['output'];
  rate: Scalars['Decimal']['output'];
  taxAmount: Scalars['Decimal']['output'];
};

export type TeamMemberFilterInput = {
  searchBy?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Template = Node & {
  __typename?: 'Template';
  contactId: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  footer: Scalars['String']['output'];
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  masterPage: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rendering: TemplateRendering;
  type: TemplateType;
  version: Scalars['Long']['output'];
};

export type TemplateQueryInput = {
  filterByName?: InputMaybe<Scalars['String']['input']>;
  filterByRendering?: InputMaybe<TemplateRendering>;
  filterByType?: InputMaybe<TemplateType>;
  order?: InputMaybe<OrderType>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TemplateRendering {
  Pdf = 'PDF',
  Text = 'TEXT'
}

export enum TemplateType {
  Client = 'CLIENT',
  CollectionInvoice = 'COLLECTION_INVOICE',
  CorrectedCreditNote = 'CORRECTED_CREDIT_NOTE',
  CorrectedInvoice = 'CORRECTED_INVOICE',
  CreditNote = 'CREDIT_NOTE',
  DunningInvoice = 'DUNNING_INVOICE',
  Invoice = 'INVOICE',
  Offer = 'OFFER',
  Order = 'ORDER',
  Product = 'PRODUCT',
  Project = 'PROJECT',
  Receipt = 'RECEIPT',
  Tender = 'TENDER',
  TimeSheet = 'TIME_SHEET',
  TimeSheetDetail = 'TIME_SHEET_DETAIL'
}

export type TemplateVariable = {
  __typename?: 'TemplateVariable';
  display: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  template: Scalars['String']['output'];
};

export type TimeBalanceEntry = Node & {
  __typename?: 'TimeBalanceEntry';
  createdBy: Contact;
  createdById: Scalars['ID']['output'];
  date: Scalars['LocalDate']['output'];
  employee: Contact;
  employeeId: Scalars['ID']['output'];
  history: Array<TimeBalanceHistoryEntry>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  overtime?: Maybe<Scalars['TimeSpan']['output']>;
  reason: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: TimeBalanceType;
  vacationDays?: Maybe<Scalars['Decimal']['output']>;
  version: Scalars['Long']['output'];
};

export type TimeBalanceHistoryEntry = {
  __typename?: 'TimeBalanceHistoryEntry';
  createdBy: Contact;
  createdById: Scalars['ID']['output'];
  date: Scalars['LocalDate']['output'];
  isDeleted: Scalars['Boolean']['output'];
  overtime?: Maybe<Scalars['TimeSpan']['output']>;
  reason: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: TimeBalanceType;
  vacationDays?: Maybe<Scalars['Decimal']['output']>;
};

export enum TimeBalanceType {
  Incremental = 'INCREMENTAL',
  Initial = 'INITIAL'
}

export type TimeEntriesQueryInput = {
  endDate: Scalars['LocalDate']['input'];
  projectId: Scalars['ID']['input'];
  startDate: Scalars['LocalDate']['input'];
};

export type TimeEntry = Node & {
  __typename?: 'TimeEntry';
  calendarId: Scalars['String']['output'];
  createdBy: Contact;
  createdById: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  entryType: TimeEntryType;
  errors: Array<TimeEntryDayGroupErrors>;
  history: Array<TimeEntryHistory>;
  id: Scalars['ID']['output'];
  logs: Array<TimeLogEntry>;
  member: Contact;
  memberId: Scalars['ID']['output'];
  path: Array<Scalars['String']['output']>;
  start: Scalars['DateTime']['output'];
  status: TimeEntryStatus;
  timeLabel?: Maybe<TimeLabel>;
  timeLabelId?: Maybe<Scalars['ID']['output']>;
  timestamp: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  version: Scalars['Long']['output'];
  workLocation: WorkLocation;
};

export type TimeEntryDayGroup = {
  __typename?: 'TimeEntryDayGroup';
  absenceReason?: Maybe<Scalars['String']['output']>;
  approvedWorkingMinutes: Scalars['Int']['output'];
  balanceEntry?: Maybe<BalanceEntry>;
  balanceMinutes: Scalars['Int']['output'];
  breakMinutes: Scalars['Int']['output'];
  date: Scalars['LocalDate']['output'];
  errors: Array<TimeEntryDayGroupErrors>;
  id: Scalars['String']['output'];
  items: Array<TimeEntry>;
  pendingWorkingMinutes: Scalars['Int']['output'];
  rejectedWorkingMinutes: Scalars['Int']['output'];
  requiredWorkingMinutes: Scalars['Int']['output'];
  workingMinutes: Scalars['Int']['output'];
};

export enum TimeEntryDayGroupErrors {
  BreakOfAtLeast30MinutesNeeded = 'BREAK_OF_AT_LEAST30_MINUTES_NEEDED',
  BreakOfAtLeast45MinutesNeeded = 'BREAK_OF_AT_LEAST45_MINUTES_NEEDED',
  OverlappingTimeEntries = 'OVERLAPPING_TIME_ENTRIES'
}

export type TimeEntryHistory = {
  __typename?: 'TimeEntryHistory';
  createdBy: Contact;
  createdById: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  entryType: TimeEntryType;
  member: Contact;
  memberId: Scalars['ID']['output'];
  start: Scalars['DateTime']['output'];
  status: TimeEntryStatus;
  timeLabel?: Maybe<TimeLabel>;
  timeLabelId?: Maybe<Scalars['ID']['output']>;
  timestamp: Scalars['DateTime']['output'];
  version: Scalars['Long']['output'];
  workLocation: WorkLocation;
};

export enum TimeEntryStatus {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum TimeEntryType {
  Break = 'BREAK',
  TimeLabel = 'TIME_LABEL'
}

export type TimeLabel = Node & {
  __typename?: 'TimeLabel';
  companyId: Scalars['ID']['output'];
  departmentIds: Array<Scalars['ID']['output']>;
  departments: Array<Department>;
  employeeIds: Array<Scalars['ID']['output']>;
  employees: Array<Contact>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  timeLabelGroups: Array<TimeLabelGroup>;
  version: Scalars['Long']['output'];
};

export type TimeLabelGroup = Node & {
  __typename?: 'TimeLabelGroup';
  companyId: Scalars['ID']['output'];
  departmentIds: Array<Scalars['ID']['output']>;
  departments: Array<Department>;
  employeeIds: Array<Scalars['ID']['output']>;
  employees: Array<Contact>;
  id: Scalars['ID']['output'];
  isGlobal: Scalars['Boolean']['output'];
  labels: Array<TimeLabel>;
  name: Scalars['String']['output'];
  version: Scalars['Long']['output'];
};

export type TimeLogEntry = {
  __typename?: 'TimeLogEntry';
  createdBy: Contact;
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type TimeRange = {
  __typename?: 'TimeRange';
  contains: Scalars['Boolean']['output'];
  from: Scalars['TimeSpan']['output'];
  to: Scalars['TimeSpan']['output'];
};


export type TimeRangeContainsArgs = {
  other: TimeRangeInput;
};

export type TimeRangeInput = {
  from: Scalars['TimeSpan']['input'];
  to: Scalars['TimeSpan']['input'];
};

export type TryGetContractorsOfContactResult = {
  __typename?: 'TryGetContractorsOfContactResult';
  contractorId?: Maybe<Scalars['ID']['output']>;
};

export type UpdateAbsenceError = DomainError | PropertyValidationError;

export type UpdateAbsenceInput = {
  absenceId: Scalars['ID']['input'];
  absenceReasonId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  delegateEmployeeId: Scalars['ID']['input'];
  end: Scalars['LocalDate']['input'];
  isHalfEndDay: Scalars['Boolean']['input'];
  isHalfStartDay: Scalars['Boolean']['input'];
  start: Scalars['LocalDate']['input'];
  startWorkflow?: InputMaybe<Scalars['Boolean']['input']>;
  version: Scalars['Long']['input'];
};

export type UpdateAbsencePayload = {
  __typename?: 'UpdateAbsencePayload';
  absence?: Maybe<Absence>;
  errors?: Maybe<Array<UpdateAbsenceError>>;
};

export type UpdateAbsenceReasonError = ConcurrentAccessError | DomainError | PropertyValidationError;

export type UpdateAbsenceReasonInput = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isPaid: Scalars['Boolean']['input'];
  isVisible: Scalars['Boolean']['input'];
  maximumContinuedPayment?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  removesWorkingHours: Scalars['Boolean']['input'];
  type: AbsenceReasonType;
  version: Scalars['Long']['input'];
};

export type UpdateAbsenceReasonPayload = {
  __typename?: 'UpdateAbsenceReasonPayload';
  absenceReason?: Maybe<AbsenceReason>;
  errors?: Maybe<Array<UpdateAbsenceReasonError>>;
};

export type UpdateAccountingProfileError = DomainError | PropertyValidationError;

export type UpdateAccountingProfileInput = {
  entries: Array<AccountingProfileEntryInput>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateAccountingProfilePayload = {
  __typename?: 'UpdateAccountingProfilePayload';
  accountingProfile?: Maybe<AccountingProfile>;
  errors?: Maybe<Array<UpdateAccountingProfileError>>;
};

export type UpdateBccRecipientListError = MyEntityNotFoundError | PropertyValidationError;

export type UpdateBccRecipientListInput = {
  contractorId: Scalars['ID']['input'];
  recipients: Array<Scalars['String']['input']>;
  type: EmailType;
};

export type UpdateBccRecipientListPayload = {
  __typename?: 'UpdateBccRecipientListPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<UpdateBccRecipientListError>>;
};

export type UpdateBillingInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type UpdateBillingInformationInput = {
  bankAccount: BankAccountInput;
  billingAddress: AddressInput;
  billingInformationId: Scalars['ID']['input'];
  contactId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  shippingAddress: AddressInput;
};

export type UpdateBillingInformationPayload = {
  __typename?: 'UpdateBillingInformationPayload';
  billingInformation?: Maybe<BillingInformation>;
  errors?: Maybe<Array<UpdateBillingInformationError>>;
};

export type UpdateCalendarEventError = ConcurrentAccessError | DomainError | PropertyValidationError;

export type UpdateCalendarEventInput = {
  description: Scalars['String']['input'];
  endDate: Scalars['LocalDate']['input'];
  federalStateCodes: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isHalfEndDay: Scalars['Boolean']['input'];
  isHalfStartDay: Scalars['Boolean']['input'];
  isVacation: Scalars['Boolean']['input'];
  locations: Array<Scalars['String']['input']>;
  startDate: Scalars['LocalDate']['input'];
  type: CalendarEventType;
  version: Scalars['Long']['input'];
};

export type UpdateCalendarEventPayload = {
  __typename?: 'UpdateCalendarEventPayload';
  calendarEvent?: Maybe<CalendarEvent>;
  errors?: Maybe<Array<UpdateCalendarEventError>>;
};

export type UpdateCompanyContactError = DomainError | PropertyValidationError;

export type UpdateCompanyContactInput = {
  companyName: Scalars['String']['input'];
  contactNumber: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateCompanyContactPayload = {
  __typename?: 'UpdateCompanyContactPayload';
  contact?: Maybe<Contact>;
  errors?: Maybe<Array<UpdateCompanyContactError>>;
};

export type UpdateContactAddressError = DomainError | EntityNotFoundError | PropertyValidationError;

export type UpdateContactAddressInput = {
  addressId: Scalars['ID']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  contactId: Scalars['ID']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  type?: AddressType;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContactAddressPayload = {
  __typename?: 'UpdateContactAddressPayload';
  addressInformation?: Maybe<AddressInformation>;
  errors?: Maybe<Array<UpdateContactAddressError>>;
};

export type UpdateContactDeleteError = DomainError | PropertyValidationError;

export type UpdateContactDeleteInput = {
  id: Scalars['ID']['input'];
  isDeleted: Scalars['Boolean']['input'];
};

export type UpdateContactDeletePayload = {
  __typename?: 'UpdateContactDeletePayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<UpdateContactDeleteError>>;
};

export type UpdateContactEmailError = DomainError | EntityNotFoundError | PropertyValidationError;

export type UpdateContactEmailInput = {
  contactId: Scalars['ID']['input'];
  emailAddress: Scalars['String']['input'];
  emailId: Scalars['ID']['input'];
  emailType: EmailType;
};

export type UpdateContactEmailPayload = {
  __typename?: 'UpdateContactEmailPayload';
  emailInformation?: Maybe<EmailInformation>;
  errors?: Maybe<Array<UpdateContactEmailError>>;
};

export type UpdateContactPersonInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type UpdateContactPersonInformationInput = {
  contactId: Scalars['ID']['input'];
  contactPersonId: Scalars['ID']['input'];
  contactUsage: Array<ContactUsage>;
  informationId: Scalars['ID']['input'];
};

export type UpdateContactPersonInformationPayload = {
  __typename?: 'UpdateContactPersonInformationPayload';
  contactPersonInformation?: Maybe<ContactPersonInformation>;
  errors?: Maybe<Array<UpdateContactPersonInformationError>>;
};

export type UpdateContractedInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type UpdateContractedInformationInput = {
  contactId: Scalars['ID']['input'];
  contactInformationId: Scalars['ID']['input'];
  contractedId: Scalars['ID']['input'];
  margin: Scalars['Decimal']['input'];
};

export type UpdateContractedInformationPayload = {
  __typename?: 'UpdateContractedInformationPayload';
  contractedInformation?: Maybe<ContractedInformation>;
  errors?: Maybe<Array<UpdateContractedInformationError>>;
};

export type UpdateDateInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type UpdateDateInformationInput = {
  contactId: Scalars['ID']['input'];
  contactInformationId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  dateType: PersonDateType;
};

export type UpdateDateInformationPayload = {
  __typename?: 'UpdateDateInformationPayload';
  dateInformation?: Maybe<DateInformation>;
  errors?: Maybe<Array<UpdateDateInformationError>>;
};

export type UpdateDayProjectTimeEntryError = DomainError | PropertyValidationError;

export type UpdateDayProjectTimeEntryInput = {
  date: Scalars['LocalDate']['input'];
  employeeId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  timeEntries: Array<UpsertProjectTimeEntryInput>;
};

export type UpdateDayProjectTimeEntryPayload = {
  __typename?: 'UpdateDayProjectTimeEntryPayload';
  errors?: Maybe<Array<UpdateDayProjectTimeEntryError>>;
  projectTimeEntryDayGroup?: Maybe<ProjectTimeEntryDayGroup>;
};

export type UpdateDayTimeEntryError = DomainError | PropertyValidationError;

export type UpdateDayTimeEntryInput = {
  date: Scalars['LocalDate']['input'];
  employeeId: Scalars['ID']['input'];
  timeEntries: Array<UpsertTimeEntryInput>;
};

export type UpdateDayTimeEntryPayload = {
  __typename?: 'UpdateDayTimeEntryPayload';
  errors?: Maybe<Array<UpdateDayTimeEntryError>>;
  timeEntryDayGroup?: Maybe<TimeEntryDayGroup>;
};

export type UpdateDepartmentError = PropertyValidationError;

export type UpdateDepartmentInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type UpdateDepartmentInformationInput = {
  contactId: Scalars['ID']['input'];
  contactInformationId: Scalars['ID']['input'];
  departmentName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDepartmentInformationPayload = {
  __typename?: 'UpdateDepartmentInformationPayload';
  departmentInformation?: Maybe<DepartmentInformation>;
  errors?: Maybe<Array<UpdateDepartmentInformationError>>;
};

export type UpdateDepartmentInput = {
  departmentId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  leaderId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateDepartmentPayload = {
  __typename?: 'UpdateDepartmentPayload';
  department?: Maybe<Department>;
  errors?: Maybe<Array<UpdateDepartmentError>>;
};

export type UpdateDiscountProfileError = MyEntityNotFoundError | PropertyValidationError;

export type UpdateDiscountProfileInput = {
  entries: Array<DiscountProfileEntryInput>;
  id: Scalars['ID']['input'];
  maxDueDate: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type UpdateDiscountProfilePayload = {
  __typename?: 'UpdateDiscountProfilePayload';
  discountProfile?: Maybe<DiscountProfile>;
  errors?: Maybe<Array<UpdateDiscountProfileError>>;
};

export type UpdateDocumentDraftError = DomainError | PropertyValidationError;

export type UpdateDocumentDraftInput = {
  document: ModifyInvoiceInput;
  documentId: Scalars['String']['input'];
  settlesInvoiceId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateDocumentDraftPayload = {
  __typename?: 'UpdateDocumentDraftPayload';
  commercialDocument?: Maybe<CommercialDocument>;
  errors?: Maybe<Array<UpdateDocumentDraftError>>;
};

export type UpdateDunningLevelError = MyEntityNotFoundError | PropertyValidationError;

export type UpdateDunningLevelInput = {
  feeAmount: Scalars['Decimal']['input'];
  feeCurrency: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  paymentDays: Scalars['Int']['input'];
};

export type UpdateDunningLevelPayload = {
  __typename?: 'UpdateDunningLevelPayload';
  dunningLevel?: Maybe<DunningLevel>;
  errors?: Maybe<Array<UpdateDunningLevelError>>;
};

export type UpdateEmailError = MyEntityNotFoundError | PropertyValidationError;

export type UpdateEmailInput = {
  bccRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  body: Scalars['String']['input'];
  ccRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  emailId: Scalars['ID']['input'];
  recipients: Array<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  type: EmailType;
};

export type UpdateEmailPayload = {
  __typename?: 'UpdateEmailPayload';
  email?: Maybe<Email>;
  errors?: Maybe<Array<UpdateEmailError>>;
};

export type UpdateEmployeeWorkingConditionError = DomainError | EntityNotFoundError | PropertyValidationError;

export type UpdateEmployeeWorkingConditionInput = {
  contactId: Scalars['ID']['input'];
  federalCode: Scalars['String']['input'];
  from: Scalars['LocalDate']['input'];
  to?: InputMaybe<Scalars['LocalDate']['input']>;
  workingConditionId: Scalars['ID']['input'];
  workingTimeModelId: Scalars['ID']['input'];
};

export type UpdateEmployeeWorkingConditionPayload = {
  __typename?: 'UpdateEmployeeWorkingConditionPayload';
  employeeWorkingConditionInformation?: Maybe<EmployeeWorkingConditionInformation>;
  errors?: Maybe<Array<UpdateEmployeeWorkingConditionError>>;
};

export type UpdateFileEntryError = InvalidEntityIdError | PropertyValidationError;

export type UpdateFileEntryInput = {
  file: Scalars['Upload']['input'];
  folderPath: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateFileEntryPayload = {
  __typename?: 'UpdateFileEntryPayload';
  errors?: Maybe<Array<UpdateFileEntryError>>;
  fileEntry?: Maybe<FileEntry>;
};

export type UpdateMailboxContactError = DomainError | PropertyValidationError;

export type UpdateMailboxContactInput = {
  contactNumber: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateMailboxContactPayload = {
  __typename?: 'UpdateMailboxContactPayload';
  contact?: Maybe<Contact>;
  errors?: Maybe<Array<UpdateMailboxContactError>>;
};

export type UpdateMetadataInput = {
  entityId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
};

export type UpdateMetadataPayload = {
  __typename?: 'UpdateMetadataPayload';
  catalogEntry?: Maybe<CatalogEntry>;
};

export type UpdateMyDayProjectTimeEntryError = DomainError | PropertyValidationError;

export type UpdateMyDayProjectTimeEntryInput = {
  date: Scalars['LocalDate']['input'];
  projectId: Scalars['ID']['input'];
  timeEntries: Array<UpsertProjectTimeEntryInput>;
};

export type UpdateMyDayProjectTimeEntryPayload = {
  __typename?: 'UpdateMyDayProjectTimeEntryPayload';
  errors?: Maybe<Array<UpdateMyDayProjectTimeEntryError>>;
  projectTimeEntryDayGroup?: Maybe<ProjectTimeEntryDayGroup>;
};

export type UpdateMyDayTimeEntryError = DomainError | PropertyValidationError;

export type UpdateMyDayTimeEntryInput = {
  date: Scalars['LocalDate']['input'];
  timeEntries: Array<UpsertTimeEntryInput>;
};

export type UpdateMyDayTimeEntryPayload = {
  __typename?: 'UpdateMyDayTimeEntryPayload';
  errors?: Maybe<Array<UpdateMyDayTimeEntryError>>;
  timeEntryDayGroup?: Maybe<TimeEntryDayGroup>;
};

export type UpdateMyPaymentConditionError = DomainError | PropertyValidationError;

export type UpdateMyPaymentConditionInput = {
  contactId: Scalars['ID']['input'];
  contactInformationId: Scalars['ID']['input'];
  selectedEntryId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateMyPaymentConditionPayload = {
  __typename?: 'UpdateMyPaymentConditionPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<UpdateMyPaymentConditionError>>;
};

export type UpdatePaymentConditionInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type UpdatePaymentConditionInformationInput = {
  contactId: Scalars['ID']['input'];
  discountProfileId?: InputMaybe<VersionedDiscountProfileIdInput>;
  doesNotParticipateInVoucherProcess: Scalars['Boolean']['input'];
  paymentInformationId: Scalars['ID']['input'];
  selectedEntryId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePaymentConditionInformationPayload = {
  __typename?: 'UpdatePaymentConditionInformationPayload';
  errors?: Maybe<Array<UpdatePaymentConditionInformationError>>;
  paymentConditionInformation?: Maybe<PaymentConditionInformation>;
};

export type UpdatePaymentInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type UpdatePaymentInformationInput = {
  contactId: Scalars['ID']['input'];
  paymentDeadlineInDays?: InputMaybe<Scalars['Int']['input']>;
  paymentInformationId: Scalars['ID']['input'];
  routeId?: InputMaybe<Scalars['String']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaymentInformationPayload = {
  __typename?: 'UpdatePaymentInformationPayload';
  errors?: Maybe<Array<UpdatePaymentInformationError>>;
  paymentInformation?: Maybe<PaymentInformation>;
};

export type UpdatePersonContactError = DomainError | PropertyValidationError;

export type UpdatePersonContactInput = {
  contactNumber: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  lastName: Scalars['String']['input'];
  salutation: SalutationType;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePersonContactPayload = {
  __typename?: 'UpdatePersonContactPayload';
  contact?: Maybe<Contact>;
  errors?: Maybe<Array<UpdatePersonContactError>>;
};

export type UpdatePhoneInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type UpdatePhoneInformationInput = {
  contactId: Scalars['ID']['input'];
  contactInformationId: Scalars['ID']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  phoneType: PhoneType;
};

export type UpdatePhoneInformationPayload = {
  __typename?: 'UpdatePhoneInformationPayload';
  errors?: Maybe<Array<UpdatePhoneInformationError>>;
  phoneInformation?: Maybe<PhoneInformation>;
};

export type UpdateProjectActiveStatusError = DomainError | PropertyValidationError;

export type UpdateProjectActiveStatusInput = {
  isDeleted: Scalars['Boolean']['input'];
  projectId: Scalars['ID']['input'];
};

export type UpdateProjectActiveStatusPayload = {
  __typename?: 'UpdateProjectActiveStatusPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<UpdateProjectActiveStatusError>>;
};

export type UpdateProjectAdditionalAccountingInformationError = DomainError | PropertyValidationError;

export type UpdateProjectAdditionalAccountingInformationInput = {
  accountingProfileId?: InputMaybe<Scalars['ID']['input']>;
  clientContractNumber?: InputMaybe<Scalars['String']['input']>;
  clientContratDate?: InputMaybe<Scalars['LocalDate']['input']>;
  clientOrderingDate?: InputMaybe<Scalars['LocalDate']['input']>;
  clientOrderingNumber?: InputMaybe<Scalars['String']['input']>;
  clientProjectNumber?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  projectInformationId: Scalars['ID']['input'];
  provision?: InputMaybe<Scalars['Decimal']['input']>;
  provisionDescription?: InputMaybe<Scalars['String']['input']>;
  supplierProjectNumber?: InputMaybe<Scalars['String']['input']>;
  timeTrackingResolution: Scalars['Int']['input'];
};

export type UpdateProjectAdditionalAccountingInformationPayload = {
  __typename?: 'UpdateProjectAdditionalAccountingInformationPayload';
  additionalAccountingInformation?: Maybe<AdditionalAccountingInformation>;
  errors?: Maybe<Array<UpdateProjectAdditionalAccountingInformationError>>;
};

export type UpdateProjectAdditionalContactInformationError = DomainError | PropertyValidationError;

export type UpdateProjectAdditionalContactInformationInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  contractorId: Scalars['ID']['input'];
  endCustomer?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  projectInformationId: Scalars['ID']['input'];
};

export type UpdateProjectAdditionalContactInformationPayload = {
  __typename?: 'UpdateProjectAdditionalContactInformationPayload';
  additionalContactInformation?: Maybe<AdditionalContactInformation>;
  errors?: Maybe<Array<UpdateProjectAdditionalContactInformationError>>;
};

export type UpdateProjectAdditionalContactPersonInformationError = DomainError | PropertyValidationError;

export type UpdateProjectAdditionalContactPersonInformationInput = {
  clientContactPersonId?: InputMaybe<Scalars['ID']['input']>;
  contractorContactPersonId?: InputMaybe<Scalars['ID']['input']>;
  contractorProjectLeaderId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  projectInformationId: Scalars['ID']['input'];
};

export type UpdateProjectAdditionalContactPersonInformationPayload = {
  __typename?: 'UpdateProjectAdditionalContactPersonInformationPayload';
  additionalContactPersonInformation?: Maybe<AdditionalContactPersonInformation>;
  errors?: Maybe<Array<UpdateProjectAdditionalContactPersonInformationError>>;
};

export type UpdateProjectAdditionalPositionInformationError = DomainError | PropertyValidationError;

export type UpdateProjectAdditionalPositionInformationInput = {
  accountingProfileId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hours?: InputMaybe<Scalars['Decimal']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  pricePerHour?: InputMaybe<Scalars['Decimal']['input']>;
  priceRate?: InputMaybe<ProjectPositionPriceRateType>;
  projectId: Scalars['ID']['input'];
  projectInformationId: Scalars['ID']['input'];
  projectSaleableServiceId: Scalars['String']['input'];
  serviceName: Scalars['String']['input'];
  servicePrice: Scalars['Decimal']['input'];
};

export type UpdateProjectAdditionalPositionInformationPayload = {
  __typename?: 'UpdateProjectAdditionalPositionInformationPayload';
  additionalPositionInformation?: Maybe<AdditionalPositionInformation>;
  errors?: Maybe<Array<UpdateProjectAdditionalPositionInformationError>>;
};

export type UpdateProjectAdditionalTeamMemberInformationError = DomainError | PropertyValidationError;

export type UpdateProjectAdditionalTeamMemberInformationInput = {
  contractorId?: InputMaybe<Scalars['ID']['input']>;
  memberId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  projectInformationId: Scalars['ID']['input'];
  worksOnPositions: Array<WorksOnPositionInput>;
};

export type UpdateProjectAdditionalTeamMemberInformationPayload = {
  __typename?: 'UpdateProjectAdditionalTeamMemberInformationPayload';
  additionalTeamMemberInformation?: Maybe<AdditionalTeamMemberInformation>;
  errors?: Maybe<Array<UpdateProjectAdditionalTeamMemberInformationError>>;
};

export type UpdateProjectAdditionalTemplateInformationError = DomainError | PropertyValidationError;

export type UpdateProjectAdditionalTemplateInformationInput = {
  isDetailTimesheet: Scalars['Boolean']['input'];
  isInvoiceWithTimesheet: Scalars['Boolean']['input'];
  projectId: Scalars['ID']['input'];
  projectInformationId: Scalars['ID']['input'];
};

export type UpdateProjectAdditionalTemplateInformationPayload = {
  __typename?: 'UpdateProjectAdditionalTemplateInformationPayload';
  additionalTemplateInformation?: Maybe<AdditionalTemplateInformation>;
  errors?: Maybe<Array<UpdateProjectAdditionalTemplateInformationError>>;
};

export type UpdateProjectError = DomainError | PropertyValidationError;

export type UpdateProjectInput = {
  budget: BudgetInput;
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  range: DateOnlyRangeInput;
};

export type UpdateProjectPayload = {
  __typename?: 'UpdateProjectPayload';
  errors?: Maybe<Array<UpdateProjectError>>;
  project?: Maybe<Project>;
};

export type UpdateProjectSaleableServiceError = DomainError | PropertyValidationError;

export type UpdateProjectSaleableServiceGroupError = DomainError | PropertyValidationError;

export type UpdateProjectSaleableServiceGroupInput = {
  budget: BudgetInput;
  hasFixSellingPrice: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  originalGroupId: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  projectSaleableServiceGroupId: Scalars['ID']['input'];
  sellingPrice: Scalars['Decimal']['input'];
};

export type UpdateProjectSaleableServiceGroupPayload = {
  __typename?: 'UpdateProjectSaleableServiceGroupPayload';
  errors?: Maybe<Array<UpdateProjectSaleableServiceGroupError>>;
  projectSaleableServiceGroup?: Maybe<ProjectSaleableServiceGroup>;
};

export type UpdateProjectSaleableServiceInput = {
  budget: BudgetInput;
  hasFixSellingPrice: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  originalServiceId: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  projectSaleableServiceGroupId: Scalars['ID']['input'];
  projectSaleableServiceId: Scalars['ID']['input'];
  projectSaleableUnitId: Scalars['ID']['input'];
  purchasePrice: Scalars['Decimal']['input'];
  sellingPrice: Scalars['Decimal']['input'];
  vatRate: Scalars['Decimal']['input'];
};

export type UpdateProjectSaleableServicePayload = {
  __typename?: 'UpdateProjectSaleableServicePayload';
  errors?: Maybe<Array<UpdateProjectSaleableServiceError>>;
  projectSaleableService?: Maybe<ProjectSaleableService>;
};

export type UpdateProjectSaleableUnitError = DomainError | PropertyValidationError;

export type UpdateProjectSaleableUnitInput = {
  name: Scalars['String']['input'];
  originalUnitId: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  projectSaleableUnitId: Scalars['ID']['input'];
  shortCode: Scalars['String']['input'];
};

export type UpdateProjectSaleableUnitPayload = {
  __typename?: 'UpdateProjectSaleableUnitPayload';
  errors?: Maybe<Array<UpdateProjectSaleableUnitError>>;
  projectSaleableUnit?: Maybe<ProjectSaleableUnit>;
};

export type UpdateProjectStatusError = DomainError | PropertyValidationError;

export type UpdateProjectStatusInput = {
  newStatus: ProjectStatus;
  projectId: Scalars['ID']['input'];
};

export type UpdateProjectStatusPayload = {
  __typename?: 'UpdateProjectStatusPayload';
  errors?: Maybe<Array<UpdateProjectStatusError>>;
  project?: Maybe<Project>;
};

export type UpdateRollingNumberError = MyEntityNotFoundError | PropertyValidationError;

export type UpdateRollingNumberInput = {
  contactId?: InputMaybe<Scalars['ID']['input']>;
  digitCount: Scalars['Int']['input'];
  format: Scalars['String']['input'];
  type: RollingNumberType;
  value: Scalars['Int']['input'];
};

export type UpdateRollingNumberPayload = {
  __typename?: 'UpdateRollingNumberPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<UpdateRollingNumberError>>;
};

export type UpdateSalaryInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type UpdateSalaryInformationInput = {
  contactId: Scalars['ID']['input'];
  informationId: Scalars['ID']['input'];
  pricePerHour: Scalars['Decimal']['input'];
  startDate: Scalars['LocalDate']['input'];
};

export type UpdateSalaryInformationPayload = {
  __typename?: 'UpdateSalaryInformationPayload';
  errors?: Maybe<Array<UpdateSalaryInformationError>>;
  salaryInformation?: Maybe<SalaryInformation>;
};

export type UpdateSaleableServiceError = DomainError | PropertyValidationError;

export type UpdateSaleableServiceGroupError = DomainError | PropertyValidationError;

export type UpdateSaleableServiceGroupInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  sellingPrice: Scalars['Decimal']['input'];
};

export type UpdateSaleableServiceGroupPayload = {
  __typename?: 'UpdateSaleableServiceGroupPayload';
  errors?: Maybe<Array<UpdateSaleableServiceGroupError>>;
  saleableServiceGroup?: Maybe<SaleableServiceGroup>;
};

export type UpdateSaleableServiceInput = {
  groupId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  purchasePrice: Scalars['Decimal']['input'];
  sellingPrice: Scalars['Decimal']['input'];
  unitId: Scalars['ID']['input'];
  vatRate: Scalars['Decimal']['input'];
};

export type UpdateSaleableServicePayload = {
  __typename?: 'UpdateSaleableServicePayload';
  errors?: Maybe<Array<UpdateSaleableServiceError>>;
  saleableService?: Maybe<SaleableService>;
};

export type UpdateSaleableUnitError = DomainError | PropertyValidationError;

export type UpdateSaleableUnitInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  shortCode: Scalars['String']['input'];
};

export type UpdateSaleableUnitPayload = {
  __typename?: 'UpdateSaleableUnitPayload';
  errors?: Maybe<Array<UpdateSaleableUnitError>>;
  saleableUnit?: Maybe<SaleableUnit>;
};

export type UpdateTemplateError = DomainError | PropertyValidationError;

export type UpdateTemplateInput = {
  content: Scalars['String']['input'];
  description: Scalars['String']['input'];
  footer?: InputMaybe<Scalars['String']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  masterPage?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  templateId: Scalars['ID']['input'];
  xmlPage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTemplatePayload = {
  __typename?: 'UpdateTemplatePayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<UpdateTemplateError>>;
};

export type UpdateTimeBalanceEntryError = ConcurrentAccessError | DomainError | PropertyValidationError;

export type UpdateTimeBalanceEntryInput = {
  date: Scalars['LocalDate']['input'];
  id: Scalars['ID']['input'];
  overtime?: InputMaybe<Scalars['TimeSpan']['input']>;
  reason: Scalars['String']['input'];
  type: TimeBalanceType;
  vacationDays?: InputMaybe<Scalars['Decimal']['input']>;
  version: Scalars['Long']['input'];
};

export type UpdateTimeBalanceEntryPayload = {
  __typename?: 'UpdateTimeBalanceEntryPayload';
  errors?: Maybe<Array<UpdateTimeBalanceEntryError>>;
  timeBalanceEntry?: Maybe<TimeBalanceEntry>;
};

export type UpdateTimeLabelError = ConcurrentAccessError | DomainError | PropertyValidationError;

export type UpdateTimeLabelGroupError = ConcurrentAccessError | DomainError | PropertyValidationError;

export type UpdateTimeLabelGroupInput = {
  id: Scalars['ID']['input'];
  isGlobal: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  version: Scalars['Long']['input'];
};

export type UpdateTimeLabelGroupPayload = {
  __typename?: 'UpdateTimeLabelGroupPayload';
  errors?: Maybe<Array<UpdateTimeLabelGroupError>>;
  timeLabelGroup?: Maybe<TimeLabelGroup>;
};

export type UpdateTimeLabelInput = {
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  version: Scalars['Long']['input'];
};

export type UpdateTimeLabelPayload = {
  __typename?: 'UpdateTimeLabelPayload';
  errors?: Maybe<Array<UpdateTimeLabelError>>;
  timeLabel?: Maybe<TimeLabel>;
};

export type UpdateWebsiteInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type UpdateWebsiteInformationInput = {
  contactId: Scalars['ID']['input'];
  informationId: Scalars['ID']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWebsiteInformationPayload = {
  __typename?: 'UpdateWebsiteInformationPayload';
  errors?: Maybe<Array<UpdateWebsiteInformationError>>;
  websiteInformation?: Maybe<WebsiteInformation>;
};

export type UpdateWorkingConditionInformationError = DomainError | EntityNotFoundError | PropertyValidationError;

export type UpdateWorkingConditionInformationInput = {
  contactId: Scalars['ID']['input'];
  hoursPerFriday: Scalars['Decimal']['input'];
  hoursPerMonday: Scalars['Decimal']['input'];
  hoursPerSaturday: Scalars['Decimal']['input'];
  hoursPerSunday: Scalars['Decimal']['input'];
  hoursPerThursday: Scalars['Decimal']['input'];
  hoursPerTuesday: Scalars['Decimal']['input'];
  hoursPerWednesday: Scalars['Decimal']['input'];
  hoursPerWeek: Scalars['Decimal']['input'];
  informationId: Scalars['ID']['input'];
  isFlexible: Scalars['Boolean']['input'];
  startDate: Scalars['LocalDate']['input'];
};

export type UpdateWorkingConditionInformationPayload = {
  __typename?: 'UpdateWorkingConditionInformationPayload';
  errors?: Maybe<Array<UpdateWorkingConditionInformationError>>;
  workingConditionInformation?: Maybe<WorkingConditionInformation>;
};

export type UpdateWorkingTimeModelError = ConcurrentAccessError | DomainError | PropertyValidationError;

export type UpdateWorkingTimeModelInput = {
  description: Scalars['String']['input'];
  hoursPerFriday: Scalars['Decimal']['input'];
  hoursPerMonday: Scalars['Decimal']['input'];
  hoursPerSaturday: Scalars['Decimal']['input'];
  hoursPerSunday: Scalars['Decimal']['input'];
  hoursPerThursday: Scalars['Decimal']['input'];
  hoursPerTuesday: Scalars['Decimal']['input'];
  hoursPerWednesday: Scalars['Decimal']['input'];
  hoursPerWeek: Scalars['Decimal']['input'];
  id: Scalars['ID']['input'];
  isFlexible: Scalars['Boolean']['input'];
  isVisible: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  vacationDaysPerYear: Scalars['Decimal']['input'];
  version: Scalars['Long']['input'];
};

export type UpdateWorkingTimeModelPayload = {
  __typename?: 'UpdateWorkingTimeModelPayload';
  errors?: Maybe<Array<UpdateWorkingTimeModelError>>;
  workingTimeModel?: Maybe<WorkingTimeModel>;
};

/** Represents a multipart upload session */
export type UploadSession = {
  __typename?: 'UploadSession';
  /** MIME type of the file being uploaded */
  contentType?: Maybe<Scalars['String']['output']>;
  /** When the upload session was created */
  createdAt: Scalars['DateTime']['output'];
  /** The entity (project, contact, etc.) that owns this upload session */
  entityId: Scalars['String']['output'];
  /** When the upload session expires */
  expiresAt: Scalars['DateTime']['output'];
  /** Unique identifier for the upload session */
  id: Scalars['ID']['output'];
  /** Full path where the file will be stored */
  path: Scalars['String']['output'];
  /** JSON string containing information about received parts */
  receivedParts?: Maybe<Scalars['String']['output']>;
  /** Current state of the upload session: INITIATED, IN_PROGRESS, COMPLETED, or ABORTED */
  state: UploadSessionState;
  /** Total size of the file being uploaded in bytes */
  totalSize: Scalars['Long']['output'];
  /** The multipart upload ID from S3/MinIO */
  uploadId: Scalars['String']['output'];
};

export enum UploadSessionState {
  Aborted = 'ABORTED',
  Completed = 'COMPLETED',
  Initiated = 'INITIATED',
  InProgress = 'IN_PROGRESS'
}

export type UploadSmallInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  file?: InputMaybe<Scalars['Upload']['input']>;
  fileBase64?: InputMaybe<Scalars['String']['input']>;
  filePath: Scalars['String']['input'];
  isTemp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UploadSmallPayload = {
  __typename?: 'UploadSmallPayload';
  catalogEntry?: Maybe<CatalogEntry>;
};

export type UpsertProjectTimeEntryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['DateTime']['input'];
  projectPositionId: Scalars['ID']['input'];
  projectTimeEntryId?: InputMaybe<Scalars['ID']['input']>;
  start: Scalars['DateTime']['input'];
};

export type UpsertSubstituteInput = {
  absenceId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
  willRepresentEmployeeId: Scalars['ID']['input'];
};

export type UpsertSubstitutePayload = {
  __typename?: 'UpsertSubstitutePayload';
  substitute?: Maybe<Substitute>;
};

export type UpsertTimeEntryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['DateTime']['input'];
  entryType: TimeEntryType;
  start: Scalars['DateTime']['input'];
  timeEntryId?: InputMaybe<Scalars['ID']['input']>;
  timeLabelId?: InputMaybe<Scalars['ID']['input']>;
  workLocation: WorkLocation;
};

export type User = Node & {
  __typename?: 'User';
  contactId?: Maybe<Scalars['ID']['output']>;
  contractorId?: Maybe<Scalars['ID']['output']>;
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  groups: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  userGuid?: Maybe<Scalars['UUID']['output']>;
  username: Scalars['String']['output'];
};

export type UserAddLoginError = InvalidUserPrivilegesError | KeyCloakError;

export type UserAddLoginInput = {
  clientId: Scalars['String']['input'];
  contactId: Scalars['ID']['input'];
  contractorId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  groupIds: Array<Scalars['ID']['input']>;
  isMultiContractor?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  sendVerificationEmail: Scalars['Boolean']['input'];
  username: Scalars['String']['input'];
};

export type UserAddLoginPayload = {
  __typename?: 'UserAddLoginPayload';
  errors?: Maybe<Array<UserAddLoginError>>;
  user?: Maybe<User>;
};

export type UserChangeGroupsError = InvalidUserPrivilegesError | KeyCloakError;

export type UserChangeGroupsInput = {
  groupIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type UserChangeGroupsPayload = {
  __typename?: 'UserChangeGroupsPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<UserChangeGroupsError>>;
};

export type UserGroup = Node & {
  __typename?: 'UserGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UserInfo = {
  __typename?: 'UserInfo';
  contactId?: Maybe<Scalars['ID']['output']>;
  contractorId?: Maybe<Scalars['ID']['output']>;
  displayName: Scalars['String']['output'];
  groups: Array<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type UserRemoveLoginError = InvalidUserPrivilegesError | KeyCloakError;

export type UserRemoveLoginInput = {
  userId: Scalars['ID']['input'];
};

export type UserRemoveLoginPayload = {
  __typename?: 'UserRemoveLoginPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<UserRemoveLoginError>>;
};

export type UserSetEnabledError = InvalidUserPrivilegesError | KeyCloakError;

export type UserSetEnabledInput = {
  enabled: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};

export type UserSetEnabledPayload = {
  __typename?: 'UserSetEnabledPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<UserSetEnabledError>>;
};

export type UserSubstitutesResult = {
  __typename?: 'UserSubstitutesResult';
  substitutes: Array<Scalars['ID']['output']>;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

export type VacationCheckResult = {
  __typename?: 'VacationCheckResult';
  canBeTaken: Scalars['Boolean']['output'];
  hasDelegateDuties: Scalars['Boolean']['output'];
  isInSameYear: Scalars['Boolean']['output'];
  isOverlapping: Scalars['Boolean']['output'];
  leftDays: Scalars['Decimal']['output'];
  neededDays: Scalars['Decimal']['output'];
  startDateIsTooClose: Scalars['Boolean']['output'];
};

export type VacationSummary = {
  __typename?: 'VacationSummary';
  inPending: Scalars['Decimal']['output'];
  planned: Scalars['Decimal']['output'];
  taken: Scalars['Decimal']['output'];
  total: Scalars['Decimal']['output'];
};

export type ValidateAllProjectsPayload = {
  __typename?: 'ValidateAllProjectsPayload';
  int?: Maybe<Scalars['Int']['output']>;
};

export enum ValidationStatus {
  Invalid = 'INVALID',
  Valid = 'VALID'
}

export type VersionedDiscountProfileId = {
  __typename?: 'VersionedDiscountProfileId';
  id: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
};

export type VersionedDiscountProfileIdInput = {
  id: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};

export type WebsiteInformation = ContactAdditionalInformation & {
  __typename?: 'WebsiteInformation';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export enum WorkLocation {
  ClientSide = 'CLIENT_SIDE',
  Office = 'OFFICE'
}

export type WorkTimeSummary = {
  __typename?: 'WorkTimeSummary';
  approvedMinutes: Scalars['Int']['output'];
  balanceMinutes: Scalars['Int']['output'];
  pendingMinutes: Scalars['Int']['output'];
  rejectedMinutes: Scalars['Int']['output'];
  requiredMinutes: Scalars['Int']['output'];
  totalMinutes: Scalars['Int']['output'];
};

export type WorkingConditionInformation = ContactAdditionalInformation & {
  __typename?: 'WorkingConditionInformation';
  hoursPerFriday: Scalars['Decimal']['output'];
  hoursPerMonday: Scalars['Decimal']['output'];
  hoursPerSaturday: Scalars['Decimal']['output'];
  hoursPerSunday: Scalars['Decimal']['output'];
  hoursPerThursday: Scalars['Decimal']['output'];
  hoursPerTuesday: Scalars['Decimal']['output'];
  hoursPerWednesday: Scalars['Decimal']['output'];
  hoursPerWeek: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  isFlexible: Scalars['Boolean']['output'];
  startDate: Scalars['LocalDate']['output'];
};

export type WorkingTimeModel = Node & {
  __typename?: 'WorkingTimeModel';
  description: Scalars['String']['output'];
  hoursPerFriday: Scalars['Decimal']['output'];
  hoursPerMonday: Scalars['Decimal']['output'];
  hoursPerSaturday: Scalars['Decimal']['output'];
  hoursPerSunday: Scalars['Decimal']['output'];
  hoursPerThursday: Scalars['Decimal']['output'];
  hoursPerTuesday: Scalars['Decimal']['output'];
  hoursPerWednesday: Scalars['Decimal']['output'];
  hoursPerWeek: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isFlexible: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  requiredWorkingHours: Scalars['Decimal']['output'];
  vacationDaysPerYear: Scalars['Decimal']['output'];
  version: Scalars['Long']['output'];
};


export type WorkingTimeModelRequiredWorkingHoursArgs = {
  date: Scalars['LocalDate']['input'];
};

export type WorksInDepartmentError = DomainError | EntityNotFoundError | PropertyValidationError;

export type WorksInDepartmentInformation = ContactAdditionalInformation & {
  __typename?: 'WorksInDepartmentInformation';
  departmentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type WorksInDepartmentInput = {
  contactId: Scalars['ID']['input'];
  departmentId: Scalars['ID']['input'];
};

export type WorksInDepartmentPayload = {
  __typename?: 'WorksInDepartmentPayload';
  errors?: Maybe<Array<WorksInDepartmentError>>;
  worksInDepartmentInformation?: Maybe<WorksInDepartmentInformation>;
};

export type WorksOnPosition = {
  __typename?: 'WorksOnPosition';
  hours?: Maybe<Scalars['Decimal']['output']>;
  positionId: Scalars['ID']['output'];
  pricePerHour?: Maybe<Scalars['Decimal']['output']>;
};

export type WorksOnPositionInput = {
  hours?: InputMaybe<Scalars['Decimal']['input']>;
  positionId: Scalars['ID']['input'];
  pricePerHour?: InputMaybe<Scalars['Decimal']['input']>;
};

export type XmlValidationResult = {
  __typename?: 'XmlValidationResult';
  errors: Array<InvoiceValidationError>;
  isValid: Scalars['Boolean']['output'];
};

export type AddMemberMutationVariables = Exact<{
  memberId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
}>;


export type AddMemberMutation = { __typename?: 'Mutation', addMember: { __typename?: 'AddMemberPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type ContactsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ContactsByIdsQuery = { __typename?: 'Query', contactsByIds: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number, isTemporary: boolean, additionalInformation: Array<{ __typename: 'AddressInformation', type: AddressType, name: string, city: string, country: string, id: string, state: string, street: string, zipCode: string } | { __typename: 'BillingInformation', id: string, isSameAsShippingAddress: boolean, name: string, shippingAddress: { __typename?: 'Address', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string }, billingAddress: { __typename?: 'Address', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string }, bankAccount: { __typename?: 'BankAccount', bankName?: string | null, bic?: string | null, clientReference?: string | null, clientReferenceDate?: string | null, iban?: string | null } } | { __typename: 'ContactPersonInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | { __typename: 'ContractedInformation', contractedId: string, id: string, marge: number } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', departmentName: string, id: string } | { __typename: 'EmailInformation', emailAddress: string, emailType: EmailType, id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string, taxNumber: string } | { __typename: 'PhoneInformation', id: string, number: string, phoneType: PhoneType } | { __typename: 'SalaryInformation', id: string, pricePerHour: number, startDate: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', hoursPerFriday: number, hoursPerMonday: number, hoursPerSaturday: number, hoursPerSunday: number, hoursPerThursday: number, hoursPerTuesday: number, hoursPerWednesday: number, hoursPerWeek: number, id: string, isFlexible: boolean, startDate: string } | { __typename: 'WorksInDepartmentInformation', id: string }> }> };

export type ContractedCompaniesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ContractedCompaniesByIdsQuery = { __typename?: 'Query', contactsByIds: Array<{ __typename?: 'Contact', displayName: string, id: string }> };

export type CreateBillingInformationMutationVariables = Exact<{
  bankAccount: BankAccountInput;
  billingAddress: AddressInput;
  contactId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  shippingAddress: AddressInput;
}>;


export type CreateBillingInformationMutation = { __typename?: 'Mutation', createBillingInformation: { __typename?: 'CreateBillingInformationPayload', errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, billingInformation?: { __typename?: 'BillingInformation', id: string, isSameAsShippingAddress: boolean, name: string, bankAccount: { __typename?: 'BankAccount', bankName?: string | null, bic?: string | null, clientReference?: string | null, clientReferenceDate?: string | null, iban?: string | null }, billingAddress: { __typename?: 'Address', type: AddressType, name: string, street: string, zipCode: string, city: string, state: string, country: string }, shippingAddress: { __typename?: 'Address', type: AddressType, name: string, street: string, zipCode: string, city: string, state: string, country: string } } | null } };

export type CreateCompanyContactMutationVariables = Exact<{
  companyName: Scalars['String']['input'];
  contactType: ContactType;
}>;


export type CreateCompanyContactMutation = { __typename?: 'Mutation', createCompanyContact: { __typename?: 'CreateCompanyContactPayload', contact?: { __typename?: 'Contact', displayName: string, id: string } | null, errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type CreateContactAddressMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  type?: AddressType;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateContactAddressMutation = { __typename?: 'Mutation', createContactAddress: { __typename?: 'CreateContactAddressPayload', addressInformation?: { __typename?: 'AddressInformation', type: AddressType, name: string, street: string, zipCode: string, city: string, state: string, country: string } | null, errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type CreateContactEmailMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  emailAddress: Scalars['String']['input'];
  emailType: EmailType;
}>;


export type CreateContactEmailMutation = { __typename?: 'Mutation', createContactEmail: { __typename?: 'CreateContactEmailPayload', errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, emailInformation?: { __typename?: 'EmailInformation', emailAddress: string, emailType: EmailType, id: string } | null } };

export type CreateContactPersonInformationMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  contactPersonId: Scalars['ID']['input'];
  contactUsage: Array<ContactUsage> | ContactUsage;
}>;


export type CreateContactPersonInformationMutation = { __typename?: 'Mutation', createContactPersonInformation: { __typename?: 'CreateContactPersonInformationPayload', errors?: Array<{ __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, contactPersonInformation?: { __typename?: 'ContactPersonInformation', contactUsage: Array<ContactUsage>, id: string, contactPersonId: string } | null } };

export type CreateContractedInformationMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  contractedId: Scalars['ID']['input'];
  margin: Scalars['Decimal']['input'];
}>;


export type CreateContractedInformationMutation = { __typename?: 'Mutation', createContractedInformation: { __typename?: 'CreateContractedInformationPayload', contractedInformation?: { __typename?: 'ContractedInformation', contractedId: string, id: string, marge: number } | null, errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type CreateDateInformationMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  dateType: PersonDateType;
}>;


export type CreateDateInformationMutation = { __typename?: 'Mutation', createDateInformation: { __typename?: 'CreateDateInformationPayload', errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, dateInformation?: { __typename?: 'DateInformation', date?: string | null, id: string, personDateType: PersonDateType } | null } };

export type CreateDepartmentInformationMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  departmentName?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateDepartmentInformationMutation = { __typename?: 'Mutation', createDepartmentInformation: { __typename?: 'CreateDepartmentInformationPayload', errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, departmentInformation?: { __typename?: 'DepartmentInformation', departmentName: string, id: string } | null } };

export type CreateInternalWorkingConditionMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  from: Scalars['LocalDate']['input'];
  federalCode: Scalars['String']['input'];
  workingTimeModelId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['LocalDate']['input']>;
}>;


export type CreateInternalWorkingConditionMutation = { __typename?: 'Mutation', createEmployeeWorkingCondition: { __typename?: 'CreateEmployeeWorkingConditionPayload', errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, employeeWorkingConditionInformation?: { __typename: 'EmployeeWorkingConditionInformation', id: string, federalLocation: string, from: string, to: string, workingTimeModelId: string, workingTimeModel?: { __typename?: 'WorkingTimeModel', id: string, name: string } | null } | null } };

export type CreateIsContactPersonInformationMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  contactPersonId: Scalars['ID']['input'];
  contactUsage: Array<ContactUsage> | ContactUsage;
}>;


export type CreateIsContactPersonInformationMutation = { __typename?: 'Mutation', createContactPersonInformation: { __typename?: 'CreateContactPersonInformationPayload', errors?: Array<{ __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, contactPersonInformation?: { __typename?: 'ContactPersonInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | null } };

export type CreateMailboxContactMutationVariables = Exact<{
  name: Scalars['String']['input'];
  memberOfCompanyId: Scalars['ID']['input'];
}>;


export type CreateMailboxContactMutation = { __typename?: 'Mutation', createMailboxContact: { __typename?: 'CreateMailboxContactPayload', contact?: { __typename?: 'Contact', id: string, displayName: string, companyName: string, contactNumber: string, contactTypes: Array<ContactType>, additionalInformation: Array<{ __typename: 'AddressInformation', id: string } | { __typename: 'BillingInformation', id: string } | { __typename: 'ContactPersonInformation', id: string } | { __typename: 'ContractedInformation', id: string } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', id: string } | { __typename: 'EmailInformation', emailAddress: string, emailType: EmailType, id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string } | { __typename: 'PhoneInformation', id: string } | { __typename: 'SalaryInformation', id: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', id: string } | { __typename: 'WorksInDepartmentInformation', id: string }> } | null, errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type CreatePaymentConditionInformationMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  discountProfileId: VersionedDiscountProfileIdInput;
  selectedEntryId: Scalars['ID']['input'];
  doesNotParticipateInVoucherProcess: Scalars['Boolean']['input'];
}>;


export type CreatePaymentConditionInformationMutation = { __typename?: 'Mutation', createPaymentConditionInformation: { __typename?: 'CreatePaymentConditionInformationPayload', errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, paymentConditionInformation?: { __typename?: 'PaymentConditionInformation', id: string, selectedEntryId?: string | null, doesNotParticipateInVoucherProcess: boolean, discountProfileId?: { __typename?: 'VersionedDiscountProfileId', id: string, version: number } | null } | null } };

export type CreatePaymentInformationMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  taxNumber: Scalars['String']['input'];
  paymentDeadlineInDays?: InputMaybe<Scalars['Int']['input']>;
  routeId?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePaymentInformationMutation = { __typename?: 'Mutation', createPaymentInformation: { __typename?: 'CreatePaymentInformationPayload', errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, paymentInformation?: { __typename?: 'PaymentInformation', id: string, taxNumber: string, paymentDeadlineInDays?: number | null, routeId: string, vatId: string } | null } };

export type CreatePersonContactMutationVariables = Exact<{
  contactType: ContactType;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  salutation: SalutationType;
  title?: InputMaybe<Scalars['String']['input']>;
  memberOfCompanyId: Scalars['ID']['input'];
  shortCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePersonContactMutation = { __typename?: 'Mutation', createPersonContact: { __typename?: 'CreatePersonContactPayload', contact?: { __typename?: 'Contact', id: string, displayName: string, firstName: string, lastName: string, salutation: SalutationType, title: string, contactNumber: string, contactTypes: Array<ContactType>, additionalInformation: Array<{ __typename: 'AddressInformation', id: string } | { __typename: 'BillingInformation', id: string } | { __typename: 'ContactPersonInformation', id: string } | { __typename: 'ContractedInformation', id: string } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', id: string } | { __typename: 'EmailInformation', emailAddress: string, emailType: EmailType, id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string, federalLocation: string, from: string, to: string, workingTimeModelId: string, workingTimeModel?: { __typename?: 'WorkingTimeModel', id: string, name: string } | null } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string } | { __typename: 'PhoneInformation', number: string, phoneType: PhoneType, id: string } | { __typename: 'SalaryInformation', pricePerHour: number, startDate: string, id: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', id: string } | { __typename: 'WorksInDepartmentInformation', id: string }> } | null, errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type CreatePhoneInformationMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  phoneType: PhoneType;
}>;


export type CreatePhoneInformationMutation = { __typename?: 'Mutation', createPhoneInformation: { __typename?: 'CreatePhoneInformationPayload', phoneInformation?: { __typename?: 'PhoneInformation', id: string, number: string, phoneType: PhoneType } | null, errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type CreateSalaryInformationMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  pricePerHour: Scalars['Decimal']['input'];
  startDate: Scalars['LocalDate']['input'];
}>;


export type CreateSalaryInformationMutation = { __typename?: 'Mutation', createSalaryInformation: { __typename?: 'CreateSalaryInformationPayload', errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, salaryInformation?: { __typename?: 'SalaryInformation', id: string, pricePerHour: number, startDate: string } | null } };

export type CreateTemporaryFreelancerMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  pricePerHour: Scalars['Decimal']['input'];
  salutation: SalutationType;
  title?: InputMaybe<Scalars['String']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateTemporaryFreelancerMutation = { __typename?: 'Mutation', createTemporaryFreelancer: { __typename?: 'CreateTemporaryFreelancerPayload', contact?: { __typename?: 'Contact', displayName: string, id: string } | null, errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type CreateWebsiteInformationMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateWebsiteInformationMutation = { __typename?: 'Mutation', createWebsiteInformation: { __typename?: 'CreateWebsiteInformationPayload', errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, websiteInformation?: { __typename?: 'WebsiteInformation', id: string, url: string } | null } };

export type CreateWorkingConditionInformationMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  hoursPerFriday: Scalars['Decimal']['input'];
  hoursPerMonday: Scalars['Decimal']['input'];
  hoursPerSaturday: Scalars['Decimal']['input'];
  hoursPerSunday: Scalars['Decimal']['input'];
  hoursPerThursday: Scalars['Decimal']['input'];
  hoursPerTuesday: Scalars['Decimal']['input'];
  hoursPerWednesday: Scalars['Decimal']['input'];
  hoursPerWeek: Scalars['Decimal']['input'];
  isFlexible: Scalars['Boolean']['input'];
  startDate: Scalars['LocalDate']['input'];
}>;


export type CreateWorkingConditionInformationMutation = { __typename?: 'Mutation', createWorkingConditionInformation: { __typename?: 'CreateWorkingConditionInformationPayload', errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, workingConditionInformation?: { __typename?: 'WorkingConditionInformation', hoursPerFriday: number, hoursPerMonday: number, hoursPerSaturday: number, hoursPerSunday: number, hoursPerThursday: number, hoursPerTuesday: number, hoursPerWednesday: number, hoursPerWeek: number, id: string, isFlexible: boolean, startDate: string } | null } };

export type DeleteAdditionalInformationMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  informationId: Scalars['ID']['input'];
}>;


export type DeleteAdditionalInformationMutation = { __typename?: 'Mutation', deleteAdditionalInformation: { __typename?: 'DeleteAdditionalInformationPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteMemberMutationVariables = Exact<{
  memberId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
}>;


export type DeleteMemberMutation = { __typename?: 'Mutation', deleteMember: { __typename?: 'DeleteMemberPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type GetAllClientsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllClientsQuery = { __typename?: 'Query', allContacts?: { __typename?: 'AllContactsConnection', totalCount: number, nodes?: Array<{ __typename: 'Contact', contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, id: string, displayName: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, additionalInformation: Array<{ __typename: 'AddressInformation', id: string } | { __typename: 'BillingInformation', id: string } | { __typename: 'ContactPersonInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | { __typename: 'ContractedInformation', id: string } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', id: string } | { __typename: 'EmailInformation', emailAddress: string, id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string } | { __typename: 'PhoneInformation', id: string } | { __typename: 'SalaryInformation', id: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', id: string } | { __typename: 'WorksInDepartmentInformation', id: string }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllCompaniesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllCompaniesQuery = { __typename?: 'Query', allContacts?: { __typename?: 'AllContactsConnection', totalCount: number, nodes?: Array<{ __typename: 'Contact', contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, id: string, displayName: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, additionalInformation: Array<{ __typename: 'AddressInformation', id: string } | { __typename: 'BillingInformation', id: string } | { __typename: 'ContactPersonInformation', id: string } | { __typename: 'ContractedInformation', id: string } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', id: string } | { __typename: 'EmailInformation', emailAddress: string, id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string } | { __typename: 'PhoneInformation', id: string } | { __typename: 'SalaryInformation', id: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', id: string } | { __typename: 'WorksInDepartmentInformation', id: string }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllContactNamesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<ContactType> | ContactType>;
  andTypes: Scalars['Boolean']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllContactNamesQuery = { __typename?: 'Query', allContacts?: { __typename?: 'AllContactsConnection', nodes?: Array<{ __typename?: 'Contact', id: string, displayName: string }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetAllContactNamesAndPriceQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<ContactType> | ContactType>;
  andTypes: Scalars['Boolean']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllContactNamesAndPriceQuery = { __typename?: 'Query', allContacts?: { __typename?: 'AllContactsConnection', nodes?: Array<{ __typename?: 'Contact', id: string, displayName: string, isAFreelancer: boolean, additionalInformation: Array<{ __typename: 'AddressInformation', id: string } | { __typename: 'BillingInformation', id: string } | { __typename: 'ContactPersonInformation', id: string } | { __typename: 'ContractedInformation', id: string } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', id: string } | { __typename: 'EmailInformation', id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string } | { __typename: 'PhoneInformation', id: string } | { __typename: 'SalaryInformation', pricePerHour: number, id: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', id: string } | { __typename: 'WorksInDepartmentInformation', id: string }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetAllContactsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllContactsQuery = { __typename?: 'Query', allContacts?: { __typename?: 'AllContactsConnection', totalCount: number, nodes?: Array<{ __typename: 'Contact', contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, id: string, displayName: string, firstName: string, lastName: string, companyName: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, additionalInformation: Array<{ __typename: 'AddressInformation', id: string } | { __typename: 'BillingInformation', id: string } | { __typename: 'ContactPersonInformation', id: string } | { __typename: 'ContractedInformation', id: string } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', id: string } | { __typename: 'EmailInformation', emailAddress: string, id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string } | { __typename: 'PhoneInformation', id: string } | { __typename: 'SalaryInformation', id: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', id: string } | { __typename: 'WorksInDepartmentInformation', id: string }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllContactsWithTypesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<ContactType> | ContactType>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllContactsWithTypesQuery = { __typename?: 'Query', allContacts?: { __typename?: 'AllContactsConnection', totalCount: number, nodes?: Array<{ __typename: 'Contact', contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, id: string, displayName: string, firstName: string, lastName: string, companyName: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, additionalInformation: Array<{ __typename: 'AddressInformation', id: string } | { __typename: 'BillingInformation', id: string } | { __typename: 'ContactPersonInformation', id: string } | { __typename: 'ContractedInformation', id: string } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', id: string } | { __typename: 'EmailInformation', emailAddress: string, id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string } | { __typename: 'PhoneInformation', id: string } | { __typename: 'SalaryInformation', id: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', id: string } | { __typename: 'WorksInDepartmentInformation', id: string }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllContractorsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllContractorsQuery = { __typename?: 'Query', allContacts?: { __typename?: 'AllContactsConnection', totalCount: number, nodes?: Array<{ __typename?: 'Contact', contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, id: string, displayName: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, additionalInformation: Array<{ __typename: 'AddressInformation', id: string } | { __typename: 'BillingInformation', id: string } | { __typename: 'ContactPersonInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | { __typename: 'ContractedInformation', contractedId: string, id: string, marge: number } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', id: string } | { __typename: 'EmailInformation', id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string } | { __typename: 'PhoneInformation', id: string } | { __typename: 'SalaryInformation', id: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', id: string } | { __typename: 'WorksInDepartmentInformation', id: string }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllEmployeesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  showTemporary?: InputMaybe<Scalars['Boolean']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllEmployeesQuery = { __typename?: 'Query', allEmployees?: { __typename?: 'AllEmployeesConnection', totalCount: number, nodes?: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number, additionalInformation: Array<{ __typename: 'AddressInformation', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string, id: string } | { __typename: 'BillingInformation', isSameAsShippingAddress: boolean, name: string, id: string, bankAccount: { __typename?: 'BankAccount', bankName?: string | null, bic?: string | null, clientReference?: string | null, clientReferenceDate?: string | null, iban?: string | null }, billingAddress: { __typename?: 'Address', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string }, shippingAddress: { __typename?: 'Address', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string } } | { __typename: 'ContactPersonInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | { __typename: 'ContractedInformation', contractedId: string, marge: number, id: string } | { __typename: 'DateInformation', date?: string | null, personDateType: PersonDateType, id: string } | { __typename: 'DepartmentInformation', departmentName: string, id: string } | { __typename: 'EmailInformation', emailAddress: string, emailType: EmailType, id: string } | { __typename: 'EmployeeWorkingConditionInformation', federalLocation: string, from: string, to: string, workingTimeModelId: string, id: string, workingTimeModel?: { __typename?: 'WorkingTimeModel', id: string, name: string } | null } | { __typename: 'IsContactPersonOfInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | { __typename: 'PaymentConditionInformation', id: string, selectedEntryId?: string | null, discountProfileId?: { __typename?: 'VersionedDiscountProfileId', id: string, version: number } | null } | { __typename: 'PaymentInformation', taxNumber: string, paymentDeadlineInDays?: number | null, routeId: string, vatId: string, id: string } | { __typename: 'PhoneInformation', number: string, phoneType: PhoneType, id: string } | { __typename: 'SalaryInformation', pricePerHour: number, startDate: string, id: string } | { __typename: 'WebsiteInformation', url: string, id: string } | { __typename: 'WorkingConditionInformation', hoursPerFriday: number, hoursPerMonday: number, hoursPerSaturday: number, hoursPerSunday: number, hoursPerThursday: number, hoursPerTuesday: number, hoursPerWednesday: number, hoursPerWeek: number, isFlexible: boolean, startDate: string, id: string } | { __typename: 'WorksInDepartmentInformation', departmentId: string, id: string }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllEmployeesOfContractorQueryVariables = Exact<{
  contractorId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  showTemporary?: InputMaybe<Scalars['Boolean']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllEmployeesOfContractorQuery = { __typename?: 'Query', allEmployeesOfContractor?: { __typename?: 'AllEmployeesOfContractorConnection', totalCount: number, nodes?: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number, additionalInformation: Array<{ __typename: 'AddressInformation', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string, id: string } | { __typename: 'BillingInformation', isSameAsShippingAddress: boolean, name: string, id: string, bankAccount: { __typename?: 'BankAccount', bankName?: string | null, bic?: string | null, clientReference?: string | null, clientReferenceDate?: string | null, iban?: string | null }, billingAddress: { __typename?: 'Address', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string }, shippingAddress: { __typename?: 'Address', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string } } | { __typename: 'ContactPersonInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | { __typename: 'ContractedInformation', contractedId: string, marge: number, id: string } | { __typename: 'DateInformation', date?: string | null, personDateType: PersonDateType, id: string } | { __typename: 'DepartmentInformation', departmentName: string, id: string } | { __typename: 'EmailInformation', emailAddress: string, emailType: EmailType, id: string } | { __typename: 'EmployeeWorkingConditionInformation', federalLocation: string, from: string, to: string, workingTimeModelId: string, id: string, workingTimeModel?: { __typename?: 'WorkingTimeModel', id: string, name: string } | null } | { __typename: 'IsContactPersonOfInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | { __typename: 'PaymentConditionInformation', id: string, selectedEntryId?: string | null, discountProfileId?: { __typename?: 'VersionedDiscountProfileId', id: string, version: number } | null } | { __typename: 'PaymentInformation', taxNumber: string, paymentDeadlineInDays?: number | null, routeId: string, vatId: string, id: string } | { __typename: 'PhoneInformation', number: string, phoneType: PhoneType, id: string } | { __typename: 'SalaryInformation', pricePerHour: number, startDate: string, id: string } | { __typename: 'WebsiteInformation', url: string, id: string } | { __typename: 'WorkingConditionInformation', hoursPerFriday: number, hoursPerMonday: number, hoursPerSaturday: number, hoursPerSunday: number, hoursPerThursday: number, hoursPerTuesday: number, hoursPerWednesday: number, hoursPerWeek: number, isFlexible: boolean, startDate: string, id: string } | { __typename: 'WorksInDepartmentInformation', departmentId: string, id: string }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllFreelancersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllFreelancersQuery = { __typename?: 'Query', allContacts?: { __typename?: 'AllContactsConnection', totalCount: number, nodes?: Array<{ __typename: 'Contact', contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, id: string, displayName: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, additionalInformation: Array<{ __typename: 'AddressInformation', id: string } | { __typename: 'BillingInformation', id: string } | { __typename: 'ContactPersonInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | { __typename: 'ContractedInformation', id: string } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', id: string } | { __typename: 'EmailInformation', emailAddress: string, id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string } | { __typename: 'PhoneInformation', id: string } | { __typename: 'SalaryInformation', id: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', id: string } | { __typename: 'WorksInDepartmentInformation', id: string }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllFreelancersAndEmployeesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllFreelancersAndEmployeesQuery = { __typename?: 'Query', allContacts?: { __typename?: 'AllContactsConnection', totalCount: number, nodes?: Array<{ __typename: 'Contact', contactNumber: string, contactTypes: Array<ContactType>, isAFreelancer: boolean, displayContactType: Array<ContactType>, id: string, displayName: string, additionalInformation: Array<{ __typename: 'AddressInformation', id: string } | { __typename: 'BillingInformation', id: string } | { __typename: 'ContactPersonInformation', id: string } | { __typename: 'ContractedInformation', id: string } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', id: string } | { __typename: 'EmailInformation', id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string } | { __typename: 'PhoneInformation', id: string } | { __typename: 'SalaryInformation', pricePerHour: number, id: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', id: string } | { __typename: 'WorksInDepartmentInformation', id: string }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllMembersOfQueryVariables = Exact<{
  contactId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  andTypes?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<ContactType> | ContactType>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllMembersOfQuery = { __typename?: 'Query', allMembersOf?: { __typename?: 'AllMembersOfConnection', totalCount: number, nodes?: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number, additionalInformation: Array<{ __typename: 'AddressInformation', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string, id: string } | { __typename: 'BillingInformation', isSameAsShippingAddress: boolean, name: string, id: string, bankAccount: { __typename?: 'BankAccount', bankName?: string | null, bic?: string | null, clientReference?: string | null, clientReferenceDate?: string | null, iban?: string | null }, billingAddress: { __typename?: 'Address', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string }, shippingAddress: { __typename?: 'Address', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string } } | { __typename: 'ContactPersonInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | { __typename: 'ContractedInformation', contractedId: string, marge: number, id: string } | { __typename: 'DateInformation', date?: string | null, personDateType: PersonDateType, id: string } | { __typename: 'DepartmentInformation', departmentName: string, id: string } | { __typename: 'EmailInformation', emailAddress: string, emailType: EmailType, id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | { __typename: 'PaymentConditionInformation', id: string, selectedEntryId?: string | null, discountProfileId?: { __typename?: 'VersionedDiscountProfileId', id: string, version: number } | null } | { __typename: 'PaymentInformation', taxNumber: string, paymentDeadlineInDays?: number | null, routeId: string, vatId: string, id: string } | { __typename: 'PhoneInformation', number: string, phoneType: PhoneType, id: string } | { __typename: 'SalaryInformation', pricePerHour: number, startDate: string, id: string } | { __typename: 'WebsiteInformation', url: string, id: string } | { __typename: 'WorkingConditionInformation', hoursPerFriday: number, hoursPerMonday: number, hoursPerSaturday: number, hoursPerSunday: number, hoursPerThursday: number, hoursPerTuesday: number, hoursPerWednesday: number, hoursPerWeek: number, isFlexible: boolean, startDate: string, id: string } | { __typename: 'WorksInDepartmentInformation', departmentId: string, id: string }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllMembersOfMyContractorsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllMembersOfMyContractorsQuery = { __typename?: 'Query', allMembersOfMyContractors?: { __typename?: 'AllMembersOfMyContractorsConnection', totalCount: number, nodes?: Array<{ __typename: 'Contact', contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, id: string, displayName: string, firstName: string, lastName: string, companyName: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, additionalInformation: Array<{ __typename: 'AddressInformation', id: string } | { __typename: 'BillingInformation', id: string } | { __typename: 'ContactPersonInformation', id: string } | { __typename: 'ContractedInformation', id: string } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', id: string } | { __typename: 'EmailInformation', emailAddress: string, id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string, federalLocation: string, from: string, to: string, workingTimeModelId: string, workingTimeModel?: { __typename?: 'WorkingTimeModel', id: string, name: string } | null } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string } | { __typename: 'PhoneInformation', id: string } | { __typename: 'SalaryInformation', id: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', id: string } | { __typename: 'WorksInDepartmentInformation', id: string }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllSuppliersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllSuppliersQuery = { __typename?: 'Query', allContacts?: { __typename?: 'AllContactsConnection', totalCount: number, nodes?: Array<{ __typename: 'Contact', contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, id: string, displayName: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, additionalInformation: Array<{ __typename: 'AddressInformation', id: string } | { __typename: 'BillingInformation', id: string } | { __typename: 'ContactPersonInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | { __typename: 'ContractedInformation', id: string } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', id: string } | { __typename: 'EmailInformation', emailAddress: string, id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string } | { __typename: 'PhoneInformation', id: string } | { __typename: 'SalaryInformation', id: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', id: string } | { __typename: 'WorksInDepartmentInformation', id: string }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetContactQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetContactQuery = { __typename?: 'Query', node?: { __typename?: 'Absence', id: string } | { __typename?: 'AbsenceReason', id: string } | { __typename?: 'AccountingProfile', id: string } | { __typename?: 'BccRecipientList', id: string } | { __typename?: 'CalendarEvent', id: string } | { __typename?: 'CatalogEntry', id: string } | { __typename: 'Contact', displayName: string, companyName: string, contactNumber: string, id: string, isDeleted: boolean, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, firstName: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, lastName: string, salutation: SalutationType, title: string, version: number, isContactPerson: boolean, isEmployee: boolean, shortCode: string, isTemporary: boolean, additionalInformation: Array<{ __typename: 'AddressInformation', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string, id: string } | { __typename: 'BillingInformation', isSameAsShippingAddress: boolean, name: string, id: string, bankAccount: { __typename?: 'BankAccount', bankName?: string | null, bic?: string | null, clientReference?: string | null, clientReferenceDate?: string | null, iban?: string | null }, billingAddress: { __typename?: 'Address', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string }, shippingAddress: { __typename?: 'Address', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string } } | { __typename: 'ContactPersonInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | { __typename: 'ContractedInformation', contractedId: string, marge: number, id: string } | { __typename: 'DateInformation', date?: string | null, personDateType: PersonDateType, id: string } | { __typename: 'DepartmentInformation', departmentName: string, id: string } | { __typename: 'EmailInformation', emailAddress: string, emailType: EmailType, id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | { __typename: 'PaymentConditionInformation', id: string, selectedEntryId?: string | null, doesNotParticipateInVoucherProcess: boolean, discountProfileId?: { __typename?: 'VersionedDiscountProfileId', id: string, version: number } | null } | { __typename: 'PaymentInformation', taxNumber: string, paymentDeadlineInDays?: number | null, routeId: string, vatId: string, id: string } | { __typename: 'PhoneInformation', number: string, phoneType: PhoneType, id: string } | { __typename: 'SalaryInformation', pricePerHour: number, startDate: string, id: string } | { __typename: 'WebsiteInformation', url: string, id: string } | { __typename: 'WorkingConditionInformation', hoursPerFriday: number, hoursPerMonday: number, hoursPerSaturday: number, hoursPerSunday: number, hoursPerThursday: number, hoursPerTuesday: number, hoursPerWednesday: number, hoursPerWeek: number, isFlexible: boolean, startDate: string, id: string } | { __typename: 'WorksInDepartmentInformation', departmentId: string, id: string }> } | { __typename?: 'CorrectedCreditNote', id: string } | { __typename?: 'CorrectedInvoice', id: string } | { __typename?: 'CreditNote', id: string } | { __typename?: 'Department', id: string } | { __typename?: 'DiscountProfile', id: string } | { __typename?: 'DunningLevel', id: string } | { __typename?: 'Email', id: string } | { __typename?: 'FileEntry', id: string } | { __typename?: 'FolderEntry', id: string } | { __typename?: 'Invoice', id: string } | { __typename?: 'Offer', id: string } | { __typename?: 'Project', id: string } | { __typename?: 'ProjectTimeApproval', id: string } | { __typename?: 'ProjectTimeEntry', id: string } | { __typename?: 'RollingNumber', id: string } | { __typename?: 'SaleableService', id: string } | { __typename?: 'SaleableServiceGroup', id: string } | { __typename?: 'SaleableUnit', id: string } | { __typename?: 'Template', id: string } | { __typename?: 'TimeBalanceEntry', id: string } | { __typename?: 'TimeEntry', id: string } | { __typename?: 'TimeLabel', id: string } | { __typename?: 'TimeLabelGroup', id: string } | { __typename?: 'User', id: string } | { __typename?: 'UserGroup', id: string } | { __typename?: 'WorkingTimeModel', id: string } | null };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me?: { __typename: 'Contact', id: string, displayName: string, firstName: string, lastName: string, title: string, salutation: SalutationType, displayContactType: Array<ContactType>, isAFreelancer: boolean, additionalInformation: Array<{ __typename: 'AddressInformation', type: AddressType, name: string, city: string, country: string, state: string, id: string, street: string, zipCode: string } | { __typename: 'BillingInformation' } | { __typename: 'ContactPersonInformation' } | { __typename: 'ContractedInformation' } | { __typename: 'DateInformation', date?: string | null, id: string, personDateType: PersonDateType } | { __typename: 'DepartmentInformation' } | { __typename: 'EmailInformation', id: string, emailAddress: string, emailType: EmailType } | { __typename: 'EmployeeWorkingConditionInformation', federalLocation: string, from: string, id: string, to: string, workingTimeModelId: string } | { __typename: 'IsContactPersonOfInformation' } | { __typename: 'PaymentConditionInformation' } | { __typename: 'PaymentInformation' } | { __typename: 'PhoneInformation', id: string, number: string, phoneType: PhoneType } | { __typename: 'SalaryInformation' } | { __typename: 'WebsiteInformation' } | { __typename: 'WorkingConditionInformation' } | { __typename: 'WorksInDepartmentInformation' }> } | null };

export type GetMyContractorsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMyContractorsQuery = { __typename?: 'Query', myContractors?: { __typename?: 'MyContractorsConnection', totalCount: number, nodes?: Array<{ __typename?: 'Contact', contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, id: string, displayName: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, additionalInformation: Array<{ __typename: 'AddressInformation', id: string } | { __typename: 'BillingInformation', id: string } | { __typename: 'ContactPersonInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | { __typename: 'ContractedInformation', contractedId: string, id: string, marge: number } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', id: string } | { __typename: 'EmailInformation', id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string } | { __typename: 'PhoneInformation', id: string } | { __typename: 'SalaryInformation', id: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', id: string } | { __typename: 'WorksInDepartmentInformation', id: string }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetMyPaymentConditionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyPaymentConditionsQuery = { __typename?: 'Query', myPaymentConditions: Array<{ __typename?: 'EditablePaymentCondition', companyId: string, displayName: string, paymentInformationId: string, selectedEntry?: string | null, entries: Array<{ __typename?: 'DiscountProfileEntry', discount: number, dueDate: number, id: string }> }> };

export type GetMySupplierMembersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filterByName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMySupplierMembersQuery = { __typename?: 'Query', mySupplierMembers?: { __typename?: 'MySupplierMembersConnection', totalCount: number, nodes?: Array<{ __typename?: 'Contact', id: string, displayName: string }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetMyTeamMembersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMyTeamMembersQuery = { __typename?: 'Query', myTeamMembers?: { __typename?: 'MyTeamMembersConnection', totalCount: number, nodes?: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number, additionalInformation: Array<{ __typename: 'AddressInformation', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string, id: string } | { __typename: 'BillingInformation', isSameAsShippingAddress: boolean, name: string, id: string, bankAccount: { __typename?: 'BankAccount', bankName?: string | null, bic?: string | null, clientReference?: string | null, clientReferenceDate?: string | null, iban?: string | null }, billingAddress: { __typename?: 'Address', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string }, shippingAddress: { __typename?: 'Address', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string } } | { __typename: 'ContactPersonInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | { __typename: 'ContractedInformation', contractedId: string, marge: number, id: string } | { __typename: 'DateInformation', date?: string | null, personDateType: PersonDateType, id: string } | { __typename: 'DepartmentInformation', departmentName: string, id: string } | { __typename: 'EmailInformation', emailAddress: string, emailType: EmailType, id: string } | { __typename: 'EmployeeWorkingConditionInformation', federalLocation: string, from: string, to: string, workingTimeModelId: string, id: string, workingTimeModel?: { __typename?: 'WorkingTimeModel', id: string, name: string } | null } | { __typename: 'IsContactPersonOfInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | { __typename: 'PaymentConditionInformation', id: string, selectedEntryId?: string | null, discountProfileId?: { __typename?: 'VersionedDiscountProfileId', id: string, version: number } | null } | { __typename: 'PaymentInformation', taxNumber: string, paymentDeadlineInDays?: number | null, routeId: string, vatId: string, id: string } | { __typename: 'PhoneInformation', number: string, phoneType: PhoneType, id: string } | { __typename: 'SalaryInformation', pricePerHour: number, startDate: string, id: string } | { __typename: 'WebsiteInformation', url: string, id: string } | { __typename: 'WorkingConditionInformation', hoursPerFriday: number, hoursPerMonday: number, hoursPerSaturday: number, hoursPerSunday: number, hoursPerThursday: number, hoursPerTuesday: number, hoursPerWednesday: number, hoursPerWeek: number, isFlexible: boolean, startDate: string, id: string } | { __typename: 'WorksInDepartmentInformation', departmentId: string, id: string }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetPaymentConditionInformationQueryVariables = Exact<{
  contactId: Scalars['ID']['input'];
}>;


export type GetPaymentConditionInformationQuery = { __typename?: 'Query', node?: { __typename?: 'Absence' } | { __typename?: 'AbsenceReason' } | { __typename?: 'AccountingProfile' } | { __typename?: 'BccRecipientList' } | { __typename?: 'CalendarEvent' } | { __typename?: 'CatalogEntry' } | { __typename?: 'Contact', additionalInformation: Array<{ __typename?: 'AddressInformation' } | { __typename?: 'BillingInformation' } | { __typename?: 'ContactPersonInformation' } | { __typename?: 'ContractedInformation' } | { __typename?: 'DateInformation' } | { __typename?: 'DepartmentInformation' } | { __typename?: 'EmailInformation' } | { __typename?: 'EmployeeWorkingConditionInformation' } | { __typename?: 'IsContactPersonOfInformation' } | { __typename?: 'PaymentConditionInformation', id: string, selectedEntryId?: string | null, doesNotParticipateInVoucherProcess: boolean } | { __typename?: 'PaymentInformation' } | { __typename?: 'PhoneInformation' } | { __typename?: 'SalaryInformation' } | { __typename?: 'WebsiteInformation' } | { __typename?: 'WorkingConditionInformation' } | { __typename?: 'WorksInDepartmentInformation' }> } | { __typename?: 'CorrectedCreditNote' } | { __typename?: 'CorrectedInvoice' } | { __typename?: 'CreditNote' } | { __typename?: 'Department' } | { __typename?: 'DiscountProfile' } | { __typename?: 'DunningLevel' } | { __typename?: 'Email' } | { __typename?: 'FileEntry' } | { __typename?: 'FolderEntry' } | { __typename?: 'Invoice' } | { __typename?: 'Offer' } | { __typename?: 'Project' } | { __typename?: 'ProjectTimeApproval' } | { __typename?: 'ProjectTimeEntry' } | { __typename?: 'RollingNumber' } | { __typename?: 'SaleableService' } | { __typename?: 'SaleableServiceGroup' } | { __typename?: 'SaleableUnit' } | { __typename?: 'Template' } | { __typename?: 'TimeBalanceEntry' } | { __typename?: 'TimeEntry' } | { __typename?: 'TimeLabel' } | { __typename?: 'TimeLabelGroup' } | { __typename?: 'User' } | { __typename?: 'UserGroup' } | { __typename?: 'WorkingTimeModel' } | null };

export type UpdateBillingInformationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  bankAccount: BankAccountInput;
  billingAddress: AddressInput;
  contactId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  shippingAddress: AddressInput;
}>;


export type UpdateBillingInformationMutation = { __typename?: 'Mutation', updateBillingInformation: { __typename?: 'UpdateBillingInformationPayload', errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, billingInformation?: { __typename?: 'BillingInformation', id: string, isSameAsShippingAddress: boolean, name: string, bankAccount: { __typename?: 'BankAccount', bankName?: string | null, bic?: string | null, clientReference?: string | null, clientReferenceDate?: string | null, iban?: string | null }, billingAddress: { __typename?: 'Address', type: AddressType, name: string, street: string, zipCode: string, city: string, state: string, country: string }, shippingAddress: { __typename?: 'Address', type: AddressType, name: string, street: string, zipCode: string, city: string, state: string, country: string } } | null } };

export type UpdateCompanyContactMutationVariables = Exact<{
  companyName: Scalars['String']['input'];
  contactNumber: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}>;


export type UpdateCompanyContactMutation = { __typename?: 'Mutation', updateCompanyContact: { __typename?: 'UpdateCompanyContactPayload', contact?: { __typename: 'Contact', displayName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, id: string, isDeleted: boolean, companyName: string, firstName: string, lastName: string, salutation: SalutationType, title: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, version: number, shortCode: string, isTemporary: boolean, additionalInformation: Array<{ __typename: 'AddressInformation', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string, id: string } | { __typename: 'BillingInformation', isSameAsShippingAddress: boolean, name: string, id: string, bankAccount: { __typename?: 'BankAccount', bankName?: string | null, bic?: string | null, clientReference?: string | null, clientReferenceDate?: string | null, iban?: string | null }, billingAddress: { __typename?: 'Address', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string }, shippingAddress: { __typename?: 'Address', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string } } | { __typename: 'ContactPersonInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | { __typename: 'ContractedInformation', contractedId: string, marge: number, id: string } | { __typename: 'DateInformation', date?: string | null, personDateType: PersonDateType, id: string } | { __typename: 'DepartmentInformation', departmentName: string, id: string } | { __typename: 'EmailInformation', emailAddress: string, emailType: EmailType, id: string } | { __typename: 'EmployeeWorkingConditionInformation', federalLocation: string, from: string, to: string, workingTimeModelId: string, id: string, workingTimeModel?: { __typename?: 'WorkingTimeModel', id: string, name: string } | null } | { __typename: 'IsContactPersonOfInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | { __typename: 'PaymentConditionInformation', id: string, selectedEntryId?: string | null, discountProfileId?: { __typename?: 'VersionedDiscountProfileId', id: string, version: number } | null } | { __typename: 'PaymentInformation', taxNumber: string, paymentDeadlineInDays?: number | null, routeId: string, vatId: string, id: string } | { __typename: 'PhoneInformation', number: string, phoneType: PhoneType, id: string } | { __typename: 'SalaryInformation', pricePerHour: number, startDate: string, id: string } | { __typename: 'WebsiteInformation', url: string, id: string } | { __typename: 'WorkingConditionInformation', hoursPerFriday: number, hoursPerMonday: number, hoursPerSaturday: number, hoursPerSunday: number, hoursPerThursday: number, hoursPerTuesday: number, hoursPerWednesday: number, hoursPerWeek: number, isFlexible: boolean, startDate: string, id: string } | { __typename: 'WorksInDepartmentInformation', departmentId: string, id: string }> } | null, errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdateContactAddressMutationVariables = Exact<{
  addressId: Scalars['ID']['input'];
  contactId: Scalars['ID']['input'];
  type?: AddressType;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateContactAddressMutation = { __typename?: 'Mutation', updateContactAddress: { __typename?: 'UpdateContactAddressPayload', addressInformation?: { __typename?: 'AddressInformation', type: AddressType, name: string, street: string, zipCode: string, city: string, state: string, country: string } | null, errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdateContactDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  isDeleted: Scalars['Boolean']['input'];
}>;


export type UpdateContactDeleteMutation = { __typename?: 'Mutation', updateContactDelete: { __typename?: 'UpdateContactDeletePayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdateContactEmailMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  emailAddress: Scalars['String']['input'];
  emailType: EmailType;
  emailId: Scalars['ID']['input'];
}>;


export type UpdateContactEmailMutation = { __typename?: 'Mutation', updateContactEmail: { __typename?: 'UpdateContactEmailPayload', emailInformation?: { __typename?: 'EmailInformation', emailAddress: string, emailType: EmailType, id: string } | null, errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdateContactPersonInformationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  contactId: Scalars['ID']['input'];
  contactPersonId: Scalars['ID']['input'];
  contactUsage: Array<ContactUsage> | ContactUsage;
}>;


export type UpdateContactPersonInformationMutation = { __typename?: 'Mutation', updateContactPersonInformation: { __typename?: 'UpdateContactPersonInformationPayload', errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, contactPersonInformation?: { __typename?: 'ContactPersonInformation', contactUsage: Array<ContactUsage>, id: string, contactPersonId: string } | null } };

export type UpdateContractedInformationMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  contractedId: Scalars['ID']['input'];
  margin: Scalars['Decimal']['input'];
  contactInformationId: Scalars['ID']['input'];
}>;


export type UpdateContractedInformationMutation = { __typename?: 'Mutation', updateContractedInformation: { __typename?: 'UpdateContractedInformationPayload', contractedInformation?: { __typename?: 'ContractedInformation', contractedId: string, id: string, marge: number } | null, errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdateDateInformationMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  dateType: PersonDateType;
  id: Scalars['ID']['input'];
}>;


export type UpdateDateInformationMutation = { __typename?: 'Mutation', updateDateInformation: { __typename?: 'UpdateDateInformationPayload', errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, dateInformation?: { __typename?: 'DateInformation', date?: string | null, id: string, personDateType: PersonDateType } | null } };

export type UpdateDepartmentInformationMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  departmentName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
}>;


export type UpdateDepartmentInformationMutation = { __typename?: 'Mutation', updateDepartmentInformation: { __typename?: 'UpdateDepartmentInformationPayload', errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, departmentInformation?: { __typename?: 'DepartmentInformation', departmentName: string, id: string } | null } };

export type UpdateInternalWorkingConditionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  contactId: Scalars['ID']['input'];
  from: Scalars['LocalDate']['input'];
  federalCode: Scalars['String']['input'];
  workingTimeModelId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['LocalDate']['input']>;
}>;


export type UpdateInternalWorkingConditionMutation = { __typename?: 'Mutation', updateEmployeeWorkingCondition: { __typename?: 'UpdateEmployeeWorkingConditionPayload', errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, employeeWorkingConditionInformation?: { __typename: 'EmployeeWorkingConditionInformation', id: string, federalLocation: string, from: string, to: string, workingTimeModelId: string, workingTimeModel?: { __typename?: 'WorkingTimeModel', id: string, name: string } | null } | null } };

export type UpdateIsContactPersonInformationMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  contactPersonId: Scalars['ID']['input'];
  contactUsage: Array<ContactUsage> | ContactUsage;
  id: Scalars['ID']['input'];
}>;


export type UpdateIsContactPersonInformationMutation = { __typename?: 'Mutation', updateContactPersonInformation: { __typename?: 'UpdateContactPersonInformationPayload', errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, contactPersonInformation?: { __typename?: 'ContactPersonInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | null } };

export type UpdateMailboxContactMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  contactNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateMailboxContactMutation = { __typename?: 'Mutation', updateMailboxContact: { __typename?: 'UpdateMailboxContactPayload', contact?: { __typename?: 'Contact', id: string, displayName: string, companyName: string, contactNumber: string, contactTypes: Array<ContactType>, additionalInformation: Array<{ __typename: 'AddressInformation', id: string } | { __typename: 'BillingInformation', id: string } | { __typename: 'ContactPersonInformation', id: string } | { __typename: 'ContractedInformation', id: string } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', id: string } | { __typename: 'EmailInformation', emailAddress: string, emailType: EmailType, id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string } | { __typename: 'PhoneInformation', id: string } | { __typename: 'SalaryInformation', id: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', id: string } | { __typename: 'WorksInDepartmentInformation', id: string }> } | null, errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdateMyPaymentConditionMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  contactInformationId: Scalars['ID']['input'];
  selectedEntry: Scalars['ID']['input'];
}>;


export type UpdateMyPaymentConditionMutation = { __typename?: 'Mutation', updateMyPaymentCondition: { __typename?: 'UpdateMyPaymentConditionPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdatePaymentConditionInformationMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  discountProfileId: VersionedDiscountProfileIdInput;
  selectedEntryId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  doesNotParticipateInVoucherProcess: Scalars['Boolean']['input'];
}>;


export type UpdatePaymentConditionInformationMutation = { __typename?: 'Mutation', updatePaymentConditionInformation: { __typename?: 'UpdatePaymentConditionInformationPayload', errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, paymentConditionInformation?: { __typename?: 'PaymentConditionInformation', id: string, selectedEntryId?: string | null, doesNotParticipateInVoucherProcess: boolean, discountProfileId?: { __typename?: 'VersionedDiscountProfileId', id: string, version: number } | null } | null } };

export type UpdatePaymentInformationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  contactId: Scalars['ID']['input'];
  taxNumber: Scalars['String']['input'];
  paymentDeadlineInDays?: InputMaybe<Scalars['Int']['input']>;
  routeId?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePaymentInformationMutation = { __typename?: 'Mutation', updatePaymentInformation: { __typename?: 'UpdatePaymentInformationPayload', errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, paymentInformation?: { __typename?: 'PaymentInformation', id: string, taxNumber: string, paymentDeadlineInDays?: number | null, routeId: string, vatId: string } | null } };

export type UpdatePersonContactMutationVariables = Exact<{
  contactNumber: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  lastName: Scalars['String']['input'];
  salutation: SalutationType;
  title?: InputMaybe<Scalars['String']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePersonContactMutation = { __typename?: 'Mutation', updatePersonContact: { __typename?: 'UpdatePersonContactPayload', contact?: { __typename: 'Contact', displayName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, id: string, isDeleted: boolean, companyName: string, firstName: string, lastName: string, salutation: SalutationType, title: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, version: number, isContactPerson: boolean, isEmployee: boolean, shortCode: string, isTemporary: boolean, additionalInformation: Array<{ __typename: 'AddressInformation', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string, id: string } | { __typename: 'BillingInformation', isSameAsShippingAddress: boolean, name: string, id: string, bankAccount: { __typename?: 'BankAccount', bankName?: string | null, bic?: string | null, clientReference?: string | null, clientReferenceDate?: string | null, iban?: string | null }, billingAddress: { __typename?: 'Address', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string }, shippingAddress: { __typename?: 'Address', type: AddressType, name: string, city: string, country: string, state: string, street: string, zipCode: string } } | { __typename: 'ContactPersonInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | { __typename: 'ContractedInformation', contractedId: string, marge: number, id: string } | { __typename: 'DateInformation', date?: string | null, personDateType: PersonDateType, id: string } | { __typename: 'DepartmentInformation', departmentName: string, id: string } | { __typename: 'EmailInformation', emailAddress: string, emailType: EmailType, id: string } | { __typename: 'EmployeeWorkingConditionInformation', federalLocation: string, from: string, to: string, workingTimeModelId: string, id: string, workingTimeModel?: { __typename?: 'WorkingTimeModel', id: string, name: string } | null } | { __typename: 'IsContactPersonOfInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | { __typename: 'PaymentConditionInformation', id: string, selectedEntryId?: string | null, discountProfileId?: { __typename?: 'VersionedDiscountProfileId', id: string, version: number } | null } | { __typename: 'PaymentInformation', taxNumber: string, paymentDeadlineInDays?: number | null, routeId: string, vatId: string, id: string } | { __typename: 'PhoneInformation', number: string, phoneType: PhoneType, id: string } | { __typename: 'SalaryInformation', pricePerHour: number, startDate: string, id: string } | { __typename: 'WebsiteInformation', url: string, id: string } | { __typename: 'WorkingConditionInformation', hoursPerFriday: number, hoursPerMonday: number, hoursPerSaturday: number, hoursPerSunday: number, hoursPerThursday: number, hoursPerTuesday: number, hoursPerWednesday: number, hoursPerWeek: number, isFlexible: boolean, startDate: string, id: string } | { __typename: 'WorksInDepartmentInformation', departmentId: string, id: string }> } | null, errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdatePhoneInformationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  contactId: Scalars['ID']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  phoneType: PhoneType;
}>;


export type UpdatePhoneInformationMutation = { __typename?: 'Mutation', updatePhoneInformation: { __typename?: 'UpdatePhoneInformationPayload', phoneInformation?: { __typename?: 'PhoneInformation', id: string, number: string } | null, errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdateSalaryInformationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  contactId: Scalars['ID']['input'];
  pricePerHour: Scalars['Decimal']['input'];
  startDate: Scalars['LocalDate']['input'];
}>;


export type UpdateSalaryInformationMutation = { __typename?: 'Mutation', updateSalaryInformation: { __typename?: 'UpdateSalaryInformationPayload', errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, salaryInformation?: { __typename?: 'SalaryInformation', id: string, pricePerHour: number, startDate: string } | null } };

export type UpdateWebsiteInformationMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
}>;


export type UpdateWebsiteInformationMutation = { __typename?: 'Mutation', updateWebsiteInformation: { __typename?: 'UpdateWebsiteInformationPayload', errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, websiteInformation?: { __typename?: 'WebsiteInformation', id: string, url: string } | null } };

export type UpdateWorkingConditionInformationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  contactId: Scalars['ID']['input'];
  hoursPerFriday: Scalars['Decimal']['input'];
  hoursPerMonday: Scalars['Decimal']['input'];
  hoursPerSaturday: Scalars['Decimal']['input'];
  hoursPerSunday: Scalars['Decimal']['input'];
  hoursPerThursday: Scalars['Decimal']['input'];
  hoursPerTuesday: Scalars['Decimal']['input'];
  hoursPerWednesday: Scalars['Decimal']['input'];
  hoursPerWeek: Scalars['Decimal']['input'];
  isFlexible: Scalars['Boolean']['input'];
  startDate: Scalars['LocalDate']['input'];
}>;


export type UpdateWorkingConditionInformationMutation = { __typename?: 'Mutation', updateWorkingConditionInformation: { __typename?: 'UpdateWorkingConditionInformationPayload', errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, workingConditionInformation?: { __typename?: 'WorkingConditionInformation', hoursPerFriday: number, hoursPerMonday: number, hoursPerSaturday: number, hoursPerSunday: number, hoursPerThursday: number, hoursPerTuesday: number, hoursPerWednesday: number, hoursPerWeek: number, id: string, isFlexible: boolean, startDate: string } | null } };

export type CreateDiscountProfileMutationVariables = Exact<{
  name: Scalars['String']['input'];
  maxDueDate: Scalars['Int']['input'];
  entries: Array<DiscountProfileEntryInput> | DiscountProfileEntryInput;
}>;


export type CreateDiscountProfileMutation = { __typename?: 'Mutation', createDiscountProfile: { __typename?: 'CreateDiscountProfilePayload', errors?: Array<{ __typename?: 'MyEntityNotFoundError', error: string, errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, discountProfile?: { __typename?: 'DiscountProfile', id: string, isDeleted: boolean, maxDueDate: number, name: string, version: number, entries: Array<{ __typename?: 'DiscountProfileEntry', discount: number, dueDate: number, id: string }> } | null } };

export type DeleteDiscountProfileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDiscountProfileMutation = { __typename?: 'Mutation', deleteDiscountProfile: { __typename?: 'DeleteDiscountProfilePayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'MyEntityNotFoundError', error: string, errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type GetAllDiscountProfilesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllDiscountProfilesQuery = { __typename?: 'Query', allDiscountProfiles?: { __typename?: 'AllDiscountProfilesConnection', totalCount: number, nodes?: Array<{ __typename?: 'DiscountProfile', id: string, maxDueDate: number, name: string, entries: Array<{ __typename?: 'DiscountProfileEntry', id: string, discount: number, dueDate: number }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetDiscountProfileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDiscountProfileQuery = { __typename?: 'Query', node?: { __typename?: 'Absence', id: string } | { __typename?: 'AbsenceReason', id: string } | { __typename?: 'AccountingProfile', id: string } | { __typename?: 'BccRecipientList', id: string } | { __typename?: 'CalendarEvent', id: string } | { __typename?: 'CatalogEntry', id: string } | { __typename?: 'Contact', id: string } | { __typename?: 'CorrectedCreditNote', id: string } | { __typename?: 'CorrectedInvoice', id: string } | { __typename?: 'CreditNote', id: string } | { __typename?: 'Department', id: string } | { __typename?: 'DiscountProfile', id: string, isDeleted: boolean, maxDueDate: number, name: string, version: number, entries: Array<{ __typename?: 'DiscountProfileEntry', discount: number, dueDate: number, id: string }> } | { __typename?: 'DunningLevel', id: string } | { __typename?: 'Email', id: string } | { __typename?: 'FileEntry', id: string } | { __typename?: 'FolderEntry', id: string } | { __typename?: 'Invoice', id: string } | { __typename?: 'Offer', id: string } | { __typename?: 'Project', id: string } | { __typename?: 'ProjectTimeApproval', id: string } | { __typename?: 'ProjectTimeEntry', id: string } | { __typename?: 'RollingNumber', id: string } | { __typename?: 'SaleableService', id: string } | { __typename?: 'SaleableServiceGroup', id: string } | { __typename?: 'SaleableUnit', id: string } | { __typename?: 'Template', id: string } | { __typename?: 'TimeBalanceEntry', id: string } | { __typename?: 'TimeEntry', id: string } | { __typename?: 'TimeLabel', id: string } | { __typename?: 'TimeLabelGroup', id: string } | { __typename?: 'User', id: string } | { __typename?: 'UserGroup', id: string } | { __typename?: 'WorkingTimeModel', id: string } | null };

export type UpdateDiscountProfileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  maxDueDate: Scalars['Int']['input'];
  entries: Array<DiscountProfileEntryInput> | DiscountProfileEntryInput;
}>;


export type UpdateDiscountProfileMutation = { __typename?: 'Mutation', updateDiscountProfile: { __typename?: 'UpdateDiscountProfilePayload', errors?: Array<{ __typename?: 'MyEntityNotFoundError', error: string, errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, discountProfile?: { __typename?: 'DiscountProfile', id: string, isDeleted: boolean, maxDueDate: number, name: string, version: number, entries: Array<{ __typename?: 'DiscountProfileEntry', discount: number, dueDate: number, id: string }> } | null } };

export type AcceptOfferMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AcceptOfferMutation = { __typename?: 'Mutation', acceptOffer: { __typename?: 'AcceptOfferPayload', offer?: { __typename?: 'Offer', id: string, status: DocumentStatus } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type CancelDocumentMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type CancelDocumentMutation = { __typename?: 'Mutation', cancelDocument: { __typename?: 'CancelDocumentPayload', commercialDocument?: { __typename: 'CorrectedCreditNote' } | { __typename: 'CorrectedInvoice' } | { __typename: 'CreditNote', id: string, number?: string | null, status: DocumentStatus, documentType: DocumentType, documentRole: DocumentRole, kind: CreditNoteKind, issueDate?: string | null, dueDate?: string | null, netTotal: number, grossTotal: number, taxTotal: number } | { __typename: 'Invoice', id: string, number?: string | null, status: DocumentStatus, documentType: DocumentType, documentRole: DocumentRole, issueDate?: string | null, dueDate?: string | null, netTotal: number, grossTotal: number, taxTotal: number } | { __typename: 'Offer' } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type ConvertOfferToInvoiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ConvertOfferToInvoiceMutation = { __typename?: 'Mutation', convertOfferToInvoice: { __typename?: 'ConvertOfferToInvoicePayload', invoice?: { __typename?: 'Invoice', id: string, status: DocumentStatus } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type CreateDocumentDraftMutationVariables = Exact<{
  documentType: DocumentType;
  creditNoteKind?: InputMaybe<CreditNoteKind>;
  documentRole?: InputMaybe<DocumentRole>;
  settlesInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  clientContactPersonId?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  concludingText?: InputMaybe<Scalars['String']['input']>;
  contractorId?: InputMaybe<Scalars['ID']['input']>;
  introductoryText?: InputMaybe<Scalars['String']['input']>;
  items: Array<ModifyInvoiceItemInput> | ModifyInvoiceItemInput;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentDeadlineInDays?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  isProforma?: InputMaybe<Scalars['Boolean']['input']>;
  validUntil?: InputMaybe<Scalars['LocalDate']['input']>;
}>;


export type CreateDocumentDraftMutation = { __typename?: 'Mutation', createDocumentDraft: { __typename?: 'CreateDocumentDraftPayload', commercialDocument?: { __typename: 'CorrectedCreditNote' } | { __typename: 'CorrectedInvoice' } | { __typename: 'CreditNote', id: string, number?: string | null, status: DocumentStatus, documentType: DocumentType, documentRole: DocumentRole, kind: CreditNoteKind, settlesInvoiceId?: string | null, clientId?: string | null, clientContactPersonId?: string | null, contractorId?: string | null, grossTotal: number, paidTotal: number, projectId?: string | null, introductoryText: string, concludingText?: string | null, paymentDeadlineInDays: number, notes?: string | null, issueDate?: string | null, netTotal: number, items: Array<{ __typename?: 'LineItem', id: string, name: string, description: string, quantity: number, unit: string, unitPriceNet: number, discountPercent?: number | null, tax: number, taxCode: string, positionNo: number, lineNetTotal: number, lineTaxTotal: number, lineGrossTotal: number }> } | { __typename: 'Invoice', id: string, number?: string | null, status: DocumentStatus, documentType: DocumentType, documentRole: DocumentRole, clientId?: string | null, clientContactPersonId?: string | null, contractorId?: string | null, projectId?: string | null, introductoryText: string, concludingText?: string | null, paymentDeadlineInDays: number, notes?: string | null, issueDate?: string | null, netTotal: number, grossTotal: number, paidTotal: number, items: Array<{ __typename?: 'LineItem', id: string, name: string, description: string, quantity: number, unit: string, unitPriceNet: number, discountPercent?: number | null, tax: number, taxCode: string, positionNo: number, lineNetTotal: number, lineTaxTotal: number, lineGrossTotal: number }> } | { __typename: 'Offer', clientId?: string | null, concludingText?: string | null, contractorId?: string | null, createdDate: string, documentRole: DocumentRole, documentType: DocumentType, dueDate?: string | null, grossTotal: number, id: string, introductoryText: string, isDeleted: boolean, isReversal: boolean, issueDate?: string | null, netTotal: number, notes?: string | null, number?: string | null, paymentDeadlineInDays: number, status: DocumentStatus, taxTotal: number, timestamp: string, createdById: string, clientContactPersonId?: string | null, isInvalid: boolean, isProforma: boolean, acceptedAt?: string | null, clientName?: string | null, projectId?: string | null, employeeIds: Array<string>, billTo: { __typename?: 'GenericAddress', line1: string, line2: string, line3: string, line4: string, line5: string }, items: Array<{ __typename?: 'LineItem', description: string, discountPercent?: number | null, id: string, lineGrossTotal: number, lineNetTotal: number, lineTaxTotal: number, positionNo: number, quantity: number, unit: string, unitPriceNet: number, tax: number, taxCode: string, name: string }>, shipTo?: { __typename?: 'GenericAddress', line1: string, line2: string, line3: string, line4: string, line5: string } | null, cancellation?: { __typename?: 'CancellationInfo', at: string, externalRef?: string | null, mode: CancellationMode, reason: string, reversalDocumentId?: string | null } | null, taxDetails: Array<{ __typename?: 'TaxDetail', code: string, netAmount: number, rate: number, taxAmount: number }>, payments?: Array<{ __typename?: 'PaymentItem', amount: number, creationDate: string, documentId: string, id: string, notes?: string | null, paymentDate: string, paymentMethod?: string | null }> | null } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type CreateDunningLevelMutationVariables = Exact<{
  contractorId: Scalars['ID']['input'];
  feeAmount: Scalars['Decimal']['input'];
  feeCurrency: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  paymentDays: Scalars['Int']['input'];
  level: Scalars['Int']['input'];
}>;


export type CreateDunningLevelMutation = { __typename?: 'Mutation', createDunningLevel: { __typename?: 'CreateDunningLevelPayload', dunningLevel?: { __typename?: 'DunningLevel', contractorId: string, createdAt: string, feeAmount: number, feeCurrency: string, id: string, isActive: boolean, isDeleted: boolean, level: number, name: string, paymentDays: number, updatedAt: string, version: number } | null, errors?: Array<{ __typename?: 'MyEntityNotFoundError', error: string, errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteDocumentDraftMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type DeleteDocumentDraftMutation = { __typename?: 'Mutation', deleteDocumentDraft: { __typename?: 'DeleteDocumentDraftPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteDunningLevelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDunningLevelMutation = { __typename?: 'Mutation', deleteDunningLevel: { __typename?: 'DeleteDunningLevelPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'MyEntityNotFoundError', error: string, errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DownloadDocumentQueryVariables = Exact<{
  id: Scalars['String']['input'];
  shouldDownload: Scalars['Boolean']['input'];
  entityId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadDocumentQuery = { __typename?: 'Query', downloadDocument: string };

export type DownloadDocumentXmlQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DownloadDocumentXmlQuery = { __typename?: 'Query', downloadDocumentXml: string };

export type FinalizeDocumentMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
  issueDate: Scalars['LocalDate']['input'];
}>;


export type FinalizeDocumentMutation = { __typename?: 'Mutation', finalizeDocument: { __typename?: 'FinalizeDocumentPayload', commercialDocument?: { __typename: 'CorrectedCreditNote' } | { __typename: 'CorrectedInvoice' } | { __typename: 'CreditNote', id: string, number?: string | null, status: DocumentStatus, documentType: DocumentType, documentRole: DocumentRole, kind: CreditNoteKind, issueDate?: string | null, dueDate?: string | null, netTotal: number, grossTotal: number, taxTotal: number } | { __typename: 'Invoice', id: string, number?: string | null, status: DocumentStatus, documentType: DocumentType, documentRole: DocumentRole, issueDate?: string | null, dueDate?: string | null, netTotal: number, grossTotal: number, taxTotal: number } | { __typename: 'Offer', id: string, number?: string | null, status: DocumentStatus, documentType: DocumentType, documentRole: DocumentRole, issueDate?: string | null, dueDate?: string | null, netTotal: number, grossTotal: number, taxTotal: number } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type GenerateInvoiceReminderMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
}>;


export type GenerateInvoiceReminderMutation = { __typename?: 'Mutation', generateReminder: { __typename?: 'GenerateReminderPayload', dunningCase?: { __typename?: 'DunningCase', createdAt: string, id: string, entries: Array<{ __typename?: 'DunningEntry', id: string, level: number, sentDate?: string | null, dueDate: string, fee: number }> } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type GetAllDunningCasesByDocumentQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAllDunningCasesByDocumentQuery = { __typename?: 'Query', dunningCaseByDocumentId?: { __typename?: 'DunningCase', createdAt: string, id: string, invoiceId: string, accruedFees: number, entries: Array<{ __typename?: 'DunningEntry', dueDate: string, id: string, level: number, sentDate?: string | null, fee: number, status: DunningStatus }> } | null };

export type GetAllDunningLevelsQueryVariables = Exact<{
  cotractorId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllDunningLevelsQuery = { __typename?: 'Query', allDunningLevels: Array<{ __typename?: 'DunningLevel', contractorId: string, createdAt: string, feeAmount: number, feeCurrency: string, id: string, isActive: boolean, isDeleted: boolean, level: number, name: string, paymentDays: number, updatedAt: string, version: number }> };

export type GetCreditNoteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCreditNoteQuery = { __typename?: 'Query', node?: { __typename: 'Absence' } | { __typename: 'AbsenceReason' } | { __typename: 'AccountingProfile' } | { __typename: 'BccRecipientList' } | { __typename: 'CalendarEvent' } | { __typename: 'CatalogEntry' } | { __typename: 'Contact' } | { __typename: 'CorrectedCreditNote' } | { __typename: 'CorrectedInvoice' } | { __typename: 'CreditNote', id: string, number?: string | null, status: DocumentStatus, documentType: DocumentType, documentRole: DocumentRole, kind: CreditNoteKind, settlesInvoiceId?: string | null, isPayable: boolean, recipientObjectedAt?: string | null, clientId?: string | null, clientContactPersonId?: string | null, contractorId?: string | null, projectId?: string | null, createdById: string, createdDate: string, introductoryText: string, concludingText?: string | null, paymentDeadlineInDays: number, notes?: string | null, issueDate?: string | null, dueDate?: string | null, timestamp: string, isDeleted: boolean, isReversal: boolean, netTotal: number, taxTotal: number, grossTotal: number, isInvalid: boolean, isProforma: boolean, paidTotal: number, billTo: { __typename?: 'GenericAddress', line1: string, line2: string, line3: string, line4: string, line5: string }, shipTo?: { __typename?: 'GenericAddress', line1: string, line2: string, line3: string, line4: string, line5: string } | null, items: Array<{ __typename?: 'LineItem', id: string, name: string, description: string, quantity: number, unit: string, unitPriceNet: number, discountPercent?: number | null, tax: number, taxCode: string, positionNo: number, lineNetTotal: number, lineTaxTotal: number, lineGrossTotal: number }>, cancellation?: { __typename?: 'CancellationInfo', at: string, externalRef?: string | null, mode: CancellationMode, reason: string, reversalDocumentId?: string | null } | null } | { __typename: 'Department' } | { __typename: 'DiscountProfile' } | { __typename: 'DunningLevel' } | { __typename: 'Email' } | { __typename: 'FileEntry' } | { __typename: 'FolderEntry' } | { __typename: 'Invoice' } | { __typename: 'Offer' } | { __typename: 'Project' } | { __typename: 'ProjectTimeApproval' } | { __typename: 'ProjectTimeEntry' } | { __typename: 'RollingNumber' } | { __typename: 'SaleableService' } | { __typename: 'SaleableServiceGroup' } | { __typename: 'SaleableUnit' } | { __typename: 'Template' } | { __typename: 'TimeBalanceEntry' } | { __typename: 'TimeEntry' } | { __typename: 'TimeLabel' } | { __typename: 'TimeLabelGroup' } | { __typename: 'User' } | { __typename: 'UserGroup' } | { __typename: 'WorkingTimeModel' } | null };

export type GetOfferQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOfferQuery = { __typename?: 'Query', node?: { __typename: 'Absence' } | { __typename: 'AbsenceReason' } | { __typename: 'AccountingProfile' } | { __typename: 'BccRecipientList' } | { __typename: 'CalendarEvent' } | { __typename: 'CatalogEntry' } | { __typename: 'Contact' } | { __typename: 'CorrectedCreditNote' } | { __typename: 'CorrectedInvoice' } | { __typename: 'CreditNote' } | { __typename: 'Department' } | { __typename: 'DiscountProfile' } | { __typename: 'DunningLevel' } | { __typename: 'Email' } | { __typename: 'FileEntry' } | { __typename: 'FolderEntry' } | { __typename: 'Invoice' } | { __typename: 'Offer', clientId?: string | null, concludingText?: string | null, contractorId?: string | null, createdDate: string, documentRole: DocumentRole, documentType: DocumentType, dueDate?: string | null, grossTotal: number, id: string, introductoryText: string, isDeleted: boolean, isReversal: boolean, issueDate?: string | null, netTotal: number, notes?: string | null, number?: string | null, paymentDeadlineInDays: number, status: DocumentStatus, taxTotal: number, timestamp: string, createdById: string, clientContactPersonId?: string | null, isInvalid: boolean, isProforma: boolean, acceptedAt?: string | null, clientName?: string | null, projectId?: string | null, employeeIds: Array<string>, billTo: { __typename?: 'GenericAddress', line1: string, line2: string, line3: string, line4: string, line5: string }, items: Array<{ __typename?: 'LineItem', description: string, discountPercent?: number | null, id: string, lineGrossTotal: number, lineNetTotal: number, lineTaxTotal: number, positionNo: number, quantity: number, unit: string, unitPriceNet: number, tax: number, taxCode: string, name: string }>, shipTo?: { __typename?: 'GenericAddress', line1: string, line2: string, line3: string, line4: string, line5: string } | null, cancellation?: { __typename?: 'CancellationInfo', at: string, externalRef?: string | null, mode: CancellationMode, reason: string, reversalDocumentId?: string | null } | null, taxDetails: Array<{ __typename?: 'TaxDetail', code: string, netAmount: number, rate: number, taxAmount: number }>, payments?: Array<{ __typename?: 'PaymentItem', amount: number, creationDate: string, documentId: string, id: string, notes?: string | null, paymentDate: string, paymentMethod?: string | null }> | null } | { __typename: 'Project' } | { __typename: 'ProjectTimeApproval' } | { __typename: 'ProjectTimeEntry' } | { __typename: 'RollingNumber' } | { __typename: 'SaleableService' } | { __typename: 'SaleableServiceGroup' } | { __typename: 'SaleableUnit' } | { __typename: 'Template' } | { __typename: 'TimeBalanceEntry' } | { __typename: 'TimeEntry' } | { __typename: 'TimeLabel' } | { __typename: 'TimeLabelGroup' } | { __typename: 'User' } | { __typename: 'UserGroup' } | { __typename: 'WorkingTimeModel' } | null };

export type InitializeDocumentEmailQueryVariables = Exact<{
  id: Scalars['String']['input'];
  entityId?: InputMaybe<Scalars['String']['input']>;
}>;


export type InitializeDocumentEmailQuery = { __typename?: 'Query', initializeDocumentEmail: { __typename?: 'CommercialDocumentEmail', body: string, subject: string, bccRecipients?: Array<string> | null, ccRecipients?: Array<string> | null, recipients: Array<string>, attachments?: Array<{ __typename?: 'CommercialDocumentEmailAttachment', content: string, extension?: string | null, name: string, positionNumber: number }> | null } };

export type RejectOfferMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type RejectOfferMutation = { __typename?: 'Mutation', rejectOffer: { __typename?: 'RejectOfferPayload', offer?: { __typename?: 'Offer', id: string, status: DocumentStatus } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type SendDocumentEmailMutationVariables = Exact<{
  id: Scalars['String']['input'];
  commercialDocumentEmail: CommercialDocumentEmailInput;
  entityId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendDocumentEmailMutation = { __typename?: 'Mutation', sendDocumentEmail: { __typename?: 'SendDocumentEmailPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdateDocumentDraftMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
  settlesInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  clientContactPersonId?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  concludingText?: InputMaybe<Scalars['String']['input']>;
  contractorId?: InputMaybe<Scalars['ID']['input']>;
  introductoryText: Scalars['String']['input'];
  items: Array<ModifyInvoiceItemInput> | ModifyInvoiceItemInput;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentDeadlineInDays?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  isProforma?: InputMaybe<Scalars['Boolean']['input']>;
  validUntil?: InputMaybe<Scalars['LocalDate']['input']>;
}>;


export type UpdateDocumentDraftMutation = { __typename?: 'Mutation', updateDocumentDraft: { __typename?: 'UpdateDocumentDraftPayload', commercialDocument?: { __typename: 'CorrectedCreditNote' } | { __typename: 'CorrectedInvoice' } | { __typename: 'CreditNote', id: string, number?: string | null, status: DocumentStatus, documentType: DocumentType, documentRole: DocumentRole, kind: CreditNoteKind, settlesInvoiceId?: string | null, clientId?: string | null, clientContactPersonId?: string | null, contractorId?: string | null, projectId?: string | null, introductoryText: string, concludingText?: string | null, paymentDeadlineInDays: number, notes?: string | null, issueDate?: string | null, netTotal: number, grossTotal: number, isProforma: boolean, isInvalid: boolean, paidTotal: number, items: Array<{ __typename?: 'LineItem', id: string, name: string, description: string, quantity: number, unit: string, unitPriceNet: number, discountPercent?: number | null, tax: number, taxCode: string, positionNo: number, lineNetTotal: number, lineTaxTotal: number, lineGrossTotal: number }> } | { __typename: 'Invoice', id: string, number?: string | null, status: DocumentStatus, documentType: DocumentType, documentRole: DocumentRole, clientId?: string | null, clientContactPersonId?: string | null, contractorId?: string | null, projectId?: string | null, introductoryText: string, concludingText?: string | null, paymentDeadlineInDays: number, notes?: string | null, issueDate?: string | null, netTotal: number, grossTotal: number, isProforma: boolean, isInvalid: boolean, paidTotal: number, items: Array<{ __typename?: 'LineItem', id: string, name: string, description: string, quantity: number, unit: string, unitPriceNet: number, discountPercent?: number | null, tax: number, taxCode: string, positionNo: number, lineNetTotal: number, lineTaxTotal: number, lineGrossTotal: number }> } | { __typename: 'Offer', clientId?: string | null, concludingText?: string | null, contractorId?: string | null, createdDate: string, documentRole: DocumentRole, documentType: DocumentType, dueDate?: string | null, grossTotal: number, id: string, introductoryText: string, isDeleted: boolean, isReversal: boolean, issueDate?: string | null, netTotal: number, notes?: string | null, number?: string | null, paymentDeadlineInDays: number, status: DocumentStatus, taxTotal: number, timestamp: string, createdById: string, clientContactPersonId?: string | null, isInvalid: boolean, isProforma: boolean, acceptedAt?: string | null, clientName?: string | null, projectId?: string | null, employeeIds: Array<string>, billTo: { __typename?: 'GenericAddress', line1: string, line2: string, line3: string, line4: string, line5: string }, items: Array<{ __typename?: 'LineItem', description: string, discountPercent?: number | null, id: string, lineGrossTotal: number, lineNetTotal: number, lineTaxTotal: number, positionNo: number, quantity: number, unit: string, unitPriceNet: number, tax: number, taxCode: string, name: string }>, shipTo?: { __typename?: 'GenericAddress', line1: string, line2: string, line3: string, line4: string, line5: string } | null, cancellation?: { __typename?: 'CancellationInfo', at: string, externalRef?: string | null, mode: CancellationMode, reason: string, reversalDocumentId?: string | null } | null, taxDetails: Array<{ __typename?: 'TaxDetail', code: string, netAmount: number, rate: number, taxAmount: number }>, payments?: Array<{ __typename?: 'PaymentItem', amount: number, creationDate: string, documentId: string, id: string, notes?: string | null, paymentDate: string, paymentMethod?: string | null }> | null } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdateDunningLevelMutationVariables = Exact<{
  feeAmount: Scalars['Decimal']['input'];
  feeCurrency: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  paymentDays: Scalars['Int']['input'];
}>;


export type UpdateDunningLevelMutation = { __typename?: 'Mutation', updateDunningLevel: { __typename?: 'UpdateDunningLevelPayload', dunningLevel?: { __typename?: 'DunningLevel', contractorId: string, createdAt: string, feeAmount: number, feeCurrency: string, id: string, isActive: boolean, isDeleted: boolean, level: number, name: string, paymentDays: number, updatedAt: string, version: number } | null, errors?: Array<{ __typename?: 'MyEntityNotFoundError', error: string, errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteCorrectedCreditNotePaymentMutationVariables = Exact<{
  correctedCreditNoteId: Scalars['ID']['input'];
  paymentId: Scalars['ID']['input'];
}>;


export type DeleteCorrectedCreditNotePaymentMutation = { __typename?: 'Mutation', deleteCorrectedCreditNotePayment: { __typename?: 'DeleteCorrectedCreditNotePaymentPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteCorrectedInvoicePaymentMutationVariables = Exact<{
  correctedInvoiceId: Scalars['ID']['input'];
  paymentId: Scalars['ID']['input'];
}>;


export type DeleteCorrectedInvoicePaymentMutation = { __typename?: 'Mutation', deleteCorrectedInvoicePayment: { __typename?: 'DeleteCorrectedInvoicePaymentPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteCreditNotePaymentMutationVariables = Exact<{
  creditNoteId: Scalars['ID']['input'];
  creditNotePaymentId: Scalars['ID']['input'];
}>;


export type DeleteCreditNotePaymentMutation = { __typename?: 'Mutation', deleteCreditNotePayment: { __typename?: 'DeleteCreditNotePaymentPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteInvoicePaymentMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  invoicePaymentId: Scalars['ID']['input'];
}>;


export type DeleteInvoicePaymentMutation = { __typename?: 'Mutation', deleteInvoicePayment: { __typename?: 'DeleteInvoicePaymentPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type GetAllCommercialDocumentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  ofStatus?: InputMaybe<Array<DocumentStatus> | DocumentStatus>;
  ofType?: InputMaybe<Array<DocumentType> | DocumentType>;
  startDate: Scalars['LocalDate']['input'];
  searchBy?: InputMaybe<Scalars['String']['input']>;
  isProforma?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetAllCommercialDocumentsQuery = { __typename?: 'Query', allCommercialDocuments?: { __typename?: 'AllCommercialDocumentsConnection', totalCount: number, nodes?: Array<{ __typename?: 'CommercialDocumentSummary', createdDate: string, documentRole: DocumentRole, documentType: DocumentType, dueDate?: string | null, grossTotal: number, issueDate?: string | null, netTotal: number, number?: string | null, projectId?: string | null, status: DocumentStatus, taxTotal: number, id?: string | null, paidTotal?: number | null, sentDate?: string | null, isInvalid?: boolean | null, isProforma: boolean, cancellationReason?: string | null, rejectionReason?: string | null, originalDocumentDate?: string | null, originalDocumentId?: string | null, originalDocumentNumber?: string | null, cancellationReversalDocumentId?: string | null, cancellationReversalDocumentSentDate?: string | null, openTotal?: number | null, client?: { __typename?: 'Contact', id: string, displayName: string } | null, clientContactPerson?: { __typename?: 'Contact', id: string, displayName: string, additionalInformation: Array<{ __typename?: 'AddressInformation' } | { __typename?: 'BillingInformation' } | { __typename?: 'ContactPersonInformation' } | { __typename?: 'ContractedInformation' } | { __typename?: 'DateInformation' } | { __typename?: 'DepartmentInformation' } | { __typename?: 'EmailInformation', emailAddress: string } | { __typename?: 'EmployeeWorkingConditionInformation' } | { __typename?: 'IsContactPersonOfInformation' } | { __typename?: 'PaymentConditionInformation' } | { __typename?: 'PaymentInformation' } | { __typename?: 'PhoneInformation' } | { __typename?: 'SalaryInformation' } | { __typename?: 'WebsiteInformation' } | { __typename?: 'WorkingConditionInformation' } | { __typename?: 'WorksInDepartmentInformation' }> } | null, contractor?: { __typename?: 'Contact', id: string, displayName: string } | null, project?: { __typename?: 'Project', id: string, name: string, number: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllCorrectedCreditNotePaymentsQueryVariables = Exact<{
  correctedCreditNoteId: Scalars['ID']['input'];
}>;


export type GetAllCorrectedCreditNotePaymentsQuery = { __typename?: 'Query', allCorrectedCreditNotePayments: Array<{ __typename?: 'PaymentItem', amount: number, creationDate: string, id: string, notes?: string | null, paymentDate: string, paymentMethod?: string | null }> };

export type GetAllCorrectedInvoicePaymentsQueryVariables = Exact<{
  correctedInvoiceId: Scalars['ID']['input'];
}>;


export type GetAllCorrectedInvoicePaymentsQuery = { __typename?: 'Query', allCorrectedInvoicePayments: Array<{ __typename?: 'PaymentItem', amount: number, creationDate: string, id: string, notes?: string | null, paymentDate: string, paymentMethod?: string | null }> };

export type GetAllCreditNotePaymentsQueryVariables = Exact<{
  creditNoteId: Scalars['ID']['input'];
}>;


export type GetAllCreditNotePaymentsQuery = { __typename?: 'Query', allCreditNotePayments: Array<{ __typename?: 'PaymentItem', amount: number, creationDate: string, id: string, notes?: string | null, paymentDate: string, paymentMethod?: string | null }> };

export type GetAllInvoicePaymentsQueryVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;


export type GetAllInvoicePaymentsQuery = { __typename?: 'Query', allInvoicePayments: Array<{ __typename?: 'PaymentItem', amount: number, creationDate: string, id: string, notes?: string | null, paymentDate: string, paymentMethod?: string | null }> };

export type GetInvoiceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInvoiceQuery = { __typename?: 'Query', node?: { __typename: 'Absence' } | { __typename: 'AbsenceReason' } | { __typename: 'AccountingProfile' } | { __typename: 'BccRecipientList' } | { __typename: 'CalendarEvent' } | { __typename: 'CatalogEntry' } | { __typename: 'Contact' } | { __typename: 'CorrectedCreditNote' } | { __typename: 'CorrectedInvoice' } | { __typename: 'CreditNote' } | { __typename: 'Department' } | { __typename: 'DiscountProfile' } | { __typename: 'DunningLevel' } | { __typename: 'Email' } | { __typename: 'FileEntry' } | { __typename: 'FolderEntry' } | { __typename: 'Invoice', clientId?: string | null, concludingText?: string | null, contractorId?: string | null, createdDate: string, documentRole: DocumentRole, documentType: DocumentType, dueDate?: string | null, grossTotal: number, id: string, introductoryText: string, isDeleted: boolean, isReversal: boolean, issueDate?: string | null, netTotal: number, notes?: string | null, number?: string | null, openTotal: number, paidTotal: number, paymentDeadlineInDays: number, projectId?: string | null, status: DocumentStatus, taxTotal: number, timestamp: string, createdById: string, clientContactPersonId?: string | null, isInvalid: boolean, isProforma: boolean, billTo: { __typename?: 'GenericAddress', line1: string, line2: string, line3: string, line4: string, line5: string }, items: Array<{ __typename?: 'LineItem', description: string, discountPercent?: number | null, id: string, lineGrossTotal: number, lineNetTotal: number, lineTaxTotal: number, positionNo: number, quantity: number, unit: string, unitPriceNet: number, tax: number, taxCode: string, name: string }>, shipTo?: { __typename?: 'GenericAddress', line1: string, line2: string, line3: string, line4: string, line5: string } | null, cancellation?: { __typename?: 'CancellationInfo', at: string, externalRef?: string | null, mode: CancellationMode, reason: string, reversalDocumentId?: string | null } | null } | { __typename: 'Offer' } | { __typename: 'Project' } | { __typename: 'ProjectTimeApproval' } | { __typename: 'ProjectTimeEntry' } | { __typename: 'RollingNumber' } | { __typename: 'SaleableService' } | { __typename: 'SaleableServiceGroup' } | { __typename: 'SaleableUnit' } | { __typename: 'Template' } | { __typename: 'TimeBalanceEntry' } | { __typename: 'TimeEntry' } | { __typename: 'TimeLabel' } | { __typename: 'TimeLabelGroup' } | { __typename: 'User' } | { __typename: 'UserGroup' } | { __typename: 'WorkingTimeModel' } | null };

export type RecordCorrectedCreditNotePaymentMutationVariables = Exact<{
  amount: Scalars['Decimal']['input'];
  correctedCreditNoteId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentDate: Scalars['LocalDate']['input'];
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecordCorrectedCreditNotePaymentMutation = { __typename?: 'Mutation', recordCorrectedCreditNotePayment: { __typename?: 'RecordCorrectedCreditNotePaymentPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, correctedCreditNote?: { __typename?: 'CorrectedCreditNote', payments?: Array<{ __typename?: 'PaymentItem', amount: number, creationDate: string, id: string, notes?: string | null, paymentDate: string, paymentMethod?: string | null, documentId: string }> | null } | null } };

export type RecordCorrectedInvoicePaymentMutationVariables = Exact<{
  amount: Scalars['Decimal']['input'];
  correctedInvoiceId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentDate: Scalars['LocalDate']['input'];
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecordCorrectedInvoicePaymentMutation = { __typename?: 'Mutation', recordCorrectedInvoicePayment: { __typename?: 'RecordCorrectedInvoicePaymentPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, correctedInvoice?: { __typename?: 'CorrectedInvoice', payments?: Array<{ __typename?: 'PaymentItem', amount: number, creationDate: string, id: string, notes?: string | null, paymentDate: string, paymentMethod?: string | null, documentId: string }> | null } | null } };

export type RecordCreditNotePaymentMutationVariables = Exact<{
  amount: Scalars['Decimal']['input'];
  creditNoteId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentDate: Scalars['LocalDate']['input'];
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecordCreditNotePaymentMutation = { __typename?: 'Mutation', recordCreditNotePayment: { __typename?: 'RecordCreditNotePaymentPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, creditNote?: { __typename?: 'CreditNote', payments?: Array<{ __typename?: 'PaymentItem', amount: number, creationDate: string, id: string, notes?: string | null, paymentDate: string, paymentMethod?: string | null, documentId: string }> | null } | null } };

export type RecordInvoicePaymentMutationVariables = Exact<{
  amount: Scalars['Decimal']['input'];
  invoiceId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentDate: Scalars['LocalDate']['input'];
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecordInvoicePaymentMutation = { __typename?: 'Mutation', recordInvoicePayment: { __typename?: 'RecordInvoicePaymentPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, invoice?: { __typename?: 'Invoice', payments?: Array<{ __typename?: 'PaymentItem', amount: number, creationDate: string, id: string, notes?: string | null, paymentDate: string, paymentMethod?: string | null, documentId: string }> | null } | null } };

export type ValidateXmlQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type ValidateXmlQuery = { __typename?: 'Query', validateXml: { __typename?: 'XmlValidationResult', isValid: boolean, errors: Array<{ __typename?: 'InvoiceValidationError', btCode: string, fieldPath: string, message: string }> } };

export type GetEligibleTimesheetsForBillingQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  month: Scalars['LocalDate']['input'];
}>;


export type GetEligibleTimesheetsForBillingQuery = { __typename?: 'Query', eligibleTimesheetsForBilling: Array<{ __typename?: 'EligibleTimesheetForBillingType', timesheetId: string, number: string, from: string, to: string, totalHours: number, requiresCreditNote: boolean, hasClientInvoice: boolean, hasSupplierCreditNote: boolean, requiresContractorCreditNote: boolean, hasContractorCreditNote: boolean, employee: { __typename?: 'Contact', id: string, displayName: string } }> };

export type GetMonthlyBillingEligibilityQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  month: Scalars['LocalDate']['input'];
}>;


export type GetMonthlyBillingEligibilityQuery = { __typename?: 'Query', monthlyBillingEligibility: { __typename?: 'MonthlyBillingEligibilityType', isEligible: boolean, eligibleTimesheetIds: Array<string>, eligibleSupplierIds: Array<string>, ineligibilityReason?: string | null } };

export type GetMonthlyOverviewChildrenQueryVariables = Exact<{
  parentId: Scalars['String']['input'];
  parentPath: Array<Scalars['String']['input']> | Scalars['String']['input'];
  parentType: OverviewItemType;
  month: Scalars['LocalDate']['input'];
  employeeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetMonthlyOverviewChildrenQuery = { __typename?: 'Query', monthlyOverviewChildren: Array<{ __typename?: 'MonthlyProjectOverviewItem', id: string, itemType: OverviewItemType, projectId?: string | null, projectName?: string | null, projectNumber?: string | null, projectType?: ProjectType | null, isGroup: boolean, isInternalProjectsGroup: boolean, clientId?: string | null, employeeId?: string | null, timesheetId?: string | null, timesheetNumber?: string | null, timesheetStatus?: ApprovalTimeEntryStatus | null, timesheetFrom?: string | null, timesheetTo?: string | null, openMinutes: number, pendingMinutes: number, approvedMinutes: number, totalMinutes: number, path: Array<string>, parentId?: string | null, canCreateInvoice: boolean, canCreateCreditNote: boolean, canCreateMonthlyBilling: boolean, budgetStatus?: { __typename?: 'BudgetStatus', totalBudgetAmount: number, totalBudgetMinutes: number, spentAmount: number, spentMinutes: number, openMinutes: number, pendingMinutes: number, approvedMinutes: number, remainingAmount: number, remainingMinutes: number, utilizationPercent: number, minutesUtilizationPercent: number } | null, client?: { __typename?: 'Contact', id: string, displayName: string } | null, employee?: { __typename?: 'Contact', id: string, displayName: string } | null, clientInvoices: Array<{ __typename?: 'InvoiceReference', invoiceId: string, status: InvoiceDocumentStatus, createdAt: string }>, supplierCreditNotes: Array<{ __typename?: 'CreditNoteReference', creditNoteId: string, status: InvoiceDocumentStatus, createdAt: string }>, project?: { __typename?: 'ProjectSummary', id: string, name: string, number: string } | null }> };

export type GetMonthlyOverviewRootsQueryVariables = Exact<{
  month: Scalars['LocalDate']['input'];
  clientId?: InputMaybe<Scalars['ID']['input']>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  excludeEmptyTenders?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFullyInvoiced?: InputMaybe<Scalars['Boolean']['input']>;
  groupByClient?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMonthlyOverviewRootsQuery = { __typename?: 'Query', monthlyOverviewRoots: { __typename?: 'MonthlyOverviewRootsResultType', totalCount: number, hasNextPage: boolean, endCursor?: string | null, nodes: Array<{ __typename?: 'MonthlyProjectOverviewItem', id: string, itemType: OverviewItemType, projectId?: string | null, projectName?: string | null, projectNumber?: string | null, projectType?: ProjectType | null, isGroup: boolean, isInternalProjectsGroup: boolean, clientId?: string | null, employeeId?: string | null, timesheetId?: string | null, timesheetNumber?: string | null, timesheetStatus?: ApprovalTimeEntryStatus | null, timesheetFrom?: string | null, timesheetTo?: string | null, openMinutes: number, pendingMinutes: number, approvedMinutes: number, totalMinutes: number, path: Array<string>, parentId?: string | null, canCreateInvoice: boolean, canCreateCreditNote: boolean, canCreateMonthlyBilling: boolean, budgetStatus?: { __typename?: 'BudgetStatus', totalBudgetAmount: number, totalBudgetMinutes: number, spentAmount: number, spentMinutes: number, openMinutes: number, pendingMinutes: number, approvedMinutes: number, remainingAmount: number, remainingMinutes: number, utilizationPercent: number, minutesUtilizationPercent: number } | null, client?: { __typename?: 'Contact', id: string, displayName: string } | null, employee?: { __typename?: 'Contact', id: string, displayName: string } | null, clientInvoices: Array<{ __typename?: 'InvoiceReference', invoiceId: string, status: InvoiceDocumentStatus, createdAt: string }>, supplierCreditNotes: Array<{ __typename?: 'CreditNoteReference', creditNoteId: string, status: InvoiceDocumentStatus, createdAt: string }>, project?: { __typename?: 'ProjectSummary', id: string, name: string, number: string } | null }> } };

export type MonthlyOverviewItemFieldsFragment = { __typename?: 'MonthlyProjectOverviewItem', id: string, itemType: OverviewItemType, projectId?: string | null, projectName?: string | null, projectNumber?: string | null, projectType?: ProjectType | null, isGroup: boolean, isInternalProjectsGroup: boolean, clientId?: string | null, employeeId?: string | null, timesheetId?: string | null, timesheetNumber?: string | null, timesheetStatus?: ApprovalTimeEntryStatus | null, timesheetFrom?: string | null, timesheetTo?: string | null, openMinutes: number, pendingMinutes: number, approvedMinutes: number, totalMinutes: number, path: Array<string>, parentId?: string | null, canCreateInvoice: boolean, canCreateCreditNote: boolean, canCreateMonthlyBilling: boolean, budgetStatus?: { __typename?: 'BudgetStatus', totalBudgetAmount: number, totalBudgetMinutes: number, spentAmount: number, spentMinutes: number, openMinutes: number, pendingMinutes: number, approvedMinutes: number, remainingAmount: number, remainingMinutes: number, utilizationPercent: number, minutesUtilizationPercent: number } | null, client?: { __typename?: 'Contact', id: string, displayName: string } | null, employee?: { __typename?: 'Contact', id: string, displayName: string } | null, clientInvoices: Array<{ __typename?: 'InvoiceReference', invoiceId: string, status: InvoiceDocumentStatus, createdAt: string }>, supplierCreditNotes: Array<{ __typename?: 'CreditNoteReference', creditNoteId: string, status: InvoiceDocumentStatus, createdAt: string }>, project?: { __typename?: 'ProjectSummary', id: string, name: string, number: string } | null };

export type RefreshMonthlyInvoiceStatusesMutationVariables = Exact<{
  month: Scalars['LocalDate']['input'];
}>;


export type RefreshMonthlyInvoiceStatusesMutation = { __typename?: 'Mutation', refreshMonthlyInvoiceStatuses: { __typename?: 'RefreshMonthlyInvoiceStatusesPayload', refreshMonthlyInvoiceStatusesResult?: { __typename?: 'RefreshMonthlyInvoiceStatusesResult', updatedInvoices: number, updatedCreditNotes: number } | null, errors?: Array<{ __typename?: 'DomainError', message: string } | { __typename?: 'PropertyValidationError', message: string, errors: Array<{ __typename?: 'PropertyError', propertyName: string, errorMessage: string }> }> | null } };

export type RequestMonthlyBillingMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  month: Scalars['LocalDate']['input'];
  timesheetIdsForInvoice: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  timesheetIdsForCreditNotes: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  timesheetIdsForContractorCreditNotes: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RequestMonthlyBillingMutation = { __typename?: 'Mutation', requestMonthlyBilling: { __typename?: 'RequestMonthlyBillingPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', message: string } | { __typename?: 'PropertyValidationError', message: string, errors: Array<{ __typename?: 'PropertyError', propertyName: string, errorMessage: string }> }> | null } };

export type SearchMonthlyOverviewQueryVariables = Exact<{
  month: Scalars['LocalDate']['input'];
  projectName: Scalars['String']['input'];
  clientId?: InputMaybe<Scalars['ID']['input']>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  excludeEmptyTenders?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFullyInvoiced?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchMonthlyOverviewQuery = { __typename?: 'Query', searchMonthlyOverview: { __typename?: 'MonthlyOverviewSearchResultType', totalCount: number, matchedProjectIds: Array<string>, items: Array<{ __typename?: 'MonthlyProjectOverviewItem', id: string, itemType: OverviewItemType, projectId?: string | null, projectName?: string | null, projectNumber?: string | null, projectType?: ProjectType | null, isGroup: boolean, isInternalProjectsGroup: boolean, clientId?: string | null, employeeId?: string | null, timesheetId?: string | null, timesheetNumber?: string | null, timesheetStatus?: ApprovalTimeEntryStatus | null, timesheetFrom?: string | null, timesheetTo?: string | null, openMinutes: number, pendingMinutes: number, approvedMinutes: number, totalMinutes: number, path: Array<string>, parentId?: string | null, canCreateInvoice: boolean, canCreateCreditNote: boolean, canCreateMonthlyBilling: boolean, budgetStatus?: { __typename?: 'BudgetStatus', totalBudgetAmount: number, totalBudgetMinutes: number, spentAmount: number, spentMinutes: number, openMinutes: number, pendingMinutes: number, approvedMinutes: number, remainingAmount: number, remainingMinutes: number, utilizationPercent: number, minutesUtilizationPercent: number } | null, client?: { __typename?: 'Contact', id: string, displayName: string } | null, employee?: { __typename?: 'Contact', id: string, displayName: string } | null, clientInvoices: Array<{ __typename?: 'InvoiceReference', invoiceId: string, status: InvoiceDocumentStatus, createdAt: string }>, supplierCreditNotes: Array<{ __typename?: 'CreditNoteReference', creditNoteId: string, status: InvoiceDocumentStatus, createdAt: string }>, project?: { __typename?: 'ProjectSummary', id: string, name: string, number: string } | null }> } };

export type AcceptTimeApprovalMutationVariables = Exact<{
  description?: InputMaybe<Scalars['String']['input']>;
  projectTimeApprovalId: Scalars['ID']['input'];
}>;


export type AcceptTimeApprovalMutation = { __typename?: 'Mutation', acceptTimeApproval: { __typename?: 'AcceptTimeApprovalPayload', projectTimeApproval?: { __typename?: 'ProjectTimeApproval', description: string, id: string, number: string, status: ApprovalTimeEntryStatus, timestamp: string, totalMinutes: number, from: string, to: string, project: { __typename?: 'ProjectSummary', id: string, name: string }, employee: { __typename?: 'Contact', id: string, displayName: string }, createdBy: { __typename?: 'Contact', id: string, displayName: string }, history: Array<{ __typename?: 'ProjectTimeApprovalHistory', description: string, status: ApprovalTimeEntryStatus, timestamp: string, createdBy: { __typename?: 'Contact', id: string, displayName: string } }> } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type AddServicesToProjectMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  serviceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddServicesToProjectMutation = { __typename?: 'Mutation', addServicesToProject: { __typename?: 'AddServicesToProjectPayload', project?: { __typename: 'Project', id: string, isDeleted: boolean, name: string, isGroup: boolean, isRoot: boolean, number: string, path: Array<string>, projectType: ProjectType, status: ProjectStatus, createdById: string, parentProjectId?: string | null, parentProjectName?: string | null, timestamp: string, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, range: { __typename?: 'DateOnlyRange', from: string, to: string }, additionalInformation: Array<{ __typename: 'AdditionalAccountingInformation', provision?: number | null, timeTrackingResolution: number, id: string, clientContractNumber?: string | null, clientOrderingDate?: string | null, clientContratDate?: string | null, clientOrderingNumber?: string | null, clientProjectNumber?: string | null, supplierProjectNumber?: string | null, accountingProfile?: { __typename?: 'AccountingProfile', name: string, id: string } | null } | { __typename: 'AdditionalContactInformation', clientId?: string | null, contractorId: string, endCustomer: string, id: string, client?: { __typename?: 'Contact', id: string, displayName: string } | null, contractor: { __typename?: 'Contact', id: string, displayName: string } } | { __typename: 'AdditionalContactPersonInformation', clientContactPersonId?: string | null, contractorContactPersonId?: string | null, contractorProjectLeaderId?: string | null, id: string, clientContactPerson?: { __typename?: 'Contact', id: string, displayName: string } | null, contractorContactPerson?: { __typename?: 'Contact', id: string, displayName: string } | null, contractorProjectLeader?: { __typename?: 'Contact', id: string, displayName: string } | null } | { __typename: 'AdditionalPositionInformation', hours?: number | null, pricePerHour?: number | null, saleableServiceId: string, serviceName: string, servicePrice: number, id: string, price?: number | null, priceRate?: ProjectPositionPriceRateType | null } | { __typename: 'AdditionalTeamMemberInformation', employeeId?: string | null, id: string, worksOnPositions: Array<{ __typename?: 'WorksOnPosition', positionId: string, pricePerHour?: number | null, hours?: number | null }>, employee?: { __typename?: 'Contact', id: string, displayName: string, isAFreelancer: boolean, additionalInformation: Array<{ __typename: 'AddressInformation', id: string } | { __typename: 'BillingInformation', id: string } | { __typename: 'ContactPersonInformation', id: string } | { __typename: 'ContractedInformation', id: string } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', id: string } | { __typename: 'EmailInformation', id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string } | { __typename: 'PhoneInformation', id: string } | { __typename: 'SalaryInformation', pricePerHour: number, startDate: string, id: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', id: string } | { __typename: 'WorksInDepartmentInformation', id: string }> } | null } | { __typename: 'AdditionalTemplateInformation', id: string }>, saleableServiceGroups: Array<{ __typename?: 'ProjectSaleableServiceGroup', hasFixSellingPrice: boolean, id: string, name: string, originalId: string, sellingPrice: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, services: Array<{ __typename?: 'ProjectSaleableService', hasFixSellingPrice: boolean, id: string, name: string, originalId: string, purchasePrice: number, sellingPrice: number, vatRate: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, unit?: { __typename?: 'ProjectSaleableUnit', id: string, name: string, originalId: string, shortCode: string } | null }> }>, saleableServices: Array<{ __typename?: 'ProjectSaleableService', hasFixSellingPrice: boolean, id: string, name: string, originalId: string, purchasePrice: number, sellingPrice: number, vatRate: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, unit?: { __typename?: 'ProjectSaleableUnit', id: string, name: string, originalId: string, shortCode: string } | null }>, saleableUnits: Array<{ __typename?: 'ProjectSaleableUnit', id: string, name: string, originalId: string, shortCode: string }>, createdBy: { __typename?: 'Contact', id: string, displayName: string } } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type AvailableServicesForProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AvailableServicesForProjectQuery = { __typename?: 'Query', availableServicesForProject: Array<{ __typename?: 'AvailableServiceGroup', id: string, name: string, services: Array<{ __typename?: 'AvailableService', hasFixSellingPrice: boolean, id: string, name: string, price: number, purchasePrice: number, sellingPrice: number, unitName?: string | null, vatRate: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number } }> }> };

export type CreateProjectMutationVariables = Exact<{
  name: Scalars['String']['input'];
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
  type: ProjectType;
  parentProject?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'CreateProjectPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, project?: { __typename?: 'Project', id: string, isDeleted: boolean, name: string, number: string, createdById: string, isGroup: boolean, isRoot: boolean, path: Array<string>, parentProjectId?: string | null, projectType: ProjectType, status: ProjectStatus, timestamp: string, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, range: { __typename?: 'DateOnlyRange', from: string, to: string }, additionalInformation: Array<{ __typename: 'AdditionalAccountingInformation', accountingProfileId?: string | null, provision?: number | null, timeTrackingResolution: number, clientContractNumber?: string | null, clientContratDate?: string | null, clientOrderingDate?: string | null, clientOrderingNumber?: string | null, clientProjectNumber?: string | null, supplierProjectNumber?: string | null, id: string } | { __typename: 'AdditionalContactInformation', clientId?: string | null, contractorId: string, endCustomer: string, id: string, client?: { __typename?: 'Contact', id: string, displayName: string } | null, contractor: { __typename?: 'Contact', id: string, displayName: string } } | { __typename: 'AdditionalContactPersonInformation', clientContactPersonId?: string | null, contractorContactPersonId?: string | null, contractorProjectLeaderId?: string | null, id: string, clientContactPerson?: { __typename?: 'Contact', id: string, displayName: string } | null, contractorContactPerson?: { __typename?: 'Contact', id: string, displayName: string } | null, contractorProjectLeader?: { __typename?: 'Contact', id: string, displayName: string } | null } | { __typename: 'AdditionalPositionInformation', hours?: number | null, saleableServiceId: string, pricePerHour?: number | null, price?: number | null, priceRate?: ProjectPositionPriceRateType | null, id: string } | { __typename: 'AdditionalTeamMemberInformation', employeeId?: string | null, id: string, worksOnPositions: Array<{ __typename?: 'WorksOnPosition', positionId: string, pricePerHour?: number | null, hours?: number | null }>, employee?: { __typename?: 'Contact', id: string, displayName: string } | null } | { __typename: 'AdditionalTemplateInformation', id: string }>, saleableServiceGroups: Array<{ __typename?: 'ProjectSaleableServiceGroup', hasFixSellingPrice: boolean, id: string, name: string, originalId: string, sellingPrice: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, services: Array<{ __typename?: 'ProjectSaleableService', hasFixSellingPrice: boolean, id: string, name: string, originalId: string, purchasePrice: number, sellingPrice: number, vatRate: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, unit?: { __typename?: 'ProjectSaleableUnit', id: string, name: string, originalId: string, shortCode: string } | null }> }>, saleableServices: Array<{ __typename?: 'ProjectSaleableService', hasFixSellingPrice: boolean, id: string, name: string, originalId: string, purchasePrice: number, sellingPrice: number, vatRate: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, unit?: { __typename?: 'ProjectSaleableUnit', id: string, name: string, originalId: string, shortCode: string } | null }>, saleableUnits: Array<{ __typename?: 'ProjectSaleableUnit', id: string, name: string, originalId: string, shortCode: string }>, createdBy: { __typename?: 'Contact', id: string, displayName: string } } | null } };

export type CreateProjectAdditionalAccountingInformationMutationVariables = Exact<{
  accountingProfileId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  provision?: InputMaybe<Scalars['Decimal']['input']>;
  timeTrackingResolution: Scalars['Int']['input'];
  clientContractNumber?: InputMaybe<Scalars['String']['input']>;
  clientContratDate?: InputMaybe<Scalars['LocalDate']['input']>;
  clientOrderingDate?: InputMaybe<Scalars['LocalDate']['input']>;
  clientOrderingNumber?: InputMaybe<Scalars['String']['input']>;
  clientProjectNumber?: InputMaybe<Scalars['String']['input']>;
  supplierProjectNumber?: InputMaybe<Scalars['String']['input']>;
  provisionDescription?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateProjectAdditionalAccountingInformationMutation = { __typename?: 'Mutation', createProjectAdditionalAccountingInformation: { __typename?: 'CreateProjectAdditionalAccountingInformationPayload', additionalAccountingInformation?: { __typename?: 'AdditionalAccountingInformation', id: string, accountingProfileId?: string | null, provision?: number | null, provisionDescription?: string | null, timeTrackingResolution: number, clientContractNumber?: string | null, clientContratDate?: string | null, clientOrderingDate?: string | null, clientOrderingNumber?: string | null, clientProjectNumber?: string | null, supplierProjectNumber?: string | null } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type CreateProjectAdditionalContactInformationMutationVariables = Exact<{
  clientId?: InputMaybe<Scalars['ID']['input']>;
  contractorId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  endCustomer?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateProjectAdditionalContactInformationMutation = { __typename?: 'Mutation', createProjectAdditionalContactInformation: { __typename?: 'CreateProjectAdditionalContactInformationPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, additionalContactInformation?: { __typename?: 'AdditionalContactInformation', clientId?: string | null, contractorId: string, endCustomer: string, id: string } | null } };

export type CreateProjectAdditionalContactPersonInformationMutationVariables = Exact<{
  clientContactId?: InputMaybe<Scalars['ID']['input']>;
  contractorContactId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  contractorProjectLeaderId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateProjectAdditionalContactPersonInformationMutation = { __typename?: 'Mutation', createProjectAdditionalContactPersonInformation: { __typename?: 'CreateProjectAdditionalContactPersonInformationPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, additionalContactPersonInformation?: { __typename?: 'AdditionalContactPersonInformation', clientContactPersonId?: string | null, contractorContactPersonId?: string | null, contractorProjectLeaderId?: string | null, id: string } | null } };

export type CreateProjectAdditionalPositionInformationMutationVariables = Exact<{
  hours?: InputMaybe<Scalars['Decimal']['input']>;
  pricePerHour?: InputMaybe<Scalars['Decimal']['input']>;
  projectId: Scalars['ID']['input'];
  saleableServiceId: Scalars['String']['input'];
  serviceName: Scalars['String']['input'];
  servicePrice: Scalars['Decimal']['input'];
  price?: InputMaybe<Scalars['Decimal']['input']>;
  priceRate?: InputMaybe<ProjectPositionPriceRateType>;
  accountingProfileId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateProjectAdditionalPositionInformationMutation = { __typename?: 'Mutation', createProjectAdditionalPositionInformation: { __typename?: 'CreateProjectAdditionalPositionInformationPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, additionalPositionInformation?: { __typename?: 'AdditionalPositionInformation', hours?: number | null, id: string, pricePerHour?: number | null, saleableServiceId: string, serviceName: string, servicePrice: number, price?: number | null, priceRate?: ProjectPositionPriceRateType | null } | null } };

export type CreateProjectAdditionalTeamMemberInformationMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  memberId?: InputMaybe<Scalars['ID']['input']>;
  worksOnPositions: Array<WorksOnPositionInput> | WorksOnPositionInput;
  contractorId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateProjectAdditionalTeamMemberInformationMutation = { __typename?: 'Mutation', createProjectAdditionalTeamMemberInformation: { __typename?: 'CreateProjectAdditionalTeamMemberInformationPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, additionalTeamMemberInformation?: { __typename: 'AdditionalTeamMemberInformation', employeeId?: string | null, id: string, worksOnPositions: Array<{ __typename?: 'WorksOnPosition', positionId: string, pricePerHour?: number | null, hours?: number | null }>, employee?: { __typename?: 'Contact', id: string, displayName: string } | null } | null } };

export type CreateProjectAdditionalTemplateInformationMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  isInvoiceWithTimesheet: Scalars['Boolean']['input'];
  isDetailTimesheet: Scalars['Boolean']['input'];
}>;


export type CreateProjectAdditionalTemplateInformationMutation = { __typename?: 'Mutation', createProjectAdditionalTemplateInformation: { __typename?: 'CreateProjectAdditionalTemplateInformationPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, additionalTemplateInformation?: { __typename?: 'AdditionalTemplateInformation', id: string, isInvoiceWithTimesheet: boolean, isDetailTimesheet: boolean } | null } };

export type CreateProjectSaleableServiceMutationVariables = Exact<{
  budget: BudgetInput;
  groupId: Scalars['ID']['input'];
  hasFixSellingPrice: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  originalServiceId: Scalars['String']['input'];
  purchasePrice: Scalars['Decimal']['input'];
  sellingPrice: Scalars['Decimal']['input'];
  projectId: Scalars['ID']['input'];
  unitId: Scalars['ID']['input'];
  vatRate: Scalars['Decimal']['input'];
}>;


export type CreateProjectSaleableServiceMutation = { __typename?: 'Mutation', createProjectSaleableService: { __typename?: 'CreateProjectSaleableServicePayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, projectSaleableService?: { __typename?: 'ProjectSaleableService', hasFixSellingPrice: boolean, id: string, originalId: string, name: string, purchasePrice: number, sellingPrice: number, vatRate: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, unit?: { __typename?: 'ProjectSaleableUnit', id: string, originalId: string, name: string, shortCode: string } | null } | null } };

export type CreateProjectSaleableServiceGroupMutationVariables = Exact<{
  budget: BudgetInput;
  hasFixSellingPrice: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  originalGroupId: Scalars['String']['input'];
  sellingPrice: Scalars['Decimal']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type CreateProjectSaleableServiceGroupMutation = { __typename?: 'Mutation', createProjectSaleableServiceGroup: { __typename?: 'CreateProjectSaleableServiceGroupPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, projectSaleableServiceGroup?: { __typename?: 'ProjectSaleableServiceGroup', hasFixSellingPrice: boolean, id: string, originalId: string, name: string, sellingPrice: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, services: Array<{ __typename?: 'ProjectSaleableService', hasFixSellingPrice: boolean, id: string, originalId: string, name: string, purchasePrice: number, sellingPrice: number, vatRate: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, unit?: { __typename?: 'ProjectSaleableUnit', id: string, originalId: string, name: string, shortCode: string } | null }> } | null } };

export type CreateProjectSaleableUnitMutationVariables = Exact<{
  name: Scalars['String']['input'];
  originalUnitId: Scalars['String']['input'];
  shortCode: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type CreateProjectSaleableUnitMutation = { __typename?: 'Mutation', createProjectSaleableUnit: { __typename?: 'CreateProjectSaleableUnitPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, projectSaleableUnit?: { __typename?: 'ProjectSaleableUnit', id: string, originalId: string, name: string, shortCode: string } | null } };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject: { __typename?: 'DeleteProjectPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteProjectAdditionalInformationMutationVariables = Exact<{
  informationId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type DeleteProjectAdditionalInformationMutation = { __typename?: 'Mutation', deleteProjectAdditionalInformation: { __typename?: 'DeleteProjectAdditionalInformationPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteProjectSaleableServiceMutationVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type DeleteProjectSaleableServiceMutation = { __typename?: 'Mutation', deleteProjectSaleableService: { __typename?: 'DeleteProjectSaleableServicePayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteProjectSaleableServiceGroupMutationVariables = Exact<{
  serviceGroupId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type DeleteProjectSaleableServiceGroupMutation = { __typename?: 'Mutation', deleteProjectSaleableServiceGroup: { __typename?: 'DeleteProjectSaleableServiceGroupPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteProjectSaleableServiceUnitMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type DeleteProjectSaleableServiceUnitMutation = { __typename?: 'Mutation', deleteProjectSaleableUnit: { __typename?: 'DeleteProjectSaleableUnitPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteTimeApprovalMutationVariables = Exact<{
  description?: InputMaybe<Scalars['String']['input']>;
  projectTimeApprovalId: Scalars['ID']['input'];
}>;


export type DeleteTimeApprovalMutation = { __typename?: 'Mutation', deleteTimeApproval: { __typename?: 'DeleteTimeApprovalPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DownloadTimeSheetQueryVariables = Exact<{
  projectTimeApprovalId: Scalars['ID']['input'];
}>;


export type DownloadTimeSheetQuery = { __typename?: 'Query', downloadTimeSheet: string };

export type GetAllClientProjectsQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllClientProjectsQuery = { __typename?: 'Query', allProjectIdsOfClient?: { __typename?: 'AllProjectIdsOfClientConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProjectSummary', id: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllProjectTimeEntriesQueryVariables = Exact<{
  startDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
  employeeId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type GetAllProjectTimeEntriesQuery = { __typename?: 'Query', allProjectTimeEntries: Array<{ __typename?: 'ProjectTimeEntryDayGroup', absenceReason?: string | null, approvedWorkingMinutes: number, date: string, errors: Array<ProjectTimeEntryDayGroupErrors>, id: string, pendingWorkingMinutes: number, rejectedWorkingMinutes: number, requiredWorkingMinutes: number, workingMinutes: number, items: Array<{ __typename?: 'ProjectTimeEntry', createdById: string, description: string, end: string, errors: Array<ProjectTimeEntryDayGroupErrors>, id: string, memberId: string, projectId: string, projectPositionId: string, start: string, status: ProjectTimeEntryStatus, timestamp: string, version: number, createdBy: { __typename?: 'Contact', id: string, displayName: string }, history: Array<{ __typename?: 'ProjectTimeEntryHistory', createdById: string, description: string, end: string, memberId: string, projectId: string, projectPositionId: string, start: string, status: ProjectTimeEntryStatus, timestamp: string, version: number, createdBy: { __typename?: 'Contact', id: string, displayName: string }, member: { __typename?: 'Contact', id: string, displayName: string }, projectPosition: { __typename?: 'DetailProjectPosition', projectName: string, saleableServiceName: string } }>, logs: Array<{ __typename?: 'ProjectTimeLogEntry', createdById: string, id: string, message: string, timestamp: string, createdBy: { __typename?: 'Contact', id: string, displayName: string } }>, member: { __typename?: 'Contact', id: string, displayName: string } }> }> };

export type GetAllProjectsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProjectType>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderType>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ProjectStatus>;
}>;


export type GetAllProjectsQuery = { __typename?: 'Query', allRootProjects?: { __typename?: 'AllRootProjectsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProjectSummary', id: string, isDeleted: boolean, name: string, number: string, path: Array<string>, isRoot: boolean, isGroup: boolean, projectType: ProjectType, status: ProjectStatus, createdById: string, parentProjectId?: string | null, timestamp: string, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, range: { __typename?: 'DateOnlyRange', from: string, to: string }, createdBy: { __typename?: 'Contact', id: string, displayName: string } }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllProjectsNameQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProjectType>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderType>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllProjectsNameQuery = { __typename?: 'Query', allProjects?: { __typename?: 'AllProjectsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProjectSummary', id: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllProjectsPlainQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProjectType>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderType>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllProjectsPlainQuery = { __typename?: 'Query', allProjects?: { __typename?: 'AllProjectsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProjectSummary', id: string, isDeleted: boolean, name: string, number: string, path: Array<string>, isRoot: boolean, isGroup: boolean, projectType: ProjectType, status: ProjectStatus, createdById: string, parentProjectId?: string | null, timestamp: string, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, range: { __typename?: 'DateOnlyRange', from: string, to: string }, createdBy: { __typename?: 'Contact', id: string, displayName: string } }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllRootProjectSummariesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProjectType>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderType>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ProjectStatus>;
}>;


export type GetAllRootProjectSummariesQuery = { __typename?: 'Query', allRootProjects?: { __typename?: 'AllRootProjectsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProjectSummary', id: string, isDeleted: boolean, name: string, number: string, validationStatus: ValidationStatus, path: Array<string>, isRoot: boolean, isGroup: boolean, projectType: ProjectType, status: ProjectStatus, isManualStatusOverride: boolean, createdById: string, parentProjectId?: string | null, parentProjectName?: string | null, timestamp: string, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, budgetStatus: { __typename?: 'BudgetStatus', totalBudgetAmount: number, totalBudgetMinutes: number, spentAmount: number, spentMinutes: number, remainingAmount: number, remainingMinutes: number, utilizationPercent: number, openMinutes: number, pendingMinutes: number, approvedMinutes: number }, range: { __typename?: 'DateOnlyRange', from: string, to: string }, client?: { __typename?: 'Contact', id: string, displayName: string } | null, contractor?: { __typename?: 'Contact', id: string, displayName: string } | null, createdBy: { __typename?: 'Contact', id: string, displayName: string } }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllSubProjectsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllSubProjectsQuery = { __typename?: 'Query', allSubProjects: Array<{ __typename?: 'ProjectSummary', id: string, isDeleted: boolean, name: string, number: string, validationStatus: ValidationStatus, path: Array<string>, isRoot: boolean, isGroup: boolean, projectType: ProjectType, status: ProjectStatus, isManualStatusOverride: boolean, createdById: string, parentProjectId?: string | null, parentProjectName?: string | null, timestamp: string, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, budgetStatus: { __typename?: 'BudgetStatus', totalBudgetAmount: number, totalBudgetMinutes: number, spentAmount: number, spentMinutes: number, remainingAmount: number, remainingMinutes: number, utilizationPercent: number, openMinutes: number, pendingMinutes: number, approvedMinutes: number }, range: { __typename?: 'DateOnlyRange', from: string, to: string }, client?: { __typename?: 'Contact', id: string, displayName: string } | null, contractor?: { __typename?: 'Contact', id: string, displayName: string } | null, createdBy: { __typename?: 'Contact', id: string, displayName: string } }> };

export type GetAllTimeApprovalsQueryVariables = Exact<{
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['LocalDate']['input'];
  end: Scalars['LocalDate']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ApprovalTimeEntryStatus> | ApprovalTimeEntryStatus>;
}>;


export type GetAllTimeApprovalsQuery = { __typename?: 'Query', allTimeApprovals?: { __typename?: 'AllTimeApprovalsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProjectTimeApproval', id: string, timestamp: string, description: string, number: string, status: ApprovalTimeEntryStatus, totalMinutes: number, from: string, to: string, createdBy: { __typename?: 'Contact', id: string, displayName: string }, history: Array<{ __typename?: 'ProjectTimeApprovalHistory', createdById: string, timestamp: string, description: string, status: ApprovalTimeEntryStatus, createdBy: { __typename?: 'Contact', id: string, displayName: string } }>, employee: { __typename?: 'Contact', id: string, displayName: string }, project: { __typename?: 'ProjectSummary', id: string, name: string } }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAvailableServicesForProjectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetAvailableServicesForProjectQuery = { __typename?: 'Query', availableServicesForProject: Array<{ __typename?: 'AvailableServiceGroup', name: string, id: string, services: Array<{ __typename?: 'AvailableService', name: string, price: number, unitName?: string | null, id: string, hasFixSellingPrice: boolean, purchasePrice: number, sellingPrice: number, vatRate: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number } }> }> };

export type GetMyAllProjectPositionQueryVariables = Exact<{
  startDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
}>;


export type GetMyAllProjectPositionQuery = { __typename?: 'Query', myAllProjectPosition: Array<{ __typename?: 'ProjectWithPositions', end: string, projectId: string, isProjectInvalid: boolean, projectName: string, start: string, timeTrackingResolution: number, client?: { __typename?: 'Contact', id: string, displayName: string } | null, contractor?: { __typename?: 'Contact', id: string, displayName: string } | null, projectLeader?: { __typename?: 'Contact', id: string, displayName: string, additionalInformation: Array<{ __typename: 'AddressInformation', id: string } | { __typename: 'BillingInformation', id: string } | { __typename: 'ContactPersonInformation', id: string } | { __typename: 'ContractedInformation', id: string } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', id: string } | { __typename: 'EmailInformation', emailType: EmailType, emailAddress: string, id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string } | { __typename: 'PhoneInformation', id: string } | { __typename: 'SalaryInformation', id: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', id: string } | { __typename: 'WorksInDepartmentInformation', id: string }> } | null, positions: Array<{ __typename?: 'ProjectPosition', projectPositionId: string, saleableServiceName: string }> }> };

export type GetMyAllTimeApprovalsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['LocalDate']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  start: Scalars['LocalDate']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMyAllTimeApprovalsQuery = { __typename?: 'Query', myAllTimeApprovals?: { __typename?: 'MyAllTimeApprovalsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProjectTimeApproval', description: string, id: string, number: string, status: ApprovalTimeEntryStatus, timestamp: string, totalMinutes: number, from: string, to: string, createdBy: { __typename?: 'Contact', id: string, displayName: string }, employee: { __typename?: 'Contact', id: string, displayName: string }, history: Array<{ __typename?: 'ProjectTimeApprovalHistory', description: string, status: ApprovalTimeEntryStatus, timestamp: string, createdBy: { __typename?: 'Contact', id: string, displayName: string } }>, project: { __typename?: 'ProjectSummary', id: string, name: string } }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetMyProjectTimeEntriesQueryVariables = Exact<{
  startDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type GetMyProjectTimeEntriesQuery = { __typename?: 'Query', myProjectTimeEntries: Array<{ __typename?: 'ProjectTimeEntryDayGroup', absenceReason?: string | null, approvedWorkingMinutes: number, date: string, errors: Array<ProjectTimeEntryDayGroupErrors>, id: string, pendingWorkingMinutes: number, rejectedWorkingMinutes: number, requiredWorkingMinutes: number, workingMinutes: number, items: Array<{ __typename?: 'ProjectTimeEntry', createdById: string, description: string, end: string, errors: Array<ProjectTimeEntryDayGroupErrors>, id: string, memberId: string, projectId: string, projectPositionId: string, start: string, status: ProjectTimeEntryStatus, timestamp: string, version: number, createdBy: { __typename?: 'Contact', id: string, displayName: string }, history: Array<{ __typename?: 'ProjectTimeEntryHistory', id: string, createdById: string, description: string, end: string, memberId: string, projectId: string, projectPositionId: string, start: string, status: ProjectTimeEntryStatus, timestamp: string, version: number, createdBy: { __typename?: 'Contact', id: string, displayName: string }, member: { __typename?: 'Contact', id: string, displayName: string }, projectPosition: { __typename?: 'DetailProjectPosition', projectName: string, saleableServiceName: string } }>, logs: Array<{ __typename?: 'ProjectTimeLogEntry', createdById: string, id: string, message: string, timestamp: string, createdBy: { __typename?: 'Contact', id: string, displayName: string } }>, member: { __typename?: 'Contact', id: string, displayName: string } }> }> };

export type GetMyTimeApprovalPreviewQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  month: Scalars['LocalDate']['input'];
}>;


export type GetMyTimeApprovalPreviewQuery = { __typename?: 'Query', myTimeApprovalPreview: { __typename?: 'ProjectTimeApprovalDetail', description: string, status: ApprovalTimeEntryStatus, totalMinutes: number, from: string, to: string, employee: { __typename?: 'Contact', id: string, displayName: string }, entries: Array<{ __typename?: 'ProjectTimeApprovalDetailEntry', date: string, description: string, endTime: string, startTime: string, totalMinutes: number, projectPositionId: string, surcharge: { __typename?: 'AbsolutOrPercent', isPercent: boolean, value: number } }>, project: { __typename?: 'ProjectSummary', id: string, name: string } } };

export type GetMyTimeApprovalsByProjectQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  ProjectId?: InputMaybe<Scalars['ID']['input']>;
  end: Scalars['LocalDate']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  start: Scalars['LocalDate']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMyTimeApprovalsByProjectQuery = { __typename?: 'Query', myTimeApprovalsByProject?: { __typename?: 'MyTimeApprovalsByProjectConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProjectTimeApproval', description: string, id: string, number: string, status: ApprovalTimeEntryStatus, timestamp: string, totalMinutes: number, from: string, to: string, createdBy: { __typename?: 'Contact', id: string, displayName: string }, employee: { __typename?: 'Contact', id: string, displayName: string }, history: Array<{ __typename?: 'ProjectTimeApprovalHistory', description: string, status: ApprovalTimeEntryStatus, timestamp: string, createdBy: { __typename?: 'Contact', id: string, displayName: string } }>, project: { __typename?: 'ProjectSummary', id: string, name: string } }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProjectQuery = { __typename?: 'Query', node?: { __typename: 'Absence', id: string } | { __typename: 'AbsenceReason', id: string } | { __typename: 'AccountingProfile', id: string } | { __typename: 'BccRecipientList', id: string } | { __typename: 'CalendarEvent', id: string } | { __typename: 'CatalogEntry', id: string } | { __typename: 'Contact', id: string } | { __typename: 'CorrectedCreditNote', id: string } | { __typename: 'CorrectedInvoice', id: string } | { __typename: 'CreditNote', id: string } | { __typename: 'Department', id: string } | { __typename: 'DiscountProfile', id: string } | { __typename: 'DunningLevel', id: string } | { __typename: 'Email', id: string } | { __typename: 'FileEntry', id: string } | { __typename: 'FolderEntry', id: string } | { __typename: 'Invoice', id: string } | { __typename: 'Offer', id: string } | { __typename: 'Project', id: string, isDeleted: boolean, name: string, isGroup: boolean, isRoot: boolean, number: string, path: Array<string>, projectType: ProjectType, status: ProjectStatus, createdById: string, parentProjectId?: string | null, parentProjectName?: string | null, timestamp: string, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, range: { __typename?: 'DateOnlyRange', from: string, to: string }, additionalInformation: Array<{ __typename: 'AdditionalAccountingInformation', provision?: number | null, provisionDescription?: string | null, timeTrackingResolution: number, id: string, clientContractNumber?: string | null, clientOrderingDate?: string | null, clientContratDate?: string | null, clientOrderingNumber?: string | null, clientProjectNumber?: string | null, supplierProjectNumber?: string | null, accountingProfile?: { __typename?: 'AccountingProfile', name: string, id: string } | null } | { __typename: 'AdditionalContactInformation', clientId?: string | null, endCustomer: string, id: string, client?: { __typename?: 'Contact', id: string, displayName: string } | null, contractor: { __typename?: 'Contact', id: string, displayName: string } } | { __typename: 'AdditionalContactPersonInformation', clientContactPersonId?: string | null, contractorContactPersonId?: string | null, contractorProjectLeaderId?: string | null, id: string, clientContactPerson?: { __typename?: 'Contact', id: string, displayName: string } | null, contractorContactPerson?: { __typename?: 'Contact', id: string, displayName: string } | null, contractorProjectLeader?: { __typename?: 'Contact', id: string, displayName: string } | null } | { __typename: 'AdditionalPositionInformation', hours?: number | null, pricePerHour?: number | null, saleableServiceId: string, serviceName: string, servicePrice: number, id: string, price?: number | null, priceRate?: ProjectPositionPriceRateType | null, description: string, accountingProfile?: { __typename?: 'AccountingProfile', id: string, name: string } | null } | { __typename: 'AdditionalTeamMemberInformation', employeeId?: string | null, id: string, worksOnPositions: Array<{ __typename?: 'WorksOnPosition', positionId: string, pricePerHour?: number | null, hours?: number | null }>, employee?: { __typename?: 'Contact', id: string, displayName: string, isAFreelancer: boolean, additionalInformation: Array<{ __typename: 'AddressInformation', id: string } | { __typename: 'BillingInformation', id: string } | { __typename: 'ContactPersonInformation', id: string } | { __typename: 'ContractedInformation', id: string } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', id: string } | { __typename: 'EmailInformation', id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string } | { __typename: 'PhoneInformation', id: string } | { __typename: 'SalaryInformation', pricePerHour: number, startDate: string, id: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', id: string } | { __typename: 'WorksInDepartmentInformation', id: string }> } | null, contractor_of_employee?: { __typename?: 'Contact', id: string, displayName: string } | null } | { __typename: 'AdditionalTemplateInformation', id: string, isInvoiceWithTimesheet: boolean, isDetailTimesheet: boolean }>, saleableServiceGroups: Array<{ __typename?: 'ProjectSaleableServiceGroup', hasFixSellingPrice: boolean, id: string, name: string, originalId: string, sellingPrice: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, services: Array<{ __typename?: 'ProjectSaleableService', hasFixSellingPrice: boolean, id: string, name: string, originalId: string, purchasePrice: number, sellingPrice: number, vatRate: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, unit?: { __typename?: 'ProjectSaleableUnit', id: string, name: string, originalId: string, shortCode: string } | null }> }>, saleableServices: Array<{ __typename?: 'ProjectSaleableService', hasFixSellingPrice: boolean, id: string, name: string, originalId: string, purchasePrice: number, sellingPrice: number, vatRate: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, unit?: { __typename?: 'ProjectSaleableUnit', id: string, name: string, originalId: string, shortCode: string } | null }>, saleableUnits: Array<{ __typename?: 'ProjectSaleableUnit', id: string, name: string, originalId: string, shortCode: string }>, createdBy: { __typename?: 'Contact', id: string, displayName: string } } | { __typename: 'ProjectTimeApproval', id: string } | { __typename: 'ProjectTimeEntry', id: string } | { __typename: 'RollingNumber', id: string } | { __typename: 'SaleableService', id: string } | { __typename: 'SaleableServiceGroup', id: string } | { __typename: 'SaleableUnit', id: string } | { __typename: 'Template', id: string } | { __typename: 'TimeBalanceEntry', id: string } | { __typename: 'TimeEntry', id: string } | { __typename: 'TimeLabel', id: string } | { __typename: 'TimeLabelGroup', id: string } | { __typename: 'User', id: string } | { __typename: 'UserGroup', id: string } | { __typename: 'WorkingTimeModel', id: string } | null };

export type GetTimeApprovalDetailsQueryVariables = Exact<{
  projectTimeApprovalId: Scalars['ID']['input'];
}>;


export type GetTimeApprovalDetailsQuery = { __typename?: 'Query', timeApprovalDetails: { __typename?: 'ProjectTimeApprovalDetail', employeeId: string, description: string, status: ApprovalTimeEntryStatus, totalMinutes: number, from: string, to: string, employee: { __typename?: 'Contact', id: string, displayName: string }, project: { __typename?: 'ProjectSummary', id: string, name: string }, entries: Array<{ __typename?: 'ProjectTimeApprovalDetailEntry', date: string, description: string, endTime: string, startTime: string, totalMinutes: number, projectPositionId: string, surcharge: { __typename?: 'AbsolutOrPercent', isPercent: boolean, value: number } }> } };

export type MyCreateTimeApprovalMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  month: Scalars['LocalDate']['input'];
}>;


export type MyCreateTimeApprovalMutation = { __typename?: 'Mutation', myCreateTimeApproval: { __typename?: 'MyCreateTimeApprovalPayload', projectTimeApproval?: { __typename?: 'ProjectTimeApproval', description: string, status: ApprovalTimeEntryStatus, totalMinutes: number, id: string, number: string, timestamp: string, from: string, to: string, employee: { __typename?: 'Contact', id: string, displayName: string }, project: { __typename?: 'ProjectSummary', id: string, name: string }, createdBy: { __typename?: 'Contact', id: string, displayName: string }, history: Array<{ __typename?: 'ProjectTimeApprovalHistory', description: string, status: ApprovalTimeEntryStatus, timestamp: string, createdBy: { __typename?: 'Contact', id: string, displayName: string } }> } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type RejectTimeApprovalMutationVariables = Exact<{
  description?: InputMaybe<Scalars['String']['input']>;
  projectTimeApprovalId: Scalars['ID']['input'];
}>;


export type RejectTimeApprovalMutation = { __typename?: 'Mutation', rejectTimeApproval: { __typename?: 'RejectTimeApprovalPayload', projectTimeApproval?: { __typename?: 'ProjectTimeApproval', description: string, id: string, number: string, status: ApprovalTimeEntryStatus, timestamp: string, totalMinutes: number, from: string, to: string, project: { __typename?: 'ProjectSummary', id: string, name: string }, employee: { __typename?: 'Contact', id: string, displayName: string }, createdBy: { __typename?: 'Contact', id: string, displayName: string }, history: Array<{ __typename?: 'ProjectTimeApprovalHistory', description: string, status: ApprovalTimeEntryStatus, timestamp: string, createdBy: { __typename?: 'Contact', id: string, displayName: string } }> } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type RemoveServicesFromProjectMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  serviceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RemoveServicesFromProjectMutation = { __typename?: 'Mutation', removeServicesFromProject: { __typename?: 'RemoveServicesFromProjectPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, project?: { __typename: 'Project', id: string, isDeleted: boolean, name: string, isGroup: boolean, isRoot: boolean, number: string, path: Array<string>, projectType: ProjectType, status: ProjectStatus, createdById: string, parentProjectId?: string | null, parentProjectName?: string | null, timestamp: string, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, range: { __typename?: 'DateOnlyRange', from: string, to: string }, additionalInformation: Array<{ __typename: 'AdditionalAccountingInformation', provision?: number | null, timeTrackingResolution: number, id: string, clientContractNumber?: string | null, clientOrderingDate?: string | null, clientContratDate?: string | null, clientOrderingNumber?: string | null, clientProjectNumber?: string | null, supplierProjectNumber?: string | null, accountingProfile?: { __typename?: 'AccountingProfile', name: string, id: string } | null } | { __typename: 'AdditionalContactInformation', clientId?: string | null, contractorId: string, endCustomer: string, id: string, client?: { __typename?: 'Contact', id: string, displayName: string } | null, contractor: { __typename?: 'Contact', id: string, displayName: string } } | { __typename: 'AdditionalContactPersonInformation', clientContactPersonId?: string | null, contractorContactPersonId?: string | null, contractorProjectLeaderId?: string | null, id: string, clientContactPerson?: { __typename?: 'Contact', id: string, displayName: string } | null, contractorContactPerson?: { __typename?: 'Contact', id: string, displayName: string } | null, contractorProjectLeader?: { __typename?: 'Contact', id: string, displayName: string } | null } | { __typename: 'AdditionalPositionInformation', hours?: number | null, pricePerHour?: number | null, saleableServiceId: string, serviceName: string, servicePrice: number, id: string, price?: number | null, priceRate?: ProjectPositionPriceRateType | null } | { __typename: 'AdditionalTeamMemberInformation', employeeId?: string | null, id: string, worksOnPositions: Array<{ __typename?: 'WorksOnPosition', positionId: string, pricePerHour?: number | null, hours?: number | null }>, employee?: { __typename?: 'Contact', id: string, displayName: string, isAFreelancer: boolean, additionalInformation: Array<{ __typename: 'AddressInformation', id: string } | { __typename: 'BillingInformation', id: string } | { __typename: 'ContactPersonInformation', id: string } | { __typename: 'ContractedInformation', id: string } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', id: string } | { __typename: 'EmailInformation', id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string } | { __typename: 'PhoneInformation', id: string } | { __typename: 'SalaryInformation', pricePerHour: number, startDate: string, id: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', id: string } | { __typename: 'WorksInDepartmentInformation', id: string }> } | null } | { __typename: 'AdditionalTemplateInformation', id: string }>, saleableServiceGroups: Array<{ __typename?: 'ProjectSaleableServiceGroup', hasFixSellingPrice: boolean, id: string, name: string, originalId: string, sellingPrice: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, services: Array<{ __typename?: 'ProjectSaleableService', hasFixSellingPrice: boolean, id: string, name: string, originalId: string, purchasePrice: number, sellingPrice: number, vatRate: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, unit?: { __typename?: 'ProjectSaleableUnit', id: string, name: string, originalId: string, shortCode: string } | null }> }>, saleableServices: Array<{ __typename?: 'ProjectSaleableService', hasFixSellingPrice: boolean, id: string, name: string, originalId: string, purchasePrice: number, sellingPrice: number, vatRate: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, unit?: { __typename?: 'ProjectSaleableUnit', id: string, name: string, originalId: string, shortCode: string } | null }>, saleableUnits: Array<{ __typename?: 'ProjectSaleableUnit', id: string, name: string, originalId: string, shortCode: string }>, createdBy: { __typename?: 'Contact', id: string, displayName: string } } | null } };

export type SearchProjectsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProjectType>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderType>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SearchProjectsQuery = { __typename?: 'Query', searchProjects: { __typename?: 'ProjectSearchResultType', totalCount: number, matchedIds: Array<string>, projects: Array<{ __typename?: 'ProjectSummary', id: string, isDeleted: boolean, name: string, number: string, validationStatus: ValidationStatus, path: Array<string>, isRoot: boolean, isGroup: boolean, projectType: ProjectType, status: ProjectStatus, isManualStatusOverride: boolean, createdById: string, parentProjectId?: string | null, parentProjectName?: string | null, timestamp: string, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, budgetStatus: { __typename?: 'BudgetStatus', totalBudgetAmount: number, totalBudgetMinutes: number, spentAmount: number, spentMinutes: number, remainingAmount: number, remainingMinutes: number, utilizationPercent: number, openMinutes: number, pendingMinutes: number, approvedMinutes: number }, range: { __typename?: 'DateOnlyRange', from: string, to: string }, client?: { __typename?: 'Contact', id: string, displayName: string } | null, contractor?: { __typename?: 'Contact', id: string, displayName: string } | null, createdBy: { __typename?: 'Contact', id: string, displayName: string } }> } };

export type UpdateDayProjectTimeEntryMutationVariables = Exact<{
  date: Scalars['LocalDate']['input'];
  timeEntries: Array<UpsertProjectTimeEntryInput> | UpsertProjectTimeEntryInput;
  employeeId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type UpdateDayProjectTimeEntryMutation = { __typename?: 'Mutation', updateDayProjectTimeEntry: { __typename?: 'UpdateDayProjectTimeEntryPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string }> | null, projectTimeEntryDayGroup?: { __typename?: 'ProjectTimeEntryDayGroup', absenceReason?: string | null, approvedWorkingMinutes: number, date: string, errors: Array<ProjectTimeEntryDayGroupErrors>, id: string, pendingWorkingMinutes: number, rejectedWorkingMinutes: number, requiredWorkingMinutes: number, workingMinutes: number, items: Array<{ __typename?: 'ProjectTimeEntry', createdById: string, description: string, end: string, errors: Array<ProjectTimeEntryDayGroupErrors>, id: string, memberId: string, projectId: string, projectPositionId: string, start: string, status: ProjectTimeEntryStatus, timestamp: string, version: number, createdBy: { __typename?: 'Contact', id: string, displayName: string }, logs: Array<{ __typename?: 'ProjectTimeLogEntry', createdById: string, id: string, message: string, timestamp: string, createdBy: { __typename?: 'Contact', id: string, displayName: string } }>, member: { __typename?: 'Contact', id: string, displayName: string }, history: Array<{ __typename?: 'ProjectTimeEntryHistory', createdById: string, description: string, end: string, memberId: string, projectId: string, projectPositionId: string, start: string, status: ProjectTimeEntryStatus, timestamp: string, version: number, createdBy: { __typename?: 'Contact', id: string, displayName: string }, member: { __typename?: 'Contact', displayName: string, id: string }, projectPosition: { __typename?: 'DetailProjectPosition', projectName: string, saleableServiceName: string } }> }> } | null } };

export type UpdateMyDayProjectTimeEntryMutationVariables = Exact<{
  date: Scalars['LocalDate']['input'];
  timeEntries: Array<UpsertProjectTimeEntryInput> | UpsertProjectTimeEntryInput;
  projectId: Scalars['ID']['input'];
}>;


export type UpdateMyDayProjectTimeEntryMutation = { __typename?: 'Mutation', updateMyDayProjectTimeEntry: { __typename?: 'UpdateMyDayProjectTimeEntryPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string }> | null, projectTimeEntryDayGroup?: { __typename?: 'ProjectTimeEntryDayGroup', absenceReason?: string | null, approvedWorkingMinutes: number, date: string, errors: Array<ProjectTimeEntryDayGroupErrors>, id: string, pendingWorkingMinutes: number, rejectedWorkingMinutes: number, requiredWorkingMinutes: number, workingMinutes: number, items: Array<{ __typename?: 'ProjectTimeEntry', createdById: string, description: string, end: string, errors: Array<ProjectTimeEntryDayGroupErrors>, id: string, memberId: string, projectId: string, projectPositionId: string, start: string, status: ProjectTimeEntryStatus, timestamp: string, version: number, createdBy: { __typename?: 'Contact', id: string, displayName: string }, logs: Array<{ __typename?: 'ProjectTimeLogEntry', createdById: string, id: string, message: string, timestamp: string, createdBy: { __typename?: 'Contact', id: string, displayName: string } }>, member: { __typename?: 'Contact', id: string, displayName: string }, history: Array<{ __typename?: 'ProjectTimeEntryHistory', createdById: string, description: string, end: string, memberId: string, projectId: string, projectPositionId: string, start: string, status: ProjectTimeEntryStatus, timestamp: string, version: number, createdBy: { __typename?: 'Contact', id: string, displayName: string }, member: { __typename?: 'Contact', displayName: string, id: string }, projectPosition: { __typename?: 'DetailProjectPosition', projectName: string, saleableServiceName: string } }> }> } | null } };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
  budget: BudgetInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'UpdateProjectPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, project?: { __typename?: 'Project', id: string, isDeleted: boolean, name: string, number: string, createdById: string, isGroup: boolean, isRoot: boolean, parentProjectId?: string | null, path: Array<string>, projectType: ProjectType, status: ProjectStatus, timestamp: string, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, range: { __typename?: 'DateOnlyRange', from: string, to: string }, additionalInformation: Array<{ __typename: 'AdditionalAccountingInformation', accountingProfileId?: string | null, provision?: number | null, id: string, timeTrackingResolution: number, supplierProjectNumber?: string | null, clientProjectNumber?: string | null, clientOrderingNumber?: string | null, clientOrderingDate?: string | null, clientContratDate?: string | null, clientContractNumber?: string | null } | { __typename: 'AdditionalContactInformation', clientId?: string | null, contractorId: string, endCustomer: string, id: string, client?: { __typename?: 'Contact', id: string, displayName: string } | null, contractor: { __typename?: 'Contact', id: string, displayName: string } } | { __typename: 'AdditionalContactPersonInformation', clientContactPersonId?: string | null, contractorContactPersonId?: string | null, contractorProjectLeaderId?: string | null, id: string, clientContactPerson?: { __typename?: 'Contact', id: string, displayName: string } | null, contractorContactPerson?: { __typename?: 'Contact', id: string, displayName: string } | null, contractorProjectLeader?: { __typename?: 'Contact', id: string, displayName: string } | null } | { __typename: 'AdditionalPositionInformation', hours?: number | null, id: string, saleableServiceId: string, pricePerHour?: number | null, price?: number | null, priceRate?: ProjectPositionPriceRateType | null } | { __typename: 'AdditionalTeamMemberInformation', employeeId?: string | null, id: string, worksOnPositions: Array<{ __typename?: 'WorksOnPosition', positionId: string, pricePerHour?: number | null, hours?: number | null }>, employee?: { __typename?: 'Contact', id: string, displayName: string } | null } | { __typename: 'AdditionalTemplateInformation', id: string }>, saleableServiceGroups: Array<{ __typename?: 'ProjectSaleableServiceGroup', hasFixSellingPrice: boolean, id: string, name: string, originalId: string, sellingPrice: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, services: Array<{ __typename?: 'ProjectSaleableService', hasFixSellingPrice: boolean, id: string, name: string, originalId: string, purchasePrice: number, sellingPrice: number, vatRate: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, unit?: { __typename?: 'ProjectSaleableUnit', id: string, name: string, originalId: string, shortCode: string } | null }> }>, saleableServices: Array<{ __typename?: 'ProjectSaleableService', hasFixSellingPrice: boolean, id: string, name: string, originalId: string, purchasePrice: number, sellingPrice: number, vatRate: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, unit?: { __typename?: 'ProjectSaleableUnit', id: string, name: string, originalId: string, shortCode: string } | null }>, saleableUnits: Array<{ __typename?: 'ProjectSaleableUnit', id: string, name: string, originalId: string, shortCode: string }>, createdBy: { __typename?: 'Contact', id: string, displayName: string } } | null } };

export type UpdateProjectActiveStatusMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  isDeleted: Scalars['Boolean']['input'];
}>;


export type UpdateProjectActiveStatusMutation = { __typename?: 'Mutation', updateProjectActiveStatus: { __typename?: 'UpdateProjectActiveStatusPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdateProjectAdditionalAccountingInformationMutationVariables = Exact<{
  accountingProfileId?: InputMaybe<Scalars['ID']['input']>;
  timeTrackingResolution: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  provision?: InputMaybe<Scalars['Decimal']['input']>;
  informationId: Scalars['ID']['input'];
  clientContractNumber?: InputMaybe<Scalars['String']['input']>;
  clientContratDate?: InputMaybe<Scalars['LocalDate']['input']>;
  clientOrderingDate?: InputMaybe<Scalars['LocalDate']['input']>;
  clientOrderingNumber?: InputMaybe<Scalars['String']['input']>;
  clientProjectNumber?: InputMaybe<Scalars['String']['input']>;
  supplierProjectNumber?: InputMaybe<Scalars['String']['input']>;
  provisionDescription?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProjectAdditionalAccountingInformationMutation = { __typename?: 'Mutation', updateProjectAdditionalAccountingInformation: { __typename?: 'UpdateProjectAdditionalAccountingInformationPayload', additionalAccountingInformation?: { __typename?: 'AdditionalAccountingInformation', id: string, accountingProfileId?: string | null, provision?: number | null, provisionDescription?: string | null, timeTrackingResolution: number, clientContractNumber?: string | null, clientContratDate?: string | null, clientOrderingDate?: string | null, clientOrderingNumber?: string | null, clientProjectNumber?: string | null, supplierProjectNumber?: string | null } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdateProjectAdditionalContactInformationMutationVariables = Exact<{
  clientId?: InputMaybe<Scalars['ID']['input']>;
  contractorId: Scalars['ID']['input'];
  endCustomer?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  informationId: Scalars['ID']['input'];
}>;


export type UpdateProjectAdditionalContactInformationMutation = { __typename?: 'Mutation', updateProjectAdditionalContactInformation: { __typename?: 'UpdateProjectAdditionalContactInformationPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, additionalContactInformation?: { __typename?: 'AdditionalContactInformation', clientId?: string | null, contractorId: string, endCustomer: string, id: string, client?: { __typename?: 'Contact', id: string, displayName: string } | null, contractor: { __typename?: 'Contact', id: string, displayName: string } } | null } };

export type UpdateProjectAdditionalContactPersonInformationMutationVariables = Exact<{
  clientContactId?: InputMaybe<Scalars['ID']['input']>;
  contractorContactId?: InputMaybe<Scalars['ID']['input']>;
  contractorProjectLeaderId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  informationId: Scalars['ID']['input'];
}>;


export type UpdateProjectAdditionalContactPersonInformationMutation = { __typename?: 'Mutation', updateProjectAdditionalContactPersonInformation: { __typename?: 'UpdateProjectAdditionalContactPersonInformationPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, additionalContactPersonInformation?: { __typename?: 'AdditionalContactPersonInformation', clientContactPersonId?: string | null, contractorContactPersonId?: string | null, contractorProjectLeaderId?: string | null, id: string, clientContactPerson?: { __typename?: 'Contact', id: string, displayName: string } | null, contractorContactPerson?: { __typename?: 'Contact', id: string, displayName: string } | null, contractorProjectLeader?: { __typename?: 'Contact', displayName: string, id: string } | null } | null } };

export type UpdateProjectAdditionalPositionInformationMutationVariables = Exact<{
  hours?: InputMaybe<Scalars['Decimal']['input']>;
  pricePerHour?: InputMaybe<Scalars['Decimal']['input']>;
  projectId: Scalars['ID']['input'];
  saleableServiceId: Scalars['String']['input'];
  serviceName: Scalars['String']['input'];
  servicePrice: Scalars['Decimal']['input'];
  informationId: Scalars['ID']['input'];
  price?: InputMaybe<Scalars['Decimal']['input']>;
  priceRate?: InputMaybe<ProjectPositionPriceRateType>;
  accountingProfileId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProjectAdditionalPositionInformationMutation = { __typename?: 'Mutation', updateProjectAdditionalPositionInformation: { __typename?: 'UpdateProjectAdditionalPositionInformationPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, additionalPositionInformation?: { __typename?: 'AdditionalPositionInformation', hours?: number | null, id: string, saleableServiceId: string, serviceName: string, servicePrice: number, pricePerHour?: number | null, price?: number | null, priceRate?: ProjectPositionPriceRateType | null } | null } };

export type UpdateProjectAdditionalTeamMemberInformationMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  informationId: Scalars['ID']['input'];
  memberId?: InputMaybe<Scalars['ID']['input']>;
  worksOnPositions: Array<WorksOnPositionInput> | WorksOnPositionInput;
  contractorId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateProjectAdditionalTeamMemberInformationMutation = { __typename?: 'Mutation', updateProjectAdditionalTeamMemberInformation: { __typename?: 'UpdateProjectAdditionalTeamMemberInformationPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, additionalTeamMemberInformation?: { __typename: 'AdditionalTeamMemberInformation', employeeId?: string | null, id: string, worksOnPositions: Array<{ __typename?: 'WorksOnPosition', positionId: string, pricePerHour?: number | null, hours?: number | null }>, employee?: { __typename?: 'Contact', id: string, displayName: string } | null } | null } };

export type UpdateProjectAdditionalTemplateInformationMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  informationId: Scalars['ID']['input'];
  isInvoiceWithTimesheet: Scalars['Boolean']['input'];
  isDetailTimesheet: Scalars['Boolean']['input'];
}>;


export type UpdateProjectAdditionalTemplateInformationMutation = { __typename?: 'Mutation', updateProjectAdditionalTemplateInformation: { __typename?: 'UpdateProjectAdditionalTemplateInformationPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, additionalTemplateInformation?: { __typename?: 'AdditionalTemplateInformation', id: string, isInvoiceWithTimesheet: boolean, isDetailTimesheet: boolean } | null } };

export type UpdateProjectSaleableServiceMutationVariables = Exact<{
  budget: BudgetInput;
  groupId: Scalars['ID']['input'];
  hasFixSellingPrice: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  originalServiceId: Scalars['String']['input'];
  purchasePrice: Scalars['Decimal']['input'];
  sellingPrice: Scalars['Decimal']['input'];
  serviceId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  unitId: Scalars['ID']['input'];
  vatRate: Scalars['Decimal']['input'];
}>;


export type UpdateProjectSaleableServiceMutation = { __typename?: 'Mutation', updateProjectSaleableService: { __typename?: 'UpdateProjectSaleableServicePayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, projectSaleableService?: { __typename?: 'ProjectSaleableService', hasFixSellingPrice: boolean, id: string, originalId: string, name: string, purchasePrice: number, sellingPrice: number, vatRate: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, unit?: { __typename?: 'ProjectSaleableUnit', id: string, originalId: string, name: string, shortCode: string } | null } | null } };

export type UpdateProjectSaleableServiceGroupMutationVariables = Exact<{
  budget: BudgetInput;
  hasFixSellingPrice: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  originalGroupId: Scalars['String']['input'];
  sellingPrice: Scalars['Decimal']['input'];
  serviceGroupId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type UpdateProjectSaleableServiceGroupMutation = { __typename?: 'Mutation', updateProjectSaleableServiceGroup: { __typename?: 'UpdateProjectSaleableServiceGroupPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, projectSaleableServiceGroup?: { __typename?: 'ProjectSaleableServiceGroup', hasFixSellingPrice: boolean, id: string, originalId: string, name: string, sellingPrice: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, services: Array<{ __typename?: 'ProjectSaleableService', hasFixSellingPrice: boolean, id: string, originalId: string, name: string, purchasePrice: number, sellingPrice: number, vatRate: number, budget: { __typename?: 'Budget', amount: number, hasAmountLimit: boolean, hasTimeLimit: boolean, hours: number }, unit?: { __typename?: 'ProjectSaleableUnit', id: string, originalId: string, name: string, shortCode: string } | null }> } | null } };

export type UpdateProjectSaleableUnitMutationVariables = Exact<{
  name: Scalars['String']['input'];
  originalUnitId: Scalars['String']['input'];
  shortCode: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  unitId: Scalars['ID']['input'];
}>;


export type UpdateProjectSaleableUnitMutation = { __typename?: 'Mutation', updateProjectSaleableUnit: { __typename?: 'UpdateProjectSaleableUnitPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, projectSaleableUnit?: { __typename?: 'ProjectSaleableUnit', id: string, originalId: string, name: string, shortCode: string } | null } };

export type UpdateProjectStatusMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  newStatus: ProjectStatus;
}>;


export type UpdateProjectStatusMutation = { __typename?: 'Mutation', updateProjectStatus: { __typename?: 'UpdateProjectStatusPayload', project?: { __typename?: 'Project', id: string, status: ProjectStatus } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type CreateAccountingProfileMutationVariables = Exact<{
  entries: Array<AccountingProfileEntryInput> | AccountingProfileEntryInput;
  name: Scalars['String']['input'];
}>;


export type CreateAccountingProfileMutation = { __typename?: 'Mutation', createAccountingProfile: { __typename?: 'CreateAccountingProfilePayload', accountingProfile?: { __typename?: 'AccountingProfile', id: string, isDeleted: boolean, name: string, createdById: string, timestamp: string, entries: Array<{ __typename?: 'AccountingProfileEntry', daysOfWeek: Array<DayOfWeek>, name: string, period: { __typename?: 'TimeRange', from: string, to: string }, surcharge: { __typename?: 'AbsolutOrPercent', isPercent: boolean, value: number } }> } | null, errors?: Array<{ __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type CreateDepartmentMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  leaderId: Scalars['ID']['input'];
}>;


export type CreateDepartmentMutation = { __typename?: 'Mutation', createDepartment: { __typename?: 'CreateDepartmentPayload', department?: { __typename?: 'Department', id: string, name: string, description: string, leaderId?: string | null, companyId: string, version: number, leader?: { __typename?: 'Contact', displayName: string, id: string } | null } | null, errors?: Array<{ __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type CreateNextRollingNumberMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  type: RollingNumberType;
}>;


export type CreateNextRollingNumberMutation = { __typename?: 'Mutation', createNextRollingNumber: { __typename?: 'CreateNextRollingNumberPayload', string?: string | null, errors?: Array<{ __typename?: 'MyEntityNotFoundError', error: string, errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type CreateSaleableServiceMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  purchasePrice: Scalars['Decimal']['input'];
  name: Scalars['String']['input'];
  unitId: Scalars['ID']['input'];
  sellingPrice: Scalars['Decimal']['input'];
  vatRate: Scalars['Decimal']['input'];
}>;


export type CreateSaleableServiceMutation = { __typename?: 'Mutation', createSaleableService: { __typename?: 'CreateSaleableServicePayload', errors?: Array<{ __typename: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, saleableService?: { __typename?: 'SaleableService', id: string, name: string, purchasePrice: number, sellingPrice: number, vatRate: number, saleableServiceGroupId: string, saleableUnitId?: string | null, unit?: { __typename?: 'SaleableUnit', id: string, name: string, shortCode: string } | null } | null } };

export type CreateSaleableServiceGroupMutationVariables = Exact<{
  name: Scalars['String']['input'];
  sellingPrice: Scalars['Decimal']['input'];
}>;


export type CreateSaleableServiceGroupMutation = { __typename?: 'Mutation', createSaleableServiceGroup: { __typename?: 'CreateSaleableServiceGroupPayload', errors?: Array<{ __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, saleableServiceGroup?: { __typename?: 'SaleableServiceGroup', id: string, name: string, sellingPrice: number, services: Array<{ __typename?: 'SaleableService', id: string, name: string, purchasePrice: number, sellingPrice: number, vatRate: number, saleableServiceGroupId: string, saleableUnitId?: string | null, unit?: { __typename?: 'SaleableUnit', id: string, name: string, shortCode: string } | null }> } | null } };

export type CreateSaleableUnitMutationVariables = Exact<{
  name: Scalars['String']['input'];
  shortCode: Scalars['String']['input'];
}>;


export type CreateSaleableUnitMutation = { __typename?: 'Mutation', createSaleableUnit: { __typename?: 'CreateSaleableUnitPayload', errors?: Array<{ __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, saleableUnit?: { __typename?: 'SaleableUnit', id: string, name: string, shortCode: string } | null } };

export type DeleteAccountingProfileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAccountingProfileMutation = { __typename?: 'Mutation', deleteAccountingProfile: { __typename?: 'DeleteAccountingProfilePayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteDepartmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDepartmentMutation = { __typename?: 'Mutation', deleteDepartment: { __typename?: 'DeleteDepartmentPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteSaleableServiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSaleableServiceMutation = { __typename?: 'Mutation', deleteSaleableService: { __typename?: 'DeleteSaleableServicePayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteSaleableServiceGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSaleableServiceGroupMutation = { __typename?: 'Mutation', deleteSaleableServiceGroup: { __typename?: 'DeleteSaleableServiceGroupPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteSaleableUnitMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSaleableUnitMutation = { __typename?: 'Mutation', deleteSaleableUnit: { __typename?: 'DeleteSaleableUnitPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type GetAllAccountingProfilesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllAccountingProfilesQuery = { __typename?: 'Query', allAccountingProfiles?: { __typename?: 'AllAccountingProfilesConnection', totalCount: number, nodes?: Array<{ __typename?: 'AccountingProfile', id: string, isDeleted: boolean, name: string, entries: Array<{ __typename?: 'AccountingProfileEntry', daysOfWeek: Array<DayOfWeek>, name: string, period: { __typename?: 'TimeRange', from: string, to: string }, surcharge: { __typename?: 'AbsolutOrPercent', isPercent: boolean, value: number } }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllContractorBccRecipientListsQueryVariables = Exact<{
  contractorId: Scalars['ID']['input'];
}>;


export type GetAllContractorBccRecipientListsQuery = { __typename?: 'Query', allContractorBccRecipientLists: Array<{ __typename?: 'BccRecipientList', id: string, contractorId: string, type: EmailType, recipients: Array<string> }> };

export type GetAllContractorRollingNumbersQueryVariables = Exact<{
  contractorId: Scalars['ID']['input'];
}>;


export type GetAllContractorRollingNumbersQuery = { __typename?: 'Query', allContractorRollingNumbers: Array<{ __typename?: 'RollingNumber', contactId?: string | null, currentValue: number, digitCount: number, format: string, id: string, type: RollingNumberType }> };

export type GetAllContractorsForRollingNumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllContractorsForRollingNumbersQuery = { __typename?: 'Query', allContacts?: { __typename?: 'AllContactsConnection', nodes?: Array<{ __typename?: 'Contact', id: string, displayName: string }> | null } | null };

export type GetAllDepartmentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderType>;
}>;


export type GetAllDepartmentsQuery = { __typename?: 'Query', allDepartments?: { __typename?: 'AllDepartmentsConnection', totalCount: number, nodes?: Array<{ __typename?: 'Department', id: string, name: string, description: string, leaderId?: string | null, companyId: string, version: number, leader?: { __typename?: 'Contact', displayName: string, id: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllGlobalRollingNumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllGlobalRollingNumbersQuery = { __typename?: 'Query', allGlobalRollingNumbers: Array<{ __typename?: 'RollingNumber', contactId?: string | null, currentValue: number, digitCount: number, format: string, id: string, type: RollingNumberType }> };

export type GetAllMembersOfDepartmentQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  departmentId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderType>;
}>;


export type GetAllMembersOfDepartmentQuery = { __typename?: 'Query', allMembersOfDepartment?: { __typename?: 'AllMembersOfDepartmentConnection', nodes?: Array<{ __typename?: 'Contact', displayName: string, id: string }> | null } | null };

export type GetAllSaleableServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSaleableServicesQuery = { __typename?: 'Query', allSaleableServices: Array<{ __typename?: 'SaleableServiceGroup', id: string, name: string, sellingPrice: number, services: Array<{ __typename?: 'SaleableService', id: string, name: string, purchasePrice: number, sellingPrice: number, vatRate: number, saleableServiceGroupId: string, saleableUnitId?: string | null, unit?: { __typename?: 'SaleableUnit', id: string, name: string, shortCode: string } | null }> }> };

export type GetAllSaleableUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSaleableUnitsQuery = { __typename?: 'Query', allSaleableUnits: Array<{ __typename?: 'SaleableUnit', id: string, name: string, shortCode: string }> };

export type LeavesDepartmentMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
}>;


export type LeavesDepartmentMutation = { __typename?: 'Mutation', leavesDepartment: { __typename?: 'LeavesDepartmentPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdateAccountingProfileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  entries: Array<AccountingProfileEntryInput> | AccountingProfileEntryInput;
  name: Scalars['String']['input'];
}>;


export type UpdateAccountingProfileMutation = { __typename?: 'Mutation', updateAccountingProfile: { __typename?: 'UpdateAccountingProfilePayload', accountingProfile?: { __typename?: 'AccountingProfile', id: string, isDeleted: boolean, name: string, createdById: string, timestamp: string, entries: Array<{ __typename?: 'AccountingProfileEntry', daysOfWeek: Array<DayOfWeek>, name: string, period: { __typename?: 'TimeRange', from: string, to: string }, surcharge: { __typename?: 'AbsolutOrPercent', isPercent: boolean, value: number } }> } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdateBccRecipientListMutationVariables = Exact<{
  contractorId: Scalars['ID']['input'];
  type: EmailType;
  recipients: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateBccRecipientListMutation = { __typename?: 'Mutation', updateBccRecipientList: { __typename?: 'UpdateBccRecipientListPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'MyEntityNotFoundError' } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdateDepartmentMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  leaderId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type UpdateDepartmentMutation = { __typename?: 'Mutation', updateDepartment: { __typename?: 'UpdateDepartmentPayload', department?: { __typename?: 'Department', id: string, name: string, description: string, leaderId?: string | null, companyId: string, version: number, leader?: { __typename?: 'Contact', displayName: string, id: string } | null } | null, errors?: Array<{ __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdateRollingNumberMutationVariables = Exact<{
  contractorId?: InputMaybe<Scalars['ID']['input']>;
  digitCount: Scalars['Int']['input'];
  format: Scalars['String']['input'];
  type: RollingNumberType;
  value: Scalars['Int']['input'];
}>;


export type UpdateRollingNumberMutation = { __typename?: 'Mutation', updateRollingNumber: { __typename?: 'UpdateRollingNumberPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'MyEntityNotFoundError' } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdateSaleableServiceMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  purchasePrice: Scalars['Decimal']['input'];
  sellingPrice: Scalars['Decimal']['input'];
  unitId: Scalars['ID']['input'];
  vatRate: Scalars['Decimal']['input'];
}>;


export type UpdateSaleableServiceMutation = { __typename?: 'Mutation', updateSaleableService: { __typename?: 'UpdateSaleableServicePayload', saleableService?: { __typename?: 'SaleableService', id: string, name: string, purchasePrice: number, sellingPrice: number, vatRate: number, saleableServiceGroupId: string, saleableUnitId?: string | null, unit?: { __typename?: 'SaleableUnit', id: string, name: string, shortCode: string } | null } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdateSaleableServiceGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  sellingPrice: Scalars['Decimal']['input'];
}>;


export type UpdateSaleableServiceGroupMutation = { __typename?: 'Mutation', updateSaleableServiceGroup: { __typename?: 'UpdateSaleableServiceGroupPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, saleableServiceGroup?: { __typename?: 'SaleableServiceGroup', id: string, name: string, sellingPrice: number, services: Array<{ __typename?: 'SaleableService', id: string, name: string, purchasePrice: number, sellingPrice: number, vatRate: number, saleableServiceGroupId: string, saleableUnitId?: string | null, unit?: { __typename?: 'SaleableUnit', id: string, name: string, shortCode: string } | null }> } | null } };

export type UpdateSaleableUnitMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  shortCode: Scalars['String']['input'];
}>;


export type UpdateSaleableUnitMutation = { __typename?: 'Mutation', updateSaleableUnit: { __typename?: 'UpdateSaleableUnitPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, saleableUnit?: { __typename?: 'SaleableUnit', id: string, name: string, shortCode: string } | null } };

export type WorksInDepartmentMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  departmentId: Scalars['ID']['input'];
}>;


export type WorksInDepartmentMutation = { __typename?: 'Mutation', worksInDepartment: { __typename?: 'WorksInDepartmentPayload', worksInDepartmentInformation?: { __typename?: 'WorksInDepartmentInformation', id: string } | null, errors?: Array<{ __typename?: 'DomainError' } | { __typename?: 'EntityNotFoundError', entityId: Array<string>, entityName: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type CreateTemplateMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  rendering: TemplateRendering;
  type: TemplateType;
}>;


export type CreateTemplateMutation = { __typename?: 'Mutation', createTemplate: { __typename?: 'CreateTemplatePayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, template?: { __typename?: 'Template', contactId: string, content: string, id: string, isDeleted: boolean, name: string, rendering: TemplateRendering, type: TemplateType, version: number, footer: string, header: string } | null } };

export type DeleteTemplateMutationVariables = Exact<{
  templateId: Scalars['ID']['input'];
}>;


export type DeleteTemplateMutation = { __typename?: 'Mutation', deleteTemplate: { __typename?: 'DeleteTemplatePayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type GetAllTemplatesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contractorId: Scalars['ID']['input'];
  filterByName?: InputMaybe<Scalars['String']['input']>;
  filterByRendering?: InputMaybe<TemplateRendering>;
  filterByType?: InputMaybe<TemplateType>;
  order?: InputMaybe<OrderType>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllTemplatesQuery = { __typename?: 'Query', allTemplates?: { __typename?: 'AllTemplatesConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, nodes?: Array<{ __typename?: 'FlatTemplate', contactId: string, id: string, isDeleted: boolean, name: string, rendering: TemplateRendering, type: TemplateType }> | null } | null };

export type GetTemplateByIdQueryVariables = Exact<{
  templateId: Scalars['ID']['input'];
}>;


export type GetTemplateByIdQuery = { __typename?: 'Query', templateById?: { __typename?: 'Template', contactId: string, content: string, id: string, isDeleted: boolean, name: string, rendering: TemplateRendering, type: TemplateType, version: number, footer: string, header: string } | null };

export type GetTemplateVariablesQueryVariables = Exact<{
  rendering: TemplateRendering;
  type: TemplateType;
}>;


export type GetTemplateVariablesQuery = { __typename?: 'Query', templateVariables: Array<{ __typename?: 'TemplateVariable', display: string, path: Array<string>, template: string }> };

export type UpdateTemplateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  content: Scalars['String']['input'];
  templateId: Scalars['ID']['input'];
  header?: InputMaybe<Scalars['String']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTemplateMutation = { __typename?: 'Mutation', updateTemplate: { __typename?: 'UpdateTemplatePayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type AddApprovalToAllTimeEntriesMutationVariables = Exact<{
  message: Scalars['String']['input'];
  approved: Scalars['Boolean']['input'];
  endDate: Scalars['LocalDate']['input'];
  startDate: Scalars['LocalDate']['input'];
  employeeId: Scalars['ID']['input'];
}>;


export type AddApprovalToAllTimeEntriesMutation = { __typename?: 'Mutation', addApprovalToAllTimeEntries: { __typename?: 'AddApprovalToAllTimeEntriesPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'InvalidUserPrivilegesError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type AddApprovalToTimeEntryMutationVariables = Exact<{
  message: Scalars['String']['input'];
  timeEntryId: Scalars['ID']['input'];
  approved: Scalars['Boolean']['input'];
}>;


export type AddApprovalToTimeEntryMutation = { __typename?: 'Mutation', addApprovalToTimeEntry: { __typename?: 'AddApprovalToTimeEntryPayload', timeEntry?: { __typename?: 'TimeEntry', id: string } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'InvalidUserPrivilegesError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type AddEmployeesToLabelGroupMutationVariables = Exact<{
  employeeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  version: Scalars['Long']['input'];
}>;


export type AddEmployeesToLabelGroupMutation = { __typename?: 'Mutation', addEmployeesToLabelGroup: { __typename?: 'AddEmployeesToLabelGroupPayload', errors?: Array<{ __typename?: 'ConcurrentAccessError', errorType: string, message: string } | { __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, timeLabelGroup?: { __typename?: 'TimeLabelGroup', companyId: string, departmentIds: Array<string>, employeeIds: Array<string>, id: string, isGlobal: boolean, name: string, version: number, departments: Array<{ __typename?: 'Department', companyId: string, description: string, id: string, leaderId?: string | null, name: string, version: number }>, employees: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number }>, labels: Array<{ __typename?: 'TimeLabel', companyId: string, departmentIds: Array<string>, employeeIds: Array<string>, id: string, isActive: boolean, isDeleted: boolean, name: string, version: number }> } | null } };

export type AddEmployeesToTimeLabelMutationVariables = Exact<{
  employeeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  version: Scalars['Long']['input'];
}>;


export type AddEmployeesToTimeLabelMutation = { __typename?: 'Mutation', addEmployeesToTimeLabel: { __typename?: 'AddEmployeesToTimeLabelPayload', errors?: Array<{ __typename?: 'ConcurrentAccessError', errorType: string, message: string } | { __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, timeLabel?: { __typename?: 'TimeLabel', companyId: string, departmentIds: Array<string>, employeeIds: Array<string>, id: string, isActive: boolean, isDeleted: boolean, name: string, version: number, departments: Array<{ __typename?: 'Department', companyId: string, description: string, id: string, leaderId?: string | null, name: string, version: number }>, employees: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isEmployee: boolean, isContactPerson: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number }> } | null } };

export type AddLabelGroupsToDepartmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  timeLabelGroupsIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddLabelGroupsToDepartmentMutation = { __typename?: 'Mutation', addLabelGroupsToDepartment: { __typename?: 'AddLabelGroupsToDepartmentPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type AddLabelsToDepartmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  labels: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddLabelsToDepartmentMutation = { __typename?: 'Mutation', addLabelsToDepartment: { __typename?: 'AddLabelsToDepartmentPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type AddLabelsToLabelGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  labels: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  version: Scalars['Long']['input'];
}>;


export type AddLabelsToLabelGroupMutation = { __typename?: 'Mutation', addLabelsToLabelGroup: { __typename?: 'AddLabelsToLabelGroupPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'ConcurrentAccessError', errorType: string, message: string } | { __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type AddLogToAbsenceMutationVariables = Exact<{
  message: Scalars['String']['input'];
  absenceId: Scalars['ID']['input'];
}>;


export type AddLogToAbsenceMutation = { __typename?: 'Mutation', addLogToAbsence: { __typename?: 'AddLogToAbsencePayload', absence?: { __typename?: 'Absence', id: string, absenceReasonId: string, absenceReasonName: string, absenceReasonType: AbsenceReasonType, end: string, isHalfEndDay: boolean, isHalfStartDay: boolean, start: string, status: AbsenceStatusType, timestamp: string, version: number, logs: Array<{ __typename?: 'AbsenceLog', message: string, timestamp: string, id: string, createdBy: { __typename?: 'Contact', displayName: string, id: string } }>, createdBy: { __typename?: 'Contact', id: string, displayName: string }, delegateEmployee?: { __typename?: 'Contact', id: string, displayName: string } | null, employee: { __typename?: 'Contact', displayName: string, id: string }, history: Array<{ __typename?: 'AbsenceHistory', absenceReasonId: string, absenceReasonName: string, end: string, isHalfEndDay: boolean, isHalfStartDay: boolean, start: string, status: AbsenceStatusType, timestamp: string, version: number, createdBy: { __typename?: 'Contact', displayName: string, id: string }, delegateEmployee?: { __typename?: 'Contact', displayName: string, id: string } | null }> } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'InvalidUserPrivilegesError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type AddLogToProjectTimeEntryMutationVariables = Exact<{
  message: Scalars['String']['input'];
  timeEntryId: Scalars['ID']['input'];
}>;


export type AddLogToProjectTimeEntryMutation = { __typename?: 'Mutation', addLogToProjectTimeEntry: { __typename?: 'AddLogToProjectTimeEntryPayload', projectTimeEntry?: { __typename?: 'ProjectTimeEntry', id: string, description: string, end: string, errors: Array<ProjectTimeEntryDayGroupErrors>, start: string, status: ProjectTimeEntryStatus, timestamp: string, version: number, memberId: string, projectPositionId: string, projectId: string, createdById: string, logs: Array<{ __typename?: 'ProjectTimeLogEntry', message: string, timestamp: string, id: string, createdBy: { __typename?: 'Contact', displayName: string, id: string } }>, createdBy: { __typename?: 'Contact', displayName: string, id: string }, history: Array<{ __typename?: 'ProjectTimeEntryHistory', id: string, description: string, end: string, start: string, status: ProjectTimeEntryStatus, timestamp: string, version: number, projectPositionId: string, projectId: string, memberId: string, createdById: string, createdBy: { __typename?: 'Contact', id: string, displayName: string }, member: { __typename?: 'Contact', id: string, displayName: string }, projectPosition: { __typename?: 'DetailProjectPosition', projectName: string, saleableServiceName: string } }>, member: { __typename?: 'Contact', id: string, displayName: string } } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'InvalidUserPrivilegesError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type AddLogToTimeEntryMutationVariables = Exact<{
  message: Scalars['String']['input'];
  timeEntryId: Scalars['ID']['input'];
}>;


export type AddLogToTimeEntryMutation = { __typename?: 'Mutation', addLogToTimeEntry: { __typename?: 'AddLogToTimeEntryPayload', timeEntry?: { __typename?: 'TimeEntry', id: string, calendarId: string, description: string, end: string, entryType: TimeEntryType, errors: Array<TimeEntryDayGroupErrors>, path: Array<string>, start: string, status: TimeEntryStatus, timeLabelId?: string | null, timestamp: string, title: string, version: number, workLocation: WorkLocation, logs: Array<{ __typename?: 'TimeLogEntry', message: string, timestamp: string, id: string, createdBy: { __typename?: 'Contact', displayName: string, id: string } }>, createdBy: { __typename?: 'Contact', displayName: string, id: string }, history: Array<{ __typename?: 'TimeEntryHistory', description: string, end: string, entryType: TimeEntryType, start: string, status: TimeEntryStatus, timestamp: string, version: number, workLocation: WorkLocation, createdBy: { __typename?: 'Contact', id: string, displayName: string }, member: { __typename?: 'Contact', id: string, displayName: string }, timeLabel?: { __typename?: 'TimeLabel', name: string, id: string } | null }>, member: { __typename?: 'Contact', id: string, displayName: string }, timeLabel?: { __typename?: 'TimeLabel', id: string, name: string } | null } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'InvalidUserPrivilegesError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type ApproveVacationMutationVariables = Exact<{
  absenceId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  isApproved: Scalars['Boolean']['input'];
  version: Scalars['Long']['input'];
}>;


export type ApproveVacationMutation = { __typename?: 'Mutation', approveVacation: { __typename?: 'ApproveVacationPayload', absence?: { __typename?: 'Absence', id: string } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'InvalidUserPrivilegesError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type CheckVacationQueryVariables = Exact<{
  startDate: Scalars['LocalDate']['input'];
  isHalfStartDay: Scalars['Boolean']['input'];
  endDate: Scalars['LocalDate']['input'];
  isHalfEndDay: Scalars['Boolean']['input'];
  employeeId: Scalars['ID']['input'];
  absenceId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CheckVacationQuery = { __typename?: 'Query', checkVacation: { __typename?: 'VacationCheckResult', canBeTaken: boolean, hasDelegateDuties: boolean, isInSameYear: boolean, isOverlapping: boolean, leftDays: number, neededDays: number, startDateIsTooClose: boolean } };

export type CreateAbsenceMutationVariables = Exact<{
  absenceReasonId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  delegateEmployeeId: Scalars['ID']['input'];
  end: Scalars['LocalDate']['input'];
  isHalfEndDay: Scalars['Boolean']['input'];
  isHalfStartDay: Scalars['Boolean']['input'];
  start: Scalars['LocalDate']['input'];
  employeeId: Scalars['ID']['input'];
  startWorkflow?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateAbsenceMutation = { __typename?: 'Mutation', createAbsence: { __typename?: 'CreateAbsencePayload', absence?: { __typename?: 'Absence', id: string, absenceReasonId: string, absenceReasonName: string, absenceReasonType: AbsenceReasonType, end: string, isHalfEndDay: boolean, isHalfStartDay: boolean, start: string, status: AbsenceStatusType, timestamp: string, version: number, publicHolidays: number, totalDays: number, workDays: number, createdBy: { __typename?: 'Contact', id: string, displayName: string }, delegateEmployee?: { __typename?: 'Contact', displayName: string, id: string } | null, employee: { __typename?: 'Contact', displayName: string, id: string }, history: Array<{ __typename?: 'AbsenceHistory', absenceReasonId: string, absenceReasonName: string, end: string, isHalfEndDay: boolean, isHalfStartDay: boolean, start: string, status: AbsenceStatusType, timestamp: string, version: number, publicHolidays: number, totalDays: number, workDays: number, createdBy: { __typename?: 'Contact', displayName: string, id: string }, delegateEmployee?: { __typename?: 'Contact', displayName: string, id: string } | null }>, logs: Array<{ __typename?: 'AbsenceLog', id: string, message: string, timestamp: string, createdBy: { __typename?: 'Contact', displayName: string, id: string } }> } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type CreateAbsenceReasonMutationVariables = Exact<{
  description: Scalars['String']['input'];
  isPaid: Scalars['Boolean']['input'];
  isVisible: Scalars['Boolean']['input'];
  maximumContinuedPayment?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  removesWorkingHours: Scalars['Boolean']['input'];
  type: AbsenceReasonType;
}>;


export type CreateAbsenceReasonMutation = { __typename?: 'Mutation', createAbsenceReason: { __typename?: 'CreateAbsenceReasonPayload', absenceReason?: { __typename?: 'AbsenceReason', id: string, name: string, description: string, isVisible: boolean, isDeleted: boolean, isPaid: boolean, maximumContinuedPayment?: number | null, removesWorkingHours: boolean, type: AbsenceReasonType, version: number } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type CreateCalendarEventMutationVariables = Exact<{
  description: Scalars['String']['input'];
  endDate: Scalars['LocalDate']['input'];
  federalStateCodes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  isHalfEndDay: Scalars['Boolean']['input'];
  isHalfStartDay: Scalars['Boolean']['input'];
  isVacation: Scalars['Boolean']['input'];
  locations: Array<Scalars['String']['input']> | Scalars['String']['input'];
  startDate: Scalars['LocalDate']['input'];
  type: CalendarEventType;
}>;


export type CreateCalendarEventMutation = { __typename?: 'Mutation', createCalendarEvent: { __typename?: 'CreateCalendarEventPayload', calendarEvent?: { __typename?: 'CalendarEvent', id: string, startDate: string, isHalfStartDay: boolean, endDate: string, isHalfEndDay: boolean, type: CalendarEventType, isVacation: boolean, description: string, federalStateCodes: Array<string>, locations: Array<string>, version: number } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type CreateTimeBalanceEntryMutationVariables = Exact<{
  employeeId: Scalars['ID']['input'];
  date: Scalars['LocalDate']['input'];
  type: TimeBalanceType;
  vacationDays?: InputMaybe<Scalars['Decimal']['input']>;
  overtime?: InputMaybe<Scalars['TimeSpan']['input']>;
  reason: Scalars['String']['input'];
}>;


export type CreateTimeBalanceEntryMutation = { __typename?: 'Mutation', createTimeBalanceEntry: { __typename?: 'CreateTimeBalanceEntryPayload', timeBalanceEntry?: { __typename?: 'TimeBalanceEntry', id: string, createdById: string, date: string, employeeId: string, isDeleted: boolean, overtime?: string | null, reason: string, timestamp: string, type: TimeBalanceType, vacationDays?: number | null, version: number, createdBy: { __typename?: 'Contact', id: string, displayName: string }, history: Array<{ __typename?: 'TimeBalanceHistoryEntry', createdById: string, date: string, isDeleted: boolean, overtime?: string | null, reason: string, timestamp: string, type: TimeBalanceType, vacationDays?: number | null, createdBy: { __typename?: 'Contact', id: string, displayName: string } }> } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type CreateTimeLabelMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateTimeLabelMutation = { __typename?: 'Mutation', createTimeLabel: { __typename?: 'CreateTimeLabelPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, timeLabel?: { __typename?: 'TimeLabel', companyId: string, departmentIds: Array<string>, employeeIds: Array<string>, id: string, isActive: boolean, isDeleted: boolean, name: string, version: number, departments: Array<{ __typename?: 'Department', companyId: string, description: string, id: string, leaderId?: string | null, name: string, version: number }>, employees: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number }> } | null } };

export type CreateTimeLabelGroupMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  isGlobal: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateTimeLabelGroupMutation = { __typename?: 'Mutation', createTimeLabelGroup: { __typename?: 'CreateTimeLabelGroupPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, timeLabelGroup?: { __typename?: 'TimeLabelGroup', companyId: string, departmentIds: Array<string>, employeeIds: Array<string>, id: string, name: string, version: number, isGlobal: boolean, labels: Array<{ __typename?: 'TimeLabel', companyId: string, departmentIds: Array<string>, employeeIds: Array<string>, id: string, isActive: boolean, isDeleted: boolean, name: string, version: number, departments: Array<{ __typename?: 'Department', companyId: string, description: string, id: string, leaderId?: string | null, name: string, version: number }>, employees: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number }> }>, departments: Array<{ __typename?: 'Department', companyId: string, description: string, id: string, leaderId?: string | null, name: string, version: number }>, employees: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number }> } | null } };

export type CreateWorkingTimeModelMutationVariables = Exact<{
  description: Scalars['String']['input'];
  hoursPerFriday: Scalars['Decimal']['input'];
  hoursPerMonday: Scalars['Decimal']['input'];
  hoursPerSaturday: Scalars['Decimal']['input'];
  hoursPerSunday: Scalars['Decimal']['input'];
  hoursPerThursday: Scalars['Decimal']['input'];
  hoursPerTuesday: Scalars['Decimal']['input'];
  hoursPerWednesday: Scalars['Decimal']['input'];
  hoursPerWeek: Scalars['Decimal']['input'];
  isFlexible: Scalars['Boolean']['input'];
  isVisible: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  vacationDaysPerYear: Scalars['Decimal']['input'];
}>;


export type CreateWorkingTimeModelMutation = { __typename?: 'Mutation', createWorkingTimeModel: { __typename?: 'CreateWorkingTimeModelPayload', workingTimeModel?: { __typename?: 'WorkingTimeModel', id: string, description: string, hoursPerFriday: number, hoursPerMonday: number, hoursPerSaturday: number, hoursPerSunday: number, hoursPerThursday: number, hoursPerTuesday: number, hoursPerWednesday: number, hoursPerWeek: number, isDeleted: boolean, isFlexible: boolean, isVisible: boolean, name: string, vacationDaysPerYear: number, version: number } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteAbsenceMutationVariables = Exact<{
  comment?: InputMaybe<Scalars['String']['input']>;
  absenceId: Scalars['ID']['input'];
  version: Scalars['Long']['input'];
}>;


export type DeleteAbsenceMutation = { __typename?: 'Mutation', deleteAbsence: { __typename?: 'DeleteAbsencePayload', absence?: { __typename?: 'Absence', id: string } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteAbsenceReasonMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAbsenceReasonMutation = { __typename?: 'Mutation', deleteAbsenceReason: { __typename?: 'DeleteAbsenceReasonPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteCalendarEventMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCalendarEventMutation = { __typename?: 'Mutation', deleteCalendarEvent: { __typename?: 'DeleteCalendarEventPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteMyTimerMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteMyTimerMutation = { __typename?: 'Mutation', myDeleteTimer: { __typename?: 'MyDeleteTimerPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string }> | null } };

export type DeleteTimeBalanceEntryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  version: Scalars['Long']['input'];
}>;


export type DeleteTimeBalanceEntryMutation = { __typename?: 'Mutation', deleteTimeBalanceEntry: { __typename?: 'DeleteTimeBalanceEntryPayload', errors?: Array<{ __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, timeBalanceEntry?: { __typename?: 'TimeBalanceEntry', id: string } | null } };

export type DeleteTimeLabelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  version: Scalars['Long']['input'];
}>;


export type DeleteTimeLabelMutation = { __typename?: 'Mutation', deleteTimeLabel: { __typename?: 'DeleteTimeLabelPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'ConcurrentAccessError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteTimeLabelGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  version: Scalars['Long']['input'];
}>;


export type DeleteTimeLabelGroupMutation = { __typename?: 'Mutation', deleteTimeLabelGroup: { __typename?: 'DeleteTimeLabelGroupPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'ConcurrentAccessError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type DeleteWorkingTimeModelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteWorkingTimeModelMutation = { __typename?: 'Mutation', deleteWorkingTimeModel: { __typename?: 'DeleteWorkingTimeModelPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type GetAllAbsenceOverviewRequestsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
}>;


export type GetAllAbsenceOverviewRequestsQuery = { __typename?: 'Query', allAbsenceOverviewRequests?: { __typename?: 'AllAbsenceOverviewRequestsConnection', totalCount: number, nodes?: Array<{ __typename?: 'AbsenceOverview', spentHolidays: number, totalSickDays: number, contactId: string, contact: { __typename?: 'Contact', displayName: string, id: string }, details: Array<{ __typename?: 'AbsenceOverviewDetails', absenceReasonName: string, end: string, isHalfEndDay: boolean, isHalfStartDay: boolean, start: string, status: AbsenceStatusType, publicHolidays: number, totalDays: number, workDays: number }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllAbsenceReasonsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  onlyVisible?: InputMaybe<Scalars['Boolean']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllAbsenceReasonsQuery = { __typename?: 'Query', allAbsenceReasons?: { __typename?: 'AllAbsenceReasonsConnection', totalCount: number, nodes?: Array<{ __typename?: 'AbsenceReason', id: string, name: string, description: string, isVisible: boolean, isDeleted: boolean, isPaid: boolean, maximumContinuedPayment?: number | null, removesWorkingHours: boolean, type: AbsenceReasonType, version: number }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllAbsenceReasonsForUsageQueryVariables = Exact<{
  types?: InputMaybe<Array<AbsenceReasonType> | AbsenceReasonType>;
}>;


export type GetAllAbsenceReasonsForUsageQuery = { __typename?: 'Query', allAbsenceReasonsForUsage?: { __typename?: 'AllAbsenceReasonsForUsageConnection', nodes?: Array<{ __typename?: 'AbsenceReason', id: string, name: string, type: AbsenceReasonType }> | null } | null };

export type GetAllAbsencesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['LocalDate']['input'];
  employeeId: Scalars['ID']['input'];
  showCanceled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllAbsencesQuery = { __typename?: 'Query', allAbsences?: { __typename?: 'AllAbsencesConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, nodes?: Array<{ __typename?: 'Absence', absenceReasonId: string, absenceReasonName: string, absenceReasonType: AbsenceReasonType, end: string, id: string, isHalfEndDay: boolean, isHalfStartDay: boolean, start: string, status: AbsenceStatusType, timestamp: string, version: number, workDays: number, totalDays: number, publicHolidays: number, delegateEmployee?: { __typename?: 'Contact', id: string, displayName: string } | null, createdBy: { __typename?: 'Contact', id: string, displayName: string }, employee: { __typename?: 'Contact', id: string, displayName: string }, history: Array<{ __typename?: 'AbsenceHistory', absenceReasonId: string, absenceReasonName: string, end: string, isHalfEndDay: boolean, isHalfStartDay: boolean, start: string, status: AbsenceStatusType, timestamp: string, version: number, workDays: number, totalDays: number, publicHolidays: number, createdBy: { __typename?: 'Contact', id: string, displayName: string }, delegateEmployee?: { __typename?: 'Contact', id: string, displayName: string } | null }>, logs: Array<{ __typename?: 'AbsenceLog', id: string, message: string, timestamp: string, createdBy: { __typename?: 'Contact', id: string, displayName: string } }> }> | null } | null };

export type GetAllCalendarEventsQueryVariables = Exact<{
  startDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
  federalStateCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllCalendarEventsQuery = { __typename?: 'Query', allCalendarEvents?: { __typename?: 'AllCalendarEventsConnection', totalCount: number, nodes?: Array<{ __typename?: 'CalendarEvent', id: string, startDate: string, isHalfStartDay: boolean, endDate: string, isHalfEndDay: boolean, type: CalendarEventType, isVacation: boolean, description: string, federalStateCodes: Array<string>, locations: Array<string>, version: number }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllEmployeeTimeLabelsQueryVariables = Exact<{
  employeeId: Scalars['ID']['input'];
}>;


export type GetAllEmployeeTimeLabelsQuery = { __typename?: 'Query', allEmployeeTimeLabels: Array<{ __typename?: 'TimeLabel', companyId: string, departmentIds: Array<string>, employeeIds: Array<string>, id: string, isActive: boolean, isDeleted: boolean, name: string, version: number, departments: Array<{ __typename?: 'Department', companyId: string, description: string, id: string, leaderId?: string | null, name: string, version: number }>, employees: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number }>, timeLabelGroups: Array<{ __typename?: 'TimeLabelGroup', companyId: string, departmentIds: Array<string>, employeeIds: Array<string>, id: string, isGlobal: boolean, name: string, version: number }> }> };

export type GetAllEmployeesOfTimeLabelQueryVariables = Exact<{
  timeLabelId: Scalars['ID']['input'];
}>;


export type GetAllEmployeesOfTimeLabelQuery = { __typename?: 'Query', allEmployeesOfTimeLabel: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number, additionalInformation: Array<{ __typename: 'AddressInformation', id: string } | { __typename: 'BillingInformation', id: string } | { __typename: 'ContactPersonInformation', id: string } | { __typename: 'ContractedInformation', id: string } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', id: string } | { __typename: 'EmailInformation', emailAddress: string, emailType: EmailType, id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string } | { __typename: 'PhoneInformation', id: string } | { __typename: 'SalaryInformation', id: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', id: string } | { __typename: 'WorksInDepartmentInformation', id: string }> }> };

export type GetAllEmployeesOfTimeLabelGroupQueryVariables = Exact<{
  timeLabelGroupId: Scalars['ID']['input'];
}>;


export type GetAllEmployeesOfTimeLabelGroupQuery = { __typename?: 'Query', allEmployeesOfTimeLabelGroup: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number, additionalInformation: Array<{ __typename: 'AddressInformation', id: string } | { __typename: 'BillingInformation', id: string } | { __typename: 'ContactPersonInformation', id: string } | { __typename: 'ContractedInformation', id: string } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', id: string } | { __typename: 'EmailInformation', emailAddress: string, emailType: EmailType, id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string } | { __typename: 'PhoneInformation', id: string } | { __typename: 'SalaryInformation', id: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', id: string } | { __typename: 'WorksInDepartmentInformation', id: string }> }> };

export type GetAllFederalStatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllFederalStatesQuery = { __typename?: 'Query', allFederalStates: Array<{ __typename?: 'FederalState', code: string, name: string }> };

export type GetAllMyTimeLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllMyTimeLabelsQuery = { __typename?: 'Query', allMyTimeLabels: Array<{ __typename?: 'TimeLabel', companyId: string, departmentIds: Array<string>, employeeIds: Array<string>, id: string, isActive: boolean, isDeleted: boolean, name: string, version: number, departments: Array<{ __typename?: 'Department', companyId: string, description: string, id: string, leaderId?: string | null, name: string, version: number }>, employees: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number }>, timeLabelGroups: Array<{ __typename?: 'TimeLabelGroup', companyId: string, departmentIds: Array<string>, employeeIds: Array<string>, id: string, isGlobal: boolean, name: string, version: number }> }> };

export type GetAllTimeBalanceEntriesQueryVariables = Exact<{
  employeeId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllTimeBalanceEntriesQuery = { __typename?: 'Query', allTimeBalanceEntries?: { __typename?: 'AllTimeBalanceEntriesConnection', totalCount: number, nodes?: Array<{ __typename?: 'TimeBalanceEntry', id: string, createdById: string, employeeId: string, date: string, type: TimeBalanceType, vacationDays?: number | null, overtime?: string | null, reason: string, isDeleted: boolean, timestamp: string, version: number, createdBy: { __typename?: 'Contact', id: string, displayName: string }, history: Array<{ __typename?: 'TimeBalanceHistoryEntry', date: string, type: TimeBalanceType, vacationDays?: number | null, overtime?: string | null, reason: string, isDeleted: boolean, createdById: string, timestamp: string, createdBy: { __typename?: 'Contact', id: string, displayName: string } }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllTimeEntriesQueryVariables = Exact<{
  startDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
  employeeId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type GetAllTimeEntriesQuery = { __typename?: 'Query', allTimeEntries: Array<{ __typename?: 'TimeEntryDayGroup', date: string, id: string, absenceReason?: string | null, approvedWorkingMinutes: number, balanceMinutes: number, breakMinutes: number, errors: Array<TimeEntryDayGroupErrors>, pendingWorkingMinutes: number, rejectedWorkingMinutes: number, requiredWorkingMinutes: number, workingMinutes: number, items: Array<{ __typename?: 'TimeEntry', calendarId: string, description: string, end: string, entryType: TimeEntryType, id: string, status: TimeEntryStatus, path: Array<string>, start: string, timestamp: string, title: string, version: number, workLocation: WorkLocation, timeLabelId?: string | null, errors: Array<TimeEntryDayGroupErrors>, createdBy: { __typename?: 'Contact', displayName: string, id: string, version: number }, logs: Array<{ __typename?: 'TimeLogEntry', id: string, message: string, timestamp: string, createdBy: { __typename?: 'Contact', displayName: string, id: string, version: number } }>, member: { __typename?: 'Contact', displayName: string, id: string, version: number }, timeLabel?: { __typename?: 'TimeLabel', name: string, id: string, version: number } | null, history: Array<{ __typename?: 'TimeEntryHistory', description: string, end: string, entryType: TimeEntryType, start: string, status: TimeEntryStatus, timestamp: string, version: number, workLocation: WorkLocation, createdBy: { __typename?: 'Contact', id: string, displayName: string }, member: { __typename?: 'Contact', id: string, displayName: string }, timeLabel?: { __typename?: 'TimeLabel', name: string, id: string } | null }> }>, balanceEntry?: { __typename?: 'BalanceEntry', overtimeMinutes: number, type: TimeBalanceType } | null }> };

export type GetAllTimeLabelGroupsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllTimeLabelGroupsQuery = { __typename?: 'Query', allTimeLabelGroup?: { __typename?: 'AllTimeLabelGroupConnection', totalCount: number, nodes?: Array<{ __typename?: 'TimeLabelGroup', departmentIds: Array<string>, employeeIds: Array<string>, id: string, name: string, version: number, companyId: string, isGlobal: boolean, labels: Array<{ __typename?: 'TimeLabel', departmentIds: Array<string>, employeeIds: Array<string>, id: string, isActive: boolean, isDeleted: boolean, name: string, version: number, companyId: string }>, departments: Array<{ __typename?: 'Department', companyId: string, description: string, id: string, leaderId?: string | null, name: string, version: number }>, employees: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllTimeLabelGroupsOfDepartmentQueryVariables = Exact<{
  departmentId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllTimeLabelGroupsOfDepartmentQuery = { __typename?: 'Query', allTimeLabelGroupsOfDepartment?: { __typename?: 'AllTimeLabelGroupsOfDepartmentConnection', totalCount: number, nodes?: Array<{ __typename?: 'TimeLabelGroup', companyId: string, departmentIds: Array<string>, employeeIds: Array<string>, id: string, isGlobal: boolean, name: string, version: number, departments: Array<{ __typename?: 'Department', companyId: string, description: string, id: string, leaderId?: string | null, name: string, version: number }>, employees: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number }>, labels: Array<{ __typename?: 'TimeLabel', companyId: string, departmentIds: Array<string>, employeeIds: Array<string>, id: string, isActive: boolean, isDeleted: boolean, name: string, version: number }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllTimeLabelsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyActive: Scalars['Boolean']['input'];
  showDeleted: Scalars['Boolean']['input'];
}>;


export type GetAllTimeLabelsQuery = { __typename?: 'Query', allTimeLabel?: { __typename?: 'AllTimeLabelConnection', totalCount: number, nodes?: Array<{ __typename?: 'TimeLabel', departmentIds: Array<string>, employeeIds: Array<string>, id: string, isActive: boolean, isDeleted: boolean, name: string, version: number, companyId: string, departments: Array<{ __typename?: 'Department', companyId: string, description: string, id: string, leaderId?: string | null, name: string, version: number }>, employees: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllTimeLabelsOfDepartmentQueryVariables = Exact<{
  departmentId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyActive: Scalars['Boolean']['input'];
  showDeleted: Scalars['Boolean']['input'];
}>;


export type GetAllTimeLabelsOfDepartmentQuery = { __typename?: 'Query', allTimeLabelsOfDepartment?: { __typename?: 'AllTimeLabelsOfDepartmentConnection', totalCount: number, nodes?: Array<{ __typename?: 'TimeLabel', companyId: string, departmentIds: Array<string>, employeeIds: Array<string>, id: string, name: string, version: number, isActive: boolean, isDeleted: boolean, departments: Array<{ __typename?: 'Department', companyId: string, description: string, id: string, leaderId?: string | null, name: string, version: number }>, employees: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllTimeLabelsOfEmployeeQueryVariables = Exact<{
  contactId: Scalars['ID']['input'];
}>;


export type GetAllTimeLabelsOfEmployeeQuery = { __typename?: 'Query', allTimeLabelsOfEmployee: Array<{ __typename?: 'TimeLabel', companyId: string, departmentIds: Array<string>, employeeIds: Array<string>, id: string, isActive: boolean, isDeleted: boolean, name: string, version: number, departments: Array<{ __typename?: 'Department', companyId: string, description: string, id: string, leaderId?: string | null, name: string, version: number }>, employees: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number }>, timeLabelGroups: Array<{ __typename?: 'TimeLabelGroup', companyId: string, departmentIds: Array<string>, employeeIds: Array<string>, id: string, isGlobal: boolean, name: string, version: number }> }> };

export type GetAllTimeLabelsOfTimeLabelGroupQueryVariables = Exact<{
  timeLabelGroupId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyActive: Scalars['Boolean']['input'];
  showDeleted: Scalars['Boolean']['input'];
}>;


export type GetAllTimeLabelsOfTimeLabelGroupQuery = { __typename?: 'Query', allTimeLabelsOfTimeLabelGroup?: { __typename?: 'AllTimeLabelsOfTimeLabelGroupConnection', totalCount: number, nodes?: Array<{ __typename?: 'TimeLabel', companyId: string, departmentIds: Array<string>, employeeIds: Array<string>, id: string, name: string, version: number, isActive: boolean, isDeleted: boolean, departments: Array<{ __typename?: 'Department', companyId: string, description: string, id: string, leaderId?: string | null, name: string, version: number }>, employees: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllWorkingTimeModelsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  onlyVisible?: InputMaybe<Scalars['Boolean']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllWorkingTimeModelsQuery = { __typename?: 'Query', allWorkingTimeModels?: { __typename?: 'AllWorkingTimeModelsConnection', totalCount: number, nodes?: Array<{ __typename?: 'WorkingTimeModel', id: string, name: string, description: string, isVisible: boolean, isFlexible: boolean, hoursPerWeek: number, hoursPerMonday: number, hoursPerTuesday: number, hoursPerWednesday: number, hoursPerThursday: number, hoursPerFriday: number, hoursPerSaturday: number, hoursPerSunday: number, isDeleted: boolean, vacationDaysPerYear: number, version: number }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetMyAllAbsenceQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['LocalDate']['input'];
  showCanceled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMyAllAbsenceQuery = { __typename?: 'Query', myAllAbsences?: { __typename?: 'MyAllAbsencesConnection', totalCount: number, nodes?: Array<{ __typename?: 'Absence', absenceReasonId: string, absenceReasonName: string, end: string, id: string, isHalfEndDay: boolean, isHalfStartDay: boolean, start: string, status: AbsenceStatusType, timestamp: string, version: number, workDays: number, totalDays: number, publicHolidays: number, absenceReasonType: AbsenceReasonType, history: Array<{ __typename?: 'AbsenceHistory', absenceReasonId: string, absenceReasonName: string, end: string, isHalfEndDay: boolean, isHalfStartDay: boolean, start: string, status: AbsenceStatusType, timestamp: string, version: number, workDays: number, totalDays: number, publicHolidays: number, createdBy: { __typename?: 'Contact', id: string, displayName: string }, delegateEmployee?: { __typename?: 'Contact', displayName: string, id: string } | null }>, logs: Array<{ __typename?: 'AbsenceLog', id: string, message: string, timestamp: string, createdBy: { __typename?: 'Contact', displayName: string, id: string } }>, createdBy: { __typename?: 'Contact', displayName: string, id: string }, delegateEmployee?: { __typename?: 'Contact', displayName: string, id: string } | null, employee: { __typename?: 'Contact', displayName: string, id: string } }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetMyAllAcceptedVacationRequestsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['LocalDate']['input'];
}>;


export type GetMyAllAcceptedVacationRequestsQuery = { __typename?: 'Query', myAllAcceptedVacationRequests?: { __typename?: 'MyAllAcceptedVacationRequestsConnection', totalCount: number, nodes?: Array<{ __typename?: 'Absence', absenceReasonId: string, absenceReasonName: string, end: string, id: string, isDeleted: boolean, isHalfEndDay: boolean, isHalfStartDay: boolean, start: string, status: AbsenceStatusType, timestamp: string, version: number, workDays: number, totalDays: number, publicHolidays: number, employee: { __typename?: 'Contact', id: string, displayName: string }, history: Array<{ __typename?: 'AbsenceHistory', absenceReasonId: string, absenceReasonName: string, end: string, isHalfEndDay: boolean, isHalfStartDay: boolean, start: string, status: AbsenceStatusType, timestamp: string, version: number, workDays: number, totalDays: number, publicHolidays: number, createdBy: { __typename?: 'Contact', id: string, displayName: string }, delegateEmployee?: { __typename?: 'Contact', displayName: string, id: string } | null }>, logs: Array<{ __typename?: 'AbsenceLog', id: string, message: string, timestamp: string, createdBy: { __typename?: 'Contact', displayName: string, id: string } }>, createdBy: { __typename?: 'Contact', displayName: string, id: string }, delegateEmployee?: { __typename?: 'Contact', displayName: string, id: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetMyAllProjectTimeSummariesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetMyAllProjectTimeSummariesQuery = { __typename?: 'Query', myProjectTimeSummaries: Array<{ __typename?: 'ProjectTimeSummary', approvedMinutes: number, openMinutes: number, pendingMinutes: number, totalMinutes: number, positionName: string, projectName: string, totalWorkedMinutes: number, projectId: string, projectPositionId: string, isDeleted: boolean, startDate: string, endDate: string }> };

export type GetMyAllProjectTimeSummariesForListQueryVariables = Exact<{
  startDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMyAllProjectTimeSummariesForListQuery = { __typename?: 'Query', myAllProjectTimeSummaries: Array<{ __typename?: 'ProjectTimeSummary', totalWorkedMinutes: number, totalMinutes: number, positionName: string, projectName: string, projectId: string, projectPositionId: string }> };

export type GetMyAllProjectsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['LocalDate']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProjectType>;
  order?: InputMaybe<OrderType>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  start: Scalars['LocalDate']['input'];
}>;


export type GetMyAllProjectsQuery = { __typename?: 'Query', myAllProjects?: { __typename?: 'MyAllProjectsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProjectSummary', name: string, id: string }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetMyAllVacationRequestsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMyAllVacationRequestsQuery = { __typename?: 'Query', myAllVacationRequests?: { __typename?: 'MyAllVacationRequestsConnection', totalCount: number, nodes?: Array<{ __typename?: 'Absence', absenceReasonId: string, absenceReasonName: string, end: string, id: string, isDeleted: boolean, isHalfEndDay: boolean, isHalfStartDay: boolean, start: string, status: AbsenceStatusType, timestamp: string, version: number, workDays: number, totalDays: number, publicHolidays: number, employee: { __typename?: 'Contact', id: string, displayName: string }, history: Array<{ __typename?: 'AbsenceHistory', absenceReasonId: string, absenceReasonName: string, end: string, isHalfEndDay: boolean, isHalfStartDay: boolean, start: string, status: AbsenceStatusType, timestamp: string, version: number, workDays: number, totalDays: number, publicHolidays: number, createdBy: { __typename?: 'Contact', id: string, displayName: string }, delegateEmployee?: { __typename?: 'Contact', displayName: string, id: string } | null }>, logs: Array<{ __typename?: 'AbsenceLog', id: string, message: string, timestamp: string, createdBy: { __typename?: 'Contact', displayName: string, id: string } }>, createdBy: { __typename?: 'Contact', displayName: string, id: string }, delegateEmployee?: { __typename?: 'Contact', displayName: string, id: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetMyCalendarEntriesQueryVariables = Exact<{
  end: Scalars['LocalDate']['input'];
  showInformation: Scalars['Boolean']['input'];
  showOnlyMe: Scalars['Boolean']['input'];
  showPending: Scalars['Boolean']['input'];
  start: Scalars['LocalDate']['input'];
}>;


export type GetMyCalendarEntriesQuery = { __typename?: 'Query', myCalendarEntries: Array<{ __typename?: 'CalendarEntry', absenceId?: string | null, absenceReasonType?: AbsenceReasonType | null, absenceStatus?: AbsenceStatusType | null, endDate: string, isHalfEndDay: boolean, isHalfStartDay: boolean, startDate: string, title: string, totalDays: number, type: CalendarEntryType, absenceReasonId?: string | null, absenceVersion?: number | null, employee?: { __typename?: 'Contact', displayName: string, id: string } | null, delegateEmployee?: { __typename?: 'Contact', id: string, displayName: string } | null }> };

export type GetMyNextCalendarEntriesQueryVariables = Exact<{
  start: Scalars['LocalDate']['input'];
  showInformation: Scalars['Boolean']['input'];
  showPending: Scalars['Boolean']['input'];
}>;


export type GetMyNextCalendarEntriesQuery = { __typename?: 'Query', myNextCalendarEntries: Array<{ __typename?: 'CalendarEntry', absenceId?: string | null, startDate: string, endDate: string, title: string, absenceStatus?: AbsenceStatusType | null, absenceReasonType?: AbsenceReasonType | null, isHalfEndDay: boolean, isHalfStartDay: boolean, totalDays: number, type: CalendarEntryType, absenceReasonId?: string | null }> };

export type GetMyProjectTimeSummariesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetMyProjectTimeSummariesQuery = { __typename?: 'Query', myProjectTimeSummaries: Array<{ __typename?: 'ProjectTimeSummary', approvedMinutes: number, openMinutes: number, pendingMinutes: number, totalMinutes: number, positionName: string, projectName: string, totalWorkedMinutes: number, projectId: string, projectPositionId: string, isDeleted: boolean, startDate: string, endDate: string }> };

export type GetMyProjectWorktimeOverviewQueryVariables = Exact<{
  startDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
}>;


export type GetMyProjectWorktimeOverviewQuery = { __typename?: 'Query', myProjectWorktimeOverview: Array<{ __typename?: 'ProjectWorktimeOverview', date: string, entries: Array<{ __typename?: 'ProjectWorktimeOverviewEntry', projectId: string, projectName: string, projectPositionId: string, projectPositionName: string, totalMinutes: number }> }> };

export type GetMyProjectWorktimeYearlyOverviewQueryVariables = Exact<{
  year: Scalars['Int']['input'];
}>;


export type GetMyProjectWorktimeYearlyOverviewQuery = { __typename?: 'Query', myProjectWorktimeYearlyOverview: Array<{ __typename?: 'ProjectWorktimeOverviewEntry', totalMinutes: number, projectPositionName: string, projectPositionId: string, projectName: string, projectId: string }> };

export type GetMyTimeEntriesQueryVariables = Exact<{
  startDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type GetMyTimeEntriesQuery = { __typename?: 'Query', myTimeEntries: Array<{ __typename?: 'TimeEntryDayGroup', date: string, id: string, errors: Array<TimeEntryDayGroupErrors>, absenceReason?: string | null, workingMinutes: number, requiredWorkingMinutes: number, rejectedWorkingMinutes: number, pendingWorkingMinutes: number, breakMinutes: number, balanceMinutes: number, approvedWorkingMinutes: number, items: Array<{ __typename?: 'TimeEntry', calendarId: string, description: string, end: string, entryType: TimeEntryType, id: string, status: TimeEntryStatus, path: Array<string>, start: string, timestamp: string, title: string, version: number, workLocation: WorkLocation, timeLabelId?: string | null, history: Array<{ __typename?: 'TimeEntryHistory', description: string, end: string, entryType: TimeEntryType, start: string, status: TimeEntryStatus, timestamp: string, version: number, workLocation: WorkLocation, createdBy: { __typename?: 'Contact', id: string, displayName: string }, member: { __typename?: 'Contact', id: string, displayName: string }, timeLabel?: { __typename?: 'TimeLabel', name: string, id: string } | null }>, createdBy: { __typename?: 'Contact', displayName: string, id: string }, logs: Array<{ __typename?: 'TimeLogEntry', id: string, message: string, timestamp: string, createdBy: { __typename?: 'Contact', displayName: string, id: string } }>, member: { __typename?: 'Contact', displayName: string, id: string }, timeLabel?: { __typename?: 'TimeLabel', name: string, id: string } | null }>, balanceEntry?: { __typename?: 'BalanceEntry', overtimeMinutes: number, type: TimeBalanceType } | null }> };

export type GetMyTimerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyTimerQuery = { __typename?: 'Query', myTimer?: string | null };

export type GetMyTotalWorkTimeSummaryQueryVariables = Exact<{
  today: Scalars['LocalDate']['input'];
}>;


export type GetMyTotalWorkTimeSummaryQuery = { __typename?: 'Query', myTotalWorkTimeSummary: { __typename?: 'WorkTimeSummary', approvedMinutes: number, balanceMinutes: number, pendingMinutes: number, rejectedMinutes: number, requiredMinutes: number, totalMinutes: number } };

export type GetMyVacationSummaryQueryVariables = Exact<{
  year: Scalars['Int']['input'];
}>;


export type GetMyVacationSummaryQuery = { __typename?: 'Query', myVacationSummary: { __typename?: 'VacationSummary', total: number, inPending: number, planned: number, taken: number } };

export type GetProjectTimeSummariesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
}>;


export type GetProjectTimeSummariesQuery = { __typename?: 'Query', projectTimeSummaries: Array<{ __typename?: 'ProjectTimeSummary', approvedMinutes: number, openMinutes: number, pendingMinutes: number, totalMinutes: number, positionName: string, projectName: string, totalWorkedMinutes: number }> };

export type GetTeamMemberTimeEntriesQueryVariables = Exact<{
  startDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
  employeeId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type GetTeamMemberTimeEntriesQuery = { __typename?: 'Query', teamMemberTimeEntries: Array<{ __typename?: 'TimeEntryDayGroup', date: string, id: string, errors: Array<TimeEntryDayGroupErrors>, absenceReason?: string | null, approvedWorkingMinutes: number, balanceMinutes: number, breakMinutes: number, pendingWorkingMinutes: number, rejectedWorkingMinutes: number, requiredWorkingMinutes: number, workingMinutes: number, items: Array<{ __typename?: 'TimeEntry', calendarId: string, description: string, end: string, entryType: TimeEntryType, id: string, status: TimeEntryStatus, path: Array<string>, start: string, timestamp: string, title: string, version: number, workLocation: WorkLocation, timeLabelId?: string | null, createdBy: { __typename?: 'Contact', displayName: string, id: string }, logs: Array<{ __typename?: 'TimeLogEntry', id: string, message: string, timestamp: string, createdBy: { __typename?: 'Contact', displayName: string, id: string } }>, member: { __typename?: 'Contact', displayName: string, id: string }, timeLabel?: { __typename?: 'TimeLabel', name: string, id: string } | null, history: Array<{ __typename?: 'TimeEntryHistory', description: string, end: string, entryType: TimeEntryType, start: string, status: TimeEntryStatus, timestamp: string, version: number, workLocation: WorkLocation, createdBy: { __typename?: 'Contact', id: string, displayName: string }, member: { __typename?: 'Contact', id: string, displayName: string }, timeLabel?: { __typename?: 'TimeLabel', name: string, id: string } | null }> }>, balanceEntry?: { __typename?: 'BalanceEntry', overtimeMinutes: number, type: TimeBalanceType } | null }> };

export type GetTeamMemberTotalWorkTimeSummaryQueryVariables = Exact<{
  today: Scalars['LocalDate']['input'];
  employeeId: Scalars['ID']['input'];
}>;


export type GetTeamMemberTotalWorkTimeSummaryQuery = { __typename?: 'Query', totalTeamMemberWorkTimeSummary: { __typename?: 'WorkTimeSummary', approvedMinutes: number, balanceMinutes: number, pendingMinutes: number, rejectedMinutes: number, requiredMinutes: number, totalMinutes: number } };

export type GetTeamVacationSummaryQueryVariables = Exact<{
  employeeId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
}>;


export type GetTeamVacationSummaryQuery = { __typename?: 'Query', teamVacationSummary: { __typename?: 'VacationSummary', total: number, inPending: number, planned: number, taken: number } };

export type GetTotalWorkTimeSummaryQueryVariables = Exact<{
  today: Scalars['LocalDate']['input'];
  employeeId: Scalars['ID']['input'];
}>;


export type GetTotalWorkTimeSummaryQuery = { __typename?: 'Query', totalWorkTimeSummary: { __typename?: 'WorkTimeSummary', approvedMinutes: number, balanceMinutes: number, pendingMinutes: number, rejectedMinutes: number, requiredMinutes: number, totalMinutes: number } };

export type GetVacationSummaryQueryVariables = Exact<{
  employeeId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
}>;


export type GetVacationSummaryQuery = { __typename?: 'Query', vacationSummary: { __typename?: 'VacationSummary', total: number, inPending: number, planned: number, taken: number } };

export type MyCancelVacationMutationVariables = Exact<{
  comment?: InputMaybe<Scalars['String']['input']>;
  absenceId: Scalars['ID']['input'];
  version: Scalars['Long']['input'];
}>;


export type MyCancelVacationMutation = { __typename?: 'Mutation', myCancelVacation: { __typename?: 'MyCancelVacationPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'InvalidUserPrivilegesError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, absence?: { __typename?: 'Absence', id: string } | null } };

export type MyCheckVacationQueryVariables = Exact<{
  startDate: Scalars['LocalDate']['input'];
  isHalfStartDay: Scalars['Boolean']['input'];
  endDate: Scalars['LocalDate']['input'];
  isHalfEndDay: Scalars['Boolean']['input'];
  absenceId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type MyCheckVacationQuery = { __typename?: 'Query', myCheckVacation: { __typename?: 'VacationCheckResult', canBeTaken: boolean, hasDelegateDuties: boolean, isInSameYear: boolean, isOverlapping: boolean, leftDays: number, neededDays: number, startDateIsTooClose: boolean } };

export type MyCreateVacationMutationVariables = Exact<{
  absenceReasonId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  delegateEmployeeId: Scalars['ID']['input'];
  end: Scalars['LocalDate']['input'];
  isHalfEndDay: Scalars['Boolean']['input'];
  isHalfStartDay: Scalars['Boolean']['input'];
  start: Scalars['LocalDate']['input'];
}>;


export type MyCreateVacationMutation = { __typename?: 'Mutation', myCreateVacation: { __typename?: 'MyCreateVacationPayload', errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, absence?: { __typename?: 'Absence', absenceReasonId: string, absenceReasonName: string, end: string, id: string, isHalfEndDay: boolean, isHalfStartDay: boolean, start: string, status: AbsenceStatusType, timestamp: string, version: number, absenceReasonType: AbsenceReasonType, publicHolidays: number, totalDays: number, workDays: number, history: Array<{ __typename?: 'AbsenceHistory', absenceReasonId: string, absenceReasonName: string, end: string, isHalfEndDay: boolean, isHalfStartDay: boolean, start: string, status: AbsenceStatusType, timestamp: string, version: number, publicHolidays: number, totalDays: number, workDays: number, createdBy: { __typename?: 'Contact', id: string, displayName: string }, delegateEmployee?: { __typename?: 'Contact', displayName: string, id: string } | null }>, logs: Array<{ __typename?: 'AbsenceLog', id: string, message: string, timestamp: string, createdBy: { __typename?: 'Contact', displayName: string, id: string } }>, createdBy: { __typename?: 'Contact', displayName: string, id: string }, delegateEmployee?: { __typename?: 'Contact', displayName: string, id: string } | null, employee: { __typename?: 'Contact', displayName: string, id: string } } | null } };

export type MyUpdateVacationMutationVariables = Exact<{
  absenceReasonId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  delegateEmployeeId: Scalars['ID']['input'];
  end: Scalars['LocalDate']['input'];
  isHalfEndDay: Scalars['Boolean']['input'];
  isHalfStartDay: Scalars['Boolean']['input'];
  start: Scalars['LocalDate']['input'];
  absenceId: Scalars['ID']['input'];
  version: Scalars['Long']['input'];
}>;


export type MyUpdateVacationMutation = { __typename?: 'Mutation', myUpdateVacation: { __typename?: 'MyUpdateVacationPayload', errors?: Array<{ __typename?: 'ConcurrentAccessError', errorType: string, message: string } | { __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'InvalidUserPrivilegesError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, absence?: { __typename?: 'Absence', absenceReasonId: string, absenceReasonName: string, end: string, id: string, isHalfEndDay: boolean, isHalfStartDay: boolean, start: string, status: AbsenceStatusType, timestamp: string, version: number, absenceReasonType: AbsenceReasonType, publicHolidays: number, totalDays: number, workDays: number, history: Array<{ __typename?: 'AbsenceHistory', absenceReasonId: string, absenceReasonName: string, end: string, isHalfEndDay: boolean, isHalfStartDay: boolean, start: string, status: AbsenceStatusType, timestamp: string, version: number, totalDays: number, publicHolidays: number, workDays: number, createdBy: { __typename?: 'Contact', id: string, displayName: string }, delegateEmployee?: { __typename?: 'Contact', displayName: string, id: string } | null }>, logs: Array<{ __typename?: 'AbsenceLog', id: string, message: string, timestamp: string, createdBy: { __typename?: 'Contact', displayName: string, id: string } }>, createdBy: { __typename?: 'Contact', displayName: string, id: string }, delegateEmployee?: { __typename?: 'Contact', displayName: string, id: string } | null, employee: { __typename?: 'Contact', displayName: string, id: string } } | null } };

export type MyWorkTimeSummaryQueryVariables = Exact<{
  startDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
}>;


export type MyWorkTimeSummaryQuery = { __typename?: 'Query', myWorkTimeSummary: { __typename?: 'WorkTimeSummary', approvedMinutes: number, balanceMinutes: number, pendingMinutes: number, rejectedMinutes: number, requiredMinutes: number, totalMinutes: number } };

export type RemoveEmployeesFromLabelGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  employees: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  version: Scalars['Long']['input'];
}>;


export type RemoveEmployeesFromLabelGroupMutation = { __typename?: 'Mutation', removeEmployeesFromLabelGroup: { __typename?: 'RemoveEmployeesFromLabelGroupPayload', errors?: Array<{ __typename?: 'ConcurrentAccessError', errorType: string, message: string } | { __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, timeLabelGroup?: { __typename?: 'TimeLabelGroup', companyId: string, departmentIds: Array<string>, employeeIds: Array<string>, id: string, isGlobal: boolean, name: string, version: number, departments: Array<{ __typename?: 'Department', companyId: string, description: string, id: string, leaderId?: string | null, name: string, version: number }>, employees: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number }>, labels: Array<{ __typename?: 'TimeLabel', companyId: string, departmentIds: Array<string>, employeeIds: Array<string>, id: string, isActive: boolean, isDeleted: boolean, name: string, version: number }> } | null } };

export type RemoveEmployeesFromTimeLabelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  employees: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  version: Scalars['Long']['input'];
}>;


export type RemoveEmployeesFromTimeLabelMutation = { __typename?: 'Mutation', removeEmployeesFromTimeLabel: { __typename?: 'RemoveEmployeesFromTimeLabelPayload', errors?: Array<{ __typename?: 'ConcurrentAccessError', errorType: string, message: string } | { __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, timeLabel?: { __typename?: 'TimeLabel', companyId: string, departmentIds: Array<string>, employeeIds: Array<string>, id: string, isActive: boolean, isDeleted: boolean, name: string, version: number, departments: Array<{ __typename?: 'Department', companyId: string, description: string, id: string, leaderId?: string | null, name: string, version: number }>, employees: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number }> } | null } };

export type RemoveLabelGroupsFromDepartmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  timeLabelGroupsIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveLabelGroupsFromDepartmentMutation = { __typename?: 'Mutation', removeLabelGroupsFromDepartment: { __typename?: 'RemoveLabelGroupsFromDepartmentPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type RemoveLabelsFromDepartmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  timeLabelIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveLabelsFromDepartmentMutation = { __typename?: 'Mutation', removeLabelsFromDepartment: { __typename?: 'RemoveLabelsFromDepartmentPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type RemoveLabelsFromLabelGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  labels: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  version: Scalars['Long']['input'];
}>;


export type RemoveLabelsFromLabelGroupMutation = { __typename?: 'Mutation', removeLabelsFromLabelGroup: { __typename?: 'RemoveLabelsFromLabelGroupPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'ConcurrentAccessError', errorType: string, message: string } | { __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type StartMyTimerMutationVariables = Exact<{
  startTime: Scalars['DateTime']['input'];
}>;


export type StartMyTimerMutation = { __typename?: 'Mutation', myStartTimer: { __typename?: 'MyStartTimerPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string }> | null } };

export type StopMyTimerMutationVariables = Exact<{
  endTime: Scalars['DateTime']['input'];
}>;


export type StopMyTimerMutation = { __typename?: 'Mutation', myStopTimer: { __typename?: 'MyStopTimerPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string }> | null } };

export type TeamMemberWorkTimeSummaryQueryVariables = Exact<{
  startDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
  employeeId: Scalars['ID']['input'];
}>;


export type TeamMemberWorkTimeSummaryQuery = { __typename?: 'Query', teamMemberWorkTimeSummary: { __typename?: 'WorkTimeSummary', approvedMinutes: number, balanceMinutes: number, pendingMinutes: number, rejectedMinutes: number, requiredMinutes: number, totalMinutes: number } };

export type UpdateAbsenceMutationVariables = Exact<{
  absenceReasonId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  delegateEmployeeId: Scalars['ID']['input'];
  end: Scalars['LocalDate']['input'];
  isHalfEndDay: Scalars['Boolean']['input'];
  isHalfStartDay: Scalars['Boolean']['input'];
  start: Scalars['LocalDate']['input'];
  absenceId: Scalars['ID']['input'];
  version: Scalars['Long']['input'];
  startWorkflow?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateAbsenceMutation = { __typename?: 'Mutation', updateAbsence: { __typename?: 'UpdateAbsencePayload', absence?: { __typename?: 'Absence', id: string, absenceReasonId: string, absenceReasonName: string, absenceReasonType: AbsenceReasonType, end: string, isHalfEndDay: boolean, isHalfStartDay: boolean, start: string, status: AbsenceStatusType, timestamp: string, version: number, totalDays: number, workDays: number, publicHolidays: number, createdBy: { __typename?: 'Contact', id: string, displayName: string }, delegateEmployee?: { __typename?: 'Contact', displayName: string, id: string } | null, employee: { __typename?: 'Contact', displayName: string, id: string }, history: Array<{ __typename?: 'AbsenceHistory', absenceReasonId: string, absenceReasonName: string, end: string, isHalfEndDay: boolean, isHalfStartDay: boolean, start: string, status: AbsenceStatusType, timestamp: string, version: number, publicHolidays: number, totalDays: number, workDays: number, createdBy: { __typename?: 'Contact', displayName: string, id: string }, delegateEmployee?: { __typename?: 'Contact', displayName: string, id: string } | null }>, logs: Array<{ __typename?: 'AbsenceLog', id: string, message: string, timestamp: string, createdBy: { __typename?: 'Contact', displayName: string, id: string } }> } | null, errors?: Array<{ __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdateAbsenceReasonMutationVariables = Exact<{
  description: Scalars['String']['input'];
  isPaid: Scalars['Boolean']['input'];
  isVisible: Scalars['Boolean']['input'];
  maximumContinuedPayment?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  removesWorkingHours: Scalars['Boolean']['input'];
  type: AbsenceReasonType;
  id: Scalars['ID']['input'];
  version: Scalars['Long']['input'];
}>;


export type UpdateAbsenceReasonMutation = { __typename?: 'Mutation', updateAbsenceReason: { __typename?: 'UpdateAbsenceReasonPayload', absenceReason?: { __typename?: 'AbsenceReason', id: string, name: string, description: string, isVisible: boolean, isDeleted: boolean, isPaid: boolean, maximumContinuedPayment?: number | null, removesWorkingHours: boolean, type: AbsenceReasonType, version: number } | null, errors?: Array<{ __typename?: 'ConcurrentAccessError', errorType: string, message: string } | { __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdateCalendarEventMutationVariables = Exact<{
  description: Scalars['String']['input'];
  endDate: Scalars['LocalDate']['input'];
  federalStateCodes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  isHalfEndDay: Scalars['Boolean']['input'];
  isHalfStartDay: Scalars['Boolean']['input'];
  isVacation: Scalars['Boolean']['input'];
  locations: Array<Scalars['String']['input']> | Scalars['String']['input'];
  startDate: Scalars['LocalDate']['input'];
  type: CalendarEventType;
  id: Scalars['ID']['input'];
  version: Scalars['Long']['input'];
}>;


export type UpdateCalendarEventMutation = { __typename?: 'Mutation', updateCalendarEvent: { __typename?: 'UpdateCalendarEventPayload', calendarEvent?: { __typename?: 'CalendarEvent', id: string, startDate: string, isHalfStartDay: boolean, endDate: string, isHalfEndDay: boolean, type: CalendarEventType, isVacation: boolean, description: string, federalStateCodes: Array<string>, locations: Array<string>, version: number } | null, errors?: Array<{ __typename?: 'ConcurrentAccessError', errorType: string, message: string } | { __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdateDayTimeEntryMutationVariables = Exact<{
  employeeId: Scalars['ID']['input'];
  date: Scalars['LocalDate']['input'];
  timeEntries: Array<UpsertTimeEntryInput> | UpsertTimeEntryInput;
}>;


export type UpdateDayTimeEntryMutation = { __typename?: 'Mutation', updateDayTimeEntry: { __typename?: 'UpdateDayTimeEntryPayload', timeEntryDayGroup?: { __typename?: 'TimeEntryDayGroup', absenceReason?: string | null, date: string, errors: Array<TimeEntryDayGroupErrors>, id: string, approvedWorkingMinutes: number, balanceMinutes: number, breakMinutes: number, pendingWorkingMinutes: number, rejectedWorkingMinutes: number, requiredWorkingMinutes: number, workingMinutes: number, items: Array<{ __typename?: 'TimeEntry', calendarId: string, createdById: string, description: string, end: string, entryType: TimeEntryType, id: string, memberId: string, path: Array<string>, start: string, status: TimeEntryStatus, timeLabelId?: string | null, timestamp: string, title: string, version: number, workLocation: WorkLocation, errors: Array<TimeEntryDayGroupErrors>, history: Array<{ __typename?: 'TimeEntryHistory', description: string, end: string, entryType: TimeEntryType, start: string, status: TimeEntryStatus, timestamp: string, version: number, workLocation: WorkLocation, createdBy: { __typename?: 'Contact', id: string, displayName: string }, member: { __typename?: 'Contact', id: string, displayName: string }, timeLabel?: { __typename?: 'TimeLabel', name: string, id: string } | null }>, logs: Array<{ __typename?: 'TimeLogEntry', id: string, message: string, timestamp: string, createdBy: { __typename?: 'Contact', displayName: string, id: string } }>, member: { __typename?: 'Contact', displayName: string, id: string }, timeLabel?: { __typename?: 'TimeLabel', name: string, id: string } | null }>, balanceEntry?: { __typename?: 'BalanceEntry', overtimeMinutes: number, type: TimeBalanceType } | null } | null } };

export type UpdateMyDayTimeEntryMutationVariables = Exact<{
  date: Scalars['LocalDate']['input'];
  timeEntries: Array<UpsertTimeEntryInput> | UpsertTimeEntryInput;
}>;


export type UpdateMyDayTimeEntryMutation = { __typename?: 'Mutation', updateMyDayTimeEntry: { __typename?: 'UpdateMyDayTimeEntryPayload', timeEntryDayGroup?: { __typename?: 'TimeEntryDayGroup', absenceReason?: string | null, date: string, errors: Array<TimeEntryDayGroupErrors>, id: string, approvedWorkingMinutes: number, balanceMinutes: number, breakMinutes: number, pendingWorkingMinutes: number, rejectedWorkingMinutes: number, requiredWorkingMinutes: number, workingMinutes: number, items: Array<{ __typename?: 'TimeEntry', calendarId: string, createdById: string, description: string, end: string, entryType: TimeEntryType, id: string, memberId: string, path: Array<string>, start: string, status: TimeEntryStatus, timeLabelId?: string | null, timestamp: string, title: string, version: number, workLocation: WorkLocation, errors: Array<TimeEntryDayGroupErrors>, history: Array<{ __typename?: 'TimeEntryHistory', description: string, end: string, entryType: TimeEntryType, start: string, status: TimeEntryStatus, timestamp: string, version: number, workLocation: WorkLocation, createdBy: { __typename?: 'Contact', id: string, displayName: string }, member: { __typename?: 'Contact', id: string, displayName: string }, timeLabel?: { __typename?: 'TimeLabel', name: string, id: string } | null }>, logs: Array<{ __typename?: 'TimeLogEntry', id: string, message: string, timestamp: string, createdBy: { __typename?: 'Contact', displayName: string, id: string } }>, member: { __typename?: 'Contact', displayName: string, id: string }, timeLabel?: { __typename?: 'TimeLabel', name: string, id: string } | null }>, balanceEntry?: { __typename?: 'BalanceEntry', overtimeMinutes: number, type: TimeBalanceType } | null } | null } };

export type UpdateTimeBalanceEntryMutationVariables = Exact<{
  date: Scalars['LocalDate']['input'];
  type: TimeBalanceType;
  vacationDays?: InputMaybe<Scalars['Decimal']['input']>;
  overtime?: InputMaybe<Scalars['TimeSpan']['input']>;
  reason: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  version: Scalars['Long']['input'];
}>;


export type UpdateTimeBalanceEntryMutation = { __typename?: 'Mutation', updateTimeBalanceEntry: { __typename?: 'UpdateTimeBalanceEntryPayload', timeBalanceEntry?: { __typename?: 'TimeBalanceEntry', id: string, createdById: string, date: string, employeeId: string, isDeleted: boolean, overtime?: string | null, reason: string, timestamp: string, type: TimeBalanceType, vacationDays?: number | null, version: number, history: Array<{ __typename?: 'TimeBalanceHistoryEntry', createdById: string, date: string, isDeleted: boolean, overtime?: string | null, reason: string, timestamp: string, type: TimeBalanceType, vacationDays?: number | null, createdBy: { __typename?: 'Contact', id: string, displayName: string } }>, createdBy: { __typename?: 'Contact', id: string, displayName: string } } | null, errors?: Array<{ __typename?: 'ConcurrentAccessError', errorType: string, message: string } | { __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type UpdateTimeLabelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  version: Scalars['Long']['input'];
}>;


export type UpdateTimeLabelMutation = { __typename?: 'Mutation', updateTimeLabel: { __typename?: 'UpdateTimeLabelPayload', errors?: Array<{ __typename?: 'ConcurrentAccessError', errorType: string, message: string } | { __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, timeLabel?: { __typename?: 'TimeLabel', departmentIds: Array<string>, employeeIds: Array<string>, id: string, isActive: boolean, isDeleted: boolean, name: string, version: number, companyId: string, departments: Array<{ __typename?: 'Department', companyId: string, description: string, id: string, leaderId?: string | null, name: string, version: number }>, employees: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number }> } | null } };

export type UpdateTimeLabelGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  isGlobal: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  version: Scalars['Long']['input'];
}>;


export type UpdateTimeLabelGroupMutation = { __typename?: 'Mutation', updateTimeLabelGroup: { __typename?: 'UpdateTimeLabelGroupPayload', errors?: Array<{ __typename?: 'ConcurrentAccessError', errorType: string, message: string } | { __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null, timeLabelGroup?: { __typename?: 'TimeLabelGroup', departmentIds: Array<string>, employeeIds: Array<string>, id: string, name: string, version: number, companyId: string, isGlobal: boolean, labels: Array<{ __typename?: 'TimeLabel', departmentIds: Array<string>, employeeIds: Array<string>, id: string, isActive: boolean, isDeleted: boolean, name: string, version: number, companyId: string }>, departments: Array<{ __typename?: 'Department', companyId: string, description: string, id: string, leaderId?: string | null, name: string, version: number }>, employees: Array<{ __typename?: 'Contact', companyName: string, contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, displayName: string, firstName: string, id: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, isDeleted: boolean, isContactPerson: boolean, isEmployee: boolean, isTemporary: boolean, lastName: string, salutation: SalutationType, shortCode: string, title: string, version: number }> } | null } };

export type UpdateWorkingTimeModelMutationVariables = Exact<{
  description: Scalars['String']['input'];
  hoursPerFriday: Scalars['Decimal']['input'];
  hoursPerMonday: Scalars['Decimal']['input'];
  hoursPerSaturday: Scalars['Decimal']['input'];
  hoursPerSunday: Scalars['Decimal']['input'];
  hoursPerThursday: Scalars['Decimal']['input'];
  hoursPerTuesday: Scalars['Decimal']['input'];
  hoursPerWednesday: Scalars['Decimal']['input'];
  hoursPerWeek: Scalars['Decimal']['input'];
  isFlexible: Scalars['Boolean']['input'];
  isVisible: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  vacationDaysPerYear: Scalars['Decimal']['input'];
  id: Scalars['ID']['input'];
  version: Scalars['Long']['input'];
}>;


export type UpdateWorkingTimeModelMutation = { __typename?: 'Mutation', updateWorkingTimeModel: { __typename?: 'UpdateWorkingTimeModelPayload', workingTimeModel?: { __typename?: 'WorkingTimeModel', id: string, description: string, hoursPerFriday: number, hoursPerMonday: number, hoursPerSaturday: number, hoursPerSunday: number, hoursPerThursday: number, hoursPerTuesday: number, hoursPerWednesday: number, hoursPerWeek: number, isDeleted: boolean, isFlexible: boolean, isVisible: boolean, name: string, vacationDaysPerYear: number, version: number } | null, errors?: Array<{ __typename?: 'ConcurrentAccessError', errorType: string, message: string } | { __typename?: 'DomainError', errorType: string, message: string } | { __typename?: 'PropertyValidationError', errorType: string, message: string, errors: Array<{ __typename?: 'PropertyError', errorMessage: string, propertyName: string }> }> | null } };

export type WorkTimeSummaryQueryVariables = Exact<{
  startDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
  employeeId: Scalars['ID']['input'];
}>;


export type WorkTimeSummaryQuery = { __typename?: 'Query', workTimeSummary: { __typename?: 'WorkTimeSummary', approvedMinutes: number, balanceMinutes: number, pendingMinutes: number, rejectedMinutes: number, requiredMinutes: number, totalMinutes: number } };

export type AccessibleUserGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccessibleUserGroupsQuery = { __typename?: 'Query', accessibleUserGroups: Array<{ __typename?: 'UserGroup', id: string, name: string }> };

export type GetAllSuppliersAndMembersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllSuppliersAndMembersQuery = { __typename?: 'Query', allContacts?: { __typename?: 'AllContactsConnection', totalCount: number, nodes?: Array<{ __typename: 'Contact', contactNumber: string, contactTypes: Array<ContactType>, displayContactType: Array<ContactType>, id: string, displayName: string, firstName: string, lastName: string, isACompany: boolean, isAFreelancer: boolean, isAPerson: boolean, additionalInformation: Array<{ __typename: 'AddressInformation', id: string } | { __typename: 'BillingInformation', id: string } | { __typename: 'ContactPersonInformation', contactPersonId: string, contactUsage: Array<ContactUsage>, id: string } | { __typename: 'ContractedInformation', id: string } | { __typename: 'DateInformation', id: string } | { __typename: 'DepartmentInformation', id: string } | { __typename: 'EmailInformation', emailAddress: string, id: string } | { __typename: 'EmployeeWorkingConditionInformation', id: string } | { __typename: 'IsContactPersonOfInformation', id: string } | { __typename: 'PaymentConditionInformation', id: string } | { __typename: 'PaymentInformation', id: string } | { __typename: 'PhoneInformation', id: string } | { __typename: 'SalaryInformation', id: string } | { __typename: 'WebsiteInformation', id: string } | { __typename: 'WorkingConditionInformation', id: string } | { __typename: 'WorksInDepartmentInformation', id: string }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetAllUsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllUsersQuery = { __typename?: 'Query', allUsers?: { __typename?: 'AllUsersConnection', totalCount: number, nodes?: Array<{ __typename?: 'User', contactId?: string | null, email: string, emailVerified: boolean, enabled: boolean, groups: Array<string>, id: string, userGuid?: string | null, username: string, firstName: string, lastName: string }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', node?: { __typename?: 'Absence', id: string } | { __typename?: 'AbsenceReason', id: string } | { __typename?: 'AccountingProfile', id: string } | { __typename?: 'BccRecipientList', id: string } | { __typename?: 'CalendarEvent', id: string } | { __typename?: 'CatalogEntry', id: string } | { __typename?: 'Contact', id: string } | { __typename?: 'CorrectedCreditNote', id: string } | { __typename?: 'CorrectedInvoice', id: string } | { __typename?: 'CreditNote', id: string } | { __typename?: 'Department', id: string } | { __typename?: 'DiscountProfile', id: string } | { __typename?: 'DunningLevel', id: string } | { __typename?: 'Email', id: string } | { __typename?: 'FileEntry', id: string } | { __typename?: 'FolderEntry', id: string } | { __typename?: 'Invoice', id: string } | { __typename?: 'Offer', id: string } | { __typename?: 'Project', id: string } | { __typename?: 'ProjectTimeApproval', id: string } | { __typename?: 'ProjectTimeEntry', id: string } | { __typename?: 'RollingNumber', id: string } | { __typename?: 'SaleableService', id: string } | { __typename?: 'SaleableServiceGroup', id: string } | { __typename?: 'SaleableUnit', id: string } | { __typename?: 'Template', id: string } | { __typename?: 'TimeBalanceEntry', id: string } | { __typename?: 'TimeEntry', id: string } | { __typename?: 'TimeLabel', id: string } | { __typename?: 'TimeLabelGroup', id: string } | { __typename?: 'User', contactId?: string | null, email: string, emailVerified: boolean, enabled: boolean, groups: Array<string>, id: string, username: string, firstName: string, lastName: string } | { __typename?: 'UserGroup', id: string } | { __typename?: 'WorkingTimeModel', id: string } | null };

export type MyPrivilegesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPrivilegesQuery = { __typename?: 'Query', myPrivileges: { __typename?: 'Privilege', roles: Array<string>, isMultiContractor: boolean, contractorId?: string | null } };

export type ResendVerificationEmailMutationVariables = Exact<{
  userid: Scalars['ID']['input'];
  redirectUri: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
}>;


export type ResendVerificationEmailMutation = { __typename?: 'Mutation', resendVerificationEmail: { __typename?: 'ResendVerificationEmailPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'InvalidUserPrivilegesError', errorType: string, message: string } | { __typename?: 'KeyCloakError', httpResponse: string, message: string }> | null } };

export type ResendVerificationEmailToAllUnverifiedMutationVariables = Exact<{
  redirectUri: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
}>;


export type ResendVerificationEmailToAllUnverifiedMutation = { __typename?: 'Mutation', resendVerificationEmailToAllUnverified: { __typename?: 'ResendVerificationEmailToAllUnverifiedPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'InvalidUserPrivilegesError', errorType: string, message: string } | { __typename?: 'KeyCloakError', httpResponse: string, message: string }> | null } };

export type UserAddLoginMutationVariables = Exact<{
  contactId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  groupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  lastName: Scalars['String']['input'];
  username: Scalars['String']['input'];
  contractorId?: InputMaybe<Scalars['ID']['input']>;
  clientId: Scalars['String']['input'];
  isMultiContractor?: InputMaybe<Scalars['Boolean']['input']>;
  redirectUri: Scalars['String']['input'];
  sendVerificationEmail: Scalars['Boolean']['input'];
}>;


export type UserAddLoginMutation = { __typename?: 'Mutation', userAddLogin: { __typename?: 'UserAddLoginPayload', errors?: Array<{ __typename?: 'InvalidUserPrivilegesError', message: string } | { __typename?: 'KeyCloakError', message: string, httpResponse: string }> | null, user?: { __typename?: 'User', contactId?: string | null, email: string, emailVerified: boolean, enabled: boolean, groups: Array<string>, id: string, username: string, firstName: string, lastName: string, contractorId?: string | null } | null } };

export type UserByContactIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserByContactIdQuery = { __typename?: 'Query', userByContactId?: { __typename?: 'User', contactId?: string | null, email: string, emailVerified: boolean, enabled: boolean, groups: Array<string>, id: string, username: string, firstName: string, lastName: string } | null };

export type UserChangeGroupsMutationVariables = Exact<{
  groupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type UserChangeGroupsMutation = { __typename?: 'Mutation', userChangeGroups: { __typename?: 'UserChangeGroupsPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'InvalidUserPrivilegesError', message: string } | { __typename?: 'KeyCloakError', message: string }> | null } };

export type UserRemoveLoginMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserRemoveLoginMutation = { __typename?: 'Mutation', userRemoveLogin: { __typename?: 'UserRemoveLoginPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'InvalidUserPrivilegesError' } | { __typename?: 'KeyCloakError', message: string }> | null } };

export type UserSetEnabledMutationVariables = Exact<{
  enabled: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
}>;


export type UserSetEnabledMutation = { __typename?: 'Mutation', userSetEnabled: { __typename?: 'UserSetEnabledPayload', boolean?: boolean | null, errors?: Array<{ __typename?: 'InvalidUserPrivilegesError', message: string } | { __typename?: 'KeyCloakError', message: string }> | null } };

export const MonthlyOverviewItemFieldsFragmentDoc = gql`
    fragment MonthlyOverviewItemFields on MonthlyProjectOverviewItem {
  id
  itemType
  projectId
  projectName
  projectNumber
  projectType
  isGroup
  isInternalProjectsGroup
  budgetStatus {
    totalBudgetAmount
    totalBudgetMinutes
    spentAmount
    spentMinutes
    openMinutes
    pendingMinutes
    approvedMinutes
    remainingAmount
    remainingMinutes
    utilizationPercent
    minutesUtilizationPercent
  }
  clientId
  client {
    id
    displayName
  }
  employeeId
  employee {
    id
    displayName
  }
  timesheetId
  timesheetNumber
  timesheetStatus
  timesheetFrom
  timesheetTo
  openMinutes
  pendingMinutes
  approvedMinutes
  totalMinutes
  clientInvoices {
    invoiceId
    status
    createdAt
  }
  supplierCreditNotes {
    creditNoteId
    status
    createdAt
  }
  path
  parentId
  canCreateInvoice
  canCreateCreditNote
  canCreateMonthlyBilling
  project {
    id
    name
    number
  }
}
    `;
export const AddMemberDocument = gql`
    mutation AddMember($memberId: ID!, $organizationId: ID!) {
  addMember(input: {memberId: $memberId, organizationId: $organizationId}) {
    boolean
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type AddMemberMutationFn = Apollo.MutationFunction<AddMemberMutation, AddMemberMutationVariables>;

/**
 * __useAddMemberMutation__
 *
 * To run a mutation, you first call `useAddMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMemberMutation, { data, loading, error }] = useAddMemberMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAddMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddMemberMutation, AddMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMemberMutation, AddMemberMutationVariables>(AddMemberDocument, options);
      }
export type AddMemberMutationHookResult = ReturnType<typeof useAddMemberMutation>;
export type AddMemberMutationResult = Apollo.MutationResult<AddMemberMutation>;
export type AddMemberMutationOptions = Apollo.BaseMutationOptions<AddMemberMutation, AddMemberMutationVariables>;
export const ContactsByIdsDocument = gql`
    query ContactsByIds($ids: [ID!]!) {
  contactsByIds(ids: $ids) {
    companyName
    contactNumber
    contactTypes
    displayContactType
    displayName
    firstName
    id
    isACompany
    isAFreelancer
    isAPerson
    isDeleted
    isContactPerson
    isEmployee
    lastName
    salutation
    shortCode
    title
    version
    additionalInformation {
      id
      __typename
      ... on AddressInformation {
        type
        name
        city
        country
        id
        state
        street
        zipCode
      }
      ... on BillingInformation {
        id
        isSameAsShippingAddress
        name
        shippingAddress {
          type
          name
          city
          country
          state
          street
          zipCode
        }
        billingAddress {
          type
          name
          city
          country
          state
          street
          zipCode
        }
        bankAccount {
          bankName
          bic
          clientReference
          clientReferenceDate
          iban
        }
      }
      ... on ContactPersonInformation {
        contactPersonId
        contactUsage
        id
      }
      ... on EmailInformation {
        emailAddress
        emailType
        id
      }
      ... on PaymentInformation {
        id
        taxNumber
      }
      ... on PhoneInformation {
        id
        number
        phoneType
      }
      ... on SalaryInformation {
        id
        pricePerHour
        startDate
      }
      ... on WorkingConditionInformation {
        hoursPerFriday
        hoursPerMonday
        hoursPerSaturday
        hoursPerSunday
        hoursPerThursday
        hoursPerTuesday
        hoursPerWednesday
        hoursPerWeek
        id
        isFlexible
        startDate
      }
      ... on ContractedInformation {
        contractedId
        id
        marge
      }
      ... on DepartmentInformation {
        departmentName
      }
    }
    isTemporary
  }
}
    `;

/**
 * __useContactsByIdsQuery__
 *
 * To run a query within a React component, call `useContactsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useContactsByIdsQuery(baseOptions: Apollo.QueryHookOptions<ContactsByIdsQuery, ContactsByIdsQueryVariables> & ({ variables: ContactsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsByIdsQuery, ContactsByIdsQueryVariables>(ContactsByIdsDocument, options);
      }
export function useContactsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsByIdsQuery, ContactsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsByIdsQuery, ContactsByIdsQueryVariables>(ContactsByIdsDocument, options);
        }
export function useContactsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsByIdsQuery, ContactsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactsByIdsQuery, ContactsByIdsQueryVariables>(ContactsByIdsDocument, options);
        }
export type ContactsByIdsQueryHookResult = ReturnType<typeof useContactsByIdsQuery>;
export type ContactsByIdsLazyQueryHookResult = ReturnType<typeof useContactsByIdsLazyQuery>;
export type ContactsByIdsSuspenseQueryHookResult = ReturnType<typeof useContactsByIdsSuspenseQuery>;
export type ContactsByIdsQueryResult = Apollo.QueryResult<ContactsByIdsQuery, ContactsByIdsQueryVariables>;
export const ContractedCompaniesByIdsDocument = gql`
    query ContractedCompaniesByIds($ids: [ID!]!) {
  contactsByIds(ids: $ids) {
    displayName
    id
  }
}
    `;

/**
 * __useContractedCompaniesByIdsQuery__
 *
 * To run a query within a React component, call `useContractedCompaniesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractedCompaniesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractedCompaniesByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useContractedCompaniesByIdsQuery(baseOptions: Apollo.QueryHookOptions<ContractedCompaniesByIdsQuery, ContractedCompaniesByIdsQueryVariables> & ({ variables: ContractedCompaniesByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractedCompaniesByIdsQuery, ContractedCompaniesByIdsQueryVariables>(ContractedCompaniesByIdsDocument, options);
      }
export function useContractedCompaniesByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractedCompaniesByIdsQuery, ContractedCompaniesByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractedCompaniesByIdsQuery, ContractedCompaniesByIdsQueryVariables>(ContractedCompaniesByIdsDocument, options);
        }
export function useContractedCompaniesByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContractedCompaniesByIdsQuery, ContractedCompaniesByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContractedCompaniesByIdsQuery, ContractedCompaniesByIdsQueryVariables>(ContractedCompaniesByIdsDocument, options);
        }
export type ContractedCompaniesByIdsQueryHookResult = ReturnType<typeof useContractedCompaniesByIdsQuery>;
export type ContractedCompaniesByIdsLazyQueryHookResult = ReturnType<typeof useContractedCompaniesByIdsLazyQuery>;
export type ContractedCompaniesByIdsSuspenseQueryHookResult = ReturnType<typeof useContractedCompaniesByIdsSuspenseQuery>;
export type ContractedCompaniesByIdsQueryResult = Apollo.QueryResult<ContractedCompaniesByIdsQuery, ContractedCompaniesByIdsQueryVariables>;
export const CreateBillingInformationDocument = gql`
    mutation CreateBillingInformation($bankAccount: BankAccountInput!, $billingAddress: AddressInput!, $contactId: ID!, $name: String!, $shippingAddress: AddressInput!) {
  createBillingInformation(
    input: {bankAccount: $bankAccount, billingAddress: $billingAddress, contactId: $contactId, name: $name, shippingAddress: $shippingAddress}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    billingInformation {
      id
      isSameAsShippingAddress
      name
      bankAccount {
        bankName
        bic
        clientReference
        clientReferenceDate
        iban
      }
      billingAddress {
        type
        name
        street
        zipCode
        city
        state
        country
      }
      shippingAddress {
        type
        name
        street
        zipCode
        city
        state
        country
      }
    }
  }
}
    `;
export type CreateBillingInformationMutationFn = Apollo.MutationFunction<CreateBillingInformationMutation, CreateBillingInformationMutationVariables>;

/**
 * __useCreateBillingInformationMutation__
 *
 * To run a mutation, you first call `useCreateBillingInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillingInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillingInformationMutation, { data, loading, error }] = useCreateBillingInformationMutation({
 *   variables: {
 *      bankAccount: // value for 'bankAccount'
 *      billingAddress: // value for 'billingAddress'
 *      contactId: // value for 'contactId'
 *      name: // value for 'name'
 *      shippingAddress: // value for 'shippingAddress'
 *   },
 * });
 */
export function useCreateBillingInformationMutation(baseOptions?: Apollo.MutationHookOptions<CreateBillingInformationMutation, CreateBillingInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBillingInformationMutation, CreateBillingInformationMutationVariables>(CreateBillingInformationDocument, options);
      }
export type CreateBillingInformationMutationHookResult = ReturnType<typeof useCreateBillingInformationMutation>;
export type CreateBillingInformationMutationResult = Apollo.MutationResult<CreateBillingInformationMutation>;
export type CreateBillingInformationMutationOptions = Apollo.BaseMutationOptions<CreateBillingInformationMutation, CreateBillingInformationMutationVariables>;
export const CreateCompanyContactDocument = gql`
    mutation CreateCompanyContact($companyName: String!, $contactType: ContactType!) {
  createCompanyContact(
    input: {companyName: $companyName, contactType: $contactType}
  ) {
    contact {
      displayName
      id
    }
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type CreateCompanyContactMutationFn = Apollo.MutationFunction<CreateCompanyContactMutation, CreateCompanyContactMutationVariables>;

/**
 * __useCreateCompanyContactMutation__
 *
 * To run a mutation, you first call `useCreateCompanyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyContactMutation, { data, loading, error }] = useCreateCompanyContactMutation({
 *   variables: {
 *      companyName: // value for 'companyName'
 *      contactType: // value for 'contactType'
 *   },
 * });
 */
export function useCreateCompanyContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyContactMutation, CreateCompanyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyContactMutation, CreateCompanyContactMutationVariables>(CreateCompanyContactDocument, options);
      }
export type CreateCompanyContactMutationHookResult = ReturnType<typeof useCreateCompanyContactMutation>;
export type CreateCompanyContactMutationResult = Apollo.MutationResult<CreateCompanyContactMutation>;
export type CreateCompanyContactMutationOptions = Apollo.BaseMutationOptions<CreateCompanyContactMutation, CreateCompanyContactMutationVariables>;
export const CreateContactAddressDocument = gql`
    mutation CreateContactAddress($contactId: ID!, $type: AddressType! = GERMAN, $city: String, $country: String, $state: String, $street: String, $zipCode: String, $name: String) {
  createContactAddress(
    input: {contactId: $contactId, type: $type, city: $city, country: $country, state: $state, street: $street, zipCode: $zipCode, name: $name}
  ) {
    addressInformation {
      type
      name
      street
      zipCode
      city
      state
      country
    }
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type CreateContactAddressMutationFn = Apollo.MutationFunction<CreateContactAddressMutation, CreateContactAddressMutationVariables>;

/**
 * __useCreateContactAddressMutation__
 *
 * To run a mutation, you first call `useCreateContactAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactAddressMutation, { data, loading, error }] = useCreateContactAddressMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      type: // value for 'type'
 *      city: // value for 'city'
 *      country: // value for 'country'
 *      state: // value for 'state'
 *      street: // value for 'street'
 *      zipCode: // value for 'zipCode'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateContactAddressMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactAddressMutation, CreateContactAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactAddressMutation, CreateContactAddressMutationVariables>(CreateContactAddressDocument, options);
      }
export type CreateContactAddressMutationHookResult = ReturnType<typeof useCreateContactAddressMutation>;
export type CreateContactAddressMutationResult = Apollo.MutationResult<CreateContactAddressMutation>;
export type CreateContactAddressMutationOptions = Apollo.BaseMutationOptions<CreateContactAddressMutation, CreateContactAddressMutationVariables>;
export const CreateContactEmailDocument = gql`
    mutation CreateContactEmail($contactId: ID!, $emailAddress: String!, $emailType: EmailType!) {
  createContactEmail(
    input: {contactId: $contactId, emailAddress: $emailAddress, emailType: $emailType}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    emailInformation {
      emailAddress
      emailType
      id
    }
  }
}
    `;
export type CreateContactEmailMutationFn = Apollo.MutationFunction<CreateContactEmailMutation, CreateContactEmailMutationVariables>;

/**
 * __useCreateContactEmailMutation__
 *
 * To run a mutation, you first call `useCreateContactEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactEmailMutation, { data, loading, error }] = useCreateContactEmailMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      emailAddress: // value for 'emailAddress'
 *      emailType: // value for 'emailType'
 *   },
 * });
 */
export function useCreateContactEmailMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactEmailMutation, CreateContactEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactEmailMutation, CreateContactEmailMutationVariables>(CreateContactEmailDocument, options);
      }
export type CreateContactEmailMutationHookResult = ReturnType<typeof useCreateContactEmailMutation>;
export type CreateContactEmailMutationResult = Apollo.MutationResult<CreateContactEmailMutation>;
export type CreateContactEmailMutationOptions = Apollo.BaseMutationOptions<CreateContactEmailMutation, CreateContactEmailMutationVariables>;
export const CreateContactPersonInformationDocument = gql`
    mutation CreateContactPersonInformation($contactId: ID!, $contactPersonId: ID!, $contactUsage: [ContactUsage!]!) {
  createContactPersonInformation(
    input: {contactId: $contactId, contactPersonId: $contactPersonId, contactUsage: $contactUsage}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    contactPersonInformation {
      contactUsage
      id
      contactPersonId
    }
  }
}
    `;
export type CreateContactPersonInformationMutationFn = Apollo.MutationFunction<CreateContactPersonInformationMutation, CreateContactPersonInformationMutationVariables>;

/**
 * __useCreateContactPersonInformationMutation__
 *
 * To run a mutation, you first call `useCreateContactPersonInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactPersonInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactPersonInformationMutation, { data, loading, error }] = useCreateContactPersonInformationMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      contactPersonId: // value for 'contactPersonId'
 *      contactUsage: // value for 'contactUsage'
 *   },
 * });
 */
export function useCreateContactPersonInformationMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactPersonInformationMutation, CreateContactPersonInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactPersonInformationMutation, CreateContactPersonInformationMutationVariables>(CreateContactPersonInformationDocument, options);
      }
export type CreateContactPersonInformationMutationHookResult = ReturnType<typeof useCreateContactPersonInformationMutation>;
export type CreateContactPersonInformationMutationResult = Apollo.MutationResult<CreateContactPersonInformationMutation>;
export type CreateContactPersonInformationMutationOptions = Apollo.BaseMutationOptions<CreateContactPersonInformationMutation, CreateContactPersonInformationMutationVariables>;
export const CreateContractedInformationDocument = gql`
    mutation CreateContractedInformation($contactId: ID!, $contractedId: ID!, $margin: Decimal!) {
  createContractedInformation(
    input: {contactId: $contactId, contractedId: $contractedId, margin: $margin}
  ) {
    contractedInformation {
      contractedId
      id
      marge
    }
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
    }
  }
}
    `;
export type CreateContractedInformationMutationFn = Apollo.MutationFunction<CreateContractedInformationMutation, CreateContractedInformationMutationVariables>;

/**
 * __useCreateContractedInformationMutation__
 *
 * To run a mutation, you first call `useCreateContractedInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractedInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractedInformationMutation, { data, loading, error }] = useCreateContractedInformationMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      contractedId: // value for 'contractedId'
 *      margin: // value for 'margin'
 *   },
 * });
 */
export function useCreateContractedInformationMutation(baseOptions?: Apollo.MutationHookOptions<CreateContractedInformationMutation, CreateContractedInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContractedInformationMutation, CreateContractedInformationMutationVariables>(CreateContractedInformationDocument, options);
      }
export type CreateContractedInformationMutationHookResult = ReturnType<typeof useCreateContractedInformationMutation>;
export type CreateContractedInformationMutationResult = Apollo.MutationResult<CreateContractedInformationMutation>;
export type CreateContractedInformationMutationOptions = Apollo.BaseMutationOptions<CreateContractedInformationMutation, CreateContractedInformationMutationVariables>;
export const CreateDateInformationDocument = gql`
    mutation CreateDateInformation($contactId: ID!, $date: LocalDate, $dateType: PersonDateType!) {
  createDateInformation(
    input: {contactId: $contactId, date: $date, dateType: $dateType}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    dateInformation {
      date
      id
      personDateType
    }
  }
}
    `;
export type CreateDateInformationMutationFn = Apollo.MutationFunction<CreateDateInformationMutation, CreateDateInformationMutationVariables>;

/**
 * __useCreateDateInformationMutation__
 *
 * To run a mutation, you first call `useCreateDateInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDateInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDateInformationMutation, { data, loading, error }] = useCreateDateInformationMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      date: // value for 'date'
 *      dateType: // value for 'dateType'
 *   },
 * });
 */
export function useCreateDateInformationMutation(baseOptions?: Apollo.MutationHookOptions<CreateDateInformationMutation, CreateDateInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDateInformationMutation, CreateDateInformationMutationVariables>(CreateDateInformationDocument, options);
      }
export type CreateDateInformationMutationHookResult = ReturnType<typeof useCreateDateInformationMutation>;
export type CreateDateInformationMutationResult = Apollo.MutationResult<CreateDateInformationMutation>;
export type CreateDateInformationMutationOptions = Apollo.BaseMutationOptions<CreateDateInformationMutation, CreateDateInformationMutationVariables>;
export const CreateDepartmentInformationDocument = gql`
    mutation CreateDepartmentInformation($contactId: ID!, $departmentName: String) {
  createDepartmentInformation(
    input: {contactId: $contactId, departmentName: $departmentName}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    departmentInformation {
      departmentName
      id
    }
  }
}
    `;
export type CreateDepartmentInformationMutationFn = Apollo.MutationFunction<CreateDepartmentInformationMutation, CreateDepartmentInformationMutationVariables>;

/**
 * __useCreateDepartmentInformationMutation__
 *
 * To run a mutation, you first call `useCreateDepartmentInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDepartmentInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDepartmentInformationMutation, { data, loading, error }] = useCreateDepartmentInformationMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      departmentName: // value for 'departmentName'
 *   },
 * });
 */
export function useCreateDepartmentInformationMutation(baseOptions?: Apollo.MutationHookOptions<CreateDepartmentInformationMutation, CreateDepartmentInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDepartmentInformationMutation, CreateDepartmentInformationMutationVariables>(CreateDepartmentInformationDocument, options);
      }
export type CreateDepartmentInformationMutationHookResult = ReturnType<typeof useCreateDepartmentInformationMutation>;
export type CreateDepartmentInformationMutationResult = Apollo.MutationResult<CreateDepartmentInformationMutation>;
export type CreateDepartmentInformationMutationOptions = Apollo.BaseMutationOptions<CreateDepartmentInformationMutation, CreateDepartmentInformationMutationVariables>;
export const CreateInternalWorkingConditionDocument = gql`
    mutation CreateInternalWorkingCondition($contactId: ID!, $from: LocalDate!, $federalCode: String!, $workingTimeModelId: ID!, $to: LocalDate) {
  createEmployeeWorkingCondition(
    input: {contactId: $contactId, from: $from, federalCode: $federalCode, workingTimeModelId: $workingTimeModelId, to: $to}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    employeeWorkingConditionInformation {
      id
      __typename
      federalLocation
      workingTimeModel {
        id
        name
      }
      from
      to
      workingTimeModelId
    }
  }
}
    `;
export type CreateInternalWorkingConditionMutationFn = Apollo.MutationFunction<CreateInternalWorkingConditionMutation, CreateInternalWorkingConditionMutationVariables>;

/**
 * __useCreateInternalWorkingConditionMutation__
 *
 * To run a mutation, you first call `useCreateInternalWorkingConditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInternalWorkingConditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInternalWorkingConditionMutation, { data, loading, error }] = useCreateInternalWorkingConditionMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      from: // value for 'from'
 *      federalCode: // value for 'federalCode'
 *      workingTimeModelId: // value for 'workingTimeModelId'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useCreateInternalWorkingConditionMutation(baseOptions?: Apollo.MutationHookOptions<CreateInternalWorkingConditionMutation, CreateInternalWorkingConditionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInternalWorkingConditionMutation, CreateInternalWorkingConditionMutationVariables>(CreateInternalWorkingConditionDocument, options);
      }
export type CreateInternalWorkingConditionMutationHookResult = ReturnType<typeof useCreateInternalWorkingConditionMutation>;
export type CreateInternalWorkingConditionMutationResult = Apollo.MutationResult<CreateInternalWorkingConditionMutation>;
export type CreateInternalWorkingConditionMutationOptions = Apollo.BaseMutationOptions<CreateInternalWorkingConditionMutation, CreateInternalWorkingConditionMutationVariables>;
export const CreateIsContactPersonInformationDocument = gql`
    mutation CreateIsContactPersonInformation($contactId: ID!, $contactPersonId: ID!, $contactUsage: [ContactUsage!]!) {
  createContactPersonInformation(
    input: {contactId: $contactId, contactPersonId: $contactPersonId, contactUsage: $contactUsage}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    contactPersonInformation {
      contactPersonId
      contactUsage
      id
    }
  }
}
    `;
export type CreateIsContactPersonInformationMutationFn = Apollo.MutationFunction<CreateIsContactPersonInformationMutation, CreateIsContactPersonInformationMutationVariables>;

/**
 * __useCreateIsContactPersonInformationMutation__
 *
 * To run a mutation, you first call `useCreateIsContactPersonInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIsContactPersonInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIsContactPersonInformationMutation, { data, loading, error }] = useCreateIsContactPersonInformationMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      contactPersonId: // value for 'contactPersonId'
 *      contactUsage: // value for 'contactUsage'
 *   },
 * });
 */
export function useCreateIsContactPersonInformationMutation(baseOptions?: Apollo.MutationHookOptions<CreateIsContactPersonInformationMutation, CreateIsContactPersonInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIsContactPersonInformationMutation, CreateIsContactPersonInformationMutationVariables>(CreateIsContactPersonInformationDocument, options);
      }
export type CreateIsContactPersonInformationMutationHookResult = ReturnType<typeof useCreateIsContactPersonInformationMutation>;
export type CreateIsContactPersonInformationMutationResult = Apollo.MutationResult<CreateIsContactPersonInformationMutation>;
export type CreateIsContactPersonInformationMutationOptions = Apollo.BaseMutationOptions<CreateIsContactPersonInformationMutation, CreateIsContactPersonInformationMutationVariables>;
export const CreateMailboxContactDocument = gql`
    mutation CreateMailboxContact($name: String!, $memberOfCompanyId: ID!) {
  createMailboxContact(
    input: {name: $name, memberOfCompanyId: $memberOfCompanyId}
  ) {
    contact {
      id
      displayName
      companyName
      contactNumber
      contactTypes
      additionalInformation {
        id
        __typename
        ... on EmailInformation {
          emailAddress
          emailType
        }
      }
    }
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type CreateMailboxContactMutationFn = Apollo.MutationFunction<CreateMailboxContactMutation, CreateMailboxContactMutationVariables>;

/**
 * __useCreateMailboxContactMutation__
 *
 * To run a mutation, you first call `useCreateMailboxContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMailboxContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMailboxContactMutation, { data, loading, error }] = useCreateMailboxContactMutation({
 *   variables: {
 *      name: // value for 'name'
 *      memberOfCompanyId: // value for 'memberOfCompanyId'
 *   },
 * });
 */
export function useCreateMailboxContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateMailboxContactMutation, CreateMailboxContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMailboxContactMutation, CreateMailboxContactMutationVariables>(CreateMailboxContactDocument, options);
      }
export type CreateMailboxContactMutationHookResult = ReturnType<typeof useCreateMailboxContactMutation>;
export type CreateMailboxContactMutationResult = Apollo.MutationResult<CreateMailboxContactMutation>;
export type CreateMailboxContactMutationOptions = Apollo.BaseMutationOptions<CreateMailboxContactMutation, CreateMailboxContactMutationVariables>;
export const CreatePaymentConditionInformationDocument = gql`
    mutation CreatePaymentConditionInformation($contactId: ID!, $discountProfileId: VersionedDiscountProfileIdInput!, $selectedEntryId: ID!, $doesNotParticipateInVoucherProcess: Boolean!) {
  createPaymentConditionInformation(
    input: {contactId: $contactId, discountProfileId: $discountProfileId, selectedEntryId: $selectedEntryId, doesNotParticipateInVoucherProcess: $doesNotParticipateInVoucherProcess}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    paymentConditionInformation {
      id
      selectedEntryId
      discountProfileId {
        id
        version
      }
      doesNotParticipateInVoucherProcess
    }
  }
}
    `;
export type CreatePaymentConditionInformationMutationFn = Apollo.MutationFunction<CreatePaymentConditionInformationMutation, CreatePaymentConditionInformationMutationVariables>;

/**
 * __useCreatePaymentConditionInformationMutation__
 *
 * To run a mutation, you first call `useCreatePaymentConditionInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentConditionInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentConditionInformationMutation, { data, loading, error }] = useCreatePaymentConditionInformationMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      discountProfileId: // value for 'discountProfileId'
 *      selectedEntryId: // value for 'selectedEntryId'
 *      doesNotParticipateInVoucherProcess: // value for 'doesNotParticipateInVoucherProcess'
 *   },
 * });
 */
export function useCreatePaymentConditionInformationMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentConditionInformationMutation, CreatePaymentConditionInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentConditionInformationMutation, CreatePaymentConditionInformationMutationVariables>(CreatePaymentConditionInformationDocument, options);
      }
export type CreatePaymentConditionInformationMutationHookResult = ReturnType<typeof useCreatePaymentConditionInformationMutation>;
export type CreatePaymentConditionInformationMutationResult = Apollo.MutationResult<CreatePaymentConditionInformationMutation>;
export type CreatePaymentConditionInformationMutationOptions = Apollo.BaseMutationOptions<CreatePaymentConditionInformationMutation, CreatePaymentConditionInformationMutationVariables>;
export const CreatePaymentInformationDocument = gql`
    mutation CreatePaymentInformation($contactId: ID!, $taxNumber: String!, $paymentDeadlineInDays: Int, $routeId: String, $vatId: String) {
  createPaymentInformation(
    input: {contactId: $contactId, taxNumber: $taxNumber, paymentDeadlineInDays: $paymentDeadlineInDays, routeId: $routeId, vatId: $vatId}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    paymentInformation {
      id
      taxNumber
      paymentDeadlineInDays
      routeId
      vatId
    }
  }
}
    `;
export type CreatePaymentInformationMutationFn = Apollo.MutationFunction<CreatePaymentInformationMutation, CreatePaymentInformationMutationVariables>;

/**
 * __useCreatePaymentInformationMutation__
 *
 * To run a mutation, you first call `useCreatePaymentInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentInformationMutation, { data, loading, error }] = useCreatePaymentInformationMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      taxNumber: // value for 'taxNumber'
 *      paymentDeadlineInDays: // value for 'paymentDeadlineInDays'
 *      routeId: // value for 'routeId'
 *      vatId: // value for 'vatId'
 *   },
 * });
 */
export function useCreatePaymentInformationMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentInformationMutation, CreatePaymentInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentInformationMutation, CreatePaymentInformationMutationVariables>(CreatePaymentInformationDocument, options);
      }
export type CreatePaymentInformationMutationHookResult = ReturnType<typeof useCreatePaymentInformationMutation>;
export type CreatePaymentInformationMutationResult = Apollo.MutationResult<CreatePaymentInformationMutation>;
export type CreatePaymentInformationMutationOptions = Apollo.BaseMutationOptions<CreatePaymentInformationMutation, CreatePaymentInformationMutationVariables>;
export const CreatePersonContactDocument = gql`
    mutation CreatePersonContact($contactType: ContactType!, $firstName: String!, $lastName: String!, $salutation: SalutationType!, $title: String, $memberOfCompanyId: ID!, $shortCode: String) {
  createPersonContact(
    input: {contactType: $contactType, firstName: $firstName, lastName: $lastName, salutation: $salutation, title: $title, memberOfCompanyId: $memberOfCompanyId, shortCode: $shortCode}
  ) {
    contact {
      id
      displayName
      firstName
      lastName
      salutation
      title
      contactNumber
      contactTypes
      additionalInformation {
        id
        __typename
        ... on EmailInformation {
          emailAddress
          emailType
        }
        ... on PhoneInformation {
          number
          phoneType
        }
        ... on SalaryInformation {
          pricePerHour
          startDate
        }
        ... on EmployeeWorkingConditionInformation {
          id
          federalLocation
          workingTimeModel {
            id
            name
          }
          from
          to
          workingTimeModelId
        }
      }
    }
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type CreatePersonContactMutationFn = Apollo.MutationFunction<CreatePersonContactMutation, CreatePersonContactMutationVariables>;

/**
 * __useCreatePersonContactMutation__
 *
 * To run a mutation, you first call `useCreatePersonContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePersonContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPersonContactMutation, { data, loading, error }] = useCreatePersonContactMutation({
 *   variables: {
 *      contactType: // value for 'contactType'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      salutation: // value for 'salutation'
 *      title: // value for 'title'
 *      memberOfCompanyId: // value for 'memberOfCompanyId'
 *      shortCode: // value for 'shortCode'
 *   },
 * });
 */
export function useCreatePersonContactMutation(baseOptions?: Apollo.MutationHookOptions<CreatePersonContactMutation, CreatePersonContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePersonContactMutation, CreatePersonContactMutationVariables>(CreatePersonContactDocument, options);
      }
export type CreatePersonContactMutationHookResult = ReturnType<typeof useCreatePersonContactMutation>;
export type CreatePersonContactMutationResult = Apollo.MutationResult<CreatePersonContactMutation>;
export type CreatePersonContactMutationOptions = Apollo.BaseMutationOptions<CreatePersonContactMutation, CreatePersonContactMutationVariables>;
export const CreatePhoneInformationDocument = gql`
    mutation CreatePhoneInformation($contactId: ID!, $number: String, $phoneType: PhoneType!) {
  createPhoneInformation(
    input: {contactId: $contactId, number: $number, phoneType: $phoneType}
  ) {
    phoneInformation {
      id
      number
      phoneType
    }
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type CreatePhoneInformationMutationFn = Apollo.MutationFunction<CreatePhoneInformationMutation, CreatePhoneInformationMutationVariables>;

/**
 * __useCreatePhoneInformationMutation__
 *
 * To run a mutation, you first call `useCreatePhoneInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePhoneInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPhoneInformationMutation, { data, loading, error }] = useCreatePhoneInformationMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      number: // value for 'number'
 *      phoneType: // value for 'phoneType'
 *   },
 * });
 */
export function useCreatePhoneInformationMutation(baseOptions?: Apollo.MutationHookOptions<CreatePhoneInformationMutation, CreatePhoneInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePhoneInformationMutation, CreatePhoneInformationMutationVariables>(CreatePhoneInformationDocument, options);
      }
export type CreatePhoneInformationMutationHookResult = ReturnType<typeof useCreatePhoneInformationMutation>;
export type CreatePhoneInformationMutationResult = Apollo.MutationResult<CreatePhoneInformationMutation>;
export type CreatePhoneInformationMutationOptions = Apollo.BaseMutationOptions<CreatePhoneInformationMutation, CreatePhoneInformationMutationVariables>;
export const CreateSalaryInformationDocument = gql`
    mutation CreateSalaryInformation($contactId: ID!, $pricePerHour: Decimal!, $startDate: LocalDate!) {
  createSalaryInformation(
    input: {contactId: $contactId, pricePerHour: $pricePerHour, startDate: $startDate}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    salaryInformation {
      id
      pricePerHour
      startDate
    }
  }
}
    `;
export type CreateSalaryInformationMutationFn = Apollo.MutationFunction<CreateSalaryInformationMutation, CreateSalaryInformationMutationVariables>;

/**
 * __useCreateSalaryInformationMutation__
 *
 * To run a mutation, you first call `useCreateSalaryInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSalaryInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSalaryInformationMutation, { data, loading, error }] = useCreateSalaryInformationMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      pricePerHour: // value for 'pricePerHour'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useCreateSalaryInformationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSalaryInformationMutation, CreateSalaryInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSalaryInformationMutation, CreateSalaryInformationMutationVariables>(CreateSalaryInformationDocument, options);
      }
export type CreateSalaryInformationMutationHookResult = ReturnType<typeof useCreateSalaryInformationMutation>;
export type CreateSalaryInformationMutationResult = Apollo.MutationResult<CreateSalaryInformationMutation>;
export type CreateSalaryInformationMutationOptions = Apollo.BaseMutationOptions<CreateSalaryInformationMutation, CreateSalaryInformationMutationVariables>;
export const CreateTemporaryFreelancerDocument = gql`
    mutation CreateTemporaryFreelancer($email: String!, $firstName: String!, $lastName: String!, $pricePerHour: Decimal!, $salutation: SalutationType!, $title: String, $shortCode: String) {
  createTemporaryFreelancer(
    input: {title: $title, salutation: $salutation, pricePerHour: $pricePerHour, lastName: $lastName, firstName: $firstName, email: $email, shortCode: $shortCode}
  ) {
    contact {
      displayName
      id
    }
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type CreateTemporaryFreelancerMutationFn = Apollo.MutationFunction<CreateTemporaryFreelancerMutation, CreateTemporaryFreelancerMutationVariables>;

/**
 * __useCreateTemporaryFreelancerMutation__
 *
 * To run a mutation, you first call `useCreateTemporaryFreelancerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemporaryFreelancerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemporaryFreelancerMutation, { data, loading, error }] = useCreateTemporaryFreelancerMutation({
 *   variables: {
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      pricePerHour: // value for 'pricePerHour'
 *      salutation: // value for 'salutation'
 *      title: // value for 'title'
 *      shortCode: // value for 'shortCode'
 *   },
 * });
 */
export function useCreateTemporaryFreelancerMutation(baseOptions?: Apollo.MutationHookOptions<CreateTemporaryFreelancerMutation, CreateTemporaryFreelancerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemporaryFreelancerMutation, CreateTemporaryFreelancerMutationVariables>(CreateTemporaryFreelancerDocument, options);
      }
export type CreateTemporaryFreelancerMutationHookResult = ReturnType<typeof useCreateTemporaryFreelancerMutation>;
export type CreateTemporaryFreelancerMutationResult = Apollo.MutationResult<CreateTemporaryFreelancerMutation>;
export type CreateTemporaryFreelancerMutationOptions = Apollo.BaseMutationOptions<CreateTemporaryFreelancerMutation, CreateTemporaryFreelancerMutationVariables>;
export const CreateWebsiteInformationDocument = gql`
    mutation CreateWebsiteInformation($contactId: ID!, $url: String) {
  createWebsiteInformation(input: {contactId: $contactId, url: $url}) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    websiteInformation {
      id
      url
    }
  }
}
    `;
export type CreateWebsiteInformationMutationFn = Apollo.MutationFunction<CreateWebsiteInformationMutation, CreateWebsiteInformationMutationVariables>;

/**
 * __useCreateWebsiteInformationMutation__
 *
 * To run a mutation, you first call `useCreateWebsiteInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebsiteInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebsiteInformationMutation, { data, loading, error }] = useCreateWebsiteInformationMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useCreateWebsiteInformationMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebsiteInformationMutation, CreateWebsiteInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebsiteInformationMutation, CreateWebsiteInformationMutationVariables>(CreateWebsiteInformationDocument, options);
      }
export type CreateWebsiteInformationMutationHookResult = ReturnType<typeof useCreateWebsiteInformationMutation>;
export type CreateWebsiteInformationMutationResult = Apollo.MutationResult<CreateWebsiteInformationMutation>;
export type CreateWebsiteInformationMutationOptions = Apollo.BaseMutationOptions<CreateWebsiteInformationMutation, CreateWebsiteInformationMutationVariables>;
export const CreateWorkingConditionInformationDocument = gql`
    mutation CreateWorkingConditionInformation($contactId: ID!, $hoursPerFriday: Decimal!, $hoursPerMonday: Decimal!, $hoursPerSaturday: Decimal!, $hoursPerSunday: Decimal!, $hoursPerThursday: Decimal!, $hoursPerTuesday: Decimal!, $hoursPerWednesday: Decimal!, $hoursPerWeek: Decimal!, $isFlexible: Boolean!, $startDate: LocalDate!) {
  createWorkingConditionInformation(
    input: {contactId: $contactId, hoursPerFriday: $hoursPerFriday, hoursPerMonday: $hoursPerMonday, hoursPerSaturday: $hoursPerSaturday, hoursPerSunday: $hoursPerSunday, hoursPerThursday: $hoursPerThursday, hoursPerTuesday: $hoursPerTuesday, hoursPerWednesday: $hoursPerWednesday, hoursPerWeek: $hoursPerWeek, isFlexible: $isFlexible, startDate: $startDate}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    workingConditionInformation {
      hoursPerFriday
      hoursPerMonday
      hoursPerSaturday
      hoursPerSunday
      hoursPerThursday
      hoursPerTuesday
      hoursPerWednesday
      hoursPerWeek
      id
      isFlexible
      startDate
    }
  }
}
    `;
export type CreateWorkingConditionInformationMutationFn = Apollo.MutationFunction<CreateWorkingConditionInformationMutation, CreateWorkingConditionInformationMutationVariables>;

/**
 * __useCreateWorkingConditionInformationMutation__
 *
 * To run a mutation, you first call `useCreateWorkingConditionInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkingConditionInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkingConditionInformationMutation, { data, loading, error }] = useCreateWorkingConditionInformationMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      hoursPerFriday: // value for 'hoursPerFriday'
 *      hoursPerMonday: // value for 'hoursPerMonday'
 *      hoursPerSaturday: // value for 'hoursPerSaturday'
 *      hoursPerSunday: // value for 'hoursPerSunday'
 *      hoursPerThursday: // value for 'hoursPerThursday'
 *      hoursPerTuesday: // value for 'hoursPerTuesday'
 *      hoursPerWednesday: // value for 'hoursPerWednesday'
 *      hoursPerWeek: // value for 'hoursPerWeek'
 *      isFlexible: // value for 'isFlexible'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useCreateWorkingConditionInformationMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkingConditionInformationMutation, CreateWorkingConditionInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkingConditionInformationMutation, CreateWorkingConditionInformationMutationVariables>(CreateWorkingConditionInformationDocument, options);
      }
export type CreateWorkingConditionInformationMutationHookResult = ReturnType<typeof useCreateWorkingConditionInformationMutation>;
export type CreateWorkingConditionInformationMutationResult = Apollo.MutationResult<CreateWorkingConditionInformationMutation>;
export type CreateWorkingConditionInformationMutationOptions = Apollo.BaseMutationOptions<CreateWorkingConditionInformationMutation, CreateWorkingConditionInformationMutationVariables>;
export const DeleteAdditionalInformationDocument = gql`
    mutation DeleteAdditionalInformation($contactId: ID!, $informationId: ID!) {
  deleteAdditionalInformation(
    input: {contactId: $contactId, informationId: $informationId}
  ) {
    boolean
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type DeleteAdditionalInformationMutationFn = Apollo.MutationFunction<DeleteAdditionalInformationMutation, DeleteAdditionalInformationMutationVariables>;

/**
 * __useDeleteAdditionalInformationMutation__
 *
 * To run a mutation, you first call `useDeleteAdditionalInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdditionalInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdditionalInformationMutation, { data, loading, error }] = useDeleteAdditionalInformationMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      informationId: // value for 'informationId'
 *   },
 * });
 */
export function useDeleteAdditionalInformationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdditionalInformationMutation, DeleteAdditionalInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdditionalInformationMutation, DeleteAdditionalInformationMutationVariables>(DeleteAdditionalInformationDocument, options);
      }
export type DeleteAdditionalInformationMutationHookResult = ReturnType<typeof useDeleteAdditionalInformationMutation>;
export type DeleteAdditionalInformationMutationResult = Apollo.MutationResult<DeleteAdditionalInformationMutation>;
export type DeleteAdditionalInformationMutationOptions = Apollo.BaseMutationOptions<DeleteAdditionalInformationMutation, DeleteAdditionalInformationMutationVariables>;
export const DeleteMemberDocument = gql`
    mutation DeleteMember($memberId: ID!, $organizationId: ID!) {
  deleteMember(input: {memberId: $memberId, organizationId: $organizationId}) {
    boolean
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type DeleteMemberMutationFn = Apollo.MutationFunction<DeleteMemberMutation, DeleteMemberMutationVariables>;

/**
 * __useDeleteMemberMutation__
 *
 * To run a mutation, you first call `useDeleteMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMemberMutation, { data, loading, error }] = useDeleteMemberMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMemberMutation, DeleteMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMemberMutation, DeleteMemberMutationVariables>(DeleteMemberDocument, options);
      }
export type DeleteMemberMutationHookResult = ReturnType<typeof useDeleteMemberMutation>;
export type DeleteMemberMutationResult = Apollo.MutationResult<DeleteMemberMutation>;
export type DeleteMemberMutationOptions = Apollo.BaseMutationOptions<DeleteMemberMutation, DeleteMemberMutationVariables>;
export const GetAllClientsDocument = gql`
    query GetAllClients($first: Int, $after: String, $name: String, $showDeleted: Boolean) {
  allContacts(
    first: $first
    after: $after
    filter: {filterByName: $name, filterByTypes: CLIENT, showDeleted: $showDeleted, showTemporary: false}
  ) {
    nodes {
      contactNumber
      contactTypes
      displayContactType
      id
      __typename
      additionalInformation {
        id
        __typename
        ... on EmailInformation {
          emailAddress
        }
        ... on ContactPersonInformation {
          contactPersonId
          contactUsage
        }
      }
      displayName
      isACompany
      isAFreelancer
      isAPerson
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllClientsQuery__
 *
 * To run a query within a React component, call `useGetAllClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllClientsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      name: // value for 'name'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useGetAllClientsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllClientsQuery, GetAllClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllClientsQuery, GetAllClientsQueryVariables>(GetAllClientsDocument, options);
      }
export function useGetAllClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllClientsQuery, GetAllClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllClientsQuery, GetAllClientsQueryVariables>(GetAllClientsDocument, options);
        }
export function useGetAllClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllClientsQuery, GetAllClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllClientsQuery, GetAllClientsQueryVariables>(GetAllClientsDocument, options);
        }
export type GetAllClientsQueryHookResult = ReturnType<typeof useGetAllClientsQuery>;
export type GetAllClientsLazyQueryHookResult = ReturnType<typeof useGetAllClientsLazyQuery>;
export type GetAllClientsSuspenseQueryHookResult = ReturnType<typeof useGetAllClientsSuspenseQuery>;
export type GetAllClientsQueryResult = Apollo.QueryResult<GetAllClientsQuery, GetAllClientsQueryVariables>;
export const GetAllCompaniesDocument = gql`
    query GetAllCompanies($first: Int, $after: String, $name: String) {
  allContacts(
    first: $first
    after: $after
    filter: {filterByName: $name, filterByTypes: [CONTRACTOR, SUPPLIER]}
  ) {
    nodes {
      contactNumber
      contactTypes
      displayContactType
      id
      __typename
      additionalInformation {
        id
        __typename
        ... on EmailInformation {
          emailAddress
        }
      }
      displayName
      isACompany
      isAFreelancer
      isAPerson
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllCompaniesQuery__
 *
 * To run a query within a React component, call `useGetAllCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCompaniesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetAllCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>(GetAllCompaniesDocument, options);
      }
export function useGetAllCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>(GetAllCompaniesDocument, options);
        }
export function useGetAllCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>(GetAllCompaniesDocument, options);
        }
export type GetAllCompaniesQueryHookResult = ReturnType<typeof useGetAllCompaniesQuery>;
export type GetAllCompaniesLazyQueryHookResult = ReturnType<typeof useGetAllCompaniesLazyQuery>;
export type GetAllCompaniesSuspenseQueryHookResult = ReturnType<typeof useGetAllCompaniesSuspenseQuery>;
export type GetAllCompaniesQueryResult = Apollo.QueryResult<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>;
export const GetAllContactNamesDocument = gql`
    query GetAllContactNames($first: Int, $after: String, $name: String, $types: [ContactType!], $andTypes: Boolean!, $showDeleted: Boolean) {
  allContacts(
    first: $first
    after: $after
    filter: {filterByName: $name, showDeleted: $showDeleted, filterByTypes: $types, andTypes: $andTypes}
  ) {
    nodes {
      id
      displayName
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetAllContactNamesQuery__
 *
 * To run a query within a React component, call `useGetAllContactNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllContactNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllContactNamesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      name: // value for 'name'
 *      types: // value for 'types'
 *      andTypes: // value for 'andTypes'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useGetAllContactNamesQuery(baseOptions: Apollo.QueryHookOptions<GetAllContactNamesQuery, GetAllContactNamesQueryVariables> & ({ variables: GetAllContactNamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllContactNamesQuery, GetAllContactNamesQueryVariables>(GetAllContactNamesDocument, options);
      }
export function useGetAllContactNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllContactNamesQuery, GetAllContactNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllContactNamesQuery, GetAllContactNamesQueryVariables>(GetAllContactNamesDocument, options);
        }
export function useGetAllContactNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllContactNamesQuery, GetAllContactNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllContactNamesQuery, GetAllContactNamesQueryVariables>(GetAllContactNamesDocument, options);
        }
export type GetAllContactNamesQueryHookResult = ReturnType<typeof useGetAllContactNamesQuery>;
export type GetAllContactNamesLazyQueryHookResult = ReturnType<typeof useGetAllContactNamesLazyQuery>;
export type GetAllContactNamesSuspenseQueryHookResult = ReturnType<typeof useGetAllContactNamesSuspenseQuery>;
export type GetAllContactNamesQueryResult = Apollo.QueryResult<GetAllContactNamesQuery, GetAllContactNamesQueryVariables>;
export const GetAllContactNamesAndPriceDocument = gql`
    query GetAllContactNamesAndPrice($first: Int, $after: String, $name: String, $types: [ContactType!], $andTypes: Boolean!, $showDeleted: Boolean) {
  allContacts(
    first: $first
    after: $after
    filter: {filterByName: $name, showDeleted: $showDeleted, filterByTypes: $types, andTypes: $andTypes}
  ) {
    nodes {
      id
      displayName
      isAFreelancer
      additionalInformation {
        __typename
        id
        ... on SalaryInformation {
          pricePerHour
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetAllContactNamesAndPriceQuery__
 *
 * To run a query within a React component, call `useGetAllContactNamesAndPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllContactNamesAndPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllContactNamesAndPriceQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      name: // value for 'name'
 *      types: // value for 'types'
 *      andTypes: // value for 'andTypes'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useGetAllContactNamesAndPriceQuery(baseOptions: Apollo.QueryHookOptions<GetAllContactNamesAndPriceQuery, GetAllContactNamesAndPriceQueryVariables> & ({ variables: GetAllContactNamesAndPriceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllContactNamesAndPriceQuery, GetAllContactNamesAndPriceQueryVariables>(GetAllContactNamesAndPriceDocument, options);
      }
export function useGetAllContactNamesAndPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllContactNamesAndPriceQuery, GetAllContactNamesAndPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllContactNamesAndPriceQuery, GetAllContactNamesAndPriceQueryVariables>(GetAllContactNamesAndPriceDocument, options);
        }
export function useGetAllContactNamesAndPriceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllContactNamesAndPriceQuery, GetAllContactNamesAndPriceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllContactNamesAndPriceQuery, GetAllContactNamesAndPriceQueryVariables>(GetAllContactNamesAndPriceDocument, options);
        }
export type GetAllContactNamesAndPriceQueryHookResult = ReturnType<typeof useGetAllContactNamesAndPriceQuery>;
export type GetAllContactNamesAndPriceLazyQueryHookResult = ReturnType<typeof useGetAllContactNamesAndPriceLazyQuery>;
export type GetAllContactNamesAndPriceSuspenseQueryHookResult = ReturnType<typeof useGetAllContactNamesAndPriceSuspenseQuery>;
export type GetAllContactNamesAndPriceQueryResult = Apollo.QueryResult<GetAllContactNamesAndPriceQuery, GetAllContactNamesAndPriceQueryVariables>;
export const GetAllContactsDocument = gql`
    query GetAllContacts($first: Int, $after: String, $name: String) {
  allContacts(first: $first, after: $after, filter: {filterByName: $name}) {
    nodes {
      contactNumber
      contactTypes
      displayContactType
      id
      __typename
      additionalInformation {
        id
        __typename
        ... on EmailInformation {
          emailAddress
        }
      }
      displayName
      firstName
      lastName
      companyName
      isACompany
      isAFreelancer
      isAPerson
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllContactsQuery__
 *
 * To run a query within a React component, call `useGetAllContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllContactsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetAllContactsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllContactsQuery, GetAllContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllContactsQuery, GetAllContactsQueryVariables>(GetAllContactsDocument, options);
      }
export function useGetAllContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllContactsQuery, GetAllContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllContactsQuery, GetAllContactsQueryVariables>(GetAllContactsDocument, options);
        }
export function useGetAllContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllContactsQuery, GetAllContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllContactsQuery, GetAllContactsQueryVariables>(GetAllContactsDocument, options);
        }
export type GetAllContactsQueryHookResult = ReturnType<typeof useGetAllContactsQuery>;
export type GetAllContactsLazyQueryHookResult = ReturnType<typeof useGetAllContactsLazyQuery>;
export type GetAllContactsSuspenseQueryHookResult = ReturnType<typeof useGetAllContactsSuspenseQuery>;
export type GetAllContactsQueryResult = Apollo.QueryResult<GetAllContactsQuery, GetAllContactsQueryVariables>;
export const GetAllContactsWithTypesDocument = gql`
    query GetAllContactsWithTypes($first: Int, $after: String, $name: String, $types: [ContactType!], $showDeleted: Boolean) {
  allContacts(
    first: $first
    after: $after
    filter: {filterByName: $name, showDeleted: $showDeleted, filterByTypes: $types, andTypes: true}
  ) {
    nodes {
      contactNumber
      contactTypes
      displayContactType
      id
      __typename
      additionalInformation {
        id
        __typename
        ... on EmailInformation {
          emailAddress
        }
      }
      displayName
      firstName
      lastName
      companyName
      isACompany
      isAFreelancer
      isAPerson
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllContactsWithTypesQuery__
 *
 * To run a query within a React component, call `useGetAllContactsWithTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllContactsWithTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllContactsWithTypesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      name: // value for 'name'
 *      types: // value for 'types'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useGetAllContactsWithTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllContactsWithTypesQuery, GetAllContactsWithTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllContactsWithTypesQuery, GetAllContactsWithTypesQueryVariables>(GetAllContactsWithTypesDocument, options);
      }
export function useGetAllContactsWithTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllContactsWithTypesQuery, GetAllContactsWithTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllContactsWithTypesQuery, GetAllContactsWithTypesQueryVariables>(GetAllContactsWithTypesDocument, options);
        }
export function useGetAllContactsWithTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllContactsWithTypesQuery, GetAllContactsWithTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllContactsWithTypesQuery, GetAllContactsWithTypesQueryVariables>(GetAllContactsWithTypesDocument, options);
        }
export type GetAllContactsWithTypesQueryHookResult = ReturnType<typeof useGetAllContactsWithTypesQuery>;
export type GetAllContactsWithTypesLazyQueryHookResult = ReturnType<typeof useGetAllContactsWithTypesLazyQuery>;
export type GetAllContactsWithTypesSuspenseQueryHookResult = ReturnType<typeof useGetAllContactsWithTypesSuspenseQuery>;
export type GetAllContactsWithTypesQueryResult = Apollo.QueryResult<GetAllContactsWithTypesQuery, GetAllContactsWithTypesQueryVariables>;
export const GetAllContractorsDocument = gql`
    query GetAllContractors($first: Int, $after: String, $name: String) {
  allContacts(
    first: $first
    after: $after
    filter: {filterByName: $name, filterByTypes: CONTRACTOR}
  ) {
    nodes {
      contactNumber
      contactTypes
      displayContactType
      id
      additionalInformation {
        id
        __typename
        ... on ContactPersonInformation {
          contactPersonId
          contactUsage
        }
        ... on ContractedInformation {
          contractedId
          id
          marge
        }
      }
      displayName
      isACompany
      isAFreelancer
      isAPerson
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllContractorsQuery__
 *
 * To run a query within a React component, call `useGetAllContractorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllContractorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllContractorsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetAllContractorsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllContractorsQuery, GetAllContractorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllContractorsQuery, GetAllContractorsQueryVariables>(GetAllContractorsDocument, options);
      }
export function useGetAllContractorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllContractorsQuery, GetAllContractorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllContractorsQuery, GetAllContractorsQueryVariables>(GetAllContractorsDocument, options);
        }
export function useGetAllContractorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllContractorsQuery, GetAllContractorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllContractorsQuery, GetAllContractorsQueryVariables>(GetAllContractorsDocument, options);
        }
export type GetAllContractorsQueryHookResult = ReturnType<typeof useGetAllContractorsQuery>;
export type GetAllContractorsLazyQueryHookResult = ReturnType<typeof useGetAllContractorsLazyQuery>;
export type GetAllContractorsSuspenseQueryHookResult = ReturnType<typeof useGetAllContractorsSuspenseQuery>;
export type GetAllContractorsQueryResult = Apollo.QueryResult<GetAllContractorsQuery, GetAllContractorsQueryVariables>;
export const GetAllEmployeesDocument = gql`
    query GetAllEmployees($first: Int, $after: String, $showTemporary: Boolean, $searchBy: String, $before: String, $last: Int) {
  allEmployees(
    first: $first
    after: $after
    before: $before
    last: $last
    queryFilter: {filterByName: $searchBy, order: ASC, showTemporary: $showTemporary}
  ) {
    totalCount
    nodes {
      companyName
      contactNumber
      contactTypes
      displayContactType
      displayName
      firstName
      id
      isACompany
      isAFreelancer
      isAPerson
      isDeleted
      isContactPerson
      isEmployee
      isTemporary
      lastName
      salutation
      shortCode
      title
      version
      additionalInformation {
        id
        __typename
        ... on EmailInformation {
          emailAddress
          emailType
        }
        ... on AddressInformation {
          type
          name
          city
          country
          state
          street
          zipCode
        }
        ... on BillingInformation {
          isSameAsShippingAddress
          name
          bankAccount {
            bankName
            bic
            clientReference
            clientReferenceDate
            iban
          }
          billingAddress {
            type
            name
            city
            country
            state
            street
            zipCode
          }
          shippingAddress {
            type
            name
            city
            country
            state
            street
            zipCode
          }
        }
        ... on ContactPersonInformation {
          contactPersonId
          contactUsage
        }
        ... on PaymentInformation {
          taxNumber
          paymentDeadlineInDays
          routeId
          vatId
        }
        ... on PhoneInformation {
          number
          phoneType
        }
        ... on SalaryInformation {
          pricePerHour
          startDate
        }
        ... on WorkingConditionInformation {
          hoursPerFriday
          hoursPerMonday
          hoursPerSaturday
          hoursPerSunday
          hoursPerThursday
          hoursPerTuesday
          hoursPerWednesday
          hoursPerWeek
          isFlexible
          startDate
        }
        ... on ContractedInformation {
          contractedId
          marge
        }
        ... on EmployeeWorkingConditionInformation {
          federalLocation
          workingTimeModel {
            id
            name
          }
          from
          to
          workingTimeModelId
        }
        ... on WorksInDepartmentInformation {
          departmentId
        }
        ... on WebsiteInformation {
          url
        }
        ... on PaymentConditionInformation {
          discountProfileId {
            id
            version
          }
          id
          selectedEntryId
        }
        ... on IsContactPersonOfInformation {
          contactPersonId
          contactUsage
        }
        ... on DepartmentInformation {
          departmentName
        }
        ... on DateInformation {
          date
          personDateType
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetAllEmployeesQuery__
 *
 * To run a query within a React component, call `useGetAllEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEmployeesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      showTemporary: // value for 'showTemporary'
 *      searchBy: // value for 'searchBy'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetAllEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>(GetAllEmployeesDocument, options);
      }
export function useGetAllEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>(GetAllEmployeesDocument, options);
        }
export function useGetAllEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>(GetAllEmployeesDocument, options);
        }
export type GetAllEmployeesQueryHookResult = ReturnType<typeof useGetAllEmployeesQuery>;
export type GetAllEmployeesLazyQueryHookResult = ReturnType<typeof useGetAllEmployeesLazyQuery>;
export type GetAllEmployeesSuspenseQueryHookResult = ReturnType<typeof useGetAllEmployeesSuspenseQuery>;
export type GetAllEmployeesQueryResult = Apollo.QueryResult<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>;
export const GetAllEmployeesOfContractorDocument = gql`
    query GetAllEmployeesOfContractor($contractorId: ID!, $first: Int, $after: String, $showTemporary: Boolean, $searchBy: String) {
  allEmployeesOfContractor(
    contractorId: $contractorId
    first: $first
    after: $after
    filter: {showTemporary: $showTemporary, filterByName: $searchBy}
  ) {
    totalCount
    nodes {
      companyName
      contactNumber
      contactTypes
      displayContactType
      displayName
      firstName
      id
      isACompany
      isAFreelancer
      isAPerson
      isDeleted
      isContactPerson
      isEmployee
      isTemporary
      lastName
      salutation
      shortCode
      title
      version
      additionalInformation {
        id
        __typename
        ... on EmailInformation {
          emailAddress
          emailType
        }
        ... on AddressInformation {
          type
          name
          city
          country
          state
          street
          zipCode
        }
        ... on BillingInformation {
          isSameAsShippingAddress
          name
          bankAccount {
            bankName
            bic
            clientReference
            clientReferenceDate
            iban
          }
          billingAddress {
            type
            name
            city
            country
            state
            street
            zipCode
          }
          shippingAddress {
            type
            name
            city
            country
            state
            street
            zipCode
          }
        }
        ... on ContactPersonInformation {
          contactPersonId
          contactUsage
        }
        ... on PaymentInformation {
          taxNumber
          paymentDeadlineInDays
          routeId
          vatId
        }
        ... on PhoneInformation {
          number
          phoneType
        }
        ... on SalaryInformation {
          pricePerHour
          startDate
        }
        ... on WorkingConditionInformation {
          hoursPerFriday
          hoursPerMonday
          hoursPerSaturday
          hoursPerSunday
          hoursPerThursday
          hoursPerTuesday
          hoursPerWednesday
          hoursPerWeek
          isFlexible
          startDate
        }
        ... on ContractedInformation {
          contractedId
          marge
        }
        ... on EmployeeWorkingConditionInformation {
          federalLocation
          workingTimeModel {
            id
            name
          }
          from
          to
          workingTimeModelId
        }
        ... on WorksInDepartmentInformation {
          departmentId
        }
        ... on WebsiteInformation {
          url
        }
        ... on PaymentConditionInformation {
          discountProfileId {
            id
            version
          }
          id
          selectedEntryId
        }
        ... on IsContactPersonOfInformation {
          contactPersonId
          contactUsage
        }
        ... on DepartmentInformation {
          departmentName
        }
        ... on DateInformation {
          date
          personDateType
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetAllEmployeesOfContractorQuery__
 *
 * To run a query within a React component, call `useGetAllEmployeesOfContractorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEmployeesOfContractorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEmployeesOfContractorQuery({
 *   variables: {
 *      contractorId: // value for 'contractorId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      showTemporary: // value for 'showTemporary'
 *      searchBy: // value for 'searchBy'
 *   },
 * });
 */
export function useGetAllEmployeesOfContractorQuery(baseOptions: Apollo.QueryHookOptions<GetAllEmployeesOfContractorQuery, GetAllEmployeesOfContractorQueryVariables> & ({ variables: GetAllEmployeesOfContractorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEmployeesOfContractorQuery, GetAllEmployeesOfContractorQueryVariables>(GetAllEmployeesOfContractorDocument, options);
      }
export function useGetAllEmployeesOfContractorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEmployeesOfContractorQuery, GetAllEmployeesOfContractorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEmployeesOfContractorQuery, GetAllEmployeesOfContractorQueryVariables>(GetAllEmployeesOfContractorDocument, options);
        }
export function useGetAllEmployeesOfContractorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllEmployeesOfContractorQuery, GetAllEmployeesOfContractorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllEmployeesOfContractorQuery, GetAllEmployeesOfContractorQueryVariables>(GetAllEmployeesOfContractorDocument, options);
        }
export type GetAllEmployeesOfContractorQueryHookResult = ReturnType<typeof useGetAllEmployeesOfContractorQuery>;
export type GetAllEmployeesOfContractorLazyQueryHookResult = ReturnType<typeof useGetAllEmployeesOfContractorLazyQuery>;
export type GetAllEmployeesOfContractorSuspenseQueryHookResult = ReturnType<typeof useGetAllEmployeesOfContractorSuspenseQuery>;
export type GetAllEmployeesOfContractorQueryResult = Apollo.QueryResult<GetAllEmployeesOfContractorQuery, GetAllEmployeesOfContractorQueryVariables>;
export const GetAllFreelancersDocument = gql`
    query GetAllFreelancers($first: Int, $after: String, $name: String, $showDeleted: Boolean) {
  allContacts(
    first: $first
    after: $after
    filter: {filterByName: $name, filterByTypes: [FREELANCER, PERSON], showDeleted: $showDeleted, showTemporary: false}
  ) {
    nodes {
      contactNumber
      contactTypes
      displayContactType
      id
      __typename
      additionalInformation {
        id
        __typename
        ... on EmailInformation {
          emailAddress
        }
        ... on ContactPersonInformation {
          contactPersonId
          contactUsage
        }
      }
      displayName
      isACompany
      isAFreelancer
      isAPerson
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllFreelancersQuery__
 *
 * To run a query within a React component, call `useGetAllFreelancersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFreelancersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFreelancersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      name: // value for 'name'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useGetAllFreelancersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllFreelancersQuery, GetAllFreelancersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFreelancersQuery, GetAllFreelancersQueryVariables>(GetAllFreelancersDocument, options);
      }
export function useGetAllFreelancersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFreelancersQuery, GetAllFreelancersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFreelancersQuery, GetAllFreelancersQueryVariables>(GetAllFreelancersDocument, options);
        }
export function useGetAllFreelancersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllFreelancersQuery, GetAllFreelancersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllFreelancersQuery, GetAllFreelancersQueryVariables>(GetAllFreelancersDocument, options);
        }
export type GetAllFreelancersQueryHookResult = ReturnType<typeof useGetAllFreelancersQuery>;
export type GetAllFreelancersLazyQueryHookResult = ReturnType<typeof useGetAllFreelancersLazyQuery>;
export type GetAllFreelancersSuspenseQueryHookResult = ReturnType<typeof useGetAllFreelancersSuspenseQuery>;
export type GetAllFreelancersQueryResult = Apollo.QueryResult<GetAllFreelancersQuery, GetAllFreelancersQueryVariables>;
export const GetAllFreelancersAndEmployeesDocument = gql`
    query GetAllFreelancersAndEmployees($first: Int, $name: String) {
  allContacts(
    first: $first
    filter: {filterByName: $name, filterByTypes: [FREELANCER, EMPLOYEE]}
  ) {
    nodes {
      contactNumber
      contactTypes
      isAFreelancer
      displayContactType
      id
      __typename
      additionalInformation {
        id
        __typename
        ... on SalaryInformation {
          pricePerHour
        }
      }
      displayName
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllFreelancersAndEmployeesQuery__
 *
 * To run a query within a React component, call `useGetAllFreelancersAndEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFreelancersAndEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFreelancersAndEmployeesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetAllFreelancersAndEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllFreelancersAndEmployeesQuery, GetAllFreelancersAndEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFreelancersAndEmployeesQuery, GetAllFreelancersAndEmployeesQueryVariables>(GetAllFreelancersAndEmployeesDocument, options);
      }
export function useGetAllFreelancersAndEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFreelancersAndEmployeesQuery, GetAllFreelancersAndEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFreelancersAndEmployeesQuery, GetAllFreelancersAndEmployeesQueryVariables>(GetAllFreelancersAndEmployeesDocument, options);
        }
export function useGetAllFreelancersAndEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllFreelancersAndEmployeesQuery, GetAllFreelancersAndEmployeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllFreelancersAndEmployeesQuery, GetAllFreelancersAndEmployeesQueryVariables>(GetAllFreelancersAndEmployeesDocument, options);
        }
export type GetAllFreelancersAndEmployeesQueryHookResult = ReturnType<typeof useGetAllFreelancersAndEmployeesQuery>;
export type GetAllFreelancersAndEmployeesLazyQueryHookResult = ReturnType<typeof useGetAllFreelancersAndEmployeesLazyQuery>;
export type GetAllFreelancersAndEmployeesSuspenseQueryHookResult = ReturnType<typeof useGetAllFreelancersAndEmployeesSuspenseQuery>;
export type GetAllFreelancersAndEmployeesQueryResult = Apollo.QueryResult<GetAllFreelancersAndEmployeesQuery, GetAllFreelancersAndEmployeesQueryVariables>;
export const GetAllMembersOfDocument = gql`
    query GetAllMembersOf($contactId: ID!, $first: Int, $after: String, $andTypes: Boolean, $name: String, $types: [ContactType!], $showDeleted: Boolean) {
  allMembersOf(
    contactId: $contactId
    first: $first
    after: $after
    filter: {andTypes: $andTypes, filterByName: $name, filterByTypes: $types, showDeleted: $showDeleted}
  ) {
    totalCount
    nodes {
      companyName
      contactNumber
      contactTypes
      displayContactType
      displayName
      firstName
      id
      isACompany
      isAFreelancer
      isAPerson
      isDeleted
      isContactPerson
      isEmployee
      isTemporary
      lastName
      salutation
      shortCode
      title
      version
      additionalInformation {
        id
        __typename
        ... on EmailInformation {
          emailAddress
          emailType
        }
        ... on AddressInformation {
          type
          name
          city
          country
          state
          street
          zipCode
        }
        ... on BillingInformation {
          isSameAsShippingAddress
          name
          bankAccount {
            bankName
            bic
            clientReference
            clientReferenceDate
            iban
          }
          billingAddress {
            type
            name
            city
            country
            state
            street
            zipCode
          }
          shippingAddress {
            type
            name
            city
            country
            state
            street
            zipCode
          }
        }
        ... on ContactPersonInformation {
          contactPersonId
          contactUsage
        }
        ... on PaymentInformation {
          taxNumber
          paymentDeadlineInDays
          routeId
          vatId
        }
        ... on PhoneInformation {
          number
          phoneType
        }
        ... on SalaryInformation {
          pricePerHour
          startDate
        }
        ... on WorkingConditionInformation {
          hoursPerFriday
          hoursPerMonday
          hoursPerSaturday
          hoursPerSunday
          hoursPerThursday
          hoursPerTuesday
          hoursPerWednesday
          hoursPerWeek
          isFlexible
          startDate
        }
        ... on ContractedInformation {
          contractedId
          marge
        }
        ... on WorksInDepartmentInformation {
          departmentId
        }
        ... on WebsiteInformation {
          url
        }
        ... on PaymentConditionInformation {
          discountProfileId {
            id
            version
          }
          id
          selectedEntryId
        }
        ... on IsContactPersonOfInformation {
          contactPersonId
          contactUsage
        }
        ... on DepartmentInformation {
          departmentName
        }
        ... on DateInformation {
          date
          personDateType
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetAllMembersOfQuery__
 *
 * To run a query within a React component, call `useGetAllMembersOfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMembersOfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMembersOfQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      andTypes: // value for 'andTypes'
 *      name: // value for 'name'
 *      types: // value for 'types'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useGetAllMembersOfQuery(baseOptions: Apollo.QueryHookOptions<GetAllMembersOfQuery, GetAllMembersOfQueryVariables> & ({ variables: GetAllMembersOfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMembersOfQuery, GetAllMembersOfQueryVariables>(GetAllMembersOfDocument, options);
      }
export function useGetAllMembersOfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMembersOfQuery, GetAllMembersOfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMembersOfQuery, GetAllMembersOfQueryVariables>(GetAllMembersOfDocument, options);
        }
export function useGetAllMembersOfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllMembersOfQuery, GetAllMembersOfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllMembersOfQuery, GetAllMembersOfQueryVariables>(GetAllMembersOfDocument, options);
        }
export type GetAllMembersOfQueryHookResult = ReturnType<typeof useGetAllMembersOfQuery>;
export type GetAllMembersOfLazyQueryHookResult = ReturnType<typeof useGetAllMembersOfLazyQuery>;
export type GetAllMembersOfSuspenseQueryHookResult = ReturnType<typeof useGetAllMembersOfSuspenseQuery>;
export type GetAllMembersOfQueryResult = Apollo.QueryResult<GetAllMembersOfQuery, GetAllMembersOfQueryVariables>;
export const GetAllMembersOfMyContractorsDocument = gql`
    query GetAllMembersOfMyContractors($first: Int, $after: String, $name: String) {
  allMembersOfMyContractors(
    first: $first
    after: $after
    filter: {filterByName: $name}
  ) {
    nodes {
      contactNumber
      contactTypes
      displayContactType
      id
      __typename
      additionalInformation {
        id
        __typename
        ... on EmailInformation {
          emailAddress
        }
        ... on EmployeeWorkingConditionInformation {
          id
          federalLocation
          workingTimeModel {
            id
            name
          }
          from
          to
          workingTimeModelId
        }
      }
      displayName
      firstName
      lastName
      companyName
      isACompany
      isAFreelancer
      isAPerson
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllMembersOfMyContractorsQuery__
 *
 * To run a query within a React component, call `useGetAllMembersOfMyContractorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMembersOfMyContractorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMembersOfMyContractorsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetAllMembersOfMyContractorsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllMembersOfMyContractorsQuery, GetAllMembersOfMyContractorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMembersOfMyContractorsQuery, GetAllMembersOfMyContractorsQueryVariables>(GetAllMembersOfMyContractorsDocument, options);
      }
export function useGetAllMembersOfMyContractorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMembersOfMyContractorsQuery, GetAllMembersOfMyContractorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMembersOfMyContractorsQuery, GetAllMembersOfMyContractorsQueryVariables>(GetAllMembersOfMyContractorsDocument, options);
        }
export function useGetAllMembersOfMyContractorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllMembersOfMyContractorsQuery, GetAllMembersOfMyContractorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllMembersOfMyContractorsQuery, GetAllMembersOfMyContractorsQueryVariables>(GetAllMembersOfMyContractorsDocument, options);
        }
export type GetAllMembersOfMyContractorsQueryHookResult = ReturnType<typeof useGetAllMembersOfMyContractorsQuery>;
export type GetAllMembersOfMyContractorsLazyQueryHookResult = ReturnType<typeof useGetAllMembersOfMyContractorsLazyQuery>;
export type GetAllMembersOfMyContractorsSuspenseQueryHookResult = ReturnType<typeof useGetAllMembersOfMyContractorsSuspenseQuery>;
export type GetAllMembersOfMyContractorsQueryResult = Apollo.QueryResult<GetAllMembersOfMyContractorsQuery, GetAllMembersOfMyContractorsQueryVariables>;
export const GetAllSuppliersDocument = gql`
    query GetAllSuppliers($first: Int, $after: String, $name: String, $showDeleted: Boolean) {
  allContacts(
    first: $first
    after: $after
    filter: {filterByName: $name, filterByTypes: SUPPLIER, showDeleted: $showDeleted, showTemporary: false}
  ) {
    nodes {
      contactNumber
      contactTypes
      displayContactType
      id
      __typename
      additionalInformation {
        id
        __typename
        ... on EmailInformation {
          emailAddress
        }
        ... on ContactPersonInformation {
          contactPersonId
          contactUsage
        }
      }
      displayName
      isACompany
      isAFreelancer
      isAPerson
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllSuppliersQuery__
 *
 * To run a query within a React component, call `useGetAllSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSuppliersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      name: // value for 'name'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useGetAllSuppliersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSuppliersQuery, GetAllSuppliersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSuppliersQuery, GetAllSuppliersQueryVariables>(GetAllSuppliersDocument, options);
      }
export function useGetAllSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSuppliersQuery, GetAllSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSuppliersQuery, GetAllSuppliersQueryVariables>(GetAllSuppliersDocument, options);
        }
export function useGetAllSuppliersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllSuppliersQuery, GetAllSuppliersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllSuppliersQuery, GetAllSuppliersQueryVariables>(GetAllSuppliersDocument, options);
        }
export type GetAllSuppliersQueryHookResult = ReturnType<typeof useGetAllSuppliersQuery>;
export type GetAllSuppliersLazyQueryHookResult = ReturnType<typeof useGetAllSuppliersLazyQuery>;
export type GetAllSuppliersSuspenseQueryHookResult = ReturnType<typeof useGetAllSuppliersSuspenseQuery>;
export type GetAllSuppliersQueryResult = Apollo.QueryResult<GetAllSuppliersQuery, GetAllSuppliersQueryVariables>;
export const GetContactDocument = gql`
    query GetContact($id: ID!) {
  node(id: $id) {
    id
    ... on Contact {
      displayName
      companyName
      contactNumber
      id
      isDeleted
      contactTypes
      displayContactType
      __typename
      additionalInformation {
        id
        __typename
        ... on EmailInformation {
          emailAddress
          emailType
        }
        ... on AddressInformation {
          type
          name
          city
          country
          state
          street
          zipCode
        }
        ... on BillingInformation {
          isSameAsShippingAddress
          name
          bankAccount {
            bankName
            bic
            clientReference
            clientReferenceDate
            iban
          }
          billingAddress {
            type
            name
            city
            country
            state
            street
            zipCode
          }
          shippingAddress {
            type
            name
            city
            country
            state
            street
            zipCode
          }
        }
        ... on ContactPersonInformation {
          contactPersonId
          contactUsage
        }
        ... on PaymentInformation {
          taxNumber
          paymentDeadlineInDays
          routeId
          vatId
        }
        ... on PhoneInformation {
          number
          phoneType
        }
        ... on SalaryInformation {
          pricePerHour
          startDate
        }
        ... on WorkingConditionInformation {
          hoursPerFriday
          hoursPerMonday
          hoursPerSaturday
          hoursPerSunday
          hoursPerThursday
          hoursPerTuesday
          hoursPerWednesday
          hoursPerWeek
          isFlexible
          startDate
        }
        ... on ContractedInformation {
          contractedId
          marge
        }
        ... on WorksInDepartmentInformation {
          departmentId
        }
        ... on WebsiteInformation {
          url
        }
        ... on PaymentConditionInformation {
          discountProfileId {
            id
            version
          }
          id
          selectedEntryId
          doesNotParticipateInVoucherProcess
        }
        ... on IsContactPersonOfInformation {
          contactPersonId
          contactUsage
        }
        ... on DepartmentInformation {
          departmentName
        }
        ... on DateInformation {
          date
          personDateType
        }
      }
      firstName
      isACompany
      isAFreelancer
      isAPerson
      lastName
      salutation
      title
      version
      isContactPerson
      isEmployee
      shortCode
      isTemporary
    }
  }
}
    `;

/**
 * __useGetContactQuery__
 *
 * To run a query within a React component, call `useGetContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContactQuery(baseOptions: Apollo.QueryHookOptions<GetContactQuery, GetContactQueryVariables> & ({ variables: GetContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
      }
export function useGetContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactQuery, GetContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
        }
export function useGetContactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactQuery, GetContactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
        }
export type GetContactQueryHookResult = ReturnType<typeof useGetContactQuery>;
export type GetContactLazyQueryHookResult = ReturnType<typeof useGetContactLazyQuery>;
export type GetContactSuspenseQueryHookResult = ReturnType<typeof useGetContactSuspenseQuery>;
export type GetContactQueryResult = Apollo.QueryResult<GetContactQuery, GetContactQueryVariables>;
export const GetMeDocument = gql`
    query GetMe {
  me {
    __typename
    id
    displayName
    firstName
    lastName
    title
    salutation
    displayContactType
    isAFreelancer
    additionalInformation {
      __typename
      ... on EmployeeWorkingConditionInformation {
        federalLocation
        from
        id
        to
        workingTimeModelId
      }
      ... on AddressInformation {
        type
        name
        city
        country
        state
        id
        street
        zipCode
      }
      ... on EmailInformation {
        id
        emailAddress
        emailType
      }
      ... on PhoneInformation {
        id
        number
        phoneType
      }
      ... on DateInformation {
        date
        id
        personDateType
      }
    }
  }
}
    `;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeSuspenseQueryHookResult = ReturnType<typeof useGetMeSuspenseQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const GetMyContractorsDocument = gql`
    query GetMyContractors($first: Int, $after: String, $name: String) {
  myContractors(first: $first, after: $after, filter: {filterByName: $name}) {
    nodes {
      contactNumber
      contactTypes
      displayContactType
      id
      additionalInformation {
        id
        __typename
        ... on ContactPersonInformation {
          contactPersonId
          contactUsage
        }
        ... on ContractedInformation {
          contractedId
          id
          marge
        }
      }
      displayName
      isACompany
      isAFreelancer
      isAPerson
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetMyContractorsQuery__
 *
 * To run a query within a React component, call `useGetMyContractorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyContractorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyContractorsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetMyContractorsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyContractorsQuery, GetMyContractorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyContractorsQuery, GetMyContractorsQueryVariables>(GetMyContractorsDocument, options);
      }
export function useGetMyContractorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyContractorsQuery, GetMyContractorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyContractorsQuery, GetMyContractorsQueryVariables>(GetMyContractorsDocument, options);
        }
export function useGetMyContractorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyContractorsQuery, GetMyContractorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyContractorsQuery, GetMyContractorsQueryVariables>(GetMyContractorsDocument, options);
        }
export type GetMyContractorsQueryHookResult = ReturnType<typeof useGetMyContractorsQuery>;
export type GetMyContractorsLazyQueryHookResult = ReturnType<typeof useGetMyContractorsLazyQuery>;
export type GetMyContractorsSuspenseQueryHookResult = ReturnType<typeof useGetMyContractorsSuspenseQuery>;
export type GetMyContractorsQueryResult = Apollo.QueryResult<GetMyContractorsQuery, GetMyContractorsQueryVariables>;
export const GetMyPaymentConditionsDocument = gql`
    query GetMyPaymentConditions {
  myPaymentConditions {
    companyId
    displayName
    entries {
      discount
      dueDate
      id
    }
    paymentInformationId
    selectedEntry
  }
}
    `;

/**
 * __useGetMyPaymentConditionsQuery__
 *
 * To run a query within a React component, call `useGetMyPaymentConditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPaymentConditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPaymentConditionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyPaymentConditionsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyPaymentConditionsQuery, GetMyPaymentConditionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyPaymentConditionsQuery, GetMyPaymentConditionsQueryVariables>(GetMyPaymentConditionsDocument, options);
      }
export function useGetMyPaymentConditionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyPaymentConditionsQuery, GetMyPaymentConditionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyPaymentConditionsQuery, GetMyPaymentConditionsQueryVariables>(GetMyPaymentConditionsDocument, options);
        }
export function useGetMyPaymentConditionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyPaymentConditionsQuery, GetMyPaymentConditionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyPaymentConditionsQuery, GetMyPaymentConditionsQueryVariables>(GetMyPaymentConditionsDocument, options);
        }
export type GetMyPaymentConditionsQueryHookResult = ReturnType<typeof useGetMyPaymentConditionsQuery>;
export type GetMyPaymentConditionsLazyQueryHookResult = ReturnType<typeof useGetMyPaymentConditionsLazyQuery>;
export type GetMyPaymentConditionsSuspenseQueryHookResult = ReturnType<typeof useGetMyPaymentConditionsSuspenseQuery>;
export type GetMyPaymentConditionsQueryResult = Apollo.QueryResult<GetMyPaymentConditionsQuery, GetMyPaymentConditionsQueryVariables>;
export const GetMySupplierMembersDocument = gql`
    query GetMySupplierMembers($first: Int, $after: String, $filterByName: String) {
  mySupplierMembers(
    first: $first
    after: $after
    filter: {filterByName: $filterByName}
  ) {
    totalCount
    nodes {
      id
      displayName
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetMySupplierMembersQuery__
 *
 * To run a query within a React component, call `useGetMySupplierMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySupplierMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySupplierMembersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filterByName: // value for 'filterByName'
 *   },
 * });
 */
export function useGetMySupplierMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetMySupplierMembersQuery, GetMySupplierMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySupplierMembersQuery, GetMySupplierMembersQueryVariables>(GetMySupplierMembersDocument, options);
      }
export function useGetMySupplierMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySupplierMembersQuery, GetMySupplierMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySupplierMembersQuery, GetMySupplierMembersQueryVariables>(GetMySupplierMembersDocument, options);
        }
export function useGetMySupplierMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMySupplierMembersQuery, GetMySupplierMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMySupplierMembersQuery, GetMySupplierMembersQueryVariables>(GetMySupplierMembersDocument, options);
        }
export type GetMySupplierMembersQueryHookResult = ReturnType<typeof useGetMySupplierMembersQuery>;
export type GetMySupplierMembersLazyQueryHookResult = ReturnType<typeof useGetMySupplierMembersLazyQuery>;
export type GetMySupplierMembersSuspenseQueryHookResult = ReturnType<typeof useGetMySupplierMembersSuspenseQuery>;
export type GetMySupplierMembersQueryResult = Apollo.QueryResult<GetMySupplierMembersQuery, GetMySupplierMembersQueryVariables>;
export const GetMyTeamMembersDocument = gql`
    query GetMyTeamMembers($first: Int, $after: String, $searchBy: String) {
  myTeamMembers(first: $first, after: $after, filter: {searchBy: $searchBy}) {
    totalCount
    nodes {
      companyName
      contactNumber
      contactTypes
      displayContactType
      displayName
      firstName
      id
      isACompany
      isAFreelancer
      isAPerson
      isDeleted
      isContactPerson
      isEmployee
      isTemporary
      lastName
      salutation
      shortCode
      title
      version
      additionalInformation {
        id
        __typename
        ... on EmailInformation {
          emailAddress
          emailType
        }
        ... on AddressInformation {
          type
          name
          city
          country
          state
          street
          zipCode
        }
        ... on BillingInformation {
          isSameAsShippingAddress
          name
          bankAccount {
            bankName
            bic
            clientReference
            clientReferenceDate
            iban
          }
          billingAddress {
            type
            name
            city
            country
            state
            street
            zipCode
          }
          shippingAddress {
            type
            name
            city
            country
            state
            street
            zipCode
          }
        }
        ... on ContactPersonInformation {
          contactPersonId
          contactUsage
        }
        ... on PaymentInformation {
          taxNumber
          paymentDeadlineInDays
          routeId
          vatId
        }
        ... on PhoneInformation {
          number
          phoneType
        }
        ... on SalaryInformation {
          pricePerHour
          startDate
        }
        ... on WorkingConditionInformation {
          hoursPerFriday
          hoursPerMonday
          hoursPerSaturday
          hoursPerSunday
          hoursPerThursday
          hoursPerTuesday
          hoursPerWednesday
          hoursPerWeek
          isFlexible
          startDate
        }
        ... on ContractedInformation {
          contractedId
          marge
        }
        ... on EmployeeWorkingConditionInformation {
          federalLocation
          workingTimeModel {
            id
            name
          }
          from
          to
          workingTimeModelId
        }
        ... on WorksInDepartmentInformation {
          departmentId
        }
        ... on WebsiteInformation {
          url
        }
        ... on PaymentConditionInformation {
          discountProfileId {
            id
            version
          }
          id
          selectedEntryId
        }
        ... on IsContactPersonOfInformation {
          contactPersonId
          contactUsage
        }
        ... on DepartmentInformation {
          departmentName
        }
        ... on DateInformation {
          date
          personDateType
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetMyTeamMembersQuery__
 *
 * To run a query within a React component, call `useGetMyTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTeamMembersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      searchBy: // value for 'searchBy'
 *   },
 * });
 */
export function useGetMyTeamMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>(GetMyTeamMembersDocument, options);
      }
export function useGetMyTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>(GetMyTeamMembersDocument, options);
        }
export function useGetMyTeamMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>(GetMyTeamMembersDocument, options);
        }
export type GetMyTeamMembersQueryHookResult = ReturnType<typeof useGetMyTeamMembersQuery>;
export type GetMyTeamMembersLazyQueryHookResult = ReturnType<typeof useGetMyTeamMembersLazyQuery>;
export type GetMyTeamMembersSuspenseQueryHookResult = ReturnType<typeof useGetMyTeamMembersSuspenseQuery>;
export type GetMyTeamMembersQueryResult = Apollo.QueryResult<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>;
export const GetPaymentConditionInformationDocument = gql`
    query GetPaymentConditionInformation($contactId: ID!) {
  node(id: $contactId) {
    ... on Contact {
      additionalInformation {
        ... on PaymentConditionInformation {
          id
          selectedEntryId
          doesNotParticipateInVoucherProcess
        }
      }
    }
  }
}
    `;

/**
 * __useGetPaymentConditionInformationQuery__
 *
 * To run a query within a React component, call `useGetPaymentConditionInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentConditionInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentConditionInformationQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetPaymentConditionInformationQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentConditionInformationQuery, GetPaymentConditionInformationQueryVariables> & ({ variables: GetPaymentConditionInformationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentConditionInformationQuery, GetPaymentConditionInformationQueryVariables>(GetPaymentConditionInformationDocument, options);
      }
export function useGetPaymentConditionInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentConditionInformationQuery, GetPaymentConditionInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentConditionInformationQuery, GetPaymentConditionInformationQueryVariables>(GetPaymentConditionInformationDocument, options);
        }
export function useGetPaymentConditionInformationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentConditionInformationQuery, GetPaymentConditionInformationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentConditionInformationQuery, GetPaymentConditionInformationQueryVariables>(GetPaymentConditionInformationDocument, options);
        }
export type GetPaymentConditionInformationQueryHookResult = ReturnType<typeof useGetPaymentConditionInformationQuery>;
export type GetPaymentConditionInformationLazyQueryHookResult = ReturnType<typeof useGetPaymentConditionInformationLazyQuery>;
export type GetPaymentConditionInformationSuspenseQueryHookResult = ReturnType<typeof useGetPaymentConditionInformationSuspenseQuery>;
export type GetPaymentConditionInformationQueryResult = Apollo.QueryResult<GetPaymentConditionInformationQuery, GetPaymentConditionInformationQueryVariables>;
export const UpdateBillingInformationDocument = gql`
    mutation UpdateBillingInformation($id: ID!, $bankAccount: BankAccountInput!, $billingAddress: AddressInput!, $contactId: ID!, $name: String!, $shippingAddress: AddressInput!) {
  updateBillingInformation(
    input: {bankAccount: $bankAccount, billingAddress: $billingAddress, contactId: $contactId, name: $name, shippingAddress: $shippingAddress, billingInformationId: $id}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    billingInformation {
      id
      isSameAsShippingAddress
      name
      bankAccount {
        bankName
        bic
        clientReference
        clientReferenceDate
        iban
      }
      billingAddress {
        type
        name
        street
        zipCode
        city
        state
        country
      }
      shippingAddress {
        type
        name
        street
        zipCode
        city
        state
        country
      }
    }
  }
}
    `;
export type UpdateBillingInformationMutationFn = Apollo.MutationFunction<UpdateBillingInformationMutation, UpdateBillingInformationMutationVariables>;

/**
 * __useUpdateBillingInformationMutation__
 *
 * To run a mutation, you first call `useUpdateBillingInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingInformationMutation, { data, loading, error }] = useUpdateBillingInformationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      bankAccount: // value for 'bankAccount'
 *      billingAddress: // value for 'billingAddress'
 *      contactId: // value for 'contactId'
 *      name: // value for 'name'
 *      shippingAddress: // value for 'shippingAddress'
 *   },
 * });
 */
export function useUpdateBillingInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillingInformationMutation, UpdateBillingInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillingInformationMutation, UpdateBillingInformationMutationVariables>(UpdateBillingInformationDocument, options);
      }
export type UpdateBillingInformationMutationHookResult = ReturnType<typeof useUpdateBillingInformationMutation>;
export type UpdateBillingInformationMutationResult = Apollo.MutationResult<UpdateBillingInformationMutation>;
export type UpdateBillingInformationMutationOptions = Apollo.BaseMutationOptions<UpdateBillingInformationMutation, UpdateBillingInformationMutationVariables>;
export const UpdateCompanyContactDocument = gql`
    mutation UpdateCompanyContact($companyName: String!, $contactNumber: String!, $id: ID!) {
  updateCompanyContact(
    input: {companyName: $companyName, contactNumber: $contactNumber, id: $id}
  ) {
    contact {
      displayName
      contactNumber
      contactTypes
      displayContactType
      id
      isDeleted
      __typename
      additionalInformation {
        id
        __typename
        ... on EmailInformation {
          emailAddress
          emailType
        }
        ... on AddressInformation {
          type
          name
          city
          country
          state
          street
          zipCode
        }
        ... on BillingInformation {
          isSameAsShippingAddress
          name
          bankAccount {
            bankName
            bic
            clientReference
            clientReferenceDate
            iban
          }
          billingAddress {
            type
            name
            city
            country
            state
            street
            zipCode
          }
          shippingAddress {
            type
            name
            city
            country
            state
            street
            zipCode
          }
        }
        ... on ContactPersonInformation {
          contactPersonId
          contactUsage
        }
        ... on PaymentInformation {
          taxNumber
          paymentDeadlineInDays
          routeId
          vatId
        }
        ... on PhoneInformation {
          number
          phoneType
        }
        ... on SalaryInformation {
          pricePerHour
          startDate
        }
        ... on WorkingConditionInformation {
          hoursPerFriday
          hoursPerMonday
          hoursPerSaturday
          hoursPerSunday
          hoursPerThursday
          hoursPerTuesday
          hoursPerWednesday
          hoursPerWeek
          isFlexible
          startDate
        }
        ... on ContractedInformation {
          contractedId
          marge
        }
        ... on EmployeeWorkingConditionInformation {
          federalLocation
          workingTimeModel {
            id
            name
          }
          from
          to
          workingTimeModelId
        }
        ... on WorksInDepartmentInformation {
          departmentId
        }
        ... on WebsiteInformation {
          url
        }
        ... on PaymentConditionInformation {
          discountProfileId {
            id
            version
          }
          id
          selectedEntryId
        }
        ... on IsContactPersonOfInformation {
          contactPersonId
          contactUsage
        }
        ... on DepartmentInformation {
          departmentName
        }
        ... on DateInformation {
          date
          personDateType
        }
      }
      companyName
      firstName
      lastName
      salutation
      title
      isACompany
      isAFreelancer
      isAPerson
      version
      shortCode
      isTemporary
    }
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type UpdateCompanyContactMutationFn = Apollo.MutationFunction<UpdateCompanyContactMutation, UpdateCompanyContactMutationVariables>;

/**
 * __useUpdateCompanyContactMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyContactMutation, { data, loading, error }] = useUpdateCompanyContactMutation({
 *   variables: {
 *      companyName: // value for 'companyName'
 *      contactNumber: // value for 'contactNumber'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCompanyContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyContactMutation, UpdateCompanyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyContactMutation, UpdateCompanyContactMutationVariables>(UpdateCompanyContactDocument, options);
      }
export type UpdateCompanyContactMutationHookResult = ReturnType<typeof useUpdateCompanyContactMutation>;
export type UpdateCompanyContactMutationResult = Apollo.MutationResult<UpdateCompanyContactMutation>;
export type UpdateCompanyContactMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyContactMutation, UpdateCompanyContactMutationVariables>;
export const UpdateContactAddressDocument = gql`
    mutation UpdateContactAddress($addressId: ID!, $contactId: ID!, $type: AddressType! = GERMAN, $city: String, $country: String, $state: String, $street: String, $zipCode: String, $name: String) {
  updateContactAddress(
    input: {addressId: $addressId, contactId: $contactId, type: $type, city: $city, country: $country, state: $state, street: $street, zipCode: $zipCode, name: $name}
  ) {
    addressInformation {
      type
      name
      street
      zipCode
      city
      state
      country
    }
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type UpdateContactAddressMutationFn = Apollo.MutationFunction<UpdateContactAddressMutation, UpdateContactAddressMutationVariables>;

/**
 * __useUpdateContactAddressMutation__
 *
 * To run a mutation, you first call `useUpdateContactAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactAddressMutation, { data, loading, error }] = useUpdateContactAddressMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *      contactId: // value for 'contactId'
 *      type: // value for 'type'
 *      city: // value for 'city'
 *      country: // value for 'country'
 *      state: // value for 'state'
 *      street: // value for 'street'
 *      zipCode: // value for 'zipCode'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateContactAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactAddressMutation, UpdateContactAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactAddressMutation, UpdateContactAddressMutationVariables>(UpdateContactAddressDocument, options);
      }
export type UpdateContactAddressMutationHookResult = ReturnType<typeof useUpdateContactAddressMutation>;
export type UpdateContactAddressMutationResult = Apollo.MutationResult<UpdateContactAddressMutation>;
export type UpdateContactAddressMutationOptions = Apollo.BaseMutationOptions<UpdateContactAddressMutation, UpdateContactAddressMutationVariables>;
export const UpdateContactDeleteDocument = gql`
    mutation UpdateContactDelete($id: ID!, $isDeleted: Boolean!) {
  updateContactDelete(input: {id: $id, isDeleted: $isDeleted}) {
    boolean
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type UpdateContactDeleteMutationFn = Apollo.MutationFunction<UpdateContactDeleteMutation, UpdateContactDeleteMutationVariables>;

/**
 * __useUpdateContactDeleteMutation__
 *
 * To run a mutation, you first call `useUpdateContactDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactDeleteMutation, { data, loading, error }] = useUpdateContactDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isDeleted: // value for 'isDeleted'
 *   },
 * });
 */
export function useUpdateContactDeleteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactDeleteMutation, UpdateContactDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactDeleteMutation, UpdateContactDeleteMutationVariables>(UpdateContactDeleteDocument, options);
      }
export type UpdateContactDeleteMutationHookResult = ReturnType<typeof useUpdateContactDeleteMutation>;
export type UpdateContactDeleteMutationResult = Apollo.MutationResult<UpdateContactDeleteMutation>;
export type UpdateContactDeleteMutationOptions = Apollo.BaseMutationOptions<UpdateContactDeleteMutation, UpdateContactDeleteMutationVariables>;
export const UpdateContactEmailDocument = gql`
    mutation UpdateContactEmail($contactId: ID!, $emailAddress: String!, $emailType: EmailType!, $emailId: ID!) {
  updateContactEmail(
    input: {contactId: $contactId, emailAddress: $emailAddress, emailType: $emailType, emailId: $emailId}
  ) {
    emailInformation {
      emailAddress
      emailType
      id
    }
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type UpdateContactEmailMutationFn = Apollo.MutationFunction<UpdateContactEmailMutation, UpdateContactEmailMutationVariables>;

/**
 * __useUpdateContactEmailMutation__
 *
 * To run a mutation, you first call `useUpdateContactEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactEmailMutation, { data, loading, error }] = useUpdateContactEmailMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      emailAddress: // value for 'emailAddress'
 *      emailType: // value for 'emailType'
 *      emailId: // value for 'emailId'
 *   },
 * });
 */
export function useUpdateContactEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactEmailMutation, UpdateContactEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactEmailMutation, UpdateContactEmailMutationVariables>(UpdateContactEmailDocument, options);
      }
export type UpdateContactEmailMutationHookResult = ReturnType<typeof useUpdateContactEmailMutation>;
export type UpdateContactEmailMutationResult = Apollo.MutationResult<UpdateContactEmailMutation>;
export type UpdateContactEmailMutationOptions = Apollo.BaseMutationOptions<UpdateContactEmailMutation, UpdateContactEmailMutationVariables>;
export const UpdateContactPersonInformationDocument = gql`
    mutation UpdateContactPersonInformation($id: ID!, $contactId: ID!, $contactPersonId: ID!, $contactUsage: [ContactUsage!]!) {
  updateContactPersonInformation(
    input: {contactId: $contactId, contactPersonId: $contactPersonId, contactUsage: $contactUsage, informationId: $id}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    contactPersonInformation {
      contactUsage
      id
      contactPersonId
    }
  }
}
    `;
export type UpdateContactPersonInformationMutationFn = Apollo.MutationFunction<UpdateContactPersonInformationMutation, UpdateContactPersonInformationMutationVariables>;

/**
 * __useUpdateContactPersonInformationMutation__
 *
 * To run a mutation, you first call `useUpdateContactPersonInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactPersonInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactPersonInformationMutation, { data, loading, error }] = useUpdateContactPersonInformationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contactId: // value for 'contactId'
 *      contactPersonId: // value for 'contactPersonId'
 *      contactUsage: // value for 'contactUsage'
 *   },
 * });
 */
export function useUpdateContactPersonInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactPersonInformationMutation, UpdateContactPersonInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactPersonInformationMutation, UpdateContactPersonInformationMutationVariables>(UpdateContactPersonInformationDocument, options);
      }
export type UpdateContactPersonInformationMutationHookResult = ReturnType<typeof useUpdateContactPersonInformationMutation>;
export type UpdateContactPersonInformationMutationResult = Apollo.MutationResult<UpdateContactPersonInformationMutation>;
export type UpdateContactPersonInformationMutationOptions = Apollo.BaseMutationOptions<UpdateContactPersonInformationMutation, UpdateContactPersonInformationMutationVariables>;
export const UpdateContractedInformationDocument = gql`
    mutation UpdateContractedInformation($contactId: ID!, $contractedId: ID!, $margin: Decimal!, $contactInformationId: ID!) {
  updateContractedInformation(
    input: {contactId: $contactId, contractedId: $contractedId, margin: $margin, contactInformationId: $contactInformationId}
  ) {
    contractedInformation {
      contractedId
      id
      marge
    }
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
    }
  }
}
    `;
export type UpdateContractedInformationMutationFn = Apollo.MutationFunction<UpdateContractedInformationMutation, UpdateContractedInformationMutationVariables>;

/**
 * __useUpdateContractedInformationMutation__
 *
 * To run a mutation, you first call `useUpdateContractedInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractedInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractedInformationMutation, { data, loading, error }] = useUpdateContractedInformationMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      contractedId: // value for 'contractedId'
 *      margin: // value for 'margin'
 *      contactInformationId: // value for 'contactInformationId'
 *   },
 * });
 */
export function useUpdateContractedInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractedInformationMutation, UpdateContractedInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractedInformationMutation, UpdateContractedInformationMutationVariables>(UpdateContractedInformationDocument, options);
      }
export type UpdateContractedInformationMutationHookResult = ReturnType<typeof useUpdateContractedInformationMutation>;
export type UpdateContractedInformationMutationResult = Apollo.MutationResult<UpdateContractedInformationMutation>;
export type UpdateContractedInformationMutationOptions = Apollo.BaseMutationOptions<UpdateContractedInformationMutation, UpdateContractedInformationMutationVariables>;
export const UpdateDateInformationDocument = gql`
    mutation UpdateDateInformation($contactId: ID!, $date: LocalDate, $dateType: PersonDateType!, $id: ID!) {
  updateDateInformation(
    input: {contactId: $contactId, date: $date, dateType: $dateType, contactInformationId: $id}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    dateInformation {
      date
      id
      personDateType
    }
  }
}
    `;
export type UpdateDateInformationMutationFn = Apollo.MutationFunction<UpdateDateInformationMutation, UpdateDateInformationMutationVariables>;

/**
 * __useUpdateDateInformationMutation__
 *
 * To run a mutation, you first call `useUpdateDateInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDateInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDateInformationMutation, { data, loading, error }] = useUpdateDateInformationMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      date: // value for 'date'
 *      dateType: // value for 'dateType'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateDateInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDateInformationMutation, UpdateDateInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDateInformationMutation, UpdateDateInformationMutationVariables>(UpdateDateInformationDocument, options);
      }
export type UpdateDateInformationMutationHookResult = ReturnType<typeof useUpdateDateInformationMutation>;
export type UpdateDateInformationMutationResult = Apollo.MutationResult<UpdateDateInformationMutation>;
export type UpdateDateInformationMutationOptions = Apollo.BaseMutationOptions<UpdateDateInformationMutation, UpdateDateInformationMutationVariables>;
export const UpdateDepartmentInformationDocument = gql`
    mutation UpdateDepartmentInformation($contactId: ID!, $departmentName: String, $id: ID!) {
  updateDepartmentInformation(
    input: {contactId: $contactId, contactInformationId: $id, departmentName: $departmentName}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    departmentInformation {
      departmentName
      id
    }
  }
}
    `;
export type UpdateDepartmentInformationMutationFn = Apollo.MutationFunction<UpdateDepartmentInformationMutation, UpdateDepartmentInformationMutationVariables>;

/**
 * __useUpdateDepartmentInformationMutation__
 *
 * To run a mutation, you first call `useUpdateDepartmentInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDepartmentInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDepartmentInformationMutation, { data, loading, error }] = useUpdateDepartmentInformationMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      departmentName: // value for 'departmentName'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateDepartmentInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDepartmentInformationMutation, UpdateDepartmentInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDepartmentInformationMutation, UpdateDepartmentInformationMutationVariables>(UpdateDepartmentInformationDocument, options);
      }
export type UpdateDepartmentInformationMutationHookResult = ReturnType<typeof useUpdateDepartmentInformationMutation>;
export type UpdateDepartmentInformationMutationResult = Apollo.MutationResult<UpdateDepartmentInformationMutation>;
export type UpdateDepartmentInformationMutationOptions = Apollo.BaseMutationOptions<UpdateDepartmentInformationMutation, UpdateDepartmentInformationMutationVariables>;
export const UpdateInternalWorkingConditionDocument = gql`
    mutation UpdateInternalWorkingCondition($id: ID!, $contactId: ID!, $from: LocalDate!, $federalCode: String!, $workingTimeModelId: ID!, $to: LocalDate) {
  updateEmployeeWorkingCondition(
    input: {contactId: $contactId, from: $from, federalCode: $federalCode, workingTimeModelId: $workingTimeModelId, to: $to, workingConditionId: $id}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    employeeWorkingConditionInformation {
      id
      __typename
      federalLocation
      workingTimeModel {
        id
        name
      }
      from
      to
      workingTimeModelId
    }
  }
}
    `;
export type UpdateInternalWorkingConditionMutationFn = Apollo.MutationFunction<UpdateInternalWorkingConditionMutation, UpdateInternalWorkingConditionMutationVariables>;

/**
 * __useUpdateInternalWorkingConditionMutation__
 *
 * To run a mutation, you first call `useUpdateInternalWorkingConditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInternalWorkingConditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInternalWorkingConditionMutation, { data, loading, error }] = useUpdateInternalWorkingConditionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contactId: // value for 'contactId'
 *      from: // value for 'from'
 *      federalCode: // value for 'federalCode'
 *      workingTimeModelId: // value for 'workingTimeModelId'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useUpdateInternalWorkingConditionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInternalWorkingConditionMutation, UpdateInternalWorkingConditionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInternalWorkingConditionMutation, UpdateInternalWorkingConditionMutationVariables>(UpdateInternalWorkingConditionDocument, options);
      }
export type UpdateInternalWorkingConditionMutationHookResult = ReturnType<typeof useUpdateInternalWorkingConditionMutation>;
export type UpdateInternalWorkingConditionMutationResult = Apollo.MutationResult<UpdateInternalWorkingConditionMutation>;
export type UpdateInternalWorkingConditionMutationOptions = Apollo.BaseMutationOptions<UpdateInternalWorkingConditionMutation, UpdateInternalWorkingConditionMutationVariables>;
export const UpdateIsContactPersonInformationDocument = gql`
    mutation UpdateIsContactPersonInformation($contactId: ID!, $contactPersonId: ID!, $contactUsage: [ContactUsage!]!, $id: ID!) {
  updateContactPersonInformation(
    input: {contactId: $contactId, contactPersonId: $contactPersonId, contactUsage: $contactUsage, informationId: $id}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    contactPersonInformation {
      contactPersonId
      contactUsage
      id
    }
  }
}
    `;
export type UpdateIsContactPersonInformationMutationFn = Apollo.MutationFunction<UpdateIsContactPersonInformationMutation, UpdateIsContactPersonInformationMutationVariables>;

/**
 * __useUpdateIsContactPersonInformationMutation__
 *
 * To run a mutation, you first call `useUpdateIsContactPersonInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIsContactPersonInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIsContactPersonInformationMutation, { data, loading, error }] = useUpdateIsContactPersonInformationMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      contactPersonId: // value for 'contactPersonId'
 *      contactUsage: // value for 'contactUsage'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateIsContactPersonInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIsContactPersonInformationMutation, UpdateIsContactPersonInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIsContactPersonInformationMutation, UpdateIsContactPersonInformationMutationVariables>(UpdateIsContactPersonInformationDocument, options);
      }
export type UpdateIsContactPersonInformationMutationHookResult = ReturnType<typeof useUpdateIsContactPersonInformationMutation>;
export type UpdateIsContactPersonInformationMutationResult = Apollo.MutationResult<UpdateIsContactPersonInformationMutation>;
export type UpdateIsContactPersonInformationMutationOptions = Apollo.BaseMutationOptions<UpdateIsContactPersonInformationMutation, UpdateIsContactPersonInformationMutationVariables>;
export const UpdateMailboxContactDocument = gql`
    mutation UpdateMailboxContact($id: ID!, $contactNumber: String!, $name: String!) {
  updateMailboxContact(
    input: {id: $id, contactNumber: $contactNumber, name: $name}
  ) {
    contact {
      id
      displayName
      companyName
      contactNumber
      contactTypes
      additionalInformation {
        id
        __typename
        ... on EmailInformation {
          emailAddress
          emailType
        }
      }
    }
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type UpdateMailboxContactMutationFn = Apollo.MutationFunction<UpdateMailboxContactMutation, UpdateMailboxContactMutationVariables>;

/**
 * __useUpdateMailboxContactMutation__
 *
 * To run a mutation, you first call `useUpdateMailboxContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMailboxContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMailboxContactMutation, { data, loading, error }] = useUpdateMailboxContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contactNumber: // value for 'contactNumber'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateMailboxContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMailboxContactMutation, UpdateMailboxContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMailboxContactMutation, UpdateMailboxContactMutationVariables>(UpdateMailboxContactDocument, options);
      }
export type UpdateMailboxContactMutationHookResult = ReturnType<typeof useUpdateMailboxContactMutation>;
export type UpdateMailboxContactMutationResult = Apollo.MutationResult<UpdateMailboxContactMutation>;
export type UpdateMailboxContactMutationOptions = Apollo.BaseMutationOptions<UpdateMailboxContactMutation, UpdateMailboxContactMutationVariables>;
export const UpdateMyPaymentConditionDocument = gql`
    mutation UpdateMyPaymentCondition($contactId: ID!, $contactInformationId: ID!, $selectedEntry: ID!) {
  updateMyPaymentCondition(
    input: {contactId: $contactId, contactInformationId: $contactInformationId, selectedEntryId: $selectedEntry}
  ) {
    boolean
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type UpdateMyPaymentConditionMutationFn = Apollo.MutationFunction<UpdateMyPaymentConditionMutation, UpdateMyPaymentConditionMutationVariables>;

/**
 * __useUpdateMyPaymentConditionMutation__
 *
 * To run a mutation, you first call `useUpdateMyPaymentConditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyPaymentConditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyPaymentConditionMutation, { data, loading, error }] = useUpdateMyPaymentConditionMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      contactInformationId: // value for 'contactInformationId'
 *      selectedEntry: // value for 'selectedEntry'
 *   },
 * });
 */
export function useUpdateMyPaymentConditionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyPaymentConditionMutation, UpdateMyPaymentConditionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyPaymentConditionMutation, UpdateMyPaymentConditionMutationVariables>(UpdateMyPaymentConditionDocument, options);
      }
export type UpdateMyPaymentConditionMutationHookResult = ReturnType<typeof useUpdateMyPaymentConditionMutation>;
export type UpdateMyPaymentConditionMutationResult = Apollo.MutationResult<UpdateMyPaymentConditionMutation>;
export type UpdateMyPaymentConditionMutationOptions = Apollo.BaseMutationOptions<UpdateMyPaymentConditionMutation, UpdateMyPaymentConditionMutationVariables>;
export const UpdatePaymentConditionInformationDocument = gql`
    mutation UpdatePaymentConditionInformation($contactId: ID!, $discountProfileId: VersionedDiscountProfileIdInput!, $selectedEntryId: ID!, $id: ID!, $doesNotParticipateInVoucherProcess: Boolean!) {
  updatePaymentConditionInformation(
    input: {contactId: $contactId, discountProfileId: $discountProfileId, paymentInformationId: $id, selectedEntryId: $selectedEntryId, doesNotParticipateInVoucherProcess: $doesNotParticipateInVoucherProcess}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    paymentConditionInformation {
      id
      selectedEntryId
      discountProfileId {
        id
        version
      }
      doesNotParticipateInVoucherProcess
    }
  }
}
    `;
export type UpdatePaymentConditionInformationMutationFn = Apollo.MutationFunction<UpdatePaymentConditionInformationMutation, UpdatePaymentConditionInformationMutationVariables>;

/**
 * __useUpdatePaymentConditionInformationMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentConditionInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentConditionInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentConditionInformationMutation, { data, loading, error }] = useUpdatePaymentConditionInformationMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      discountProfileId: // value for 'discountProfileId'
 *      selectedEntryId: // value for 'selectedEntryId'
 *      id: // value for 'id'
 *      doesNotParticipateInVoucherProcess: // value for 'doesNotParticipateInVoucherProcess'
 *   },
 * });
 */
export function useUpdatePaymentConditionInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentConditionInformationMutation, UpdatePaymentConditionInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentConditionInformationMutation, UpdatePaymentConditionInformationMutationVariables>(UpdatePaymentConditionInformationDocument, options);
      }
export type UpdatePaymentConditionInformationMutationHookResult = ReturnType<typeof useUpdatePaymentConditionInformationMutation>;
export type UpdatePaymentConditionInformationMutationResult = Apollo.MutationResult<UpdatePaymentConditionInformationMutation>;
export type UpdatePaymentConditionInformationMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentConditionInformationMutation, UpdatePaymentConditionInformationMutationVariables>;
export const UpdatePaymentInformationDocument = gql`
    mutation UpdatePaymentInformation($id: ID!, $contactId: ID!, $taxNumber: String!, $paymentDeadlineInDays: Int, $routeId: String, $vatId: String) {
  updatePaymentInformation(
    input: {paymentInformationId: $id, contactId: $contactId, taxNumber: $taxNumber, paymentDeadlineInDays: $paymentDeadlineInDays, routeId: $routeId, vatId: $vatId}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    paymentInformation {
      id
      taxNumber
      paymentDeadlineInDays
      routeId
      vatId
    }
  }
}
    `;
export type UpdatePaymentInformationMutationFn = Apollo.MutationFunction<UpdatePaymentInformationMutation, UpdatePaymentInformationMutationVariables>;

/**
 * __useUpdatePaymentInformationMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentInformationMutation, { data, loading, error }] = useUpdatePaymentInformationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contactId: // value for 'contactId'
 *      taxNumber: // value for 'taxNumber'
 *      paymentDeadlineInDays: // value for 'paymentDeadlineInDays'
 *      routeId: // value for 'routeId'
 *      vatId: // value for 'vatId'
 *   },
 * });
 */
export function useUpdatePaymentInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentInformationMutation, UpdatePaymentInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentInformationMutation, UpdatePaymentInformationMutationVariables>(UpdatePaymentInformationDocument, options);
      }
export type UpdatePaymentInformationMutationHookResult = ReturnType<typeof useUpdatePaymentInformationMutation>;
export type UpdatePaymentInformationMutationResult = Apollo.MutationResult<UpdatePaymentInformationMutation>;
export type UpdatePaymentInformationMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentInformationMutation, UpdatePaymentInformationMutationVariables>;
export const UpdatePersonContactDocument = gql`
    mutation UpdatePersonContact($contactNumber: String!, $firstName: String!, $id: ID!, $lastName: String!, $salutation: SalutationType!, $title: String, $shortCode: String) {
  updatePersonContact(
    input: {contactNumber: $contactNumber, firstName: $firstName, id: $id, lastName: $lastName, salutation: $salutation, title: $title, shortCode: $shortCode}
  ) {
    contact {
      displayName
      contactNumber
      contactTypes
      displayContactType
      id
      isDeleted
      __typename
      additionalInformation {
        id
        __typename
        ... on EmailInformation {
          emailAddress
          emailType
        }
        ... on AddressInformation {
          type
          name
          city
          country
          state
          street
          zipCode
        }
        ... on BillingInformation {
          isSameAsShippingAddress
          name
          bankAccount {
            bankName
            bic
            clientReference
            clientReferenceDate
            iban
          }
          billingAddress {
            type
            name
            city
            country
            state
            street
            zipCode
          }
          shippingAddress {
            type
            name
            city
            country
            state
            street
            zipCode
          }
        }
        ... on ContactPersonInformation {
          contactPersonId
          contactUsage
        }
        ... on PaymentInformation {
          taxNumber
          paymentDeadlineInDays
          routeId
          vatId
        }
        ... on PhoneInformation {
          number
          phoneType
        }
        ... on SalaryInformation {
          pricePerHour
          startDate
        }
        ... on WorkingConditionInformation {
          hoursPerFriday
          hoursPerMonday
          hoursPerSaturday
          hoursPerSunday
          hoursPerThursday
          hoursPerTuesday
          hoursPerWednesday
          hoursPerWeek
          isFlexible
          startDate
        }
        ... on ContractedInformation {
          contractedId
          marge
        }
        ... on EmployeeWorkingConditionInformation {
          federalLocation
          workingTimeModel {
            id
            name
          }
          from
          to
          workingTimeModelId
        }
        ... on WorksInDepartmentInformation {
          departmentId
        }
        ... on WebsiteInformation {
          url
        }
        ... on PaymentConditionInformation {
          discountProfileId {
            id
            version
          }
          id
          selectedEntryId
        }
        ... on IsContactPersonOfInformation {
          contactPersonId
          contactUsage
        }
        ... on DepartmentInformation {
          departmentName
        }
        ... on DateInformation {
          date
          personDateType
        }
      }
      companyName
      firstName
      lastName
      salutation
      title
      isACompany
      isAFreelancer
      isAPerson
      version
      isContactPerson
      isEmployee
      shortCode
      isTemporary
    }
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type UpdatePersonContactMutationFn = Apollo.MutationFunction<UpdatePersonContactMutation, UpdatePersonContactMutationVariables>;

/**
 * __useUpdatePersonContactMutation__
 *
 * To run a mutation, you first call `useUpdatePersonContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonContactMutation, { data, loading, error }] = useUpdatePersonContactMutation({
 *   variables: {
 *      contactNumber: // value for 'contactNumber'
 *      firstName: // value for 'firstName'
 *      id: // value for 'id'
 *      lastName: // value for 'lastName'
 *      salutation: // value for 'salutation'
 *      title: // value for 'title'
 *      shortCode: // value for 'shortCode'
 *   },
 * });
 */
export function useUpdatePersonContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonContactMutation, UpdatePersonContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonContactMutation, UpdatePersonContactMutationVariables>(UpdatePersonContactDocument, options);
      }
export type UpdatePersonContactMutationHookResult = ReturnType<typeof useUpdatePersonContactMutation>;
export type UpdatePersonContactMutationResult = Apollo.MutationResult<UpdatePersonContactMutation>;
export type UpdatePersonContactMutationOptions = Apollo.BaseMutationOptions<UpdatePersonContactMutation, UpdatePersonContactMutationVariables>;
export const UpdatePhoneInformationDocument = gql`
    mutation UpdatePhoneInformation($id: ID!, $contactId: ID!, $number: String, $phoneType: PhoneType!) {
  updatePhoneInformation(
    input: {contactId: $contactId, number: $number, contactInformationId: $id, phoneType: $phoneType}
  ) {
    phoneInformation {
      id
      number
    }
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type UpdatePhoneInformationMutationFn = Apollo.MutationFunction<UpdatePhoneInformationMutation, UpdatePhoneInformationMutationVariables>;

/**
 * __useUpdatePhoneInformationMutation__
 *
 * To run a mutation, you first call `useUpdatePhoneInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhoneInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhoneInformationMutation, { data, loading, error }] = useUpdatePhoneInformationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contactId: // value for 'contactId'
 *      number: // value for 'number'
 *      phoneType: // value for 'phoneType'
 *   },
 * });
 */
export function useUpdatePhoneInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePhoneInformationMutation, UpdatePhoneInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePhoneInformationMutation, UpdatePhoneInformationMutationVariables>(UpdatePhoneInformationDocument, options);
      }
export type UpdatePhoneInformationMutationHookResult = ReturnType<typeof useUpdatePhoneInformationMutation>;
export type UpdatePhoneInformationMutationResult = Apollo.MutationResult<UpdatePhoneInformationMutation>;
export type UpdatePhoneInformationMutationOptions = Apollo.BaseMutationOptions<UpdatePhoneInformationMutation, UpdatePhoneInformationMutationVariables>;
export const UpdateSalaryInformationDocument = gql`
    mutation UpdateSalaryInformation($id: ID!, $contactId: ID!, $pricePerHour: Decimal!, $startDate: LocalDate!) {
  updateSalaryInformation(
    input: {informationId: $id, contactId: $contactId, pricePerHour: $pricePerHour, startDate: $startDate}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    salaryInformation {
      id
      pricePerHour
      startDate
    }
  }
}
    `;
export type UpdateSalaryInformationMutationFn = Apollo.MutationFunction<UpdateSalaryInformationMutation, UpdateSalaryInformationMutationVariables>;

/**
 * __useUpdateSalaryInformationMutation__
 *
 * To run a mutation, you first call `useUpdateSalaryInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSalaryInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSalaryInformationMutation, { data, loading, error }] = useUpdateSalaryInformationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contactId: // value for 'contactId'
 *      pricePerHour: // value for 'pricePerHour'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useUpdateSalaryInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSalaryInformationMutation, UpdateSalaryInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSalaryInformationMutation, UpdateSalaryInformationMutationVariables>(UpdateSalaryInformationDocument, options);
      }
export type UpdateSalaryInformationMutationHookResult = ReturnType<typeof useUpdateSalaryInformationMutation>;
export type UpdateSalaryInformationMutationResult = Apollo.MutationResult<UpdateSalaryInformationMutation>;
export type UpdateSalaryInformationMutationOptions = Apollo.BaseMutationOptions<UpdateSalaryInformationMutation, UpdateSalaryInformationMutationVariables>;
export const UpdateWebsiteInformationDocument = gql`
    mutation UpdateWebsiteInformation($contactId: ID!, $url: String, $id: ID!) {
  updateWebsiteInformation(
    input: {contactId: $contactId, url: $url, informationId: $id}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    websiteInformation {
      id
      url
    }
  }
}
    `;
export type UpdateWebsiteInformationMutationFn = Apollo.MutationFunction<UpdateWebsiteInformationMutation, UpdateWebsiteInformationMutationVariables>;

/**
 * __useUpdateWebsiteInformationMutation__
 *
 * To run a mutation, you first call `useUpdateWebsiteInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsiteInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsiteInformationMutation, { data, loading, error }] = useUpdateWebsiteInformationMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      url: // value for 'url'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateWebsiteInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebsiteInformationMutation, UpdateWebsiteInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWebsiteInformationMutation, UpdateWebsiteInformationMutationVariables>(UpdateWebsiteInformationDocument, options);
      }
export type UpdateWebsiteInformationMutationHookResult = ReturnType<typeof useUpdateWebsiteInformationMutation>;
export type UpdateWebsiteInformationMutationResult = Apollo.MutationResult<UpdateWebsiteInformationMutation>;
export type UpdateWebsiteInformationMutationOptions = Apollo.BaseMutationOptions<UpdateWebsiteInformationMutation, UpdateWebsiteInformationMutationVariables>;
export const UpdateWorkingConditionInformationDocument = gql`
    mutation UpdateWorkingConditionInformation($id: ID!, $contactId: ID!, $hoursPerFriday: Decimal!, $hoursPerMonday: Decimal!, $hoursPerSaturday: Decimal!, $hoursPerSunday: Decimal!, $hoursPerThursday: Decimal!, $hoursPerTuesday: Decimal!, $hoursPerWednesday: Decimal!, $hoursPerWeek: Decimal!, $isFlexible: Boolean!, $startDate: LocalDate!) {
  updateWorkingConditionInformation(
    input: {contactId: $contactId, hoursPerFriday: $hoursPerFriday, hoursPerMonday: $hoursPerMonday, hoursPerSaturday: $hoursPerSaturday, hoursPerSunday: $hoursPerSunday, hoursPerThursday: $hoursPerThursday, hoursPerTuesday: $hoursPerTuesday, hoursPerWednesday: $hoursPerWednesday, hoursPerWeek: $hoursPerWeek, informationId: $id, isFlexible: $isFlexible, startDate: $startDate}
  ) {
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    workingConditionInformation {
      hoursPerFriday
      hoursPerMonday
      hoursPerSaturday
      hoursPerSunday
      hoursPerThursday
      hoursPerTuesday
      hoursPerWednesday
      hoursPerWeek
      id
      isFlexible
      startDate
    }
  }
}
    `;
export type UpdateWorkingConditionInformationMutationFn = Apollo.MutationFunction<UpdateWorkingConditionInformationMutation, UpdateWorkingConditionInformationMutationVariables>;

/**
 * __useUpdateWorkingConditionInformationMutation__
 *
 * To run a mutation, you first call `useUpdateWorkingConditionInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkingConditionInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkingConditionInformationMutation, { data, loading, error }] = useUpdateWorkingConditionInformationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contactId: // value for 'contactId'
 *      hoursPerFriday: // value for 'hoursPerFriday'
 *      hoursPerMonday: // value for 'hoursPerMonday'
 *      hoursPerSaturday: // value for 'hoursPerSaturday'
 *      hoursPerSunday: // value for 'hoursPerSunday'
 *      hoursPerThursday: // value for 'hoursPerThursday'
 *      hoursPerTuesday: // value for 'hoursPerTuesday'
 *      hoursPerWednesday: // value for 'hoursPerWednesday'
 *      hoursPerWeek: // value for 'hoursPerWeek'
 *      isFlexible: // value for 'isFlexible'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useUpdateWorkingConditionInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkingConditionInformationMutation, UpdateWorkingConditionInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkingConditionInformationMutation, UpdateWorkingConditionInformationMutationVariables>(UpdateWorkingConditionInformationDocument, options);
      }
export type UpdateWorkingConditionInformationMutationHookResult = ReturnType<typeof useUpdateWorkingConditionInformationMutation>;
export type UpdateWorkingConditionInformationMutationResult = Apollo.MutationResult<UpdateWorkingConditionInformationMutation>;
export type UpdateWorkingConditionInformationMutationOptions = Apollo.BaseMutationOptions<UpdateWorkingConditionInformationMutation, UpdateWorkingConditionInformationMutationVariables>;
export const CreateDiscountProfileDocument = gql`
    mutation CreateDiscountProfile($name: String!, $maxDueDate: Int!, $entries: [DiscountProfileEntryInput!]!) {
  createDiscountProfile(
    input: {entries: $entries, maxDueDate: $maxDueDate, name: $name}
  ) {
    errors {
      ... on MyEntityNotFoundError {
        error
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    discountProfile {
      id
      isDeleted
      maxDueDate
      name
      version
      entries {
        discount
        dueDate
        id
      }
    }
  }
}
    `;
export type CreateDiscountProfileMutationFn = Apollo.MutationFunction<CreateDiscountProfileMutation, CreateDiscountProfileMutationVariables>;

/**
 * __useCreateDiscountProfileMutation__
 *
 * To run a mutation, you first call `useCreateDiscountProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscountProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscountProfileMutation, { data, loading, error }] = useCreateDiscountProfileMutation({
 *   variables: {
 *      name: // value for 'name'
 *      maxDueDate: // value for 'maxDueDate'
 *      entries: // value for 'entries'
 *   },
 * });
 */
export function useCreateDiscountProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateDiscountProfileMutation, CreateDiscountProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDiscountProfileMutation, CreateDiscountProfileMutationVariables>(CreateDiscountProfileDocument, options);
      }
export type CreateDiscountProfileMutationHookResult = ReturnType<typeof useCreateDiscountProfileMutation>;
export type CreateDiscountProfileMutationResult = Apollo.MutationResult<CreateDiscountProfileMutation>;
export type CreateDiscountProfileMutationOptions = Apollo.BaseMutationOptions<CreateDiscountProfileMutation, CreateDiscountProfileMutationVariables>;
export const DeleteDiscountProfileDocument = gql`
    mutation DeleteDiscountProfile($id: ID!) {
  deleteDiscountProfile(input: {id: $id}) {
    boolean
    errors {
      ... on MyEntityNotFoundError {
        error
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type DeleteDiscountProfileMutationFn = Apollo.MutationFunction<DeleteDiscountProfileMutation, DeleteDiscountProfileMutationVariables>;

/**
 * __useDeleteDiscountProfileMutation__
 *
 * To run a mutation, you first call `useDeleteDiscountProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscountProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscountProfileMutation, { data, loading, error }] = useDeleteDiscountProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDiscountProfileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDiscountProfileMutation, DeleteDiscountProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDiscountProfileMutation, DeleteDiscountProfileMutationVariables>(DeleteDiscountProfileDocument, options);
      }
export type DeleteDiscountProfileMutationHookResult = ReturnType<typeof useDeleteDiscountProfileMutation>;
export type DeleteDiscountProfileMutationResult = Apollo.MutationResult<DeleteDiscountProfileMutation>;
export type DeleteDiscountProfileMutationOptions = Apollo.BaseMutationOptions<DeleteDiscountProfileMutation, DeleteDiscountProfileMutationVariables>;
export const GetAllDiscountProfilesDocument = gql`
    query GetAllDiscountProfiles($first: Int, $after: String, $name: String, $deleted: Boolean) {
  allDiscountProfiles(
    filter: {filterByName: $name, showDeleted: $deleted}
    after: $after
    first: $first
  ) {
    totalCount
    nodes {
      id
      maxDueDate
      name
      entries {
        id
        discount
        dueDate
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetAllDiscountProfilesQuery__
 *
 * To run a query within a React component, call `useGetAllDiscountProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDiscountProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDiscountProfilesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      name: // value for 'name'
 *      deleted: // value for 'deleted'
 *   },
 * });
 */
export function useGetAllDiscountProfilesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllDiscountProfilesQuery, GetAllDiscountProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDiscountProfilesQuery, GetAllDiscountProfilesQueryVariables>(GetAllDiscountProfilesDocument, options);
      }
export function useGetAllDiscountProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDiscountProfilesQuery, GetAllDiscountProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDiscountProfilesQuery, GetAllDiscountProfilesQueryVariables>(GetAllDiscountProfilesDocument, options);
        }
export function useGetAllDiscountProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllDiscountProfilesQuery, GetAllDiscountProfilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllDiscountProfilesQuery, GetAllDiscountProfilesQueryVariables>(GetAllDiscountProfilesDocument, options);
        }
export type GetAllDiscountProfilesQueryHookResult = ReturnType<typeof useGetAllDiscountProfilesQuery>;
export type GetAllDiscountProfilesLazyQueryHookResult = ReturnType<typeof useGetAllDiscountProfilesLazyQuery>;
export type GetAllDiscountProfilesSuspenseQueryHookResult = ReturnType<typeof useGetAllDiscountProfilesSuspenseQuery>;
export type GetAllDiscountProfilesQueryResult = Apollo.QueryResult<GetAllDiscountProfilesQuery, GetAllDiscountProfilesQueryVariables>;
export const GetDiscountProfileDocument = gql`
    query GetDiscountProfile($id: ID!) {
  node(id: $id) {
    id
    ... on DiscountProfile {
      id
      isDeleted
      maxDueDate
      name
      version
      entries {
        discount
        dueDate
        id
      }
    }
  }
}
    `;

/**
 * __useGetDiscountProfileQuery__
 *
 * To run a query within a React component, call `useGetDiscountProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDiscountProfileQuery(baseOptions: Apollo.QueryHookOptions<GetDiscountProfileQuery, GetDiscountProfileQueryVariables> & ({ variables: GetDiscountProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscountProfileQuery, GetDiscountProfileQueryVariables>(GetDiscountProfileDocument, options);
      }
export function useGetDiscountProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscountProfileQuery, GetDiscountProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscountProfileQuery, GetDiscountProfileQueryVariables>(GetDiscountProfileDocument, options);
        }
export function useGetDiscountProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDiscountProfileQuery, GetDiscountProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDiscountProfileQuery, GetDiscountProfileQueryVariables>(GetDiscountProfileDocument, options);
        }
export type GetDiscountProfileQueryHookResult = ReturnType<typeof useGetDiscountProfileQuery>;
export type GetDiscountProfileLazyQueryHookResult = ReturnType<typeof useGetDiscountProfileLazyQuery>;
export type GetDiscountProfileSuspenseQueryHookResult = ReturnType<typeof useGetDiscountProfileSuspenseQuery>;
export type GetDiscountProfileQueryResult = Apollo.QueryResult<GetDiscountProfileQuery, GetDiscountProfileQueryVariables>;
export const UpdateDiscountProfileDocument = gql`
    mutation UpdateDiscountProfile($id: ID!, $name: String!, $maxDueDate: Int!, $entries: [DiscountProfileEntryInput!]!) {
  updateDiscountProfile(
    input: {entries: $entries, maxDueDate: $maxDueDate, name: $name, id: $id}
  ) {
    errors {
      ... on MyEntityNotFoundError {
        error
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    discountProfile {
      id
      isDeleted
      maxDueDate
      name
      version
      entries {
        discount
        dueDate
        id
      }
    }
  }
}
    `;
export type UpdateDiscountProfileMutationFn = Apollo.MutationFunction<UpdateDiscountProfileMutation, UpdateDiscountProfileMutationVariables>;

/**
 * __useUpdateDiscountProfileMutation__
 *
 * To run a mutation, you first call `useUpdateDiscountProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscountProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscountProfileMutation, { data, loading, error }] = useUpdateDiscountProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      maxDueDate: // value for 'maxDueDate'
 *      entries: // value for 'entries'
 *   },
 * });
 */
export function useUpdateDiscountProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDiscountProfileMutation, UpdateDiscountProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDiscountProfileMutation, UpdateDiscountProfileMutationVariables>(UpdateDiscountProfileDocument, options);
      }
export type UpdateDiscountProfileMutationHookResult = ReturnType<typeof useUpdateDiscountProfileMutation>;
export type UpdateDiscountProfileMutationResult = Apollo.MutationResult<UpdateDiscountProfileMutation>;
export type UpdateDiscountProfileMutationOptions = Apollo.BaseMutationOptions<UpdateDiscountProfileMutation, UpdateDiscountProfileMutationVariables>;
export const AcceptOfferDocument = gql`
    mutation AcceptOffer($id: ID!) {
  acceptOffer(input: {id: $id}) {
    offer {
      id
      status
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type AcceptOfferMutationFn = Apollo.MutationFunction<AcceptOfferMutation, AcceptOfferMutationVariables>;

/**
 * __useAcceptOfferMutation__
 *
 * To run a mutation, you first call `useAcceptOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptOfferMutation, { data, loading, error }] = useAcceptOfferMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcceptOfferMutation(baseOptions?: Apollo.MutationHookOptions<AcceptOfferMutation, AcceptOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptOfferMutation, AcceptOfferMutationVariables>(AcceptOfferDocument, options);
      }
export type AcceptOfferMutationHookResult = ReturnType<typeof useAcceptOfferMutation>;
export type AcceptOfferMutationResult = Apollo.MutationResult<AcceptOfferMutation>;
export type AcceptOfferMutationOptions = Apollo.BaseMutationOptions<AcceptOfferMutation, AcceptOfferMutationVariables>;
export const CancelDocumentDocument = gql`
    mutation CancelDocument($documentId: String!, $reason: String) {
  cancelDocument(input: {documentId: $documentId, reason: $reason}) {
    commercialDocument {
      __typename
      ... on Invoice {
        id
        number
        status
        documentType
        documentRole
        issueDate
        dueDate
        netTotal
        grossTotal
        taxTotal
      }
      ... on CreditNote {
        id
        number
        status
        documentType
        documentRole
        kind
        issueDate
        dueDate
        netTotal
        grossTotal
        taxTotal
      }
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type CancelDocumentMutationFn = Apollo.MutationFunction<CancelDocumentMutation, CancelDocumentMutationVariables>;

/**
 * __useCancelDocumentMutation__
 *
 * To run a mutation, you first call `useCancelDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDocumentMutation, { data, loading, error }] = useCancelDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCancelDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CancelDocumentMutation, CancelDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelDocumentMutation, CancelDocumentMutationVariables>(CancelDocumentDocument, options);
      }
export type CancelDocumentMutationHookResult = ReturnType<typeof useCancelDocumentMutation>;
export type CancelDocumentMutationResult = Apollo.MutationResult<CancelDocumentMutation>;
export type CancelDocumentMutationOptions = Apollo.BaseMutationOptions<CancelDocumentMutation, CancelDocumentMutationVariables>;
export const ConvertOfferToInvoiceDocument = gql`
    mutation ConvertOfferToInvoice($id: ID!) {
  convertOfferToInvoice(input: {id: $id}) {
    invoice {
      id
      status
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type ConvertOfferToInvoiceMutationFn = Apollo.MutationFunction<ConvertOfferToInvoiceMutation, ConvertOfferToInvoiceMutationVariables>;

/**
 * __useConvertOfferToInvoiceMutation__
 *
 * To run a mutation, you first call `useConvertOfferToInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertOfferToInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertOfferToInvoiceMutation, { data, loading, error }] = useConvertOfferToInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConvertOfferToInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<ConvertOfferToInvoiceMutation, ConvertOfferToInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConvertOfferToInvoiceMutation, ConvertOfferToInvoiceMutationVariables>(ConvertOfferToInvoiceDocument, options);
      }
export type ConvertOfferToInvoiceMutationHookResult = ReturnType<typeof useConvertOfferToInvoiceMutation>;
export type ConvertOfferToInvoiceMutationResult = Apollo.MutationResult<ConvertOfferToInvoiceMutation>;
export type ConvertOfferToInvoiceMutationOptions = Apollo.BaseMutationOptions<ConvertOfferToInvoiceMutation, ConvertOfferToInvoiceMutationVariables>;
export const CreateDocumentDraftDocument = gql`
    mutation CreateDocumentDraft($documentType: DocumentType!, $creditNoteKind: CreditNoteKind, $documentRole: DocumentRole, $settlesInvoiceId: ID, $clientContactPersonId: ID, $clientId: ID, $concludingText: String, $contractorId: ID, $introductoryText: String, $items: [ModifyInvoiceItemInput!]!, $notes: String, $paymentDeadlineInDays: Int, $projectId: ID, $isProforma: Boolean, $validUntil: LocalDate) {
  createDocumentDraft(
    input: {documentType: $documentType, creditNoteKind: $creditNoteKind, documentRole: $documentRole, settlesInvoiceId: $settlesInvoiceId, document: {clientContactPersonId: $clientContactPersonId, clientId: $clientId, concludingText: $concludingText, contractorId: $contractorId, introductoryText: $introductoryText, items: $items, notes: $notes, paymentDeadlineInDays: $paymentDeadlineInDays, projectId: $projectId, isProforma: $isProforma, dueDate: $validUntil}}
  ) {
    commercialDocument {
      __typename
      ... on Offer {
        clientId
        concludingText
        contractorId
        createdDate
        documentRole
        documentType
        dueDate
        grossTotal
        id
        introductoryText
        isDeleted
        isReversal
        issueDate
        netTotal
        notes
        number
        paymentDeadlineInDays
        status
        taxTotal
        timestamp
        billTo {
          line1
          line2
          line3
          line4
          line5
        }
        items {
          description
          discountPercent
          id
          lineGrossTotal
          lineNetTotal
          lineTaxTotal
          positionNo
          quantity
          unit
          unitPriceNet
          tax
          taxCode
          name
        }
        shipTo {
          line1
          line2
          line3
          line4
          line5
        }
        cancellation {
          at
          externalRef
          mode
          reason
          reversalDocumentId
        }
        createdById
        clientContactPersonId
        isInvalid
        isProforma
        acceptedAt
        clientName
        taxDetails {
          code
          netAmount
          rate
          taxAmount
        }
        projectId
        payments {
          amount
          creationDate
          documentId
          id
          notes
          paymentDate
          paymentMethod
        }
        employeeIds
      }
      ... on Invoice {
        id
        number
        status
        documentType
        documentRole
        clientId
        clientContactPersonId
        contractorId
        projectId
        introductoryText
        concludingText
        paymentDeadlineInDays
        notes
        issueDate
        netTotal
        grossTotal
        paidTotal
        items {
          id
          name
          description
          quantity
          unit
          unitPriceNet
          discountPercent
          tax
          taxCode
          positionNo
          lineNetTotal
          lineTaxTotal
          lineGrossTotal
        }
      }
      ... on CreditNote {
        id
        number
        status
        documentType
        documentRole
        kind
        settlesInvoiceId
        clientId
        clientContactPersonId
        contractorId
        grossTotal
        paidTotal
        projectId
        introductoryText
        concludingText
        paymentDeadlineInDays
        notes
        issueDate
        netTotal
        grossTotal
        items {
          id
          name
          description
          quantity
          unit
          unitPriceNet
          discountPercent
          tax
          taxCode
          positionNo
          lineNetTotal
          lineTaxTotal
          lineGrossTotal
        }
      }
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type CreateDocumentDraftMutationFn = Apollo.MutationFunction<CreateDocumentDraftMutation, CreateDocumentDraftMutationVariables>;

/**
 * __useCreateDocumentDraftMutation__
 *
 * To run a mutation, you first call `useCreateDocumentDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentDraftMutation, { data, loading, error }] = useCreateDocumentDraftMutation({
 *   variables: {
 *      documentType: // value for 'documentType'
 *      creditNoteKind: // value for 'creditNoteKind'
 *      documentRole: // value for 'documentRole'
 *      settlesInvoiceId: // value for 'settlesInvoiceId'
 *      clientContactPersonId: // value for 'clientContactPersonId'
 *      clientId: // value for 'clientId'
 *      concludingText: // value for 'concludingText'
 *      contractorId: // value for 'contractorId'
 *      introductoryText: // value for 'introductoryText'
 *      items: // value for 'items'
 *      notes: // value for 'notes'
 *      paymentDeadlineInDays: // value for 'paymentDeadlineInDays'
 *      projectId: // value for 'projectId'
 *      isProforma: // value for 'isProforma'
 *      validUntil: // value for 'validUntil'
 *   },
 * });
 */
export function useCreateDocumentDraftMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentDraftMutation, CreateDocumentDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocumentDraftMutation, CreateDocumentDraftMutationVariables>(CreateDocumentDraftDocument, options);
      }
export type CreateDocumentDraftMutationHookResult = ReturnType<typeof useCreateDocumentDraftMutation>;
export type CreateDocumentDraftMutationResult = Apollo.MutationResult<CreateDocumentDraftMutation>;
export type CreateDocumentDraftMutationOptions = Apollo.BaseMutationOptions<CreateDocumentDraftMutation, CreateDocumentDraftMutationVariables>;
export const CreateDunningLevelDocument = gql`
    mutation CreateDunningLevel($contractorId: ID!, $feeAmount: Decimal!, $feeCurrency: String!, $isActive: Boolean!, $name: String!, $paymentDays: Int!, $level: Int!) {
  createDunningLevel(
    input: {contractorId: $contractorId, feeAmount: $feeAmount, feeCurrency: $feeCurrency, isActive: $isActive, name: $name, paymentDays: $paymentDays, level: $level}
  ) {
    dunningLevel {
      contractorId
      createdAt
      feeAmount
      feeCurrency
      id
      isActive
      isDeleted
      level
      name
      paymentDays
      updatedAt
      version
    }
    errors {
      ... on MyEntityNotFoundError {
        error
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type CreateDunningLevelMutationFn = Apollo.MutationFunction<CreateDunningLevelMutation, CreateDunningLevelMutationVariables>;

/**
 * __useCreateDunningLevelMutation__
 *
 * To run a mutation, you first call `useCreateDunningLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDunningLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDunningLevelMutation, { data, loading, error }] = useCreateDunningLevelMutation({
 *   variables: {
 *      contractorId: // value for 'contractorId'
 *      feeAmount: // value for 'feeAmount'
 *      feeCurrency: // value for 'feeCurrency'
 *      isActive: // value for 'isActive'
 *      name: // value for 'name'
 *      paymentDays: // value for 'paymentDays'
 *      level: // value for 'level'
 *   },
 * });
 */
export function useCreateDunningLevelMutation(baseOptions?: Apollo.MutationHookOptions<CreateDunningLevelMutation, CreateDunningLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDunningLevelMutation, CreateDunningLevelMutationVariables>(CreateDunningLevelDocument, options);
      }
export type CreateDunningLevelMutationHookResult = ReturnType<typeof useCreateDunningLevelMutation>;
export type CreateDunningLevelMutationResult = Apollo.MutationResult<CreateDunningLevelMutation>;
export type CreateDunningLevelMutationOptions = Apollo.BaseMutationOptions<CreateDunningLevelMutation, CreateDunningLevelMutationVariables>;
export const DeleteDocumentDraftDocument = gql`
    mutation DeleteDocumentDraft($documentId: String!) {
  deleteDocumentDraft(input: {documentId: $documentId}) {
    boolean
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type DeleteDocumentDraftMutationFn = Apollo.MutationFunction<DeleteDocumentDraftMutation, DeleteDocumentDraftMutationVariables>;

/**
 * __useDeleteDocumentDraftMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentDraftMutation, { data, loading, error }] = useDeleteDocumentDraftMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteDocumentDraftMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentDraftMutation, DeleteDocumentDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDocumentDraftMutation, DeleteDocumentDraftMutationVariables>(DeleteDocumentDraftDocument, options);
      }
export type DeleteDocumentDraftMutationHookResult = ReturnType<typeof useDeleteDocumentDraftMutation>;
export type DeleteDocumentDraftMutationResult = Apollo.MutationResult<DeleteDocumentDraftMutation>;
export type DeleteDocumentDraftMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentDraftMutation, DeleteDocumentDraftMutationVariables>;
export const DeleteDunningLevelDocument = gql`
    mutation DeleteDunningLevel($id: ID!) {
  deleteDunningLevel(input: {id: $id}) {
    boolean
    errors {
      ... on MyEntityNotFoundError {
        error
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type DeleteDunningLevelMutationFn = Apollo.MutationFunction<DeleteDunningLevelMutation, DeleteDunningLevelMutationVariables>;

/**
 * __useDeleteDunningLevelMutation__
 *
 * To run a mutation, you first call `useDeleteDunningLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDunningLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDunningLevelMutation, { data, loading, error }] = useDeleteDunningLevelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDunningLevelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDunningLevelMutation, DeleteDunningLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDunningLevelMutation, DeleteDunningLevelMutationVariables>(DeleteDunningLevelDocument, options);
      }
export type DeleteDunningLevelMutationHookResult = ReturnType<typeof useDeleteDunningLevelMutation>;
export type DeleteDunningLevelMutationResult = Apollo.MutationResult<DeleteDunningLevelMutation>;
export type DeleteDunningLevelMutationOptions = Apollo.BaseMutationOptions<DeleteDunningLevelMutation, DeleteDunningLevelMutationVariables>;
export const DownloadDocumentDocument = gql`
    query DownloadDocument($id: String!, $shouldDownload: Boolean!, $entityId: String) {
  downloadDocument(
    documentId: $id
    shouldDownload: $shouldDownload
    dunningEntityId: $entityId
  )
}
    `;

/**
 * __useDownloadDocumentQuery__
 *
 * To run a query within a React component, call `useDownloadDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      shouldDownload: // value for 'shouldDownload'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useDownloadDocumentQuery(baseOptions: Apollo.QueryHookOptions<DownloadDocumentQuery, DownloadDocumentQueryVariables> & ({ variables: DownloadDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadDocumentQuery, DownloadDocumentQueryVariables>(DownloadDocumentDocument, options);
      }
export function useDownloadDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadDocumentQuery, DownloadDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadDocumentQuery, DownloadDocumentQueryVariables>(DownloadDocumentDocument, options);
        }
export function useDownloadDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadDocumentQuery, DownloadDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadDocumentQuery, DownloadDocumentQueryVariables>(DownloadDocumentDocument, options);
        }
export type DownloadDocumentQueryHookResult = ReturnType<typeof useDownloadDocumentQuery>;
export type DownloadDocumentLazyQueryHookResult = ReturnType<typeof useDownloadDocumentLazyQuery>;
export type DownloadDocumentSuspenseQueryHookResult = ReturnType<typeof useDownloadDocumentSuspenseQuery>;
export type DownloadDocumentQueryResult = Apollo.QueryResult<DownloadDocumentQuery, DownloadDocumentQueryVariables>;
export const DownloadDocumentXmlDocument = gql`
    query DownloadDocumentXml($id: String!) {
  downloadDocumentXml(documentId: $id)
}
    `;

/**
 * __useDownloadDocumentXmlQuery__
 *
 * To run a query within a React component, call `useDownloadDocumentXmlQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadDocumentXmlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadDocumentXmlQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadDocumentXmlQuery(baseOptions: Apollo.QueryHookOptions<DownloadDocumentXmlQuery, DownloadDocumentXmlQueryVariables> & ({ variables: DownloadDocumentXmlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadDocumentXmlQuery, DownloadDocumentXmlQueryVariables>(DownloadDocumentXmlDocument, options);
      }
export function useDownloadDocumentXmlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadDocumentXmlQuery, DownloadDocumentXmlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadDocumentXmlQuery, DownloadDocumentXmlQueryVariables>(DownloadDocumentXmlDocument, options);
        }
export function useDownloadDocumentXmlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadDocumentXmlQuery, DownloadDocumentXmlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadDocumentXmlQuery, DownloadDocumentXmlQueryVariables>(DownloadDocumentXmlDocument, options);
        }
export type DownloadDocumentXmlQueryHookResult = ReturnType<typeof useDownloadDocumentXmlQuery>;
export type DownloadDocumentXmlLazyQueryHookResult = ReturnType<typeof useDownloadDocumentXmlLazyQuery>;
export type DownloadDocumentXmlSuspenseQueryHookResult = ReturnType<typeof useDownloadDocumentXmlSuspenseQuery>;
export type DownloadDocumentXmlQueryResult = Apollo.QueryResult<DownloadDocumentXmlQuery, DownloadDocumentXmlQueryVariables>;
export const FinalizeDocumentDocument = gql`
    mutation FinalizeDocument($documentId: String!, $issueDate: LocalDate!) {
  finalizeDocument(input: {documentId: $documentId, issueDate: $issueDate}) {
    commercialDocument {
      __typename
      ... on Invoice {
        id
        number
        status
        documentType
        documentRole
        issueDate
        dueDate
        netTotal
        grossTotal
        taxTotal
      }
      ... on CreditNote {
        id
        number
        status
        documentType
        documentRole
        kind
        issueDate
        dueDate
        netTotal
        grossTotal
        taxTotal
      }
      ... on Offer {
        id
        number
        status
        documentType
        documentRole
        issueDate
        dueDate
        netTotal
        grossTotal
        taxTotal
      }
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type FinalizeDocumentMutationFn = Apollo.MutationFunction<FinalizeDocumentMutation, FinalizeDocumentMutationVariables>;

/**
 * __useFinalizeDocumentMutation__
 *
 * To run a mutation, you first call `useFinalizeDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeDocumentMutation, { data, loading, error }] = useFinalizeDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      issueDate: // value for 'issueDate'
 *   },
 * });
 */
export function useFinalizeDocumentMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeDocumentMutation, FinalizeDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeDocumentMutation, FinalizeDocumentMutationVariables>(FinalizeDocumentDocument, options);
      }
export type FinalizeDocumentMutationHookResult = ReturnType<typeof useFinalizeDocumentMutation>;
export type FinalizeDocumentMutationResult = Apollo.MutationResult<FinalizeDocumentMutation>;
export type FinalizeDocumentMutationOptions = Apollo.BaseMutationOptions<FinalizeDocumentMutation, FinalizeDocumentMutationVariables>;
export const GenerateInvoiceReminderDocument = gql`
    mutation GenerateInvoiceReminder($invoiceId: String!) {
  generateReminder(input: {documentId: $invoiceId}) {
    dunningCase {
      createdAt
      id
      entries {
        id
        level
        sentDate
        dueDate
        fee
      }
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type GenerateInvoiceReminderMutationFn = Apollo.MutationFunction<GenerateInvoiceReminderMutation, GenerateInvoiceReminderMutationVariables>;

/**
 * __useGenerateInvoiceReminderMutation__
 *
 * To run a mutation, you first call `useGenerateInvoiceReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateInvoiceReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateInvoiceReminderMutation, { data, loading, error }] = useGenerateInvoiceReminderMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGenerateInvoiceReminderMutation(baseOptions?: Apollo.MutationHookOptions<GenerateInvoiceReminderMutation, GenerateInvoiceReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateInvoiceReminderMutation, GenerateInvoiceReminderMutationVariables>(GenerateInvoiceReminderDocument, options);
      }
export type GenerateInvoiceReminderMutationHookResult = ReturnType<typeof useGenerateInvoiceReminderMutation>;
export type GenerateInvoiceReminderMutationResult = Apollo.MutationResult<GenerateInvoiceReminderMutation>;
export type GenerateInvoiceReminderMutationOptions = Apollo.BaseMutationOptions<GenerateInvoiceReminderMutation, GenerateInvoiceReminderMutationVariables>;
export const GetAllDunningCasesByDocumentDocument = gql`
    query GetAllDunningCasesByDocument($id: String!) {
  dunningCaseByDocumentId(documentId: $id) {
    createdAt
    id
    entries {
      dueDate
      id
      level
      sentDate
      fee
      status
    }
    invoiceId
    accruedFees
  }
}
    `;

/**
 * __useGetAllDunningCasesByDocumentQuery__
 *
 * To run a query within a React component, call `useGetAllDunningCasesByDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDunningCasesByDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDunningCasesByDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAllDunningCasesByDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetAllDunningCasesByDocumentQuery, GetAllDunningCasesByDocumentQueryVariables> & ({ variables: GetAllDunningCasesByDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDunningCasesByDocumentQuery, GetAllDunningCasesByDocumentQueryVariables>(GetAllDunningCasesByDocumentDocument, options);
      }
export function useGetAllDunningCasesByDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDunningCasesByDocumentQuery, GetAllDunningCasesByDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDunningCasesByDocumentQuery, GetAllDunningCasesByDocumentQueryVariables>(GetAllDunningCasesByDocumentDocument, options);
        }
export function useGetAllDunningCasesByDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllDunningCasesByDocumentQuery, GetAllDunningCasesByDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllDunningCasesByDocumentQuery, GetAllDunningCasesByDocumentQueryVariables>(GetAllDunningCasesByDocumentDocument, options);
        }
export type GetAllDunningCasesByDocumentQueryHookResult = ReturnType<typeof useGetAllDunningCasesByDocumentQuery>;
export type GetAllDunningCasesByDocumentLazyQueryHookResult = ReturnType<typeof useGetAllDunningCasesByDocumentLazyQuery>;
export type GetAllDunningCasesByDocumentSuspenseQueryHookResult = ReturnType<typeof useGetAllDunningCasesByDocumentSuspenseQuery>;
export type GetAllDunningCasesByDocumentQueryResult = Apollo.QueryResult<GetAllDunningCasesByDocumentQuery, GetAllDunningCasesByDocumentQueryVariables>;
export const GetAllDunningLevelsDocument = gql`
    query GetAllDunningLevels($cotractorId: ID!, $name: String, $onlyActive: Boolean) {
  allDunningLevels(
    contractorId: $cotractorId
    filter: {filterByName: $name, onlyActive: $onlyActive}
  ) {
    contractorId
    createdAt
    feeAmount
    feeCurrency
    id
    isActive
    isDeleted
    level
    name
    paymentDays
    updatedAt
    version
  }
}
    `;

/**
 * __useGetAllDunningLevelsQuery__
 *
 * To run a query within a React component, call `useGetAllDunningLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDunningLevelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDunningLevelsQuery({
 *   variables: {
 *      cotractorId: // value for 'cotractorId'
 *      name: // value for 'name'
 *      onlyActive: // value for 'onlyActive'
 *   },
 * });
 */
export function useGetAllDunningLevelsQuery(baseOptions: Apollo.QueryHookOptions<GetAllDunningLevelsQuery, GetAllDunningLevelsQueryVariables> & ({ variables: GetAllDunningLevelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDunningLevelsQuery, GetAllDunningLevelsQueryVariables>(GetAllDunningLevelsDocument, options);
      }
export function useGetAllDunningLevelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDunningLevelsQuery, GetAllDunningLevelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDunningLevelsQuery, GetAllDunningLevelsQueryVariables>(GetAllDunningLevelsDocument, options);
        }
export function useGetAllDunningLevelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllDunningLevelsQuery, GetAllDunningLevelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllDunningLevelsQuery, GetAllDunningLevelsQueryVariables>(GetAllDunningLevelsDocument, options);
        }
export type GetAllDunningLevelsQueryHookResult = ReturnType<typeof useGetAllDunningLevelsQuery>;
export type GetAllDunningLevelsLazyQueryHookResult = ReturnType<typeof useGetAllDunningLevelsLazyQuery>;
export type GetAllDunningLevelsSuspenseQueryHookResult = ReturnType<typeof useGetAllDunningLevelsSuspenseQuery>;
export type GetAllDunningLevelsQueryResult = Apollo.QueryResult<GetAllDunningLevelsQuery, GetAllDunningLevelsQueryVariables>;
export const GetCreditNoteDocument = gql`
    query GetCreditNote($id: ID!) {
  node(id: $id) {
    __typename
    ... on CreditNote {
      id
      number
      status
      documentType
      documentRole
      kind
      settlesInvoiceId
      isPayable
      recipientObjectedAt
      clientId
      clientContactPersonId
      contractorId
      projectId
      createdById
      createdDate
      introductoryText
      concludingText
      paymentDeadlineInDays
      notes
      issueDate
      dueDate
      timestamp
      isDeleted
      isReversal
      netTotal
      taxTotal
      grossTotal
      billTo {
        line1
        line2
        line3
        line4
        line5
      }
      shipTo {
        line1
        line2
        line3
        line4
        line5
      }
      items {
        id
        name
        description
        quantity
        unit
        unitPriceNet
        discountPercent
        tax
        taxCode
        positionNo
        lineNetTotal
        lineTaxTotal
        lineGrossTotal
      }
      cancellation {
        at
        externalRef
        mode
        reason
        reversalDocumentId
      }
      isInvalid
      isProforma
      paidTotal
    }
  }
}
    `;

/**
 * __useGetCreditNoteQuery__
 *
 * To run a query within a React component, call `useGetCreditNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditNoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCreditNoteQuery(baseOptions: Apollo.QueryHookOptions<GetCreditNoteQuery, GetCreditNoteQueryVariables> & ({ variables: GetCreditNoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditNoteQuery, GetCreditNoteQueryVariables>(GetCreditNoteDocument, options);
      }
export function useGetCreditNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditNoteQuery, GetCreditNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditNoteQuery, GetCreditNoteQueryVariables>(GetCreditNoteDocument, options);
        }
export function useGetCreditNoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreditNoteQuery, GetCreditNoteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreditNoteQuery, GetCreditNoteQueryVariables>(GetCreditNoteDocument, options);
        }
export type GetCreditNoteQueryHookResult = ReturnType<typeof useGetCreditNoteQuery>;
export type GetCreditNoteLazyQueryHookResult = ReturnType<typeof useGetCreditNoteLazyQuery>;
export type GetCreditNoteSuspenseQueryHookResult = ReturnType<typeof useGetCreditNoteSuspenseQuery>;
export type GetCreditNoteQueryResult = Apollo.QueryResult<GetCreditNoteQuery, GetCreditNoteQueryVariables>;
export const GetOfferDocument = gql`
    query GetOffer($id: ID!) {
  node(id: $id) {
    __typename
    ... on Offer {
      clientId
      concludingText
      contractorId
      createdDate
      documentRole
      documentType
      dueDate
      grossTotal
      id
      introductoryText
      isDeleted
      isReversal
      issueDate
      netTotal
      notes
      number
      paymentDeadlineInDays
      status
      taxTotal
      timestamp
      billTo {
        line1
        line2
        line3
        line4
        line5
      }
      items {
        description
        discountPercent
        id
        lineGrossTotal
        lineNetTotal
        lineTaxTotal
        positionNo
        quantity
        unit
        unitPriceNet
        tax
        taxCode
        name
      }
      shipTo {
        line1
        line2
        line3
        line4
        line5
      }
      cancellation {
        at
        externalRef
        mode
        reason
        reversalDocumentId
      }
      createdById
      clientContactPersonId
      isInvalid
      isProforma
      acceptedAt
      clientName
      taxDetails {
        code
        netAmount
        rate
        taxAmount
      }
      projectId
      payments {
        amount
        creationDate
        documentId
        id
        notes
        paymentDate
        paymentMethod
      }
      employeeIds
    }
  }
}
    `;

/**
 * __useGetOfferQuery__
 *
 * To run a query within a React component, call `useGetOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOfferQuery(baseOptions: Apollo.QueryHookOptions<GetOfferQuery, GetOfferQueryVariables> & ({ variables: GetOfferQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfferQuery, GetOfferQueryVariables>(GetOfferDocument, options);
      }
export function useGetOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfferQuery, GetOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfferQuery, GetOfferQueryVariables>(GetOfferDocument, options);
        }
export function useGetOfferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferQuery, GetOfferQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOfferQuery, GetOfferQueryVariables>(GetOfferDocument, options);
        }
export type GetOfferQueryHookResult = ReturnType<typeof useGetOfferQuery>;
export type GetOfferLazyQueryHookResult = ReturnType<typeof useGetOfferLazyQuery>;
export type GetOfferSuspenseQueryHookResult = ReturnType<typeof useGetOfferSuspenseQuery>;
export type GetOfferQueryResult = Apollo.QueryResult<GetOfferQuery, GetOfferQueryVariables>;
export const InitializeDocumentEmailDocument = gql`
    query InitializeDocumentEmail($id: String!, $entityId: String) {
  initializeDocumentEmail(documentId: $id, dunningEntityId: $entityId) {
    attachments {
      content
      extension
      name
      positionNumber
    }
    body
    subject
    bccRecipients
    ccRecipients
    recipients
  }
}
    `;

/**
 * __useInitializeDocumentEmailQuery__
 *
 * To run a query within a React component, call `useInitializeDocumentEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitializeDocumentEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitializeDocumentEmailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useInitializeDocumentEmailQuery(baseOptions: Apollo.QueryHookOptions<InitializeDocumentEmailQuery, InitializeDocumentEmailQueryVariables> & ({ variables: InitializeDocumentEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitializeDocumentEmailQuery, InitializeDocumentEmailQueryVariables>(InitializeDocumentEmailDocument, options);
      }
export function useInitializeDocumentEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitializeDocumentEmailQuery, InitializeDocumentEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitializeDocumentEmailQuery, InitializeDocumentEmailQueryVariables>(InitializeDocumentEmailDocument, options);
        }
export function useInitializeDocumentEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InitializeDocumentEmailQuery, InitializeDocumentEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InitializeDocumentEmailQuery, InitializeDocumentEmailQueryVariables>(InitializeDocumentEmailDocument, options);
        }
export type InitializeDocumentEmailQueryHookResult = ReturnType<typeof useInitializeDocumentEmailQuery>;
export type InitializeDocumentEmailLazyQueryHookResult = ReturnType<typeof useInitializeDocumentEmailLazyQuery>;
export type InitializeDocumentEmailSuspenseQueryHookResult = ReturnType<typeof useInitializeDocumentEmailSuspenseQuery>;
export type InitializeDocumentEmailQueryResult = Apollo.QueryResult<InitializeDocumentEmailQuery, InitializeDocumentEmailQueryVariables>;
export const RejectOfferDocument = gql`
    mutation RejectOffer($id: ID!, $reason: String) {
  rejectOffer(input: {id: $id, reason: $reason}) {
    offer {
      id
      status
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type RejectOfferMutationFn = Apollo.MutationFunction<RejectOfferMutation, RejectOfferMutationVariables>;

/**
 * __useRejectOfferMutation__
 *
 * To run a mutation, you first call `useRejectOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectOfferMutation, { data, loading, error }] = useRejectOfferMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRejectOfferMutation(baseOptions?: Apollo.MutationHookOptions<RejectOfferMutation, RejectOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectOfferMutation, RejectOfferMutationVariables>(RejectOfferDocument, options);
      }
export type RejectOfferMutationHookResult = ReturnType<typeof useRejectOfferMutation>;
export type RejectOfferMutationResult = Apollo.MutationResult<RejectOfferMutation>;
export type RejectOfferMutationOptions = Apollo.BaseMutationOptions<RejectOfferMutation, RejectOfferMutationVariables>;
export const SendDocumentEmailDocument = gql`
    mutation SendDocumentEmail($id: String!, $commercialDocumentEmail: CommercialDocumentEmailInput!, $entityId: String) {
  sendDocumentEmail(
    input: {commercialDocumentEmail: $commercialDocumentEmail, documentId: $id, dunningEntityId: $entityId}
  ) {
    boolean
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type SendDocumentEmailMutationFn = Apollo.MutationFunction<SendDocumentEmailMutation, SendDocumentEmailMutationVariables>;

/**
 * __useSendDocumentEmailMutation__
 *
 * To run a mutation, you first call `useSendDocumentEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDocumentEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDocumentEmailMutation, { data, loading, error }] = useSendDocumentEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      commercialDocumentEmail: // value for 'commercialDocumentEmail'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useSendDocumentEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendDocumentEmailMutation, SendDocumentEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDocumentEmailMutation, SendDocumentEmailMutationVariables>(SendDocumentEmailDocument, options);
      }
export type SendDocumentEmailMutationHookResult = ReturnType<typeof useSendDocumentEmailMutation>;
export type SendDocumentEmailMutationResult = Apollo.MutationResult<SendDocumentEmailMutation>;
export type SendDocumentEmailMutationOptions = Apollo.BaseMutationOptions<SendDocumentEmailMutation, SendDocumentEmailMutationVariables>;
export const UpdateDocumentDraftDocument = gql`
    mutation UpdateDocumentDraft($documentId: String!, $settlesInvoiceId: ID, $clientContactPersonId: ID, $clientId: ID, $concludingText: String, $contractorId: ID, $introductoryText: String!, $items: [ModifyInvoiceItemInput!]!, $notes: String, $paymentDeadlineInDays: Int, $projectId: ID, $isProforma: Boolean, $validUntil: LocalDate) {
  updateDocumentDraft(
    input: {documentId: $documentId, settlesInvoiceId: $settlesInvoiceId, document: {clientContactPersonId: $clientContactPersonId, clientId: $clientId, concludingText: $concludingText, contractorId: $contractorId, introductoryText: $introductoryText, items: $items, notes: $notes, paymentDeadlineInDays: $paymentDeadlineInDays, projectId: $projectId, isProforma: $isProforma, dueDate: $validUntil}}
  ) {
    commercialDocument {
      __typename
      ... on Invoice {
        id
        number
        status
        documentType
        documentRole
        clientId
        clientContactPersonId
        contractorId
        projectId
        introductoryText
        concludingText
        paymentDeadlineInDays
        notes
        issueDate
        netTotal
        grossTotal
        items {
          id
          name
          description
          quantity
          unit
          unitPriceNet
          discountPercent
          tax
          taxCode
          positionNo
          lineNetTotal
          lineTaxTotal
          lineGrossTotal
        }
        isProforma
        isInvalid
        paidTotal
      }
      ... on CreditNote {
        id
        number
        status
        documentType
        documentRole
        kind
        settlesInvoiceId
        clientId
        clientContactPersonId
        contractorId
        projectId
        introductoryText
        concludingText
        paymentDeadlineInDays
        notes
        issueDate
        netTotal
        grossTotal
        items {
          id
          name
          description
          quantity
          unit
          unitPriceNet
          discountPercent
          tax
          taxCode
          positionNo
          lineNetTotal
          lineTaxTotal
          lineGrossTotal
        }
        isProforma
        isInvalid
        paidTotal
      }
      ... on Offer {
        clientId
        concludingText
        contractorId
        createdDate
        documentRole
        documentType
        dueDate
        grossTotal
        id
        introductoryText
        isDeleted
        isReversal
        issueDate
        netTotal
        notes
        number
        paymentDeadlineInDays
        status
        taxTotal
        timestamp
        billTo {
          line1
          line2
          line3
          line4
          line5
        }
        items {
          description
          discountPercent
          id
          lineGrossTotal
          lineNetTotal
          lineTaxTotal
          positionNo
          quantity
          unit
          unitPriceNet
          tax
          taxCode
          name
        }
        shipTo {
          line1
          line2
          line3
          line4
          line5
        }
        cancellation {
          at
          externalRef
          mode
          reason
          reversalDocumentId
        }
        createdById
        clientContactPersonId
        isInvalid
        isProforma
        acceptedAt
        clientName
        taxDetails {
          code
          netAmount
          rate
          taxAmount
        }
        projectId
        payments {
          amount
          creationDate
          documentId
          id
          notes
          paymentDate
          paymentMethod
        }
        employeeIds
      }
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type UpdateDocumentDraftMutationFn = Apollo.MutationFunction<UpdateDocumentDraftMutation, UpdateDocumentDraftMutationVariables>;

/**
 * __useUpdateDocumentDraftMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentDraftMutation, { data, loading, error }] = useUpdateDocumentDraftMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      settlesInvoiceId: // value for 'settlesInvoiceId'
 *      clientContactPersonId: // value for 'clientContactPersonId'
 *      clientId: // value for 'clientId'
 *      concludingText: // value for 'concludingText'
 *      contractorId: // value for 'contractorId'
 *      introductoryText: // value for 'introductoryText'
 *      items: // value for 'items'
 *      notes: // value for 'notes'
 *      paymentDeadlineInDays: // value for 'paymentDeadlineInDays'
 *      projectId: // value for 'projectId'
 *      isProforma: // value for 'isProforma'
 *      validUntil: // value for 'validUntil'
 *   },
 * });
 */
export function useUpdateDocumentDraftMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentDraftMutation, UpdateDocumentDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentDraftMutation, UpdateDocumentDraftMutationVariables>(UpdateDocumentDraftDocument, options);
      }
export type UpdateDocumentDraftMutationHookResult = ReturnType<typeof useUpdateDocumentDraftMutation>;
export type UpdateDocumentDraftMutationResult = Apollo.MutationResult<UpdateDocumentDraftMutation>;
export type UpdateDocumentDraftMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentDraftMutation, UpdateDocumentDraftMutationVariables>;
export const UpdateDunningLevelDocument = gql`
    mutation UpdateDunningLevel($feeAmount: Decimal!, $feeCurrency: String!, $id: ID!, $isActive: Boolean!, $name: String!, $paymentDays: Int!) {
  updateDunningLevel(
    input: {feeAmount: $feeAmount, feeCurrency: $feeCurrency, id: $id, isActive: $isActive, name: $name, paymentDays: $paymentDays}
  ) {
    dunningLevel {
      contractorId
      createdAt
      feeAmount
      feeCurrency
      id
      isActive
      isDeleted
      level
      name
      paymentDays
      updatedAt
      version
    }
    errors {
      ... on MyEntityNotFoundError {
        error
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type UpdateDunningLevelMutationFn = Apollo.MutationFunction<UpdateDunningLevelMutation, UpdateDunningLevelMutationVariables>;

/**
 * __useUpdateDunningLevelMutation__
 *
 * To run a mutation, you first call `useUpdateDunningLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDunningLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDunningLevelMutation, { data, loading, error }] = useUpdateDunningLevelMutation({
 *   variables: {
 *      feeAmount: // value for 'feeAmount'
 *      feeCurrency: // value for 'feeCurrency'
 *      id: // value for 'id'
 *      isActive: // value for 'isActive'
 *      name: // value for 'name'
 *      paymentDays: // value for 'paymentDays'
 *   },
 * });
 */
export function useUpdateDunningLevelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDunningLevelMutation, UpdateDunningLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDunningLevelMutation, UpdateDunningLevelMutationVariables>(UpdateDunningLevelDocument, options);
      }
export type UpdateDunningLevelMutationHookResult = ReturnType<typeof useUpdateDunningLevelMutation>;
export type UpdateDunningLevelMutationResult = Apollo.MutationResult<UpdateDunningLevelMutation>;
export type UpdateDunningLevelMutationOptions = Apollo.BaseMutationOptions<UpdateDunningLevelMutation, UpdateDunningLevelMutationVariables>;
export const DeleteCorrectedCreditNotePaymentDocument = gql`
    mutation DeleteCorrectedCreditNotePayment($correctedCreditNoteId: ID!, $paymentId: ID!) {
  deleteCorrectedCreditNotePayment(
    input: {correctedCreditNoteId: $correctedCreditNoteId, paymentId: $paymentId}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    boolean
  }
}
    `;
export type DeleteCorrectedCreditNotePaymentMutationFn = Apollo.MutationFunction<DeleteCorrectedCreditNotePaymentMutation, DeleteCorrectedCreditNotePaymentMutationVariables>;

/**
 * __useDeleteCorrectedCreditNotePaymentMutation__
 *
 * To run a mutation, you first call `useDeleteCorrectedCreditNotePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCorrectedCreditNotePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCorrectedCreditNotePaymentMutation, { data, loading, error }] = useDeleteCorrectedCreditNotePaymentMutation({
 *   variables: {
 *      correctedCreditNoteId: // value for 'correctedCreditNoteId'
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useDeleteCorrectedCreditNotePaymentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCorrectedCreditNotePaymentMutation, DeleteCorrectedCreditNotePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCorrectedCreditNotePaymentMutation, DeleteCorrectedCreditNotePaymentMutationVariables>(DeleteCorrectedCreditNotePaymentDocument, options);
      }
export type DeleteCorrectedCreditNotePaymentMutationHookResult = ReturnType<typeof useDeleteCorrectedCreditNotePaymentMutation>;
export type DeleteCorrectedCreditNotePaymentMutationResult = Apollo.MutationResult<DeleteCorrectedCreditNotePaymentMutation>;
export type DeleteCorrectedCreditNotePaymentMutationOptions = Apollo.BaseMutationOptions<DeleteCorrectedCreditNotePaymentMutation, DeleteCorrectedCreditNotePaymentMutationVariables>;
export const DeleteCorrectedInvoicePaymentDocument = gql`
    mutation DeleteCorrectedInvoicePayment($correctedInvoiceId: ID!, $paymentId: ID!) {
  deleteCorrectedInvoicePayment(
    input: {correctedInvoiceId: $correctedInvoiceId, paymentId: $paymentId}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    boolean
  }
}
    `;
export type DeleteCorrectedInvoicePaymentMutationFn = Apollo.MutationFunction<DeleteCorrectedInvoicePaymentMutation, DeleteCorrectedInvoicePaymentMutationVariables>;

/**
 * __useDeleteCorrectedInvoicePaymentMutation__
 *
 * To run a mutation, you first call `useDeleteCorrectedInvoicePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCorrectedInvoicePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCorrectedInvoicePaymentMutation, { data, loading, error }] = useDeleteCorrectedInvoicePaymentMutation({
 *   variables: {
 *      correctedInvoiceId: // value for 'correctedInvoiceId'
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useDeleteCorrectedInvoicePaymentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCorrectedInvoicePaymentMutation, DeleteCorrectedInvoicePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCorrectedInvoicePaymentMutation, DeleteCorrectedInvoicePaymentMutationVariables>(DeleteCorrectedInvoicePaymentDocument, options);
      }
export type DeleteCorrectedInvoicePaymentMutationHookResult = ReturnType<typeof useDeleteCorrectedInvoicePaymentMutation>;
export type DeleteCorrectedInvoicePaymentMutationResult = Apollo.MutationResult<DeleteCorrectedInvoicePaymentMutation>;
export type DeleteCorrectedInvoicePaymentMutationOptions = Apollo.BaseMutationOptions<DeleteCorrectedInvoicePaymentMutation, DeleteCorrectedInvoicePaymentMutationVariables>;
export const DeleteCreditNotePaymentDocument = gql`
    mutation DeleteCreditNotePayment($creditNoteId: ID!, $creditNotePaymentId: ID!) {
  deleteCreditNotePayment(
    input: {creditNoteId: $creditNoteId, creditNotePaymentId: $creditNotePaymentId}
  ) {
    boolean
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type DeleteCreditNotePaymentMutationFn = Apollo.MutationFunction<DeleteCreditNotePaymentMutation, DeleteCreditNotePaymentMutationVariables>;

/**
 * __useDeleteCreditNotePaymentMutation__
 *
 * To run a mutation, you first call `useDeleteCreditNotePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCreditNotePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCreditNotePaymentMutation, { data, loading, error }] = useDeleteCreditNotePaymentMutation({
 *   variables: {
 *      creditNoteId: // value for 'creditNoteId'
 *      creditNotePaymentId: // value for 'creditNotePaymentId'
 *   },
 * });
 */
export function useDeleteCreditNotePaymentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCreditNotePaymentMutation, DeleteCreditNotePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCreditNotePaymentMutation, DeleteCreditNotePaymentMutationVariables>(DeleteCreditNotePaymentDocument, options);
      }
export type DeleteCreditNotePaymentMutationHookResult = ReturnType<typeof useDeleteCreditNotePaymentMutation>;
export type DeleteCreditNotePaymentMutationResult = Apollo.MutationResult<DeleteCreditNotePaymentMutation>;
export type DeleteCreditNotePaymentMutationOptions = Apollo.BaseMutationOptions<DeleteCreditNotePaymentMutation, DeleteCreditNotePaymentMutationVariables>;
export const DeleteInvoicePaymentDocument = gql`
    mutation DeleteInvoicePayment($invoiceId: ID!, $invoicePaymentId: ID!) {
  deleteInvoicePayment(
    input: {invoiceId: $invoiceId, invoicePaymentId: $invoicePaymentId}
  ) {
    boolean
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type DeleteInvoicePaymentMutationFn = Apollo.MutationFunction<DeleteInvoicePaymentMutation, DeleteInvoicePaymentMutationVariables>;

/**
 * __useDeleteInvoicePaymentMutation__
 *
 * To run a mutation, you first call `useDeleteInvoicePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoicePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvoicePaymentMutation, { data, loading, error }] = useDeleteInvoicePaymentMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      invoicePaymentId: // value for 'invoicePaymentId'
 *   },
 * });
 */
export function useDeleteInvoicePaymentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInvoicePaymentMutation, DeleteInvoicePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInvoicePaymentMutation, DeleteInvoicePaymentMutationVariables>(DeleteInvoicePaymentDocument, options);
      }
export type DeleteInvoicePaymentMutationHookResult = ReturnType<typeof useDeleteInvoicePaymentMutation>;
export type DeleteInvoicePaymentMutationResult = Apollo.MutationResult<DeleteInvoicePaymentMutation>;
export type DeleteInvoicePaymentMutationOptions = Apollo.BaseMutationOptions<DeleteInvoicePaymentMutation, DeleteInvoicePaymentMutationVariables>;
export const GetAllCommercialDocumentsDocument = gql`
    query GetAllCommercialDocuments($first: Int, $after: String, $last: Int, $before: String, $endDate: LocalDate, $ofStatus: [DocumentStatus!], $ofType: [DocumentType!], $startDate: LocalDate!, $searchBy: String, $isProforma: Boolean, $sent: Boolean, $projectId: ID) {
  allCommercialDocuments(
    first: $first
    after: $after
    last: $last
    before: $before
    filter: {endDate: $endDate, ofStatuses: $ofStatus, ofTypes: $ofType, startDate: $startDate, clientName: $searchBy, isProforma: $isProforma, sent: $sent, projectId: $projectId}
  ) {
    nodes {
      createdDate
      documentRole
      documentType
      dueDate
      grossTotal
      issueDate
      netTotal
      number
      projectId
      status
      taxTotal
      id
      client {
        id
        displayName
      }
      clientContactPerson {
        id
        displayName
        additionalInformation {
          ... on EmailInformation {
            emailAddress
          }
        }
      }
      contractor {
        id
        displayName
      }
      paidTotal
      sentDate
      isInvalid
      project {
        id
        name
        number
      }
      isProforma
      cancellationReason
      rejectionReason
      originalDocumentDate
      originalDocumentId
      originalDocumentNumber
      cancellationReversalDocumentId
      cancellationReversalDocumentSentDate
      openTotal
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllCommercialDocumentsQuery__
 *
 * To run a query within a React component, call `useGetAllCommercialDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCommercialDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCommercialDocumentsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      endDate: // value for 'endDate'
 *      ofStatus: // value for 'ofStatus'
 *      ofType: // value for 'ofType'
 *      startDate: // value for 'startDate'
 *      searchBy: // value for 'searchBy'
 *      isProforma: // value for 'isProforma'
 *      sent: // value for 'sent'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetAllCommercialDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetAllCommercialDocumentsQuery, GetAllCommercialDocumentsQueryVariables> & ({ variables: GetAllCommercialDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCommercialDocumentsQuery, GetAllCommercialDocumentsQueryVariables>(GetAllCommercialDocumentsDocument, options);
      }
export function useGetAllCommercialDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCommercialDocumentsQuery, GetAllCommercialDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCommercialDocumentsQuery, GetAllCommercialDocumentsQueryVariables>(GetAllCommercialDocumentsDocument, options);
        }
export function useGetAllCommercialDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCommercialDocumentsQuery, GetAllCommercialDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCommercialDocumentsQuery, GetAllCommercialDocumentsQueryVariables>(GetAllCommercialDocumentsDocument, options);
        }
export type GetAllCommercialDocumentsQueryHookResult = ReturnType<typeof useGetAllCommercialDocumentsQuery>;
export type GetAllCommercialDocumentsLazyQueryHookResult = ReturnType<typeof useGetAllCommercialDocumentsLazyQuery>;
export type GetAllCommercialDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetAllCommercialDocumentsSuspenseQuery>;
export type GetAllCommercialDocumentsQueryResult = Apollo.QueryResult<GetAllCommercialDocumentsQuery, GetAllCommercialDocumentsQueryVariables>;
export const GetAllCorrectedCreditNotePaymentsDocument = gql`
    query GetAllCorrectedCreditNotePayments($correctedCreditNoteId: ID!) {
  allCorrectedCreditNotePayments(correctedCreditNoteId: $correctedCreditNoteId) {
    amount
    creationDate
    id
    notes
    paymentDate
    paymentMethod
  }
}
    `;

/**
 * __useGetAllCorrectedCreditNotePaymentsQuery__
 *
 * To run a query within a React component, call `useGetAllCorrectedCreditNotePaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCorrectedCreditNotePaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCorrectedCreditNotePaymentsQuery({
 *   variables: {
 *      correctedCreditNoteId: // value for 'correctedCreditNoteId'
 *   },
 * });
 */
export function useGetAllCorrectedCreditNotePaymentsQuery(baseOptions: Apollo.QueryHookOptions<GetAllCorrectedCreditNotePaymentsQuery, GetAllCorrectedCreditNotePaymentsQueryVariables> & ({ variables: GetAllCorrectedCreditNotePaymentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCorrectedCreditNotePaymentsQuery, GetAllCorrectedCreditNotePaymentsQueryVariables>(GetAllCorrectedCreditNotePaymentsDocument, options);
      }
export function useGetAllCorrectedCreditNotePaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCorrectedCreditNotePaymentsQuery, GetAllCorrectedCreditNotePaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCorrectedCreditNotePaymentsQuery, GetAllCorrectedCreditNotePaymentsQueryVariables>(GetAllCorrectedCreditNotePaymentsDocument, options);
        }
export function useGetAllCorrectedCreditNotePaymentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCorrectedCreditNotePaymentsQuery, GetAllCorrectedCreditNotePaymentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCorrectedCreditNotePaymentsQuery, GetAllCorrectedCreditNotePaymentsQueryVariables>(GetAllCorrectedCreditNotePaymentsDocument, options);
        }
export type GetAllCorrectedCreditNotePaymentsQueryHookResult = ReturnType<typeof useGetAllCorrectedCreditNotePaymentsQuery>;
export type GetAllCorrectedCreditNotePaymentsLazyQueryHookResult = ReturnType<typeof useGetAllCorrectedCreditNotePaymentsLazyQuery>;
export type GetAllCorrectedCreditNotePaymentsSuspenseQueryHookResult = ReturnType<typeof useGetAllCorrectedCreditNotePaymentsSuspenseQuery>;
export type GetAllCorrectedCreditNotePaymentsQueryResult = Apollo.QueryResult<GetAllCorrectedCreditNotePaymentsQuery, GetAllCorrectedCreditNotePaymentsQueryVariables>;
export const GetAllCorrectedInvoicePaymentsDocument = gql`
    query GetAllCorrectedInvoicePayments($correctedInvoiceId: ID!) {
  allCorrectedInvoicePayments(correctedInvoiceId: $correctedInvoiceId) {
    amount
    creationDate
    id
    notes
    paymentDate
    paymentMethod
  }
}
    `;

/**
 * __useGetAllCorrectedInvoicePaymentsQuery__
 *
 * To run a query within a React component, call `useGetAllCorrectedInvoicePaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCorrectedInvoicePaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCorrectedInvoicePaymentsQuery({
 *   variables: {
 *      correctedInvoiceId: // value for 'correctedInvoiceId'
 *   },
 * });
 */
export function useGetAllCorrectedInvoicePaymentsQuery(baseOptions: Apollo.QueryHookOptions<GetAllCorrectedInvoicePaymentsQuery, GetAllCorrectedInvoicePaymentsQueryVariables> & ({ variables: GetAllCorrectedInvoicePaymentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCorrectedInvoicePaymentsQuery, GetAllCorrectedInvoicePaymentsQueryVariables>(GetAllCorrectedInvoicePaymentsDocument, options);
      }
export function useGetAllCorrectedInvoicePaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCorrectedInvoicePaymentsQuery, GetAllCorrectedInvoicePaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCorrectedInvoicePaymentsQuery, GetAllCorrectedInvoicePaymentsQueryVariables>(GetAllCorrectedInvoicePaymentsDocument, options);
        }
export function useGetAllCorrectedInvoicePaymentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCorrectedInvoicePaymentsQuery, GetAllCorrectedInvoicePaymentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCorrectedInvoicePaymentsQuery, GetAllCorrectedInvoicePaymentsQueryVariables>(GetAllCorrectedInvoicePaymentsDocument, options);
        }
export type GetAllCorrectedInvoicePaymentsQueryHookResult = ReturnType<typeof useGetAllCorrectedInvoicePaymentsQuery>;
export type GetAllCorrectedInvoicePaymentsLazyQueryHookResult = ReturnType<typeof useGetAllCorrectedInvoicePaymentsLazyQuery>;
export type GetAllCorrectedInvoicePaymentsSuspenseQueryHookResult = ReturnType<typeof useGetAllCorrectedInvoicePaymentsSuspenseQuery>;
export type GetAllCorrectedInvoicePaymentsQueryResult = Apollo.QueryResult<GetAllCorrectedInvoicePaymentsQuery, GetAllCorrectedInvoicePaymentsQueryVariables>;
export const GetAllCreditNotePaymentsDocument = gql`
    query GetAllCreditNotePayments($creditNoteId: ID!) {
  allCreditNotePayments(creditNoteId: $creditNoteId) {
    amount
    creationDate
    id
    notes
    paymentDate
    paymentMethod
  }
}
    `;

/**
 * __useGetAllCreditNotePaymentsQuery__
 *
 * To run a query within a React component, call `useGetAllCreditNotePaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCreditNotePaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCreditNotePaymentsQuery({
 *   variables: {
 *      creditNoteId: // value for 'creditNoteId'
 *   },
 * });
 */
export function useGetAllCreditNotePaymentsQuery(baseOptions: Apollo.QueryHookOptions<GetAllCreditNotePaymentsQuery, GetAllCreditNotePaymentsQueryVariables> & ({ variables: GetAllCreditNotePaymentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCreditNotePaymentsQuery, GetAllCreditNotePaymentsQueryVariables>(GetAllCreditNotePaymentsDocument, options);
      }
export function useGetAllCreditNotePaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCreditNotePaymentsQuery, GetAllCreditNotePaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCreditNotePaymentsQuery, GetAllCreditNotePaymentsQueryVariables>(GetAllCreditNotePaymentsDocument, options);
        }
export function useGetAllCreditNotePaymentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCreditNotePaymentsQuery, GetAllCreditNotePaymentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCreditNotePaymentsQuery, GetAllCreditNotePaymentsQueryVariables>(GetAllCreditNotePaymentsDocument, options);
        }
export type GetAllCreditNotePaymentsQueryHookResult = ReturnType<typeof useGetAllCreditNotePaymentsQuery>;
export type GetAllCreditNotePaymentsLazyQueryHookResult = ReturnType<typeof useGetAllCreditNotePaymentsLazyQuery>;
export type GetAllCreditNotePaymentsSuspenseQueryHookResult = ReturnType<typeof useGetAllCreditNotePaymentsSuspenseQuery>;
export type GetAllCreditNotePaymentsQueryResult = Apollo.QueryResult<GetAllCreditNotePaymentsQuery, GetAllCreditNotePaymentsQueryVariables>;
export const GetAllInvoicePaymentsDocument = gql`
    query GetAllInvoicePayments($invoiceId: ID!) {
  allInvoicePayments(invoiceId: $invoiceId) {
    amount
    creationDate
    id
    notes
    paymentDate
    paymentMethod
  }
}
    `;

/**
 * __useGetAllInvoicePaymentsQuery__
 *
 * To run a query within a React component, call `useGetAllInvoicePaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllInvoicePaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllInvoicePaymentsQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetAllInvoicePaymentsQuery(baseOptions: Apollo.QueryHookOptions<GetAllInvoicePaymentsQuery, GetAllInvoicePaymentsQueryVariables> & ({ variables: GetAllInvoicePaymentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllInvoicePaymentsQuery, GetAllInvoicePaymentsQueryVariables>(GetAllInvoicePaymentsDocument, options);
      }
export function useGetAllInvoicePaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllInvoicePaymentsQuery, GetAllInvoicePaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllInvoicePaymentsQuery, GetAllInvoicePaymentsQueryVariables>(GetAllInvoicePaymentsDocument, options);
        }
export function useGetAllInvoicePaymentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllInvoicePaymentsQuery, GetAllInvoicePaymentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllInvoicePaymentsQuery, GetAllInvoicePaymentsQueryVariables>(GetAllInvoicePaymentsDocument, options);
        }
export type GetAllInvoicePaymentsQueryHookResult = ReturnType<typeof useGetAllInvoicePaymentsQuery>;
export type GetAllInvoicePaymentsLazyQueryHookResult = ReturnType<typeof useGetAllInvoicePaymentsLazyQuery>;
export type GetAllInvoicePaymentsSuspenseQueryHookResult = ReturnType<typeof useGetAllInvoicePaymentsSuspenseQuery>;
export type GetAllInvoicePaymentsQueryResult = Apollo.QueryResult<GetAllInvoicePaymentsQuery, GetAllInvoicePaymentsQueryVariables>;
export const GetInvoiceDocument = gql`
    query GetInvoice($id: ID!) {
  node(id: $id) {
    __typename
    ... on Invoice {
      clientId
      concludingText
      contractorId
      createdDate
      documentRole
      documentType
      dueDate
      grossTotal
      id
      introductoryText
      isDeleted
      isReversal
      issueDate
      netTotal
      notes
      number
      openTotal
      paidTotal
      paymentDeadlineInDays
      projectId
      status
      taxTotal
      timestamp
      billTo {
        line1
        line2
        line3
        line4
        line5
      }
      items {
        description
        discountPercent
        id
        lineGrossTotal
        lineNetTotal
        lineTaxTotal
        positionNo
        quantity
        unit
        unitPriceNet
        tax
        taxCode
        name
      }
      shipTo {
        line1
        line2
        line3
        line4
        line5
      }
      cancellation {
        at
        externalRef
        mode
        reason
        reversalDocumentId
      }
      createdById
      clientContactPersonId
      isInvalid
      isProforma
    }
  }
}
    `;

/**
 * __useGetInvoiceQuery__
 *
 * To run a query within a React component, call `useGetInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables> & ({ variables: GetInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
      }
export function useGetInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
        }
export function useGetInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
        }
export type GetInvoiceQueryHookResult = ReturnType<typeof useGetInvoiceQuery>;
export type GetInvoiceLazyQueryHookResult = ReturnType<typeof useGetInvoiceLazyQuery>;
export type GetInvoiceSuspenseQueryHookResult = ReturnType<typeof useGetInvoiceSuspenseQuery>;
export type GetInvoiceQueryResult = Apollo.QueryResult<GetInvoiceQuery, GetInvoiceQueryVariables>;
export const RecordCorrectedCreditNotePaymentDocument = gql`
    mutation RecordCorrectedCreditNotePayment($amount: Decimal!, $correctedCreditNoteId: ID!, $notes: String, $paymentDate: LocalDate!, $paymentMethod: String) {
  recordCorrectedCreditNotePayment(
    input: {amount: $amount, correctedCreditNoteId: $correctedCreditNoteId, notes: $notes, paymentDate: $paymentDate, paymentMethod: $paymentMethod}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    correctedCreditNote {
      payments {
        amount
        creationDate
        id
        notes
        paymentDate
        paymentMethod
        documentId
      }
    }
  }
}
    `;
export type RecordCorrectedCreditNotePaymentMutationFn = Apollo.MutationFunction<RecordCorrectedCreditNotePaymentMutation, RecordCorrectedCreditNotePaymentMutationVariables>;

/**
 * __useRecordCorrectedCreditNotePaymentMutation__
 *
 * To run a mutation, you first call `useRecordCorrectedCreditNotePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordCorrectedCreditNotePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordCorrectedCreditNotePaymentMutation, { data, loading, error }] = useRecordCorrectedCreditNotePaymentMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      correctedCreditNoteId: // value for 'correctedCreditNoteId'
 *      notes: // value for 'notes'
 *      paymentDate: // value for 'paymentDate'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useRecordCorrectedCreditNotePaymentMutation(baseOptions?: Apollo.MutationHookOptions<RecordCorrectedCreditNotePaymentMutation, RecordCorrectedCreditNotePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordCorrectedCreditNotePaymentMutation, RecordCorrectedCreditNotePaymentMutationVariables>(RecordCorrectedCreditNotePaymentDocument, options);
      }
export type RecordCorrectedCreditNotePaymentMutationHookResult = ReturnType<typeof useRecordCorrectedCreditNotePaymentMutation>;
export type RecordCorrectedCreditNotePaymentMutationResult = Apollo.MutationResult<RecordCorrectedCreditNotePaymentMutation>;
export type RecordCorrectedCreditNotePaymentMutationOptions = Apollo.BaseMutationOptions<RecordCorrectedCreditNotePaymentMutation, RecordCorrectedCreditNotePaymentMutationVariables>;
export const RecordCorrectedInvoicePaymentDocument = gql`
    mutation RecordCorrectedInvoicePayment($amount: Decimal!, $correctedInvoiceId: ID!, $notes: String, $paymentDate: LocalDate!, $paymentMethod: String) {
  recordCorrectedInvoicePayment(
    input: {amount: $amount, correctedInvoiceId: $correctedInvoiceId, notes: $notes, paymentDate: $paymentDate, paymentMethod: $paymentMethod}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    correctedInvoice {
      payments {
        amount
        creationDate
        id
        notes
        paymentDate
        paymentMethod
        documentId
      }
    }
  }
}
    `;
export type RecordCorrectedInvoicePaymentMutationFn = Apollo.MutationFunction<RecordCorrectedInvoicePaymentMutation, RecordCorrectedInvoicePaymentMutationVariables>;

/**
 * __useRecordCorrectedInvoicePaymentMutation__
 *
 * To run a mutation, you first call `useRecordCorrectedInvoicePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordCorrectedInvoicePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordCorrectedInvoicePaymentMutation, { data, loading, error }] = useRecordCorrectedInvoicePaymentMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      correctedInvoiceId: // value for 'correctedInvoiceId'
 *      notes: // value for 'notes'
 *      paymentDate: // value for 'paymentDate'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useRecordCorrectedInvoicePaymentMutation(baseOptions?: Apollo.MutationHookOptions<RecordCorrectedInvoicePaymentMutation, RecordCorrectedInvoicePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordCorrectedInvoicePaymentMutation, RecordCorrectedInvoicePaymentMutationVariables>(RecordCorrectedInvoicePaymentDocument, options);
      }
export type RecordCorrectedInvoicePaymentMutationHookResult = ReturnType<typeof useRecordCorrectedInvoicePaymentMutation>;
export type RecordCorrectedInvoicePaymentMutationResult = Apollo.MutationResult<RecordCorrectedInvoicePaymentMutation>;
export type RecordCorrectedInvoicePaymentMutationOptions = Apollo.BaseMutationOptions<RecordCorrectedInvoicePaymentMutation, RecordCorrectedInvoicePaymentMutationVariables>;
export const RecordCreditNotePaymentDocument = gql`
    mutation RecordCreditNotePayment($amount: Decimal!, $creditNoteId: ID!, $notes: String, $paymentDate: LocalDate!, $paymentMethod: String) {
  recordCreditNotePayment(
    input: {amount: $amount, creditNoteId: $creditNoteId, notes: $notes, paymentDate: $paymentDate, paymentMethod: $paymentMethod}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    creditNote {
      payments {
        amount
        creationDate
        id
        notes
        paymentDate
        paymentMethod
        documentId
      }
    }
  }
}
    `;
export type RecordCreditNotePaymentMutationFn = Apollo.MutationFunction<RecordCreditNotePaymentMutation, RecordCreditNotePaymentMutationVariables>;

/**
 * __useRecordCreditNotePaymentMutation__
 *
 * To run a mutation, you first call `useRecordCreditNotePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordCreditNotePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordCreditNotePaymentMutation, { data, loading, error }] = useRecordCreditNotePaymentMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      creditNoteId: // value for 'creditNoteId'
 *      notes: // value for 'notes'
 *      paymentDate: // value for 'paymentDate'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useRecordCreditNotePaymentMutation(baseOptions?: Apollo.MutationHookOptions<RecordCreditNotePaymentMutation, RecordCreditNotePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordCreditNotePaymentMutation, RecordCreditNotePaymentMutationVariables>(RecordCreditNotePaymentDocument, options);
      }
export type RecordCreditNotePaymentMutationHookResult = ReturnType<typeof useRecordCreditNotePaymentMutation>;
export type RecordCreditNotePaymentMutationResult = Apollo.MutationResult<RecordCreditNotePaymentMutation>;
export type RecordCreditNotePaymentMutationOptions = Apollo.BaseMutationOptions<RecordCreditNotePaymentMutation, RecordCreditNotePaymentMutationVariables>;
export const RecordInvoicePaymentDocument = gql`
    mutation RecordInvoicePayment($amount: Decimal!, $invoiceId: ID!, $notes: String, $paymentDate: LocalDate!, $paymentMethod: String) {
  recordInvoicePayment(
    input: {input: {amount: $amount, invoiceId: $invoiceId, notes: $notes, paymentDate: $paymentDate, paymentMethod: $paymentMethod}}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    invoice {
      payments {
        amount
        creationDate
        id
        notes
        paymentDate
        paymentMethod
        documentId
      }
    }
  }
}
    `;
export type RecordInvoicePaymentMutationFn = Apollo.MutationFunction<RecordInvoicePaymentMutation, RecordInvoicePaymentMutationVariables>;

/**
 * __useRecordInvoicePaymentMutation__
 *
 * To run a mutation, you first call `useRecordInvoicePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordInvoicePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordInvoicePaymentMutation, { data, loading, error }] = useRecordInvoicePaymentMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      invoiceId: // value for 'invoiceId'
 *      notes: // value for 'notes'
 *      paymentDate: // value for 'paymentDate'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useRecordInvoicePaymentMutation(baseOptions?: Apollo.MutationHookOptions<RecordInvoicePaymentMutation, RecordInvoicePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordInvoicePaymentMutation, RecordInvoicePaymentMutationVariables>(RecordInvoicePaymentDocument, options);
      }
export type RecordInvoicePaymentMutationHookResult = ReturnType<typeof useRecordInvoicePaymentMutation>;
export type RecordInvoicePaymentMutationResult = Apollo.MutationResult<RecordInvoicePaymentMutation>;
export type RecordInvoicePaymentMutationOptions = Apollo.BaseMutationOptions<RecordInvoicePaymentMutation, RecordInvoicePaymentMutationVariables>;
export const ValidateXmlDocument = gql`
    query ValidateXml($documentId: String!) {
  validateXml(documentId: $documentId) {
    isValid
    errors {
      btCode
      fieldPath
      message
    }
  }
}
    `;

/**
 * __useValidateXmlQuery__
 *
 * To run a query within a React component, call `useValidateXmlQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateXmlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateXmlQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useValidateXmlQuery(baseOptions: Apollo.QueryHookOptions<ValidateXmlQuery, ValidateXmlQueryVariables> & ({ variables: ValidateXmlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateXmlQuery, ValidateXmlQueryVariables>(ValidateXmlDocument, options);
      }
export function useValidateXmlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateXmlQuery, ValidateXmlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateXmlQuery, ValidateXmlQueryVariables>(ValidateXmlDocument, options);
        }
export function useValidateXmlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateXmlQuery, ValidateXmlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateXmlQuery, ValidateXmlQueryVariables>(ValidateXmlDocument, options);
        }
export type ValidateXmlQueryHookResult = ReturnType<typeof useValidateXmlQuery>;
export type ValidateXmlLazyQueryHookResult = ReturnType<typeof useValidateXmlLazyQuery>;
export type ValidateXmlSuspenseQueryHookResult = ReturnType<typeof useValidateXmlSuspenseQuery>;
export type ValidateXmlQueryResult = Apollo.QueryResult<ValidateXmlQuery, ValidateXmlQueryVariables>;
export const GetEligibleTimesheetsForBillingDocument = gql`
    query GetEligibleTimesheetsForBilling($projectId: ID!, $month: LocalDate!) {
  eligibleTimesheetsForBilling(projectId: $projectId, month: $month) {
    timesheetId
    number
    employee {
      id
      displayName
    }
    from
    to
    totalHours
    requiresCreditNote
    hasClientInvoice
    hasSupplierCreditNote
    requiresContractorCreditNote
    hasContractorCreditNote
  }
}
    `;

/**
 * __useGetEligibleTimesheetsForBillingQuery__
 *
 * To run a query within a React component, call `useGetEligibleTimesheetsForBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEligibleTimesheetsForBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEligibleTimesheetsForBillingQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useGetEligibleTimesheetsForBillingQuery(baseOptions: Apollo.QueryHookOptions<GetEligibleTimesheetsForBillingQuery, GetEligibleTimesheetsForBillingQueryVariables> & ({ variables: GetEligibleTimesheetsForBillingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEligibleTimesheetsForBillingQuery, GetEligibleTimesheetsForBillingQueryVariables>(GetEligibleTimesheetsForBillingDocument, options);
      }
export function useGetEligibleTimesheetsForBillingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEligibleTimesheetsForBillingQuery, GetEligibleTimesheetsForBillingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEligibleTimesheetsForBillingQuery, GetEligibleTimesheetsForBillingQueryVariables>(GetEligibleTimesheetsForBillingDocument, options);
        }
export function useGetEligibleTimesheetsForBillingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEligibleTimesheetsForBillingQuery, GetEligibleTimesheetsForBillingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEligibleTimesheetsForBillingQuery, GetEligibleTimesheetsForBillingQueryVariables>(GetEligibleTimesheetsForBillingDocument, options);
        }
export type GetEligibleTimesheetsForBillingQueryHookResult = ReturnType<typeof useGetEligibleTimesheetsForBillingQuery>;
export type GetEligibleTimesheetsForBillingLazyQueryHookResult = ReturnType<typeof useGetEligibleTimesheetsForBillingLazyQuery>;
export type GetEligibleTimesheetsForBillingSuspenseQueryHookResult = ReturnType<typeof useGetEligibleTimesheetsForBillingSuspenseQuery>;
export type GetEligibleTimesheetsForBillingQueryResult = Apollo.QueryResult<GetEligibleTimesheetsForBillingQuery, GetEligibleTimesheetsForBillingQueryVariables>;
export const GetMonthlyBillingEligibilityDocument = gql`
    query GetMonthlyBillingEligibility($projectId: ID!, $month: LocalDate!) {
  monthlyBillingEligibility(projectId: $projectId, month: $month) {
    isEligible
    eligibleTimesheetIds
    eligibleSupplierIds
    ineligibilityReason
  }
}
    `;

/**
 * __useGetMonthlyBillingEligibilityQuery__
 *
 * To run a query within a React component, call `useGetMonthlyBillingEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMonthlyBillingEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMonthlyBillingEligibilityQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useGetMonthlyBillingEligibilityQuery(baseOptions: Apollo.QueryHookOptions<GetMonthlyBillingEligibilityQuery, GetMonthlyBillingEligibilityQueryVariables> & ({ variables: GetMonthlyBillingEligibilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMonthlyBillingEligibilityQuery, GetMonthlyBillingEligibilityQueryVariables>(GetMonthlyBillingEligibilityDocument, options);
      }
export function useGetMonthlyBillingEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMonthlyBillingEligibilityQuery, GetMonthlyBillingEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMonthlyBillingEligibilityQuery, GetMonthlyBillingEligibilityQueryVariables>(GetMonthlyBillingEligibilityDocument, options);
        }
export function useGetMonthlyBillingEligibilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMonthlyBillingEligibilityQuery, GetMonthlyBillingEligibilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMonthlyBillingEligibilityQuery, GetMonthlyBillingEligibilityQueryVariables>(GetMonthlyBillingEligibilityDocument, options);
        }
export type GetMonthlyBillingEligibilityQueryHookResult = ReturnType<typeof useGetMonthlyBillingEligibilityQuery>;
export type GetMonthlyBillingEligibilityLazyQueryHookResult = ReturnType<typeof useGetMonthlyBillingEligibilityLazyQuery>;
export type GetMonthlyBillingEligibilitySuspenseQueryHookResult = ReturnType<typeof useGetMonthlyBillingEligibilitySuspenseQuery>;
export type GetMonthlyBillingEligibilityQueryResult = Apollo.QueryResult<GetMonthlyBillingEligibilityQuery, GetMonthlyBillingEligibilityQueryVariables>;
export const GetMonthlyOverviewChildrenDocument = gql`
    query GetMonthlyOverviewChildren($parentId: String!, $parentPath: [String!]!, $parentType: OverviewItemType!, $month: LocalDate!, $employeeId: ID) {
  monthlyOverviewChildren(
    parentId: $parentId
    parentPath: $parentPath
    parentType: $parentType
    month: $month
    employeeId: $employeeId
  ) {
    ...MonthlyOverviewItemFields
  }
}
    ${MonthlyOverviewItemFieldsFragmentDoc}`;

/**
 * __useGetMonthlyOverviewChildrenQuery__
 *
 * To run a query within a React component, call `useGetMonthlyOverviewChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMonthlyOverviewChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMonthlyOverviewChildrenQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      parentPath: // value for 'parentPath'
 *      parentType: // value for 'parentType'
 *      month: // value for 'month'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useGetMonthlyOverviewChildrenQuery(baseOptions: Apollo.QueryHookOptions<GetMonthlyOverviewChildrenQuery, GetMonthlyOverviewChildrenQueryVariables> & ({ variables: GetMonthlyOverviewChildrenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMonthlyOverviewChildrenQuery, GetMonthlyOverviewChildrenQueryVariables>(GetMonthlyOverviewChildrenDocument, options);
      }
export function useGetMonthlyOverviewChildrenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMonthlyOverviewChildrenQuery, GetMonthlyOverviewChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMonthlyOverviewChildrenQuery, GetMonthlyOverviewChildrenQueryVariables>(GetMonthlyOverviewChildrenDocument, options);
        }
export function useGetMonthlyOverviewChildrenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMonthlyOverviewChildrenQuery, GetMonthlyOverviewChildrenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMonthlyOverviewChildrenQuery, GetMonthlyOverviewChildrenQueryVariables>(GetMonthlyOverviewChildrenDocument, options);
        }
export type GetMonthlyOverviewChildrenQueryHookResult = ReturnType<typeof useGetMonthlyOverviewChildrenQuery>;
export type GetMonthlyOverviewChildrenLazyQueryHookResult = ReturnType<typeof useGetMonthlyOverviewChildrenLazyQuery>;
export type GetMonthlyOverviewChildrenSuspenseQueryHookResult = ReturnType<typeof useGetMonthlyOverviewChildrenSuspenseQuery>;
export type GetMonthlyOverviewChildrenQueryResult = Apollo.QueryResult<GetMonthlyOverviewChildrenQuery, GetMonthlyOverviewChildrenQueryVariables>;
export const GetMonthlyOverviewRootsDocument = gql`
    query GetMonthlyOverviewRoots($month: LocalDate!, $clientId: ID, $employeeId: ID, $excludeEmptyTenders: Boolean, $excludeFullyInvoiced: Boolean, $groupByClient: Boolean, $first: Int, $after: String) {
  monthlyOverviewRoots(
    month: $month
    clientId: $clientId
    employeeId: $employeeId
    excludeEmptyTenders: $excludeEmptyTenders
    excludeFullyInvoiced: $excludeFullyInvoiced
    groupByClient: $groupByClient
    first: $first
    after: $after
  ) {
    totalCount
    hasNextPage
    endCursor
    nodes {
      ...MonthlyOverviewItemFields
    }
  }
}
    ${MonthlyOverviewItemFieldsFragmentDoc}`;

/**
 * __useGetMonthlyOverviewRootsQuery__
 *
 * To run a query within a React component, call `useGetMonthlyOverviewRootsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMonthlyOverviewRootsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMonthlyOverviewRootsQuery({
 *   variables: {
 *      month: // value for 'month'
 *      clientId: // value for 'clientId'
 *      employeeId: // value for 'employeeId'
 *      excludeEmptyTenders: // value for 'excludeEmptyTenders'
 *      excludeFullyInvoiced: // value for 'excludeFullyInvoiced'
 *      groupByClient: // value for 'groupByClient'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetMonthlyOverviewRootsQuery(baseOptions: Apollo.QueryHookOptions<GetMonthlyOverviewRootsQuery, GetMonthlyOverviewRootsQueryVariables> & ({ variables: GetMonthlyOverviewRootsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMonthlyOverviewRootsQuery, GetMonthlyOverviewRootsQueryVariables>(GetMonthlyOverviewRootsDocument, options);
      }
export function useGetMonthlyOverviewRootsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMonthlyOverviewRootsQuery, GetMonthlyOverviewRootsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMonthlyOverviewRootsQuery, GetMonthlyOverviewRootsQueryVariables>(GetMonthlyOverviewRootsDocument, options);
        }
export function useGetMonthlyOverviewRootsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMonthlyOverviewRootsQuery, GetMonthlyOverviewRootsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMonthlyOverviewRootsQuery, GetMonthlyOverviewRootsQueryVariables>(GetMonthlyOverviewRootsDocument, options);
        }
export type GetMonthlyOverviewRootsQueryHookResult = ReturnType<typeof useGetMonthlyOverviewRootsQuery>;
export type GetMonthlyOverviewRootsLazyQueryHookResult = ReturnType<typeof useGetMonthlyOverviewRootsLazyQuery>;
export type GetMonthlyOverviewRootsSuspenseQueryHookResult = ReturnType<typeof useGetMonthlyOverviewRootsSuspenseQuery>;
export type GetMonthlyOverviewRootsQueryResult = Apollo.QueryResult<GetMonthlyOverviewRootsQuery, GetMonthlyOverviewRootsQueryVariables>;
export const RefreshMonthlyInvoiceStatusesDocument = gql`
    mutation RefreshMonthlyInvoiceStatuses($month: LocalDate!) {
  refreshMonthlyInvoiceStatuses(input: {month: $month}) {
    refreshMonthlyInvoiceStatusesResult {
      updatedInvoices
      updatedCreditNotes
    }
    errors {
      ... on DomainError {
        message
      }
      ... on PropertyValidationError {
        message
        errors {
          propertyName
          errorMessage
        }
      }
    }
  }
}
    `;
export type RefreshMonthlyInvoiceStatusesMutationFn = Apollo.MutationFunction<RefreshMonthlyInvoiceStatusesMutation, RefreshMonthlyInvoiceStatusesMutationVariables>;

/**
 * __useRefreshMonthlyInvoiceStatusesMutation__
 *
 * To run a mutation, you first call `useRefreshMonthlyInvoiceStatusesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshMonthlyInvoiceStatusesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshMonthlyInvoiceStatusesMutation, { data, loading, error }] = useRefreshMonthlyInvoiceStatusesMutation({
 *   variables: {
 *      month: // value for 'month'
 *   },
 * });
 */
export function useRefreshMonthlyInvoiceStatusesMutation(baseOptions?: Apollo.MutationHookOptions<RefreshMonthlyInvoiceStatusesMutation, RefreshMonthlyInvoiceStatusesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshMonthlyInvoiceStatusesMutation, RefreshMonthlyInvoiceStatusesMutationVariables>(RefreshMonthlyInvoiceStatusesDocument, options);
      }
export type RefreshMonthlyInvoiceStatusesMutationHookResult = ReturnType<typeof useRefreshMonthlyInvoiceStatusesMutation>;
export type RefreshMonthlyInvoiceStatusesMutationResult = Apollo.MutationResult<RefreshMonthlyInvoiceStatusesMutation>;
export type RefreshMonthlyInvoiceStatusesMutationOptions = Apollo.BaseMutationOptions<RefreshMonthlyInvoiceStatusesMutation, RefreshMonthlyInvoiceStatusesMutationVariables>;
export const RequestMonthlyBillingDocument = gql`
    mutation RequestMonthlyBilling($projectId: ID!, $month: LocalDate!, $timesheetIdsForInvoice: [ID!]!, $timesheetIdsForCreditNotes: [ID!]!, $timesheetIdsForContractorCreditNotes: [ID!]!) {
  requestMonthlyBilling(
    input: {projectId: $projectId, month: $month, timesheetIdsForInvoice: $timesheetIdsForInvoice, timesheetIdsForCreditNotes: $timesheetIdsForCreditNotes, timesheetIdsForContractorCreditNotes: $timesheetIdsForContractorCreditNotes}
  ) {
    boolean
    errors {
      ... on DomainError {
        message
      }
      ... on PropertyValidationError {
        message
        errors {
          propertyName
          errorMessage
        }
      }
    }
  }
}
    `;
export type RequestMonthlyBillingMutationFn = Apollo.MutationFunction<RequestMonthlyBillingMutation, RequestMonthlyBillingMutationVariables>;

/**
 * __useRequestMonthlyBillingMutation__
 *
 * To run a mutation, you first call `useRequestMonthlyBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestMonthlyBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestMonthlyBillingMutation, { data, loading, error }] = useRequestMonthlyBillingMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      month: // value for 'month'
 *      timesheetIdsForInvoice: // value for 'timesheetIdsForInvoice'
 *      timesheetIdsForCreditNotes: // value for 'timesheetIdsForCreditNotes'
 *      timesheetIdsForContractorCreditNotes: // value for 'timesheetIdsForContractorCreditNotes'
 *   },
 * });
 */
export function useRequestMonthlyBillingMutation(baseOptions?: Apollo.MutationHookOptions<RequestMonthlyBillingMutation, RequestMonthlyBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestMonthlyBillingMutation, RequestMonthlyBillingMutationVariables>(RequestMonthlyBillingDocument, options);
      }
export type RequestMonthlyBillingMutationHookResult = ReturnType<typeof useRequestMonthlyBillingMutation>;
export type RequestMonthlyBillingMutationResult = Apollo.MutationResult<RequestMonthlyBillingMutation>;
export type RequestMonthlyBillingMutationOptions = Apollo.BaseMutationOptions<RequestMonthlyBillingMutation, RequestMonthlyBillingMutationVariables>;
export const SearchMonthlyOverviewDocument = gql`
    query SearchMonthlyOverview($month: LocalDate!, $projectName: String!, $clientId: ID, $employeeId: ID, $excludeEmptyTenders: Boolean, $excludeFullyInvoiced: Boolean, $first: Int, $after: String) {
  searchMonthlyOverview(
    month: $month
    projectName: $projectName
    clientId: $clientId
    employeeId: $employeeId
    excludeEmptyTenders: $excludeEmptyTenders
    excludeFullyInvoiced: $excludeFullyInvoiced
    first: $first
    after: $after
  ) {
    totalCount
    matchedProjectIds
    items {
      ...MonthlyOverviewItemFields
    }
  }
}
    ${MonthlyOverviewItemFieldsFragmentDoc}`;

/**
 * __useSearchMonthlyOverviewQuery__
 *
 * To run a query within a React component, call `useSearchMonthlyOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMonthlyOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMonthlyOverviewQuery({
 *   variables: {
 *      month: // value for 'month'
 *      projectName: // value for 'projectName'
 *      clientId: // value for 'clientId'
 *      employeeId: // value for 'employeeId'
 *      excludeEmptyTenders: // value for 'excludeEmptyTenders'
 *      excludeFullyInvoiced: // value for 'excludeFullyInvoiced'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSearchMonthlyOverviewQuery(baseOptions: Apollo.QueryHookOptions<SearchMonthlyOverviewQuery, SearchMonthlyOverviewQueryVariables> & ({ variables: SearchMonthlyOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchMonthlyOverviewQuery, SearchMonthlyOverviewQueryVariables>(SearchMonthlyOverviewDocument, options);
      }
export function useSearchMonthlyOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchMonthlyOverviewQuery, SearchMonthlyOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchMonthlyOverviewQuery, SearchMonthlyOverviewQueryVariables>(SearchMonthlyOverviewDocument, options);
        }
export function useSearchMonthlyOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchMonthlyOverviewQuery, SearchMonthlyOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchMonthlyOverviewQuery, SearchMonthlyOverviewQueryVariables>(SearchMonthlyOverviewDocument, options);
        }
export type SearchMonthlyOverviewQueryHookResult = ReturnType<typeof useSearchMonthlyOverviewQuery>;
export type SearchMonthlyOverviewLazyQueryHookResult = ReturnType<typeof useSearchMonthlyOverviewLazyQuery>;
export type SearchMonthlyOverviewSuspenseQueryHookResult = ReturnType<typeof useSearchMonthlyOverviewSuspenseQuery>;
export type SearchMonthlyOverviewQueryResult = Apollo.QueryResult<SearchMonthlyOverviewQuery, SearchMonthlyOverviewQueryVariables>;
export const AcceptTimeApprovalDocument = gql`
    mutation AcceptTimeApproval($description: String, $projectTimeApprovalId: ID!) {
  acceptTimeApproval(
    input: {description: $description, projectTimeApprovalId: $projectTimeApprovalId}
  ) {
    projectTimeApproval {
      description
      id
      number
      status
      timestamp
      totalMinutes
      project {
        id
        name
      }
      employee {
        id
        displayName
      }
      createdBy {
        id
        displayName
      }
      from
      to
      history {
        description
        status
        timestamp
        createdBy {
          id
          displayName
        }
      }
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type AcceptTimeApprovalMutationFn = Apollo.MutationFunction<AcceptTimeApprovalMutation, AcceptTimeApprovalMutationVariables>;

/**
 * __useAcceptTimeApprovalMutation__
 *
 * To run a mutation, you first call `useAcceptTimeApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTimeApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTimeApprovalMutation, { data, loading, error }] = useAcceptTimeApprovalMutation({
 *   variables: {
 *      description: // value for 'description'
 *      projectTimeApprovalId: // value for 'projectTimeApprovalId'
 *   },
 * });
 */
export function useAcceptTimeApprovalMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTimeApprovalMutation, AcceptTimeApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTimeApprovalMutation, AcceptTimeApprovalMutationVariables>(AcceptTimeApprovalDocument, options);
      }
export type AcceptTimeApprovalMutationHookResult = ReturnType<typeof useAcceptTimeApprovalMutation>;
export type AcceptTimeApprovalMutationResult = Apollo.MutationResult<AcceptTimeApprovalMutation>;
export type AcceptTimeApprovalMutationOptions = Apollo.BaseMutationOptions<AcceptTimeApprovalMutation, AcceptTimeApprovalMutationVariables>;
export const AddServicesToProjectDocument = gql`
    mutation AddServicesToProject($projectId: ID!, $serviceIds: [String!]!) {
  addServicesToProject(input: {serviceIds: $serviceIds, projectId: $projectId}) {
    project {
      id
      __typename
      ... on Project {
        id
        isDeleted
        name
        budget {
          amount
          hasAmountLimit
          hasTimeLimit
          hours
        }
        isGroup
        isRoot
        number
        path
        projectType
        range {
          from
          to
        }
        status
        additionalInformation {
          id
          __typename
          ... on AdditionalAccountingInformation {
            accountingProfile {
              name
              id
            }
            provision
            timeTrackingResolution
            id
            clientContractNumber
            clientOrderingDate
            clientContratDate
            clientOrderingNumber
            clientProjectNumber
            supplierProjectNumber
            accountingProfile {
              id
              name
            }
          }
          ... on AdditionalContactInformation {
            clientId
            contractorId
            endCustomer
            client {
              id
              displayName
            }
            contractor {
              id
              displayName
            }
            id
          }
          ... on AdditionalContactPersonInformation {
            clientContactPersonId
            contractorContactPersonId
            contractorProjectLeaderId
            clientContactPerson {
              id
              displayName
            }
            contractorContactPerson {
              id
              displayName
            }
            contractorProjectLeader {
              id
              displayName
            }
            id
          }
          ... on AdditionalPositionInformation {
            hours
            pricePerHour
            saleableServiceId
            serviceName
            servicePrice
            id
            price
            priceRate
          }
          ... on AdditionalTeamMemberInformation {
            employeeId
            id
            worksOnPositions {
              positionId
              pricePerHour
              hours
            }
            employee {
              id
              displayName
              isAFreelancer
              additionalInformation {
                id
                __typename
                ... on SalaryInformation {
                  pricePerHour
                  startDate
                }
              }
            }
          }
        }
        createdById
        parentProjectId
        parentProjectName
        saleableServiceGroups {
          hasFixSellingPrice
          id
          name
          originalId
          sellingPrice
          budget {
            amount
            hasAmountLimit
            hasTimeLimit
            hours
          }
          services {
            hasFixSellingPrice
            id
            name
            originalId
            purchasePrice
            sellingPrice
            vatRate
            budget {
              amount
              hasAmountLimit
              hasTimeLimit
              hours
            }
            unit {
              id
              name
              originalId
              shortCode
            }
          }
        }
        saleableServices {
          hasFixSellingPrice
          id
          name
          originalId
          purchasePrice
          sellingPrice
          vatRate
          budget {
            amount
            hasAmountLimit
            hasTimeLimit
            hours
          }
          unit {
            id
            name
            originalId
            shortCode
          }
        }
        saleableUnits {
          id
          name
          originalId
          shortCode
        }
        timestamp
        createdBy {
          id
          displayName
        }
      }
    }
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on DomainError {
        errorType
        message
      }
    }
  }
}
    `;
export type AddServicesToProjectMutationFn = Apollo.MutationFunction<AddServicesToProjectMutation, AddServicesToProjectMutationVariables>;

/**
 * __useAddServicesToProjectMutation__
 *
 * To run a mutation, you first call `useAddServicesToProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddServicesToProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addServicesToProjectMutation, { data, loading, error }] = useAddServicesToProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      serviceIds: // value for 'serviceIds'
 *   },
 * });
 */
export function useAddServicesToProjectMutation(baseOptions?: Apollo.MutationHookOptions<AddServicesToProjectMutation, AddServicesToProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddServicesToProjectMutation, AddServicesToProjectMutationVariables>(AddServicesToProjectDocument, options);
      }
export type AddServicesToProjectMutationHookResult = ReturnType<typeof useAddServicesToProjectMutation>;
export type AddServicesToProjectMutationResult = Apollo.MutationResult<AddServicesToProjectMutation>;
export type AddServicesToProjectMutationOptions = Apollo.BaseMutationOptions<AddServicesToProjectMutation, AddServicesToProjectMutationVariables>;
export const AvailableServicesForProjectDocument = gql`
    query AvailableServicesForProject($id: ID!) {
  availableServicesForProject(projectId: $id) {
    id
    name
    services {
      hasFixSellingPrice
      id
      name
      price
      purchasePrice
      sellingPrice
      unitName
      vatRate
      budget {
        amount
        hasAmountLimit
        hasTimeLimit
        hours
      }
    }
  }
}
    `;

/**
 * __useAvailableServicesForProjectQuery__
 *
 * To run a query within a React component, call `useAvailableServicesForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableServicesForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableServicesForProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAvailableServicesForProjectQuery(baseOptions: Apollo.QueryHookOptions<AvailableServicesForProjectQuery, AvailableServicesForProjectQueryVariables> & ({ variables: AvailableServicesForProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableServicesForProjectQuery, AvailableServicesForProjectQueryVariables>(AvailableServicesForProjectDocument, options);
      }
export function useAvailableServicesForProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableServicesForProjectQuery, AvailableServicesForProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableServicesForProjectQuery, AvailableServicesForProjectQueryVariables>(AvailableServicesForProjectDocument, options);
        }
export function useAvailableServicesForProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableServicesForProjectQuery, AvailableServicesForProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableServicesForProjectQuery, AvailableServicesForProjectQueryVariables>(AvailableServicesForProjectDocument, options);
        }
export type AvailableServicesForProjectQueryHookResult = ReturnType<typeof useAvailableServicesForProjectQuery>;
export type AvailableServicesForProjectLazyQueryHookResult = ReturnType<typeof useAvailableServicesForProjectLazyQuery>;
export type AvailableServicesForProjectSuspenseQueryHookResult = ReturnType<typeof useAvailableServicesForProjectSuspenseQuery>;
export type AvailableServicesForProjectQueryResult = Apollo.QueryResult<AvailableServicesForProjectQuery, AvailableServicesForProjectQueryVariables>;
export const CreateProjectDocument = gql`
    mutation CreateProject($name: String!, $from: LocalDate!, $to: LocalDate!, $type: ProjectType!, $parentProject: ID) {
  createProject(
    input: {name: $name, range: {from: $from, to: $to}, type: $type, parentProjectId: $parentProject}
  ) {
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on DomainError {
        errorType
        message
      }
    }
    project {
      id
      isDeleted
      name
      number
      budget {
        amount
        hasAmountLimit
        hasTimeLimit
        hours
      }
      range {
        from
        to
      }
      additionalInformation {
        id
        __typename
        ... on AdditionalAccountingInformation {
          accountingProfileId
          provision
          timeTrackingResolution
          clientContractNumber
          clientContratDate
          clientOrderingDate
          clientOrderingNumber
          clientProjectNumber
          supplierProjectNumber
        }
        ... on AdditionalContactInformation {
          clientId
          contractorId
          endCustomer
          client {
            id
            displayName
          }
          contractor {
            id
            displayName
          }
        }
        ... on AdditionalContactPersonInformation {
          clientContactPersonId
          contractorContactPersonId
          contractorProjectLeaderId
          clientContactPerson {
            id
            displayName
          }
          contractorContactPerson {
            id
            displayName
          }
          contractorProjectLeader {
            id
            displayName
          }
        }
        ... on AdditionalPositionInformation {
          hours
          saleableServiceId
          pricePerHour
          price
          priceRate
        }
        ... on AdditionalTeamMemberInformation {
          employeeId
          worksOnPositions {
            positionId
            pricePerHour
            hours
          }
          employee {
            id
            displayName
          }
        }
      }
      createdById
      isGroup
      isRoot
      path
      parentProjectId
      projectType
      saleableServiceGroups {
        hasFixSellingPrice
        id
        name
        originalId
        sellingPrice
        budget {
          amount
          hasAmountLimit
          hasTimeLimit
          hours
        }
        services {
          hasFixSellingPrice
          id
          name
          originalId
          purchasePrice
          sellingPrice
          vatRate
          budget {
            amount
            hasAmountLimit
            hasTimeLimit
            hours
          }
          unit {
            id
            name
            originalId
            shortCode
          }
        }
      }
      saleableServices {
        hasFixSellingPrice
        id
        name
        originalId
        purchasePrice
        sellingPrice
        vatRate
        budget {
          amount
          hasAmountLimit
          hasTimeLimit
          hours
        }
        unit {
          id
          name
          originalId
          shortCode
        }
      }
      saleableUnits {
        id
        name
        originalId
        shortCode
      }
      status
      timestamp
      createdBy {
        id
        displayName
      }
    }
  }
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      name: // value for 'name'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      type: // value for 'type'
 *      parentProject: // value for 'parentProject'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const CreateProjectAdditionalAccountingInformationDocument = gql`
    mutation CreateProjectAdditionalAccountingInformation($accountingProfileId: ID, $projectId: ID!, $provision: Decimal, $timeTrackingResolution: Int!, $clientContractNumber: String, $clientContratDate: LocalDate, $clientOrderingDate: LocalDate, $clientOrderingNumber: String, $clientProjectNumber: String, $supplierProjectNumber: String, $provisionDescription: String) {
  createProjectAdditionalAccountingInformation(
    input: {accountingProfileId: $accountingProfileId, projectId: $projectId, provision: $provision, timeTrackingResolution: $timeTrackingResolution, clientContractNumber: $clientContractNumber, clientContratDate: $clientContratDate, clientOrderingDate: $clientOrderingDate, clientOrderingNumber: $clientOrderingNumber, clientProjectNumber: $clientProjectNumber, supplierProjectNumber: $supplierProjectNumber, provisionDescription: $provisionDescription}
  ) {
    additionalAccountingInformation {
      id
      accountingProfileId
      provision
      provisionDescription
      timeTrackingResolution
      clientContractNumber
      clientContratDate
      clientOrderingDate
      clientOrderingNumber
      clientProjectNumber
      supplierProjectNumber
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type CreateProjectAdditionalAccountingInformationMutationFn = Apollo.MutationFunction<CreateProjectAdditionalAccountingInformationMutation, CreateProjectAdditionalAccountingInformationMutationVariables>;

/**
 * __useCreateProjectAdditionalAccountingInformationMutation__
 *
 * To run a mutation, you first call `useCreateProjectAdditionalAccountingInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectAdditionalAccountingInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectAdditionalAccountingInformationMutation, { data, loading, error }] = useCreateProjectAdditionalAccountingInformationMutation({
 *   variables: {
 *      accountingProfileId: // value for 'accountingProfileId'
 *      projectId: // value for 'projectId'
 *      provision: // value for 'provision'
 *      timeTrackingResolution: // value for 'timeTrackingResolution'
 *      clientContractNumber: // value for 'clientContractNumber'
 *      clientContratDate: // value for 'clientContratDate'
 *      clientOrderingDate: // value for 'clientOrderingDate'
 *      clientOrderingNumber: // value for 'clientOrderingNumber'
 *      clientProjectNumber: // value for 'clientProjectNumber'
 *      supplierProjectNumber: // value for 'supplierProjectNumber'
 *      provisionDescription: // value for 'provisionDescription'
 *   },
 * });
 */
export function useCreateProjectAdditionalAccountingInformationMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectAdditionalAccountingInformationMutation, CreateProjectAdditionalAccountingInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectAdditionalAccountingInformationMutation, CreateProjectAdditionalAccountingInformationMutationVariables>(CreateProjectAdditionalAccountingInformationDocument, options);
      }
export type CreateProjectAdditionalAccountingInformationMutationHookResult = ReturnType<typeof useCreateProjectAdditionalAccountingInformationMutation>;
export type CreateProjectAdditionalAccountingInformationMutationResult = Apollo.MutationResult<CreateProjectAdditionalAccountingInformationMutation>;
export type CreateProjectAdditionalAccountingInformationMutationOptions = Apollo.BaseMutationOptions<CreateProjectAdditionalAccountingInformationMutation, CreateProjectAdditionalAccountingInformationMutationVariables>;
export const CreateProjectAdditionalContactInformationDocument = gql`
    mutation CreateProjectAdditionalContactInformation($clientId: ID, $contractorId: ID!, $projectId: ID!, $endCustomer: String) {
  createProjectAdditionalContactInformation(
    input: {clientId: $clientId, contractorId: $contractorId, projectId: $projectId, endCustomer: $endCustomer}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    additionalContactInformation {
      clientId
      contractorId
      endCustomer
      id
    }
  }
}
    `;
export type CreateProjectAdditionalContactInformationMutationFn = Apollo.MutationFunction<CreateProjectAdditionalContactInformationMutation, CreateProjectAdditionalContactInformationMutationVariables>;

/**
 * __useCreateProjectAdditionalContactInformationMutation__
 *
 * To run a mutation, you first call `useCreateProjectAdditionalContactInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectAdditionalContactInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectAdditionalContactInformationMutation, { data, loading, error }] = useCreateProjectAdditionalContactInformationMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      contractorId: // value for 'contractorId'
 *      projectId: // value for 'projectId'
 *      endCustomer: // value for 'endCustomer'
 *   },
 * });
 */
export function useCreateProjectAdditionalContactInformationMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectAdditionalContactInformationMutation, CreateProjectAdditionalContactInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectAdditionalContactInformationMutation, CreateProjectAdditionalContactInformationMutationVariables>(CreateProjectAdditionalContactInformationDocument, options);
      }
export type CreateProjectAdditionalContactInformationMutationHookResult = ReturnType<typeof useCreateProjectAdditionalContactInformationMutation>;
export type CreateProjectAdditionalContactInformationMutationResult = Apollo.MutationResult<CreateProjectAdditionalContactInformationMutation>;
export type CreateProjectAdditionalContactInformationMutationOptions = Apollo.BaseMutationOptions<CreateProjectAdditionalContactInformationMutation, CreateProjectAdditionalContactInformationMutationVariables>;
export const CreateProjectAdditionalContactPersonInformationDocument = gql`
    mutation CreateProjectAdditionalContactPersonInformation($clientContactId: ID, $contractorContactId: ID, $projectId: ID!, $contractorProjectLeaderId: ID) {
  createProjectAdditionalContactPersonInformation(
    input: {clientContactPersonId: $clientContactId, contractorContactPersonId: $contractorContactId, contractorProjectLeaderId: $contractorProjectLeaderId, projectId: $projectId}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errors {
          errorMessage
          propertyName
        }
        errorType
        message
      }
    }
    additionalContactPersonInformation {
      clientContactPersonId
      contractorContactPersonId
      contractorProjectLeaderId
      id
    }
  }
}
    `;
export type CreateProjectAdditionalContactPersonInformationMutationFn = Apollo.MutationFunction<CreateProjectAdditionalContactPersonInformationMutation, CreateProjectAdditionalContactPersonInformationMutationVariables>;

/**
 * __useCreateProjectAdditionalContactPersonInformationMutation__
 *
 * To run a mutation, you first call `useCreateProjectAdditionalContactPersonInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectAdditionalContactPersonInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectAdditionalContactPersonInformationMutation, { data, loading, error }] = useCreateProjectAdditionalContactPersonInformationMutation({
 *   variables: {
 *      clientContactId: // value for 'clientContactId'
 *      contractorContactId: // value for 'contractorContactId'
 *      projectId: // value for 'projectId'
 *      contractorProjectLeaderId: // value for 'contractorProjectLeaderId'
 *   },
 * });
 */
export function useCreateProjectAdditionalContactPersonInformationMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectAdditionalContactPersonInformationMutation, CreateProjectAdditionalContactPersonInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectAdditionalContactPersonInformationMutation, CreateProjectAdditionalContactPersonInformationMutationVariables>(CreateProjectAdditionalContactPersonInformationDocument, options);
      }
export type CreateProjectAdditionalContactPersonInformationMutationHookResult = ReturnType<typeof useCreateProjectAdditionalContactPersonInformationMutation>;
export type CreateProjectAdditionalContactPersonInformationMutationResult = Apollo.MutationResult<CreateProjectAdditionalContactPersonInformationMutation>;
export type CreateProjectAdditionalContactPersonInformationMutationOptions = Apollo.BaseMutationOptions<CreateProjectAdditionalContactPersonInformationMutation, CreateProjectAdditionalContactPersonInformationMutationVariables>;
export const CreateProjectAdditionalPositionInformationDocument = gql`
    mutation CreateProjectAdditionalPositionInformation($hours: Decimal, $pricePerHour: Decimal, $projectId: ID!, $saleableServiceId: String!, $serviceName: String!, $servicePrice: Decimal!, $price: Decimal, $priceRate: ProjectPositionPriceRateType, $accountingProfileId: ID, $description: String) {
  createProjectAdditionalPositionInformation(
    input: {hours: $hours, pricePerHour: $pricePerHour, projectId: $projectId, projectSaleableServiceId: $saleableServiceId, price: $price, priceRate: $priceRate, serviceName: $serviceName, servicePrice: $servicePrice, accountingProfileId: $accountingProfileId, description: $description}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    additionalPositionInformation {
      hours
      id
      pricePerHour
      saleableServiceId
      serviceName
      servicePrice
      price
      priceRate
    }
  }
}
    `;
export type CreateProjectAdditionalPositionInformationMutationFn = Apollo.MutationFunction<CreateProjectAdditionalPositionInformationMutation, CreateProjectAdditionalPositionInformationMutationVariables>;

/**
 * __useCreateProjectAdditionalPositionInformationMutation__
 *
 * To run a mutation, you first call `useCreateProjectAdditionalPositionInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectAdditionalPositionInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectAdditionalPositionInformationMutation, { data, loading, error }] = useCreateProjectAdditionalPositionInformationMutation({
 *   variables: {
 *      hours: // value for 'hours'
 *      pricePerHour: // value for 'pricePerHour'
 *      projectId: // value for 'projectId'
 *      saleableServiceId: // value for 'saleableServiceId'
 *      serviceName: // value for 'serviceName'
 *      servicePrice: // value for 'servicePrice'
 *      price: // value for 'price'
 *      priceRate: // value for 'priceRate'
 *      accountingProfileId: // value for 'accountingProfileId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateProjectAdditionalPositionInformationMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectAdditionalPositionInformationMutation, CreateProjectAdditionalPositionInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectAdditionalPositionInformationMutation, CreateProjectAdditionalPositionInformationMutationVariables>(CreateProjectAdditionalPositionInformationDocument, options);
      }
export type CreateProjectAdditionalPositionInformationMutationHookResult = ReturnType<typeof useCreateProjectAdditionalPositionInformationMutation>;
export type CreateProjectAdditionalPositionInformationMutationResult = Apollo.MutationResult<CreateProjectAdditionalPositionInformationMutation>;
export type CreateProjectAdditionalPositionInformationMutationOptions = Apollo.BaseMutationOptions<CreateProjectAdditionalPositionInformationMutation, CreateProjectAdditionalPositionInformationMutationVariables>;
export const CreateProjectAdditionalTeamMemberInformationDocument = gql`
    mutation CreateProjectAdditionalTeamMemberInformation($projectId: ID!, $memberId: ID, $worksOnPositions: [WorksOnPositionInput!]!, $contractorId: ID) {
  createProjectAdditionalTeamMemberInformation(
    input: {projectId: $projectId, memberId: $memberId, worksOnPositions: $worksOnPositions, contractorId: $contractorId}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    additionalTeamMemberInformation {
      __typename
      employeeId
      id
      worksOnPositions {
        positionId
        pricePerHour
        hours
      }
      employee {
        id
        displayName
      }
    }
  }
}
    `;
export type CreateProjectAdditionalTeamMemberInformationMutationFn = Apollo.MutationFunction<CreateProjectAdditionalTeamMemberInformationMutation, CreateProjectAdditionalTeamMemberInformationMutationVariables>;

/**
 * __useCreateProjectAdditionalTeamMemberInformationMutation__
 *
 * To run a mutation, you first call `useCreateProjectAdditionalTeamMemberInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectAdditionalTeamMemberInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectAdditionalTeamMemberInformationMutation, { data, loading, error }] = useCreateProjectAdditionalTeamMemberInformationMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      memberId: // value for 'memberId'
 *      worksOnPositions: // value for 'worksOnPositions'
 *      contractorId: // value for 'contractorId'
 *   },
 * });
 */
export function useCreateProjectAdditionalTeamMemberInformationMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectAdditionalTeamMemberInformationMutation, CreateProjectAdditionalTeamMemberInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectAdditionalTeamMemberInformationMutation, CreateProjectAdditionalTeamMemberInformationMutationVariables>(CreateProjectAdditionalTeamMemberInformationDocument, options);
      }
export type CreateProjectAdditionalTeamMemberInformationMutationHookResult = ReturnType<typeof useCreateProjectAdditionalTeamMemberInformationMutation>;
export type CreateProjectAdditionalTeamMemberInformationMutationResult = Apollo.MutationResult<CreateProjectAdditionalTeamMemberInformationMutation>;
export type CreateProjectAdditionalTeamMemberInformationMutationOptions = Apollo.BaseMutationOptions<CreateProjectAdditionalTeamMemberInformationMutation, CreateProjectAdditionalTeamMemberInformationMutationVariables>;
export const CreateProjectAdditionalTemplateInformationDocument = gql`
    mutation CreateProjectAdditionalTemplateInformation($projectId: ID!, $isInvoiceWithTimesheet: Boolean!, $isDetailTimesheet: Boolean!) {
  createProjectAdditionalTemplateInformation(
    input: {projectId: $projectId, isInvoiceWithTimesheet: $isInvoiceWithTimesheet, isDetailTimesheet: $isDetailTimesheet}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    additionalTemplateInformation {
      id
      isInvoiceWithTimesheet
      isDetailTimesheet
    }
  }
}
    `;
export type CreateProjectAdditionalTemplateInformationMutationFn = Apollo.MutationFunction<CreateProjectAdditionalTemplateInformationMutation, CreateProjectAdditionalTemplateInformationMutationVariables>;

/**
 * __useCreateProjectAdditionalTemplateInformationMutation__
 *
 * To run a mutation, you first call `useCreateProjectAdditionalTemplateInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectAdditionalTemplateInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectAdditionalTemplateInformationMutation, { data, loading, error }] = useCreateProjectAdditionalTemplateInformationMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      isInvoiceWithTimesheet: // value for 'isInvoiceWithTimesheet'
 *      isDetailTimesheet: // value for 'isDetailTimesheet'
 *   },
 * });
 */
export function useCreateProjectAdditionalTemplateInformationMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectAdditionalTemplateInformationMutation, CreateProjectAdditionalTemplateInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectAdditionalTemplateInformationMutation, CreateProjectAdditionalTemplateInformationMutationVariables>(CreateProjectAdditionalTemplateInformationDocument, options);
      }
export type CreateProjectAdditionalTemplateInformationMutationHookResult = ReturnType<typeof useCreateProjectAdditionalTemplateInformationMutation>;
export type CreateProjectAdditionalTemplateInformationMutationResult = Apollo.MutationResult<CreateProjectAdditionalTemplateInformationMutation>;
export type CreateProjectAdditionalTemplateInformationMutationOptions = Apollo.BaseMutationOptions<CreateProjectAdditionalTemplateInformationMutation, CreateProjectAdditionalTemplateInformationMutationVariables>;
export const CreateProjectSaleableServiceDocument = gql`
    mutation CreateProjectSaleableService($budget: BudgetInput!, $groupId: ID!, $hasFixSellingPrice: Boolean!, $name: String!, $originalServiceId: String!, $purchasePrice: Decimal!, $sellingPrice: Decimal!, $projectId: ID!, $unitId: ID!, $vatRate: Decimal!) {
  createProjectSaleableService(
    input: {budget: $budget, projectSaleableServiceGroupId: $groupId, hasFixSellingPrice: $hasFixSellingPrice, name: $name, originalServiceId: $originalServiceId, purchasePrice: $purchasePrice, sellingPrice: $sellingPrice, projectId: $projectId, projectSaleableUnitId: $unitId, vatRate: $vatRate}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    projectSaleableService {
      hasFixSellingPrice
      id
      originalId
      name
      purchasePrice
      sellingPrice
      vatRate
      budget {
        amount
        hasAmountLimit
        hasTimeLimit
        hours
      }
      unit {
        id
        originalId
        name
        shortCode
      }
    }
  }
}
    `;
export type CreateProjectSaleableServiceMutationFn = Apollo.MutationFunction<CreateProjectSaleableServiceMutation, CreateProjectSaleableServiceMutationVariables>;

/**
 * __useCreateProjectSaleableServiceMutation__
 *
 * To run a mutation, you first call `useCreateProjectSaleableServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectSaleableServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectSaleableServiceMutation, { data, loading, error }] = useCreateProjectSaleableServiceMutation({
 *   variables: {
 *      budget: // value for 'budget'
 *      groupId: // value for 'groupId'
 *      hasFixSellingPrice: // value for 'hasFixSellingPrice'
 *      name: // value for 'name'
 *      originalServiceId: // value for 'originalServiceId'
 *      purchasePrice: // value for 'purchasePrice'
 *      sellingPrice: // value for 'sellingPrice'
 *      projectId: // value for 'projectId'
 *      unitId: // value for 'unitId'
 *      vatRate: // value for 'vatRate'
 *   },
 * });
 */
export function useCreateProjectSaleableServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectSaleableServiceMutation, CreateProjectSaleableServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectSaleableServiceMutation, CreateProjectSaleableServiceMutationVariables>(CreateProjectSaleableServiceDocument, options);
      }
export type CreateProjectSaleableServiceMutationHookResult = ReturnType<typeof useCreateProjectSaleableServiceMutation>;
export type CreateProjectSaleableServiceMutationResult = Apollo.MutationResult<CreateProjectSaleableServiceMutation>;
export type CreateProjectSaleableServiceMutationOptions = Apollo.BaseMutationOptions<CreateProjectSaleableServiceMutation, CreateProjectSaleableServiceMutationVariables>;
export const CreateProjectSaleableServiceGroupDocument = gql`
    mutation CreateProjectSaleableServiceGroup($budget: BudgetInput!, $hasFixSellingPrice: Boolean!, $name: String!, $originalGroupId: String!, $sellingPrice: Decimal!, $projectId: ID!) {
  createProjectSaleableServiceGroup(
    input: {budget: $budget, hasFixSellingPrice: $hasFixSellingPrice, name: $name, originalGroupId: $originalGroupId, sellingPrice: $sellingPrice, projectId: $projectId}
  ) {
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on DomainError {
        errorType
        message
      }
    }
    projectSaleableServiceGroup {
      hasFixSellingPrice
      id
      originalId
      name
      sellingPrice
      budget {
        amount
        hasAmountLimit
        hasTimeLimit
        hours
      }
      services {
        hasFixSellingPrice
        id
        originalId
        name
        purchasePrice
        sellingPrice
        vatRate
        budget {
          amount
          hasAmountLimit
          hasTimeLimit
          hours
        }
        unit {
          id
          originalId
          name
          shortCode
        }
      }
    }
  }
}
    `;
export type CreateProjectSaleableServiceGroupMutationFn = Apollo.MutationFunction<CreateProjectSaleableServiceGroupMutation, CreateProjectSaleableServiceGroupMutationVariables>;

/**
 * __useCreateProjectSaleableServiceGroupMutation__
 *
 * To run a mutation, you first call `useCreateProjectSaleableServiceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectSaleableServiceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectSaleableServiceGroupMutation, { data, loading, error }] = useCreateProjectSaleableServiceGroupMutation({
 *   variables: {
 *      budget: // value for 'budget'
 *      hasFixSellingPrice: // value for 'hasFixSellingPrice'
 *      name: // value for 'name'
 *      originalGroupId: // value for 'originalGroupId'
 *      sellingPrice: // value for 'sellingPrice'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateProjectSaleableServiceGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectSaleableServiceGroupMutation, CreateProjectSaleableServiceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectSaleableServiceGroupMutation, CreateProjectSaleableServiceGroupMutationVariables>(CreateProjectSaleableServiceGroupDocument, options);
      }
export type CreateProjectSaleableServiceGroupMutationHookResult = ReturnType<typeof useCreateProjectSaleableServiceGroupMutation>;
export type CreateProjectSaleableServiceGroupMutationResult = Apollo.MutationResult<CreateProjectSaleableServiceGroupMutation>;
export type CreateProjectSaleableServiceGroupMutationOptions = Apollo.BaseMutationOptions<CreateProjectSaleableServiceGroupMutation, CreateProjectSaleableServiceGroupMutationVariables>;
export const CreateProjectSaleableUnitDocument = gql`
    mutation CreateProjectSaleableUnit($name: String!, $originalUnitId: String!, $shortCode: String!, $projectId: ID!) {
  createProjectSaleableUnit(
    input: {name: $name, originalUnitId: $originalUnitId, shortCode: $shortCode, projectId: $projectId}
  ) {
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on DomainError {
        errorType
        message
      }
    }
    projectSaleableUnit {
      id
      originalId
      name
      shortCode
    }
  }
}
    `;
export type CreateProjectSaleableUnitMutationFn = Apollo.MutationFunction<CreateProjectSaleableUnitMutation, CreateProjectSaleableUnitMutationVariables>;

/**
 * __useCreateProjectSaleableUnitMutation__
 *
 * To run a mutation, you first call `useCreateProjectSaleableUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectSaleableUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectSaleableUnitMutation, { data, loading, error }] = useCreateProjectSaleableUnitMutation({
 *   variables: {
 *      name: // value for 'name'
 *      originalUnitId: // value for 'originalUnitId'
 *      shortCode: // value for 'shortCode'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateProjectSaleableUnitMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectSaleableUnitMutation, CreateProjectSaleableUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectSaleableUnitMutation, CreateProjectSaleableUnitMutationVariables>(CreateProjectSaleableUnitDocument, options);
      }
export type CreateProjectSaleableUnitMutationHookResult = ReturnType<typeof useCreateProjectSaleableUnitMutation>;
export type CreateProjectSaleableUnitMutationResult = Apollo.MutationResult<CreateProjectSaleableUnitMutation>;
export type CreateProjectSaleableUnitMutationOptions = Apollo.BaseMutationOptions<CreateProjectSaleableUnitMutation, CreateProjectSaleableUnitMutationVariables>;
export const DeleteProjectDocument = gql`
    mutation DeleteProject($id: ID!) {
  deleteProject(input: {projectId: $id}) {
    boolean
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on DomainError {
        errorType
        message
      }
    }
  }
}
    `;
export type DeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, options);
      }
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const DeleteProjectAdditionalInformationDocument = gql`
    mutation DeleteProjectAdditionalInformation($informationId: ID!, $projectId: ID!) {
  deleteProjectAdditionalInformation(
    input: {projectInformationId: $informationId, projectId: $projectId}
  ) {
    boolean
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type DeleteProjectAdditionalInformationMutationFn = Apollo.MutationFunction<DeleteProjectAdditionalInformationMutation, DeleteProjectAdditionalInformationMutationVariables>;

/**
 * __useDeleteProjectAdditionalInformationMutation__
 *
 * To run a mutation, you first call `useDeleteProjectAdditionalInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectAdditionalInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectAdditionalInformationMutation, { data, loading, error }] = useDeleteProjectAdditionalInformationMutation({
 *   variables: {
 *      informationId: // value for 'informationId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteProjectAdditionalInformationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectAdditionalInformationMutation, DeleteProjectAdditionalInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectAdditionalInformationMutation, DeleteProjectAdditionalInformationMutationVariables>(DeleteProjectAdditionalInformationDocument, options);
      }
export type DeleteProjectAdditionalInformationMutationHookResult = ReturnType<typeof useDeleteProjectAdditionalInformationMutation>;
export type DeleteProjectAdditionalInformationMutationResult = Apollo.MutationResult<DeleteProjectAdditionalInformationMutation>;
export type DeleteProjectAdditionalInformationMutationOptions = Apollo.BaseMutationOptions<DeleteProjectAdditionalInformationMutation, DeleteProjectAdditionalInformationMutationVariables>;
export const DeleteProjectSaleableServiceDocument = gql`
    mutation DeleteProjectSaleableService($serviceId: ID!, $projectId: ID!) {
  deleteProjectSaleableService(
    input: {projectSaleableServiceId: $serviceId, projectId: $projectId}
  ) {
    boolean
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type DeleteProjectSaleableServiceMutationFn = Apollo.MutationFunction<DeleteProjectSaleableServiceMutation, DeleteProjectSaleableServiceMutationVariables>;

/**
 * __useDeleteProjectSaleableServiceMutation__
 *
 * To run a mutation, you first call `useDeleteProjectSaleableServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectSaleableServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectSaleableServiceMutation, { data, loading, error }] = useDeleteProjectSaleableServiceMutation({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteProjectSaleableServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectSaleableServiceMutation, DeleteProjectSaleableServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectSaleableServiceMutation, DeleteProjectSaleableServiceMutationVariables>(DeleteProjectSaleableServiceDocument, options);
      }
export type DeleteProjectSaleableServiceMutationHookResult = ReturnType<typeof useDeleteProjectSaleableServiceMutation>;
export type DeleteProjectSaleableServiceMutationResult = Apollo.MutationResult<DeleteProjectSaleableServiceMutation>;
export type DeleteProjectSaleableServiceMutationOptions = Apollo.BaseMutationOptions<DeleteProjectSaleableServiceMutation, DeleteProjectSaleableServiceMutationVariables>;
export const DeleteProjectSaleableServiceGroupDocument = gql`
    mutation DeleteProjectSaleableServiceGroup($serviceGroupId: ID!, $projectId: ID!) {
  deleteProjectSaleableServiceGroup(
    input: {projectSaleableServiceGroupId: $serviceGroupId, projectId: $projectId}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    boolean
  }
}
    `;
export type DeleteProjectSaleableServiceGroupMutationFn = Apollo.MutationFunction<DeleteProjectSaleableServiceGroupMutation, DeleteProjectSaleableServiceGroupMutationVariables>;

/**
 * __useDeleteProjectSaleableServiceGroupMutation__
 *
 * To run a mutation, you first call `useDeleteProjectSaleableServiceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectSaleableServiceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectSaleableServiceGroupMutation, { data, loading, error }] = useDeleteProjectSaleableServiceGroupMutation({
 *   variables: {
 *      serviceGroupId: // value for 'serviceGroupId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteProjectSaleableServiceGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectSaleableServiceGroupMutation, DeleteProjectSaleableServiceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectSaleableServiceGroupMutation, DeleteProjectSaleableServiceGroupMutationVariables>(DeleteProjectSaleableServiceGroupDocument, options);
      }
export type DeleteProjectSaleableServiceGroupMutationHookResult = ReturnType<typeof useDeleteProjectSaleableServiceGroupMutation>;
export type DeleteProjectSaleableServiceGroupMutationResult = Apollo.MutationResult<DeleteProjectSaleableServiceGroupMutation>;
export type DeleteProjectSaleableServiceGroupMutationOptions = Apollo.BaseMutationOptions<DeleteProjectSaleableServiceGroupMutation, DeleteProjectSaleableServiceGroupMutationVariables>;
export const DeleteProjectSaleableServiceUnitDocument = gql`
    mutation DeleteProjectSaleableServiceUnit($unitId: ID!, $projectId: ID!) {
  deleteProjectSaleableUnit(
    input: {projectId: $projectId, projectSaleableUnitId: $unitId}
  ) {
    boolean
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on DomainError {
        errorType
        message
      }
    }
  }
}
    `;
export type DeleteProjectSaleableServiceUnitMutationFn = Apollo.MutationFunction<DeleteProjectSaleableServiceUnitMutation, DeleteProjectSaleableServiceUnitMutationVariables>;

/**
 * __useDeleteProjectSaleableServiceUnitMutation__
 *
 * To run a mutation, you first call `useDeleteProjectSaleableServiceUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectSaleableServiceUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectSaleableServiceUnitMutation, { data, loading, error }] = useDeleteProjectSaleableServiceUnitMutation({
 *   variables: {
 *      unitId: // value for 'unitId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteProjectSaleableServiceUnitMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectSaleableServiceUnitMutation, DeleteProjectSaleableServiceUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectSaleableServiceUnitMutation, DeleteProjectSaleableServiceUnitMutationVariables>(DeleteProjectSaleableServiceUnitDocument, options);
      }
export type DeleteProjectSaleableServiceUnitMutationHookResult = ReturnType<typeof useDeleteProjectSaleableServiceUnitMutation>;
export type DeleteProjectSaleableServiceUnitMutationResult = Apollo.MutationResult<DeleteProjectSaleableServiceUnitMutation>;
export type DeleteProjectSaleableServiceUnitMutationOptions = Apollo.BaseMutationOptions<DeleteProjectSaleableServiceUnitMutation, DeleteProjectSaleableServiceUnitMutationVariables>;
export const DeleteTimeApprovalDocument = gql`
    mutation DeleteTimeApproval($description: String, $projectTimeApprovalId: ID!) {
  deleteTimeApproval(
    input: {description: $description, projectTimeApprovalId: $projectTimeApprovalId}
  ) {
    boolean
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type DeleteTimeApprovalMutationFn = Apollo.MutationFunction<DeleteTimeApprovalMutation, DeleteTimeApprovalMutationVariables>;

/**
 * __useDeleteTimeApprovalMutation__
 *
 * To run a mutation, you first call `useDeleteTimeApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeApprovalMutation, { data, loading, error }] = useDeleteTimeApprovalMutation({
 *   variables: {
 *      description: // value for 'description'
 *      projectTimeApprovalId: // value for 'projectTimeApprovalId'
 *   },
 * });
 */
export function useDeleteTimeApprovalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeApprovalMutation, DeleteTimeApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTimeApprovalMutation, DeleteTimeApprovalMutationVariables>(DeleteTimeApprovalDocument, options);
      }
export type DeleteTimeApprovalMutationHookResult = ReturnType<typeof useDeleteTimeApprovalMutation>;
export type DeleteTimeApprovalMutationResult = Apollo.MutationResult<DeleteTimeApprovalMutation>;
export type DeleteTimeApprovalMutationOptions = Apollo.BaseMutationOptions<DeleteTimeApprovalMutation, DeleteTimeApprovalMutationVariables>;
export const DownloadTimeSheetDocument = gql`
    query DownloadTimeSheet($projectTimeApprovalId: ID!) {
  downloadTimeSheet(projectTimeApprovalId: $projectTimeApprovalId)
}
    `;

/**
 * __useDownloadTimeSheetQuery__
 *
 * To run a query within a React component, call `useDownloadTimeSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadTimeSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadTimeSheetQuery({
 *   variables: {
 *      projectTimeApprovalId: // value for 'projectTimeApprovalId'
 *   },
 * });
 */
export function useDownloadTimeSheetQuery(baseOptions: Apollo.QueryHookOptions<DownloadTimeSheetQuery, DownloadTimeSheetQueryVariables> & ({ variables: DownloadTimeSheetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadTimeSheetQuery, DownloadTimeSheetQueryVariables>(DownloadTimeSheetDocument, options);
      }
export function useDownloadTimeSheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadTimeSheetQuery, DownloadTimeSheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadTimeSheetQuery, DownloadTimeSheetQueryVariables>(DownloadTimeSheetDocument, options);
        }
export function useDownloadTimeSheetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadTimeSheetQuery, DownloadTimeSheetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadTimeSheetQuery, DownloadTimeSheetQueryVariables>(DownloadTimeSheetDocument, options);
        }
export type DownloadTimeSheetQueryHookResult = ReturnType<typeof useDownloadTimeSheetQuery>;
export type DownloadTimeSheetLazyQueryHookResult = ReturnType<typeof useDownloadTimeSheetLazyQuery>;
export type DownloadTimeSheetSuspenseQueryHookResult = ReturnType<typeof useDownloadTimeSheetSuspenseQuery>;
export type DownloadTimeSheetQueryResult = Apollo.QueryResult<DownloadTimeSheetQuery, DownloadTimeSheetQueryVariables>;
export const GetAllClientProjectsDocument = gql`
    query GetAllClientProjects($clientId: ID!, $first: Int, $after: String, $name: String) {
  allProjectIdsOfClient(
    clientId: $clientId
    filter: {filterByName: $name}
    first: $first
    after: $after
  ) {
    nodes {
      id
      name
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllClientProjectsQuery__
 *
 * To run a query within a React component, call `useGetAllClientProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllClientProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllClientProjectsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetAllClientProjectsQuery(baseOptions: Apollo.QueryHookOptions<GetAllClientProjectsQuery, GetAllClientProjectsQueryVariables> & ({ variables: GetAllClientProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllClientProjectsQuery, GetAllClientProjectsQueryVariables>(GetAllClientProjectsDocument, options);
      }
export function useGetAllClientProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllClientProjectsQuery, GetAllClientProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllClientProjectsQuery, GetAllClientProjectsQueryVariables>(GetAllClientProjectsDocument, options);
        }
export function useGetAllClientProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllClientProjectsQuery, GetAllClientProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllClientProjectsQuery, GetAllClientProjectsQueryVariables>(GetAllClientProjectsDocument, options);
        }
export type GetAllClientProjectsQueryHookResult = ReturnType<typeof useGetAllClientProjectsQuery>;
export type GetAllClientProjectsLazyQueryHookResult = ReturnType<typeof useGetAllClientProjectsLazyQuery>;
export type GetAllClientProjectsSuspenseQueryHookResult = ReturnType<typeof useGetAllClientProjectsSuspenseQuery>;
export type GetAllClientProjectsQueryResult = Apollo.QueryResult<GetAllClientProjectsQuery, GetAllClientProjectsQueryVariables>;
export const GetAllProjectTimeEntriesDocument = gql`
    query GetAllProjectTimeEntries($startDate: LocalDate!, $endDate: LocalDate!, $employeeId: ID!, $projectId: ID!) {
  allProjectTimeEntries(
    filter: {endDate: $endDate, startDate: $startDate, employeeId: $employeeId, projectId: $projectId}
  ) {
    absenceReason
    approvedWorkingMinutes
    date
    errors
    id
    items {
      createdById
      description
      end
      errors
      id
      memberId
      projectId
      projectPositionId
      start
      status
      timestamp
      version
      createdBy {
        id
        displayName
      }
      history {
        createdById
        description
        end
        memberId
        projectId
        projectPositionId
        start
        status
        timestamp
        version
        createdBy {
          id
          displayName
        }
        member {
          id
          displayName
        }
        projectPosition {
          projectName
          saleableServiceName
        }
      }
      logs {
        createdById
        id
        message
        timestamp
        createdBy {
          id
          displayName
        }
      }
      member {
        id
        displayName
      }
    }
    pendingWorkingMinutes
    rejectedWorkingMinutes
    requiredWorkingMinutes
    workingMinutes
  }
}
    `;

/**
 * __useGetAllProjectTimeEntriesQuery__
 *
 * To run a query within a React component, call `useGetAllProjectTimeEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProjectTimeEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProjectTimeEntriesQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      employeeId: // value for 'employeeId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetAllProjectTimeEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetAllProjectTimeEntriesQuery, GetAllProjectTimeEntriesQueryVariables> & ({ variables: GetAllProjectTimeEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProjectTimeEntriesQuery, GetAllProjectTimeEntriesQueryVariables>(GetAllProjectTimeEntriesDocument, options);
      }
export function useGetAllProjectTimeEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProjectTimeEntriesQuery, GetAllProjectTimeEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProjectTimeEntriesQuery, GetAllProjectTimeEntriesQueryVariables>(GetAllProjectTimeEntriesDocument, options);
        }
export function useGetAllProjectTimeEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllProjectTimeEntriesQuery, GetAllProjectTimeEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllProjectTimeEntriesQuery, GetAllProjectTimeEntriesQueryVariables>(GetAllProjectTimeEntriesDocument, options);
        }
export type GetAllProjectTimeEntriesQueryHookResult = ReturnType<typeof useGetAllProjectTimeEntriesQuery>;
export type GetAllProjectTimeEntriesLazyQueryHookResult = ReturnType<typeof useGetAllProjectTimeEntriesLazyQuery>;
export type GetAllProjectTimeEntriesSuspenseQueryHookResult = ReturnType<typeof useGetAllProjectTimeEntriesSuspenseQuery>;
export type GetAllProjectTimeEntriesQueryResult = Apollo.QueryResult<GetAllProjectTimeEntriesQuery, GetAllProjectTimeEntriesQueryVariables>;
export const GetAllProjectsDocument = gql`
    query GetAllProjects($first: Int, $after: String, $type: ProjectType, $name: String, $order: OrderType, $showDeleted: Boolean, $status: ProjectStatus) {
  allRootProjects(
    filter: {filterByType: $type, filterByName: $name, showDeleted: $showDeleted, order: $order, filterByStatus: $status}
    first: $first
    after: $after
  ) {
    nodes {
      id
      isDeleted
      name
      number
      budget {
        amount
        hasAmountLimit
        hasTimeLimit
        hours
      }
      range {
        from
        to
      }
      path
      isRoot
      isGroup
      projectType
      status
      createdById
      parentProjectId
      timestamp
      createdBy {
        id
        displayName
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllProjectsQuery__
 *
 * To run a query within a React component, call `useGetAllProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProjectsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      order: // value for 'order'
 *      showDeleted: // value for 'showDeleted'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetAllProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProjectsQuery, GetAllProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProjectsQuery, GetAllProjectsQueryVariables>(GetAllProjectsDocument, options);
      }
export function useGetAllProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProjectsQuery, GetAllProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProjectsQuery, GetAllProjectsQueryVariables>(GetAllProjectsDocument, options);
        }
export function useGetAllProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllProjectsQuery, GetAllProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllProjectsQuery, GetAllProjectsQueryVariables>(GetAllProjectsDocument, options);
        }
export type GetAllProjectsQueryHookResult = ReturnType<typeof useGetAllProjectsQuery>;
export type GetAllProjectsLazyQueryHookResult = ReturnType<typeof useGetAllProjectsLazyQuery>;
export type GetAllProjectsSuspenseQueryHookResult = ReturnType<typeof useGetAllProjectsSuspenseQuery>;
export type GetAllProjectsQueryResult = Apollo.QueryResult<GetAllProjectsQuery, GetAllProjectsQueryVariables>;
export const GetAllProjectsNameDocument = gql`
    query GetAllProjectsName($first: Int, $after: String, $type: ProjectType, $name: String, $order: OrderType, $showDeleted: Boolean) {
  allProjects(
    filter: {filterByType: $type, filterByName: $name, showDeleted: $showDeleted, order: $order}
    first: $first
    after: $after
  ) {
    nodes {
      id
      name
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllProjectsNameQuery__
 *
 * To run a query within a React component, call `useGetAllProjectsNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProjectsNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProjectsNameQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      order: // value for 'order'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useGetAllProjectsNameQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProjectsNameQuery, GetAllProjectsNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProjectsNameQuery, GetAllProjectsNameQueryVariables>(GetAllProjectsNameDocument, options);
      }
export function useGetAllProjectsNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProjectsNameQuery, GetAllProjectsNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProjectsNameQuery, GetAllProjectsNameQueryVariables>(GetAllProjectsNameDocument, options);
        }
export function useGetAllProjectsNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllProjectsNameQuery, GetAllProjectsNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllProjectsNameQuery, GetAllProjectsNameQueryVariables>(GetAllProjectsNameDocument, options);
        }
export type GetAllProjectsNameQueryHookResult = ReturnType<typeof useGetAllProjectsNameQuery>;
export type GetAllProjectsNameLazyQueryHookResult = ReturnType<typeof useGetAllProjectsNameLazyQuery>;
export type GetAllProjectsNameSuspenseQueryHookResult = ReturnType<typeof useGetAllProjectsNameSuspenseQuery>;
export type GetAllProjectsNameQueryResult = Apollo.QueryResult<GetAllProjectsNameQuery, GetAllProjectsNameQueryVariables>;
export const GetAllProjectsPlainDocument = gql`
    query GetAllProjectsPlain($first: Int, $after: String, $type: ProjectType, $name: String, $order: OrderType, $showDeleted: Boolean) {
  allProjects(
    filter: {filterByType: $type, filterByName: $name, showDeleted: $showDeleted, order: $order}
    first: $first
    after: $after
  ) {
    nodes {
      id
      isDeleted
      name
      number
      budget {
        amount
        hasAmountLimit
        hasTimeLimit
        hours
      }
      range {
        from
        to
      }
      path
      isRoot
      isGroup
      projectType
      status
      createdById
      parentProjectId
      timestamp
      createdBy {
        id
        displayName
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllProjectsPlainQuery__
 *
 * To run a query within a React component, call `useGetAllProjectsPlainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProjectsPlainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProjectsPlainQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      order: // value for 'order'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useGetAllProjectsPlainQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProjectsPlainQuery, GetAllProjectsPlainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProjectsPlainQuery, GetAllProjectsPlainQueryVariables>(GetAllProjectsPlainDocument, options);
      }
export function useGetAllProjectsPlainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProjectsPlainQuery, GetAllProjectsPlainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProjectsPlainQuery, GetAllProjectsPlainQueryVariables>(GetAllProjectsPlainDocument, options);
        }
export function useGetAllProjectsPlainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllProjectsPlainQuery, GetAllProjectsPlainQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllProjectsPlainQuery, GetAllProjectsPlainQueryVariables>(GetAllProjectsPlainDocument, options);
        }
export type GetAllProjectsPlainQueryHookResult = ReturnType<typeof useGetAllProjectsPlainQuery>;
export type GetAllProjectsPlainLazyQueryHookResult = ReturnType<typeof useGetAllProjectsPlainLazyQuery>;
export type GetAllProjectsPlainSuspenseQueryHookResult = ReturnType<typeof useGetAllProjectsPlainSuspenseQuery>;
export type GetAllProjectsPlainQueryResult = Apollo.QueryResult<GetAllProjectsPlainQuery, GetAllProjectsPlainQueryVariables>;
export const GetAllRootProjectSummariesDocument = gql`
    query GetAllRootProjectSummaries($first: Int, $after: String, $type: ProjectType, $name: String, $order: OrderType, $showDeleted: Boolean, $clientId: ID, $status: ProjectStatus) {
  allRootProjects(
    filter: {filterByType: $type, filterByName: $name, showDeleted: $showDeleted, order: $order, filterByClientId: $clientId, filterByStatus: $status}
    first: $first
    after: $after
  ) {
    nodes {
      id
      isDeleted
      name
      number
      validationStatus
      budget {
        amount
        hasAmountLimit
        hasTimeLimit
        hours
      }
      budgetStatus {
        totalBudgetAmount
        totalBudgetMinutes
        spentAmount
        spentMinutes
        remainingAmount
        remainingMinutes
        utilizationPercent
        openMinutes
        pendingMinutes
        approvedMinutes
      }
      range {
        from
        to
      }
      path
      isRoot
      isGroup
      projectType
      status
      isManualStatusOverride
      createdById
      parentProjectId
      parentProjectName
      timestamp
      client {
        id
        displayName
      }
      contractor {
        id
        displayName
      }
      createdBy {
        id
        displayName
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllRootProjectSummariesQuery__
 *
 * To run a query within a React component, call `useGetAllRootProjectSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRootProjectSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRootProjectSummariesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      order: // value for 'order'
 *      showDeleted: // value for 'showDeleted'
 *      clientId: // value for 'clientId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetAllRootProjectSummariesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRootProjectSummariesQuery, GetAllRootProjectSummariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRootProjectSummariesQuery, GetAllRootProjectSummariesQueryVariables>(GetAllRootProjectSummariesDocument, options);
      }
export function useGetAllRootProjectSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRootProjectSummariesQuery, GetAllRootProjectSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRootProjectSummariesQuery, GetAllRootProjectSummariesQueryVariables>(GetAllRootProjectSummariesDocument, options);
        }
export function useGetAllRootProjectSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRootProjectSummariesQuery, GetAllRootProjectSummariesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRootProjectSummariesQuery, GetAllRootProjectSummariesQueryVariables>(GetAllRootProjectSummariesDocument, options);
        }
export type GetAllRootProjectSummariesQueryHookResult = ReturnType<typeof useGetAllRootProjectSummariesQuery>;
export type GetAllRootProjectSummariesLazyQueryHookResult = ReturnType<typeof useGetAllRootProjectSummariesLazyQuery>;
export type GetAllRootProjectSummariesSuspenseQueryHookResult = ReturnType<typeof useGetAllRootProjectSummariesSuspenseQuery>;
export type GetAllRootProjectSummariesQueryResult = Apollo.QueryResult<GetAllRootProjectSummariesQuery, GetAllRootProjectSummariesQueryVariables>;
export const GetAllSubProjectsDocument = gql`
    query GetAllSubProjects($projectId: ID!, $showDeleted: Boolean) {
  allSubProjects(projectId: $projectId, filter: {showDeleted: $showDeleted}) {
    id
    isDeleted
    name
    number
    validationStatus
    budget {
      amount
      hasAmountLimit
      hasTimeLimit
      hours
    }
    budgetStatus {
      totalBudgetAmount
      totalBudgetMinutes
      spentAmount
      spentMinutes
      remainingAmount
      remainingMinutes
      utilizationPercent
      openMinutes
      pendingMinutes
      approvedMinutes
    }
    range {
      from
      to
    }
    path
    isRoot
    isGroup
    projectType
    status
    isManualStatusOverride
    createdById
    parentProjectId
    parentProjectName
    timestamp
    client {
      id
      displayName
    }
    contractor {
      id
      displayName
    }
    createdBy {
      id
      displayName
    }
  }
}
    `;

/**
 * __useGetAllSubProjectsQuery__
 *
 * To run a query within a React component, call `useGetAllSubProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSubProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSubProjectsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useGetAllSubProjectsQuery(baseOptions: Apollo.QueryHookOptions<GetAllSubProjectsQuery, GetAllSubProjectsQueryVariables> & ({ variables: GetAllSubProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSubProjectsQuery, GetAllSubProjectsQueryVariables>(GetAllSubProjectsDocument, options);
      }
export function useGetAllSubProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSubProjectsQuery, GetAllSubProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSubProjectsQuery, GetAllSubProjectsQueryVariables>(GetAllSubProjectsDocument, options);
        }
export function useGetAllSubProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllSubProjectsQuery, GetAllSubProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllSubProjectsQuery, GetAllSubProjectsQueryVariables>(GetAllSubProjectsDocument, options);
        }
export type GetAllSubProjectsQueryHookResult = ReturnType<typeof useGetAllSubProjectsQuery>;
export type GetAllSubProjectsLazyQueryHookResult = ReturnType<typeof useGetAllSubProjectsLazyQuery>;
export type GetAllSubProjectsSuspenseQueryHookResult = ReturnType<typeof useGetAllSubProjectsSuspenseQuery>;
export type GetAllSubProjectsQueryResult = Apollo.QueryResult<GetAllSubProjectsQuery, GetAllSubProjectsQueryVariables>;
export const GetAllTimeApprovalsDocument = gql`
    query GetAllTimeApprovals($employeeId: ID, $first: Int, $last: Int, $after: String, $before: String, $start: LocalDate!, $end: LocalDate!, $projectId: ID, $search: String, $statuses: [ApprovalTimeEntryStatus!]) {
  allTimeApprovals(
    first: $first
    employeeId: $employeeId
    after: $after
    before: $before
    last: $last
    end: $end
    projectId: $projectId
    start: $start
    searchByNumber: $search
    statuses: $statuses
  ) {
    totalCount
    nodes {
      id
      createdBy {
        id
        displayName
      }
      timestamp
      history {
        createdById
        createdBy {
          id
          displayName
        }
        timestamp
        description
        status
      }
      description
      employee {
        id
        displayName
      }
      number
      project {
        id
        name
      }
      status
      totalMinutes
      from
      to
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetAllTimeApprovalsQuery__
 *
 * To run a query within a React component, call `useGetAllTimeApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTimeApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTimeApprovalsQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      projectId: // value for 'projectId'
 *      search: // value for 'search'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useGetAllTimeApprovalsQuery(baseOptions: Apollo.QueryHookOptions<GetAllTimeApprovalsQuery, GetAllTimeApprovalsQueryVariables> & ({ variables: GetAllTimeApprovalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTimeApprovalsQuery, GetAllTimeApprovalsQueryVariables>(GetAllTimeApprovalsDocument, options);
      }
export function useGetAllTimeApprovalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTimeApprovalsQuery, GetAllTimeApprovalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTimeApprovalsQuery, GetAllTimeApprovalsQueryVariables>(GetAllTimeApprovalsDocument, options);
        }
export function useGetAllTimeApprovalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTimeApprovalsQuery, GetAllTimeApprovalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTimeApprovalsQuery, GetAllTimeApprovalsQueryVariables>(GetAllTimeApprovalsDocument, options);
        }
export type GetAllTimeApprovalsQueryHookResult = ReturnType<typeof useGetAllTimeApprovalsQuery>;
export type GetAllTimeApprovalsLazyQueryHookResult = ReturnType<typeof useGetAllTimeApprovalsLazyQuery>;
export type GetAllTimeApprovalsSuspenseQueryHookResult = ReturnType<typeof useGetAllTimeApprovalsSuspenseQuery>;
export type GetAllTimeApprovalsQueryResult = Apollo.QueryResult<GetAllTimeApprovalsQuery, GetAllTimeApprovalsQueryVariables>;
export const GetAvailableServicesForProjectDocument = gql`
    query GetAvailableServicesForProject($projectId: ID!) {
  availableServicesForProject(projectId: $projectId) {
    name
    services {
      name
      price
      unitName
      id
      budget {
        amount
        hasAmountLimit
        hasTimeLimit
        hours
      }
      hasFixSellingPrice
      purchasePrice
      sellingPrice
      vatRate
    }
    id
  }
}
    `;

/**
 * __useGetAvailableServicesForProjectQuery__
 *
 * To run a query within a React component, call `useGetAvailableServicesForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableServicesForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableServicesForProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetAvailableServicesForProjectQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableServicesForProjectQuery, GetAvailableServicesForProjectQueryVariables> & ({ variables: GetAvailableServicesForProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableServicesForProjectQuery, GetAvailableServicesForProjectQueryVariables>(GetAvailableServicesForProjectDocument, options);
      }
export function useGetAvailableServicesForProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableServicesForProjectQuery, GetAvailableServicesForProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableServicesForProjectQuery, GetAvailableServicesForProjectQueryVariables>(GetAvailableServicesForProjectDocument, options);
        }
export function useGetAvailableServicesForProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableServicesForProjectQuery, GetAvailableServicesForProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableServicesForProjectQuery, GetAvailableServicesForProjectQueryVariables>(GetAvailableServicesForProjectDocument, options);
        }
export type GetAvailableServicesForProjectQueryHookResult = ReturnType<typeof useGetAvailableServicesForProjectQuery>;
export type GetAvailableServicesForProjectLazyQueryHookResult = ReturnType<typeof useGetAvailableServicesForProjectLazyQuery>;
export type GetAvailableServicesForProjectSuspenseQueryHookResult = ReturnType<typeof useGetAvailableServicesForProjectSuspenseQuery>;
export type GetAvailableServicesForProjectQueryResult = Apollo.QueryResult<GetAvailableServicesForProjectQuery, GetAvailableServicesForProjectQueryVariables>;
export const GetMyAllProjectPositionDocument = gql`
    query GetMyAllProjectPosition($startDate: LocalDate!, $endDate: LocalDate!) {
  myAllProjectPosition(input: {endDate: $endDate, startDate: $startDate}) {
    client {
      id
      displayName
    }
    contractor {
      id
      displayName
    }
    projectLeader {
      id
      displayName
      additionalInformation {
        id
        __typename
        ... on EmailInformation {
          emailType
          emailAddress
        }
      }
    }
    end
    projectId
    isProjectInvalid
    projectName
    start
    timeTrackingResolution
    positions {
      projectPositionId
      saleableServiceName
    }
  }
}
    `;

/**
 * __useGetMyAllProjectPositionQuery__
 *
 * To run a query within a React component, call `useGetMyAllProjectPositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAllProjectPositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAllProjectPositionQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetMyAllProjectPositionQuery(baseOptions: Apollo.QueryHookOptions<GetMyAllProjectPositionQuery, GetMyAllProjectPositionQueryVariables> & ({ variables: GetMyAllProjectPositionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAllProjectPositionQuery, GetMyAllProjectPositionQueryVariables>(GetMyAllProjectPositionDocument, options);
      }
export function useGetMyAllProjectPositionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAllProjectPositionQuery, GetMyAllProjectPositionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAllProjectPositionQuery, GetMyAllProjectPositionQueryVariables>(GetMyAllProjectPositionDocument, options);
        }
export function useGetMyAllProjectPositionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyAllProjectPositionQuery, GetMyAllProjectPositionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyAllProjectPositionQuery, GetMyAllProjectPositionQueryVariables>(GetMyAllProjectPositionDocument, options);
        }
export type GetMyAllProjectPositionQueryHookResult = ReturnType<typeof useGetMyAllProjectPositionQuery>;
export type GetMyAllProjectPositionLazyQueryHookResult = ReturnType<typeof useGetMyAllProjectPositionLazyQuery>;
export type GetMyAllProjectPositionSuspenseQueryHookResult = ReturnType<typeof useGetMyAllProjectPositionSuspenseQuery>;
export type GetMyAllProjectPositionQueryResult = Apollo.QueryResult<GetMyAllProjectPositionQuery, GetMyAllProjectPositionQueryVariables>;
export const GetMyAllTimeApprovalsDocument = gql`
    query GetMyAllTimeApprovals($after: String, $before: String, $end: LocalDate!, $first: Int, $last: Int, $start: LocalDate!, $search: String) {
  myAllTimeApprovals(
    after: $after
    before: $before
    end: $end
    first: $first
    last: $last
    start: $start
    searchByNumber: $search
  ) {
    nodes {
      description
      id
      number
      status
      timestamp
      totalMinutes
      createdBy {
        id
        displayName
      }
      employee {
        id
        displayName
      }
      history {
        description
        status
        timestamp
        createdBy {
          id
          displayName
        }
      }
      project {
        id
        name
      }
      from
      to
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetMyAllTimeApprovalsQuery__
 *
 * To run a query within a React component, call `useGetMyAllTimeApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAllTimeApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAllTimeApprovalsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      end: // value for 'end'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      start: // value for 'start'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetMyAllTimeApprovalsQuery(baseOptions: Apollo.QueryHookOptions<GetMyAllTimeApprovalsQuery, GetMyAllTimeApprovalsQueryVariables> & ({ variables: GetMyAllTimeApprovalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAllTimeApprovalsQuery, GetMyAllTimeApprovalsQueryVariables>(GetMyAllTimeApprovalsDocument, options);
      }
export function useGetMyAllTimeApprovalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAllTimeApprovalsQuery, GetMyAllTimeApprovalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAllTimeApprovalsQuery, GetMyAllTimeApprovalsQueryVariables>(GetMyAllTimeApprovalsDocument, options);
        }
export function useGetMyAllTimeApprovalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyAllTimeApprovalsQuery, GetMyAllTimeApprovalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyAllTimeApprovalsQuery, GetMyAllTimeApprovalsQueryVariables>(GetMyAllTimeApprovalsDocument, options);
        }
export type GetMyAllTimeApprovalsQueryHookResult = ReturnType<typeof useGetMyAllTimeApprovalsQuery>;
export type GetMyAllTimeApprovalsLazyQueryHookResult = ReturnType<typeof useGetMyAllTimeApprovalsLazyQuery>;
export type GetMyAllTimeApprovalsSuspenseQueryHookResult = ReturnType<typeof useGetMyAllTimeApprovalsSuspenseQuery>;
export type GetMyAllTimeApprovalsQueryResult = Apollo.QueryResult<GetMyAllTimeApprovalsQuery, GetMyAllTimeApprovalsQueryVariables>;
export const GetMyProjectTimeEntriesDocument = gql`
    query GetMyProjectTimeEntries($startDate: LocalDate!, $endDate: LocalDate!, $projectId: ID!) {
  myProjectTimeEntries(
    filter: {endDate: $endDate, startDate: $startDate, projectId: $projectId}
  ) {
    absenceReason
    approvedWorkingMinutes
    date
    errors
    id
    items {
      createdById
      description
      end
      errors
      id
      memberId
      projectId
      projectPositionId
      start
      status
      timestamp
      version
      createdBy {
        id
        displayName
      }
      history {
        id
        createdById
        description
        end
        memberId
        projectId
        projectPositionId
        start
        status
        timestamp
        version
        createdBy {
          id
          displayName
        }
        member {
          id
          displayName
        }
        projectPosition {
          projectName
          saleableServiceName
        }
      }
      logs {
        createdById
        id
        message
        timestamp
        createdBy {
          id
          displayName
        }
      }
      member {
        id
        displayName
      }
    }
    pendingWorkingMinutes
    rejectedWorkingMinutes
    requiredWorkingMinutes
    workingMinutes
  }
}
    `;

/**
 * __useGetMyProjectTimeEntriesQuery__
 *
 * To run a query within a React component, call `useGetMyProjectTimeEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProjectTimeEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProjectTimeEntriesQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetMyProjectTimeEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetMyProjectTimeEntriesQuery, GetMyProjectTimeEntriesQueryVariables> & ({ variables: GetMyProjectTimeEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyProjectTimeEntriesQuery, GetMyProjectTimeEntriesQueryVariables>(GetMyProjectTimeEntriesDocument, options);
      }
export function useGetMyProjectTimeEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyProjectTimeEntriesQuery, GetMyProjectTimeEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyProjectTimeEntriesQuery, GetMyProjectTimeEntriesQueryVariables>(GetMyProjectTimeEntriesDocument, options);
        }
export function useGetMyProjectTimeEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyProjectTimeEntriesQuery, GetMyProjectTimeEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyProjectTimeEntriesQuery, GetMyProjectTimeEntriesQueryVariables>(GetMyProjectTimeEntriesDocument, options);
        }
export type GetMyProjectTimeEntriesQueryHookResult = ReturnType<typeof useGetMyProjectTimeEntriesQuery>;
export type GetMyProjectTimeEntriesLazyQueryHookResult = ReturnType<typeof useGetMyProjectTimeEntriesLazyQuery>;
export type GetMyProjectTimeEntriesSuspenseQueryHookResult = ReturnType<typeof useGetMyProjectTimeEntriesSuspenseQuery>;
export type GetMyProjectTimeEntriesQueryResult = Apollo.QueryResult<GetMyProjectTimeEntriesQuery, GetMyProjectTimeEntriesQueryVariables>;
export const GetMyTimeApprovalPreviewDocument = gql`
    query GetMyTimeApprovalPreview($projectId: ID!, $month: LocalDate!) {
  myTimeApprovalPreview(projectId: $projectId, month: $month) {
    description
    employee {
      id
      displayName
    }
    entries {
      date
      description
      endTime
      startTime
      totalMinutes
      projectPositionId
      surcharge {
        isPercent
        value
      }
    }
    project {
      id
      name
    }
    status
    totalMinutes
    from
    to
  }
}
    `;

/**
 * __useGetMyTimeApprovalPreviewQuery__
 *
 * To run a query within a React component, call `useGetMyTimeApprovalPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTimeApprovalPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTimeApprovalPreviewQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useGetMyTimeApprovalPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetMyTimeApprovalPreviewQuery, GetMyTimeApprovalPreviewQueryVariables> & ({ variables: GetMyTimeApprovalPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyTimeApprovalPreviewQuery, GetMyTimeApprovalPreviewQueryVariables>(GetMyTimeApprovalPreviewDocument, options);
      }
export function useGetMyTimeApprovalPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyTimeApprovalPreviewQuery, GetMyTimeApprovalPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyTimeApprovalPreviewQuery, GetMyTimeApprovalPreviewQueryVariables>(GetMyTimeApprovalPreviewDocument, options);
        }
export function useGetMyTimeApprovalPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyTimeApprovalPreviewQuery, GetMyTimeApprovalPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyTimeApprovalPreviewQuery, GetMyTimeApprovalPreviewQueryVariables>(GetMyTimeApprovalPreviewDocument, options);
        }
export type GetMyTimeApprovalPreviewQueryHookResult = ReturnType<typeof useGetMyTimeApprovalPreviewQuery>;
export type GetMyTimeApprovalPreviewLazyQueryHookResult = ReturnType<typeof useGetMyTimeApprovalPreviewLazyQuery>;
export type GetMyTimeApprovalPreviewSuspenseQueryHookResult = ReturnType<typeof useGetMyTimeApprovalPreviewSuspenseQuery>;
export type GetMyTimeApprovalPreviewQueryResult = Apollo.QueryResult<GetMyTimeApprovalPreviewQuery, GetMyTimeApprovalPreviewQueryVariables>;
export const GetMyTimeApprovalsByProjectDocument = gql`
    query GetMyTimeApprovalsByProject($after: String, $before: String, $ProjectId: ID, $end: LocalDate!, $first: Int, $last: Int, $start: LocalDate!, $search: String) {
  myTimeApprovalsByProject(
    after: $after
    before: $before
    projectId: $ProjectId
    end: $end
    first: $first
    last: $last
    start: $start
    searchByNumber: $search
  ) {
    nodes {
      description
      id
      number
      status
      timestamp
      totalMinutes
      createdBy {
        id
        displayName
      }
      employee {
        id
        displayName
      }
      history {
        description
        status
        timestamp
        createdBy {
          id
          displayName
        }
      }
      project {
        id
        name
      }
      from
      to
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetMyTimeApprovalsByProjectQuery__
 *
 * To run a query within a React component, call `useGetMyTimeApprovalsByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTimeApprovalsByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTimeApprovalsByProjectQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      ProjectId: // value for 'ProjectId'
 *      end: // value for 'end'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      start: // value for 'start'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetMyTimeApprovalsByProjectQuery(baseOptions: Apollo.QueryHookOptions<GetMyTimeApprovalsByProjectQuery, GetMyTimeApprovalsByProjectQueryVariables> & ({ variables: GetMyTimeApprovalsByProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyTimeApprovalsByProjectQuery, GetMyTimeApprovalsByProjectQueryVariables>(GetMyTimeApprovalsByProjectDocument, options);
      }
export function useGetMyTimeApprovalsByProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyTimeApprovalsByProjectQuery, GetMyTimeApprovalsByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyTimeApprovalsByProjectQuery, GetMyTimeApprovalsByProjectQueryVariables>(GetMyTimeApprovalsByProjectDocument, options);
        }
export function useGetMyTimeApprovalsByProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyTimeApprovalsByProjectQuery, GetMyTimeApprovalsByProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyTimeApprovalsByProjectQuery, GetMyTimeApprovalsByProjectQueryVariables>(GetMyTimeApprovalsByProjectDocument, options);
        }
export type GetMyTimeApprovalsByProjectQueryHookResult = ReturnType<typeof useGetMyTimeApprovalsByProjectQuery>;
export type GetMyTimeApprovalsByProjectLazyQueryHookResult = ReturnType<typeof useGetMyTimeApprovalsByProjectLazyQuery>;
export type GetMyTimeApprovalsByProjectSuspenseQueryHookResult = ReturnType<typeof useGetMyTimeApprovalsByProjectSuspenseQuery>;
export type GetMyTimeApprovalsByProjectQueryResult = Apollo.QueryResult<GetMyTimeApprovalsByProjectQuery, GetMyTimeApprovalsByProjectQueryVariables>;
export const GetProjectDocument = gql`
    query GetProject($id: ID!) {
  node(id: $id) {
    id
    __typename
    ... on Project {
      id
      isDeleted
      name
      budget {
        amount
        hasAmountLimit
        hasTimeLimit
        hours
      }
      isGroup
      isRoot
      number
      path
      projectType
      range {
        from
        to
      }
      status
      additionalInformation {
        id
        __typename
        ... on AdditionalAccountingInformation {
          accountingProfile {
            name
            id
          }
          provision
          provisionDescription
          timeTrackingResolution
          id
          clientContractNumber
          clientOrderingDate
          clientContratDate
          clientOrderingNumber
          clientProjectNumber
          supplierProjectNumber
          accountingProfile {
            id
            name
          }
        }
        ... on AdditionalContactInformation {
          clientId
          endCustomer
          client {
            id
            displayName
          }
          contractor {
            id
            displayName
          }
          id
        }
        ... on AdditionalContactPersonInformation {
          clientContactPersonId
          contractorContactPersonId
          contractorProjectLeaderId
          clientContactPerson {
            id
            displayName
          }
          contractorContactPerson {
            id
            displayName
          }
          contractorProjectLeader {
            id
            displayName
          }
          id
        }
        ... on AdditionalPositionInformation {
          hours
          pricePerHour
          saleableServiceId
          serviceName
          servicePrice
          id
          price
          priceRate
          description
          accountingProfile {
            id
            name
          }
        }
        ... on AdditionalTeamMemberInformation {
          employeeId
          id
          worksOnPositions {
            positionId
            pricePerHour
            hours
          }
          employee {
            id
            displayName
            isAFreelancer
            additionalInformation {
              id
              __typename
              ... on SalaryInformation {
                pricePerHour
                startDate
              }
            }
          }
          contractor_of_employee: contractor {
            id
            displayName
          }
        }
        ... on AdditionalTemplateInformation {
          id
          isInvoiceWithTimesheet
          isDetailTimesheet
        }
      }
      createdById
      parentProjectId
      parentProjectName
      saleableServiceGroups {
        hasFixSellingPrice
        id
        name
        originalId
        sellingPrice
        budget {
          amount
          hasAmountLimit
          hasTimeLimit
          hours
        }
        services {
          hasFixSellingPrice
          id
          name
          originalId
          purchasePrice
          sellingPrice
          vatRate
          budget {
            amount
            hasAmountLimit
            hasTimeLimit
            hours
          }
          unit {
            id
            name
            originalId
            shortCode
          }
        }
      }
      saleableServices {
        hasFixSellingPrice
        id
        name
        originalId
        purchasePrice
        sellingPrice
        vatRate
        budget {
          amount
          hasAmountLimit
          hasTimeLimit
          hours
        }
        unit {
          id
          name
          originalId
          shortCode
        }
      }
      saleableUnits {
        id
        name
        originalId
        shortCode
      }
      timestamp
      createdBy {
        id
        displayName
      }
    }
  }
}
    `;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectQuery(baseOptions: Apollo.QueryHookOptions<GetProjectQuery, GetProjectQueryVariables> & ({ variables: GetProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
      }
export function useGetProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export function useGetProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectSuspenseQueryHookResult = ReturnType<typeof useGetProjectSuspenseQuery>;
export type GetProjectQueryResult = Apollo.QueryResult<GetProjectQuery, GetProjectQueryVariables>;
export const GetTimeApprovalDetailsDocument = gql`
    query GetTimeApprovalDetails($projectTimeApprovalId: ID!) {
  timeApprovalDetails(projectTimeApprovalId: $projectTimeApprovalId) {
    employeeId
    description
    employee {
      id
      displayName
    }
    project {
      id
      name
    }
    status
    totalMinutes
    entries {
      date
      description
      endTime
      startTime
      totalMinutes
      surcharge {
        isPercent
        value
      }
      projectPositionId
    }
    from
    to
  }
}
    `;

/**
 * __useGetTimeApprovalDetailsQuery__
 *
 * To run a query within a React component, call `useGetTimeApprovalDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeApprovalDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeApprovalDetailsQuery({
 *   variables: {
 *      projectTimeApprovalId: // value for 'projectTimeApprovalId'
 *   },
 * });
 */
export function useGetTimeApprovalDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetTimeApprovalDetailsQuery, GetTimeApprovalDetailsQueryVariables> & ({ variables: GetTimeApprovalDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeApprovalDetailsQuery, GetTimeApprovalDetailsQueryVariables>(GetTimeApprovalDetailsDocument, options);
      }
export function useGetTimeApprovalDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeApprovalDetailsQuery, GetTimeApprovalDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeApprovalDetailsQuery, GetTimeApprovalDetailsQueryVariables>(GetTimeApprovalDetailsDocument, options);
        }
export function useGetTimeApprovalDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTimeApprovalDetailsQuery, GetTimeApprovalDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTimeApprovalDetailsQuery, GetTimeApprovalDetailsQueryVariables>(GetTimeApprovalDetailsDocument, options);
        }
export type GetTimeApprovalDetailsQueryHookResult = ReturnType<typeof useGetTimeApprovalDetailsQuery>;
export type GetTimeApprovalDetailsLazyQueryHookResult = ReturnType<typeof useGetTimeApprovalDetailsLazyQuery>;
export type GetTimeApprovalDetailsSuspenseQueryHookResult = ReturnType<typeof useGetTimeApprovalDetailsSuspenseQuery>;
export type GetTimeApprovalDetailsQueryResult = Apollo.QueryResult<GetTimeApprovalDetailsQuery, GetTimeApprovalDetailsQueryVariables>;
export const MyCreateTimeApprovalDocument = gql`
    mutation MyCreateTimeApproval($projectId: ID!, $month: LocalDate!) {
  myCreateTimeApproval(input: {projectId: $projectId, month: $month}) {
    projectTimeApproval {
      description
      employee {
        id
        displayName
      }
      project {
        id
        name
      }
      status
      totalMinutes
      createdBy {
        id
        displayName
      }
      id
      number
      timestamp
      history {
        description
        status
        timestamp
        createdBy {
          id
          displayName
        }
      }
      from
      to
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type MyCreateTimeApprovalMutationFn = Apollo.MutationFunction<MyCreateTimeApprovalMutation, MyCreateTimeApprovalMutationVariables>;

/**
 * __useMyCreateTimeApprovalMutation__
 *
 * To run a mutation, you first call `useMyCreateTimeApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyCreateTimeApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myCreateTimeApprovalMutation, { data, loading, error }] = useMyCreateTimeApprovalMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useMyCreateTimeApprovalMutation(baseOptions?: Apollo.MutationHookOptions<MyCreateTimeApprovalMutation, MyCreateTimeApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyCreateTimeApprovalMutation, MyCreateTimeApprovalMutationVariables>(MyCreateTimeApprovalDocument, options);
      }
export type MyCreateTimeApprovalMutationHookResult = ReturnType<typeof useMyCreateTimeApprovalMutation>;
export type MyCreateTimeApprovalMutationResult = Apollo.MutationResult<MyCreateTimeApprovalMutation>;
export type MyCreateTimeApprovalMutationOptions = Apollo.BaseMutationOptions<MyCreateTimeApprovalMutation, MyCreateTimeApprovalMutationVariables>;
export const RejectTimeApprovalDocument = gql`
    mutation RejectTimeApproval($description: String, $projectTimeApprovalId: ID!) {
  rejectTimeApproval(
    input: {description: $description, projectTimeApprovalId: $projectTimeApprovalId}
  ) {
    projectTimeApproval {
      description
      id
      number
      status
      timestamp
      totalMinutes
      project {
        id
        name
      }
      employee {
        id
        displayName
      }
      createdBy {
        id
        displayName
      }
      from
      to
      history {
        description
        status
        timestamp
        createdBy {
          id
          displayName
        }
      }
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type RejectTimeApprovalMutationFn = Apollo.MutationFunction<RejectTimeApprovalMutation, RejectTimeApprovalMutationVariables>;

/**
 * __useRejectTimeApprovalMutation__
 *
 * To run a mutation, you first call `useRejectTimeApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectTimeApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectTimeApprovalMutation, { data, loading, error }] = useRejectTimeApprovalMutation({
 *   variables: {
 *      description: // value for 'description'
 *      projectTimeApprovalId: // value for 'projectTimeApprovalId'
 *   },
 * });
 */
export function useRejectTimeApprovalMutation(baseOptions?: Apollo.MutationHookOptions<RejectTimeApprovalMutation, RejectTimeApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectTimeApprovalMutation, RejectTimeApprovalMutationVariables>(RejectTimeApprovalDocument, options);
      }
export type RejectTimeApprovalMutationHookResult = ReturnType<typeof useRejectTimeApprovalMutation>;
export type RejectTimeApprovalMutationResult = Apollo.MutationResult<RejectTimeApprovalMutation>;
export type RejectTimeApprovalMutationOptions = Apollo.BaseMutationOptions<RejectTimeApprovalMutation, RejectTimeApprovalMutationVariables>;
export const RemoveServicesFromProjectDocument = gql`
    mutation RemoveServicesFromProject($projectId: ID!, $serviceIds: [String!]!) {
  removeServicesFromProject(
    input: {projectId: $projectId, serviceIds: $serviceIds}
  ) {
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on DomainError {
        errorType
        message
      }
    }
    project {
      id
      __typename
      ... on Project {
        id
        isDeleted
        name
        budget {
          amount
          hasAmountLimit
          hasTimeLimit
          hours
        }
        isGroup
        isRoot
        number
        path
        projectType
        range {
          from
          to
        }
        status
        additionalInformation {
          id
          __typename
          ... on AdditionalAccountingInformation {
            accountingProfile {
              name
              id
            }
            provision
            timeTrackingResolution
            id
            clientContractNumber
            clientOrderingDate
            clientContratDate
            clientOrderingNumber
            clientProjectNumber
            supplierProjectNumber
            accountingProfile {
              id
              name
            }
          }
          ... on AdditionalContactInformation {
            clientId
            contractorId
            endCustomer
            client {
              id
              displayName
            }
            contractor {
              id
              displayName
            }
            id
          }
          ... on AdditionalContactPersonInformation {
            clientContactPersonId
            contractorContactPersonId
            contractorProjectLeaderId
            clientContactPerson {
              id
              displayName
            }
            contractorContactPerson {
              id
              displayName
            }
            contractorProjectLeader {
              id
              displayName
            }
            id
          }
          ... on AdditionalPositionInformation {
            hours
            pricePerHour
            saleableServiceId
            serviceName
            servicePrice
            id
            price
            priceRate
          }
          ... on AdditionalTeamMemberInformation {
            employeeId
            id
            worksOnPositions {
              positionId
              pricePerHour
              hours
            }
            employee {
              id
              displayName
              isAFreelancer
              additionalInformation {
                id
                __typename
                ... on SalaryInformation {
                  pricePerHour
                  startDate
                }
              }
            }
          }
        }
        createdById
        parentProjectId
        parentProjectName
        saleableServiceGroups {
          hasFixSellingPrice
          id
          name
          originalId
          sellingPrice
          budget {
            amount
            hasAmountLimit
            hasTimeLimit
            hours
          }
          services {
            hasFixSellingPrice
            id
            name
            originalId
            purchasePrice
            sellingPrice
            vatRate
            budget {
              amount
              hasAmountLimit
              hasTimeLimit
              hours
            }
            unit {
              id
              name
              originalId
              shortCode
            }
          }
        }
        saleableServices {
          hasFixSellingPrice
          id
          name
          originalId
          purchasePrice
          sellingPrice
          vatRate
          budget {
            amount
            hasAmountLimit
            hasTimeLimit
            hours
          }
          unit {
            id
            name
            originalId
            shortCode
          }
        }
        saleableUnits {
          id
          name
          originalId
          shortCode
        }
        timestamp
        createdBy {
          id
          displayName
        }
      }
    }
  }
}
    `;
export type RemoveServicesFromProjectMutationFn = Apollo.MutationFunction<RemoveServicesFromProjectMutation, RemoveServicesFromProjectMutationVariables>;

/**
 * __useRemoveServicesFromProjectMutation__
 *
 * To run a mutation, you first call `useRemoveServicesFromProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveServicesFromProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeServicesFromProjectMutation, { data, loading, error }] = useRemoveServicesFromProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      serviceIds: // value for 'serviceIds'
 *   },
 * });
 */
export function useRemoveServicesFromProjectMutation(baseOptions?: Apollo.MutationHookOptions<RemoveServicesFromProjectMutation, RemoveServicesFromProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveServicesFromProjectMutation, RemoveServicesFromProjectMutationVariables>(RemoveServicesFromProjectDocument, options);
      }
export type RemoveServicesFromProjectMutationHookResult = ReturnType<typeof useRemoveServicesFromProjectMutation>;
export type RemoveServicesFromProjectMutationResult = Apollo.MutationResult<RemoveServicesFromProjectMutation>;
export type RemoveServicesFromProjectMutationOptions = Apollo.BaseMutationOptions<RemoveServicesFromProjectMutation, RemoveServicesFromProjectMutationVariables>;
export const SearchProjectsDocument = gql`
    query SearchProjects($first: Int, $after: String, $type: ProjectType, $name: String, $order: OrderType, $showDeleted: Boolean, $clientId: ID) {
  searchProjects(
    filter: {filterByType: $type, filterByName: $name, showDeleted: $showDeleted, order: $order, filterByClientId: $clientId}
    first: $first
    after: $after
  ) {
    totalCount
    projects {
      id
      isDeleted
      name
      number
      validationStatus
      budget {
        amount
        hasAmountLimit
        hasTimeLimit
        hours
      }
      budgetStatus {
        totalBudgetAmount
        totalBudgetMinutes
        spentAmount
        spentMinutes
        remainingAmount
        remainingMinutes
        utilizationPercent
        openMinutes
        pendingMinutes
        approvedMinutes
      }
      range {
        from
        to
      }
      path
      isRoot
      isGroup
      projectType
      status
      isManualStatusOverride
      createdById
      parentProjectId
      parentProjectName
      timestamp
      client {
        id
        displayName
      }
      contractor {
        id
        displayName
      }
      createdBy {
        id
        displayName
      }
    }
    matchedIds
  }
}
    `;

/**
 * __useSearchProjectsQuery__
 *
 * To run a query within a React component, call `useSearchProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProjectsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      order: // value for 'order'
 *      showDeleted: // value for 'showDeleted'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useSearchProjectsQuery(baseOptions?: Apollo.QueryHookOptions<SearchProjectsQuery, SearchProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchProjectsQuery, SearchProjectsQueryVariables>(SearchProjectsDocument, options);
      }
export function useSearchProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchProjectsQuery, SearchProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchProjectsQuery, SearchProjectsQueryVariables>(SearchProjectsDocument, options);
        }
export function useSearchProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchProjectsQuery, SearchProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchProjectsQuery, SearchProjectsQueryVariables>(SearchProjectsDocument, options);
        }
export type SearchProjectsQueryHookResult = ReturnType<typeof useSearchProjectsQuery>;
export type SearchProjectsLazyQueryHookResult = ReturnType<typeof useSearchProjectsLazyQuery>;
export type SearchProjectsSuspenseQueryHookResult = ReturnType<typeof useSearchProjectsSuspenseQuery>;
export type SearchProjectsQueryResult = Apollo.QueryResult<SearchProjectsQuery, SearchProjectsQueryVariables>;
export const UpdateDayProjectTimeEntryDocument = gql`
    mutation UpdateDayProjectTimeEntry($date: LocalDate!, $timeEntries: [UpsertProjectTimeEntryInput!]!, $employeeId: ID!, $projectId: ID!) {
  updateDayProjectTimeEntry(
    input: {date: $date, timeEntries: $timeEntries, employeeId: $employeeId, projectId: $projectId}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
      }
    }
    projectTimeEntryDayGroup {
      absenceReason
      approvedWorkingMinutes
      date
      errors
      id
      pendingWorkingMinutes
      rejectedWorkingMinutes
      requiredWorkingMinutes
      workingMinutes
      items {
        createdById
        description
        end
        errors
        id
        memberId
        projectId
        projectPositionId
        start
        status
        timestamp
        version
        createdBy {
          id
          displayName
        }
        logs {
          createdById
          id
          message
          timestamp
          createdBy {
            id
            displayName
          }
        }
        member {
          id
          displayName
        }
        history {
          createdById
          description
          end
          memberId
          projectId
          projectPositionId
          start
          status
          timestamp
          version
          createdBy {
            id
            displayName
          }
          member {
            displayName
            id
          }
          projectPosition {
            projectName
            saleableServiceName
          }
        }
      }
    }
  }
}
    `;
export type UpdateDayProjectTimeEntryMutationFn = Apollo.MutationFunction<UpdateDayProjectTimeEntryMutation, UpdateDayProjectTimeEntryMutationVariables>;

/**
 * __useUpdateDayProjectTimeEntryMutation__
 *
 * To run a mutation, you first call `useUpdateDayProjectTimeEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDayProjectTimeEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDayProjectTimeEntryMutation, { data, loading, error }] = useUpdateDayProjectTimeEntryMutation({
 *   variables: {
 *      date: // value for 'date'
 *      timeEntries: // value for 'timeEntries'
 *      employeeId: // value for 'employeeId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUpdateDayProjectTimeEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDayProjectTimeEntryMutation, UpdateDayProjectTimeEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDayProjectTimeEntryMutation, UpdateDayProjectTimeEntryMutationVariables>(UpdateDayProjectTimeEntryDocument, options);
      }
export type UpdateDayProjectTimeEntryMutationHookResult = ReturnType<typeof useUpdateDayProjectTimeEntryMutation>;
export type UpdateDayProjectTimeEntryMutationResult = Apollo.MutationResult<UpdateDayProjectTimeEntryMutation>;
export type UpdateDayProjectTimeEntryMutationOptions = Apollo.BaseMutationOptions<UpdateDayProjectTimeEntryMutation, UpdateDayProjectTimeEntryMutationVariables>;
export const UpdateMyDayProjectTimeEntryDocument = gql`
    mutation UpdateMyDayProjectTimeEntry($date: LocalDate!, $timeEntries: [UpsertProjectTimeEntryInput!]!, $projectId: ID!) {
  updateMyDayProjectTimeEntry(
    input: {date: $date, timeEntries: $timeEntries, projectId: $projectId}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
      }
    }
    projectTimeEntryDayGroup {
      absenceReason
      approvedWorkingMinutes
      date
      errors
      id
      pendingWorkingMinutes
      rejectedWorkingMinutes
      requiredWorkingMinutes
      workingMinutes
      items {
        createdById
        description
        end
        errors
        id
        memberId
        projectId
        projectPositionId
        start
        status
        timestamp
        version
        createdBy {
          id
          displayName
        }
        logs {
          createdById
          id
          message
          timestamp
          createdBy {
            id
            displayName
          }
        }
        member {
          id
          displayName
        }
        history {
          createdById
          description
          end
          memberId
          projectId
          projectPositionId
          start
          status
          timestamp
          version
          createdBy {
            id
            displayName
          }
          member {
            displayName
            id
          }
          projectPosition {
            projectName
            saleableServiceName
          }
        }
      }
    }
  }
}
    `;
export type UpdateMyDayProjectTimeEntryMutationFn = Apollo.MutationFunction<UpdateMyDayProjectTimeEntryMutation, UpdateMyDayProjectTimeEntryMutationVariables>;

/**
 * __useUpdateMyDayProjectTimeEntryMutation__
 *
 * To run a mutation, you first call `useUpdateMyDayProjectTimeEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyDayProjectTimeEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyDayProjectTimeEntryMutation, { data, loading, error }] = useUpdateMyDayProjectTimeEntryMutation({
 *   variables: {
 *      date: // value for 'date'
 *      timeEntries: // value for 'timeEntries'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUpdateMyDayProjectTimeEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyDayProjectTimeEntryMutation, UpdateMyDayProjectTimeEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyDayProjectTimeEntryMutation, UpdateMyDayProjectTimeEntryMutationVariables>(UpdateMyDayProjectTimeEntryDocument, options);
      }
export type UpdateMyDayProjectTimeEntryMutationHookResult = ReturnType<typeof useUpdateMyDayProjectTimeEntryMutation>;
export type UpdateMyDayProjectTimeEntryMutationResult = Apollo.MutationResult<UpdateMyDayProjectTimeEntryMutation>;
export type UpdateMyDayProjectTimeEntryMutationOptions = Apollo.BaseMutationOptions<UpdateMyDayProjectTimeEntryMutation, UpdateMyDayProjectTimeEntryMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($id: ID!, $name: String!, $from: LocalDate!, $to: LocalDate!, $budget: BudgetInput!) {
  updateProject(
    input: {projectId: $id, name: $name, range: {from: $from, to: $to}, budget: $budget}
  ) {
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on DomainError {
        errorType
        message
      }
    }
    project {
      id
      isDeleted
      name
      number
      budget {
        amount
        hasAmountLimit
        hasTimeLimit
        hours
      }
      range {
        from
        to
      }
      additionalInformation {
        id
        __typename
        ... on AdditionalAccountingInformation {
          accountingProfileId
          provision
          id
          timeTrackingResolution
          supplierProjectNumber
          clientProjectNumber
          clientOrderingNumber
          clientOrderingDate
          clientContratDate
          clientContractNumber
        }
        ... on AdditionalContactInformation {
          clientId
          contractorId
          endCustomer
          client {
            id
            displayName
          }
          contractor {
            id
            displayName
          }
          id
        }
        ... on AdditionalContactPersonInformation {
          clientContactPersonId
          contractorContactPersonId
          contractorProjectLeaderId
          clientContactPerson {
            id
            displayName
          }
          contractorContactPerson {
            id
            displayName
          }
          contractorProjectLeader {
            id
            displayName
          }
          id
        }
        ... on AdditionalPositionInformation {
          hours
          id
          saleableServiceId
          pricePerHour
          price
          priceRate
        }
        ... on AdditionalTeamMemberInformation {
          employeeId
          id
          worksOnPositions {
            positionId
            pricePerHour
            hours
          }
          employee {
            id
            displayName
          }
        }
      }
      createdById
      isGroup
      isRoot
      parentProjectId
      path
      projectType
      saleableServiceGroups {
        hasFixSellingPrice
        id
        name
        originalId
        sellingPrice
        budget {
          amount
          hasAmountLimit
          hasTimeLimit
          hours
        }
        services {
          hasFixSellingPrice
          id
          name
          originalId
          purchasePrice
          sellingPrice
          vatRate
          budget {
            amount
            hasAmountLimit
            hasTimeLimit
            hours
          }
          unit {
            id
            name
            originalId
            shortCode
          }
        }
      }
      saleableServices {
        hasFixSellingPrice
        id
        name
        originalId
        purchasePrice
        sellingPrice
        vatRate
        budget {
          amount
          hasAmountLimit
          hasTimeLimit
          hours
        }
        unit {
          id
          name
          originalId
          shortCode
        }
      }
      saleableUnits {
        id
        name
        originalId
        shortCode
      }
      status
      timestamp
      createdBy {
        id
        displayName
      }
    }
  }
}
    `;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      budget: // value for 'budget'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const UpdateProjectActiveStatusDocument = gql`
    mutation UpdateProjectActiveStatus($projectId: ID!, $isDeleted: Boolean!) {
  updateProjectActiveStatus(input: {projectId: $projectId, isDeleted: $isDeleted}) {
    boolean
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type UpdateProjectActiveStatusMutationFn = Apollo.MutationFunction<UpdateProjectActiveStatusMutation, UpdateProjectActiveStatusMutationVariables>;

/**
 * __useUpdateProjectActiveStatusMutation__
 *
 * To run a mutation, you first call `useUpdateProjectActiveStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectActiveStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectActiveStatusMutation, { data, loading, error }] = useUpdateProjectActiveStatusMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      isDeleted: // value for 'isDeleted'
 *   },
 * });
 */
export function useUpdateProjectActiveStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectActiveStatusMutation, UpdateProjectActiveStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectActiveStatusMutation, UpdateProjectActiveStatusMutationVariables>(UpdateProjectActiveStatusDocument, options);
      }
export type UpdateProjectActiveStatusMutationHookResult = ReturnType<typeof useUpdateProjectActiveStatusMutation>;
export type UpdateProjectActiveStatusMutationResult = Apollo.MutationResult<UpdateProjectActiveStatusMutation>;
export type UpdateProjectActiveStatusMutationOptions = Apollo.BaseMutationOptions<UpdateProjectActiveStatusMutation, UpdateProjectActiveStatusMutationVariables>;
export const UpdateProjectAdditionalAccountingInformationDocument = gql`
    mutation UpdateProjectAdditionalAccountingInformation($accountingProfileId: ID, $timeTrackingResolution: Int!, $id: ID!, $provision: Decimal, $informationId: ID!, $clientContractNumber: String, $clientContratDate: LocalDate, $clientOrderingDate: LocalDate, $clientOrderingNumber: String, $clientProjectNumber: String, $supplierProjectNumber: String, $provisionDescription: String) {
  updateProjectAdditionalAccountingInformation(
    input: {accountingProfileId: $accountingProfileId, projectId: $id, provision: $provision, projectInformationId: $informationId, timeTrackingResolution: $timeTrackingResolution, clientContractNumber: $clientContractNumber, clientContratDate: $clientContratDate, clientOrderingDate: $clientOrderingDate, clientOrderingNumber: $clientOrderingNumber, clientProjectNumber: $clientProjectNumber, supplierProjectNumber: $supplierProjectNumber, provisionDescription: $provisionDescription}
  ) {
    additionalAccountingInformation {
      id
      accountingProfileId
      provision
      provisionDescription
      timeTrackingResolution
      clientContractNumber
      clientContratDate
      clientOrderingDate
      clientOrderingNumber
      clientProjectNumber
      supplierProjectNumber
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type UpdateProjectAdditionalAccountingInformationMutationFn = Apollo.MutationFunction<UpdateProjectAdditionalAccountingInformationMutation, UpdateProjectAdditionalAccountingInformationMutationVariables>;

/**
 * __useUpdateProjectAdditionalAccountingInformationMutation__
 *
 * To run a mutation, you first call `useUpdateProjectAdditionalAccountingInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectAdditionalAccountingInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectAdditionalAccountingInformationMutation, { data, loading, error }] = useUpdateProjectAdditionalAccountingInformationMutation({
 *   variables: {
 *      accountingProfileId: // value for 'accountingProfileId'
 *      timeTrackingResolution: // value for 'timeTrackingResolution'
 *      id: // value for 'id'
 *      provision: // value for 'provision'
 *      informationId: // value for 'informationId'
 *      clientContractNumber: // value for 'clientContractNumber'
 *      clientContratDate: // value for 'clientContratDate'
 *      clientOrderingDate: // value for 'clientOrderingDate'
 *      clientOrderingNumber: // value for 'clientOrderingNumber'
 *      clientProjectNumber: // value for 'clientProjectNumber'
 *      supplierProjectNumber: // value for 'supplierProjectNumber'
 *      provisionDescription: // value for 'provisionDescription'
 *   },
 * });
 */
export function useUpdateProjectAdditionalAccountingInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectAdditionalAccountingInformationMutation, UpdateProjectAdditionalAccountingInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectAdditionalAccountingInformationMutation, UpdateProjectAdditionalAccountingInformationMutationVariables>(UpdateProjectAdditionalAccountingInformationDocument, options);
      }
export type UpdateProjectAdditionalAccountingInformationMutationHookResult = ReturnType<typeof useUpdateProjectAdditionalAccountingInformationMutation>;
export type UpdateProjectAdditionalAccountingInformationMutationResult = Apollo.MutationResult<UpdateProjectAdditionalAccountingInformationMutation>;
export type UpdateProjectAdditionalAccountingInformationMutationOptions = Apollo.BaseMutationOptions<UpdateProjectAdditionalAccountingInformationMutation, UpdateProjectAdditionalAccountingInformationMutationVariables>;
export const UpdateProjectAdditionalContactInformationDocument = gql`
    mutation UpdateProjectAdditionalContactInformation($clientId: ID, $contractorId: ID!, $endCustomer: String, $projectId: ID!, $informationId: ID!) {
  updateProjectAdditionalContactInformation(
    input: {clientId: $clientId, contractorId: $contractorId, projectId: $projectId, endCustomer: $endCustomer, projectInformationId: $informationId}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    additionalContactInformation {
      clientId
      contractorId
      endCustomer
      id
      client {
        id
        displayName
      }
      contractor {
        id
        displayName
      }
    }
  }
}
    `;
export type UpdateProjectAdditionalContactInformationMutationFn = Apollo.MutationFunction<UpdateProjectAdditionalContactInformationMutation, UpdateProjectAdditionalContactInformationMutationVariables>;

/**
 * __useUpdateProjectAdditionalContactInformationMutation__
 *
 * To run a mutation, you first call `useUpdateProjectAdditionalContactInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectAdditionalContactInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectAdditionalContactInformationMutation, { data, loading, error }] = useUpdateProjectAdditionalContactInformationMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      contractorId: // value for 'contractorId'
 *      endCustomer: // value for 'endCustomer'
 *      projectId: // value for 'projectId'
 *      informationId: // value for 'informationId'
 *   },
 * });
 */
export function useUpdateProjectAdditionalContactInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectAdditionalContactInformationMutation, UpdateProjectAdditionalContactInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectAdditionalContactInformationMutation, UpdateProjectAdditionalContactInformationMutationVariables>(UpdateProjectAdditionalContactInformationDocument, options);
      }
export type UpdateProjectAdditionalContactInformationMutationHookResult = ReturnType<typeof useUpdateProjectAdditionalContactInformationMutation>;
export type UpdateProjectAdditionalContactInformationMutationResult = Apollo.MutationResult<UpdateProjectAdditionalContactInformationMutation>;
export type UpdateProjectAdditionalContactInformationMutationOptions = Apollo.BaseMutationOptions<UpdateProjectAdditionalContactInformationMutation, UpdateProjectAdditionalContactInformationMutationVariables>;
export const UpdateProjectAdditionalContactPersonInformationDocument = gql`
    mutation UpdateProjectAdditionalContactPersonInformation($clientContactId: ID, $contractorContactId: ID, $contractorProjectLeaderId: ID, $projectId: ID!, $informationId: ID!) {
  updateProjectAdditionalContactPersonInformation(
    input: {clientContactPersonId: $clientContactId, contractorContactPersonId: $contractorContactId, contractorProjectLeaderId: $contractorProjectLeaderId, projectId: $projectId, projectInformationId: $informationId}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errors {
          errorMessage
          propertyName
        }
        errorType
        message
      }
    }
    additionalContactPersonInformation {
      clientContactPersonId
      contractorContactPersonId
      contractorProjectLeaderId
      id
      clientContactPerson {
        id
        displayName
      }
      contractorContactPerson {
        id
        displayName
      }
      contractorProjectLeader {
        displayName
        id
      }
    }
  }
}
    `;
export type UpdateProjectAdditionalContactPersonInformationMutationFn = Apollo.MutationFunction<UpdateProjectAdditionalContactPersonInformationMutation, UpdateProjectAdditionalContactPersonInformationMutationVariables>;

/**
 * __useUpdateProjectAdditionalContactPersonInformationMutation__
 *
 * To run a mutation, you first call `useUpdateProjectAdditionalContactPersonInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectAdditionalContactPersonInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectAdditionalContactPersonInformationMutation, { data, loading, error }] = useUpdateProjectAdditionalContactPersonInformationMutation({
 *   variables: {
 *      clientContactId: // value for 'clientContactId'
 *      contractorContactId: // value for 'contractorContactId'
 *      contractorProjectLeaderId: // value for 'contractorProjectLeaderId'
 *      projectId: // value for 'projectId'
 *      informationId: // value for 'informationId'
 *   },
 * });
 */
export function useUpdateProjectAdditionalContactPersonInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectAdditionalContactPersonInformationMutation, UpdateProjectAdditionalContactPersonInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectAdditionalContactPersonInformationMutation, UpdateProjectAdditionalContactPersonInformationMutationVariables>(UpdateProjectAdditionalContactPersonInformationDocument, options);
      }
export type UpdateProjectAdditionalContactPersonInformationMutationHookResult = ReturnType<typeof useUpdateProjectAdditionalContactPersonInformationMutation>;
export type UpdateProjectAdditionalContactPersonInformationMutationResult = Apollo.MutationResult<UpdateProjectAdditionalContactPersonInformationMutation>;
export type UpdateProjectAdditionalContactPersonInformationMutationOptions = Apollo.BaseMutationOptions<UpdateProjectAdditionalContactPersonInformationMutation, UpdateProjectAdditionalContactPersonInformationMutationVariables>;
export const UpdateProjectAdditionalPositionInformationDocument = gql`
    mutation UpdateProjectAdditionalPositionInformation($hours: Decimal, $pricePerHour: Decimal, $projectId: ID!, $saleableServiceId: String!, $serviceName: String!, $servicePrice: Decimal!, $informationId: ID!, $price: Decimal, $priceRate: ProjectPositionPriceRateType, $accountingProfileId: ID, $description: String) {
  updateProjectAdditionalPositionInformation(
    input: {hours: $hours, pricePerHour: $pricePerHour, projectId: $projectId, projectSaleableServiceId: $saleableServiceId, serviceName: $serviceName, servicePrice: $servicePrice, projectInformationId: $informationId, price: $price, priceRate: $priceRate, accountingProfileId: $accountingProfileId, description: $description}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    additionalPositionInformation {
      hours
      id
      saleableServiceId
      serviceName
      servicePrice
      pricePerHour
      price
      priceRate
    }
  }
}
    `;
export type UpdateProjectAdditionalPositionInformationMutationFn = Apollo.MutationFunction<UpdateProjectAdditionalPositionInformationMutation, UpdateProjectAdditionalPositionInformationMutationVariables>;

/**
 * __useUpdateProjectAdditionalPositionInformationMutation__
 *
 * To run a mutation, you first call `useUpdateProjectAdditionalPositionInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectAdditionalPositionInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectAdditionalPositionInformationMutation, { data, loading, error }] = useUpdateProjectAdditionalPositionInformationMutation({
 *   variables: {
 *      hours: // value for 'hours'
 *      pricePerHour: // value for 'pricePerHour'
 *      projectId: // value for 'projectId'
 *      saleableServiceId: // value for 'saleableServiceId'
 *      serviceName: // value for 'serviceName'
 *      servicePrice: // value for 'servicePrice'
 *      informationId: // value for 'informationId'
 *      price: // value for 'price'
 *      priceRate: // value for 'priceRate'
 *      accountingProfileId: // value for 'accountingProfileId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateProjectAdditionalPositionInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectAdditionalPositionInformationMutation, UpdateProjectAdditionalPositionInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectAdditionalPositionInformationMutation, UpdateProjectAdditionalPositionInformationMutationVariables>(UpdateProjectAdditionalPositionInformationDocument, options);
      }
export type UpdateProjectAdditionalPositionInformationMutationHookResult = ReturnType<typeof useUpdateProjectAdditionalPositionInformationMutation>;
export type UpdateProjectAdditionalPositionInformationMutationResult = Apollo.MutationResult<UpdateProjectAdditionalPositionInformationMutation>;
export type UpdateProjectAdditionalPositionInformationMutationOptions = Apollo.BaseMutationOptions<UpdateProjectAdditionalPositionInformationMutation, UpdateProjectAdditionalPositionInformationMutationVariables>;
export const UpdateProjectAdditionalTeamMemberInformationDocument = gql`
    mutation UpdateProjectAdditionalTeamMemberInformation($projectId: ID!, $informationId: ID!, $memberId: ID, $worksOnPositions: [WorksOnPositionInput!]!, $contractorId: ID) {
  updateProjectAdditionalTeamMemberInformation(
    input: {projectId: $projectId, projectInformationId: $informationId, memberId: $memberId, worksOnPositions: $worksOnPositions, contractorId: $contractorId}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    additionalTeamMemberInformation {
      __typename
      employeeId
      id
      worksOnPositions {
        positionId
        pricePerHour
        hours
      }
      employee {
        id
        displayName
      }
    }
  }
}
    `;
export type UpdateProjectAdditionalTeamMemberInformationMutationFn = Apollo.MutationFunction<UpdateProjectAdditionalTeamMemberInformationMutation, UpdateProjectAdditionalTeamMemberInformationMutationVariables>;

/**
 * __useUpdateProjectAdditionalTeamMemberInformationMutation__
 *
 * To run a mutation, you first call `useUpdateProjectAdditionalTeamMemberInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectAdditionalTeamMemberInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectAdditionalTeamMemberInformationMutation, { data, loading, error }] = useUpdateProjectAdditionalTeamMemberInformationMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      informationId: // value for 'informationId'
 *      memberId: // value for 'memberId'
 *      worksOnPositions: // value for 'worksOnPositions'
 *      contractorId: // value for 'contractorId'
 *   },
 * });
 */
export function useUpdateProjectAdditionalTeamMemberInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectAdditionalTeamMemberInformationMutation, UpdateProjectAdditionalTeamMemberInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectAdditionalTeamMemberInformationMutation, UpdateProjectAdditionalTeamMemberInformationMutationVariables>(UpdateProjectAdditionalTeamMemberInformationDocument, options);
      }
export type UpdateProjectAdditionalTeamMemberInformationMutationHookResult = ReturnType<typeof useUpdateProjectAdditionalTeamMemberInformationMutation>;
export type UpdateProjectAdditionalTeamMemberInformationMutationResult = Apollo.MutationResult<UpdateProjectAdditionalTeamMemberInformationMutation>;
export type UpdateProjectAdditionalTeamMemberInformationMutationOptions = Apollo.BaseMutationOptions<UpdateProjectAdditionalTeamMemberInformationMutation, UpdateProjectAdditionalTeamMemberInformationMutationVariables>;
export const UpdateProjectAdditionalTemplateInformationDocument = gql`
    mutation UpdateProjectAdditionalTemplateInformation($projectId: ID!, $informationId: ID!, $isInvoiceWithTimesheet: Boolean!, $isDetailTimesheet: Boolean!) {
  updateProjectAdditionalTemplateInformation(
    input: {projectId: $projectId, projectInformationId: $informationId, isInvoiceWithTimesheet: $isInvoiceWithTimesheet, isDetailTimesheet: $isDetailTimesheet}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    additionalTemplateInformation {
      id
      isInvoiceWithTimesheet
      isDetailTimesheet
    }
  }
}
    `;
export type UpdateProjectAdditionalTemplateInformationMutationFn = Apollo.MutationFunction<UpdateProjectAdditionalTemplateInformationMutation, UpdateProjectAdditionalTemplateInformationMutationVariables>;

/**
 * __useUpdateProjectAdditionalTemplateInformationMutation__
 *
 * To run a mutation, you first call `useUpdateProjectAdditionalTemplateInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectAdditionalTemplateInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectAdditionalTemplateInformationMutation, { data, loading, error }] = useUpdateProjectAdditionalTemplateInformationMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      informationId: // value for 'informationId'
 *      isInvoiceWithTimesheet: // value for 'isInvoiceWithTimesheet'
 *      isDetailTimesheet: // value for 'isDetailTimesheet'
 *   },
 * });
 */
export function useUpdateProjectAdditionalTemplateInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectAdditionalTemplateInformationMutation, UpdateProjectAdditionalTemplateInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectAdditionalTemplateInformationMutation, UpdateProjectAdditionalTemplateInformationMutationVariables>(UpdateProjectAdditionalTemplateInformationDocument, options);
      }
export type UpdateProjectAdditionalTemplateInformationMutationHookResult = ReturnType<typeof useUpdateProjectAdditionalTemplateInformationMutation>;
export type UpdateProjectAdditionalTemplateInformationMutationResult = Apollo.MutationResult<UpdateProjectAdditionalTemplateInformationMutation>;
export type UpdateProjectAdditionalTemplateInformationMutationOptions = Apollo.BaseMutationOptions<UpdateProjectAdditionalTemplateInformationMutation, UpdateProjectAdditionalTemplateInformationMutationVariables>;
export const UpdateProjectSaleableServiceDocument = gql`
    mutation UpdateProjectSaleableService($budget: BudgetInput!, $groupId: ID!, $hasFixSellingPrice: Boolean!, $name: String!, $originalServiceId: String!, $purchasePrice: Decimal!, $sellingPrice: Decimal!, $serviceId: ID!, $projectId: ID!, $unitId: ID!, $vatRate: Decimal!) {
  updateProjectSaleableService(
    input: {budget: $budget, projectSaleableServiceGroupId: $groupId, hasFixSellingPrice: $hasFixSellingPrice, name: $name, originalServiceId: $originalServiceId, purchasePrice: $purchasePrice, sellingPrice: $sellingPrice, projectSaleableServiceId: $serviceId, projectId: $projectId, projectSaleableUnitId: $unitId, vatRate: $vatRate}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    projectSaleableService {
      hasFixSellingPrice
      id
      originalId
      name
      purchasePrice
      sellingPrice
      vatRate
      budget {
        amount
        hasAmountLimit
        hasTimeLimit
        hours
      }
      unit {
        id
        originalId
        name
        shortCode
      }
    }
  }
}
    `;
export type UpdateProjectSaleableServiceMutationFn = Apollo.MutationFunction<UpdateProjectSaleableServiceMutation, UpdateProjectSaleableServiceMutationVariables>;

/**
 * __useUpdateProjectSaleableServiceMutation__
 *
 * To run a mutation, you first call `useUpdateProjectSaleableServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectSaleableServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectSaleableServiceMutation, { data, loading, error }] = useUpdateProjectSaleableServiceMutation({
 *   variables: {
 *      budget: // value for 'budget'
 *      groupId: // value for 'groupId'
 *      hasFixSellingPrice: // value for 'hasFixSellingPrice'
 *      name: // value for 'name'
 *      originalServiceId: // value for 'originalServiceId'
 *      purchasePrice: // value for 'purchasePrice'
 *      sellingPrice: // value for 'sellingPrice'
 *      serviceId: // value for 'serviceId'
 *      projectId: // value for 'projectId'
 *      unitId: // value for 'unitId'
 *      vatRate: // value for 'vatRate'
 *   },
 * });
 */
export function useUpdateProjectSaleableServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectSaleableServiceMutation, UpdateProjectSaleableServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectSaleableServiceMutation, UpdateProjectSaleableServiceMutationVariables>(UpdateProjectSaleableServiceDocument, options);
      }
export type UpdateProjectSaleableServiceMutationHookResult = ReturnType<typeof useUpdateProjectSaleableServiceMutation>;
export type UpdateProjectSaleableServiceMutationResult = Apollo.MutationResult<UpdateProjectSaleableServiceMutation>;
export type UpdateProjectSaleableServiceMutationOptions = Apollo.BaseMutationOptions<UpdateProjectSaleableServiceMutation, UpdateProjectSaleableServiceMutationVariables>;
export const UpdateProjectSaleableServiceGroupDocument = gql`
    mutation UpdateProjectSaleableServiceGroup($budget: BudgetInput!, $hasFixSellingPrice: Boolean!, $name: String!, $originalGroupId: String!, $sellingPrice: Decimal!, $serviceGroupId: ID!, $projectId: ID!) {
  updateProjectSaleableServiceGroup(
    input: {budget: $budget, hasFixSellingPrice: $hasFixSellingPrice, name: $name, originalGroupId: $originalGroupId, sellingPrice: $sellingPrice, projectSaleableServiceGroupId: $serviceGroupId, projectId: $projectId}
  ) {
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on DomainError {
        errorType
        message
      }
    }
    projectSaleableServiceGroup {
      hasFixSellingPrice
      id
      originalId
      name
      sellingPrice
      budget {
        amount
        hasAmountLimit
        hasTimeLimit
        hours
      }
      services {
        hasFixSellingPrice
        id
        originalId
        name
        purchasePrice
        sellingPrice
        vatRate
        budget {
          amount
          hasAmountLimit
          hasTimeLimit
          hours
        }
        unit {
          id
          originalId
          name
          shortCode
        }
      }
    }
  }
}
    `;
export type UpdateProjectSaleableServiceGroupMutationFn = Apollo.MutationFunction<UpdateProjectSaleableServiceGroupMutation, UpdateProjectSaleableServiceGroupMutationVariables>;

/**
 * __useUpdateProjectSaleableServiceGroupMutation__
 *
 * To run a mutation, you first call `useUpdateProjectSaleableServiceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectSaleableServiceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectSaleableServiceGroupMutation, { data, loading, error }] = useUpdateProjectSaleableServiceGroupMutation({
 *   variables: {
 *      budget: // value for 'budget'
 *      hasFixSellingPrice: // value for 'hasFixSellingPrice'
 *      name: // value for 'name'
 *      originalGroupId: // value for 'originalGroupId'
 *      sellingPrice: // value for 'sellingPrice'
 *      serviceGroupId: // value for 'serviceGroupId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUpdateProjectSaleableServiceGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectSaleableServiceGroupMutation, UpdateProjectSaleableServiceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectSaleableServiceGroupMutation, UpdateProjectSaleableServiceGroupMutationVariables>(UpdateProjectSaleableServiceGroupDocument, options);
      }
export type UpdateProjectSaleableServiceGroupMutationHookResult = ReturnType<typeof useUpdateProjectSaleableServiceGroupMutation>;
export type UpdateProjectSaleableServiceGroupMutationResult = Apollo.MutationResult<UpdateProjectSaleableServiceGroupMutation>;
export type UpdateProjectSaleableServiceGroupMutationOptions = Apollo.BaseMutationOptions<UpdateProjectSaleableServiceGroupMutation, UpdateProjectSaleableServiceGroupMutationVariables>;
export const UpdateProjectSaleableUnitDocument = gql`
    mutation UpdateProjectSaleableUnit($name: String!, $originalUnitId: String!, $shortCode: String!, $projectId: ID!, $unitId: ID!) {
  updateProjectSaleableUnit(
    input: {name: $name, originalUnitId: $originalUnitId, shortCode: $shortCode, projectId: $projectId, projectSaleableUnitId: $unitId}
  ) {
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on DomainError {
        errorType
        message
      }
    }
    projectSaleableUnit {
      id
      originalId
      name
      shortCode
    }
  }
}
    `;
export type UpdateProjectSaleableUnitMutationFn = Apollo.MutationFunction<UpdateProjectSaleableUnitMutation, UpdateProjectSaleableUnitMutationVariables>;

/**
 * __useUpdateProjectSaleableUnitMutation__
 *
 * To run a mutation, you first call `useUpdateProjectSaleableUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectSaleableUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectSaleableUnitMutation, { data, loading, error }] = useUpdateProjectSaleableUnitMutation({
 *   variables: {
 *      name: // value for 'name'
 *      originalUnitId: // value for 'originalUnitId'
 *      shortCode: // value for 'shortCode'
 *      projectId: // value for 'projectId'
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useUpdateProjectSaleableUnitMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectSaleableUnitMutation, UpdateProjectSaleableUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectSaleableUnitMutation, UpdateProjectSaleableUnitMutationVariables>(UpdateProjectSaleableUnitDocument, options);
      }
export type UpdateProjectSaleableUnitMutationHookResult = ReturnType<typeof useUpdateProjectSaleableUnitMutation>;
export type UpdateProjectSaleableUnitMutationResult = Apollo.MutationResult<UpdateProjectSaleableUnitMutation>;
export type UpdateProjectSaleableUnitMutationOptions = Apollo.BaseMutationOptions<UpdateProjectSaleableUnitMutation, UpdateProjectSaleableUnitMutationVariables>;
export const UpdateProjectStatusDocument = gql`
    mutation UpdateProjectStatus($projectId: ID!, $newStatus: ProjectStatus!) {
  updateProjectStatus(input: {projectId: $projectId, newStatus: $newStatus}) {
    project {
      id
      status
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type UpdateProjectStatusMutationFn = Apollo.MutationFunction<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>;

/**
 * __useUpdateProjectStatusMutation__
 *
 * To run a mutation, you first call `useUpdateProjectStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectStatusMutation, { data, loading, error }] = useUpdateProjectStatusMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      newStatus: // value for 'newStatus'
 *   },
 * });
 */
export function useUpdateProjectStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>(UpdateProjectStatusDocument, options);
      }
export type UpdateProjectStatusMutationHookResult = ReturnType<typeof useUpdateProjectStatusMutation>;
export type UpdateProjectStatusMutationResult = Apollo.MutationResult<UpdateProjectStatusMutation>;
export type UpdateProjectStatusMutationOptions = Apollo.BaseMutationOptions<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>;
export const CreateAccountingProfileDocument = gql`
    mutation CreateAccountingProfile($entries: [AccountingProfileEntryInput!]!, $name: String!) {
  createAccountingProfile(input: {entries: $entries, name: $name}) {
    accountingProfile {
      id
      isDeleted
      name
      entries {
        daysOfWeek
        name
        period {
          from
          to
        }
        surcharge {
          isPercent
          value
        }
      }
      createdById
      timestamp
    }
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type CreateAccountingProfileMutationFn = Apollo.MutationFunction<CreateAccountingProfileMutation, CreateAccountingProfileMutationVariables>;

/**
 * __useCreateAccountingProfileMutation__
 *
 * To run a mutation, you first call `useCreateAccountingProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountingProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountingProfileMutation, { data, loading, error }] = useCreateAccountingProfileMutation({
 *   variables: {
 *      entries: // value for 'entries'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateAccountingProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountingProfileMutation, CreateAccountingProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountingProfileMutation, CreateAccountingProfileMutationVariables>(CreateAccountingProfileDocument, options);
      }
export type CreateAccountingProfileMutationHookResult = ReturnType<typeof useCreateAccountingProfileMutation>;
export type CreateAccountingProfileMutationResult = Apollo.MutationResult<CreateAccountingProfileMutation>;
export type CreateAccountingProfileMutationOptions = Apollo.BaseMutationOptions<CreateAccountingProfileMutation, CreateAccountingProfileMutationVariables>;
export const CreateDepartmentDocument = gql`
    mutation CreateDepartment($name: String!, $description: String!, $companyId: ID!, $leaderId: ID!) {
  createDepartment(
    input: {name: $name, description: $description, leaderId: $leaderId, companyId: $companyId}
  ) {
    department {
      id
      name
      description
      leaderId
      companyId
      version
      leader {
        displayName
        id
      }
    }
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type CreateDepartmentMutationFn = Apollo.MutationFunction<CreateDepartmentMutation, CreateDepartmentMutationVariables>;

/**
 * __useCreateDepartmentMutation__
 *
 * To run a mutation, you first call `useCreateDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDepartmentMutation, { data, loading, error }] = useCreateDepartmentMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      companyId: // value for 'companyId'
 *      leaderId: // value for 'leaderId'
 *   },
 * });
 */
export function useCreateDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDepartmentMutation, CreateDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDepartmentMutation, CreateDepartmentMutationVariables>(CreateDepartmentDocument, options);
      }
export type CreateDepartmentMutationHookResult = ReturnType<typeof useCreateDepartmentMutation>;
export type CreateDepartmentMutationResult = Apollo.MutationResult<CreateDepartmentMutation>;
export type CreateDepartmentMutationOptions = Apollo.BaseMutationOptions<CreateDepartmentMutation, CreateDepartmentMutationVariables>;
export const CreateNextRollingNumberDocument = gql`
    mutation CreateNextRollingNumber($contactId: ID!, $type: RollingNumberType!) {
  createNextRollingNumber(input: {contactId: $contactId, type: $type}) {
    string
    errors {
      ... on MyEntityNotFoundError {
        error
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type CreateNextRollingNumberMutationFn = Apollo.MutationFunction<CreateNextRollingNumberMutation, CreateNextRollingNumberMutationVariables>;

/**
 * __useCreateNextRollingNumberMutation__
 *
 * To run a mutation, you first call `useCreateNextRollingNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNextRollingNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNextRollingNumberMutation, { data, loading, error }] = useCreateNextRollingNumberMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateNextRollingNumberMutation(baseOptions?: Apollo.MutationHookOptions<CreateNextRollingNumberMutation, CreateNextRollingNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNextRollingNumberMutation, CreateNextRollingNumberMutationVariables>(CreateNextRollingNumberDocument, options);
      }
export type CreateNextRollingNumberMutationHookResult = ReturnType<typeof useCreateNextRollingNumberMutation>;
export type CreateNextRollingNumberMutationResult = Apollo.MutationResult<CreateNextRollingNumberMutation>;
export type CreateNextRollingNumberMutationOptions = Apollo.BaseMutationOptions<CreateNextRollingNumberMutation, CreateNextRollingNumberMutationVariables>;
export const CreateSaleableServiceDocument = gql`
    mutation CreateSaleableService($groupId: ID!, $purchasePrice: Decimal!, $name: String!, $unitId: ID!, $sellingPrice: Decimal!, $vatRate: Decimal!) {
  createSaleableService(
    input: {groupId: $groupId, purchasePrice: $purchasePrice, name: $name, unitId: $unitId, sellingPrice: $sellingPrice, vatRate: $vatRate}
  ) {
    errors {
      __typename
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    saleableService {
      id
      name
      purchasePrice
      sellingPrice
      vatRate
      unit {
        id
        name
        shortCode
      }
      saleableServiceGroupId
      saleableUnitId
    }
  }
}
    `;
export type CreateSaleableServiceMutationFn = Apollo.MutationFunction<CreateSaleableServiceMutation, CreateSaleableServiceMutationVariables>;

/**
 * __useCreateSaleableServiceMutation__
 *
 * To run a mutation, you first call `useCreateSaleableServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSaleableServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSaleableServiceMutation, { data, loading, error }] = useCreateSaleableServiceMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      purchasePrice: // value for 'purchasePrice'
 *      name: // value for 'name'
 *      unitId: // value for 'unitId'
 *      sellingPrice: // value for 'sellingPrice'
 *      vatRate: // value for 'vatRate'
 *   },
 * });
 */
export function useCreateSaleableServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateSaleableServiceMutation, CreateSaleableServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSaleableServiceMutation, CreateSaleableServiceMutationVariables>(CreateSaleableServiceDocument, options);
      }
export type CreateSaleableServiceMutationHookResult = ReturnType<typeof useCreateSaleableServiceMutation>;
export type CreateSaleableServiceMutationResult = Apollo.MutationResult<CreateSaleableServiceMutation>;
export type CreateSaleableServiceMutationOptions = Apollo.BaseMutationOptions<CreateSaleableServiceMutation, CreateSaleableServiceMutationVariables>;
export const CreateSaleableServiceGroupDocument = gql`
    mutation CreateSaleableServiceGroup($name: String!, $sellingPrice: Decimal!) {
  createSaleableServiceGroup(input: {name: $name, sellingPrice: $sellingPrice}) {
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    saleableServiceGroup {
      id
      name
      sellingPrice
      services {
        id
        name
        purchasePrice
        sellingPrice
        vatRate
        unit {
          id
          name
          shortCode
        }
        saleableServiceGroupId
        saleableUnitId
      }
    }
  }
}
    `;
export type CreateSaleableServiceGroupMutationFn = Apollo.MutationFunction<CreateSaleableServiceGroupMutation, CreateSaleableServiceGroupMutationVariables>;

/**
 * __useCreateSaleableServiceGroupMutation__
 *
 * To run a mutation, you first call `useCreateSaleableServiceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSaleableServiceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSaleableServiceGroupMutation, { data, loading, error }] = useCreateSaleableServiceGroupMutation({
 *   variables: {
 *      name: // value for 'name'
 *      sellingPrice: // value for 'sellingPrice'
 *   },
 * });
 */
export function useCreateSaleableServiceGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateSaleableServiceGroupMutation, CreateSaleableServiceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSaleableServiceGroupMutation, CreateSaleableServiceGroupMutationVariables>(CreateSaleableServiceGroupDocument, options);
      }
export type CreateSaleableServiceGroupMutationHookResult = ReturnType<typeof useCreateSaleableServiceGroupMutation>;
export type CreateSaleableServiceGroupMutationResult = Apollo.MutationResult<CreateSaleableServiceGroupMutation>;
export type CreateSaleableServiceGroupMutationOptions = Apollo.BaseMutationOptions<CreateSaleableServiceGroupMutation, CreateSaleableServiceGroupMutationVariables>;
export const CreateSaleableUnitDocument = gql`
    mutation CreateSaleableUnit($name: String!, $shortCode: String!) {
  createSaleableUnit(input: {name: $name, shortCode: $shortCode}) {
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    saleableUnit {
      id
      name
      shortCode
    }
  }
}
    `;
export type CreateSaleableUnitMutationFn = Apollo.MutationFunction<CreateSaleableUnitMutation, CreateSaleableUnitMutationVariables>;

/**
 * __useCreateSaleableUnitMutation__
 *
 * To run a mutation, you first call `useCreateSaleableUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSaleableUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSaleableUnitMutation, { data, loading, error }] = useCreateSaleableUnitMutation({
 *   variables: {
 *      name: // value for 'name'
 *      shortCode: // value for 'shortCode'
 *   },
 * });
 */
export function useCreateSaleableUnitMutation(baseOptions?: Apollo.MutationHookOptions<CreateSaleableUnitMutation, CreateSaleableUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSaleableUnitMutation, CreateSaleableUnitMutationVariables>(CreateSaleableUnitDocument, options);
      }
export type CreateSaleableUnitMutationHookResult = ReturnType<typeof useCreateSaleableUnitMutation>;
export type CreateSaleableUnitMutationResult = Apollo.MutationResult<CreateSaleableUnitMutation>;
export type CreateSaleableUnitMutationOptions = Apollo.BaseMutationOptions<CreateSaleableUnitMutation, CreateSaleableUnitMutationVariables>;
export const DeleteAccountingProfileDocument = gql`
    mutation DeleteAccountingProfile($id: ID!) {
  deleteAccountingProfile(input: {id: $id}) {
    boolean
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on DomainError {
        errorType
        message
      }
    }
  }
}
    `;
export type DeleteAccountingProfileMutationFn = Apollo.MutationFunction<DeleteAccountingProfileMutation, DeleteAccountingProfileMutationVariables>;

/**
 * __useDeleteAccountingProfileMutation__
 *
 * To run a mutation, you first call `useDeleteAccountingProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountingProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountingProfileMutation, { data, loading, error }] = useDeleteAccountingProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAccountingProfileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountingProfileMutation, DeleteAccountingProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountingProfileMutation, DeleteAccountingProfileMutationVariables>(DeleteAccountingProfileDocument, options);
      }
export type DeleteAccountingProfileMutationHookResult = ReturnType<typeof useDeleteAccountingProfileMutation>;
export type DeleteAccountingProfileMutationResult = Apollo.MutationResult<DeleteAccountingProfileMutation>;
export type DeleteAccountingProfileMutationOptions = Apollo.BaseMutationOptions<DeleteAccountingProfileMutation, DeleteAccountingProfileMutationVariables>;
export const DeleteDepartmentDocument = gql`
    mutation DeleteDepartment($id: ID!) {
  deleteDepartment(input: {departmentId: $id}) {
    boolean
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type DeleteDepartmentMutationFn = Apollo.MutationFunction<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>;

/**
 * __useDeleteDepartmentMutation__
 *
 * To run a mutation, you first call `useDeleteDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDepartmentMutation, { data, loading, error }] = useDeleteDepartmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>(DeleteDepartmentDocument, options);
      }
export type DeleteDepartmentMutationHookResult = ReturnType<typeof useDeleteDepartmentMutation>;
export type DeleteDepartmentMutationResult = Apollo.MutationResult<DeleteDepartmentMutation>;
export type DeleteDepartmentMutationOptions = Apollo.BaseMutationOptions<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>;
export const DeleteSaleableServiceDocument = gql`
    mutation DeleteSaleableService($id: ID!) {
  deleteSaleableService(input: {id: $id}) {
    boolean
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on DomainError {
        errorType
        message
      }
    }
  }
}
    `;
export type DeleteSaleableServiceMutationFn = Apollo.MutationFunction<DeleteSaleableServiceMutation, DeleteSaleableServiceMutationVariables>;

/**
 * __useDeleteSaleableServiceMutation__
 *
 * To run a mutation, you first call `useDeleteSaleableServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSaleableServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSaleableServiceMutation, { data, loading, error }] = useDeleteSaleableServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSaleableServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSaleableServiceMutation, DeleteSaleableServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSaleableServiceMutation, DeleteSaleableServiceMutationVariables>(DeleteSaleableServiceDocument, options);
      }
export type DeleteSaleableServiceMutationHookResult = ReturnType<typeof useDeleteSaleableServiceMutation>;
export type DeleteSaleableServiceMutationResult = Apollo.MutationResult<DeleteSaleableServiceMutation>;
export type DeleteSaleableServiceMutationOptions = Apollo.BaseMutationOptions<DeleteSaleableServiceMutation, DeleteSaleableServiceMutationVariables>;
export const DeleteSaleableServiceGroupDocument = gql`
    mutation DeleteSaleableServiceGroup($id: ID!) {
  deleteSaleableServiceGroup(input: {id: $id}) {
    boolean
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on DomainError {
        errorType
        message
      }
    }
  }
}
    `;
export type DeleteSaleableServiceGroupMutationFn = Apollo.MutationFunction<DeleteSaleableServiceGroupMutation, DeleteSaleableServiceGroupMutationVariables>;

/**
 * __useDeleteSaleableServiceGroupMutation__
 *
 * To run a mutation, you first call `useDeleteSaleableServiceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSaleableServiceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSaleableServiceGroupMutation, { data, loading, error }] = useDeleteSaleableServiceGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSaleableServiceGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSaleableServiceGroupMutation, DeleteSaleableServiceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSaleableServiceGroupMutation, DeleteSaleableServiceGroupMutationVariables>(DeleteSaleableServiceGroupDocument, options);
      }
export type DeleteSaleableServiceGroupMutationHookResult = ReturnType<typeof useDeleteSaleableServiceGroupMutation>;
export type DeleteSaleableServiceGroupMutationResult = Apollo.MutationResult<DeleteSaleableServiceGroupMutation>;
export type DeleteSaleableServiceGroupMutationOptions = Apollo.BaseMutationOptions<DeleteSaleableServiceGroupMutation, DeleteSaleableServiceGroupMutationVariables>;
export const DeleteSaleableUnitDocument = gql`
    mutation DeleteSaleableUnit($id: ID!) {
  deleteSaleableUnit(input: {id: $id}) {
    boolean
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on DomainError {
        errorType
        message
      }
    }
  }
}
    `;
export type DeleteSaleableUnitMutationFn = Apollo.MutationFunction<DeleteSaleableUnitMutation, DeleteSaleableUnitMutationVariables>;

/**
 * __useDeleteSaleableUnitMutation__
 *
 * To run a mutation, you first call `useDeleteSaleableUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSaleableUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSaleableUnitMutation, { data, loading, error }] = useDeleteSaleableUnitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSaleableUnitMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSaleableUnitMutation, DeleteSaleableUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSaleableUnitMutation, DeleteSaleableUnitMutationVariables>(DeleteSaleableUnitDocument, options);
      }
export type DeleteSaleableUnitMutationHookResult = ReturnType<typeof useDeleteSaleableUnitMutation>;
export type DeleteSaleableUnitMutationResult = Apollo.MutationResult<DeleteSaleableUnitMutation>;
export type DeleteSaleableUnitMutationOptions = Apollo.BaseMutationOptions<DeleteSaleableUnitMutation, DeleteSaleableUnitMutationVariables>;
export const GetAllAccountingProfilesDocument = gql`
    query GetAllAccountingProfiles($first: Int!, $after: String, $name: String) {
  allAccountingProfiles(
    first: $first
    after: $after
    filter: {filterByName: $name, order: ASC}
  ) {
    nodes {
      id
      isDeleted
      name
      entries {
        daysOfWeek
        name
        period {
          from
          to
        }
        surcharge {
          isPercent
          value
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllAccountingProfilesQuery__
 *
 * To run a query within a React component, call `useGetAllAccountingProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAccountingProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAccountingProfilesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetAllAccountingProfilesQuery(baseOptions: Apollo.QueryHookOptions<GetAllAccountingProfilesQuery, GetAllAccountingProfilesQueryVariables> & ({ variables: GetAllAccountingProfilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAccountingProfilesQuery, GetAllAccountingProfilesQueryVariables>(GetAllAccountingProfilesDocument, options);
      }
export function useGetAllAccountingProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAccountingProfilesQuery, GetAllAccountingProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAccountingProfilesQuery, GetAllAccountingProfilesQueryVariables>(GetAllAccountingProfilesDocument, options);
        }
export function useGetAllAccountingProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAccountingProfilesQuery, GetAllAccountingProfilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAccountingProfilesQuery, GetAllAccountingProfilesQueryVariables>(GetAllAccountingProfilesDocument, options);
        }
export type GetAllAccountingProfilesQueryHookResult = ReturnType<typeof useGetAllAccountingProfilesQuery>;
export type GetAllAccountingProfilesLazyQueryHookResult = ReturnType<typeof useGetAllAccountingProfilesLazyQuery>;
export type GetAllAccountingProfilesSuspenseQueryHookResult = ReturnType<typeof useGetAllAccountingProfilesSuspenseQuery>;
export type GetAllAccountingProfilesQueryResult = Apollo.QueryResult<GetAllAccountingProfilesQuery, GetAllAccountingProfilesQueryVariables>;
export const GetAllContractorBccRecipientListsDocument = gql`
    query GetAllContractorBccRecipientLists($contractorId: ID!) {
  allContractorBccRecipientLists(contractorId: $contractorId) {
    id
    contractorId
    type
    recipients
  }
}
    `;

/**
 * __useGetAllContractorBccRecipientListsQuery__
 *
 * To run a query within a React component, call `useGetAllContractorBccRecipientListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllContractorBccRecipientListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllContractorBccRecipientListsQuery({
 *   variables: {
 *      contractorId: // value for 'contractorId'
 *   },
 * });
 */
export function useGetAllContractorBccRecipientListsQuery(baseOptions: Apollo.QueryHookOptions<GetAllContractorBccRecipientListsQuery, GetAllContractorBccRecipientListsQueryVariables> & ({ variables: GetAllContractorBccRecipientListsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllContractorBccRecipientListsQuery, GetAllContractorBccRecipientListsQueryVariables>(GetAllContractorBccRecipientListsDocument, options);
      }
export function useGetAllContractorBccRecipientListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllContractorBccRecipientListsQuery, GetAllContractorBccRecipientListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllContractorBccRecipientListsQuery, GetAllContractorBccRecipientListsQueryVariables>(GetAllContractorBccRecipientListsDocument, options);
        }
export function useGetAllContractorBccRecipientListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllContractorBccRecipientListsQuery, GetAllContractorBccRecipientListsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllContractorBccRecipientListsQuery, GetAllContractorBccRecipientListsQueryVariables>(GetAllContractorBccRecipientListsDocument, options);
        }
export type GetAllContractorBccRecipientListsQueryHookResult = ReturnType<typeof useGetAllContractorBccRecipientListsQuery>;
export type GetAllContractorBccRecipientListsLazyQueryHookResult = ReturnType<typeof useGetAllContractorBccRecipientListsLazyQuery>;
export type GetAllContractorBccRecipientListsSuspenseQueryHookResult = ReturnType<typeof useGetAllContractorBccRecipientListsSuspenseQuery>;
export type GetAllContractorBccRecipientListsQueryResult = Apollo.QueryResult<GetAllContractorBccRecipientListsQuery, GetAllContractorBccRecipientListsQueryVariables>;
export const GetAllContractorRollingNumbersDocument = gql`
    query GetAllContractorRollingNumbers($contractorId: ID!) {
  allContractorRollingNumbers(contractorId: $contractorId) {
    contactId
    currentValue
    digitCount
    format
    id
    type
  }
}
    `;

/**
 * __useGetAllContractorRollingNumbersQuery__
 *
 * To run a query within a React component, call `useGetAllContractorRollingNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllContractorRollingNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllContractorRollingNumbersQuery({
 *   variables: {
 *      contractorId: // value for 'contractorId'
 *   },
 * });
 */
export function useGetAllContractorRollingNumbersQuery(baseOptions: Apollo.QueryHookOptions<GetAllContractorRollingNumbersQuery, GetAllContractorRollingNumbersQueryVariables> & ({ variables: GetAllContractorRollingNumbersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllContractorRollingNumbersQuery, GetAllContractorRollingNumbersQueryVariables>(GetAllContractorRollingNumbersDocument, options);
      }
export function useGetAllContractorRollingNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllContractorRollingNumbersQuery, GetAllContractorRollingNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllContractorRollingNumbersQuery, GetAllContractorRollingNumbersQueryVariables>(GetAllContractorRollingNumbersDocument, options);
        }
export function useGetAllContractorRollingNumbersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllContractorRollingNumbersQuery, GetAllContractorRollingNumbersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllContractorRollingNumbersQuery, GetAllContractorRollingNumbersQueryVariables>(GetAllContractorRollingNumbersDocument, options);
        }
export type GetAllContractorRollingNumbersQueryHookResult = ReturnType<typeof useGetAllContractorRollingNumbersQuery>;
export type GetAllContractorRollingNumbersLazyQueryHookResult = ReturnType<typeof useGetAllContractorRollingNumbersLazyQuery>;
export type GetAllContractorRollingNumbersSuspenseQueryHookResult = ReturnType<typeof useGetAllContractorRollingNumbersSuspenseQuery>;
export type GetAllContractorRollingNumbersQueryResult = Apollo.QueryResult<GetAllContractorRollingNumbersQuery, GetAllContractorRollingNumbersQueryVariables>;
export const GetAllContractorsForRollingNumbersDocument = gql`
    query GetAllContractorsForRollingNumbers {
  allContacts(first: 100, filter: {filterByTypes: CONTRACTOR}) {
    nodes {
      id
      displayName
    }
  }
}
    `;

/**
 * __useGetAllContractorsForRollingNumbersQuery__
 *
 * To run a query within a React component, call `useGetAllContractorsForRollingNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllContractorsForRollingNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllContractorsForRollingNumbersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllContractorsForRollingNumbersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllContractorsForRollingNumbersQuery, GetAllContractorsForRollingNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllContractorsForRollingNumbersQuery, GetAllContractorsForRollingNumbersQueryVariables>(GetAllContractorsForRollingNumbersDocument, options);
      }
export function useGetAllContractorsForRollingNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllContractorsForRollingNumbersQuery, GetAllContractorsForRollingNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllContractorsForRollingNumbersQuery, GetAllContractorsForRollingNumbersQueryVariables>(GetAllContractorsForRollingNumbersDocument, options);
        }
export function useGetAllContractorsForRollingNumbersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllContractorsForRollingNumbersQuery, GetAllContractorsForRollingNumbersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllContractorsForRollingNumbersQuery, GetAllContractorsForRollingNumbersQueryVariables>(GetAllContractorsForRollingNumbersDocument, options);
        }
export type GetAllContractorsForRollingNumbersQueryHookResult = ReturnType<typeof useGetAllContractorsForRollingNumbersQuery>;
export type GetAllContractorsForRollingNumbersLazyQueryHookResult = ReturnType<typeof useGetAllContractorsForRollingNumbersLazyQuery>;
export type GetAllContractorsForRollingNumbersSuspenseQueryHookResult = ReturnType<typeof useGetAllContractorsForRollingNumbersSuspenseQuery>;
export type GetAllContractorsForRollingNumbersQueryResult = Apollo.QueryResult<GetAllContractorsForRollingNumbersQuery, GetAllContractorsForRollingNumbersQueryVariables>;
export const GetAllDepartmentsDocument = gql`
    query GetAllDepartments($first: Int, $after: String, $last: Int, $before: String, $companyId: ID!, $name: String, $order: OrderType) {
  allDepartments(
    after: $after
    before: $before
    filter: {companyId: $companyId, filterByName: $name, order: $order}
    first: $first
    last: $last
  ) {
    nodes {
      id
      name
      description
      leaderId
      companyId
      version
      leader {
        displayName
        id
      }
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetAllDepartmentsQuery__
 *
 * To run a query within a React component, call `useGetAllDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDepartmentsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      companyId: // value for 'companyId'
 *      name: // value for 'name'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetAllDepartmentsQuery(baseOptions: Apollo.QueryHookOptions<GetAllDepartmentsQuery, GetAllDepartmentsQueryVariables> & ({ variables: GetAllDepartmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDepartmentsQuery, GetAllDepartmentsQueryVariables>(GetAllDepartmentsDocument, options);
      }
export function useGetAllDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDepartmentsQuery, GetAllDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDepartmentsQuery, GetAllDepartmentsQueryVariables>(GetAllDepartmentsDocument, options);
        }
export function useGetAllDepartmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllDepartmentsQuery, GetAllDepartmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllDepartmentsQuery, GetAllDepartmentsQueryVariables>(GetAllDepartmentsDocument, options);
        }
export type GetAllDepartmentsQueryHookResult = ReturnType<typeof useGetAllDepartmentsQuery>;
export type GetAllDepartmentsLazyQueryHookResult = ReturnType<typeof useGetAllDepartmentsLazyQuery>;
export type GetAllDepartmentsSuspenseQueryHookResult = ReturnType<typeof useGetAllDepartmentsSuspenseQuery>;
export type GetAllDepartmentsQueryResult = Apollo.QueryResult<GetAllDepartmentsQuery, GetAllDepartmentsQueryVariables>;
export const GetAllGlobalRollingNumbersDocument = gql`
    query GetAllGlobalRollingNumbers {
  allGlobalRollingNumbers {
    contactId
    currentValue
    digitCount
    format
    id
    type
  }
}
    `;

/**
 * __useGetAllGlobalRollingNumbersQuery__
 *
 * To run a query within a React component, call `useGetAllGlobalRollingNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllGlobalRollingNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllGlobalRollingNumbersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllGlobalRollingNumbersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllGlobalRollingNumbersQuery, GetAllGlobalRollingNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllGlobalRollingNumbersQuery, GetAllGlobalRollingNumbersQueryVariables>(GetAllGlobalRollingNumbersDocument, options);
      }
export function useGetAllGlobalRollingNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllGlobalRollingNumbersQuery, GetAllGlobalRollingNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllGlobalRollingNumbersQuery, GetAllGlobalRollingNumbersQueryVariables>(GetAllGlobalRollingNumbersDocument, options);
        }
export function useGetAllGlobalRollingNumbersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllGlobalRollingNumbersQuery, GetAllGlobalRollingNumbersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllGlobalRollingNumbersQuery, GetAllGlobalRollingNumbersQueryVariables>(GetAllGlobalRollingNumbersDocument, options);
        }
export type GetAllGlobalRollingNumbersQueryHookResult = ReturnType<typeof useGetAllGlobalRollingNumbersQuery>;
export type GetAllGlobalRollingNumbersLazyQueryHookResult = ReturnType<typeof useGetAllGlobalRollingNumbersLazyQuery>;
export type GetAllGlobalRollingNumbersSuspenseQueryHookResult = ReturnType<typeof useGetAllGlobalRollingNumbersSuspenseQuery>;
export type GetAllGlobalRollingNumbersQueryResult = Apollo.QueryResult<GetAllGlobalRollingNumbersQuery, GetAllGlobalRollingNumbersQueryVariables>;
export const GetAllMembersOfDepartmentDocument = gql`
    query GetAllMembersOfDepartment($first: Int, $after: String, $last: Int, $before: String, $departmentId: ID!, $name: String, $order: OrderType) {
  allMembersOfDepartment(
    first: $first
    departmentId: $departmentId
    filter: {filterByName: $name, order: $order}
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      displayName
      id
    }
  }
}
    `;

/**
 * __useGetAllMembersOfDepartmentQuery__
 *
 * To run a query within a React component, call `useGetAllMembersOfDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMembersOfDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMembersOfDepartmentQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      departmentId: // value for 'departmentId'
 *      name: // value for 'name'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetAllMembersOfDepartmentQuery(baseOptions: Apollo.QueryHookOptions<GetAllMembersOfDepartmentQuery, GetAllMembersOfDepartmentQueryVariables> & ({ variables: GetAllMembersOfDepartmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMembersOfDepartmentQuery, GetAllMembersOfDepartmentQueryVariables>(GetAllMembersOfDepartmentDocument, options);
      }
export function useGetAllMembersOfDepartmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMembersOfDepartmentQuery, GetAllMembersOfDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMembersOfDepartmentQuery, GetAllMembersOfDepartmentQueryVariables>(GetAllMembersOfDepartmentDocument, options);
        }
export function useGetAllMembersOfDepartmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllMembersOfDepartmentQuery, GetAllMembersOfDepartmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllMembersOfDepartmentQuery, GetAllMembersOfDepartmentQueryVariables>(GetAllMembersOfDepartmentDocument, options);
        }
export type GetAllMembersOfDepartmentQueryHookResult = ReturnType<typeof useGetAllMembersOfDepartmentQuery>;
export type GetAllMembersOfDepartmentLazyQueryHookResult = ReturnType<typeof useGetAllMembersOfDepartmentLazyQuery>;
export type GetAllMembersOfDepartmentSuspenseQueryHookResult = ReturnType<typeof useGetAllMembersOfDepartmentSuspenseQuery>;
export type GetAllMembersOfDepartmentQueryResult = Apollo.QueryResult<GetAllMembersOfDepartmentQuery, GetAllMembersOfDepartmentQueryVariables>;
export const GetAllSaleableServicesDocument = gql`
    query GetAllSaleableServices {
  allSaleableServices {
    id
    name
    sellingPrice
    services {
      id
      name
      purchasePrice
      sellingPrice
      vatRate
      unit {
        id
        name
        shortCode
      }
      saleableServiceGroupId
      saleableUnitId
    }
  }
}
    `;

/**
 * __useGetAllSaleableServicesQuery__
 *
 * To run a query within a React component, call `useGetAllSaleableServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSaleableServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSaleableServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSaleableServicesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSaleableServicesQuery, GetAllSaleableServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSaleableServicesQuery, GetAllSaleableServicesQueryVariables>(GetAllSaleableServicesDocument, options);
      }
export function useGetAllSaleableServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSaleableServicesQuery, GetAllSaleableServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSaleableServicesQuery, GetAllSaleableServicesQueryVariables>(GetAllSaleableServicesDocument, options);
        }
export function useGetAllSaleableServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllSaleableServicesQuery, GetAllSaleableServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllSaleableServicesQuery, GetAllSaleableServicesQueryVariables>(GetAllSaleableServicesDocument, options);
        }
export type GetAllSaleableServicesQueryHookResult = ReturnType<typeof useGetAllSaleableServicesQuery>;
export type GetAllSaleableServicesLazyQueryHookResult = ReturnType<typeof useGetAllSaleableServicesLazyQuery>;
export type GetAllSaleableServicesSuspenseQueryHookResult = ReturnType<typeof useGetAllSaleableServicesSuspenseQuery>;
export type GetAllSaleableServicesQueryResult = Apollo.QueryResult<GetAllSaleableServicesQuery, GetAllSaleableServicesQueryVariables>;
export const GetAllSaleableUnitsDocument = gql`
    query GetAllSaleableUnits {
  allSaleableUnits {
    id
    name
    shortCode
  }
}
    `;

/**
 * __useGetAllSaleableUnitsQuery__
 *
 * To run a query within a React component, call `useGetAllSaleableUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSaleableUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSaleableUnitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSaleableUnitsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSaleableUnitsQuery, GetAllSaleableUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSaleableUnitsQuery, GetAllSaleableUnitsQueryVariables>(GetAllSaleableUnitsDocument, options);
      }
export function useGetAllSaleableUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSaleableUnitsQuery, GetAllSaleableUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSaleableUnitsQuery, GetAllSaleableUnitsQueryVariables>(GetAllSaleableUnitsDocument, options);
        }
export function useGetAllSaleableUnitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllSaleableUnitsQuery, GetAllSaleableUnitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllSaleableUnitsQuery, GetAllSaleableUnitsQueryVariables>(GetAllSaleableUnitsDocument, options);
        }
export type GetAllSaleableUnitsQueryHookResult = ReturnType<typeof useGetAllSaleableUnitsQuery>;
export type GetAllSaleableUnitsLazyQueryHookResult = ReturnType<typeof useGetAllSaleableUnitsLazyQuery>;
export type GetAllSaleableUnitsSuspenseQueryHookResult = ReturnType<typeof useGetAllSaleableUnitsSuspenseQuery>;
export type GetAllSaleableUnitsQueryResult = Apollo.QueryResult<GetAllSaleableUnitsQuery, GetAllSaleableUnitsQueryVariables>;
export const LeavesDepartmentDocument = gql`
    mutation LeavesDepartment($contactId: ID!) {
  leavesDepartment(input: {contactId: $contactId}) {
    boolean
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type LeavesDepartmentMutationFn = Apollo.MutationFunction<LeavesDepartmentMutation, LeavesDepartmentMutationVariables>;

/**
 * __useLeavesDepartmentMutation__
 *
 * To run a mutation, you first call `useLeavesDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeavesDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leavesDepartmentMutation, { data, loading, error }] = useLeavesDepartmentMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useLeavesDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<LeavesDepartmentMutation, LeavesDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeavesDepartmentMutation, LeavesDepartmentMutationVariables>(LeavesDepartmentDocument, options);
      }
export type LeavesDepartmentMutationHookResult = ReturnType<typeof useLeavesDepartmentMutation>;
export type LeavesDepartmentMutationResult = Apollo.MutationResult<LeavesDepartmentMutation>;
export type LeavesDepartmentMutationOptions = Apollo.BaseMutationOptions<LeavesDepartmentMutation, LeavesDepartmentMutationVariables>;
export const UpdateAccountingProfileDocument = gql`
    mutation UpdateAccountingProfile($id: ID!, $entries: [AccountingProfileEntryInput!]!, $name: String!) {
  updateAccountingProfile(input: {entries: $entries, id: $id, name: $name}) {
    accountingProfile {
      id
      isDeleted
      name
      entries {
        daysOfWeek
        name
        period {
          from
          to
        }
        surcharge {
          isPercent
          value
        }
      }
      createdById
      timestamp
    }
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on DomainError {
        errorType
        message
      }
    }
  }
}
    `;
export type UpdateAccountingProfileMutationFn = Apollo.MutationFunction<UpdateAccountingProfileMutation, UpdateAccountingProfileMutationVariables>;

/**
 * __useUpdateAccountingProfileMutation__
 *
 * To run a mutation, you first call `useUpdateAccountingProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountingProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountingProfileMutation, { data, loading, error }] = useUpdateAccountingProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entries: // value for 'entries'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateAccountingProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountingProfileMutation, UpdateAccountingProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountingProfileMutation, UpdateAccountingProfileMutationVariables>(UpdateAccountingProfileDocument, options);
      }
export type UpdateAccountingProfileMutationHookResult = ReturnType<typeof useUpdateAccountingProfileMutation>;
export type UpdateAccountingProfileMutationResult = Apollo.MutationResult<UpdateAccountingProfileMutation>;
export type UpdateAccountingProfileMutationOptions = Apollo.BaseMutationOptions<UpdateAccountingProfileMutation, UpdateAccountingProfileMutationVariables>;
export const UpdateBccRecipientListDocument = gql`
    mutation UpdateBccRecipientList($contractorId: ID!, $type: EmailType!, $recipients: [String!]!) {
  updateBccRecipientList(
    input: {contractorId: $contractorId, type: $type, recipients: $recipients}
  ) {
    boolean
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type UpdateBccRecipientListMutationFn = Apollo.MutationFunction<UpdateBccRecipientListMutation, UpdateBccRecipientListMutationVariables>;

/**
 * __useUpdateBccRecipientListMutation__
 *
 * To run a mutation, you first call `useUpdateBccRecipientListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBccRecipientListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBccRecipientListMutation, { data, loading, error }] = useUpdateBccRecipientListMutation({
 *   variables: {
 *      contractorId: // value for 'contractorId'
 *      type: // value for 'type'
 *      recipients: // value for 'recipients'
 *   },
 * });
 */
export function useUpdateBccRecipientListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBccRecipientListMutation, UpdateBccRecipientListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBccRecipientListMutation, UpdateBccRecipientListMutationVariables>(UpdateBccRecipientListDocument, options);
      }
export type UpdateBccRecipientListMutationHookResult = ReturnType<typeof useUpdateBccRecipientListMutation>;
export type UpdateBccRecipientListMutationResult = Apollo.MutationResult<UpdateBccRecipientListMutation>;
export type UpdateBccRecipientListMutationOptions = Apollo.BaseMutationOptions<UpdateBccRecipientListMutation, UpdateBccRecipientListMutationVariables>;
export const UpdateDepartmentDocument = gql`
    mutation UpdateDepartment($name: String!, $description: String!, $leaderId: ID!, $id: ID!) {
  updateDepartment(
    input: {name: $name, description: $description, leaderId: $leaderId, departmentId: $id}
  ) {
    department {
      id
      name
      description
      leaderId
      companyId
      version
      leader {
        displayName
        id
      }
    }
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type UpdateDepartmentMutationFn = Apollo.MutationFunction<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>;

/**
 * __useUpdateDepartmentMutation__
 *
 * To run a mutation, you first call `useUpdateDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDepartmentMutation, { data, loading, error }] = useUpdateDepartmentMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      leaderId: // value for 'leaderId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>(UpdateDepartmentDocument, options);
      }
export type UpdateDepartmentMutationHookResult = ReturnType<typeof useUpdateDepartmentMutation>;
export type UpdateDepartmentMutationResult = Apollo.MutationResult<UpdateDepartmentMutation>;
export type UpdateDepartmentMutationOptions = Apollo.BaseMutationOptions<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>;
export const UpdateRollingNumberDocument = gql`
    mutation UpdateRollingNumber($contractorId: ID, $digitCount: Int!, $format: String!, $type: RollingNumberType!, $value: Int!) {
  updateRollingNumber(
    input: {type: $type, value: $value, format: $format, digitCount: $digitCount, contactId: $contractorId}
  ) {
    boolean
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type UpdateRollingNumberMutationFn = Apollo.MutationFunction<UpdateRollingNumberMutation, UpdateRollingNumberMutationVariables>;

/**
 * __useUpdateRollingNumberMutation__
 *
 * To run a mutation, you first call `useUpdateRollingNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRollingNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRollingNumberMutation, { data, loading, error }] = useUpdateRollingNumberMutation({
 *   variables: {
 *      contractorId: // value for 'contractorId'
 *      digitCount: // value for 'digitCount'
 *      format: // value for 'format'
 *      type: // value for 'type'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateRollingNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRollingNumberMutation, UpdateRollingNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRollingNumberMutation, UpdateRollingNumberMutationVariables>(UpdateRollingNumberDocument, options);
      }
export type UpdateRollingNumberMutationHookResult = ReturnType<typeof useUpdateRollingNumberMutation>;
export type UpdateRollingNumberMutationResult = Apollo.MutationResult<UpdateRollingNumberMutation>;
export type UpdateRollingNumberMutationOptions = Apollo.BaseMutationOptions<UpdateRollingNumberMutation, UpdateRollingNumberMutationVariables>;
export const UpdateSaleableServiceDocument = gql`
    mutation UpdateSaleableService($groupId: ID!, $id: ID!, $name: String!, $purchasePrice: Decimal!, $sellingPrice: Decimal!, $unitId: ID!, $vatRate: Decimal!) {
  updateSaleableService(
    input: {groupId: $groupId, id: $id, name: $name, purchasePrice: $purchasePrice, unitId: $unitId, sellingPrice: $sellingPrice, vatRate: $vatRate}
  ) {
    saleableService {
      id
      name
      purchasePrice
      sellingPrice
      vatRate
      unit {
        id
        name
        shortCode
      }
      saleableServiceGroupId
      saleableUnitId
    }
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on DomainError {
        errorType
        message
      }
    }
  }
}
    `;
export type UpdateSaleableServiceMutationFn = Apollo.MutationFunction<UpdateSaleableServiceMutation, UpdateSaleableServiceMutationVariables>;

/**
 * __useUpdateSaleableServiceMutation__
 *
 * To run a mutation, you first call `useUpdateSaleableServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSaleableServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSaleableServiceMutation, { data, loading, error }] = useUpdateSaleableServiceMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      purchasePrice: // value for 'purchasePrice'
 *      sellingPrice: // value for 'sellingPrice'
 *      unitId: // value for 'unitId'
 *      vatRate: // value for 'vatRate'
 *   },
 * });
 */
export function useUpdateSaleableServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSaleableServiceMutation, UpdateSaleableServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSaleableServiceMutation, UpdateSaleableServiceMutationVariables>(UpdateSaleableServiceDocument, options);
      }
export type UpdateSaleableServiceMutationHookResult = ReturnType<typeof useUpdateSaleableServiceMutation>;
export type UpdateSaleableServiceMutationResult = Apollo.MutationResult<UpdateSaleableServiceMutation>;
export type UpdateSaleableServiceMutationOptions = Apollo.BaseMutationOptions<UpdateSaleableServiceMutation, UpdateSaleableServiceMutationVariables>;
export const UpdateSaleableServiceGroupDocument = gql`
    mutation UpdateSaleableServiceGroup($id: ID!, $name: String!, $sellingPrice: Decimal!) {
  updateSaleableServiceGroup(
    input: {id: $id, name: $name, sellingPrice: $sellingPrice}
  ) {
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on DomainError {
        errorType
        message
      }
    }
    saleableServiceGroup {
      id
      name
      sellingPrice
      services {
        id
        name
        purchasePrice
        sellingPrice
        vatRate
        unit {
          id
          name
          shortCode
        }
        saleableServiceGroupId
        saleableUnitId
      }
    }
  }
}
    `;
export type UpdateSaleableServiceGroupMutationFn = Apollo.MutationFunction<UpdateSaleableServiceGroupMutation, UpdateSaleableServiceGroupMutationVariables>;

/**
 * __useUpdateSaleableServiceGroupMutation__
 *
 * To run a mutation, you first call `useUpdateSaleableServiceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSaleableServiceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSaleableServiceGroupMutation, { data, loading, error }] = useUpdateSaleableServiceGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      sellingPrice: // value for 'sellingPrice'
 *   },
 * });
 */
export function useUpdateSaleableServiceGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSaleableServiceGroupMutation, UpdateSaleableServiceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSaleableServiceGroupMutation, UpdateSaleableServiceGroupMutationVariables>(UpdateSaleableServiceGroupDocument, options);
      }
export type UpdateSaleableServiceGroupMutationHookResult = ReturnType<typeof useUpdateSaleableServiceGroupMutation>;
export type UpdateSaleableServiceGroupMutationResult = Apollo.MutationResult<UpdateSaleableServiceGroupMutation>;
export type UpdateSaleableServiceGroupMutationOptions = Apollo.BaseMutationOptions<UpdateSaleableServiceGroupMutation, UpdateSaleableServiceGroupMutationVariables>;
export const UpdateSaleableUnitDocument = gql`
    mutation UpdateSaleableUnit($id: ID!, $name: String!, $shortCode: String!) {
  updateSaleableUnit(input: {id: $id, name: $name, shortCode: $shortCode}) {
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on DomainError {
        errorType
        message
      }
    }
    saleableUnit {
      id
      name
      shortCode
    }
  }
}
    `;
export type UpdateSaleableUnitMutationFn = Apollo.MutationFunction<UpdateSaleableUnitMutation, UpdateSaleableUnitMutationVariables>;

/**
 * __useUpdateSaleableUnitMutation__
 *
 * To run a mutation, you first call `useUpdateSaleableUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSaleableUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSaleableUnitMutation, { data, loading, error }] = useUpdateSaleableUnitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      shortCode: // value for 'shortCode'
 *   },
 * });
 */
export function useUpdateSaleableUnitMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSaleableUnitMutation, UpdateSaleableUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSaleableUnitMutation, UpdateSaleableUnitMutationVariables>(UpdateSaleableUnitDocument, options);
      }
export type UpdateSaleableUnitMutationHookResult = ReturnType<typeof useUpdateSaleableUnitMutation>;
export type UpdateSaleableUnitMutationResult = Apollo.MutationResult<UpdateSaleableUnitMutation>;
export type UpdateSaleableUnitMutationOptions = Apollo.BaseMutationOptions<UpdateSaleableUnitMutation, UpdateSaleableUnitMutationVariables>;
export const WorksInDepartmentDocument = gql`
    mutation WorksInDepartment($contactId: ID!, $departmentId: ID!) {
  worksInDepartment(input: {contactId: $contactId, departmentId: $departmentId}) {
    worksInDepartmentInformation {
      id
    }
    errors {
      ... on EntityNotFoundError {
        entityId
        entityName
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type WorksInDepartmentMutationFn = Apollo.MutationFunction<WorksInDepartmentMutation, WorksInDepartmentMutationVariables>;

/**
 * __useWorksInDepartmentMutation__
 *
 * To run a mutation, you first call `useWorksInDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorksInDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [worksInDepartmentMutation, { data, loading, error }] = useWorksInDepartmentMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useWorksInDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<WorksInDepartmentMutation, WorksInDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorksInDepartmentMutation, WorksInDepartmentMutationVariables>(WorksInDepartmentDocument, options);
      }
export type WorksInDepartmentMutationHookResult = ReturnType<typeof useWorksInDepartmentMutation>;
export type WorksInDepartmentMutationResult = Apollo.MutationResult<WorksInDepartmentMutation>;
export type WorksInDepartmentMutationOptions = Apollo.BaseMutationOptions<WorksInDepartmentMutation, WorksInDepartmentMutationVariables>;
export const CreateTemplateDocument = gql`
    mutation CreateTemplate($contactId: ID!, $name: String!, $rendering: TemplateRendering!, $type: TemplateType!) {
  createTemplate(
    input: {contactId: $contactId, name: $name, rendering: $rendering, type: $type}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    template {
      contactId
      content
      id
      isDeleted
      name
      rendering
      type
      version
      footer
      header
    }
  }
}
    `;
export type CreateTemplateMutationFn = Apollo.MutationFunction<CreateTemplateMutation, CreateTemplateMutationVariables>;

/**
 * __useCreateTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateMutation, { data, loading, error }] = useCreateTemplateMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      name: // value for 'name'
 *      rendering: // value for 'rendering'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateTemplateMutation, CreateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemplateMutation, CreateTemplateMutationVariables>(CreateTemplateDocument, options);
      }
export type CreateTemplateMutationHookResult = ReturnType<typeof useCreateTemplateMutation>;
export type CreateTemplateMutationResult = Apollo.MutationResult<CreateTemplateMutation>;
export type CreateTemplateMutationOptions = Apollo.BaseMutationOptions<CreateTemplateMutation, CreateTemplateMutationVariables>;
export const DeleteTemplateDocument = gql`
    mutation DeleteTemplate($templateId: ID!) {
  deleteTemplate(input: {templateId: $templateId}) {
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    boolean
  }
}
    `;
export type DeleteTemplateMutationFn = Apollo.MutationFunction<DeleteTemplateMutation, DeleteTemplateMutationVariables>;

/**
 * __useDeleteTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateMutation, { data, loading, error }] = useDeleteTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useDeleteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTemplateMutation, DeleteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTemplateMutation, DeleteTemplateMutationVariables>(DeleteTemplateDocument, options);
      }
export type DeleteTemplateMutationHookResult = ReturnType<typeof useDeleteTemplateMutation>;
export type DeleteTemplateMutationResult = Apollo.MutationResult<DeleteTemplateMutation>;
export type DeleteTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteTemplateMutation, DeleteTemplateMutationVariables>;
export const GetAllTemplatesDocument = gql`
    query GetAllTemplates($first: Int, $last: Int, $after: String, $before: String, $contractorId: ID!, $filterByName: String, $filterByRendering: TemplateRendering, $filterByType: TemplateType, $order: OrderType, $showDeleted: Boolean) {
  allTemplates(
    after: $after
    before: $before
    contractorId: $contractorId
    filter: {filterByName: $filterByName, filterByRendering: $filterByRendering, filterByType: $filterByType, order: $order, showDeleted: $showDeleted}
    first: $first
    last: $last
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    nodes {
      contactId
      id
      isDeleted
      name
      rendering
      type
    }
  }
}
    `;

/**
 * __useGetAllTemplatesQuery__
 *
 * To run a query within a React component, call `useGetAllTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTemplatesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      contractorId: // value for 'contractorId'
 *      filterByName: // value for 'filterByName'
 *      filterByRendering: // value for 'filterByRendering'
 *      filterByType: // value for 'filterByType'
 *      order: // value for 'order'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useGetAllTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetAllTemplatesQuery, GetAllTemplatesQueryVariables> & ({ variables: GetAllTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTemplatesQuery, GetAllTemplatesQueryVariables>(GetAllTemplatesDocument, options);
      }
export function useGetAllTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTemplatesQuery, GetAllTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTemplatesQuery, GetAllTemplatesQueryVariables>(GetAllTemplatesDocument, options);
        }
export function useGetAllTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTemplatesQuery, GetAllTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTemplatesQuery, GetAllTemplatesQueryVariables>(GetAllTemplatesDocument, options);
        }
export type GetAllTemplatesQueryHookResult = ReturnType<typeof useGetAllTemplatesQuery>;
export type GetAllTemplatesLazyQueryHookResult = ReturnType<typeof useGetAllTemplatesLazyQuery>;
export type GetAllTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetAllTemplatesSuspenseQuery>;
export type GetAllTemplatesQueryResult = Apollo.QueryResult<GetAllTemplatesQuery, GetAllTemplatesQueryVariables>;
export const GetTemplateByIdDocument = gql`
    query GetTemplateById($templateId: ID!) {
  templateById(templateId: $templateId) {
    contactId
    content
    id
    isDeleted
    name
    rendering
    type
    version
    footer
    header
  }
}
    `;

/**
 * __useGetTemplateByIdQuery__
 *
 * To run a query within a React component, call `useGetTemplateByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplateByIdQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useGetTemplateByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTemplateByIdQuery, GetTemplateByIdQueryVariables> & ({ variables: GetTemplateByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTemplateByIdQuery, GetTemplateByIdQueryVariables>(GetTemplateByIdDocument, options);
      }
export function useGetTemplateByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemplateByIdQuery, GetTemplateByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTemplateByIdQuery, GetTemplateByIdQueryVariables>(GetTemplateByIdDocument, options);
        }
export function useGetTemplateByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTemplateByIdQuery, GetTemplateByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTemplateByIdQuery, GetTemplateByIdQueryVariables>(GetTemplateByIdDocument, options);
        }
export type GetTemplateByIdQueryHookResult = ReturnType<typeof useGetTemplateByIdQuery>;
export type GetTemplateByIdLazyQueryHookResult = ReturnType<typeof useGetTemplateByIdLazyQuery>;
export type GetTemplateByIdSuspenseQueryHookResult = ReturnType<typeof useGetTemplateByIdSuspenseQuery>;
export type GetTemplateByIdQueryResult = Apollo.QueryResult<GetTemplateByIdQuery, GetTemplateByIdQueryVariables>;
export const GetTemplateVariablesDocument = gql`
    query GetTemplateVariables($rendering: TemplateRendering!, $type: TemplateType!) {
  templateVariables(input: {rendering: $rendering, type: $type}) {
    display
    path
    template
  }
}
    `;

/**
 * __useGetTemplateVariablesQuery__
 *
 * To run a query within a React component, call `useGetTemplateVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplateVariablesQuery({
 *   variables: {
 *      rendering: // value for 'rendering'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetTemplateVariablesQuery(baseOptions: Apollo.QueryHookOptions<GetTemplateVariablesQuery, GetTemplateVariablesQueryVariables> & ({ variables: GetTemplateVariablesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTemplateVariablesQuery, GetTemplateVariablesQueryVariables>(GetTemplateVariablesDocument, options);
      }
export function useGetTemplateVariablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemplateVariablesQuery, GetTemplateVariablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTemplateVariablesQuery, GetTemplateVariablesQueryVariables>(GetTemplateVariablesDocument, options);
        }
export function useGetTemplateVariablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTemplateVariablesQuery, GetTemplateVariablesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTemplateVariablesQuery, GetTemplateVariablesQueryVariables>(GetTemplateVariablesDocument, options);
        }
export type GetTemplateVariablesQueryHookResult = ReturnType<typeof useGetTemplateVariablesQuery>;
export type GetTemplateVariablesLazyQueryHookResult = ReturnType<typeof useGetTemplateVariablesLazyQuery>;
export type GetTemplateVariablesSuspenseQueryHookResult = ReturnType<typeof useGetTemplateVariablesSuspenseQuery>;
export type GetTemplateVariablesQueryResult = Apollo.QueryResult<GetTemplateVariablesQuery, GetTemplateVariablesQueryVariables>;
export const UpdateTemplateDocument = gql`
    mutation UpdateTemplate($name: String!, $content: String!, $templateId: ID!, $header: String, $footer: String) {
  updateTemplate(
    input: {name: $name, content: $content, description: "", templateId: $templateId, footer: $footer, header: $header}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    boolean
  }
}
    `;
export type UpdateTemplateMutationFn = Apollo.MutationFunction<UpdateTemplateMutation, UpdateTemplateMutationVariables>;

/**
 * __useUpdateTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateMutation, { data, loading, error }] = useUpdateTemplateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      content: // value for 'content'
 *      templateId: // value for 'templateId'
 *      header: // value for 'header'
 *      footer: // value for 'footer'
 *   },
 * });
 */
export function useUpdateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTemplateMutation, UpdateTemplateMutationVariables>(UpdateTemplateDocument, options);
      }
export type UpdateTemplateMutationHookResult = ReturnType<typeof useUpdateTemplateMutation>;
export type UpdateTemplateMutationResult = Apollo.MutationResult<UpdateTemplateMutation>;
export type UpdateTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>;
export const AddApprovalToAllTimeEntriesDocument = gql`
    mutation AddApprovalToAllTimeEntries($message: String!, $approved: Boolean!, $endDate: LocalDate!, $startDate: LocalDate!, $employeeId: ID!) {
  addApprovalToAllTimeEntries(
    input: {message: $message, approved: $approved, employeeId: $employeeId, endDate: $endDate, startDate: $startDate}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on InvalidUserPrivilegesError {
        errorType
        message
      }
    }
    boolean
  }
}
    `;
export type AddApprovalToAllTimeEntriesMutationFn = Apollo.MutationFunction<AddApprovalToAllTimeEntriesMutation, AddApprovalToAllTimeEntriesMutationVariables>;

/**
 * __useAddApprovalToAllTimeEntriesMutation__
 *
 * To run a mutation, you first call `useAddApprovalToAllTimeEntriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddApprovalToAllTimeEntriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addApprovalToAllTimeEntriesMutation, { data, loading, error }] = useAddApprovalToAllTimeEntriesMutation({
 *   variables: {
 *      message: // value for 'message'
 *      approved: // value for 'approved'
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useAddApprovalToAllTimeEntriesMutation(baseOptions?: Apollo.MutationHookOptions<AddApprovalToAllTimeEntriesMutation, AddApprovalToAllTimeEntriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddApprovalToAllTimeEntriesMutation, AddApprovalToAllTimeEntriesMutationVariables>(AddApprovalToAllTimeEntriesDocument, options);
      }
export type AddApprovalToAllTimeEntriesMutationHookResult = ReturnType<typeof useAddApprovalToAllTimeEntriesMutation>;
export type AddApprovalToAllTimeEntriesMutationResult = Apollo.MutationResult<AddApprovalToAllTimeEntriesMutation>;
export type AddApprovalToAllTimeEntriesMutationOptions = Apollo.BaseMutationOptions<AddApprovalToAllTimeEntriesMutation, AddApprovalToAllTimeEntriesMutationVariables>;
export const AddApprovalToTimeEntryDocument = gql`
    mutation AddApprovalToTimeEntry($message: String!, $timeEntryId: ID!, $approved: Boolean!) {
  addApprovalToTimeEntry(
    input: {message: $message, timeEntryId: $timeEntryId, approved: $approved}
  ) {
    timeEntry {
      id
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on InvalidUserPrivilegesError {
        errorType
        message
      }
    }
  }
}
    `;
export type AddApprovalToTimeEntryMutationFn = Apollo.MutationFunction<AddApprovalToTimeEntryMutation, AddApprovalToTimeEntryMutationVariables>;

/**
 * __useAddApprovalToTimeEntryMutation__
 *
 * To run a mutation, you first call `useAddApprovalToTimeEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddApprovalToTimeEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addApprovalToTimeEntryMutation, { data, loading, error }] = useAddApprovalToTimeEntryMutation({
 *   variables: {
 *      message: // value for 'message'
 *      timeEntryId: // value for 'timeEntryId'
 *      approved: // value for 'approved'
 *   },
 * });
 */
export function useAddApprovalToTimeEntryMutation(baseOptions?: Apollo.MutationHookOptions<AddApprovalToTimeEntryMutation, AddApprovalToTimeEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddApprovalToTimeEntryMutation, AddApprovalToTimeEntryMutationVariables>(AddApprovalToTimeEntryDocument, options);
      }
export type AddApprovalToTimeEntryMutationHookResult = ReturnType<typeof useAddApprovalToTimeEntryMutation>;
export type AddApprovalToTimeEntryMutationResult = Apollo.MutationResult<AddApprovalToTimeEntryMutation>;
export type AddApprovalToTimeEntryMutationOptions = Apollo.BaseMutationOptions<AddApprovalToTimeEntryMutation, AddApprovalToTimeEntryMutationVariables>;
export const AddEmployeesToLabelGroupDocument = gql`
    mutation AddEmployeesToLabelGroup($employeeIds: [ID!]!, $id: ID!, $version: Long!) {
  addEmployeesToLabelGroup(
    input: {employees: $employeeIds, id: $id, version: $version}
  ) {
    errors {
      ... on ConcurrentAccessError {
        errorType
        message
      }
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    timeLabelGroup {
      companyId
      departmentIds
      employeeIds
      id
      isGlobal
      name
      version
      departments {
        companyId
        description
        id
        leaderId
        name
        version
      }
      employees {
        companyName
        contactNumber
        contactTypes
        displayContactType
        displayName
        firstName
        id
        isACompany
        isAFreelancer
        isAPerson
        isDeleted
        isContactPerson
        isEmployee
        isTemporary
        lastName
        salutation
        shortCode
        title
        version
      }
      labels {
        companyId
        departmentIds
        employeeIds
        id
        isActive
        isDeleted
        name
        version
      }
    }
  }
}
    `;
export type AddEmployeesToLabelGroupMutationFn = Apollo.MutationFunction<AddEmployeesToLabelGroupMutation, AddEmployeesToLabelGroupMutationVariables>;

/**
 * __useAddEmployeesToLabelGroupMutation__
 *
 * To run a mutation, you first call `useAddEmployeesToLabelGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEmployeesToLabelGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEmployeesToLabelGroupMutation, { data, loading, error }] = useAddEmployeesToLabelGroupMutation({
 *   variables: {
 *      employeeIds: // value for 'employeeIds'
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useAddEmployeesToLabelGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddEmployeesToLabelGroupMutation, AddEmployeesToLabelGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEmployeesToLabelGroupMutation, AddEmployeesToLabelGroupMutationVariables>(AddEmployeesToLabelGroupDocument, options);
      }
export type AddEmployeesToLabelGroupMutationHookResult = ReturnType<typeof useAddEmployeesToLabelGroupMutation>;
export type AddEmployeesToLabelGroupMutationResult = Apollo.MutationResult<AddEmployeesToLabelGroupMutation>;
export type AddEmployeesToLabelGroupMutationOptions = Apollo.BaseMutationOptions<AddEmployeesToLabelGroupMutation, AddEmployeesToLabelGroupMutationVariables>;
export const AddEmployeesToTimeLabelDocument = gql`
    mutation AddEmployeesToTimeLabel($employeeIds: [ID!]!, $id: ID!, $version: Long!) {
  addEmployeesToTimeLabel(
    input: {employeeIds: $employeeIds, id: $id, version: $version}
  ) {
    errors {
      ... on ConcurrentAccessError {
        errorType
        message
      }
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    timeLabel {
      companyId
      departmentIds
      employeeIds
      id
      isActive
      isDeleted
      name
      version
      departments {
        companyId
        description
        id
        leaderId
        name
        version
      }
      employees {
        companyName
        contactNumber
        contactTypes
        displayContactType
        displayName
        firstName
        id
        isACompany
        isAFreelancer
        isAPerson
        isDeleted
        isEmployee
        isContactPerson
        isTemporary
        lastName
        salutation
        shortCode
        title
        version
      }
    }
  }
}
    `;
export type AddEmployeesToTimeLabelMutationFn = Apollo.MutationFunction<AddEmployeesToTimeLabelMutation, AddEmployeesToTimeLabelMutationVariables>;

/**
 * __useAddEmployeesToTimeLabelMutation__
 *
 * To run a mutation, you first call `useAddEmployeesToTimeLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEmployeesToTimeLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEmployeesToTimeLabelMutation, { data, loading, error }] = useAddEmployeesToTimeLabelMutation({
 *   variables: {
 *      employeeIds: // value for 'employeeIds'
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useAddEmployeesToTimeLabelMutation(baseOptions?: Apollo.MutationHookOptions<AddEmployeesToTimeLabelMutation, AddEmployeesToTimeLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEmployeesToTimeLabelMutation, AddEmployeesToTimeLabelMutationVariables>(AddEmployeesToTimeLabelDocument, options);
      }
export type AddEmployeesToTimeLabelMutationHookResult = ReturnType<typeof useAddEmployeesToTimeLabelMutation>;
export type AddEmployeesToTimeLabelMutationResult = Apollo.MutationResult<AddEmployeesToTimeLabelMutation>;
export type AddEmployeesToTimeLabelMutationOptions = Apollo.BaseMutationOptions<AddEmployeesToTimeLabelMutation, AddEmployeesToTimeLabelMutationVariables>;
export const AddLabelGroupsToDepartmentDocument = gql`
    mutation AddLabelGroupsToDepartment($id: ID!, $timeLabelGroupsIds: [ID!]!) {
  addLabelGroupsToDepartment(
    input: {id: $id, timeLabelGroupsIds: $timeLabelGroupsIds}
  ) {
    boolean
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type AddLabelGroupsToDepartmentMutationFn = Apollo.MutationFunction<AddLabelGroupsToDepartmentMutation, AddLabelGroupsToDepartmentMutationVariables>;

/**
 * __useAddLabelGroupsToDepartmentMutation__
 *
 * To run a mutation, you first call `useAddLabelGroupsToDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLabelGroupsToDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLabelGroupsToDepartmentMutation, { data, loading, error }] = useAddLabelGroupsToDepartmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      timeLabelGroupsIds: // value for 'timeLabelGroupsIds'
 *   },
 * });
 */
export function useAddLabelGroupsToDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<AddLabelGroupsToDepartmentMutation, AddLabelGroupsToDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLabelGroupsToDepartmentMutation, AddLabelGroupsToDepartmentMutationVariables>(AddLabelGroupsToDepartmentDocument, options);
      }
export type AddLabelGroupsToDepartmentMutationHookResult = ReturnType<typeof useAddLabelGroupsToDepartmentMutation>;
export type AddLabelGroupsToDepartmentMutationResult = Apollo.MutationResult<AddLabelGroupsToDepartmentMutation>;
export type AddLabelGroupsToDepartmentMutationOptions = Apollo.BaseMutationOptions<AddLabelGroupsToDepartmentMutation, AddLabelGroupsToDepartmentMutationVariables>;
export const AddLabelsToDepartmentDocument = gql`
    mutation AddLabelsToDepartment($id: ID!, $labels: [ID!]!) {
  addLabelsToDepartment(input: {id: $id, timeLabelIds: $labels}) {
    boolean
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type AddLabelsToDepartmentMutationFn = Apollo.MutationFunction<AddLabelsToDepartmentMutation, AddLabelsToDepartmentMutationVariables>;

/**
 * __useAddLabelsToDepartmentMutation__
 *
 * To run a mutation, you first call `useAddLabelsToDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLabelsToDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLabelsToDepartmentMutation, { data, loading, error }] = useAddLabelsToDepartmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      labels: // value for 'labels'
 *   },
 * });
 */
export function useAddLabelsToDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<AddLabelsToDepartmentMutation, AddLabelsToDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLabelsToDepartmentMutation, AddLabelsToDepartmentMutationVariables>(AddLabelsToDepartmentDocument, options);
      }
export type AddLabelsToDepartmentMutationHookResult = ReturnType<typeof useAddLabelsToDepartmentMutation>;
export type AddLabelsToDepartmentMutationResult = Apollo.MutationResult<AddLabelsToDepartmentMutation>;
export type AddLabelsToDepartmentMutationOptions = Apollo.BaseMutationOptions<AddLabelsToDepartmentMutation, AddLabelsToDepartmentMutationVariables>;
export const AddLabelsToLabelGroupDocument = gql`
    mutation AddLabelsToLabelGroup($id: ID!, $labels: [ID!]!, $version: Long!) {
  addLabelsToLabelGroup(input: {id: $id, labels: $labels, version: $version}) {
    boolean
    errors {
      ... on ConcurrentAccessError {
        errorType
        message
      }
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type AddLabelsToLabelGroupMutationFn = Apollo.MutationFunction<AddLabelsToLabelGroupMutation, AddLabelsToLabelGroupMutationVariables>;

/**
 * __useAddLabelsToLabelGroupMutation__
 *
 * To run a mutation, you first call `useAddLabelsToLabelGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLabelsToLabelGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLabelsToLabelGroupMutation, { data, loading, error }] = useAddLabelsToLabelGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      labels: // value for 'labels'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useAddLabelsToLabelGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddLabelsToLabelGroupMutation, AddLabelsToLabelGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLabelsToLabelGroupMutation, AddLabelsToLabelGroupMutationVariables>(AddLabelsToLabelGroupDocument, options);
      }
export type AddLabelsToLabelGroupMutationHookResult = ReturnType<typeof useAddLabelsToLabelGroupMutation>;
export type AddLabelsToLabelGroupMutationResult = Apollo.MutationResult<AddLabelsToLabelGroupMutation>;
export type AddLabelsToLabelGroupMutationOptions = Apollo.BaseMutationOptions<AddLabelsToLabelGroupMutation, AddLabelsToLabelGroupMutationVariables>;
export const AddLogToAbsenceDocument = gql`
    mutation AddLogToAbsence($message: String!, $absenceId: ID!) {
  addLogToAbsence(input: {message: $message, absenceId: $absenceId}) {
    absence {
      id
      logs {
        createdBy {
          displayName
          id
        }
        message
        timestamp
        id
      }
      absenceReasonId
      absenceReasonName
      absenceReasonType
      createdBy {
        id
        displayName
      }
      delegateEmployee {
        id
        displayName
      }
      employee {
        displayName
        id
      }
      end
      history {
        absenceReasonId
        absenceReasonName
        end
        isHalfEndDay
        isHalfStartDay
        start
        status
        timestamp
        version
        createdBy {
          displayName
          id
        }
        delegateEmployee {
          displayName
          id
        }
      }
      isHalfEndDay
      isHalfStartDay
      start
      status
      timestamp
      version
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on InvalidUserPrivilegesError {
        errorType
        message
      }
    }
  }
}
    `;
export type AddLogToAbsenceMutationFn = Apollo.MutationFunction<AddLogToAbsenceMutation, AddLogToAbsenceMutationVariables>;

/**
 * __useAddLogToAbsenceMutation__
 *
 * To run a mutation, you first call `useAddLogToAbsenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLogToAbsenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLogToAbsenceMutation, { data, loading, error }] = useAddLogToAbsenceMutation({
 *   variables: {
 *      message: // value for 'message'
 *      absenceId: // value for 'absenceId'
 *   },
 * });
 */
export function useAddLogToAbsenceMutation(baseOptions?: Apollo.MutationHookOptions<AddLogToAbsenceMutation, AddLogToAbsenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLogToAbsenceMutation, AddLogToAbsenceMutationVariables>(AddLogToAbsenceDocument, options);
      }
export type AddLogToAbsenceMutationHookResult = ReturnType<typeof useAddLogToAbsenceMutation>;
export type AddLogToAbsenceMutationResult = Apollo.MutationResult<AddLogToAbsenceMutation>;
export type AddLogToAbsenceMutationOptions = Apollo.BaseMutationOptions<AddLogToAbsenceMutation, AddLogToAbsenceMutationVariables>;
export const AddLogToProjectTimeEntryDocument = gql`
    mutation AddLogToProjectTimeEntry($message: String!, $timeEntryId: ID!) {
  addLogToProjectTimeEntry(
    input: {message: $message, projectTimeEntryId: $timeEntryId}
  ) {
    projectTimeEntry {
      id
      logs {
        createdBy {
          displayName
          id
        }
        message
        timestamp
        id
      }
      createdBy {
        displayName
        id
      }
      description
      end
      errors
      history {
        id
        createdBy {
          id
          displayName
        }
        description
        end
        member {
          id
          displayName
        }
        start
        status
        timestamp
        version
        projectPositionId
        projectId
        memberId
        createdById
        projectPosition {
          projectName
          saleableServiceName
        }
      }
      member {
        id
        displayName
      }
      start
      status
      timestamp
      version
      memberId
      projectPositionId
      projectId
      createdById
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on InvalidUserPrivilegesError {
        errorType
        message
      }
    }
  }
}
    `;
export type AddLogToProjectTimeEntryMutationFn = Apollo.MutationFunction<AddLogToProjectTimeEntryMutation, AddLogToProjectTimeEntryMutationVariables>;

/**
 * __useAddLogToProjectTimeEntryMutation__
 *
 * To run a mutation, you first call `useAddLogToProjectTimeEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLogToProjectTimeEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLogToProjectTimeEntryMutation, { data, loading, error }] = useAddLogToProjectTimeEntryMutation({
 *   variables: {
 *      message: // value for 'message'
 *      timeEntryId: // value for 'timeEntryId'
 *   },
 * });
 */
export function useAddLogToProjectTimeEntryMutation(baseOptions?: Apollo.MutationHookOptions<AddLogToProjectTimeEntryMutation, AddLogToProjectTimeEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLogToProjectTimeEntryMutation, AddLogToProjectTimeEntryMutationVariables>(AddLogToProjectTimeEntryDocument, options);
      }
export type AddLogToProjectTimeEntryMutationHookResult = ReturnType<typeof useAddLogToProjectTimeEntryMutation>;
export type AddLogToProjectTimeEntryMutationResult = Apollo.MutationResult<AddLogToProjectTimeEntryMutation>;
export type AddLogToProjectTimeEntryMutationOptions = Apollo.BaseMutationOptions<AddLogToProjectTimeEntryMutation, AddLogToProjectTimeEntryMutationVariables>;
export const AddLogToTimeEntryDocument = gql`
    mutation AddLogToTimeEntry($message: String!, $timeEntryId: ID!) {
  addLogToTimeEntry(input: {message: $message, timeEntryId: $timeEntryId}) {
    timeEntry {
      id
      logs {
        createdBy {
          displayName
          id
        }
        message
        timestamp
        id
      }
      createdBy {
        displayName
        id
      }
      calendarId
      description
      end
      entryType
      errors
      history {
        createdBy {
          id
          displayName
        }
        description
        end
        entryType
        member {
          id
          displayName
        }
        start
        status
        timeLabel {
          name
          id
        }
        timestamp
        version
        workLocation
      }
      member {
        id
        displayName
      }
      path
      start
      status
      timeLabel {
        id
        name
      }
      timeLabelId
      timestamp
      title
      version
      workLocation
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on InvalidUserPrivilegesError {
        errorType
        message
      }
    }
  }
}
    `;
export type AddLogToTimeEntryMutationFn = Apollo.MutationFunction<AddLogToTimeEntryMutation, AddLogToTimeEntryMutationVariables>;

/**
 * __useAddLogToTimeEntryMutation__
 *
 * To run a mutation, you first call `useAddLogToTimeEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLogToTimeEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLogToTimeEntryMutation, { data, loading, error }] = useAddLogToTimeEntryMutation({
 *   variables: {
 *      message: // value for 'message'
 *      timeEntryId: // value for 'timeEntryId'
 *   },
 * });
 */
export function useAddLogToTimeEntryMutation(baseOptions?: Apollo.MutationHookOptions<AddLogToTimeEntryMutation, AddLogToTimeEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLogToTimeEntryMutation, AddLogToTimeEntryMutationVariables>(AddLogToTimeEntryDocument, options);
      }
export type AddLogToTimeEntryMutationHookResult = ReturnType<typeof useAddLogToTimeEntryMutation>;
export type AddLogToTimeEntryMutationResult = Apollo.MutationResult<AddLogToTimeEntryMutation>;
export type AddLogToTimeEntryMutationOptions = Apollo.BaseMutationOptions<AddLogToTimeEntryMutation, AddLogToTimeEntryMutationVariables>;
export const ApproveVacationDocument = gql`
    mutation ApproveVacation($absenceId: ID!, $comment: String, $isApproved: Boolean!, $version: Long!) {
  approveVacation(
    input: {absenceId: $absenceId, comment: $comment, isApproved: $isApproved, version: $version}
  ) {
    absence {
      id
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on InvalidUserPrivilegesError {
        errorType
        message
      }
    }
  }
}
    `;
export type ApproveVacationMutationFn = Apollo.MutationFunction<ApproveVacationMutation, ApproveVacationMutationVariables>;

/**
 * __useApproveVacationMutation__
 *
 * To run a mutation, you first call `useApproveVacationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveVacationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveVacationMutation, { data, loading, error }] = useApproveVacationMutation({
 *   variables: {
 *      absenceId: // value for 'absenceId'
 *      comment: // value for 'comment'
 *      isApproved: // value for 'isApproved'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useApproveVacationMutation(baseOptions?: Apollo.MutationHookOptions<ApproveVacationMutation, ApproveVacationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveVacationMutation, ApproveVacationMutationVariables>(ApproveVacationDocument, options);
      }
export type ApproveVacationMutationHookResult = ReturnType<typeof useApproveVacationMutation>;
export type ApproveVacationMutationResult = Apollo.MutationResult<ApproveVacationMutation>;
export type ApproveVacationMutationOptions = Apollo.BaseMutationOptions<ApproveVacationMutation, ApproveVacationMutationVariables>;
export const CheckVacationDocument = gql`
    query CheckVacation($startDate: LocalDate!, $isHalfStartDay: Boolean!, $endDate: LocalDate!, $isHalfEndDay: Boolean!, $employeeId: ID!, $absenceId: ID) {
  checkVacation(
    startDate: $startDate
    endDate: $endDate
    employeeId: $employeeId
    updatingAbsenceId: $absenceId
    isHalfEndDay: $isHalfEndDay
    isHalfStartDay: $isHalfStartDay
  ) {
    canBeTaken
    hasDelegateDuties
    isInSameYear
    isOverlapping
    leftDays
    neededDays
    startDateIsTooClose
  }
}
    `;

/**
 * __useCheckVacationQuery__
 *
 * To run a query within a React component, call `useCheckVacationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckVacationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckVacationQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      isHalfStartDay: // value for 'isHalfStartDay'
 *      endDate: // value for 'endDate'
 *      isHalfEndDay: // value for 'isHalfEndDay'
 *      employeeId: // value for 'employeeId'
 *      absenceId: // value for 'absenceId'
 *   },
 * });
 */
export function useCheckVacationQuery(baseOptions: Apollo.QueryHookOptions<CheckVacationQuery, CheckVacationQueryVariables> & ({ variables: CheckVacationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckVacationQuery, CheckVacationQueryVariables>(CheckVacationDocument, options);
      }
export function useCheckVacationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckVacationQuery, CheckVacationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckVacationQuery, CheckVacationQueryVariables>(CheckVacationDocument, options);
        }
export function useCheckVacationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckVacationQuery, CheckVacationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckVacationQuery, CheckVacationQueryVariables>(CheckVacationDocument, options);
        }
export type CheckVacationQueryHookResult = ReturnType<typeof useCheckVacationQuery>;
export type CheckVacationLazyQueryHookResult = ReturnType<typeof useCheckVacationLazyQuery>;
export type CheckVacationSuspenseQueryHookResult = ReturnType<typeof useCheckVacationSuspenseQuery>;
export type CheckVacationQueryResult = Apollo.QueryResult<CheckVacationQuery, CheckVacationQueryVariables>;
export const CreateAbsenceDocument = gql`
    mutation CreateAbsence($absenceReasonId: ID!, $comment: String, $delegateEmployeeId: ID!, $end: LocalDate!, $isHalfEndDay: Boolean!, $isHalfStartDay: Boolean!, $start: LocalDate!, $employeeId: ID!, $startWorkflow: Boolean) {
  createAbsence(
    input: {absenceReasonId: $absenceReasonId, comment: $comment, delegateEmployeeId: $delegateEmployeeId, end: $end, isHalfEndDay: $isHalfEndDay, isHalfStartDay: $isHalfStartDay, start: $start, employeeId: $employeeId, startWorkflow: $startWorkflow}
  ) {
    absence {
      id
      absenceReasonId
      absenceReasonName
      absenceReasonType
      createdBy {
        id
        displayName
      }
      delegateEmployee {
        displayName
        id
      }
      employee {
        displayName
        id
      }
      end
      history {
        absenceReasonId
        absenceReasonName
        end
        isHalfEndDay
        isHalfStartDay
        start
        status
        timestamp
        version
        createdBy {
          displayName
          id
        }
        delegateEmployee {
          displayName
          id
        }
        publicHolidays
        totalDays
        workDays
      }
      isHalfEndDay
      isHalfStartDay
      logs {
        createdBy {
          displayName
          id
        }
        id
        message
        timestamp
      }
      start
      status
      timestamp
      version
      publicHolidays
      totalDays
      workDays
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type CreateAbsenceMutationFn = Apollo.MutationFunction<CreateAbsenceMutation, CreateAbsenceMutationVariables>;

/**
 * __useCreateAbsenceMutation__
 *
 * To run a mutation, you first call `useCreateAbsenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAbsenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAbsenceMutation, { data, loading, error }] = useCreateAbsenceMutation({
 *   variables: {
 *      absenceReasonId: // value for 'absenceReasonId'
 *      comment: // value for 'comment'
 *      delegateEmployeeId: // value for 'delegateEmployeeId'
 *      end: // value for 'end'
 *      isHalfEndDay: // value for 'isHalfEndDay'
 *      isHalfStartDay: // value for 'isHalfStartDay'
 *      start: // value for 'start'
 *      employeeId: // value for 'employeeId'
 *      startWorkflow: // value for 'startWorkflow'
 *   },
 * });
 */
export function useCreateAbsenceMutation(baseOptions?: Apollo.MutationHookOptions<CreateAbsenceMutation, CreateAbsenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAbsenceMutation, CreateAbsenceMutationVariables>(CreateAbsenceDocument, options);
      }
export type CreateAbsenceMutationHookResult = ReturnType<typeof useCreateAbsenceMutation>;
export type CreateAbsenceMutationResult = Apollo.MutationResult<CreateAbsenceMutation>;
export type CreateAbsenceMutationOptions = Apollo.BaseMutationOptions<CreateAbsenceMutation, CreateAbsenceMutationVariables>;
export const CreateAbsenceReasonDocument = gql`
    mutation CreateAbsenceReason($description: String!, $isPaid: Boolean!, $isVisible: Boolean!, $maximumContinuedPayment: Int, $name: String!, $removesWorkingHours: Boolean!, $type: AbsenceReasonType!) {
  createAbsenceReason(
    input: {description: $description, isPaid: $isPaid, isVisible: $isVisible, maximumContinuedPayment: $maximumContinuedPayment, name: $name, removesWorkingHours: $removesWorkingHours, type: $type}
  ) {
    absenceReason {
      id
      name
      description
      isVisible
      isDeleted
      isPaid
      maximumContinuedPayment
      removesWorkingHours
      type
      version
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type CreateAbsenceReasonMutationFn = Apollo.MutationFunction<CreateAbsenceReasonMutation, CreateAbsenceReasonMutationVariables>;

/**
 * __useCreateAbsenceReasonMutation__
 *
 * To run a mutation, you first call `useCreateAbsenceReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAbsenceReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAbsenceReasonMutation, { data, loading, error }] = useCreateAbsenceReasonMutation({
 *   variables: {
 *      description: // value for 'description'
 *      isPaid: // value for 'isPaid'
 *      isVisible: // value for 'isVisible'
 *      maximumContinuedPayment: // value for 'maximumContinuedPayment'
 *      name: // value for 'name'
 *      removesWorkingHours: // value for 'removesWorkingHours'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateAbsenceReasonMutation(baseOptions?: Apollo.MutationHookOptions<CreateAbsenceReasonMutation, CreateAbsenceReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAbsenceReasonMutation, CreateAbsenceReasonMutationVariables>(CreateAbsenceReasonDocument, options);
      }
export type CreateAbsenceReasonMutationHookResult = ReturnType<typeof useCreateAbsenceReasonMutation>;
export type CreateAbsenceReasonMutationResult = Apollo.MutationResult<CreateAbsenceReasonMutation>;
export type CreateAbsenceReasonMutationOptions = Apollo.BaseMutationOptions<CreateAbsenceReasonMutation, CreateAbsenceReasonMutationVariables>;
export const CreateCalendarEventDocument = gql`
    mutation CreateCalendarEvent($description: String!, $endDate: LocalDate!, $federalStateCodes: [String!]!, $isHalfEndDay: Boolean!, $isHalfStartDay: Boolean!, $isVacation: Boolean!, $locations: [String!]!, $startDate: LocalDate!, $type: CalendarEventType!) {
  createCalendarEvent(
    input: {description: $description, endDate: $endDate, federalStateCodes: $federalStateCodes, isHalfEndDay: $isHalfEndDay, isHalfStartDay: $isHalfStartDay, isVacation: $isVacation, locations: $locations, startDate: $startDate, type: $type}
  ) {
    calendarEvent {
      id
      startDate
      isHalfStartDay
      endDate
      isHalfEndDay
      type
      isVacation
      description
      federalStateCodes
      locations
      version
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type CreateCalendarEventMutationFn = Apollo.MutationFunction<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>;

/**
 * __useCreateCalendarEventMutation__
 *
 * To run a mutation, you first call `useCreateCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCalendarEventMutation, { data, loading, error }] = useCreateCalendarEventMutation({
 *   variables: {
 *      description: // value for 'description'
 *      endDate: // value for 'endDate'
 *      federalStateCodes: // value for 'federalStateCodes'
 *      isHalfEndDay: // value for 'isHalfEndDay'
 *      isHalfStartDay: // value for 'isHalfStartDay'
 *      isVacation: // value for 'isVacation'
 *      locations: // value for 'locations'
 *      startDate: // value for 'startDate'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>(CreateCalendarEventDocument, options);
      }
export type CreateCalendarEventMutationHookResult = ReturnType<typeof useCreateCalendarEventMutation>;
export type CreateCalendarEventMutationResult = Apollo.MutationResult<CreateCalendarEventMutation>;
export type CreateCalendarEventMutationOptions = Apollo.BaseMutationOptions<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>;
export const CreateTimeBalanceEntryDocument = gql`
    mutation CreateTimeBalanceEntry($employeeId: ID!, $date: LocalDate!, $type: TimeBalanceType!, $vacationDays: Decimal, $overtime: TimeSpan, $reason: String!) {
  createTimeBalanceEntry(
    input: {employeeId: $employeeId, date: $date, type: $type, vacationDays: $vacationDays, overtime: $overtime, reason: $reason}
  ) {
    timeBalanceEntry {
      id
      createdById
      createdBy {
        id
        displayName
      }
      date
      employeeId
      history {
        createdBy {
          id
          displayName
        }
        createdById
        date
        isDeleted
        overtime
        reason
        timestamp
        type
        vacationDays
      }
      isDeleted
      overtime
      reason
      timestamp
      type
      vacationDays
      version
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type CreateTimeBalanceEntryMutationFn = Apollo.MutationFunction<CreateTimeBalanceEntryMutation, CreateTimeBalanceEntryMutationVariables>;

/**
 * __useCreateTimeBalanceEntryMutation__
 *
 * To run a mutation, you first call `useCreateTimeBalanceEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimeBalanceEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTimeBalanceEntryMutation, { data, loading, error }] = useCreateTimeBalanceEntryMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      date: // value for 'date'
 *      type: // value for 'type'
 *      vacationDays: // value for 'vacationDays'
 *      overtime: // value for 'overtime'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCreateTimeBalanceEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateTimeBalanceEntryMutation, CreateTimeBalanceEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTimeBalanceEntryMutation, CreateTimeBalanceEntryMutationVariables>(CreateTimeBalanceEntryDocument, options);
      }
export type CreateTimeBalanceEntryMutationHookResult = ReturnType<typeof useCreateTimeBalanceEntryMutation>;
export type CreateTimeBalanceEntryMutationResult = Apollo.MutationResult<CreateTimeBalanceEntryMutation>;
export type CreateTimeBalanceEntryMutationOptions = Apollo.BaseMutationOptions<CreateTimeBalanceEntryMutation, CreateTimeBalanceEntryMutationVariables>;
export const CreateTimeLabelDocument = gql`
    mutation CreateTimeLabel($companyId: ID!, $isActive: Boolean!, $name: String!) {
  createTimeLabel(
    input: {companyId: $companyId, isActive: $isActive, name: $name}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    timeLabel {
      companyId
      departmentIds
      employeeIds
      id
      isActive
      isDeleted
      name
      version
      departments {
        companyId
        description
        id
        leaderId
        name
        version
      }
      employees {
        companyName
        contactNumber
        contactTypes
        displayContactType
        displayName
        firstName
        id
        isACompany
        isAFreelancer
        isAPerson
        isDeleted
        isContactPerson
        isEmployee
        isTemporary
        lastName
        salutation
        shortCode
        title
        version
      }
    }
  }
}
    `;
export type CreateTimeLabelMutationFn = Apollo.MutationFunction<CreateTimeLabelMutation, CreateTimeLabelMutationVariables>;

/**
 * __useCreateTimeLabelMutation__
 *
 * To run a mutation, you first call `useCreateTimeLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimeLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTimeLabelMutation, { data, loading, error }] = useCreateTimeLabelMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      isActive: // value for 'isActive'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateTimeLabelMutation(baseOptions?: Apollo.MutationHookOptions<CreateTimeLabelMutation, CreateTimeLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTimeLabelMutation, CreateTimeLabelMutationVariables>(CreateTimeLabelDocument, options);
      }
export type CreateTimeLabelMutationHookResult = ReturnType<typeof useCreateTimeLabelMutation>;
export type CreateTimeLabelMutationResult = Apollo.MutationResult<CreateTimeLabelMutation>;
export type CreateTimeLabelMutationOptions = Apollo.BaseMutationOptions<CreateTimeLabelMutation, CreateTimeLabelMutationVariables>;
export const CreateTimeLabelGroupDocument = gql`
    mutation CreateTimeLabelGroup($companyId: ID!, $isGlobal: Boolean!, $name: String!) {
  createTimeLabelGroup(
    input: {companyId: $companyId, isGlobal: $isGlobal, name: $name}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    timeLabelGroup {
      companyId
      departmentIds
      employeeIds
      id
      name
      version
      isGlobal
      labels {
        companyId
        departmentIds
        employeeIds
        id
        isActive
        isDeleted
        name
        version
        departments {
          companyId
          description
          id
          leaderId
          name
          version
        }
        employees {
          companyName
          contactNumber
          contactTypes
          displayContactType
          displayName
          firstName
          id
          isACompany
          isAFreelancer
          isAPerson
          isDeleted
          isContactPerson
          isEmployee
          isTemporary
          lastName
          salutation
          shortCode
          title
          version
        }
      }
      departments {
        companyId
        description
        id
        leaderId
        name
        version
      }
      employees {
        companyName
        contactNumber
        contactTypes
        displayContactType
        displayName
        firstName
        id
        isACompany
        isAFreelancer
        isAPerson
        isDeleted
        isContactPerson
        isEmployee
        isTemporary
        lastName
        salutation
        shortCode
        title
        version
      }
    }
  }
}
    `;
export type CreateTimeLabelGroupMutationFn = Apollo.MutationFunction<CreateTimeLabelGroupMutation, CreateTimeLabelGroupMutationVariables>;

/**
 * __useCreateTimeLabelGroupMutation__
 *
 * To run a mutation, you first call `useCreateTimeLabelGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimeLabelGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTimeLabelGroupMutation, { data, loading, error }] = useCreateTimeLabelGroupMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      isGlobal: // value for 'isGlobal'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateTimeLabelGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateTimeLabelGroupMutation, CreateTimeLabelGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTimeLabelGroupMutation, CreateTimeLabelGroupMutationVariables>(CreateTimeLabelGroupDocument, options);
      }
export type CreateTimeLabelGroupMutationHookResult = ReturnType<typeof useCreateTimeLabelGroupMutation>;
export type CreateTimeLabelGroupMutationResult = Apollo.MutationResult<CreateTimeLabelGroupMutation>;
export type CreateTimeLabelGroupMutationOptions = Apollo.BaseMutationOptions<CreateTimeLabelGroupMutation, CreateTimeLabelGroupMutationVariables>;
export const CreateWorkingTimeModelDocument = gql`
    mutation CreateWorkingTimeModel($description: String!, $hoursPerFriday: Decimal!, $hoursPerMonday: Decimal!, $hoursPerSaturday: Decimal!, $hoursPerSunday: Decimal!, $hoursPerThursday: Decimal!, $hoursPerTuesday: Decimal!, $hoursPerWednesday: Decimal!, $hoursPerWeek: Decimal!, $isFlexible: Boolean!, $isVisible: Boolean!, $name: String!, $vacationDaysPerYear: Decimal!) {
  createWorkingTimeModel(
    input: {description: $description, hoursPerFriday: $hoursPerFriday, hoursPerMonday: $hoursPerMonday, hoursPerSaturday: $hoursPerSaturday, hoursPerSunday: $hoursPerSunday, hoursPerThursday: $hoursPerThursday, hoursPerTuesday: $hoursPerTuesday, hoursPerWednesday: $hoursPerWednesday, hoursPerWeek: $hoursPerWeek, isFlexible: $isFlexible, isVisible: $isVisible, name: $name, vacationDaysPerYear: $vacationDaysPerYear}
  ) {
    workingTimeModel {
      id
      description
      hoursPerFriday
      hoursPerMonday
      hoursPerSaturday
      hoursPerSunday
      hoursPerThursday
      hoursPerTuesday
      hoursPerWednesday
      hoursPerWeek
      isDeleted
      isFlexible
      isVisible
      name
      vacationDaysPerYear
      version
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type CreateWorkingTimeModelMutationFn = Apollo.MutationFunction<CreateWorkingTimeModelMutation, CreateWorkingTimeModelMutationVariables>;

/**
 * __useCreateWorkingTimeModelMutation__
 *
 * To run a mutation, you first call `useCreateWorkingTimeModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkingTimeModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkingTimeModelMutation, { data, loading, error }] = useCreateWorkingTimeModelMutation({
 *   variables: {
 *      description: // value for 'description'
 *      hoursPerFriday: // value for 'hoursPerFriday'
 *      hoursPerMonday: // value for 'hoursPerMonday'
 *      hoursPerSaturday: // value for 'hoursPerSaturday'
 *      hoursPerSunday: // value for 'hoursPerSunday'
 *      hoursPerThursday: // value for 'hoursPerThursday'
 *      hoursPerTuesday: // value for 'hoursPerTuesday'
 *      hoursPerWednesday: // value for 'hoursPerWednesday'
 *      hoursPerWeek: // value for 'hoursPerWeek'
 *      isFlexible: // value for 'isFlexible'
 *      isVisible: // value for 'isVisible'
 *      name: // value for 'name'
 *      vacationDaysPerYear: // value for 'vacationDaysPerYear'
 *   },
 * });
 */
export function useCreateWorkingTimeModelMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkingTimeModelMutation, CreateWorkingTimeModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkingTimeModelMutation, CreateWorkingTimeModelMutationVariables>(CreateWorkingTimeModelDocument, options);
      }
export type CreateWorkingTimeModelMutationHookResult = ReturnType<typeof useCreateWorkingTimeModelMutation>;
export type CreateWorkingTimeModelMutationResult = Apollo.MutationResult<CreateWorkingTimeModelMutation>;
export type CreateWorkingTimeModelMutationOptions = Apollo.BaseMutationOptions<CreateWorkingTimeModelMutation, CreateWorkingTimeModelMutationVariables>;
export const DeleteAbsenceDocument = gql`
    mutation DeleteAbsence($comment: String, $absenceId: ID!, $version: Long!) {
  deleteAbsence(
    input: {comment: $comment, absenceId: $absenceId, version: $version}
  ) {
    absence {
      id
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type DeleteAbsenceMutationFn = Apollo.MutationFunction<DeleteAbsenceMutation, DeleteAbsenceMutationVariables>;

/**
 * __useDeleteAbsenceMutation__
 *
 * To run a mutation, you first call `useDeleteAbsenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAbsenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAbsenceMutation, { data, loading, error }] = useDeleteAbsenceMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *      absenceId: // value for 'absenceId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useDeleteAbsenceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAbsenceMutation, DeleteAbsenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAbsenceMutation, DeleteAbsenceMutationVariables>(DeleteAbsenceDocument, options);
      }
export type DeleteAbsenceMutationHookResult = ReturnType<typeof useDeleteAbsenceMutation>;
export type DeleteAbsenceMutationResult = Apollo.MutationResult<DeleteAbsenceMutation>;
export type DeleteAbsenceMutationOptions = Apollo.BaseMutationOptions<DeleteAbsenceMutation, DeleteAbsenceMutationVariables>;
export const DeleteAbsenceReasonDocument = gql`
    mutation DeleteAbsenceReason($id: ID!) {
  deleteAbsenceReason(input: {id: $id}) {
    boolean
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on DomainError {
        errorType
        message
      }
    }
  }
}
    `;
export type DeleteAbsenceReasonMutationFn = Apollo.MutationFunction<DeleteAbsenceReasonMutation, DeleteAbsenceReasonMutationVariables>;

/**
 * __useDeleteAbsenceReasonMutation__
 *
 * To run a mutation, you first call `useDeleteAbsenceReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAbsenceReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAbsenceReasonMutation, { data, loading, error }] = useDeleteAbsenceReasonMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAbsenceReasonMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAbsenceReasonMutation, DeleteAbsenceReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAbsenceReasonMutation, DeleteAbsenceReasonMutationVariables>(DeleteAbsenceReasonDocument, options);
      }
export type DeleteAbsenceReasonMutationHookResult = ReturnType<typeof useDeleteAbsenceReasonMutation>;
export type DeleteAbsenceReasonMutationResult = Apollo.MutationResult<DeleteAbsenceReasonMutation>;
export type DeleteAbsenceReasonMutationOptions = Apollo.BaseMutationOptions<DeleteAbsenceReasonMutation, DeleteAbsenceReasonMutationVariables>;
export const DeleteCalendarEventDocument = gql`
    mutation DeleteCalendarEvent($id: ID!) {
  deleteCalendarEvent(input: {id: $id}) {
    boolean
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type DeleteCalendarEventMutationFn = Apollo.MutationFunction<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables>;

/**
 * __useDeleteCalendarEventMutation__
 *
 * To run a mutation, you first call `useDeleteCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCalendarEventMutation, { data, loading, error }] = useDeleteCalendarEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables>(DeleteCalendarEventDocument, options);
      }
export type DeleteCalendarEventMutationHookResult = ReturnType<typeof useDeleteCalendarEventMutation>;
export type DeleteCalendarEventMutationResult = Apollo.MutationResult<DeleteCalendarEventMutation>;
export type DeleteCalendarEventMutationOptions = Apollo.BaseMutationOptions<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables>;
export const DeleteMyTimerDocument = gql`
    mutation DeleteMyTimer {
  myDeleteTimer {
    errors {
      ... on DomainError {
        errorType
        message
      }
    }
    boolean
  }
}
    `;
export type DeleteMyTimerMutationFn = Apollo.MutationFunction<DeleteMyTimerMutation, DeleteMyTimerMutationVariables>;

/**
 * __useDeleteMyTimerMutation__
 *
 * To run a mutation, you first call `useDeleteMyTimerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMyTimerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMyTimerMutation, { data, loading, error }] = useDeleteMyTimerMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteMyTimerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMyTimerMutation, DeleteMyTimerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMyTimerMutation, DeleteMyTimerMutationVariables>(DeleteMyTimerDocument, options);
      }
export type DeleteMyTimerMutationHookResult = ReturnType<typeof useDeleteMyTimerMutation>;
export type DeleteMyTimerMutationResult = Apollo.MutationResult<DeleteMyTimerMutation>;
export type DeleteMyTimerMutationOptions = Apollo.BaseMutationOptions<DeleteMyTimerMutation, DeleteMyTimerMutationVariables>;
export const DeleteTimeBalanceEntryDocument = gql`
    mutation DeleteTimeBalanceEntry($id: ID!, $reason: String!, $version: Long!) {
  deleteTimeBalanceEntry(input: {id: $id, reason: $reason, version: $version}) {
    errors {
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    timeBalanceEntry {
      id
    }
  }
}
    `;
export type DeleteTimeBalanceEntryMutationFn = Apollo.MutationFunction<DeleteTimeBalanceEntryMutation, DeleteTimeBalanceEntryMutationVariables>;

/**
 * __useDeleteTimeBalanceEntryMutation__
 *
 * To run a mutation, you first call `useDeleteTimeBalanceEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeBalanceEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeBalanceEntryMutation, { data, loading, error }] = useDeleteTimeBalanceEntryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useDeleteTimeBalanceEntryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeBalanceEntryMutation, DeleteTimeBalanceEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTimeBalanceEntryMutation, DeleteTimeBalanceEntryMutationVariables>(DeleteTimeBalanceEntryDocument, options);
      }
export type DeleteTimeBalanceEntryMutationHookResult = ReturnType<typeof useDeleteTimeBalanceEntryMutation>;
export type DeleteTimeBalanceEntryMutationResult = Apollo.MutationResult<DeleteTimeBalanceEntryMutation>;
export type DeleteTimeBalanceEntryMutationOptions = Apollo.BaseMutationOptions<DeleteTimeBalanceEntryMutation, DeleteTimeBalanceEntryMutationVariables>;
export const DeleteTimeLabelDocument = gql`
    mutation DeleteTimeLabel($id: ID!, $version: Long!) {
  deleteTimeLabel(input: {id: $id, version: $version}) {
    boolean
    errors {
      ... on ConcurrentAccessError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type DeleteTimeLabelMutationFn = Apollo.MutationFunction<DeleteTimeLabelMutation, DeleteTimeLabelMutationVariables>;

/**
 * __useDeleteTimeLabelMutation__
 *
 * To run a mutation, you first call `useDeleteTimeLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeLabelMutation, { data, loading, error }] = useDeleteTimeLabelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useDeleteTimeLabelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeLabelMutation, DeleteTimeLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTimeLabelMutation, DeleteTimeLabelMutationVariables>(DeleteTimeLabelDocument, options);
      }
export type DeleteTimeLabelMutationHookResult = ReturnType<typeof useDeleteTimeLabelMutation>;
export type DeleteTimeLabelMutationResult = Apollo.MutationResult<DeleteTimeLabelMutation>;
export type DeleteTimeLabelMutationOptions = Apollo.BaseMutationOptions<DeleteTimeLabelMutation, DeleteTimeLabelMutationVariables>;
export const DeleteTimeLabelGroupDocument = gql`
    mutation DeleteTimeLabelGroup($id: ID!, $version: Long!) {
  deleteTimeLabelGroup(input: {id: $id, version: $version}) {
    boolean
    errors {
      ... on ConcurrentAccessError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type DeleteTimeLabelGroupMutationFn = Apollo.MutationFunction<DeleteTimeLabelGroupMutation, DeleteTimeLabelGroupMutationVariables>;

/**
 * __useDeleteTimeLabelGroupMutation__
 *
 * To run a mutation, you first call `useDeleteTimeLabelGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeLabelGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeLabelGroupMutation, { data, loading, error }] = useDeleteTimeLabelGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useDeleteTimeLabelGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeLabelGroupMutation, DeleteTimeLabelGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTimeLabelGroupMutation, DeleteTimeLabelGroupMutationVariables>(DeleteTimeLabelGroupDocument, options);
      }
export type DeleteTimeLabelGroupMutationHookResult = ReturnType<typeof useDeleteTimeLabelGroupMutation>;
export type DeleteTimeLabelGroupMutationResult = Apollo.MutationResult<DeleteTimeLabelGroupMutation>;
export type DeleteTimeLabelGroupMutationOptions = Apollo.BaseMutationOptions<DeleteTimeLabelGroupMutation, DeleteTimeLabelGroupMutationVariables>;
export const DeleteWorkingTimeModelDocument = gql`
    mutation DeleteWorkingTimeModel($id: ID!) {
  deleteWorkingTimeModel(input: {id: $id}) {
    boolean
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type DeleteWorkingTimeModelMutationFn = Apollo.MutationFunction<DeleteWorkingTimeModelMutation, DeleteWorkingTimeModelMutationVariables>;

/**
 * __useDeleteWorkingTimeModelMutation__
 *
 * To run a mutation, you first call `useDeleteWorkingTimeModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkingTimeModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkingTimeModelMutation, { data, loading, error }] = useDeleteWorkingTimeModelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWorkingTimeModelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkingTimeModelMutation, DeleteWorkingTimeModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkingTimeModelMutation, DeleteWorkingTimeModelMutationVariables>(DeleteWorkingTimeModelDocument, options);
      }
export type DeleteWorkingTimeModelMutationHookResult = ReturnType<typeof useDeleteWorkingTimeModelMutation>;
export type DeleteWorkingTimeModelMutationResult = Apollo.MutationResult<DeleteWorkingTimeModelMutation>;
export type DeleteWorkingTimeModelMutationOptions = Apollo.BaseMutationOptions<DeleteWorkingTimeModelMutation, DeleteWorkingTimeModelMutationVariables>;
export const GetAllAbsenceOverviewRequestsDocument = gql`
    query GetAllAbsenceOverviewRequests($first: Int, $after: String, $startDate: LocalDate!, $endDate: LocalDate!) {
  allAbsenceOverviewRequests(
    first: $first
    after: $after
    filter: {endDate: $endDate, startDate: $startDate}
  ) {
    nodes {
      spentHolidays
      totalSickDays
      contact {
        displayName
        id
      }
      contactId
      details {
        absenceReasonName
        end
        isHalfEndDay
        isHalfStartDay
        start
        status
        publicHolidays
        totalDays
        workDays
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllAbsenceOverviewRequestsQuery__
 *
 * To run a query within a React component, call `useGetAllAbsenceOverviewRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAbsenceOverviewRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAbsenceOverviewRequestsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetAllAbsenceOverviewRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetAllAbsenceOverviewRequestsQuery, GetAllAbsenceOverviewRequestsQueryVariables> & ({ variables: GetAllAbsenceOverviewRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAbsenceOverviewRequestsQuery, GetAllAbsenceOverviewRequestsQueryVariables>(GetAllAbsenceOverviewRequestsDocument, options);
      }
export function useGetAllAbsenceOverviewRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAbsenceOverviewRequestsQuery, GetAllAbsenceOverviewRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAbsenceOverviewRequestsQuery, GetAllAbsenceOverviewRequestsQueryVariables>(GetAllAbsenceOverviewRequestsDocument, options);
        }
export function useGetAllAbsenceOverviewRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAbsenceOverviewRequestsQuery, GetAllAbsenceOverviewRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAbsenceOverviewRequestsQuery, GetAllAbsenceOverviewRequestsQueryVariables>(GetAllAbsenceOverviewRequestsDocument, options);
        }
export type GetAllAbsenceOverviewRequestsQueryHookResult = ReturnType<typeof useGetAllAbsenceOverviewRequestsQuery>;
export type GetAllAbsenceOverviewRequestsLazyQueryHookResult = ReturnType<typeof useGetAllAbsenceOverviewRequestsLazyQuery>;
export type GetAllAbsenceOverviewRequestsSuspenseQueryHookResult = ReturnType<typeof useGetAllAbsenceOverviewRequestsSuspenseQuery>;
export type GetAllAbsenceOverviewRequestsQueryResult = Apollo.QueryResult<GetAllAbsenceOverviewRequestsQuery, GetAllAbsenceOverviewRequestsQueryVariables>;
export const GetAllAbsenceReasonsDocument = gql`
    query GetAllAbsenceReasons($first: Int, $after: String, $last: Int, $before: String, $nameContains: String, $onlyVisible: Boolean, $showDeleted: Boolean) {
  allAbsenceReasons(
    first: $first
    after: $after
    before: $before
    last: $last
    filter: {nameContains: $nameContains, onlyVisible: $onlyVisible, showDeleted: $showDeleted}
  ) {
    nodes {
      id
      name
      description
      isVisible
      isDeleted
      isPaid
      maximumContinuedPayment
      removesWorkingHours
      type
      version
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllAbsenceReasonsQuery__
 *
 * To run a query within a React component, call `useGetAllAbsenceReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAbsenceReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAbsenceReasonsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      nameContains: // value for 'nameContains'
 *      onlyVisible: // value for 'onlyVisible'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useGetAllAbsenceReasonsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllAbsenceReasonsQuery, GetAllAbsenceReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAbsenceReasonsQuery, GetAllAbsenceReasonsQueryVariables>(GetAllAbsenceReasonsDocument, options);
      }
export function useGetAllAbsenceReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAbsenceReasonsQuery, GetAllAbsenceReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAbsenceReasonsQuery, GetAllAbsenceReasonsQueryVariables>(GetAllAbsenceReasonsDocument, options);
        }
export function useGetAllAbsenceReasonsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAbsenceReasonsQuery, GetAllAbsenceReasonsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAbsenceReasonsQuery, GetAllAbsenceReasonsQueryVariables>(GetAllAbsenceReasonsDocument, options);
        }
export type GetAllAbsenceReasonsQueryHookResult = ReturnType<typeof useGetAllAbsenceReasonsQuery>;
export type GetAllAbsenceReasonsLazyQueryHookResult = ReturnType<typeof useGetAllAbsenceReasonsLazyQuery>;
export type GetAllAbsenceReasonsSuspenseQueryHookResult = ReturnType<typeof useGetAllAbsenceReasonsSuspenseQuery>;
export type GetAllAbsenceReasonsQueryResult = Apollo.QueryResult<GetAllAbsenceReasonsQuery, GetAllAbsenceReasonsQueryVariables>;
export const GetAllAbsenceReasonsForUsageDocument = gql`
    query GetAllAbsenceReasonsForUsage($types: [AbsenceReasonType!]) {
  allAbsenceReasonsForUsage(first: 100, filter: {filterByTypes: $types}) {
    nodes {
      id
      name
      type
    }
  }
}
    `;

/**
 * __useGetAllAbsenceReasonsForUsageQuery__
 *
 * To run a query within a React component, call `useGetAllAbsenceReasonsForUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAbsenceReasonsForUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAbsenceReasonsForUsageQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useGetAllAbsenceReasonsForUsageQuery(baseOptions?: Apollo.QueryHookOptions<GetAllAbsenceReasonsForUsageQuery, GetAllAbsenceReasonsForUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAbsenceReasonsForUsageQuery, GetAllAbsenceReasonsForUsageQueryVariables>(GetAllAbsenceReasonsForUsageDocument, options);
      }
export function useGetAllAbsenceReasonsForUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAbsenceReasonsForUsageQuery, GetAllAbsenceReasonsForUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAbsenceReasonsForUsageQuery, GetAllAbsenceReasonsForUsageQueryVariables>(GetAllAbsenceReasonsForUsageDocument, options);
        }
export function useGetAllAbsenceReasonsForUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAbsenceReasonsForUsageQuery, GetAllAbsenceReasonsForUsageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAbsenceReasonsForUsageQuery, GetAllAbsenceReasonsForUsageQueryVariables>(GetAllAbsenceReasonsForUsageDocument, options);
        }
export type GetAllAbsenceReasonsForUsageQueryHookResult = ReturnType<typeof useGetAllAbsenceReasonsForUsageQuery>;
export type GetAllAbsenceReasonsForUsageLazyQueryHookResult = ReturnType<typeof useGetAllAbsenceReasonsForUsageLazyQuery>;
export type GetAllAbsenceReasonsForUsageSuspenseQueryHookResult = ReturnType<typeof useGetAllAbsenceReasonsForUsageSuspenseQuery>;
export type GetAllAbsenceReasonsForUsageQueryResult = Apollo.QueryResult<GetAllAbsenceReasonsForUsageQuery, GetAllAbsenceReasonsForUsageQueryVariables>;
export const GetAllAbsencesDocument = gql`
    query GetAllAbsences($first: Int, $after: String, $startDate: LocalDate!, $employeeId: ID!, $showCanceled: Boolean) {
  allAbsences(
    after: $after
    first: $first
    filter: {startDate: $startDate, showCanceled: $showCanceled}
    employeeId: $employeeId
  ) {
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
    nodes {
      absenceReasonId
      absenceReasonName
      absenceReasonType
      delegateEmployee {
        id
        displayName
      }
      end
      id
      isHalfEndDay
      isHalfStartDay
      start
      status
      timestamp
      version
      createdBy {
        id
        displayName
      }
      employee {
        id
        displayName
      }
      workDays
      totalDays
      publicHolidays
      history {
        absenceReasonId
        absenceReasonName
        end
        isHalfEndDay
        isHalfStartDay
        start
        status
        timestamp
        version
        createdBy {
          id
          displayName
        }
        delegateEmployee {
          id
          displayName
        }
        workDays
        totalDays
        publicHolidays
      }
      logs {
        id
        message
        timestamp
        createdBy {
          id
          displayName
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllAbsencesQuery__
 *
 * To run a query within a React component, call `useGetAllAbsencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAbsencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAbsencesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      startDate: // value for 'startDate'
 *      employeeId: // value for 'employeeId'
 *      showCanceled: // value for 'showCanceled'
 *   },
 * });
 */
export function useGetAllAbsencesQuery(baseOptions: Apollo.QueryHookOptions<GetAllAbsencesQuery, GetAllAbsencesQueryVariables> & ({ variables: GetAllAbsencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAbsencesQuery, GetAllAbsencesQueryVariables>(GetAllAbsencesDocument, options);
      }
export function useGetAllAbsencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAbsencesQuery, GetAllAbsencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAbsencesQuery, GetAllAbsencesQueryVariables>(GetAllAbsencesDocument, options);
        }
export function useGetAllAbsencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAbsencesQuery, GetAllAbsencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAbsencesQuery, GetAllAbsencesQueryVariables>(GetAllAbsencesDocument, options);
        }
export type GetAllAbsencesQueryHookResult = ReturnType<typeof useGetAllAbsencesQuery>;
export type GetAllAbsencesLazyQueryHookResult = ReturnType<typeof useGetAllAbsencesLazyQuery>;
export type GetAllAbsencesSuspenseQueryHookResult = ReturnType<typeof useGetAllAbsencesSuspenseQuery>;
export type GetAllAbsencesQueryResult = Apollo.QueryResult<GetAllAbsencesQuery, GetAllAbsencesQueryVariables>;
export const GetAllCalendarEventsDocument = gql`
    query GetAllCalendarEvents($startDate: LocalDate!, $endDate: LocalDate!, $federalStateCodes: [String!], $first: Int, $after: String, $last: Int, $before: String) {
  allCalendarEvents(
    filter: {endDate: $endDate, federalStateCodes: $federalStateCodes, startDate: $startDate}
    first: $first
    after: $after
    before: $before
    last: $last
  ) {
    nodes {
      id
      startDate
      isHalfStartDay
      endDate
      isHalfEndDay
      type
      isVacation
      description
      federalStateCodes
      locations
      version
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllCalendarEventsQuery__
 *
 * To run a query within a React component, call `useGetAllCalendarEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCalendarEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCalendarEventsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      federalStateCodes: // value for 'federalStateCodes'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetAllCalendarEventsQuery(baseOptions: Apollo.QueryHookOptions<GetAllCalendarEventsQuery, GetAllCalendarEventsQueryVariables> & ({ variables: GetAllCalendarEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCalendarEventsQuery, GetAllCalendarEventsQueryVariables>(GetAllCalendarEventsDocument, options);
      }
export function useGetAllCalendarEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCalendarEventsQuery, GetAllCalendarEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCalendarEventsQuery, GetAllCalendarEventsQueryVariables>(GetAllCalendarEventsDocument, options);
        }
export function useGetAllCalendarEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCalendarEventsQuery, GetAllCalendarEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCalendarEventsQuery, GetAllCalendarEventsQueryVariables>(GetAllCalendarEventsDocument, options);
        }
export type GetAllCalendarEventsQueryHookResult = ReturnType<typeof useGetAllCalendarEventsQuery>;
export type GetAllCalendarEventsLazyQueryHookResult = ReturnType<typeof useGetAllCalendarEventsLazyQuery>;
export type GetAllCalendarEventsSuspenseQueryHookResult = ReturnType<typeof useGetAllCalendarEventsSuspenseQuery>;
export type GetAllCalendarEventsQueryResult = Apollo.QueryResult<GetAllCalendarEventsQuery, GetAllCalendarEventsQueryVariables>;
export const GetAllEmployeeTimeLabelsDocument = gql`
    query GetAllEmployeeTimeLabels($employeeId: ID!) {
  allEmployeeTimeLabels(employeeId: $employeeId) {
    companyId
    departmentIds
    departments {
      companyId
      description
      id
      leaderId
      name
      version
    }
    employeeIds
    employees {
      companyName
      contactNumber
      contactTypes
      displayContactType
      displayName
      firstName
      id
      isACompany
      isAFreelancer
      isAPerson
      isDeleted
      isContactPerson
      isEmployee
      isTemporary
      lastName
      salutation
      shortCode
      title
      version
    }
    id
    isActive
    isDeleted
    name
    timeLabelGroups {
      companyId
      departmentIds
      employeeIds
      id
      isGlobal
      name
      version
    }
    version
  }
}
    `;

/**
 * __useGetAllEmployeeTimeLabelsQuery__
 *
 * To run a query within a React component, call `useGetAllEmployeeTimeLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEmployeeTimeLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEmployeeTimeLabelsQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useGetAllEmployeeTimeLabelsQuery(baseOptions: Apollo.QueryHookOptions<GetAllEmployeeTimeLabelsQuery, GetAllEmployeeTimeLabelsQueryVariables> & ({ variables: GetAllEmployeeTimeLabelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEmployeeTimeLabelsQuery, GetAllEmployeeTimeLabelsQueryVariables>(GetAllEmployeeTimeLabelsDocument, options);
      }
export function useGetAllEmployeeTimeLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEmployeeTimeLabelsQuery, GetAllEmployeeTimeLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEmployeeTimeLabelsQuery, GetAllEmployeeTimeLabelsQueryVariables>(GetAllEmployeeTimeLabelsDocument, options);
        }
export function useGetAllEmployeeTimeLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllEmployeeTimeLabelsQuery, GetAllEmployeeTimeLabelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllEmployeeTimeLabelsQuery, GetAllEmployeeTimeLabelsQueryVariables>(GetAllEmployeeTimeLabelsDocument, options);
        }
export type GetAllEmployeeTimeLabelsQueryHookResult = ReturnType<typeof useGetAllEmployeeTimeLabelsQuery>;
export type GetAllEmployeeTimeLabelsLazyQueryHookResult = ReturnType<typeof useGetAllEmployeeTimeLabelsLazyQuery>;
export type GetAllEmployeeTimeLabelsSuspenseQueryHookResult = ReturnType<typeof useGetAllEmployeeTimeLabelsSuspenseQuery>;
export type GetAllEmployeeTimeLabelsQueryResult = Apollo.QueryResult<GetAllEmployeeTimeLabelsQuery, GetAllEmployeeTimeLabelsQueryVariables>;
export const GetAllEmployeesOfTimeLabelDocument = gql`
    query GetAllEmployeesOfTimeLabel($timeLabelId: ID!) {
  allEmployeesOfTimeLabel(timeLabelId: $timeLabelId) {
    companyName
    contactNumber
    contactTypes
    displayContactType
    displayName
    firstName
    id
    isACompany
    isAFreelancer
    isAPerson
    isDeleted
    isContactPerson
    isEmployee
    isTemporary
    lastName
    salutation
    shortCode
    title
    version
    additionalInformation {
      id
      __typename
      ... on EmailInformation {
        emailAddress
        emailType
        id
      }
    }
  }
}
    `;

/**
 * __useGetAllEmployeesOfTimeLabelQuery__
 *
 * To run a query within a React component, call `useGetAllEmployeesOfTimeLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEmployeesOfTimeLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEmployeesOfTimeLabelQuery({
 *   variables: {
 *      timeLabelId: // value for 'timeLabelId'
 *   },
 * });
 */
export function useGetAllEmployeesOfTimeLabelQuery(baseOptions: Apollo.QueryHookOptions<GetAllEmployeesOfTimeLabelQuery, GetAllEmployeesOfTimeLabelQueryVariables> & ({ variables: GetAllEmployeesOfTimeLabelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEmployeesOfTimeLabelQuery, GetAllEmployeesOfTimeLabelQueryVariables>(GetAllEmployeesOfTimeLabelDocument, options);
      }
export function useGetAllEmployeesOfTimeLabelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEmployeesOfTimeLabelQuery, GetAllEmployeesOfTimeLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEmployeesOfTimeLabelQuery, GetAllEmployeesOfTimeLabelQueryVariables>(GetAllEmployeesOfTimeLabelDocument, options);
        }
export function useGetAllEmployeesOfTimeLabelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllEmployeesOfTimeLabelQuery, GetAllEmployeesOfTimeLabelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllEmployeesOfTimeLabelQuery, GetAllEmployeesOfTimeLabelQueryVariables>(GetAllEmployeesOfTimeLabelDocument, options);
        }
export type GetAllEmployeesOfTimeLabelQueryHookResult = ReturnType<typeof useGetAllEmployeesOfTimeLabelQuery>;
export type GetAllEmployeesOfTimeLabelLazyQueryHookResult = ReturnType<typeof useGetAllEmployeesOfTimeLabelLazyQuery>;
export type GetAllEmployeesOfTimeLabelSuspenseQueryHookResult = ReturnType<typeof useGetAllEmployeesOfTimeLabelSuspenseQuery>;
export type GetAllEmployeesOfTimeLabelQueryResult = Apollo.QueryResult<GetAllEmployeesOfTimeLabelQuery, GetAllEmployeesOfTimeLabelQueryVariables>;
export const GetAllEmployeesOfTimeLabelGroupDocument = gql`
    query GetAllEmployeesOfTimeLabelGroup($timeLabelGroupId: ID!) {
  allEmployeesOfTimeLabelGroup(timeLabelGroupId: $timeLabelGroupId) {
    companyName
    contactNumber
    contactTypes
    displayContactType
    displayName
    firstName
    id
    isACompany
    isAFreelancer
    isAPerson
    isDeleted
    isContactPerson
    isEmployee
    isTemporary
    lastName
    salutation
    shortCode
    title
    version
    additionalInformation {
      id
      __typename
      ... on EmailInformation {
        emailAddress
        emailType
        id
      }
    }
  }
}
    `;

/**
 * __useGetAllEmployeesOfTimeLabelGroupQuery__
 *
 * To run a query within a React component, call `useGetAllEmployeesOfTimeLabelGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEmployeesOfTimeLabelGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEmployeesOfTimeLabelGroupQuery({
 *   variables: {
 *      timeLabelGroupId: // value for 'timeLabelGroupId'
 *   },
 * });
 */
export function useGetAllEmployeesOfTimeLabelGroupQuery(baseOptions: Apollo.QueryHookOptions<GetAllEmployeesOfTimeLabelGroupQuery, GetAllEmployeesOfTimeLabelGroupQueryVariables> & ({ variables: GetAllEmployeesOfTimeLabelGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEmployeesOfTimeLabelGroupQuery, GetAllEmployeesOfTimeLabelGroupQueryVariables>(GetAllEmployeesOfTimeLabelGroupDocument, options);
      }
export function useGetAllEmployeesOfTimeLabelGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEmployeesOfTimeLabelGroupQuery, GetAllEmployeesOfTimeLabelGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEmployeesOfTimeLabelGroupQuery, GetAllEmployeesOfTimeLabelGroupQueryVariables>(GetAllEmployeesOfTimeLabelGroupDocument, options);
        }
export function useGetAllEmployeesOfTimeLabelGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllEmployeesOfTimeLabelGroupQuery, GetAllEmployeesOfTimeLabelGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllEmployeesOfTimeLabelGroupQuery, GetAllEmployeesOfTimeLabelGroupQueryVariables>(GetAllEmployeesOfTimeLabelGroupDocument, options);
        }
export type GetAllEmployeesOfTimeLabelGroupQueryHookResult = ReturnType<typeof useGetAllEmployeesOfTimeLabelGroupQuery>;
export type GetAllEmployeesOfTimeLabelGroupLazyQueryHookResult = ReturnType<typeof useGetAllEmployeesOfTimeLabelGroupLazyQuery>;
export type GetAllEmployeesOfTimeLabelGroupSuspenseQueryHookResult = ReturnType<typeof useGetAllEmployeesOfTimeLabelGroupSuspenseQuery>;
export type GetAllEmployeesOfTimeLabelGroupQueryResult = Apollo.QueryResult<GetAllEmployeesOfTimeLabelGroupQuery, GetAllEmployeesOfTimeLabelGroupQueryVariables>;
export const GetAllFederalStatesDocument = gql`
    query GetAllFederalStates {
  allFederalStates {
    code
    name
  }
}
    `;

/**
 * __useGetAllFederalStatesQuery__
 *
 * To run a query within a React component, call `useGetAllFederalStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFederalStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFederalStatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllFederalStatesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllFederalStatesQuery, GetAllFederalStatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFederalStatesQuery, GetAllFederalStatesQueryVariables>(GetAllFederalStatesDocument, options);
      }
export function useGetAllFederalStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFederalStatesQuery, GetAllFederalStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFederalStatesQuery, GetAllFederalStatesQueryVariables>(GetAllFederalStatesDocument, options);
        }
export function useGetAllFederalStatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllFederalStatesQuery, GetAllFederalStatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllFederalStatesQuery, GetAllFederalStatesQueryVariables>(GetAllFederalStatesDocument, options);
        }
export type GetAllFederalStatesQueryHookResult = ReturnType<typeof useGetAllFederalStatesQuery>;
export type GetAllFederalStatesLazyQueryHookResult = ReturnType<typeof useGetAllFederalStatesLazyQuery>;
export type GetAllFederalStatesSuspenseQueryHookResult = ReturnType<typeof useGetAllFederalStatesSuspenseQuery>;
export type GetAllFederalStatesQueryResult = Apollo.QueryResult<GetAllFederalStatesQuery, GetAllFederalStatesQueryVariables>;
export const GetAllMyTimeLabelsDocument = gql`
    query GetAllMyTimeLabels {
  allMyTimeLabels {
    companyId
    departmentIds
    departments {
      companyId
      description
      id
      leaderId
      name
      version
    }
    employeeIds
    employees {
      companyName
      contactNumber
      contactTypes
      displayContactType
      displayName
      firstName
      id
      isACompany
      isAFreelancer
      isAPerson
      isDeleted
      isContactPerson
      isEmployee
      isTemporary
      lastName
      salutation
      shortCode
      title
      version
    }
    id
    isActive
    isDeleted
    name
    timeLabelGroups {
      companyId
      departmentIds
      employeeIds
      id
      isGlobal
      name
      version
    }
    version
  }
}
    `;

/**
 * __useGetAllMyTimeLabelsQuery__
 *
 * To run a query within a React component, call `useGetAllMyTimeLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMyTimeLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMyTimeLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllMyTimeLabelsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllMyTimeLabelsQuery, GetAllMyTimeLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMyTimeLabelsQuery, GetAllMyTimeLabelsQueryVariables>(GetAllMyTimeLabelsDocument, options);
      }
export function useGetAllMyTimeLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMyTimeLabelsQuery, GetAllMyTimeLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMyTimeLabelsQuery, GetAllMyTimeLabelsQueryVariables>(GetAllMyTimeLabelsDocument, options);
        }
export function useGetAllMyTimeLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllMyTimeLabelsQuery, GetAllMyTimeLabelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllMyTimeLabelsQuery, GetAllMyTimeLabelsQueryVariables>(GetAllMyTimeLabelsDocument, options);
        }
export type GetAllMyTimeLabelsQueryHookResult = ReturnType<typeof useGetAllMyTimeLabelsQuery>;
export type GetAllMyTimeLabelsLazyQueryHookResult = ReturnType<typeof useGetAllMyTimeLabelsLazyQuery>;
export type GetAllMyTimeLabelsSuspenseQueryHookResult = ReturnType<typeof useGetAllMyTimeLabelsSuspenseQuery>;
export type GetAllMyTimeLabelsQueryResult = Apollo.QueryResult<GetAllMyTimeLabelsQuery, GetAllMyTimeLabelsQueryVariables>;
export const GetAllTimeBalanceEntriesDocument = gql`
    query GetAllTimeBalanceEntries($employeeId: ID!, $first: Int, $last: Int, $after: String, $before: String) {
  allTimeBalanceEntries(
    first: $first
    filter: {employeeId: $employeeId}
    after: $after
    before: $before
    last: $last
  ) {
    totalCount
    nodes {
      id
      createdById
      createdBy {
        id
        displayName
      }
      employeeId
      date
      type
      vacationDays
      overtime
      reason
      isDeleted
      timestamp
      version
      history {
        date
        type
        vacationDays
        overtime
        reason
        isDeleted
        createdById
        createdBy {
          id
          displayName
        }
        timestamp
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetAllTimeBalanceEntriesQuery__
 *
 * To run a query within a React component, call `useGetAllTimeBalanceEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTimeBalanceEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTimeBalanceEntriesQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetAllTimeBalanceEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetAllTimeBalanceEntriesQuery, GetAllTimeBalanceEntriesQueryVariables> & ({ variables: GetAllTimeBalanceEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTimeBalanceEntriesQuery, GetAllTimeBalanceEntriesQueryVariables>(GetAllTimeBalanceEntriesDocument, options);
      }
export function useGetAllTimeBalanceEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTimeBalanceEntriesQuery, GetAllTimeBalanceEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTimeBalanceEntriesQuery, GetAllTimeBalanceEntriesQueryVariables>(GetAllTimeBalanceEntriesDocument, options);
        }
export function useGetAllTimeBalanceEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTimeBalanceEntriesQuery, GetAllTimeBalanceEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTimeBalanceEntriesQuery, GetAllTimeBalanceEntriesQueryVariables>(GetAllTimeBalanceEntriesDocument, options);
        }
export type GetAllTimeBalanceEntriesQueryHookResult = ReturnType<typeof useGetAllTimeBalanceEntriesQuery>;
export type GetAllTimeBalanceEntriesLazyQueryHookResult = ReturnType<typeof useGetAllTimeBalanceEntriesLazyQuery>;
export type GetAllTimeBalanceEntriesSuspenseQueryHookResult = ReturnType<typeof useGetAllTimeBalanceEntriesSuspenseQuery>;
export type GetAllTimeBalanceEntriesQueryResult = Apollo.QueryResult<GetAllTimeBalanceEntriesQuery, GetAllTimeBalanceEntriesQueryVariables>;
export const GetAllTimeEntriesDocument = gql`
    query GetAllTimeEntries($startDate: LocalDate!, $endDate: LocalDate!, $employeeId: ID!, $projectId: ID!) {
  allTimeEntries(
    filter: {endDate: $endDate, startDate: $startDate, employeeId: $employeeId, projectId: $projectId}
  ) {
    date
    id
    items {
      calendarId
      createdBy {
        displayName
        id
        version
      }
      description
      end
      entryType
      id
      status
      logs {
        createdBy {
          displayName
          id
          version
        }
        id
        message
        timestamp
      }
      member {
        displayName
        id
        version
      }
      path
      start
      timeLabel {
        name
        id
        version
      }
      timestamp
      title
      version
      workLocation
      timeLabelId
      errors
      history {
        createdBy {
          id
          displayName
        }
        description
        end
        entryType
        member {
          id
          displayName
        }
        start
        status
        timeLabel {
          name
          id
        }
        timestamp
        version
        workLocation
      }
    }
    absenceReason
    approvedWorkingMinutes
    balanceEntry {
      overtimeMinutes
      type
    }
    balanceMinutes
    breakMinutes
    errors
    pendingWorkingMinutes
    rejectedWorkingMinutes
    requiredWorkingMinutes
    workingMinutes
  }
}
    `;

/**
 * __useGetAllTimeEntriesQuery__
 *
 * To run a query within a React component, call `useGetAllTimeEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTimeEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTimeEntriesQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      employeeId: // value for 'employeeId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetAllTimeEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetAllTimeEntriesQuery, GetAllTimeEntriesQueryVariables> & ({ variables: GetAllTimeEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTimeEntriesQuery, GetAllTimeEntriesQueryVariables>(GetAllTimeEntriesDocument, options);
      }
export function useGetAllTimeEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTimeEntriesQuery, GetAllTimeEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTimeEntriesQuery, GetAllTimeEntriesQueryVariables>(GetAllTimeEntriesDocument, options);
        }
export function useGetAllTimeEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTimeEntriesQuery, GetAllTimeEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTimeEntriesQuery, GetAllTimeEntriesQueryVariables>(GetAllTimeEntriesDocument, options);
        }
export type GetAllTimeEntriesQueryHookResult = ReturnType<typeof useGetAllTimeEntriesQuery>;
export type GetAllTimeEntriesLazyQueryHookResult = ReturnType<typeof useGetAllTimeEntriesLazyQuery>;
export type GetAllTimeEntriesSuspenseQueryHookResult = ReturnType<typeof useGetAllTimeEntriesSuspenseQuery>;
export type GetAllTimeEntriesQueryResult = Apollo.QueryResult<GetAllTimeEntriesQuery, GetAllTimeEntriesQueryVariables>;
export const GetAllTimeLabelGroupsDocument = gql`
    query GetAllTimeLabelGroups($companyId: ID!, $first: Int, $last: Int, $after: String, $before: String, $name: String) {
  allTimeLabelGroup(
    companyId: $companyId
    after: $after
    before: $before
    filter: {nameContains: $name}
    first: $first
    last: $last
  ) {
    totalCount
    nodes {
      departmentIds
      employeeIds
      id
      name
      version
      companyId
      isGlobal
      labels {
        departmentIds
        employeeIds
        id
        isActive
        isDeleted
        name
        version
        companyId
      }
      departments {
        companyId
        description
        id
        leaderId
        name
        version
      }
      employees {
        companyName
        contactNumber
        contactTypes
        displayContactType
        displayName
        firstName
        id
        isACompany
        isAFreelancer
        isAPerson
        isDeleted
        isContactPerson
        isEmployee
        isTemporary
        lastName
        salutation
        shortCode
        title
        version
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetAllTimeLabelGroupsQuery__
 *
 * To run a query within a React component, call `useGetAllTimeLabelGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTimeLabelGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTimeLabelGroupsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetAllTimeLabelGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetAllTimeLabelGroupsQuery, GetAllTimeLabelGroupsQueryVariables> & ({ variables: GetAllTimeLabelGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTimeLabelGroupsQuery, GetAllTimeLabelGroupsQueryVariables>(GetAllTimeLabelGroupsDocument, options);
      }
export function useGetAllTimeLabelGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTimeLabelGroupsQuery, GetAllTimeLabelGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTimeLabelGroupsQuery, GetAllTimeLabelGroupsQueryVariables>(GetAllTimeLabelGroupsDocument, options);
        }
export function useGetAllTimeLabelGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTimeLabelGroupsQuery, GetAllTimeLabelGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTimeLabelGroupsQuery, GetAllTimeLabelGroupsQueryVariables>(GetAllTimeLabelGroupsDocument, options);
        }
export type GetAllTimeLabelGroupsQueryHookResult = ReturnType<typeof useGetAllTimeLabelGroupsQuery>;
export type GetAllTimeLabelGroupsLazyQueryHookResult = ReturnType<typeof useGetAllTimeLabelGroupsLazyQuery>;
export type GetAllTimeLabelGroupsSuspenseQueryHookResult = ReturnType<typeof useGetAllTimeLabelGroupsSuspenseQuery>;
export type GetAllTimeLabelGroupsQueryResult = Apollo.QueryResult<GetAllTimeLabelGroupsQuery, GetAllTimeLabelGroupsQueryVariables>;
export const GetAllTimeLabelGroupsOfDepartmentDocument = gql`
    query GetAllTimeLabelGroupsOfDepartment($departmentId: ID!, $first: Int, $last: Int, $after: String, $before: String, $name: String) {
  allTimeLabelGroupsOfDepartment(
    after: $after
    before: $before
    departmentId: $departmentId
    filter: {nameContains: $name}
    first: $first
    last: $last
  ) {
    totalCount
    nodes {
      companyId
      departmentIds
      employeeIds
      id
      isGlobal
      name
      version
      departments {
        companyId
        description
        id
        leaderId
        name
        version
      }
      employees {
        companyName
        contactNumber
        contactTypes
        displayContactType
        displayName
        firstName
        id
        isACompany
        isAFreelancer
        isAPerson
        isDeleted
        isContactPerson
        isEmployee
        isTemporary
        lastName
        salutation
        shortCode
        title
        version
      }
      labels {
        companyId
        departmentIds
        employeeIds
        id
        isActive
        isDeleted
        name
        version
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetAllTimeLabelGroupsOfDepartmentQuery__
 *
 * To run a query within a React component, call `useGetAllTimeLabelGroupsOfDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTimeLabelGroupsOfDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTimeLabelGroupsOfDepartmentQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetAllTimeLabelGroupsOfDepartmentQuery(baseOptions: Apollo.QueryHookOptions<GetAllTimeLabelGroupsOfDepartmentQuery, GetAllTimeLabelGroupsOfDepartmentQueryVariables> & ({ variables: GetAllTimeLabelGroupsOfDepartmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTimeLabelGroupsOfDepartmentQuery, GetAllTimeLabelGroupsOfDepartmentQueryVariables>(GetAllTimeLabelGroupsOfDepartmentDocument, options);
      }
export function useGetAllTimeLabelGroupsOfDepartmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTimeLabelGroupsOfDepartmentQuery, GetAllTimeLabelGroupsOfDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTimeLabelGroupsOfDepartmentQuery, GetAllTimeLabelGroupsOfDepartmentQueryVariables>(GetAllTimeLabelGroupsOfDepartmentDocument, options);
        }
export function useGetAllTimeLabelGroupsOfDepartmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTimeLabelGroupsOfDepartmentQuery, GetAllTimeLabelGroupsOfDepartmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTimeLabelGroupsOfDepartmentQuery, GetAllTimeLabelGroupsOfDepartmentQueryVariables>(GetAllTimeLabelGroupsOfDepartmentDocument, options);
        }
export type GetAllTimeLabelGroupsOfDepartmentQueryHookResult = ReturnType<typeof useGetAllTimeLabelGroupsOfDepartmentQuery>;
export type GetAllTimeLabelGroupsOfDepartmentLazyQueryHookResult = ReturnType<typeof useGetAllTimeLabelGroupsOfDepartmentLazyQuery>;
export type GetAllTimeLabelGroupsOfDepartmentSuspenseQueryHookResult = ReturnType<typeof useGetAllTimeLabelGroupsOfDepartmentSuspenseQuery>;
export type GetAllTimeLabelGroupsOfDepartmentQueryResult = Apollo.QueryResult<GetAllTimeLabelGroupsOfDepartmentQuery, GetAllTimeLabelGroupsOfDepartmentQueryVariables>;
export const GetAllTimeLabelsDocument = gql`
    query GetAllTimeLabels($companyId: ID!, $first: Int, $last: Int, $after: String, $before: String, $name: String, $onlyActive: Boolean!, $showDeleted: Boolean!) {
  allTimeLabel(
    after: $after
    before: $before
    companyId: $companyId
    filter: {nameContains: $name, onlyActive: $onlyActive, showDeleted: $showDeleted}
    first: $first
    last: $last
  ) {
    totalCount
    nodes {
      departmentIds
      employeeIds
      id
      isActive
      isDeleted
      name
      version
      companyId
      departments {
        companyId
        description
        id
        leaderId
        name
        version
      }
      employees {
        companyName
        contactNumber
        contactTypes
        displayContactType
        displayName
        firstName
        id
        isACompany
        isAFreelancer
        isAPerson
        isDeleted
        isContactPerson
        isEmployee
        isTemporary
        lastName
        salutation
        shortCode
        title
        version
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetAllTimeLabelsQuery__
 *
 * To run a query within a React component, call `useGetAllTimeLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTimeLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTimeLabelsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      name: // value for 'name'
 *      onlyActive: // value for 'onlyActive'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useGetAllTimeLabelsQuery(baseOptions: Apollo.QueryHookOptions<GetAllTimeLabelsQuery, GetAllTimeLabelsQueryVariables> & ({ variables: GetAllTimeLabelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTimeLabelsQuery, GetAllTimeLabelsQueryVariables>(GetAllTimeLabelsDocument, options);
      }
export function useGetAllTimeLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTimeLabelsQuery, GetAllTimeLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTimeLabelsQuery, GetAllTimeLabelsQueryVariables>(GetAllTimeLabelsDocument, options);
        }
export function useGetAllTimeLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTimeLabelsQuery, GetAllTimeLabelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTimeLabelsQuery, GetAllTimeLabelsQueryVariables>(GetAllTimeLabelsDocument, options);
        }
export type GetAllTimeLabelsQueryHookResult = ReturnType<typeof useGetAllTimeLabelsQuery>;
export type GetAllTimeLabelsLazyQueryHookResult = ReturnType<typeof useGetAllTimeLabelsLazyQuery>;
export type GetAllTimeLabelsSuspenseQueryHookResult = ReturnType<typeof useGetAllTimeLabelsSuspenseQuery>;
export type GetAllTimeLabelsQueryResult = Apollo.QueryResult<GetAllTimeLabelsQuery, GetAllTimeLabelsQueryVariables>;
export const GetAllTimeLabelsOfDepartmentDocument = gql`
    query GetAllTimeLabelsOfDepartment($departmentId: ID!, $first: Int, $last: Int, $after: String, $before: String, $name: String, $onlyActive: Boolean!, $showDeleted: Boolean!) {
  allTimeLabelsOfDepartment(
    after: $after
    before: $before
    departmentId: $departmentId
    filter: {nameContains: $name, onlyActive: $onlyActive, showDeleted: $showDeleted}
    first: $first
    last: $last
  ) {
    totalCount
    nodes {
      companyId
      departmentIds
      employeeIds
      id
      name
      version
      departments {
        companyId
        description
        id
        leaderId
        name
        version
      }
      employees {
        companyName
        contactNumber
        contactTypes
        displayContactType
        displayName
        firstName
        id
        isACompany
        isAFreelancer
        isAPerson
        isDeleted
        isContactPerson
        isEmployee
        isTemporary
        lastName
        salutation
        shortCode
        title
        version
      }
      isActive
      isDeleted
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetAllTimeLabelsOfDepartmentQuery__
 *
 * To run a query within a React component, call `useGetAllTimeLabelsOfDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTimeLabelsOfDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTimeLabelsOfDepartmentQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      name: // value for 'name'
 *      onlyActive: // value for 'onlyActive'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useGetAllTimeLabelsOfDepartmentQuery(baseOptions: Apollo.QueryHookOptions<GetAllTimeLabelsOfDepartmentQuery, GetAllTimeLabelsOfDepartmentQueryVariables> & ({ variables: GetAllTimeLabelsOfDepartmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTimeLabelsOfDepartmentQuery, GetAllTimeLabelsOfDepartmentQueryVariables>(GetAllTimeLabelsOfDepartmentDocument, options);
      }
export function useGetAllTimeLabelsOfDepartmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTimeLabelsOfDepartmentQuery, GetAllTimeLabelsOfDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTimeLabelsOfDepartmentQuery, GetAllTimeLabelsOfDepartmentQueryVariables>(GetAllTimeLabelsOfDepartmentDocument, options);
        }
export function useGetAllTimeLabelsOfDepartmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTimeLabelsOfDepartmentQuery, GetAllTimeLabelsOfDepartmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTimeLabelsOfDepartmentQuery, GetAllTimeLabelsOfDepartmentQueryVariables>(GetAllTimeLabelsOfDepartmentDocument, options);
        }
export type GetAllTimeLabelsOfDepartmentQueryHookResult = ReturnType<typeof useGetAllTimeLabelsOfDepartmentQuery>;
export type GetAllTimeLabelsOfDepartmentLazyQueryHookResult = ReturnType<typeof useGetAllTimeLabelsOfDepartmentLazyQuery>;
export type GetAllTimeLabelsOfDepartmentSuspenseQueryHookResult = ReturnType<typeof useGetAllTimeLabelsOfDepartmentSuspenseQuery>;
export type GetAllTimeLabelsOfDepartmentQueryResult = Apollo.QueryResult<GetAllTimeLabelsOfDepartmentQuery, GetAllTimeLabelsOfDepartmentQueryVariables>;
export const GetAllTimeLabelsOfEmployeeDocument = gql`
    query GetAllTimeLabelsOfEmployee($contactId: ID!) {
  allTimeLabelsOfEmployee(contactId: $contactId) {
    companyId
    departmentIds
    departments {
      companyId
      description
      id
      leaderId
      name
      version
    }
    employeeIds
    employees {
      companyName
      contactNumber
      contactTypes
      displayContactType
      displayName
      firstName
      id
      isACompany
      isAFreelancer
      isAPerson
      isDeleted
      isContactPerson
      isEmployee
      isTemporary
      lastName
      salutation
      shortCode
      title
      version
    }
    id
    isActive
    isDeleted
    name
    timeLabelGroups {
      companyId
      departmentIds
      employeeIds
      id
      isGlobal
      name
      version
    }
    version
  }
}
    `;

/**
 * __useGetAllTimeLabelsOfEmployeeQuery__
 *
 * To run a query within a React component, call `useGetAllTimeLabelsOfEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTimeLabelsOfEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTimeLabelsOfEmployeeQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetAllTimeLabelsOfEmployeeQuery(baseOptions: Apollo.QueryHookOptions<GetAllTimeLabelsOfEmployeeQuery, GetAllTimeLabelsOfEmployeeQueryVariables> & ({ variables: GetAllTimeLabelsOfEmployeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTimeLabelsOfEmployeeQuery, GetAllTimeLabelsOfEmployeeQueryVariables>(GetAllTimeLabelsOfEmployeeDocument, options);
      }
export function useGetAllTimeLabelsOfEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTimeLabelsOfEmployeeQuery, GetAllTimeLabelsOfEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTimeLabelsOfEmployeeQuery, GetAllTimeLabelsOfEmployeeQueryVariables>(GetAllTimeLabelsOfEmployeeDocument, options);
        }
export function useGetAllTimeLabelsOfEmployeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTimeLabelsOfEmployeeQuery, GetAllTimeLabelsOfEmployeeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTimeLabelsOfEmployeeQuery, GetAllTimeLabelsOfEmployeeQueryVariables>(GetAllTimeLabelsOfEmployeeDocument, options);
        }
export type GetAllTimeLabelsOfEmployeeQueryHookResult = ReturnType<typeof useGetAllTimeLabelsOfEmployeeQuery>;
export type GetAllTimeLabelsOfEmployeeLazyQueryHookResult = ReturnType<typeof useGetAllTimeLabelsOfEmployeeLazyQuery>;
export type GetAllTimeLabelsOfEmployeeSuspenseQueryHookResult = ReturnType<typeof useGetAllTimeLabelsOfEmployeeSuspenseQuery>;
export type GetAllTimeLabelsOfEmployeeQueryResult = Apollo.QueryResult<GetAllTimeLabelsOfEmployeeQuery, GetAllTimeLabelsOfEmployeeQueryVariables>;
export const GetAllTimeLabelsOfTimeLabelGroupDocument = gql`
    query GetAllTimeLabelsOfTimeLabelGroup($timeLabelGroupId: ID!, $first: Int, $last: Int, $after: String, $before: String, $name: String, $onlyActive: Boolean!, $showDeleted: Boolean!) {
  allTimeLabelsOfTimeLabelGroup(
    after: $after
    before: $before
    timeLabelGroupId: $timeLabelGroupId
    filter: {nameContains: $name, onlyActive: $onlyActive, showDeleted: $showDeleted}
    first: $first
    last: $last
  ) {
    totalCount
    nodes {
      companyId
      departmentIds
      employeeIds
      id
      name
      version
      departments {
        companyId
        description
        id
        leaderId
        name
        version
      }
      employees {
        companyName
        contactNumber
        contactTypes
        displayContactType
        displayName
        firstName
        id
        isACompany
        isAFreelancer
        isAPerson
        isDeleted
        isContactPerson
        isEmployee
        isTemporary
        lastName
        salutation
        shortCode
        title
        version
      }
      isActive
      isDeleted
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetAllTimeLabelsOfTimeLabelGroupQuery__
 *
 * To run a query within a React component, call `useGetAllTimeLabelsOfTimeLabelGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTimeLabelsOfTimeLabelGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTimeLabelsOfTimeLabelGroupQuery({
 *   variables: {
 *      timeLabelGroupId: // value for 'timeLabelGroupId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      name: // value for 'name'
 *      onlyActive: // value for 'onlyActive'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useGetAllTimeLabelsOfTimeLabelGroupQuery(baseOptions: Apollo.QueryHookOptions<GetAllTimeLabelsOfTimeLabelGroupQuery, GetAllTimeLabelsOfTimeLabelGroupQueryVariables> & ({ variables: GetAllTimeLabelsOfTimeLabelGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTimeLabelsOfTimeLabelGroupQuery, GetAllTimeLabelsOfTimeLabelGroupQueryVariables>(GetAllTimeLabelsOfTimeLabelGroupDocument, options);
      }
export function useGetAllTimeLabelsOfTimeLabelGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTimeLabelsOfTimeLabelGroupQuery, GetAllTimeLabelsOfTimeLabelGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTimeLabelsOfTimeLabelGroupQuery, GetAllTimeLabelsOfTimeLabelGroupQueryVariables>(GetAllTimeLabelsOfTimeLabelGroupDocument, options);
        }
export function useGetAllTimeLabelsOfTimeLabelGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTimeLabelsOfTimeLabelGroupQuery, GetAllTimeLabelsOfTimeLabelGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTimeLabelsOfTimeLabelGroupQuery, GetAllTimeLabelsOfTimeLabelGroupQueryVariables>(GetAllTimeLabelsOfTimeLabelGroupDocument, options);
        }
export type GetAllTimeLabelsOfTimeLabelGroupQueryHookResult = ReturnType<typeof useGetAllTimeLabelsOfTimeLabelGroupQuery>;
export type GetAllTimeLabelsOfTimeLabelGroupLazyQueryHookResult = ReturnType<typeof useGetAllTimeLabelsOfTimeLabelGroupLazyQuery>;
export type GetAllTimeLabelsOfTimeLabelGroupSuspenseQueryHookResult = ReturnType<typeof useGetAllTimeLabelsOfTimeLabelGroupSuspenseQuery>;
export type GetAllTimeLabelsOfTimeLabelGroupQueryResult = Apollo.QueryResult<GetAllTimeLabelsOfTimeLabelGroupQuery, GetAllTimeLabelsOfTimeLabelGroupQueryVariables>;
export const GetAllWorkingTimeModelsDocument = gql`
    query GetAllWorkingTimeModels($first: Int, $after: String, $last: Int, $before: String, $nameContains: String, $onlyVisible: Boolean, $showDeleted: Boolean) {
  allWorkingTimeModels(
    first: $first
    after: $after
    before: $before
    last: $last
    filter: {nameContains: $nameContains, onlyVisible: $onlyVisible, showDeleted: $showDeleted}
  ) {
    nodes {
      id
      name
      description
      isVisible
      isFlexible
      hoursPerWeek
      hoursPerMonday
      hoursPerTuesday
      hoursPerWednesday
      hoursPerThursday
      hoursPerFriday
      hoursPerSaturday
      hoursPerSunday
      isDeleted
      vacationDaysPerYear
      version
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllWorkingTimeModelsQuery__
 *
 * To run a query within a React component, call `useGetAllWorkingTimeModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllWorkingTimeModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllWorkingTimeModelsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      nameContains: // value for 'nameContains'
 *      onlyVisible: // value for 'onlyVisible'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useGetAllWorkingTimeModelsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllWorkingTimeModelsQuery, GetAllWorkingTimeModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllWorkingTimeModelsQuery, GetAllWorkingTimeModelsQueryVariables>(GetAllWorkingTimeModelsDocument, options);
      }
export function useGetAllWorkingTimeModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllWorkingTimeModelsQuery, GetAllWorkingTimeModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllWorkingTimeModelsQuery, GetAllWorkingTimeModelsQueryVariables>(GetAllWorkingTimeModelsDocument, options);
        }
export function useGetAllWorkingTimeModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllWorkingTimeModelsQuery, GetAllWorkingTimeModelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllWorkingTimeModelsQuery, GetAllWorkingTimeModelsQueryVariables>(GetAllWorkingTimeModelsDocument, options);
        }
export type GetAllWorkingTimeModelsQueryHookResult = ReturnType<typeof useGetAllWorkingTimeModelsQuery>;
export type GetAllWorkingTimeModelsLazyQueryHookResult = ReturnType<typeof useGetAllWorkingTimeModelsLazyQuery>;
export type GetAllWorkingTimeModelsSuspenseQueryHookResult = ReturnType<typeof useGetAllWorkingTimeModelsSuspenseQuery>;
export type GetAllWorkingTimeModelsQueryResult = Apollo.QueryResult<GetAllWorkingTimeModelsQuery, GetAllWorkingTimeModelsQueryVariables>;
export const GetMyAllAbsenceDocument = gql`
    query GetMyAllAbsence($first: Int, $after: String, $startDate: LocalDate!, $showCanceled: Boolean) {
  myAllAbsences(
    after: $after
    first: $first
    filter: {startDate: $startDate, showCanceled: $showCanceled}
  ) {
    nodes {
      absenceReasonId
      absenceReasonName
      end
      id
      isHalfEndDay
      isHalfStartDay
      start
      status
      timestamp
      version
      workDays
      totalDays
      publicHolidays
      history {
        absenceReasonId
        absenceReasonName
        end
        isHalfEndDay
        isHalfStartDay
        start
        status
        timestamp
        version
        createdBy {
          id
          displayName
        }
        delegateEmployee {
          displayName
          id
        }
        workDays
        totalDays
        publicHolidays
      }
      logs {
        id
        message
        timestamp
        createdBy {
          displayName
          id
        }
      }
      createdBy {
        displayName
        id
      }
      delegateEmployee {
        displayName
        id
      }
      employee {
        displayName
        id
      }
      absenceReasonType
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetMyAllAbsenceQuery__
 *
 * To run a query within a React component, call `useGetMyAllAbsenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAllAbsenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAllAbsenceQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      startDate: // value for 'startDate'
 *      showCanceled: // value for 'showCanceled'
 *   },
 * });
 */
export function useGetMyAllAbsenceQuery(baseOptions: Apollo.QueryHookOptions<GetMyAllAbsenceQuery, GetMyAllAbsenceQueryVariables> & ({ variables: GetMyAllAbsenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAllAbsenceQuery, GetMyAllAbsenceQueryVariables>(GetMyAllAbsenceDocument, options);
      }
export function useGetMyAllAbsenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAllAbsenceQuery, GetMyAllAbsenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAllAbsenceQuery, GetMyAllAbsenceQueryVariables>(GetMyAllAbsenceDocument, options);
        }
export function useGetMyAllAbsenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyAllAbsenceQuery, GetMyAllAbsenceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyAllAbsenceQuery, GetMyAllAbsenceQueryVariables>(GetMyAllAbsenceDocument, options);
        }
export type GetMyAllAbsenceQueryHookResult = ReturnType<typeof useGetMyAllAbsenceQuery>;
export type GetMyAllAbsenceLazyQueryHookResult = ReturnType<typeof useGetMyAllAbsenceLazyQuery>;
export type GetMyAllAbsenceSuspenseQueryHookResult = ReturnType<typeof useGetMyAllAbsenceSuspenseQuery>;
export type GetMyAllAbsenceQueryResult = Apollo.QueryResult<GetMyAllAbsenceQuery, GetMyAllAbsenceQueryVariables>;
export const GetMyAllAcceptedVacationRequestsDocument = gql`
    query GetMyAllAcceptedVacationRequests($first: Int, $after: String, $startDate: LocalDate!) {
  myAllAcceptedVacationRequests(
    after: $after
    first: $first
    filter: {startDate: $startDate}
  ) {
    nodes {
      absenceReasonId
      absenceReasonName
      employee {
        id
        displayName
      }
      end
      id
      isDeleted
      isHalfEndDay
      isHalfStartDay
      start
      status
      timestamp
      version
      workDays
      totalDays
      publicHolidays
      history {
        absenceReasonId
        absenceReasonName
        end
        isHalfEndDay
        isHalfStartDay
        start
        status
        timestamp
        version
        createdBy {
          id
          displayName
        }
        delegateEmployee {
          displayName
          id
        }
        workDays
        totalDays
        publicHolidays
      }
      logs {
        id
        message
        timestamp
        createdBy {
          displayName
          id
        }
      }
      createdBy {
        displayName
        id
      }
      delegateEmployee {
        displayName
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetMyAllAcceptedVacationRequestsQuery__
 *
 * To run a query within a React component, call `useGetMyAllAcceptedVacationRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAllAcceptedVacationRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAllAcceptedVacationRequestsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetMyAllAcceptedVacationRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetMyAllAcceptedVacationRequestsQuery, GetMyAllAcceptedVacationRequestsQueryVariables> & ({ variables: GetMyAllAcceptedVacationRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAllAcceptedVacationRequestsQuery, GetMyAllAcceptedVacationRequestsQueryVariables>(GetMyAllAcceptedVacationRequestsDocument, options);
      }
export function useGetMyAllAcceptedVacationRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAllAcceptedVacationRequestsQuery, GetMyAllAcceptedVacationRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAllAcceptedVacationRequestsQuery, GetMyAllAcceptedVacationRequestsQueryVariables>(GetMyAllAcceptedVacationRequestsDocument, options);
        }
export function useGetMyAllAcceptedVacationRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyAllAcceptedVacationRequestsQuery, GetMyAllAcceptedVacationRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyAllAcceptedVacationRequestsQuery, GetMyAllAcceptedVacationRequestsQueryVariables>(GetMyAllAcceptedVacationRequestsDocument, options);
        }
export type GetMyAllAcceptedVacationRequestsQueryHookResult = ReturnType<typeof useGetMyAllAcceptedVacationRequestsQuery>;
export type GetMyAllAcceptedVacationRequestsLazyQueryHookResult = ReturnType<typeof useGetMyAllAcceptedVacationRequestsLazyQuery>;
export type GetMyAllAcceptedVacationRequestsSuspenseQueryHookResult = ReturnType<typeof useGetMyAllAcceptedVacationRequestsSuspenseQuery>;
export type GetMyAllAcceptedVacationRequestsQueryResult = Apollo.QueryResult<GetMyAllAcceptedVacationRequestsQuery, GetMyAllAcceptedVacationRequestsQueryVariables>;
export const GetMyAllProjectTimeSummariesDocument = gql`
    query GetMyAllProjectTimeSummaries($projectId: ID!) {
  myProjectTimeSummaries(projectId: $projectId) {
    approvedMinutes
    openMinutes
    pendingMinutes
    totalMinutes
    positionName
    projectName
    totalWorkedMinutes
    projectId
    projectPositionId
    isDeleted
    startDate
    endDate
  }
}
    `;

/**
 * __useGetMyAllProjectTimeSummariesQuery__
 *
 * To run a query within a React component, call `useGetMyAllProjectTimeSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAllProjectTimeSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAllProjectTimeSummariesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetMyAllProjectTimeSummariesQuery(baseOptions: Apollo.QueryHookOptions<GetMyAllProjectTimeSummariesQuery, GetMyAllProjectTimeSummariesQueryVariables> & ({ variables: GetMyAllProjectTimeSummariesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAllProjectTimeSummariesQuery, GetMyAllProjectTimeSummariesQueryVariables>(GetMyAllProjectTimeSummariesDocument, options);
      }
export function useGetMyAllProjectTimeSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAllProjectTimeSummariesQuery, GetMyAllProjectTimeSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAllProjectTimeSummariesQuery, GetMyAllProjectTimeSummariesQueryVariables>(GetMyAllProjectTimeSummariesDocument, options);
        }
export function useGetMyAllProjectTimeSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyAllProjectTimeSummariesQuery, GetMyAllProjectTimeSummariesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyAllProjectTimeSummariesQuery, GetMyAllProjectTimeSummariesQueryVariables>(GetMyAllProjectTimeSummariesDocument, options);
        }
export type GetMyAllProjectTimeSummariesQueryHookResult = ReturnType<typeof useGetMyAllProjectTimeSummariesQuery>;
export type GetMyAllProjectTimeSummariesLazyQueryHookResult = ReturnType<typeof useGetMyAllProjectTimeSummariesLazyQuery>;
export type GetMyAllProjectTimeSummariesSuspenseQueryHookResult = ReturnType<typeof useGetMyAllProjectTimeSummariesSuspenseQuery>;
export type GetMyAllProjectTimeSummariesQueryResult = Apollo.QueryResult<GetMyAllProjectTimeSummariesQuery, GetMyAllProjectTimeSummariesQueryVariables>;
export const GetMyAllProjectTimeSummariesForListDocument = gql`
    query GetMyAllProjectTimeSummariesForList($startDate: LocalDate!, $endDate: LocalDate!, $showDeleted: Boolean) {
  myAllProjectTimeSummaries(
    startDate: $startDate
    endDate: $endDate
    showDeleted: $showDeleted
  ) {
    totalWorkedMinutes
    totalMinutes
    positionName
    projectName
    projectId
    projectPositionId
  }
}
    `;

/**
 * __useGetMyAllProjectTimeSummariesForListQuery__
 *
 * To run a query within a React component, call `useGetMyAllProjectTimeSummariesForListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAllProjectTimeSummariesForListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAllProjectTimeSummariesForListQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useGetMyAllProjectTimeSummariesForListQuery(baseOptions: Apollo.QueryHookOptions<GetMyAllProjectTimeSummariesForListQuery, GetMyAllProjectTimeSummariesForListQueryVariables> & ({ variables: GetMyAllProjectTimeSummariesForListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAllProjectTimeSummariesForListQuery, GetMyAllProjectTimeSummariesForListQueryVariables>(GetMyAllProjectTimeSummariesForListDocument, options);
      }
export function useGetMyAllProjectTimeSummariesForListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAllProjectTimeSummariesForListQuery, GetMyAllProjectTimeSummariesForListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAllProjectTimeSummariesForListQuery, GetMyAllProjectTimeSummariesForListQueryVariables>(GetMyAllProjectTimeSummariesForListDocument, options);
        }
export function useGetMyAllProjectTimeSummariesForListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyAllProjectTimeSummariesForListQuery, GetMyAllProjectTimeSummariesForListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyAllProjectTimeSummariesForListQuery, GetMyAllProjectTimeSummariesForListQueryVariables>(GetMyAllProjectTimeSummariesForListDocument, options);
        }
export type GetMyAllProjectTimeSummariesForListQueryHookResult = ReturnType<typeof useGetMyAllProjectTimeSummariesForListQuery>;
export type GetMyAllProjectTimeSummariesForListLazyQueryHookResult = ReturnType<typeof useGetMyAllProjectTimeSummariesForListLazyQuery>;
export type GetMyAllProjectTimeSummariesForListSuspenseQueryHookResult = ReturnType<typeof useGetMyAllProjectTimeSummariesForListSuspenseQuery>;
export type GetMyAllProjectTimeSummariesForListQueryResult = Apollo.QueryResult<GetMyAllProjectTimeSummariesForListQuery, GetMyAllProjectTimeSummariesForListQueryVariables>;
export const GetMyAllProjectsDocument = gql`
    query GetMyAllProjects($after: String, $before: String, $end: LocalDate!, $name: String, $type: ProjectType, $order: OrderType, $showDeleted: Boolean, $first: Int, $last: Int, $start: LocalDate!) {
  myAllProjects(
    after: $after
    before: $before
    end: $end
    filter: {filterByName: $name, filterByType: $type, order: $order, showDeleted: $showDeleted}
    first: $first
    last: $last
    start: $start
  ) {
    nodes {
      name
      id
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetMyAllProjectsQuery__
 *
 * To run a query within a React component, call `useGetMyAllProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAllProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAllProjectsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      end: // value for 'end'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      order: // value for 'order'
 *      showDeleted: // value for 'showDeleted'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      start: // value for 'start'
 *   },
 * });
 */
export function useGetMyAllProjectsQuery(baseOptions: Apollo.QueryHookOptions<GetMyAllProjectsQuery, GetMyAllProjectsQueryVariables> & ({ variables: GetMyAllProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAllProjectsQuery, GetMyAllProjectsQueryVariables>(GetMyAllProjectsDocument, options);
      }
export function useGetMyAllProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAllProjectsQuery, GetMyAllProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAllProjectsQuery, GetMyAllProjectsQueryVariables>(GetMyAllProjectsDocument, options);
        }
export function useGetMyAllProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyAllProjectsQuery, GetMyAllProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyAllProjectsQuery, GetMyAllProjectsQueryVariables>(GetMyAllProjectsDocument, options);
        }
export type GetMyAllProjectsQueryHookResult = ReturnType<typeof useGetMyAllProjectsQuery>;
export type GetMyAllProjectsLazyQueryHookResult = ReturnType<typeof useGetMyAllProjectsLazyQuery>;
export type GetMyAllProjectsSuspenseQueryHookResult = ReturnType<typeof useGetMyAllProjectsSuspenseQuery>;
export type GetMyAllProjectsQueryResult = Apollo.QueryResult<GetMyAllProjectsQuery, GetMyAllProjectsQueryVariables>;
export const GetMyAllVacationRequestsDocument = gql`
    query GetMyAllVacationRequests($first: Int, $after: String) {
  myAllVacationRequests(after: $after, first: $first) {
    nodes {
      absenceReasonId
      absenceReasonName
      employee {
        id
        displayName
      }
      end
      id
      isDeleted
      isHalfEndDay
      isHalfStartDay
      start
      status
      timestamp
      version
      workDays
      totalDays
      publicHolidays
      history {
        absenceReasonId
        absenceReasonName
        end
        isHalfEndDay
        isHalfStartDay
        start
        status
        timestamp
        version
        createdBy {
          id
          displayName
        }
        delegateEmployee {
          displayName
          id
        }
        workDays
        totalDays
        publicHolidays
      }
      logs {
        id
        message
        timestamp
        createdBy {
          displayName
          id
        }
      }
      createdBy {
        displayName
        id
      }
      delegateEmployee {
        displayName
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetMyAllVacationRequestsQuery__
 *
 * To run a query within a React component, call `useGetMyAllVacationRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAllVacationRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAllVacationRequestsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetMyAllVacationRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyAllVacationRequestsQuery, GetMyAllVacationRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAllVacationRequestsQuery, GetMyAllVacationRequestsQueryVariables>(GetMyAllVacationRequestsDocument, options);
      }
export function useGetMyAllVacationRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAllVacationRequestsQuery, GetMyAllVacationRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAllVacationRequestsQuery, GetMyAllVacationRequestsQueryVariables>(GetMyAllVacationRequestsDocument, options);
        }
export function useGetMyAllVacationRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyAllVacationRequestsQuery, GetMyAllVacationRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyAllVacationRequestsQuery, GetMyAllVacationRequestsQueryVariables>(GetMyAllVacationRequestsDocument, options);
        }
export type GetMyAllVacationRequestsQueryHookResult = ReturnType<typeof useGetMyAllVacationRequestsQuery>;
export type GetMyAllVacationRequestsLazyQueryHookResult = ReturnType<typeof useGetMyAllVacationRequestsLazyQuery>;
export type GetMyAllVacationRequestsSuspenseQueryHookResult = ReturnType<typeof useGetMyAllVacationRequestsSuspenseQuery>;
export type GetMyAllVacationRequestsQueryResult = Apollo.QueryResult<GetMyAllVacationRequestsQuery, GetMyAllVacationRequestsQueryVariables>;
export const GetMyCalendarEntriesDocument = gql`
    query GetMyCalendarEntries($end: LocalDate!, $showInformation: Boolean!, $showOnlyMe: Boolean!, $showPending: Boolean!, $start: LocalDate!) {
  myCalendarEntries(
    end: $end
    showInformation: $showInformation
    showOnlyMe: $showOnlyMe
    showPending: $showPending
    start: $start
  ) {
    absenceId
    absenceReasonType
    absenceStatus
    employee {
      displayName
      id
    }
    endDate
    isHalfEndDay
    isHalfStartDay
    startDate
    title
    totalDays
    type
    delegateEmployee {
      id
      displayName
    }
    absenceReasonId
    absenceVersion
  }
}
    `;

/**
 * __useGetMyCalendarEntriesQuery__
 *
 * To run a query within a React component, call `useGetMyCalendarEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCalendarEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCalendarEntriesQuery({
 *   variables: {
 *      end: // value for 'end'
 *      showInformation: // value for 'showInformation'
 *      showOnlyMe: // value for 'showOnlyMe'
 *      showPending: // value for 'showPending'
 *      start: // value for 'start'
 *   },
 * });
 */
export function useGetMyCalendarEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetMyCalendarEntriesQuery, GetMyCalendarEntriesQueryVariables> & ({ variables: GetMyCalendarEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCalendarEntriesQuery, GetMyCalendarEntriesQueryVariables>(GetMyCalendarEntriesDocument, options);
      }
export function useGetMyCalendarEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCalendarEntriesQuery, GetMyCalendarEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCalendarEntriesQuery, GetMyCalendarEntriesQueryVariables>(GetMyCalendarEntriesDocument, options);
        }
export function useGetMyCalendarEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyCalendarEntriesQuery, GetMyCalendarEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyCalendarEntriesQuery, GetMyCalendarEntriesQueryVariables>(GetMyCalendarEntriesDocument, options);
        }
export type GetMyCalendarEntriesQueryHookResult = ReturnType<typeof useGetMyCalendarEntriesQuery>;
export type GetMyCalendarEntriesLazyQueryHookResult = ReturnType<typeof useGetMyCalendarEntriesLazyQuery>;
export type GetMyCalendarEntriesSuspenseQueryHookResult = ReturnType<typeof useGetMyCalendarEntriesSuspenseQuery>;
export type GetMyCalendarEntriesQueryResult = Apollo.QueryResult<GetMyCalendarEntriesQuery, GetMyCalendarEntriesQueryVariables>;
export const GetMyNextCalendarEntriesDocument = gql`
    query GetMyNextCalendarEntries($start: LocalDate!, $showInformation: Boolean!, $showPending: Boolean!) {
  myNextCalendarEntries(
    start: $start
    showInformation: $showInformation
    showPending: $showPending
  ) {
    absenceId
    startDate
    endDate
    title
    absenceStatus
    absenceReasonType
    isHalfEndDay
    isHalfStartDay
    totalDays
    type
    absenceReasonId
  }
}
    `;

/**
 * __useGetMyNextCalendarEntriesQuery__
 *
 * To run a query within a React component, call `useGetMyNextCalendarEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyNextCalendarEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyNextCalendarEntriesQuery({
 *   variables: {
 *      start: // value for 'start'
 *      showInformation: // value for 'showInformation'
 *      showPending: // value for 'showPending'
 *   },
 * });
 */
export function useGetMyNextCalendarEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetMyNextCalendarEntriesQuery, GetMyNextCalendarEntriesQueryVariables> & ({ variables: GetMyNextCalendarEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyNextCalendarEntriesQuery, GetMyNextCalendarEntriesQueryVariables>(GetMyNextCalendarEntriesDocument, options);
      }
export function useGetMyNextCalendarEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyNextCalendarEntriesQuery, GetMyNextCalendarEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyNextCalendarEntriesQuery, GetMyNextCalendarEntriesQueryVariables>(GetMyNextCalendarEntriesDocument, options);
        }
export function useGetMyNextCalendarEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyNextCalendarEntriesQuery, GetMyNextCalendarEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyNextCalendarEntriesQuery, GetMyNextCalendarEntriesQueryVariables>(GetMyNextCalendarEntriesDocument, options);
        }
export type GetMyNextCalendarEntriesQueryHookResult = ReturnType<typeof useGetMyNextCalendarEntriesQuery>;
export type GetMyNextCalendarEntriesLazyQueryHookResult = ReturnType<typeof useGetMyNextCalendarEntriesLazyQuery>;
export type GetMyNextCalendarEntriesSuspenseQueryHookResult = ReturnType<typeof useGetMyNextCalendarEntriesSuspenseQuery>;
export type GetMyNextCalendarEntriesQueryResult = Apollo.QueryResult<GetMyNextCalendarEntriesQuery, GetMyNextCalendarEntriesQueryVariables>;
export const GetMyProjectTimeSummariesDocument = gql`
    query GetMyProjectTimeSummaries($projectId: ID!) {
  myProjectTimeSummaries(projectId: $projectId) {
    approvedMinutes
    openMinutes
    pendingMinutes
    totalMinutes
    positionName
    projectName
    totalWorkedMinutes
    projectId
    projectPositionId
    isDeleted
    startDate
    endDate
  }
}
    `;

/**
 * __useGetMyProjectTimeSummariesQuery__
 *
 * To run a query within a React component, call `useGetMyProjectTimeSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProjectTimeSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProjectTimeSummariesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetMyProjectTimeSummariesQuery(baseOptions: Apollo.QueryHookOptions<GetMyProjectTimeSummariesQuery, GetMyProjectTimeSummariesQueryVariables> & ({ variables: GetMyProjectTimeSummariesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyProjectTimeSummariesQuery, GetMyProjectTimeSummariesQueryVariables>(GetMyProjectTimeSummariesDocument, options);
      }
export function useGetMyProjectTimeSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyProjectTimeSummariesQuery, GetMyProjectTimeSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyProjectTimeSummariesQuery, GetMyProjectTimeSummariesQueryVariables>(GetMyProjectTimeSummariesDocument, options);
        }
export function useGetMyProjectTimeSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyProjectTimeSummariesQuery, GetMyProjectTimeSummariesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyProjectTimeSummariesQuery, GetMyProjectTimeSummariesQueryVariables>(GetMyProjectTimeSummariesDocument, options);
        }
export type GetMyProjectTimeSummariesQueryHookResult = ReturnType<typeof useGetMyProjectTimeSummariesQuery>;
export type GetMyProjectTimeSummariesLazyQueryHookResult = ReturnType<typeof useGetMyProjectTimeSummariesLazyQuery>;
export type GetMyProjectTimeSummariesSuspenseQueryHookResult = ReturnType<typeof useGetMyProjectTimeSummariesSuspenseQuery>;
export type GetMyProjectTimeSummariesQueryResult = Apollo.QueryResult<GetMyProjectTimeSummariesQuery, GetMyProjectTimeSummariesQueryVariables>;
export const GetMyProjectWorktimeOverviewDocument = gql`
    query GetMyProjectWorktimeOverview($startDate: LocalDate!, $endDate: LocalDate!) {
  myProjectWorktimeOverview(startDate: $startDate, endDate: $endDate) {
    date
    entries {
      projectId
      projectName
      projectPositionId
      projectPositionName
      totalMinutes
    }
  }
}
    `;

/**
 * __useGetMyProjectWorktimeOverviewQuery__
 *
 * To run a query within a React component, call `useGetMyProjectWorktimeOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProjectWorktimeOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProjectWorktimeOverviewQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetMyProjectWorktimeOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetMyProjectWorktimeOverviewQuery, GetMyProjectWorktimeOverviewQueryVariables> & ({ variables: GetMyProjectWorktimeOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyProjectWorktimeOverviewQuery, GetMyProjectWorktimeOverviewQueryVariables>(GetMyProjectWorktimeOverviewDocument, options);
      }
export function useGetMyProjectWorktimeOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyProjectWorktimeOverviewQuery, GetMyProjectWorktimeOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyProjectWorktimeOverviewQuery, GetMyProjectWorktimeOverviewQueryVariables>(GetMyProjectWorktimeOverviewDocument, options);
        }
export function useGetMyProjectWorktimeOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyProjectWorktimeOverviewQuery, GetMyProjectWorktimeOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyProjectWorktimeOverviewQuery, GetMyProjectWorktimeOverviewQueryVariables>(GetMyProjectWorktimeOverviewDocument, options);
        }
export type GetMyProjectWorktimeOverviewQueryHookResult = ReturnType<typeof useGetMyProjectWorktimeOverviewQuery>;
export type GetMyProjectWorktimeOverviewLazyQueryHookResult = ReturnType<typeof useGetMyProjectWorktimeOverviewLazyQuery>;
export type GetMyProjectWorktimeOverviewSuspenseQueryHookResult = ReturnType<typeof useGetMyProjectWorktimeOverviewSuspenseQuery>;
export type GetMyProjectWorktimeOverviewQueryResult = Apollo.QueryResult<GetMyProjectWorktimeOverviewQuery, GetMyProjectWorktimeOverviewQueryVariables>;
export const GetMyProjectWorktimeYearlyOverviewDocument = gql`
    query GetMyProjectWorktimeYearlyOverview($year: Int!) {
  myProjectWorktimeYearlyOverview(year: $year) {
    totalMinutes
    projectPositionName
    projectPositionId
    projectName
    projectId
  }
}
    `;

/**
 * __useGetMyProjectWorktimeYearlyOverviewQuery__
 *
 * To run a query within a React component, call `useGetMyProjectWorktimeYearlyOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProjectWorktimeYearlyOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProjectWorktimeYearlyOverviewQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetMyProjectWorktimeYearlyOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetMyProjectWorktimeYearlyOverviewQuery, GetMyProjectWorktimeYearlyOverviewQueryVariables> & ({ variables: GetMyProjectWorktimeYearlyOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyProjectWorktimeYearlyOverviewQuery, GetMyProjectWorktimeYearlyOverviewQueryVariables>(GetMyProjectWorktimeYearlyOverviewDocument, options);
      }
export function useGetMyProjectWorktimeYearlyOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyProjectWorktimeYearlyOverviewQuery, GetMyProjectWorktimeYearlyOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyProjectWorktimeYearlyOverviewQuery, GetMyProjectWorktimeYearlyOverviewQueryVariables>(GetMyProjectWorktimeYearlyOverviewDocument, options);
        }
export function useGetMyProjectWorktimeYearlyOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyProjectWorktimeYearlyOverviewQuery, GetMyProjectWorktimeYearlyOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyProjectWorktimeYearlyOverviewQuery, GetMyProjectWorktimeYearlyOverviewQueryVariables>(GetMyProjectWorktimeYearlyOverviewDocument, options);
        }
export type GetMyProjectWorktimeYearlyOverviewQueryHookResult = ReturnType<typeof useGetMyProjectWorktimeYearlyOverviewQuery>;
export type GetMyProjectWorktimeYearlyOverviewLazyQueryHookResult = ReturnType<typeof useGetMyProjectWorktimeYearlyOverviewLazyQuery>;
export type GetMyProjectWorktimeYearlyOverviewSuspenseQueryHookResult = ReturnType<typeof useGetMyProjectWorktimeYearlyOverviewSuspenseQuery>;
export type GetMyProjectWorktimeYearlyOverviewQueryResult = Apollo.QueryResult<GetMyProjectWorktimeYearlyOverviewQuery, GetMyProjectWorktimeYearlyOverviewQueryVariables>;
export const GetMyTimeEntriesDocument = gql`
    query GetMyTimeEntries($startDate: LocalDate!, $endDate: LocalDate!, $projectId: ID!) {
  myTimeEntries(
    filter: {endDate: $endDate, startDate: $startDate, projectId: $projectId}
  ) {
    date
    id
    items {
      history {
        createdBy {
          id
          displayName
        }
        description
        end
        entryType
        member {
          id
          displayName
        }
        start
        status
        timeLabel {
          name
          id
        }
        timestamp
        version
        workLocation
      }
      calendarId
      createdBy {
        displayName
        id
      }
      description
      end
      entryType
      id
      status
      logs {
        createdBy {
          displayName
          id
        }
        id
        message
        timestamp
      }
      member {
        displayName
        id
      }
      path
      start
      timeLabel {
        name
        id
      }
      timestamp
      title
      version
      workLocation
      timeLabelId
    }
    errors
    absenceReason
    workingMinutes
    requiredWorkingMinutes
    rejectedWorkingMinutes
    pendingWorkingMinutes
    breakMinutes
    balanceMinutes
    balanceEntry {
      overtimeMinutes
      type
    }
    approvedWorkingMinutes
  }
}
    `;

/**
 * __useGetMyTimeEntriesQuery__
 *
 * To run a query within a React component, call `useGetMyTimeEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTimeEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTimeEntriesQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetMyTimeEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetMyTimeEntriesQuery, GetMyTimeEntriesQueryVariables> & ({ variables: GetMyTimeEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyTimeEntriesQuery, GetMyTimeEntriesQueryVariables>(GetMyTimeEntriesDocument, options);
      }
export function useGetMyTimeEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyTimeEntriesQuery, GetMyTimeEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyTimeEntriesQuery, GetMyTimeEntriesQueryVariables>(GetMyTimeEntriesDocument, options);
        }
export function useGetMyTimeEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyTimeEntriesQuery, GetMyTimeEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyTimeEntriesQuery, GetMyTimeEntriesQueryVariables>(GetMyTimeEntriesDocument, options);
        }
export type GetMyTimeEntriesQueryHookResult = ReturnType<typeof useGetMyTimeEntriesQuery>;
export type GetMyTimeEntriesLazyQueryHookResult = ReturnType<typeof useGetMyTimeEntriesLazyQuery>;
export type GetMyTimeEntriesSuspenseQueryHookResult = ReturnType<typeof useGetMyTimeEntriesSuspenseQuery>;
export type GetMyTimeEntriesQueryResult = Apollo.QueryResult<GetMyTimeEntriesQuery, GetMyTimeEntriesQueryVariables>;
export const GetMyTimerDocument = gql`
    query GetMyTimer {
  myTimer
}
    `;

/**
 * __useGetMyTimerQuery__
 *
 * To run a query within a React component, call `useGetMyTimerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTimerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTimerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyTimerQuery(baseOptions?: Apollo.QueryHookOptions<GetMyTimerQuery, GetMyTimerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyTimerQuery, GetMyTimerQueryVariables>(GetMyTimerDocument, options);
      }
export function useGetMyTimerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyTimerQuery, GetMyTimerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyTimerQuery, GetMyTimerQueryVariables>(GetMyTimerDocument, options);
        }
export function useGetMyTimerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyTimerQuery, GetMyTimerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyTimerQuery, GetMyTimerQueryVariables>(GetMyTimerDocument, options);
        }
export type GetMyTimerQueryHookResult = ReturnType<typeof useGetMyTimerQuery>;
export type GetMyTimerLazyQueryHookResult = ReturnType<typeof useGetMyTimerLazyQuery>;
export type GetMyTimerSuspenseQueryHookResult = ReturnType<typeof useGetMyTimerSuspenseQuery>;
export type GetMyTimerQueryResult = Apollo.QueryResult<GetMyTimerQuery, GetMyTimerQueryVariables>;
export const GetMyTotalWorkTimeSummaryDocument = gql`
    query GetMyTotalWorkTimeSummary($today: LocalDate!) {
  myTotalWorkTimeSummary(today: $today) {
    approvedMinutes
    balanceMinutes
    pendingMinutes
    rejectedMinutes
    requiredMinutes
    totalMinutes
  }
}
    `;

/**
 * __useGetMyTotalWorkTimeSummaryQuery__
 *
 * To run a query within a React component, call `useGetMyTotalWorkTimeSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTotalWorkTimeSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTotalWorkTimeSummaryQuery({
 *   variables: {
 *      today: // value for 'today'
 *   },
 * });
 */
export function useGetMyTotalWorkTimeSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetMyTotalWorkTimeSummaryQuery, GetMyTotalWorkTimeSummaryQueryVariables> & ({ variables: GetMyTotalWorkTimeSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyTotalWorkTimeSummaryQuery, GetMyTotalWorkTimeSummaryQueryVariables>(GetMyTotalWorkTimeSummaryDocument, options);
      }
export function useGetMyTotalWorkTimeSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyTotalWorkTimeSummaryQuery, GetMyTotalWorkTimeSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyTotalWorkTimeSummaryQuery, GetMyTotalWorkTimeSummaryQueryVariables>(GetMyTotalWorkTimeSummaryDocument, options);
        }
export function useGetMyTotalWorkTimeSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyTotalWorkTimeSummaryQuery, GetMyTotalWorkTimeSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyTotalWorkTimeSummaryQuery, GetMyTotalWorkTimeSummaryQueryVariables>(GetMyTotalWorkTimeSummaryDocument, options);
        }
export type GetMyTotalWorkTimeSummaryQueryHookResult = ReturnType<typeof useGetMyTotalWorkTimeSummaryQuery>;
export type GetMyTotalWorkTimeSummaryLazyQueryHookResult = ReturnType<typeof useGetMyTotalWorkTimeSummaryLazyQuery>;
export type GetMyTotalWorkTimeSummarySuspenseQueryHookResult = ReturnType<typeof useGetMyTotalWorkTimeSummarySuspenseQuery>;
export type GetMyTotalWorkTimeSummaryQueryResult = Apollo.QueryResult<GetMyTotalWorkTimeSummaryQuery, GetMyTotalWorkTimeSummaryQueryVariables>;
export const GetMyVacationSummaryDocument = gql`
    query GetMyVacationSummary($year: Int!) {
  myVacationSummary(year: $year) {
    total
    inPending
    planned
    taken
  }
}
    `;

/**
 * __useGetMyVacationSummaryQuery__
 *
 * To run a query within a React component, call `useGetMyVacationSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyVacationSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyVacationSummaryQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetMyVacationSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetMyVacationSummaryQuery, GetMyVacationSummaryQueryVariables> & ({ variables: GetMyVacationSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyVacationSummaryQuery, GetMyVacationSummaryQueryVariables>(GetMyVacationSummaryDocument, options);
      }
export function useGetMyVacationSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyVacationSummaryQuery, GetMyVacationSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyVacationSummaryQuery, GetMyVacationSummaryQueryVariables>(GetMyVacationSummaryDocument, options);
        }
export function useGetMyVacationSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyVacationSummaryQuery, GetMyVacationSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyVacationSummaryQuery, GetMyVacationSummaryQueryVariables>(GetMyVacationSummaryDocument, options);
        }
export type GetMyVacationSummaryQueryHookResult = ReturnType<typeof useGetMyVacationSummaryQuery>;
export type GetMyVacationSummaryLazyQueryHookResult = ReturnType<typeof useGetMyVacationSummaryLazyQuery>;
export type GetMyVacationSummarySuspenseQueryHookResult = ReturnType<typeof useGetMyVacationSummarySuspenseQuery>;
export type GetMyVacationSummaryQueryResult = Apollo.QueryResult<GetMyVacationSummaryQuery, GetMyVacationSummaryQueryVariables>;
export const GetProjectTimeSummariesDocument = gql`
    query GetProjectTimeSummaries($projectId: ID!, $employeeId: ID!) {
  projectTimeSummaries(projectId: $projectId, employeeId: $employeeId) {
    approvedMinutes
    openMinutes
    pendingMinutes
    totalMinutes
    positionName
    projectName
    totalWorkedMinutes
  }
}
    `;

/**
 * __useGetProjectTimeSummariesQuery__
 *
 * To run a query within a React component, call `useGetProjectTimeSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectTimeSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectTimeSummariesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useGetProjectTimeSummariesQuery(baseOptions: Apollo.QueryHookOptions<GetProjectTimeSummariesQuery, GetProjectTimeSummariesQueryVariables> & ({ variables: GetProjectTimeSummariesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectTimeSummariesQuery, GetProjectTimeSummariesQueryVariables>(GetProjectTimeSummariesDocument, options);
      }
export function useGetProjectTimeSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectTimeSummariesQuery, GetProjectTimeSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectTimeSummariesQuery, GetProjectTimeSummariesQueryVariables>(GetProjectTimeSummariesDocument, options);
        }
export function useGetProjectTimeSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectTimeSummariesQuery, GetProjectTimeSummariesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectTimeSummariesQuery, GetProjectTimeSummariesQueryVariables>(GetProjectTimeSummariesDocument, options);
        }
export type GetProjectTimeSummariesQueryHookResult = ReturnType<typeof useGetProjectTimeSummariesQuery>;
export type GetProjectTimeSummariesLazyQueryHookResult = ReturnType<typeof useGetProjectTimeSummariesLazyQuery>;
export type GetProjectTimeSummariesSuspenseQueryHookResult = ReturnType<typeof useGetProjectTimeSummariesSuspenseQuery>;
export type GetProjectTimeSummariesQueryResult = Apollo.QueryResult<GetProjectTimeSummariesQuery, GetProjectTimeSummariesQueryVariables>;
export const GetTeamMemberTimeEntriesDocument = gql`
    query GetTeamMemberTimeEntries($startDate: LocalDate!, $endDate: LocalDate!, $employeeId: ID!, $projectId: ID!) {
  teamMemberTimeEntries(
    filter: {employeeId: $employeeId, endDate: $endDate, startDate: $startDate, projectId: $projectId}
  ) {
    date
    id
    items {
      calendarId
      createdBy {
        displayName
        id
      }
      description
      end
      entryType
      id
      status
      logs {
        createdBy {
          displayName
          id
        }
        id
        message
        timestamp
      }
      member {
        displayName
        id
      }
      path
      start
      timeLabel {
        name
        id
      }
      timestamp
      title
      version
      workLocation
      timeLabelId
      history {
        createdBy {
          id
          displayName
        }
        description
        end
        entryType
        member {
          id
          displayName
        }
        start
        status
        timeLabel {
          name
          id
        }
        timestamp
        version
        workLocation
      }
    }
    errors
    absenceReason
    approvedWorkingMinutes
    balanceEntry {
      overtimeMinutes
      type
    }
    balanceMinutes
    breakMinutes
    pendingWorkingMinutes
    rejectedWorkingMinutes
    requiredWorkingMinutes
    workingMinutes
  }
}
    `;

/**
 * __useGetTeamMemberTimeEntriesQuery__
 *
 * To run a query within a React component, call `useGetTeamMemberTimeEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamMemberTimeEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamMemberTimeEntriesQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      employeeId: // value for 'employeeId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetTeamMemberTimeEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetTeamMemberTimeEntriesQuery, GetTeamMemberTimeEntriesQueryVariables> & ({ variables: GetTeamMemberTimeEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamMemberTimeEntriesQuery, GetTeamMemberTimeEntriesQueryVariables>(GetTeamMemberTimeEntriesDocument, options);
      }
export function useGetTeamMemberTimeEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamMemberTimeEntriesQuery, GetTeamMemberTimeEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamMemberTimeEntriesQuery, GetTeamMemberTimeEntriesQueryVariables>(GetTeamMemberTimeEntriesDocument, options);
        }
export function useGetTeamMemberTimeEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamMemberTimeEntriesQuery, GetTeamMemberTimeEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamMemberTimeEntriesQuery, GetTeamMemberTimeEntriesQueryVariables>(GetTeamMemberTimeEntriesDocument, options);
        }
export type GetTeamMemberTimeEntriesQueryHookResult = ReturnType<typeof useGetTeamMemberTimeEntriesQuery>;
export type GetTeamMemberTimeEntriesLazyQueryHookResult = ReturnType<typeof useGetTeamMemberTimeEntriesLazyQuery>;
export type GetTeamMemberTimeEntriesSuspenseQueryHookResult = ReturnType<typeof useGetTeamMemberTimeEntriesSuspenseQuery>;
export type GetTeamMemberTimeEntriesQueryResult = Apollo.QueryResult<GetTeamMemberTimeEntriesQuery, GetTeamMemberTimeEntriesQueryVariables>;
export const GetTeamMemberTotalWorkTimeSummaryDocument = gql`
    query GetTeamMemberTotalWorkTimeSummary($today: LocalDate!, $employeeId: ID!) {
  totalTeamMemberWorkTimeSummary(today: $today, employeeId: $employeeId) {
    approvedMinutes
    balanceMinutes
    pendingMinutes
    rejectedMinutes
    requiredMinutes
    totalMinutes
  }
}
    `;

/**
 * __useGetTeamMemberTotalWorkTimeSummaryQuery__
 *
 * To run a query within a React component, call `useGetTeamMemberTotalWorkTimeSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamMemberTotalWorkTimeSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamMemberTotalWorkTimeSummaryQuery({
 *   variables: {
 *      today: // value for 'today'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useGetTeamMemberTotalWorkTimeSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetTeamMemberTotalWorkTimeSummaryQuery, GetTeamMemberTotalWorkTimeSummaryQueryVariables> & ({ variables: GetTeamMemberTotalWorkTimeSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamMemberTotalWorkTimeSummaryQuery, GetTeamMemberTotalWorkTimeSummaryQueryVariables>(GetTeamMemberTotalWorkTimeSummaryDocument, options);
      }
export function useGetTeamMemberTotalWorkTimeSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamMemberTotalWorkTimeSummaryQuery, GetTeamMemberTotalWorkTimeSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamMemberTotalWorkTimeSummaryQuery, GetTeamMemberTotalWorkTimeSummaryQueryVariables>(GetTeamMemberTotalWorkTimeSummaryDocument, options);
        }
export function useGetTeamMemberTotalWorkTimeSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamMemberTotalWorkTimeSummaryQuery, GetTeamMemberTotalWorkTimeSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamMemberTotalWorkTimeSummaryQuery, GetTeamMemberTotalWorkTimeSummaryQueryVariables>(GetTeamMemberTotalWorkTimeSummaryDocument, options);
        }
export type GetTeamMemberTotalWorkTimeSummaryQueryHookResult = ReturnType<typeof useGetTeamMemberTotalWorkTimeSummaryQuery>;
export type GetTeamMemberTotalWorkTimeSummaryLazyQueryHookResult = ReturnType<typeof useGetTeamMemberTotalWorkTimeSummaryLazyQuery>;
export type GetTeamMemberTotalWorkTimeSummarySuspenseQueryHookResult = ReturnType<typeof useGetTeamMemberTotalWorkTimeSummarySuspenseQuery>;
export type GetTeamMemberTotalWorkTimeSummaryQueryResult = Apollo.QueryResult<GetTeamMemberTotalWorkTimeSummaryQuery, GetTeamMemberTotalWorkTimeSummaryQueryVariables>;
export const GetTeamVacationSummaryDocument = gql`
    query GetTeamVacationSummary($employeeId: ID!, $year: Int!) {
  teamVacationSummary(employeeId: $employeeId, year: $year) {
    total
    inPending
    planned
    taken
  }
}
    `;

/**
 * __useGetTeamVacationSummaryQuery__
 *
 * To run a query within a React component, call `useGetTeamVacationSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamVacationSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamVacationSummaryQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetTeamVacationSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetTeamVacationSummaryQuery, GetTeamVacationSummaryQueryVariables> & ({ variables: GetTeamVacationSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamVacationSummaryQuery, GetTeamVacationSummaryQueryVariables>(GetTeamVacationSummaryDocument, options);
      }
export function useGetTeamVacationSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamVacationSummaryQuery, GetTeamVacationSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamVacationSummaryQuery, GetTeamVacationSummaryQueryVariables>(GetTeamVacationSummaryDocument, options);
        }
export function useGetTeamVacationSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamVacationSummaryQuery, GetTeamVacationSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamVacationSummaryQuery, GetTeamVacationSummaryQueryVariables>(GetTeamVacationSummaryDocument, options);
        }
export type GetTeamVacationSummaryQueryHookResult = ReturnType<typeof useGetTeamVacationSummaryQuery>;
export type GetTeamVacationSummaryLazyQueryHookResult = ReturnType<typeof useGetTeamVacationSummaryLazyQuery>;
export type GetTeamVacationSummarySuspenseQueryHookResult = ReturnType<typeof useGetTeamVacationSummarySuspenseQuery>;
export type GetTeamVacationSummaryQueryResult = Apollo.QueryResult<GetTeamVacationSummaryQuery, GetTeamVacationSummaryQueryVariables>;
export const GetTotalWorkTimeSummaryDocument = gql`
    query GetTotalWorkTimeSummary($today: LocalDate!, $employeeId: ID!) {
  totalWorkTimeSummary(today: $today, employeeId: $employeeId) {
    approvedMinutes
    balanceMinutes
    pendingMinutes
    rejectedMinutes
    requiredMinutes
    totalMinutes
  }
}
    `;

/**
 * __useGetTotalWorkTimeSummaryQuery__
 *
 * To run a query within a React component, call `useGetTotalWorkTimeSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalWorkTimeSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalWorkTimeSummaryQuery({
 *   variables: {
 *      today: // value for 'today'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useGetTotalWorkTimeSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetTotalWorkTimeSummaryQuery, GetTotalWorkTimeSummaryQueryVariables> & ({ variables: GetTotalWorkTimeSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotalWorkTimeSummaryQuery, GetTotalWorkTimeSummaryQueryVariables>(GetTotalWorkTimeSummaryDocument, options);
      }
export function useGetTotalWorkTimeSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotalWorkTimeSummaryQuery, GetTotalWorkTimeSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotalWorkTimeSummaryQuery, GetTotalWorkTimeSummaryQueryVariables>(GetTotalWorkTimeSummaryDocument, options);
        }
export function useGetTotalWorkTimeSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTotalWorkTimeSummaryQuery, GetTotalWorkTimeSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTotalWorkTimeSummaryQuery, GetTotalWorkTimeSummaryQueryVariables>(GetTotalWorkTimeSummaryDocument, options);
        }
export type GetTotalWorkTimeSummaryQueryHookResult = ReturnType<typeof useGetTotalWorkTimeSummaryQuery>;
export type GetTotalWorkTimeSummaryLazyQueryHookResult = ReturnType<typeof useGetTotalWorkTimeSummaryLazyQuery>;
export type GetTotalWorkTimeSummarySuspenseQueryHookResult = ReturnType<typeof useGetTotalWorkTimeSummarySuspenseQuery>;
export type GetTotalWorkTimeSummaryQueryResult = Apollo.QueryResult<GetTotalWorkTimeSummaryQuery, GetTotalWorkTimeSummaryQueryVariables>;
export const GetVacationSummaryDocument = gql`
    query GetVacationSummary($employeeId: ID!, $year: Int!) {
  vacationSummary(employeeId: $employeeId, year: $year) {
    total
    inPending
    planned
    taken
  }
}
    `;

/**
 * __useGetVacationSummaryQuery__
 *
 * To run a query within a React component, call `useGetVacationSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVacationSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVacationSummaryQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetVacationSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetVacationSummaryQuery, GetVacationSummaryQueryVariables> & ({ variables: GetVacationSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVacationSummaryQuery, GetVacationSummaryQueryVariables>(GetVacationSummaryDocument, options);
      }
export function useGetVacationSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVacationSummaryQuery, GetVacationSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVacationSummaryQuery, GetVacationSummaryQueryVariables>(GetVacationSummaryDocument, options);
        }
export function useGetVacationSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVacationSummaryQuery, GetVacationSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVacationSummaryQuery, GetVacationSummaryQueryVariables>(GetVacationSummaryDocument, options);
        }
export type GetVacationSummaryQueryHookResult = ReturnType<typeof useGetVacationSummaryQuery>;
export type GetVacationSummaryLazyQueryHookResult = ReturnType<typeof useGetVacationSummaryLazyQuery>;
export type GetVacationSummarySuspenseQueryHookResult = ReturnType<typeof useGetVacationSummarySuspenseQuery>;
export type GetVacationSummaryQueryResult = Apollo.QueryResult<GetVacationSummaryQuery, GetVacationSummaryQueryVariables>;
export const MyCancelVacationDocument = gql`
    mutation MyCancelVacation($comment: String, $absenceId: ID!, $version: Long!) {
  myCancelVacation(
    input: {comment: $comment, absenceId: $absenceId, version: $version}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on InvalidUserPrivilegesError {
        errorType
        message
      }
    }
    absence {
      id
    }
  }
}
    `;
export type MyCancelVacationMutationFn = Apollo.MutationFunction<MyCancelVacationMutation, MyCancelVacationMutationVariables>;

/**
 * __useMyCancelVacationMutation__
 *
 * To run a mutation, you first call `useMyCancelVacationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyCancelVacationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myCancelVacationMutation, { data, loading, error }] = useMyCancelVacationMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *      absenceId: // value for 'absenceId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useMyCancelVacationMutation(baseOptions?: Apollo.MutationHookOptions<MyCancelVacationMutation, MyCancelVacationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyCancelVacationMutation, MyCancelVacationMutationVariables>(MyCancelVacationDocument, options);
      }
export type MyCancelVacationMutationHookResult = ReturnType<typeof useMyCancelVacationMutation>;
export type MyCancelVacationMutationResult = Apollo.MutationResult<MyCancelVacationMutation>;
export type MyCancelVacationMutationOptions = Apollo.BaseMutationOptions<MyCancelVacationMutation, MyCancelVacationMutationVariables>;
export const MyCheckVacationDocument = gql`
    query MyCheckVacation($startDate: LocalDate!, $isHalfStartDay: Boolean!, $endDate: LocalDate!, $isHalfEndDay: Boolean!, $absenceId: ID) {
  myCheckVacation(
    startDate: $startDate
    endDate: $endDate
    updatingAbsenceId: $absenceId
    isHalfEndDay: $isHalfEndDay
    isHalfStartDay: $isHalfStartDay
  ) {
    canBeTaken
    hasDelegateDuties
    isInSameYear
    isOverlapping
    leftDays
    neededDays
    startDateIsTooClose
  }
}
    `;

/**
 * __useMyCheckVacationQuery__
 *
 * To run a query within a React component, call `useMyCheckVacationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCheckVacationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCheckVacationQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      isHalfStartDay: // value for 'isHalfStartDay'
 *      endDate: // value for 'endDate'
 *      isHalfEndDay: // value for 'isHalfEndDay'
 *      absenceId: // value for 'absenceId'
 *   },
 * });
 */
export function useMyCheckVacationQuery(baseOptions: Apollo.QueryHookOptions<MyCheckVacationQuery, MyCheckVacationQueryVariables> & ({ variables: MyCheckVacationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCheckVacationQuery, MyCheckVacationQueryVariables>(MyCheckVacationDocument, options);
      }
export function useMyCheckVacationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCheckVacationQuery, MyCheckVacationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCheckVacationQuery, MyCheckVacationQueryVariables>(MyCheckVacationDocument, options);
        }
export function useMyCheckVacationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyCheckVacationQuery, MyCheckVacationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyCheckVacationQuery, MyCheckVacationQueryVariables>(MyCheckVacationDocument, options);
        }
export type MyCheckVacationQueryHookResult = ReturnType<typeof useMyCheckVacationQuery>;
export type MyCheckVacationLazyQueryHookResult = ReturnType<typeof useMyCheckVacationLazyQuery>;
export type MyCheckVacationSuspenseQueryHookResult = ReturnType<typeof useMyCheckVacationSuspenseQuery>;
export type MyCheckVacationQueryResult = Apollo.QueryResult<MyCheckVacationQuery, MyCheckVacationQueryVariables>;
export const MyCreateVacationDocument = gql`
    mutation MyCreateVacation($absenceReasonId: ID!, $comment: String, $delegateEmployeeId: ID!, $end: LocalDate!, $isHalfEndDay: Boolean!, $isHalfStartDay: Boolean!, $start: LocalDate!) {
  myCreateVacation(
    input: {absenceReasonId: $absenceReasonId, comment: $comment, delegateEmployeeId: $delegateEmployeeId, end: $end, isHalfEndDay: $isHalfEndDay, isHalfStartDay: $isHalfStartDay, start: $start}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    absence {
      absenceReasonId
      absenceReasonName
      end
      id
      isHalfEndDay
      isHalfStartDay
      start
      status
      timestamp
      version
      history {
        absenceReasonId
        absenceReasonName
        end
        isHalfEndDay
        isHalfStartDay
        start
        status
        timestamp
        version
        createdBy {
          id
          displayName
        }
        delegateEmployee {
          displayName
          id
        }
        publicHolidays
        totalDays
        workDays
      }
      logs {
        id
        message
        timestamp
        createdBy {
          displayName
          id
        }
      }
      createdBy {
        displayName
        id
      }
      delegateEmployee {
        displayName
        id
      }
      employee {
        displayName
        id
      }
      absenceReasonType
      publicHolidays
      totalDays
      workDays
    }
  }
}
    `;
export type MyCreateVacationMutationFn = Apollo.MutationFunction<MyCreateVacationMutation, MyCreateVacationMutationVariables>;

/**
 * __useMyCreateVacationMutation__
 *
 * To run a mutation, you first call `useMyCreateVacationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyCreateVacationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myCreateVacationMutation, { data, loading, error }] = useMyCreateVacationMutation({
 *   variables: {
 *      absenceReasonId: // value for 'absenceReasonId'
 *      comment: // value for 'comment'
 *      delegateEmployeeId: // value for 'delegateEmployeeId'
 *      end: // value for 'end'
 *      isHalfEndDay: // value for 'isHalfEndDay'
 *      isHalfStartDay: // value for 'isHalfStartDay'
 *      start: // value for 'start'
 *   },
 * });
 */
export function useMyCreateVacationMutation(baseOptions?: Apollo.MutationHookOptions<MyCreateVacationMutation, MyCreateVacationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyCreateVacationMutation, MyCreateVacationMutationVariables>(MyCreateVacationDocument, options);
      }
export type MyCreateVacationMutationHookResult = ReturnType<typeof useMyCreateVacationMutation>;
export type MyCreateVacationMutationResult = Apollo.MutationResult<MyCreateVacationMutation>;
export type MyCreateVacationMutationOptions = Apollo.BaseMutationOptions<MyCreateVacationMutation, MyCreateVacationMutationVariables>;
export const MyUpdateVacationDocument = gql`
    mutation MyUpdateVacation($absenceReasonId: ID!, $comment: String, $delegateEmployeeId: ID!, $end: LocalDate!, $isHalfEndDay: Boolean!, $isHalfStartDay: Boolean!, $start: LocalDate!, $absenceId: ID!, $version: Long!) {
  myUpdateVacation(
    input: {absenceReasonId: $absenceReasonId, comment: $comment, delegateEmployeeId: $delegateEmployeeId, end: $end, isHalfEndDay: $isHalfEndDay, isHalfStartDay: $isHalfStartDay, start: $start, absenceId: $absenceId, version: $version}
  ) {
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on InvalidUserPrivilegesError {
        errorType
        message
      }
      ... on ConcurrentAccessError {
        errorType
        message
      }
    }
    absence {
      absenceReasonId
      absenceReasonName
      end
      id
      isHalfEndDay
      isHalfStartDay
      start
      status
      timestamp
      version
      history {
        absenceReasonId
        absenceReasonName
        end
        isHalfEndDay
        isHalfStartDay
        start
        status
        timestamp
        version
        createdBy {
          id
          displayName
        }
        delegateEmployee {
          displayName
          id
        }
        totalDays
        publicHolidays
        workDays
      }
      logs {
        id
        message
        timestamp
        createdBy {
          displayName
          id
        }
      }
      createdBy {
        displayName
        id
      }
      delegateEmployee {
        displayName
        id
      }
      employee {
        displayName
        id
      }
      absenceReasonType
      publicHolidays
      totalDays
      workDays
    }
  }
}
    `;
export type MyUpdateVacationMutationFn = Apollo.MutationFunction<MyUpdateVacationMutation, MyUpdateVacationMutationVariables>;

/**
 * __useMyUpdateVacationMutation__
 *
 * To run a mutation, you first call `useMyUpdateVacationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyUpdateVacationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myUpdateVacationMutation, { data, loading, error }] = useMyUpdateVacationMutation({
 *   variables: {
 *      absenceReasonId: // value for 'absenceReasonId'
 *      comment: // value for 'comment'
 *      delegateEmployeeId: // value for 'delegateEmployeeId'
 *      end: // value for 'end'
 *      isHalfEndDay: // value for 'isHalfEndDay'
 *      isHalfStartDay: // value for 'isHalfStartDay'
 *      start: // value for 'start'
 *      absenceId: // value for 'absenceId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useMyUpdateVacationMutation(baseOptions?: Apollo.MutationHookOptions<MyUpdateVacationMutation, MyUpdateVacationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyUpdateVacationMutation, MyUpdateVacationMutationVariables>(MyUpdateVacationDocument, options);
      }
export type MyUpdateVacationMutationHookResult = ReturnType<typeof useMyUpdateVacationMutation>;
export type MyUpdateVacationMutationResult = Apollo.MutationResult<MyUpdateVacationMutation>;
export type MyUpdateVacationMutationOptions = Apollo.BaseMutationOptions<MyUpdateVacationMutation, MyUpdateVacationMutationVariables>;
export const MyWorkTimeSummaryDocument = gql`
    query MyWorkTimeSummary($startDate: LocalDate!, $endDate: LocalDate!) {
  myWorkTimeSummary(startDate: $startDate, endDate: $endDate) {
    approvedMinutes
    balanceMinutes
    pendingMinutes
    rejectedMinutes
    requiredMinutes
    totalMinutes
  }
}
    `;

/**
 * __useMyWorkTimeSummaryQuery__
 *
 * To run a query within a React component, call `useMyWorkTimeSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyWorkTimeSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyWorkTimeSummaryQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useMyWorkTimeSummaryQuery(baseOptions: Apollo.QueryHookOptions<MyWorkTimeSummaryQuery, MyWorkTimeSummaryQueryVariables> & ({ variables: MyWorkTimeSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyWorkTimeSummaryQuery, MyWorkTimeSummaryQueryVariables>(MyWorkTimeSummaryDocument, options);
      }
export function useMyWorkTimeSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyWorkTimeSummaryQuery, MyWorkTimeSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyWorkTimeSummaryQuery, MyWorkTimeSummaryQueryVariables>(MyWorkTimeSummaryDocument, options);
        }
export function useMyWorkTimeSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyWorkTimeSummaryQuery, MyWorkTimeSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyWorkTimeSummaryQuery, MyWorkTimeSummaryQueryVariables>(MyWorkTimeSummaryDocument, options);
        }
export type MyWorkTimeSummaryQueryHookResult = ReturnType<typeof useMyWorkTimeSummaryQuery>;
export type MyWorkTimeSummaryLazyQueryHookResult = ReturnType<typeof useMyWorkTimeSummaryLazyQuery>;
export type MyWorkTimeSummarySuspenseQueryHookResult = ReturnType<typeof useMyWorkTimeSummarySuspenseQuery>;
export type MyWorkTimeSummaryQueryResult = Apollo.QueryResult<MyWorkTimeSummaryQuery, MyWorkTimeSummaryQueryVariables>;
export const RemoveEmployeesFromLabelGroupDocument = gql`
    mutation RemoveEmployeesFromLabelGroup($id: ID!, $employees: [ID!]!, $version: Long!) {
  removeEmployeesFromLabelGroup(
    input: {employees: $employees, id: $id, version: $version}
  ) {
    errors {
      ... on ConcurrentAccessError {
        errorType
        message
      }
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    timeLabelGroup {
      companyId
      departmentIds
      employeeIds
      id
      isGlobal
      name
      version
      departments {
        companyId
        description
        id
        leaderId
        name
        version
      }
      employees {
        companyName
        contactNumber
        contactTypes
        displayContactType
        displayName
        firstName
        id
        isACompany
        isAFreelancer
        isAPerson
        isDeleted
        isContactPerson
        isEmployee
        isTemporary
        lastName
        salutation
        shortCode
        title
        version
      }
      labels {
        companyId
        departmentIds
        employeeIds
        id
        isActive
        isDeleted
        name
        version
      }
    }
  }
}
    `;
export type RemoveEmployeesFromLabelGroupMutationFn = Apollo.MutationFunction<RemoveEmployeesFromLabelGroupMutation, RemoveEmployeesFromLabelGroupMutationVariables>;

/**
 * __useRemoveEmployeesFromLabelGroupMutation__
 *
 * To run a mutation, you first call `useRemoveEmployeesFromLabelGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEmployeesFromLabelGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEmployeesFromLabelGroupMutation, { data, loading, error }] = useRemoveEmployeesFromLabelGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      employees: // value for 'employees'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useRemoveEmployeesFromLabelGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEmployeesFromLabelGroupMutation, RemoveEmployeesFromLabelGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEmployeesFromLabelGroupMutation, RemoveEmployeesFromLabelGroupMutationVariables>(RemoveEmployeesFromLabelGroupDocument, options);
      }
export type RemoveEmployeesFromLabelGroupMutationHookResult = ReturnType<typeof useRemoveEmployeesFromLabelGroupMutation>;
export type RemoveEmployeesFromLabelGroupMutationResult = Apollo.MutationResult<RemoveEmployeesFromLabelGroupMutation>;
export type RemoveEmployeesFromLabelGroupMutationOptions = Apollo.BaseMutationOptions<RemoveEmployeesFromLabelGroupMutation, RemoveEmployeesFromLabelGroupMutationVariables>;
export const RemoveEmployeesFromTimeLabelDocument = gql`
    mutation RemoveEmployeesFromTimeLabel($id: ID!, $employees: [ID!]!, $version: Long!) {
  removeEmployeesFromTimeLabel(
    input: {employeeIds: $employees, id: $id, version: $version}
  ) {
    errors {
      ... on ConcurrentAccessError {
        errorType
        message
      }
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    timeLabel {
      companyId
      departmentIds
      employeeIds
      id
      isActive
      isDeleted
      name
      version
      departments {
        companyId
        description
        id
        leaderId
        name
        version
      }
      employees {
        companyName
        contactNumber
        contactTypes
        displayContactType
        displayName
        firstName
        id
        isACompany
        isAFreelancer
        isAPerson
        isDeleted
        isContactPerson
        isEmployee
        isTemporary
        lastName
        salutation
        shortCode
        title
        version
      }
    }
  }
}
    `;
export type RemoveEmployeesFromTimeLabelMutationFn = Apollo.MutationFunction<RemoveEmployeesFromTimeLabelMutation, RemoveEmployeesFromTimeLabelMutationVariables>;

/**
 * __useRemoveEmployeesFromTimeLabelMutation__
 *
 * To run a mutation, you first call `useRemoveEmployeesFromTimeLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEmployeesFromTimeLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEmployeesFromTimeLabelMutation, { data, loading, error }] = useRemoveEmployeesFromTimeLabelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      employees: // value for 'employees'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useRemoveEmployeesFromTimeLabelMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEmployeesFromTimeLabelMutation, RemoveEmployeesFromTimeLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEmployeesFromTimeLabelMutation, RemoveEmployeesFromTimeLabelMutationVariables>(RemoveEmployeesFromTimeLabelDocument, options);
      }
export type RemoveEmployeesFromTimeLabelMutationHookResult = ReturnType<typeof useRemoveEmployeesFromTimeLabelMutation>;
export type RemoveEmployeesFromTimeLabelMutationResult = Apollo.MutationResult<RemoveEmployeesFromTimeLabelMutation>;
export type RemoveEmployeesFromTimeLabelMutationOptions = Apollo.BaseMutationOptions<RemoveEmployeesFromTimeLabelMutation, RemoveEmployeesFromTimeLabelMutationVariables>;
export const RemoveLabelGroupsFromDepartmentDocument = gql`
    mutation RemoveLabelGroupsFromDepartment($id: ID!, $timeLabelGroupsIds: [ID!]!) {
  removeLabelGroupsFromDepartment(
    input: {id: $id, timeLabelGroupsIds: $timeLabelGroupsIds}
  ) {
    boolean
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type RemoveLabelGroupsFromDepartmentMutationFn = Apollo.MutationFunction<RemoveLabelGroupsFromDepartmentMutation, RemoveLabelGroupsFromDepartmentMutationVariables>;

/**
 * __useRemoveLabelGroupsFromDepartmentMutation__
 *
 * To run a mutation, you first call `useRemoveLabelGroupsFromDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLabelGroupsFromDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLabelGroupsFromDepartmentMutation, { data, loading, error }] = useRemoveLabelGroupsFromDepartmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      timeLabelGroupsIds: // value for 'timeLabelGroupsIds'
 *   },
 * });
 */
export function useRemoveLabelGroupsFromDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLabelGroupsFromDepartmentMutation, RemoveLabelGroupsFromDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLabelGroupsFromDepartmentMutation, RemoveLabelGroupsFromDepartmentMutationVariables>(RemoveLabelGroupsFromDepartmentDocument, options);
      }
export type RemoveLabelGroupsFromDepartmentMutationHookResult = ReturnType<typeof useRemoveLabelGroupsFromDepartmentMutation>;
export type RemoveLabelGroupsFromDepartmentMutationResult = Apollo.MutationResult<RemoveLabelGroupsFromDepartmentMutation>;
export type RemoveLabelGroupsFromDepartmentMutationOptions = Apollo.BaseMutationOptions<RemoveLabelGroupsFromDepartmentMutation, RemoveLabelGroupsFromDepartmentMutationVariables>;
export const RemoveLabelsFromDepartmentDocument = gql`
    mutation RemoveLabelsFromDepartment($id: ID!, $timeLabelIds: [ID!]!) {
  removeLabelsFromDepartment(input: {id: $id, timeLabelIds: $timeLabelIds}) {
    boolean
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type RemoveLabelsFromDepartmentMutationFn = Apollo.MutationFunction<RemoveLabelsFromDepartmentMutation, RemoveLabelsFromDepartmentMutationVariables>;

/**
 * __useRemoveLabelsFromDepartmentMutation__
 *
 * To run a mutation, you first call `useRemoveLabelsFromDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLabelsFromDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLabelsFromDepartmentMutation, { data, loading, error }] = useRemoveLabelsFromDepartmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      timeLabelIds: // value for 'timeLabelIds'
 *   },
 * });
 */
export function useRemoveLabelsFromDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLabelsFromDepartmentMutation, RemoveLabelsFromDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLabelsFromDepartmentMutation, RemoveLabelsFromDepartmentMutationVariables>(RemoveLabelsFromDepartmentDocument, options);
      }
export type RemoveLabelsFromDepartmentMutationHookResult = ReturnType<typeof useRemoveLabelsFromDepartmentMutation>;
export type RemoveLabelsFromDepartmentMutationResult = Apollo.MutationResult<RemoveLabelsFromDepartmentMutation>;
export type RemoveLabelsFromDepartmentMutationOptions = Apollo.BaseMutationOptions<RemoveLabelsFromDepartmentMutation, RemoveLabelsFromDepartmentMutationVariables>;
export const RemoveLabelsFromLabelGroupDocument = gql`
    mutation RemoveLabelsFromLabelGroup($id: ID!, $labels: [ID!]!, $version: Long!) {
  removeLabelsFromLabelGroup(input: {id: $id, labels: $labels, version: $version}) {
    boolean
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on ConcurrentAccessError {
        errorType
        message
      }
    }
  }
}
    `;
export type RemoveLabelsFromLabelGroupMutationFn = Apollo.MutationFunction<RemoveLabelsFromLabelGroupMutation, RemoveLabelsFromLabelGroupMutationVariables>;

/**
 * __useRemoveLabelsFromLabelGroupMutation__
 *
 * To run a mutation, you first call `useRemoveLabelsFromLabelGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLabelsFromLabelGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLabelsFromLabelGroupMutation, { data, loading, error }] = useRemoveLabelsFromLabelGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      labels: // value for 'labels'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useRemoveLabelsFromLabelGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLabelsFromLabelGroupMutation, RemoveLabelsFromLabelGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLabelsFromLabelGroupMutation, RemoveLabelsFromLabelGroupMutationVariables>(RemoveLabelsFromLabelGroupDocument, options);
      }
export type RemoveLabelsFromLabelGroupMutationHookResult = ReturnType<typeof useRemoveLabelsFromLabelGroupMutation>;
export type RemoveLabelsFromLabelGroupMutationResult = Apollo.MutationResult<RemoveLabelsFromLabelGroupMutation>;
export type RemoveLabelsFromLabelGroupMutationOptions = Apollo.BaseMutationOptions<RemoveLabelsFromLabelGroupMutation, RemoveLabelsFromLabelGroupMutationVariables>;
export const StartMyTimerDocument = gql`
    mutation StartMyTimer($startTime: DateTime!) {
  myStartTimer(input: {startTime: $startTime}) {
    errors {
      ... on DomainError {
        errorType
        message
      }
    }
    boolean
  }
}
    `;
export type StartMyTimerMutationFn = Apollo.MutationFunction<StartMyTimerMutation, StartMyTimerMutationVariables>;

/**
 * __useStartMyTimerMutation__
 *
 * To run a mutation, you first call `useStartMyTimerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMyTimerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMyTimerMutation, { data, loading, error }] = useStartMyTimerMutation({
 *   variables: {
 *      startTime: // value for 'startTime'
 *   },
 * });
 */
export function useStartMyTimerMutation(baseOptions?: Apollo.MutationHookOptions<StartMyTimerMutation, StartMyTimerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartMyTimerMutation, StartMyTimerMutationVariables>(StartMyTimerDocument, options);
      }
export type StartMyTimerMutationHookResult = ReturnType<typeof useStartMyTimerMutation>;
export type StartMyTimerMutationResult = Apollo.MutationResult<StartMyTimerMutation>;
export type StartMyTimerMutationOptions = Apollo.BaseMutationOptions<StartMyTimerMutation, StartMyTimerMutationVariables>;
export const StopMyTimerDocument = gql`
    mutation StopMyTimer($endTime: DateTime!) {
  myStopTimer(input: {endTime: $endTime}) {
    errors {
      ... on DomainError {
        errorType
        message
      }
    }
    boolean
  }
}
    `;
export type StopMyTimerMutationFn = Apollo.MutationFunction<StopMyTimerMutation, StopMyTimerMutationVariables>;

/**
 * __useStopMyTimerMutation__
 *
 * To run a mutation, you first call `useStopMyTimerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopMyTimerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopMyTimerMutation, { data, loading, error }] = useStopMyTimerMutation({
 *   variables: {
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useStopMyTimerMutation(baseOptions?: Apollo.MutationHookOptions<StopMyTimerMutation, StopMyTimerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopMyTimerMutation, StopMyTimerMutationVariables>(StopMyTimerDocument, options);
      }
export type StopMyTimerMutationHookResult = ReturnType<typeof useStopMyTimerMutation>;
export type StopMyTimerMutationResult = Apollo.MutationResult<StopMyTimerMutation>;
export type StopMyTimerMutationOptions = Apollo.BaseMutationOptions<StopMyTimerMutation, StopMyTimerMutationVariables>;
export const TeamMemberWorkTimeSummaryDocument = gql`
    query TeamMemberWorkTimeSummary($startDate: LocalDate!, $endDate: LocalDate!, $employeeId: ID!) {
  teamMemberWorkTimeSummary(
    startDate: $startDate
    endDate: $endDate
    employeeId: $employeeId
  ) {
    approvedMinutes
    balanceMinutes
    pendingMinutes
    rejectedMinutes
    requiredMinutes
    totalMinutes
  }
}
    `;

/**
 * __useTeamMemberWorkTimeSummaryQuery__
 *
 * To run a query within a React component, call `useTeamMemberWorkTimeSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMemberWorkTimeSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMemberWorkTimeSummaryQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useTeamMemberWorkTimeSummaryQuery(baseOptions: Apollo.QueryHookOptions<TeamMemberWorkTimeSummaryQuery, TeamMemberWorkTimeSummaryQueryVariables> & ({ variables: TeamMemberWorkTimeSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamMemberWorkTimeSummaryQuery, TeamMemberWorkTimeSummaryQueryVariables>(TeamMemberWorkTimeSummaryDocument, options);
      }
export function useTeamMemberWorkTimeSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamMemberWorkTimeSummaryQuery, TeamMemberWorkTimeSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamMemberWorkTimeSummaryQuery, TeamMemberWorkTimeSummaryQueryVariables>(TeamMemberWorkTimeSummaryDocument, options);
        }
export function useTeamMemberWorkTimeSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeamMemberWorkTimeSummaryQuery, TeamMemberWorkTimeSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeamMemberWorkTimeSummaryQuery, TeamMemberWorkTimeSummaryQueryVariables>(TeamMemberWorkTimeSummaryDocument, options);
        }
export type TeamMemberWorkTimeSummaryQueryHookResult = ReturnType<typeof useTeamMemberWorkTimeSummaryQuery>;
export type TeamMemberWorkTimeSummaryLazyQueryHookResult = ReturnType<typeof useTeamMemberWorkTimeSummaryLazyQuery>;
export type TeamMemberWorkTimeSummarySuspenseQueryHookResult = ReturnType<typeof useTeamMemberWorkTimeSummarySuspenseQuery>;
export type TeamMemberWorkTimeSummaryQueryResult = Apollo.QueryResult<TeamMemberWorkTimeSummaryQuery, TeamMemberWorkTimeSummaryQueryVariables>;
export const UpdateAbsenceDocument = gql`
    mutation UpdateAbsence($absenceReasonId: ID!, $comment: String, $delegateEmployeeId: ID!, $end: LocalDate!, $isHalfEndDay: Boolean!, $isHalfStartDay: Boolean!, $start: LocalDate!, $absenceId: ID!, $version: Long!, $startWorkflow: Boolean) {
  updateAbsence(
    input: {absenceReasonId: $absenceReasonId, comment: $comment, delegateEmployeeId: $delegateEmployeeId, end: $end, isHalfEndDay: $isHalfEndDay, isHalfStartDay: $isHalfStartDay, start: $start, absenceId: $absenceId, version: $version, startWorkflow: $startWorkflow}
  ) {
    absence {
      id
      absenceReasonId
      absenceReasonName
      absenceReasonType
      createdBy {
        id
        displayName
      }
      delegateEmployee {
        displayName
        id
      }
      employee {
        displayName
        id
      }
      end
      history {
        absenceReasonId
        absenceReasonName
        end
        isHalfEndDay
        isHalfStartDay
        start
        status
        timestamp
        version
        createdBy {
          displayName
          id
        }
        delegateEmployee {
          displayName
          id
        }
        publicHolidays
        totalDays
        workDays
      }
      isHalfEndDay
      isHalfStartDay
      logs {
        createdBy {
          displayName
          id
        }
        id
        message
        timestamp
      }
      start
      status
      timestamp
      version
      totalDays
      workDays
      publicHolidays
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
  }
}
    `;
export type UpdateAbsenceMutationFn = Apollo.MutationFunction<UpdateAbsenceMutation, UpdateAbsenceMutationVariables>;

/**
 * __useUpdateAbsenceMutation__
 *
 * To run a mutation, you first call `useUpdateAbsenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAbsenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAbsenceMutation, { data, loading, error }] = useUpdateAbsenceMutation({
 *   variables: {
 *      absenceReasonId: // value for 'absenceReasonId'
 *      comment: // value for 'comment'
 *      delegateEmployeeId: // value for 'delegateEmployeeId'
 *      end: // value for 'end'
 *      isHalfEndDay: // value for 'isHalfEndDay'
 *      isHalfStartDay: // value for 'isHalfStartDay'
 *      start: // value for 'start'
 *      absenceId: // value for 'absenceId'
 *      version: // value for 'version'
 *      startWorkflow: // value for 'startWorkflow'
 *   },
 * });
 */
export function useUpdateAbsenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAbsenceMutation, UpdateAbsenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAbsenceMutation, UpdateAbsenceMutationVariables>(UpdateAbsenceDocument, options);
      }
export type UpdateAbsenceMutationHookResult = ReturnType<typeof useUpdateAbsenceMutation>;
export type UpdateAbsenceMutationResult = Apollo.MutationResult<UpdateAbsenceMutation>;
export type UpdateAbsenceMutationOptions = Apollo.BaseMutationOptions<UpdateAbsenceMutation, UpdateAbsenceMutationVariables>;
export const UpdateAbsenceReasonDocument = gql`
    mutation UpdateAbsenceReason($description: String!, $isPaid: Boolean!, $isVisible: Boolean!, $maximumContinuedPayment: Int, $name: String!, $removesWorkingHours: Boolean!, $type: AbsenceReasonType!, $id: ID!, $version: Long!) {
  updateAbsenceReason(
    input: {description: $description, isPaid: $isPaid, isVisible: $isVisible, maximumContinuedPayment: $maximumContinuedPayment, name: $name, removesWorkingHours: $removesWorkingHours, type: $type, id: $id, version: $version}
  ) {
    absenceReason {
      id
      name
      description
      isVisible
      isDeleted
      isPaid
      maximumContinuedPayment
      removesWorkingHours
      type
      version
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on ConcurrentAccessError {
        errorType
        message
      }
    }
  }
}
    `;
export type UpdateAbsenceReasonMutationFn = Apollo.MutationFunction<UpdateAbsenceReasonMutation, UpdateAbsenceReasonMutationVariables>;

/**
 * __useUpdateAbsenceReasonMutation__
 *
 * To run a mutation, you first call `useUpdateAbsenceReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAbsenceReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAbsenceReasonMutation, { data, loading, error }] = useUpdateAbsenceReasonMutation({
 *   variables: {
 *      description: // value for 'description'
 *      isPaid: // value for 'isPaid'
 *      isVisible: // value for 'isVisible'
 *      maximumContinuedPayment: // value for 'maximumContinuedPayment'
 *      name: // value for 'name'
 *      removesWorkingHours: // value for 'removesWorkingHours'
 *      type: // value for 'type'
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useUpdateAbsenceReasonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAbsenceReasonMutation, UpdateAbsenceReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAbsenceReasonMutation, UpdateAbsenceReasonMutationVariables>(UpdateAbsenceReasonDocument, options);
      }
export type UpdateAbsenceReasonMutationHookResult = ReturnType<typeof useUpdateAbsenceReasonMutation>;
export type UpdateAbsenceReasonMutationResult = Apollo.MutationResult<UpdateAbsenceReasonMutation>;
export type UpdateAbsenceReasonMutationOptions = Apollo.BaseMutationOptions<UpdateAbsenceReasonMutation, UpdateAbsenceReasonMutationVariables>;
export const UpdateCalendarEventDocument = gql`
    mutation UpdateCalendarEvent($description: String!, $endDate: LocalDate!, $federalStateCodes: [String!]!, $isHalfEndDay: Boolean!, $isHalfStartDay: Boolean!, $isVacation: Boolean!, $locations: [String!]!, $startDate: LocalDate!, $type: CalendarEventType!, $id: ID!, $version: Long!) {
  updateCalendarEvent(
    input: {description: $description, endDate: $endDate, federalStateCodes: $federalStateCodes, isHalfEndDay: $isHalfEndDay, isHalfStartDay: $isHalfStartDay, isVacation: $isVacation, locations: $locations, startDate: $startDate, type: $type, id: $id, version: $version}
  ) {
    calendarEvent {
      id
      startDate
      isHalfStartDay
      endDate
      isHalfEndDay
      type
      isVacation
      description
      federalStateCodes
      locations
      version
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on ConcurrentAccessError {
        errorType
        message
      }
    }
  }
}
    `;
export type UpdateCalendarEventMutationFn = Apollo.MutationFunction<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>;

/**
 * __useUpdateCalendarEventMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarEventMutation, { data, loading, error }] = useUpdateCalendarEventMutation({
 *   variables: {
 *      description: // value for 'description'
 *      endDate: // value for 'endDate'
 *      federalStateCodes: // value for 'federalStateCodes'
 *      isHalfEndDay: // value for 'isHalfEndDay'
 *      isHalfStartDay: // value for 'isHalfStartDay'
 *      isVacation: // value for 'isVacation'
 *      locations: // value for 'locations'
 *      startDate: // value for 'startDate'
 *      type: // value for 'type'
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useUpdateCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>(UpdateCalendarEventDocument, options);
      }
export type UpdateCalendarEventMutationHookResult = ReturnType<typeof useUpdateCalendarEventMutation>;
export type UpdateCalendarEventMutationResult = Apollo.MutationResult<UpdateCalendarEventMutation>;
export type UpdateCalendarEventMutationOptions = Apollo.BaseMutationOptions<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>;
export const UpdateDayTimeEntryDocument = gql`
    mutation UpdateDayTimeEntry($employeeId: ID!, $date: LocalDate!, $timeEntries: [UpsertTimeEntryInput!]!) {
  updateDayTimeEntry(
    input: {employeeId: $employeeId, date: $date, timeEntries: $timeEntries}
  ) {
    timeEntryDayGroup {
      absenceReason
      date
      errors
      id
      items {
        calendarId
        createdById
        description
        end
        entryType
        id
        memberId
        path
        start
        status
        timeLabelId
        timestamp
        title
        version
        workLocation
        errors
        history {
          createdBy {
            id
            displayName
          }
          description
          end
          entryType
          member {
            id
            displayName
          }
          start
          status
          timeLabel {
            name
            id
          }
          timestamp
          version
          workLocation
        }
        logs {
          createdBy {
            displayName
            id
          }
          id
          message
          timestamp
        }
        member {
          displayName
          id
        }
        timeLabel {
          name
          id
        }
      }
      approvedWorkingMinutes
      balanceEntry {
        overtimeMinutes
        type
      }
      balanceMinutes
      breakMinutes
      pendingWorkingMinutes
      rejectedWorkingMinutes
      requiredWorkingMinutes
      workingMinutes
    }
  }
}
    `;
export type UpdateDayTimeEntryMutationFn = Apollo.MutationFunction<UpdateDayTimeEntryMutation, UpdateDayTimeEntryMutationVariables>;

/**
 * __useUpdateDayTimeEntryMutation__
 *
 * To run a mutation, you first call `useUpdateDayTimeEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDayTimeEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDayTimeEntryMutation, { data, loading, error }] = useUpdateDayTimeEntryMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      date: // value for 'date'
 *      timeEntries: // value for 'timeEntries'
 *   },
 * });
 */
export function useUpdateDayTimeEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDayTimeEntryMutation, UpdateDayTimeEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDayTimeEntryMutation, UpdateDayTimeEntryMutationVariables>(UpdateDayTimeEntryDocument, options);
      }
export type UpdateDayTimeEntryMutationHookResult = ReturnType<typeof useUpdateDayTimeEntryMutation>;
export type UpdateDayTimeEntryMutationResult = Apollo.MutationResult<UpdateDayTimeEntryMutation>;
export type UpdateDayTimeEntryMutationOptions = Apollo.BaseMutationOptions<UpdateDayTimeEntryMutation, UpdateDayTimeEntryMutationVariables>;
export const UpdateMyDayTimeEntryDocument = gql`
    mutation UpdateMyDayTimeEntry($date: LocalDate!, $timeEntries: [UpsertTimeEntryInput!]!) {
  updateMyDayTimeEntry(input: {date: $date, timeEntries: $timeEntries}) {
    timeEntryDayGroup {
      absenceReason
      date
      errors
      id
      items {
        history {
          createdBy {
            id
            displayName
          }
          description
          end
          entryType
          member {
            id
            displayName
          }
          start
          status
          timeLabel {
            name
            id
          }
          timestamp
          version
          workLocation
        }
        calendarId
        createdById
        description
        end
        entryType
        id
        memberId
        path
        start
        status
        timeLabelId
        timestamp
        title
        version
        workLocation
        errors
        logs {
          createdBy {
            displayName
            id
          }
          id
          message
          timestamp
        }
        member {
          displayName
          id
        }
        timeLabel {
          name
          id
        }
      }
      approvedWorkingMinutes
      balanceEntry {
        overtimeMinutes
        type
      }
      balanceMinutes
      breakMinutes
      pendingWorkingMinutes
      rejectedWorkingMinutes
      requiredWorkingMinutes
      workingMinutes
    }
  }
}
    `;
export type UpdateMyDayTimeEntryMutationFn = Apollo.MutationFunction<UpdateMyDayTimeEntryMutation, UpdateMyDayTimeEntryMutationVariables>;

/**
 * __useUpdateMyDayTimeEntryMutation__
 *
 * To run a mutation, you first call `useUpdateMyDayTimeEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyDayTimeEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyDayTimeEntryMutation, { data, loading, error }] = useUpdateMyDayTimeEntryMutation({
 *   variables: {
 *      date: // value for 'date'
 *      timeEntries: // value for 'timeEntries'
 *   },
 * });
 */
export function useUpdateMyDayTimeEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyDayTimeEntryMutation, UpdateMyDayTimeEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyDayTimeEntryMutation, UpdateMyDayTimeEntryMutationVariables>(UpdateMyDayTimeEntryDocument, options);
      }
export type UpdateMyDayTimeEntryMutationHookResult = ReturnType<typeof useUpdateMyDayTimeEntryMutation>;
export type UpdateMyDayTimeEntryMutationResult = Apollo.MutationResult<UpdateMyDayTimeEntryMutation>;
export type UpdateMyDayTimeEntryMutationOptions = Apollo.BaseMutationOptions<UpdateMyDayTimeEntryMutation, UpdateMyDayTimeEntryMutationVariables>;
export const UpdateTimeBalanceEntryDocument = gql`
    mutation UpdateTimeBalanceEntry($date: LocalDate!, $type: TimeBalanceType!, $vacationDays: Decimal, $overtime: TimeSpan, $reason: String!, $id: ID!, $version: Long!) {
  updateTimeBalanceEntry(
    input: {date: $date, type: $type, vacationDays: $vacationDays, overtime: $overtime, reason: $reason, id: $id, version: $version}
  ) {
    timeBalanceEntry {
      id
      createdById
      date
      employeeId
      history {
        createdBy {
          id
          displayName
        }
        createdById
        date
        isDeleted
        overtime
        reason
        timestamp
        type
        vacationDays
      }
      isDeleted
      overtime
      reason
      timestamp
      type
      vacationDays
      version
      createdBy {
        id
        displayName
      }
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on ConcurrentAccessError {
        errorType
        message
      }
    }
  }
}
    `;
export type UpdateTimeBalanceEntryMutationFn = Apollo.MutationFunction<UpdateTimeBalanceEntryMutation, UpdateTimeBalanceEntryMutationVariables>;

/**
 * __useUpdateTimeBalanceEntryMutation__
 *
 * To run a mutation, you first call `useUpdateTimeBalanceEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeBalanceEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeBalanceEntryMutation, { data, loading, error }] = useUpdateTimeBalanceEntryMutation({
 *   variables: {
 *      date: // value for 'date'
 *      type: // value for 'type'
 *      vacationDays: // value for 'vacationDays'
 *      overtime: // value for 'overtime'
 *      reason: // value for 'reason'
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useUpdateTimeBalanceEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimeBalanceEntryMutation, UpdateTimeBalanceEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTimeBalanceEntryMutation, UpdateTimeBalanceEntryMutationVariables>(UpdateTimeBalanceEntryDocument, options);
      }
export type UpdateTimeBalanceEntryMutationHookResult = ReturnType<typeof useUpdateTimeBalanceEntryMutation>;
export type UpdateTimeBalanceEntryMutationResult = Apollo.MutationResult<UpdateTimeBalanceEntryMutation>;
export type UpdateTimeBalanceEntryMutationOptions = Apollo.BaseMutationOptions<UpdateTimeBalanceEntryMutation, UpdateTimeBalanceEntryMutationVariables>;
export const UpdateTimeLabelDocument = gql`
    mutation UpdateTimeLabel($id: ID!, $isActive: Boolean!, $name: String!, $version: Long!) {
  updateTimeLabel(
    input: {id: $id, isActive: $isActive, name: $name, version: $version}
  ) {
    errors {
      ... on ConcurrentAccessError {
        errorType
        message
      }
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    timeLabel {
      departmentIds
      employeeIds
      id
      isActive
      isDeleted
      name
      version
      companyId
      departments {
        companyId
        description
        id
        leaderId
        name
        version
      }
      employees {
        companyName
        contactNumber
        contactTypes
        displayContactType
        displayName
        firstName
        id
        isACompany
        isAFreelancer
        isAPerson
        isDeleted
        isContactPerson
        isEmployee
        isTemporary
        lastName
        salutation
        shortCode
        title
        version
      }
    }
  }
}
    `;
export type UpdateTimeLabelMutationFn = Apollo.MutationFunction<UpdateTimeLabelMutation, UpdateTimeLabelMutationVariables>;

/**
 * __useUpdateTimeLabelMutation__
 *
 * To run a mutation, you first call `useUpdateTimeLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeLabelMutation, { data, loading, error }] = useUpdateTimeLabelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isActive: // value for 'isActive'
 *      name: // value for 'name'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useUpdateTimeLabelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimeLabelMutation, UpdateTimeLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTimeLabelMutation, UpdateTimeLabelMutationVariables>(UpdateTimeLabelDocument, options);
      }
export type UpdateTimeLabelMutationHookResult = ReturnType<typeof useUpdateTimeLabelMutation>;
export type UpdateTimeLabelMutationResult = Apollo.MutationResult<UpdateTimeLabelMutation>;
export type UpdateTimeLabelMutationOptions = Apollo.BaseMutationOptions<UpdateTimeLabelMutation, UpdateTimeLabelMutationVariables>;
export const UpdateTimeLabelGroupDocument = gql`
    mutation UpdateTimeLabelGroup($id: ID!, $isGlobal: Boolean!, $name: String!, $version: Long!) {
  updateTimeLabelGroup(
    input: {id: $id, isGlobal: $isGlobal, name: $name, version: $version}
  ) {
    errors {
      ... on ConcurrentAccessError {
        errorType
        message
      }
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
    }
    timeLabelGroup {
      departmentIds
      employeeIds
      id
      name
      version
      companyId
      isGlobal
      labels {
        departmentIds
        employeeIds
        id
        isActive
        isDeleted
        name
        version
        companyId
      }
      departments {
        companyId
        description
        id
        leaderId
        name
        version
      }
      employees {
        companyName
        contactNumber
        contactTypes
        displayContactType
        displayName
        firstName
        id
        isACompany
        isAFreelancer
        isAPerson
        isDeleted
        isContactPerson
        isEmployee
        isTemporary
        lastName
        salutation
        shortCode
        title
        version
      }
    }
  }
}
    `;
export type UpdateTimeLabelGroupMutationFn = Apollo.MutationFunction<UpdateTimeLabelGroupMutation, UpdateTimeLabelGroupMutationVariables>;

/**
 * __useUpdateTimeLabelGroupMutation__
 *
 * To run a mutation, you first call `useUpdateTimeLabelGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeLabelGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeLabelGroupMutation, { data, loading, error }] = useUpdateTimeLabelGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isGlobal: // value for 'isGlobal'
 *      name: // value for 'name'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useUpdateTimeLabelGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimeLabelGroupMutation, UpdateTimeLabelGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTimeLabelGroupMutation, UpdateTimeLabelGroupMutationVariables>(UpdateTimeLabelGroupDocument, options);
      }
export type UpdateTimeLabelGroupMutationHookResult = ReturnType<typeof useUpdateTimeLabelGroupMutation>;
export type UpdateTimeLabelGroupMutationResult = Apollo.MutationResult<UpdateTimeLabelGroupMutation>;
export type UpdateTimeLabelGroupMutationOptions = Apollo.BaseMutationOptions<UpdateTimeLabelGroupMutation, UpdateTimeLabelGroupMutationVariables>;
export const UpdateWorkingTimeModelDocument = gql`
    mutation UpdateWorkingTimeModel($description: String!, $hoursPerFriday: Decimal!, $hoursPerMonday: Decimal!, $hoursPerSaturday: Decimal!, $hoursPerSunday: Decimal!, $hoursPerThursday: Decimal!, $hoursPerTuesday: Decimal!, $hoursPerWednesday: Decimal!, $hoursPerWeek: Decimal!, $isFlexible: Boolean!, $isVisible: Boolean!, $name: String!, $vacationDaysPerYear: Decimal!, $id: ID!, $version: Long!) {
  updateWorkingTimeModel(
    input: {description: $description, hoursPerFriday: $hoursPerFriday, hoursPerMonday: $hoursPerMonday, hoursPerSaturday: $hoursPerSaturday, hoursPerSunday: $hoursPerSunday, hoursPerThursday: $hoursPerThursday, hoursPerTuesday: $hoursPerTuesday, hoursPerWednesday: $hoursPerWednesday, hoursPerWeek: $hoursPerWeek, isFlexible: $isFlexible, isVisible: $isVisible, name: $name, vacationDaysPerYear: $vacationDaysPerYear, id: $id, version: $version}
  ) {
    workingTimeModel {
      id
      description
      hoursPerFriday
      hoursPerMonday
      hoursPerSaturday
      hoursPerSunday
      hoursPerThursday
      hoursPerTuesday
      hoursPerWednesday
      hoursPerWeek
      isDeleted
      isFlexible
      isVisible
      name
      vacationDaysPerYear
      version
    }
    errors {
      ... on DomainError {
        errorType
        message
      }
      ... on PropertyValidationError {
        errorType
        message
        errors {
          errorMessage
          propertyName
        }
      }
      ... on ConcurrentAccessError {
        errorType
        message
      }
    }
  }
}
    `;
export type UpdateWorkingTimeModelMutationFn = Apollo.MutationFunction<UpdateWorkingTimeModelMutation, UpdateWorkingTimeModelMutationVariables>;

/**
 * __useUpdateWorkingTimeModelMutation__
 *
 * To run a mutation, you first call `useUpdateWorkingTimeModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkingTimeModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkingTimeModelMutation, { data, loading, error }] = useUpdateWorkingTimeModelMutation({
 *   variables: {
 *      description: // value for 'description'
 *      hoursPerFriday: // value for 'hoursPerFriday'
 *      hoursPerMonday: // value for 'hoursPerMonday'
 *      hoursPerSaturday: // value for 'hoursPerSaturday'
 *      hoursPerSunday: // value for 'hoursPerSunday'
 *      hoursPerThursday: // value for 'hoursPerThursday'
 *      hoursPerTuesday: // value for 'hoursPerTuesday'
 *      hoursPerWednesday: // value for 'hoursPerWednesday'
 *      hoursPerWeek: // value for 'hoursPerWeek'
 *      isFlexible: // value for 'isFlexible'
 *      isVisible: // value for 'isVisible'
 *      name: // value for 'name'
 *      vacationDaysPerYear: // value for 'vacationDaysPerYear'
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useUpdateWorkingTimeModelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkingTimeModelMutation, UpdateWorkingTimeModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkingTimeModelMutation, UpdateWorkingTimeModelMutationVariables>(UpdateWorkingTimeModelDocument, options);
      }
export type UpdateWorkingTimeModelMutationHookResult = ReturnType<typeof useUpdateWorkingTimeModelMutation>;
export type UpdateWorkingTimeModelMutationResult = Apollo.MutationResult<UpdateWorkingTimeModelMutation>;
export type UpdateWorkingTimeModelMutationOptions = Apollo.BaseMutationOptions<UpdateWorkingTimeModelMutation, UpdateWorkingTimeModelMutationVariables>;
export const WorkTimeSummaryDocument = gql`
    query WorkTimeSummary($startDate: LocalDate!, $endDate: LocalDate!, $employeeId: ID!) {
  workTimeSummary(
    startDate: $startDate
    endDate: $endDate
    employeeId: $employeeId
  ) {
    approvedMinutes
    balanceMinutes
    pendingMinutes
    rejectedMinutes
    requiredMinutes
    totalMinutes
  }
}
    `;

/**
 * __useWorkTimeSummaryQuery__
 *
 * To run a query within a React component, call `useWorkTimeSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkTimeSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkTimeSummaryQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useWorkTimeSummaryQuery(baseOptions: Apollo.QueryHookOptions<WorkTimeSummaryQuery, WorkTimeSummaryQueryVariables> & ({ variables: WorkTimeSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkTimeSummaryQuery, WorkTimeSummaryQueryVariables>(WorkTimeSummaryDocument, options);
      }
export function useWorkTimeSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkTimeSummaryQuery, WorkTimeSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkTimeSummaryQuery, WorkTimeSummaryQueryVariables>(WorkTimeSummaryDocument, options);
        }
export function useWorkTimeSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkTimeSummaryQuery, WorkTimeSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkTimeSummaryQuery, WorkTimeSummaryQueryVariables>(WorkTimeSummaryDocument, options);
        }
export type WorkTimeSummaryQueryHookResult = ReturnType<typeof useWorkTimeSummaryQuery>;
export type WorkTimeSummaryLazyQueryHookResult = ReturnType<typeof useWorkTimeSummaryLazyQuery>;
export type WorkTimeSummarySuspenseQueryHookResult = ReturnType<typeof useWorkTimeSummarySuspenseQuery>;
export type WorkTimeSummaryQueryResult = Apollo.QueryResult<WorkTimeSummaryQuery, WorkTimeSummaryQueryVariables>;
export const AccessibleUserGroupsDocument = gql`
    query AccessibleUserGroups {
  accessibleUserGroups {
    id
    name
  }
}
    `;

/**
 * __useAccessibleUserGroupsQuery__
 *
 * To run a query within a React component, call `useAccessibleUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessibleUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessibleUserGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccessibleUserGroupsQuery(baseOptions?: Apollo.QueryHookOptions<AccessibleUserGroupsQuery, AccessibleUserGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessibleUserGroupsQuery, AccessibleUserGroupsQueryVariables>(AccessibleUserGroupsDocument, options);
      }
export function useAccessibleUserGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessibleUserGroupsQuery, AccessibleUserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessibleUserGroupsQuery, AccessibleUserGroupsQueryVariables>(AccessibleUserGroupsDocument, options);
        }
export function useAccessibleUserGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccessibleUserGroupsQuery, AccessibleUserGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccessibleUserGroupsQuery, AccessibleUserGroupsQueryVariables>(AccessibleUserGroupsDocument, options);
        }
export type AccessibleUserGroupsQueryHookResult = ReturnType<typeof useAccessibleUserGroupsQuery>;
export type AccessibleUserGroupsLazyQueryHookResult = ReturnType<typeof useAccessibleUserGroupsLazyQuery>;
export type AccessibleUserGroupsSuspenseQueryHookResult = ReturnType<typeof useAccessibleUserGroupsSuspenseQuery>;
export type AccessibleUserGroupsQueryResult = Apollo.QueryResult<AccessibleUserGroupsQuery, AccessibleUserGroupsQueryVariables>;
export const GetAllSuppliersAndMembersDocument = gql`
    query GetAllSuppliersAndMembers($first: Int, $after: String, $name: String) {
  allContacts(
    first: $first
    after: $after
    filter: {filterByName: $name, filterByTypes: [SUPPLIER]}
  ) {
    nodes {
      contactNumber
      contactTypes
      displayContactType
      id
      __typename
      additionalInformation {
        id
        __typename
        ... on EmailInformation {
          emailAddress
        }
        ... on ContactPersonInformation {
          contactPersonId
          contactUsage
        }
      }
      displayName
      firstName
      lastName
      isACompany
      isAFreelancer
      isAPerson
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllSuppliersAndMembersQuery__
 *
 * To run a query within a React component, call `useGetAllSuppliersAndMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSuppliersAndMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSuppliersAndMembersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetAllSuppliersAndMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSuppliersAndMembersQuery, GetAllSuppliersAndMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSuppliersAndMembersQuery, GetAllSuppliersAndMembersQueryVariables>(GetAllSuppliersAndMembersDocument, options);
      }
export function useGetAllSuppliersAndMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSuppliersAndMembersQuery, GetAllSuppliersAndMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSuppliersAndMembersQuery, GetAllSuppliersAndMembersQueryVariables>(GetAllSuppliersAndMembersDocument, options);
        }
export function useGetAllSuppliersAndMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllSuppliersAndMembersQuery, GetAllSuppliersAndMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllSuppliersAndMembersQuery, GetAllSuppliersAndMembersQueryVariables>(GetAllSuppliersAndMembersDocument, options);
        }
export type GetAllSuppliersAndMembersQueryHookResult = ReturnType<typeof useGetAllSuppliersAndMembersQuery>;
export type GetAllSuppliersAndMembersLazyQueryHookResult = ReturnType<typeof useGetAllSuppliersAndMembersLazyQuery>;
export type GetAllSuppliersAndMembersSuspenseQueryHookResult = ReturnType<typeof useGetAllSuppliersAndMembersSuspenseQuery>;
export type GetAllSuppliersAndMembersQueryResult = Apollo.QueryResult<GetAllSuppliersAndMembersQuery, GetAllSuppliersAndMembersQueryVariables>;
export const GetAllUsersDocument = gql`
    query GetAllUsers($first: Int, $after: String, $search: String) {
  allUsers(first: $first, after: $after, filter: {search: $search}) {
    totalCount
    nodes {
      contactId
      email
      emailVerified
      enabled
      groups
      id
      userGuid
      username
      firstName
      lastName
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetAllUsersQuery__
 *
 * To run a query within a React component, call `useGetAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUsersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAllUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
      }
export function useGetAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
        }
export function useGetAllUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
        }
export type GetAllUsersQueryHookResult = ReturnType<typeof useGetAllUsersQuery>;
export type GetAllUsersLazyQueryHookResult = ReturnType<typeof useGetAllUsersLazyQuery>;
export type GetAllUsersSuspenseQueryHookResult = ReturnType<typeof useGetAllUsersSuspenseQuery>;
export type GetAllUsersQueryResult = Apollo.QueryResult<GetAllUsersQuery, GetAllUsersQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($id: ID!) {
  node(id: $id) {
    id
    ... on User {
      contactId
      email
      emailVerified
      enabled
      groups
      id
      username
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const MyPrivilegesDocument = gql`
    query MyPrivileges {
  myPrivileges {
    roles
    isMultiContractor
    contractorId
  }
}
    `;

/**
 * __useMyPrivilegesQuery__
 *
 * To run a query within a React component, call `useMyPrivilegesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPrivilegesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPrivilegesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyPrivilegesQuery(baseOptions?: Apollo.QueryHookOptions<MyPrivilegesQuery, MyPrivilegesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPrivilegesQuery, MyPrivilegesQueryVariables>(MyPrivilegesDocument, options);
      }
export function useMyPrivilegesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPrivilegesQuery, MyPrivilegesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPrivilegesQuery, MyPrivilegesQueryVariables>(MyPrivilegesDocument, options);
        }
export function useMyPrivilegesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyPrivilegesQuery, MyPrivilegesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyPrivilegesQuery, MyPrivilegesQueryVariables>(MyPrivilegesDocument, options);
        }
export type MyPrivilegesQueryHookResult = ReturnType<typeof useMyPrivilegesQuery>;
export type MyPrivilegesLazyQueryHookResult = ReturnType<typeof useMyPrivilegesLazyQuery>;
export type MyPrivilegesSuspenseQueryHookResult = ReturnType<typeof useMyPrivilegesSuspenseQuery>;
export type MyPrivilegesQueryResult = Apollo.QueryResult<MyPrivilegesQuery, MyPrivilegesQueryVariables>;
export const ResendVerificationEmailDocument = gql`
    mutation ResendVerificationEmail($userid: ID!, $redirectUri: String!, $clientId: String!) {
  resendVerificationEmail(
    input: {userId: $userid, redirectUri: $redirectUri, clientId: $clientId}
  ) {
    boolean
    errors {
      ... on InvalidUserPrivilegesError {
        errorType
        message
      }
      ... on KeyCloakError {
        httpResponse
        message
      }
    }
  }
}
    `;
export type ResendVerificationEmailMutationFn = Apollo.MutationFunction<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;

/**
 * __useResendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useResendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationEmailMutation, { data, loading, error }] = useResendVerificationEmailMutation({
 *   variables: {
 *      userid: // value for 'userid'
 *      redirectUri: // value for 'redirectUri'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useResendVerificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>(ResendVerificationEmailDocument, options);
      }
export type ResendVerificationEmailMutationHookResult = ReturnType<typeof useResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationResult = Apollo.MutationResult<ResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationOptions = Apollo.BaseMutationOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;
export const ResendVerificationEmailToAllUnverifiedDocument = gql`
    mutation ResendVerificationEmailToAllUnverified($redirectUri: String!, $clientId: String!) {
  resendVerificationEmailToAllUnverified(
    input: {clientId: $clientId, redirectUri: $redirectUri}
  ) {
    boolean
    errors {
      ... on InvalidUserPrivilegesError {
        errorType
        message
      }
      ... on KeyCloakError {
        httpResponse
        message
      }
    }
  }
}
    `;
export type ResendVerificationEmailToAllUnverifiedMutationFn = Apollo.MutationFunction<ResendVerificationEmailToAllUnverifiedMutation, ResendVerificationEmailToAllUnverifiedMutationVariables>;

/**
 * __useResendVerificationEmailToAllUnverifiedMutation__
 *
 * To run a mutation, you first call `useResendVerificationEmailToAllUnverifiedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationEmailToAllUnverifiedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationEmailToAllUnverifiedMutation, { data, loading, error }] = useResendVerificationEmailToAllUnverifiedMutation({
 *   variables: {
 *      redirectUri: // value for 'redirectUri'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useResendVerificationEmailToAllUnverifiedMutation(baseOptions?: Apollo.MutationHookOptions<ResendVerificationEmailToAllUnverifiedMutation, ResendVerificationEmailToAllUnverifiedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendVerificationEmailToAllUnverifiedMutation, ResendVerificationEmailToAllUnverifiedMutationVariables>(ResendVerificationEmailToAllUnverifiedDocument, options);
      }
export type ResendVerificationEmailToAllUnverifiedMutationHookResult = ReturnType<typeof useResendVerificationEmailToAllUnverifiedMutation>;
export type ResendVerificationEmailToAllUnverifiedMutationResult = Apollo.MutationResult<ResendVerificationEmailToAllUnverifiedMutation>;
export type ResendVerificationEmailToAllUnverifiedMutationOptions = Apollo.BaseMutationOptions<ResendVerificationEmailToAllUnverifiedMutation, ResendVerificationEmailToAllUnverifiedMutationVariables>;
export const UserAddLoginDocument = gql`
    mutation UserAddLogin($contactId: ID!, $email: String!, $firstName: String!, $groupIds: [ID!]!, $lastName: String!, $username: String!, $contractorId: ID, $clientId: String!, $isMultiContractor: Boolean, $redirectUri: String!, $sendVerificationEmail: Boolean!) {
  userAddLogin(
    input: {contactId: $contactId, email: $email, firstName: $firstName, groupIds: $groupIds, lastName: $lastName, username: $username, contractorId: $contractorId, clientId: $clientId, isMultiContractor: $isMultiContractor, redirectUri: $redirectUri, sendVerificationEmail: $sendVerificationEmail}
  ) {
    errors {
      ... on KeyCloakError {
        message
        httpResponse
      }
      ... on InvalidUserPrivilegesError {
        message
      }
    }
    user {
      contactId
      email
      emailVerified
      enabled
      groups
      id
      username
      firstName
      lastName
      contractorId
    }
  }
}
    `;
export type UserAddLoginMutationFn = Apollo.MutationFunction<UserAddLoginMutation, UserAddLoginMutationVariables>;

/**
 * __useUserAddLoginMutation__
 *
 * To run a mutation, you first call `useUserAddLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAddLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAddLoginMutation, { data, loading, error }] = useUserAddLoginMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      groupIds: // value for 'groupIds'
 *      lastName: // value for 'lastName'
 *      username: // value for 'username'
 *      contractorId: // value for 'contractorId'
 *      clientId: // value for 'clientId'
 *      isMultiContractor: // value for 'isMultiContractor'
 *      redirectUri: // value for 'redirectUri'
 *      sendVerificationEmail: // value for 'sendVerificationEmail'
 *   },
 * });
 */
export function useUserAddLoginMutation(baseOptions?: Apollo.MutationHookOptions<UserAddLoginMutation, UserAddLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserAddLoginMutation, UserAddLoginMutationVariables>(UserAddLoginDocument, options);
      }
export type UserAddLoginMutationHookResult = ReturnType<typeof useUserAddLoginMutation>;
export type UserAddLoginMutationResult = Apollo.MutationResult<UserAddLoginMutation>;
export type UserAddLoginMutationOptions = Apollo.BaseMutationOptions<UserAddLoginMutation, UserAddLoginMutationVariables>;
export const UserByContactIdDocument = gql`
    query UserByContactId($id: ID!) {
  userByContactId(id: $id) {
    contactId
    email
    emailVerified
    enabled
    groups
    id
    username
    firstName
    lastName
  }
}
    `;

/**
 * __useUserByContactIdQuery__
 *
 * To run a query within a React component, call `useUserByContactIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserByContactIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByContactIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserByContactIdQuery(baseOptions: Apollo.QueryHookOptions<UserByContactIdQuery, UserByContactIdQueryVariables> & ({ variables: UserByContactIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserByContactIdQuery, UserByContactIdQueryVariables>(UserByContactIdDocument, options);
      }
export function useUserByContactIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserByContactIdQuery, UserByContactIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserByContactIdQuery, UserByContactIdQueryVariables>(UserByContactIdDocument, options);
        }
export function useUserByContactIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserByContactIdQuery, UserByContactIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserByContactIdQuery, UserByContactIdQueryVariables>(UserByContactIdDocument, options);
        }
export type UserByContactIdQueryHookResult = ReturnType<typeof useUserByContactIdQuery>;
export type UserByContactIdLazyQueryHookResult = ReturnType<typeof useUserByContactIdLazyQuery>;
export type UserByContactIdSuspenseQueryHookResult = ReturnType<typeof useUserByContactIdSuspenseQuery>;
export type UserByContactIdQueryResult = Apollo.QueryResult<UserByContactIdQuery, UserByContactIdQueryVariables>;
export const UserChangeGroupsDocument = gql`
    mutation UserChangeGroups($groupIds: [ID!]!, $userId: ID!) {
  userChangeGroups(input: {groupIds: $groupIds, userId: $userId}) {
    errors {
      ... on KeyCloakError {
        message
      }
      ... on InvalidUserPrivilegesError {
        message
      }
    }
    boolean
  }
}
    `;
export type UserChangeGroupsMutationFn = Apollo.MutationFunction<UserChangeGroupsMutation, UserChangeGroupsMutationVariables>;

/**
 * __useUserChangeGroupsMutation__
 *
 * To run a mutation, you first call `useUserChangeGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserChangeGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userChangeGroupsMutation, { data, loading, error }] = useUserChangeGroupsMutation({
 *   variables: {
 *      groupIds: // value for 'groupIds'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserChangeGroupsMutation(baseOptions?: Apollo.MutationHookOptions<UserChangeGroupsMutation, UserChangeGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserChangeGroupsMutation, UserChangeGroupsMutationVariables>(UserChangeGroupsDocument, options);
      }
export type UserChangeGroupsMutationHookResult = ReturnType<typeof useUserChangeGroupsMutation>;
export type UserChangeGroupsMutationResult = Apollo.MutationResult<UserChangeGroupsMutation>;
export type UserChangeGroupsMutationOptions = Apollo.BaseMutationOptions<UserChangeGroupsMutation, UserChangeGroupsMutationVariables>;
export const UserRemoveLoginDocument = gql`
    mutation UserRemoveLogin($userId: ID!) {
  userRemoveLogin(input: {userId: $userId}) {
    errors {
      ... on KeyCloakError {
        message
      }
    }
    boolean
  }
}
    `;
export type UserRemoveLoginMutationFn = Apollo.MutationFunction<UserRemoveLoginMutation, UserRemoveLoginMutationVariables>;

/**
 * __useUserRemoveLoginMutation__
 *
 * To run a mutation, you first call `useUserRemoveLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRemoveLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRemoveLoginMutation, { data, loading, error }] = useUserRemoveLoginMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserRemoveLoginMutation(baseOptions?: Apollo.MutationHookOptions<UserRemoveLoginMutation, UserRemoveLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRemoveLoginMutation, UserRemoveLoginMutationVariables>(UserRemoveLoginDocument, options);
      }
export type UserRemoveLoginMutationHookResult = ReturnType<typeof useUserRemoveLoginMutation>;
export type UserRemoveLoginMutationResult = Apollo.MutationResult<UserRemoveLoginMutation>;
export type UserRemoveLoginMutationOptions = Apollo.BaseMutationOptions<UserRemoveLoginMutation, UserRemoveLoginMutationVariables>;
export const UserSetEnabledDocument = gql`
    mutation UserSetEnabled($enabled: Boolean!, $userId: ID!) {
  userSetEnabled(input: {enabled: $enabled, userId: $userId}) {
    errors {
      ... on KeyCloakError {
        message
      }
      ... on InvalidUserPrivilegesError {
        message
      }
    }
    boolean
  }
}
    `;
export type UserSetEnabledMutationFn = Apollo.MutationFunction<UserSetEnabledMutation, UserSetEnabledMutationVariables>;

/**
 * __useUserSetEnabledMutation__
 *
 * To run a mutation, you first call `useUserSetEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSetEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSetEnabledMutation, { data, loading, error }] = useUserSetEnabledMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserSetEnabledMutation(baseOptions?: Apollo.MutationHookOptions<UserSetEnabledMutation, UserSetEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserSetEnabledMutation, UserSetEnabledMutationVariables>(UserSetEnabledDocument, options);
      }
export type UserSetEnabledMutationHookResult = ReturnType<typeof useUserSetEnabledMutation>;
export type UserSetEnabledMutationResult = Apollo.MutationResult<UserSetEnabledMutation>;
export type UserSetEnabledMutationOptions = Apollo.BaseMutationOptions<UserSetEnabledMutation, UserSetEnabledMutationVariables>;